
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("92V6K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $eXmBZ = parcelRequire("eXmBZ");


var $9Q2dU = parcelRequire("9Q2dU");


var $h1ewt = parcelRequire("h1ewt");


var $cuAuQ = parcelRequire("cuAuQ");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $inPa6 = parcelRequire("inPa6");


var $jhTeh = parcelRequire("jhTeh");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $euL71 = parcelRequire("euL71");





var $cgtv4 = parcelRequire("cgtv4");


var $Zkhpa = parcelRequire("Zkhpa");





var $cHKtk = parcelRequire("cHKtk");


var $kpYGL = parcelRequire("kpYGL");

const $81a808df43af1979$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    body: {
        id: "change-edition.inline-message.share-and-restrict-dialog.body",
        defaultMessage: "You can restrict this content to specific people on paid plans."
    },
    learnMoreLink: {
        id: "change-edition.inline-message.share-and-restrict-dialog.learn-more-link",
        defaultMessage: "Learn more"
    }
});
const $81a808df43af1979$var$SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
const $81a808df43af1979$export$88ea41c5571e7568 = ({ source: source, customPadding: customPadding, href: href = $81a808df43af1979$var$SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION })=>{
    const { showRequestUpgradeButton: showRequestUpgradeButton, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(source);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "200px",
        height: "32px"
    });
    const learnMoreLink = {
        href: href,
        actionSubjectId: source,
        messageDescriptor: $81a808df43af1979$export$a7357cdd1f0b0168.learnMoreLink
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Zkhpa.MiniSectionMessage), {
        source: source,
        messageContent: $81a808df43af1979$export$a7357cdd1f0b0168.body,
        withGradient: false,
        customPadding: customPadding,
        learnMoreLink: learnMoreLink,
        targetEdition: (0, $euL71.ConfluenceEdition).STANDARD,
        showRequestUpgradeButton: showRequestUpgradeButton,
        showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest
    });
};


var $2WE3u = parcelRequire("2WE3u");


var $6mKj3 = parcelRequire("6mKj3");


var $bYWO7 = parcelRequire("bYWO7");


var $4adOe = parcelRequire("4adOe");




const $421c2ce5ab401cdb$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    openAccessLabel: {
        id: "share-and-restrict-dialog.general-access.level.open",
        defaultMessage: "Open"
    },
    restrictedAccessLabel: {
        id: "share-and-restrict-dialog.general-access.level.restricted",
        defaultMessage: "Restricted"
    },
    restrictedByParentAccessLabel: {
        id: "share-and-restrict-dialog.general-access.level.restricted-by-parent",
        defaultMessage: "Restricted by a parent"
    },
    restrictedByParentTooltip: {
        id: "share-and-restrict-dialog.general-access.level.restricted-by-parent-tooltip",
        defaultMessage: "Can\u2019t open to the space because access is limited by a parent item."
    },
    restrictedByParentTooltipIconLabel: {
        id: "share-and-restrict-dialog.general-access.level.restricted-by-parent-tooltip-icon-label",
        defaultMessage: "Open disabled - More info"
    },
    unlockIconLabel: {
        id: "share-and-restrict-dialog.general-access.unlock-icon.label",
        defaultMessage: "Open"
    },
    lockIconLabel: {
        id: "share-and-restrict-dialog.general-access.lock-icon.label",
        defaultMessage: "Restricted"
    },
    dropdownIconLabel: {
        id: "share-and-restrict-dialog.general-access.dropdown-icon.label",
        defaultMessage: "Change general access level"
    }
});
const $421c2ce5ab401cdb$export$83ef53e4815508d1 = (0, $cgtv4.defineMessages)({
    anyoneInThisSpaceSubtext: {
        id: "share-and-restrict-dialog.general-access.anyone-in-this-space",
        defaultMessage: "Anyone in <a>this space</a>"
    },
    anyoneOnTheParentSubtext: {
        id: "share-and-restrict-dialog.general-access.anyone-on-parent",
        defaultMessage: "Anyone on <parentLink>the parent</parentLink>"
    },
    onlySpecificPeopleSubtext: {
        id: "share-and-restrict-dialog.general-access.only-specific-people",
        defaultMessage: "Only specific people can view or edit"
    },
    draftAnyoneInThisSpaceSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.anyone-in-this-space",
        defaultMessage: "Anyone in <a>this space</a> (with the link)"
    },
    draftAnyoneOnTheParentSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.anyone-on-parent",
        defaultMessage: "Anyone on <parentLink>the parent</parentLink> (with the link)"
    },
    draftOnlySpecificPeopleSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.only-specific-people",
        defaultMessage: "Only specific people can view or edit (with the link)"
    }
});
// All of the "long subtext" strings below are only used in the PublishModal.
// (As of 2024-08-14, it is the only place that uses the `showLongSubtext` prop.)
const $421c2ce5ab401cdb$var$longSubtextI18n = (0, $cgtv4.defineMessages)({
    anyoneInThisSpaceCanViewAndEditSubtext: {
        id: "share-and-restrict-dialog.general-access.anyone-in-this-space-can-view-and-edit",
        defaultMessage: "Anyone in <a>this space</a> can view and edit"
    },
    anyoneInThisSpaceCanViewNotEditSubtext: {
        id: "share-and-restrict-dialog.general-access.anyone-in-this-space-can-view-not-edit",
        defaultMessage: "Anyone in <a>this space</a> can view, only some can edit"
    },
    anyoneOnTheParentCanViewAndEditSubtext: {
        id: "share-and-restrict-dialog.general-access.anyone-on-parent-can-view-and-edit",
        defaultMessage: "Anyone on <parentLink>the parent</parentLink> can view and edit"
    },
    anyoneOnTheParentCanViewNotEditSubtext: {
        id: "share-and-restrict-dialog.general-access.anyone-on-parent-can-view-not-edit",
        defaultMessage: "Anyone on <parentLink>the parent</parentLink> can view, only some can edit"
    },
    draftAnyoneInThisSpaceCanViewAndEditSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.anyone-in-this-space-can-view-and-edit",
        defaultMessage: "Anyone in <a>this space</a> (with the link) can view and edit"
    },
    draftAnyoneInThisSpaceCanViewNotEditSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.anyone-in-this-space-can-view-not-edit",
        defaultMessage: "Anyone in <a>this space</a> (with the link) can view, only some can edit"
    },
    draftAnyoneOnTheParentCanViewAndEditSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.anyone-on-parent-can-view-and-edit",
        defaultMessage: "Anyone on <parentLink>the parent</parentLink> (with the link) can view and edit"
    },
    draftAnyoneOnTheParentCanViewNotEditSubtext: {
        id: "share-and-restrict-dialog.general-access.draft.anyone-on-parent-can-view-not-edit",
        defaultMessage: "Anyone on <parentLink>the parent</parentLink> (with the link) can view, only some can edit"
    }
});
const $421c2ce5ab401cdb$export$1040174de0206963 = {
    anyoneInThisSpaceSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.anyoneInThisSpaceCanViewAndEditSubtext,
    anyoneOnTheParentSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.anyoneOnTheParentCanViewAndEditSubtext,
    onlySpecificPeopleSubtext: $421c2ce5ab401cdb$export$83ef53e4815508d1.onlySpecificPeopleSubtext,
    draftAnyoneInThisSpaceSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.draftAnyoneInThisSpaceCanViewAndEditSubtext,
    draftAnyoneOnTheParentSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.draftAnyoneOnTheParentCanViewAndEditSubtext,
    draftOnlySpecificPeopleSubtext: $421c2ce5ab401cdb$export$83ef53e4815508d1.draftOnlySpecificPeopleSubtext
};
const $421c2ce5ab401cdb$export$6594d0d9dd7af4fe = {
    anyoneInThisSpaceSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.anyoneInThisSpaceCanViewNotEditSubtext,
    anyoneOnTheParentSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.anyoneOnTheParentCanViewNotEditSubtext,
    onlySpecificPeopleSubtext: $421c2ce5ab401cdb$export$83ef53e4815508d1.onlySpecificPeopleSubtext,
    draftAnyoneInThisSpaceSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.draftAnyoneInThisSpaceCanViewNotEditSubtext,
    draftAnyoneOnTheParentSubtext: $421c2ce5ab401cdb$var$longSubtextI18n.draftAnyoneOnTheParentCanViewNotEditSubtext,
    draftOnlySpecificPeopleSubtext: $421c2ce5ab401cdb$export$83ef53e4815508d1.draftOnlySpecificPeopleSubtext
};


const $4a9db9ea273a11cb$var$unlockedIconBackground = (0, $ecnYn.xcss)({
    height: '32px',
    width: '32px',
    borderRadius: 'radius.medium',
    background: "var(--ds-background-accent-gray-subtlest, #F0F1F2)"
});
const $4a9db9ea273a11cb$var$lockedIconBackground = (0, $ecnYn.xcss)({
    height: '32px',
    width: '32px',
    borderRadius: 'radius.medium',
    background: "var(--ds-background-danger, #FFECEB)"
});
const $4a9db9ea273a11cb$var$disabledOption = (0, $ecnYn.xcss)({
    opacity: '0.6'
});
const $4a9db9ea273a11cb$var$optionStyle = (0, $ecnYn.xcss)({
    color: 'color.text',
    fontWeight: 'font.weight.bold',
    paddingLeft: 'space.075'
});
const $4a9db9ea273a11cb$var$subtextStyleForOptions = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    whiteSpace: 'pre',
    paddingLeft: 'space.075'
});
const $4a9db9ea273a11cb$var$subtextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    whiteSpace: 'pre',
    maxHeight: '16px'
});
const $4a9db9ea273a11cb$var$optionStackStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150'
});
const $4a9db9ea273a11cb$var$buttonTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text',
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $4a9db9ea273a11cb$var$pressableTextStyle = (0, $ecnYn.xcss)({
    height: '20px',
    color: 'color.text',
    ':hover': {
        color: 'color.text.accent.blue'
    },
    ':active': {
        color: 'color.text.accent.blue.bolder'
    },
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    display: 'flex',
    alignItems: 'center'
});
const $4a9db9ea273a11cb$var$inlineMessageUpsellStyle = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    width: '350px'
});
const $4a9db9ea273a11cb$var$sectionMessageUpsellStyle = (0, $ecnYn.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    width: '380px'
});
const $4a9db9ea273a11cb$var$blueTextStyle = (0, $ecnYn.xcss)({
    color: 'color.text.accent.blue'
});
const $4a9db9ea273a11cb$export$f3de4679afe2e76a = ({ isLockedOut: isLockedOut, isDraft: isDraft, hasInheritedRestrictions: hasInheritedRestrictions, onOpenRestrictedChange: onOpenRestrictedChange, openSpaceAccessDetails: openSpaceAccessDetails, handleOpenAccessWarningDialog: handleOpenAccessWarningDialog, shouldGeneralAccessMenuBeOpen: shouldGeneralAccessMenuBeOpen, parentPageLink: parentPageLink, isEditable: isEditable, hideSpaceOrParentLink: hideSpaceOrParentLink, showLongSubtext: showLongSubtext, generalAccessLevel: generalAccessLevel, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails, hasRestrictions: hasRestrictions, hasViewRestrictions: hasViewRestrictions, isLivePage: // Used for analytics
isLivePage, contentType: contentType, edition: edition, shouldResolveMismatchedRestrictions: shouldResolveMismatchedRestrictions, isSaving: isSaving })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const OPTION_LABELS = {
        open: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).openAccessLabel),
        openInherited: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).restrictedByParentAccessLabel),
        restricted: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).restrictedAccessLabel)
    };
    const isGeneralAccessOpen = generalAccessLevel !== 'restricted';
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const shouldDisable = isFreeEdition || hasInheritedRestrictions;
    const showOpenAccessUpsell = generalAccessLevel !== 'open-can-edit';
    let parentUrl = `${(0, $jlIaF.CONTEXT_PATH)}${parentPageLink}`;
    if ((0, $1NBp8.FOLDER_VIEW).match(parentUrl)) parentUrl += '?referrer=share-and-restrict-dialog';
    const getLabel = (selectedOption)=>{
        if (selectedOption === 0) return OPTION_LABELS.open;
        if (selectedOption === 1 && hasInheritedRestrictions) return OPTION_LABELS.openInherited;
        return OPTION_LABELS.restricted;
    };
    const getLabelForMismatchRestrictionsWithQuery = (hasRestrictions)=>{
        if (shouldResolveMismatchedRestrictions || !hasRestrictions) return OPTION_LABELS.open;
        if (hasInheritedRestrictions) return OPTION_LABELS.openInherited;
        return OPTION_LABELS.restricted;
    };
    const subtextI18n = (()=>{
        if (!showLongSubtext) return 0, $421c2ce5ab401cdb$export$83ef53e4815508d1;
        if (generalAccessLevel === 'open-can-edit') return 0, $421c2ce5ab401cdb$export$1040174de0206963;
         // else, generalAccessLevel === 'open-can-view' or 'restricted',
        // both of which are handled by `longSubtextCanViewNotEditI18n`.
        return 0, $421c2ce5ab401cdb$export$6594d0d9dd7af4fe;
    })();
    const getSubtext = ({ isOpen: isOpen, hasInheritedRestrictionsSubtext: hasInheritedRestrictionsSubtext })=>{
        if (shouldShowDeletedGroupDetails) return subtextI18n.onlySpecificPeopleSubtext;
        if (isDraft && hasInheritedRestrictionsSubtext && isOpen) return subtextI18n.draftAnyoneOnTheParentSubtext;
        if (isDraft && !hasInheritedRestrictionsSubtext && isOpen) return subtextI18n.draftAnyoneInThisSpaceSubtext;
        if (isDraft && !isOpen) return subtextI18n.draftOnlySpecificPeopleSubtext;
        if (!isDraft && hasInheritedRestrictionsSubtext && isOpen) return subtextI18n.anyoneOnTheParentSubtext;
        if (!isDraft && !hasInheritedRestrictionsSubtext && isOpen) return subtextI18n.anyoneInThisSpaceSubtext;
         // !isDraft && !isOpen
        return subtextI18n.onlySpecificPeopleSubtext;
    };
    const handleSpaceAccessDetailsClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: 'button',
                actionSubjectId: 'AuditSpaceAccessButton',
                action: 'clicked'
            }
        }).fire();
        openSpaceAccessDetails();
    }, [
        createAnalyticsEvent,
        openSpaceAccessDetails
    ]);
    const makeSubtext = ({ isOpen: isOpen, hasInheritedRestrictionsSubtext: hasInheritedRestrictionsSubtext, forOptions: forOptions = false })=>formatMessage(getSubtext({
            isOpen: isOpen,
            hasInheritedRestrictionsSubtext: hasInheritedRestrictionsSubtext
        }), {
            a: (chunks)=>{
                if (shouldShowDeletedGroupDetails) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, chunks);
                if (forOptions || openSpaceAccessDetails === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, chunks);
                else if (hasInheritedRestrictionsSubtext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYWO7.PressableLink), {
                    showUnderline: true,
                    fontSize: "small",
                    onClick: handleSpaceAccessDetailsClick
                }, chunks);
            },
            parentLink: (chunks)=>forOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, chunks) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYWO7.PressableLink), {
                    targetBlank: true,
                    href: parentUrl,
                    showUnderline: true,
                    fontSize: "small"
                }, chunks)
        });
    const makeOptions = ()=>[
            ...isFreeEdition ? [
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showOpenAccessUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $4a9db9ea273a11cb$var$sectionMessageUpsellStyle
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2WE3u.ChangeEditionSectionMessageShareAndRestrict), {
                        handleOnClick: handleOpenAccessWarningDialog,
                        customPadding: `${"var(--ds-space-200, 16px)"}`
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: $4a9db9ea273a11cb$var$inlineMessageUpsellStyle
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $81a808df43af1979$export$88ea41c5571e7568), {
                        source: "generalAccessLevelSelector",
                        customPadding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"}`
                    }))),
                    value: 'tryItFree',
                    isDisabled: isFreeEdition
                }
            ] : [],
            {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    grow: "fill",
                    spread: "space-between",
                    alignInline: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    alignItems: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    justifyContent: "center",
                    alignItems: "center",
                    xcss: [
                        $4a9db9ea273a11cb$var$unlockedIconBackground,
                        shouldDisable && $4a9db9ea273a11cb$var$disabledOption
                    ]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
                    label: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).unlockIconLabel),
                    color: "var(--ds-icon, #292A2E)"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: shouldDisable && $4a9db9ea273a11cb$var$disabledOption
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: [
                        $4a9db9ea273a11cb$var$optionStyle
                    ]
                }, OPTION_LABELS.open), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    alignBlock: "center",
                    xcss: [
                        $4a9db9ea273a11cb$var$subtextStyleForOptions
                    ]
                }, makeSubtext({
                    isOpen: true,
                    hasInheritedRestrictionsSubtext: false,
                    forOptions: true
                })))), hasInheritedRestrictions && !isFreeEdition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    content: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).restrictedByParentTooltip),
                    position: "bottom"
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                        ...tooltipProps,
                        spacing: "compact",
                        shape: "circle",
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
                        label: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).restrictedByParentTooltipIconLabel)
                    }))),
                value: 'open',
                isDisabled: shouldDisable
            },
            ...hasInheritedRestrictions ? [
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                        alignItems: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                        justifyContent: "center",
                        alignItems: "center",
                        xcss: [
                            $4a9db9ea273a11cb$var$lockedIconBackground,
                            isFreeEdition && $4a9db9ea273a11cb$var$disabledOption
                        ]
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                        label: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).lockIconLabel),
                        color: "var(--ds-icon-danger, #C9372C)"
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: isFreeEdition && $4a9db9ea273a11cb$var$disabledOption
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                        xcss: [
                            $4a9db9ea273a11cb$var$optionStyle
                        ]
                    }, OPTION_LABELS.openInherited), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                        alignBlock: "center",
                        xcss: [
                            $4a9db9ea273a11cb$var$subtextStyleForOptions
                        ]
                    }, makeSubtext({
                        isOpen: true,
                        hasInheritedRestrictionsSubtext: true,
                        forOptions: true
                    })))),
                    value: 'open',
                    isDisabled: isFreeEdition
                }
            ] : [],
            {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    alignItems: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
                    justifyContent: "center",
                    alignItems: "center",
                    xcss: [
                        $4a9db9ea273a11cb$var$lockedIconBackground,
                        isFreeEdition && $4a9db9ea273a11cb$var$disabledOption
                    ]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                    label: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).lockIconLabel),
                    color: "var(--ds-icon-danger, #C9372C)"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: isFreeEdition && $4a9db9ea273a11cb$var$disabledOption
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: [
                        $4a9db9ea273a11cb$var$optionStyle
                    ]
                }, OPTION_LABELS.restricted), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jhTeh.ReverseTrialLozengeExperiment), {
                    touchpointId: "confluence_page_restrictions_dialog_list_item",
                    edition: (0, $euL71.ConfluenceEdition).STANDARD
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    alignBlock: "center",
                    xcss: [
                        $4a9db9ea273a11cb$var$subtextStyleForOptions
                    ]
                }, makeSubtext({
                    isOpen: false,
                    hasInheritedRestrictionsSubtext: hasInheritedRestrictions,
                    forOptions: true
                })))),
                value: 'restricted',
                isDisabled: isFreeEdition
            }
        ];
    const handleGeneralAccessChange = (selectedOption)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'selected',
                actionSubject: 'option',
                actionSubjectId: 'GeneralAccessLevelSelector',
                attributes: {
                    selectedOption: selectedOption?.value,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    contentType: contentType
                }
            }
        }).fire();
        onOpenRestrictedChange(selectedOption?.value === 'restricted');
    };
    const getCurrentOptionValue = ()=>{
        let currentOption; //Utilizes the restrictions data from singleContent query, which includes unfiltered information regarding deleted groups which hold content restrictions.
        //This will only calculate the current option value if:
        //1. The feature flag is enabled (fg('confluence_frontend_perms_deleted_groups_treatment'))
        //2. The content has mismatching query restrictions (hasMismatchWithQueryRestrictions, defined in the derivedState)
        //See https://jira.atlassian.com/browse/CONFCLOUD-80781 for more context.
        if (shouldResolveMismatchedRestrictions && shouldShowDeletedGroupDetails) return currentOption = 0;
        if (shouldShowDeletedGroupDetails) {
            hasRestrictions || hasViewRestrictions ? currentOption = 1 : currentOption = 0;
            return currentOption;
        }
        if (isGeneralAccessOpen) currentOption = 0;
        else currentOption = 1;
         // If we have inherited restrictions, option 0 is disabled and a third option
        // (Restricted by a parent) is added (as though spliced at 1), so the available options are 1 and 2
        // instead of 0 and 1, and we can just add 1 to selectedOption to account for this.
        if (hasInheritedRestrictions) currentOption += 1;
        return currentOption;
    };
    const options = makeOptions();
    const currentOption = getCurrentOptionValue();
    const selectedLabel = shouldShowDeletedGroupDetails ? getLabelForMismatchRestrictionsWithQuery(hasRestrictions) : getLabel(currentOption);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center"
    }, currentOption === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4a9db9ea273a11cb$var$unlockedIconBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))), {
        label: "unlocked",
        color: "var(--ds-icon, #292A2E)"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $4a9db9ea273a11cb$var$lockedIconBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: "locked",
        color: "var(--ds-icon-danger, #C9372C)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $4a9db9ea273a11cb$var$optionStackStyle
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cuAuQ.default), {
        options: options,
        value: options[currentOption],
        spacing: "compact",
        id: "general-access-level-options",
        target: ({ isOpen: isOpen, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
                ...triggerProps,
                isDisabled: isLockedOut || isSaving && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment'),
                padding: "space.0",
                backgroundColor: "color.background.neutral.subtle",
                xcss: [
                    $4a9db9ea273a11cb$var$pressableTextStyle,
                    isOpen && $4a9db9ea273a11cb$var$blueTextStyle
                ],
                "aria-describedby": "instru"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, selectedLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                spacing: "spacious",
                label: formatMessage((0, $421c2ce5ab401cdb$export$a7357cdd1f0b0168).dropdownIconLabel),
                size: "small"
            })),
        onChange: handleGeneralAccessChange,
        styles: {
            option: (styles, { data: data })=>{
                const value = data?.value;
                return {
                    ...styles,
                    color: value === 'tryItFree' ? `${"var(--ds-text, #292A2E)"}` : ' ',
                    padding: value === 'tryItFree' ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`
                };
            }
        },
        menuIsOpen: shouldGeneralAccessMenuBeOpen
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $4a9db9ea273a11cb$var$buttonTextStyle
        ]
    }, selectedLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $4a9db9ea273a11cb$var$subtextStyle
        ],
        id: "instru"
    }, makeSubtext({
        isOpen: isGeneralAccessOpen,
        hasInheritedRestrictionsSubtext: hasInheritedRestrictions,
        forOptions: hideSpaceOrParentLink
    }))));
};
module.exports["GeneralAccessLevelSelector"] = $4a9db9ea273a11cb$export$f3de4679afe2e76a;

});

parcelRegister("jhTeh", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $acf80d11b8f0d3f1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i0t_g",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("1GeOk"))).ReverseTrialLozengeWithErrorBoundary
});
module.exports["ReverseTrialLozengeExperiment"] = $acf80d11b8f0d3f1$export$b51195909514673e;

});

parcelRegister("1GeOk", function(module, exports) {

let $139533c72f429712$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $139533c72f429712$var$load("Wowvf"),
    $139533c72f429712$var$load("fqBFU")
]).then(()=>parcelRequire('gQsLh'));

});

parcelRegister("Zkhpa", function(module, exports) {
/* MiniSectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $4WmbV = parcelRequire("4WmbV");


var $ki6F7 = parcelRequire("ki6F7");


var $ktelT = parcelRequire("ktelT");


var $euL71 = parcelRequire("euL71");


var $gLeLL = parcelRequire("gLeLL");


var $cHKtk = parcelRequire("cHKtk");

const $32a7b52fc4024767$var$BodyWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulputpp _1e0c1txw _16jlkb7n _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $32a7b52fc4024767$var$MessageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp?.topBanner ? "_zulputpp _1e0c11p5 _yv0e1ghl _4cvrv2br" : "_1e0c1o8l _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $32a7b52fc4024767$var$LearnMoreLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_k48p1wq8 _syaz1gd8 _80omtlke",
            __cmplp.className
        ])
    });
});
const $32a7b52fc4024767$var$messageWrapperBannerStyles = (0, $ecnYn.xcss)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $32a7b52fc4024767$var$messageWrapperMessageStyles = (0, $ecnYn.xcss)({
    display: 'inline'
});
const $32a7b52fc4024767$export$4970578d41b1ae7b = ({ messageContent: messageContent, dismissButton: dismissButton, learnMoreLink: learnMoreLink, showRequestUpgradeButton: showRequestUpgradeButton, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest, topBanner: topBanner = false, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).PREMIUM, ...rest })=>{
    const { source: source, upgradeEditionActionSubjectId: upgradeEditionActionSubjectId, onUpgradeButtonClick: onUpgradeButtonClick } = rest;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const LearnMoreLinkComponent = learnMoreLink?.appearance === 'subtle-link' ? (0, $ktelT.GradientSubtleLinkButton) : $32a7b52fc4024767$var$LearnMoreLink;
    const onLearnMoreClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                source: source,
                attributes: {
                    currentEdition: edition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: learnMoreLink?.messageDescriptor?.defaultMessage
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        edition,
        targetEdition,
        isSiteAdmin,
        learnMoreLink
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32a7b52fc4024767$var$BodyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32a7b52fc4024767$var$MessageWrapper, {
            topBanner: topBanner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: topBanner ? $32a7b52fc4024767$var$messageWrapperBannerStyles : $32a7b52fc4024767$var$messageWrapperMessageStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), messageContent), ' '), isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
            analyticsProps: {
                actionSubjectId: upgradeEditionActionSubjectId || '',
                source: source,
                attributes: {
                    isSiteAdmin: true
                }
            },
            appearance: "subtle-link",
            targetEdition: targetEdition,
            onUpgradeButtonClick: onUpgradeButtonClick
        }) : showRequestUpgradeButtonAATest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null) && showRequestUpgradeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHKtk.EndUserRequestUpgradeButton), null) || learnMoreLink?.messageDescriptor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LearnMoreLinkComponent, {
            href: learnMoreLink?.href,
            onClick: ()=>{
                onLearnMoreClick();
                learnMoreLink?.onClick?.();
            },
            target: learnMoreLink?.target
        }, formatMessage(learnMoreLink.messageDescriptor))), dismissButton),
        buttonConfig: (0, $4WmbV.SectionMessageButtonConfig).NONE,
        ...rest
    });
};
module.exports["MiniSectionMessage"] = $32a7b52fc4024767$export$4970578d41b1ae7b;

});

parcelRegister("4WmbV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $9wGTI = parcelRequire("9wGTI");


var $cHKtk = parcelRequire("cHKtk");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink),
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cHKtk.EndUserRequestUpgradeButton), null);
            else if (showRequestUpgradeButtonAATest && (0, $9wGTI.fg)('connie_end_user_request_kill_switch')) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null);
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore, learnMoreIsPrimaryCTA)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("iJ9aA", function(module, exports) {

var $bsrY7 = parcelRequire("bsrY7");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $42omo.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("j0wkI"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("j0wkI", function(module, exports) {

let $dd671919af841761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd671919af841761$var$load("82QsP").then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$cf1d63b4a60d4ea = ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$export$9190afc902e08eb3 = ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>{
        const event = createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        const experimentMeta = event.context?.find((ctx)=>ctx?.attributes?.experimentMeta)?.attributes?.experimentMeta;
        event.payload = {
            ...event.payload,
            data: {
                ...event.payload?.data,
                attributes: {
                    ...event.payload?.data?.attributes,
                    ...experimentMeta?.key && experimentMeta?.cohort && {
                        experiments: {
                            [experimentMeta.key]: {
                                cohort: experimentMeta.cohort
                            }
                        }
                    }
                }
            }
        };
        return event;
    }, [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = ()=>{
    const contextWithExperiments = $8ea1c6a3abbe8170$export$9190afc902e08eb3();
    const contextImpl = $8ea1c6a3abbe8170$export$cf1d63b4a60d4ea();
    return (0, $9wGTI.fg)('replace_upsell_cta_content_fg') ? contextWithExperiments : contextImpl;
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $42omo.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $12IaO = parcelRequire("12IaO");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($12IaO)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("ki6F7", function(module, exports) {

var $ey6Pt = parcelRequire("ey6Pt");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $izVB4 = parcelRequire("izVB4");


var $lgF8o = parcelRequire("lgF8o");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $ij4CE = parcelRequire("ij4CE");


var $b0Zto = parcelRequire("b0Zto");


var $3yh4a = parcelRequire("3yh4a");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $2UjZJ = parcelRequire("2UjZJ");


var $gsZdA = parcelRequire("gsZdA");


var $5M47w = parcelRequire("5M47w");


var $dqdrq = parcelRequire("dqdrq");


var $ktelT = parcelRequire("ktelT");


var $l0DoV = parcelRequire("l0DoV");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $fDbEj = parcelRequire("fDbEj");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");

const $3615035320db7a8b$var$i18n = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$determineButtonComponent = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $4KS7f.default;
}; /**
    * @deprecated Please reach out to #cc-flywheel-engagement for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
    */ 
const $3615035320db7a8b$var$UpgradeEditionButtonImpl = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $42omo.useState)(false);
    const [pollingError, setPollingError] = (0, $42omo.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ey6Pt.default)
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { cohort: upflowV2ExperimentCohort, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, loading: upflowV2EligibilityHookLoading } = (0, $2UjZJ.useUpflowV2ConfluenceStandardFGsExperiment)({
        skip: !showUpFlow || !openUpFlow,
        touchpointId: source,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $42omo.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $42omo.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire(); // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: planConsentDeepLink ? planConsentDeepLink.split('?')[0] : undefined,
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
         // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition, writeFragmentInterop);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            }); // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics(); // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        }); // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const upflowV2ExperimentButtonProps = {
        appearance: appearance,
        testId: 'upflowV2ExperimentLoadingButton',
        isDisabled: true,
        isLoading: true,
        iconBefore: appearance === 'primary' ? (0, (/*@__PURE__*/$parcel$interopDefault($izVB4))) : undefined
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$var$determineButtonComponent(appearance);
    const renderModalContent = ()=>{
        if (upflowV2EligibilityHookLoading) return null;
        if (upflowV2ExperimentCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l0DoV.TryStandardUpflowV2ExperimentTreatmentModalLoadable), {
            isOpen: openUpFlow,
            closeModal: onUpFlowClose,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            canChangeEdition: true,
            cloudId: cloudId,
            currentEdition: currentEdition || undefined,
            atlassianAccountId: userId || undefined,
            flow: "upgrade",
            product: "confluence",
            targetEdition: targetEdition,
            touchpointId: source,
            isExperienceTrackerEnabled: true,
            onClose: // Note: onUpFlowOpen function closes the parent component which
            // means we don't need to trigger the onClose.
            onUpFlowOpen ? undefined : onUpFlowClose,
            onOpen: onUpFlowOpen,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, upflowV2EligibilityHookLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), upflowV2ExperimentButtonProps, buttonChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? renderModalContent() : null);
};
const $3615035320db7a8b$var$UpgradeEditionButtonWithExperiment = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { upgradeButtonContent: upgradeButtonContent, cohort: cohort } = (0, $b0Zto.useChangeEditionUpgradeButtonContentExperiment)({
        targetEdition: targetEdition,
        featureGateId: actionSubjectId || source
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
        onError: (error, info)=>{
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'replace_upsell_cta_content'
                },
                errorType: (0, $gwZbZ.ErrorType).ERROR_BOUNDARY,
                errorMessage: error.message,
                severity: (0, $gwZbZ.Severity).MEDIUM,
                source: 'replace_upsell_cta_content',
                additionalAttributes: {
                    ...info,
                    feature_gate: actionSubjectId || source,
                    attributes: attributes,
                    source: source
                }
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgF8o.ExperimentAnalyticsContext), {
        experimentMeta: {
            key: 'replace_upsell_cta_content',
            cohort: cohort,
            targetEdition: targetEdition,
            currentEdition: edition,
            content: upgradeButtonContent || children
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3615035320db7a8b$var$UpgradeEditionButtonImpl, {
        analyticsProps: {
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            source: source
        },
        appearance: appearance,
        onUpFlowOpen: onUpFlowOpen,
        targetEdition: targetEdition,
        onUpgradeButtonClick: onUpgradeButtonClick
    }, upgradeButtonContent || children)));
}; /**
    * @deprecated Please reach out to #growth-luna for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
    */ 
const $3615035320db7a8b$export$2f4bd8d23e81b246 = (0, $3yh4a.componentWithFG)('replace_upsell_cta_content_fg', $3615035320db7a8b$var$UpgradeEditionButtonWithExperiment, $3615035320db7a8b$var$UpgradeEditionButtonImpl);
module.exports["UpgradeEditionButton"] = $3615035320db7a8b$export$2f4bd8d23e81b246;

});

parcelRegister("ey6Pt", function(module, exports) {
/**
 * @generated SignedSource<<9788b38f2bb32f836366310152c95cca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $377a05a3faea70b3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "UpgradeEditionButtonFragment",
        "selections": [
            {
                "concreteType": "Editions",
                "kind": "LinkedField",
                "name": "editions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "confluence"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "ConfluenceTenantContext"
    };
}();
$377a05a3faea70b3$var$node.hash = "bee007bb99f1be1656322a1f41effd37";
var $377a05a3faea70b3$export$2e2bcd8739ae039 = $377a05a3faea70b3$var$node;
module.exports["default"] = $377a05a3faea70b3$export$2e2bcd8739ae039;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56b88a11fb19ee4bef2fa0f940debca3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features and functionality. Editions may replace the current premium sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.614 1.353A.75.75 0 0 1 3.25 1h9.5a.75.75 0 0 1 .636.353l2.5 4a.75.75 0 0 1-.065.884l-7.25 8.5a.75.75 0 0 1-1.142 0l-7.25-8.5a.75.75 0 0 1-.065-.885zM3.666 2.5 2.103 5H4.7l.78-2.5zm3.385 0L6.271 5H9.73l-.781-2.5zm3.47 0L11.3 5h2.596l-1.563-2.5zm3.103 4h-2.328l-1.424 4.399zM8 11.813 9.72 6.5H6.28zM4.704 6.5l1.424 4.399L2.375 6.5z" clip-rule="evenodd"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("lgF8o", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $8918255f2a9fee62$export$b8a9d3f49ba5a590 = ({ experimentMeta: experimentMeta, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            attributes: {
                experimentMeta: experimentMeta
            }
        },
        children: children
    });
};
module.exports["ExperimentAnalyticsContext"] = $8918255f2a9fee62$export$b8a9d3f49ba5a590;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("b0Zto", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $6mKj3 = parcelRequire("6mKj3");


var $d9tcB = parcelRequire("d9tcB");

const $daeecc56e3f5b5fd$var$messages = (0, $cgtv4.defineMessages)({
    upgradeButtonText: {
        id: "experiment-change-edition-upgrade-button-content.upgrade-button.text",
        defaultMessage: "Upgrade"
    },
    getStartedButtonText: {
        id: "experiment-change-edition-upgrade-button-content.get-started-button.text",
        defaultMessage: "Get started"
    }
});
const $daeecc56e3f5b5fd$var$isEligibleForExperiment = ({ targetEdition: targetEdition, featureGateId: featureGateId })=>{
    const excludedFeatureGates = [
        'editorAITryPremium',
        'quickSummaryTryPremium',
        'whiteboardPaywallLearnMoreButton',
        'elevateAutomationUpsellExploreAutomation',
        'elevateAutomationUpsellTryPremium'
    ];
    if (!featureGateId) return false;
    return targetEdition === (0, $d9tcB.ConfluenceEdition).PREMIUM && !excludedFeatureGates.includes(featureGateId);
};
const $daeecc56e3f5b5fd$export$8be5e1b5b37b4586 = (eligibilityParams)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligible = eligibilityParams ? $daeecc56e3f5b5fd$var$isEligibleForExperiment(eligibilityParams) : false;
    const cohort = isEligible ? (0, $6mKj3.expVal)('replace_upsell_cta_content', 'cohort', 'not-enrolled') : 'not-enrolled';
    (0, $42omo.useEffect)(()=>{
        if (cohort === 'not-enrolled') return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'replace_upsell_cta_content',
                attributes: {
                    flagKey: 'replace_upsell_cta_content',
                    cohort: cohort
                }
            }
        }).fire();
    }, [
        cohort,
        createAnalyticsEvent
    ]);
    if (cohort === 'variant-upgrade') return {
        upgradeButtonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daeecc56e3f5b5fd$var$messages.upgradeButtonText),
        cohort: cohort
    };
    if (cohort === 'variant-get-started') return {
        upgradeButtonContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $daeecc56e3f5b5fd$var$messages.getStartedButtonText),
        cohort: cohort
    };
    return {
        upgradeButtonContent: null,
        cohort: cohort
    };
};
module.exports["useChangeEditionUpgradeButtonContentExperiment"] = $daeecc56e3f5b5fd$export$8be5e1b5b37b4586;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("2UjZJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $gXR0B = parcelRequire("gXR0B");


var $f1B2z = parcelRequire("f1B2z");

const $dd8da84ad086336b$export$2bbc11bf12d076a0 = ({ skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)({
        skip: skip,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    (0, $42omo.useEffect)(()=>{
        if (isEligible) {
            fireExperimentExposureEvent({
                flagKey: 'grw-1930_confluence_upv2_standard_ab',
                cohort: (0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'),
                growthInitiative: 'luna',
                touchpointId: touchpointId,
                additionalAttributes: {
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    isBillingAdmin: isBillingAdmin
                }
            });
            setAbCohort((0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'));
        } else if (eligibilityHookError) // Error occurred, reset to null
        setAbCohort(null);
        else setAbCohort('not-enrolled');
    }, [
        fireExperimentExposureEvent,
        isEligible,
        eligibilityHookError,
        currentEdition,
        targetEdition,
        isSiteAdmin,
        isBillingAdmin,
        touchpointId
    ]);
    return {
        cohort: abCohort,
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: eligibilityHookLoading,
        error: eligibilityHookError
    };
};
module.exports["useUpflowV2ConfluenceStandardFGsExperiment"] = $dd8da84ad086336b$export$2bbc11bf12d076a0;

});

parcelRegister("gXR0B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $c07cc869290551b6$export$5218ddb3d9c658c0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    // This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
    return (0, $42omo.useCallback)(({ flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: additionalAttributes = {} })=>{
        const flagTouchpointKey = `${flagKey}:${touchpointId}`;
        if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: `${flagKey}-exposed`,
                source: flagKey,
                attributes: {
                    cohort: cohort,
                    touchpointId: touchpointId,
                    growthInitiative: growthInitiative,
                    ...additionalAttributes
                }
            }
        }).fire();
        sentFlagKeys.current.push(flagTouchpointKey);
    }, [
        createAnalyticsEvent
    ]);
};
module.exports["useFeatureExposedAnalytics"] = $c07cc869290551b6$export$5218ddb3d9c658c0;

});

parcelRegister("f1B2z", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 */ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $euL71 = parcelRequire("euL71");

const $26baada861c32413$var$extractBillingAdminStatus = (billingData)=>{
    return billingData?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
};
const $26baada861c32413$export$6da6d4db5c51c32 = ({ skip: skip = false, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement{id transactionAccount{...on Node{id __typename}isCurrentUserBillingAdmin}}}}}`, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId
        },
        skip: skip || !isBasicEligible
    });
    (0, $42omo.useEffect)(()=>{
        if (billingAdminQueryError) {
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'grw-1930_confluence_upv2_standard_ab'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: billingAdminQueryError.message,
                source: 'useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook',
                severity: (0, $gwZbZ.Severity).HIGH
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, [
        billingAdminQueryError,
        createAnalyticsEvent
    ]);
    const isBillingAdmin = (0, $42omo.useMemo)(()=>{
        return $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
    }, [
        billingAdminData
    ]);
    return {
        isEligible: Boolean(isBasicEligible && isBillingAdmin),
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: isBillingAdminQueryLoading,
        error: billingAdminQueryError
    };
};
module.exports["useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment"] = $26baada861c32413$export$6da6d4db5c51c32;

});

parcelRegister("5M47w", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $6Co6F = parcelRequire("6Co6F");


var $6bHqX = parcelRequire("6bHqX");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $lh1MN = parcelRequire("lh1MN");


var $hfUvC = parcelRequire("hfUvC");

var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
   * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
   * but to construct the deeplink, we need to:
   * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
   * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
   * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
   *
   * This is a stop gap solution while we work with Commerce to eventually have one AGG query
   * to provide everything we need with just a CloudId and the product key (e.g. confluence
   */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $lzcvT.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) || (0, $lzcvT.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $j1Ss3.useQuery)(/** @schema cc */ (0, $eSUdr.default)`query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}}tenant{cloudId}}`, {
        skip: skipDeepLinks || !isCcpBackend
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $j1Ss3.useQuery)(/** @schema agg */ (0, $eSUdr.default)`query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!$targetEditionName:String$shouldFetchChangeOffering:Boolean!){ccp{entitlement(id:$entitlementId){transactionAccountId experienceCapabilities@include(if:$shouldFetchChangeOffering){changeOfferingV2(offeringName:$targetEditionName){experienceUrl}}}}}`, {
        variables: {
            entitlementId: ccpEntitlementId || '',
            targetEditionName: targetEdition || '',
            shouldFetchChangeOffering: (0, $9wGTI.fg)('ld-74-fetch-change-offering-url-in-upgrade-edition')
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    let changeOfferingDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        // format -> https://admin.stg.atlassian.com/billing/UUID/entitlement/TWC-UUID-OR-CONF/change-plan?requireAtlOrigin=true&referrer=
        const changeOfferingExperienceUrl = ccpEntitlementTxaIdData?.ccp?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId || undefined
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        changeOfferingDeepLink = changeOfferingExperienceUrl ? $ae96eb60e6557b8b$var$addAtlOriginToUrl(`${changeOfferingExperienceUrl}confluence`) : undefined;
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: changeOfferingDeepLink || planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};
module.exports["CommerceDeepLinksTargetEdition"] = $ae96eb60e6557b8b$export$92b15cc7e26a62fb;
module.exports["useCommerceDeepLinks"] = $ae96eb60e6557b8b$export$91505ae0b86ded0b;

});

parcelRegister("6bHqX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gstll = parcelRequire("gstll");

var $6H9BA = parcelRequire("6H9BA");


var $4Twfb = parcelRequire("4Twfb");


var $3yFL2 = parcelRequire("3yFL2");

var $3SLm1 = parcelRequire("3SLm1");

var $cEhot = parcelRequire("cEhot");


var $1Y5Zp = parcelRequire("1Y5Zp");

const $30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL = `${(0, $gstll.GATEWAY_URL)}/bag`;
const $30c48f23b8aa47be$export$56507f8f3f7349a5 = 'HAMS';
const $30c48f23b8aa47be$export$9a39331b1bb2f849 = 'CCP';
const $30c48f23b8aa47be$export$49ab1426acf387e4 = async (params, { fetch: fetch })=>{
    try {
        const response = await fetch(`${$30c48f23b8aa47be$var$BILLING_API_GATEWAY_URL}/rollout/service?cloudId=${encodeURIComponent(params.cloudId)}`);
        if (response.status !== 200) return {
            payload: undefined,
            error: `Failed to fetch commerce rollout information: ${response.statusText}`,
            exception: undefined
        };
        const service = (await response.json()).service;
        return {
            payload: service === 'CCP' ? {
                commerceBackend: service,
                ccp: {}
            } : {
                commerceBackend: service,
                hams: {}
            },
            error: undefined,
            exception: undefined
        };
    } catch (exception) {
        return {
            payload: undefined,
            error: undefined,
            exception: exception
        };
    }
};
const $30c48f23b8aa47be$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $6H9BA.useCommerceFetch)();
    const effectiveOptions = (0, $42omo.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $cEhot.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $4Twfb.useFetchService)((0, $42omo.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $30c48f23b8aa47be$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $1Y5Zp.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $1Y5Zp.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $3SLm1).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $3yFL2).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $3SLm1).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $3yFL2).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};
module.exports["COMMERCE_BACKEND_HAMS"] = $30c48f23b8aa47be$export$56507f8f3f7349a5;
module.exports["COMMERCE_BACKEND_CCP"] = $30c48f23b8aa47be$export$9a39331b1bb2f849;
module.exports["fetchCommerceRolloutInformation"] = $30c48f23b8aa47be$export$49ab1426acf387e4;

});

parcelRegister("gstll", function(module, exports) {
// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
const $973c3a69f9510c45$export$91e8019c72e4e6d = `/gateway/api`;
module.exports["GATEWAY_URL"] = $973c3a69f9510c45$export$91e8019c72e4e6d;

});

parcelRegister("6H9BA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $goqBE = parcelRequire("goqBE");


var $bIMHH = parcelRequire("bIMHH");


var $1cK19 = parcelRequire("1cK19");


var $1EMUC = parcelRequire("1EMUC");


var $lzJ3V = parcelRequire("lzJ3V");

const $5f57f8a421838b9c$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $1EMUC.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $bIMHH.useSentryExceptionDispatch)();
    return (0, $42omo.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $1cK19.sanitizeUrlString)((0, $lzJ3V.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $4u5NT.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5f57f8a421838b9c$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $goqBE.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });
module.exports["useCommerceFetch"] = $5f57f8a421838b9c$export$5f844fc0012b62a;

});

parcelRegister("goqBE", function(module, exports) {
class $de24e055bcb736b9$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de24e055bcb736b9$export$d2f2761cbe9cebf2.prototype);
    }
}
const $de24e055bcb736b9$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $de24e055bcb736b9$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};
module.exports["HttpResponseError"] = $de24e055bcb736b9$export$d2f2761cbe9cebf2;
module.exports["rejectOnHttpError"] = $de24e055bcb736b9$export$a4c208475de70990;

});

parcelRegister("bIMHH", function(module, exports) {

var $aNwpq = parcelRequire("aNwpq");


var $k6lJw = parcelRequire("k6lJw");


var $6YLhE = parcelRequire("6YLhE");

const $48dc7deec6188f73$export$3c3f21d4489e178a = (0, $aNwpq.internalGasV3UIEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$5e75c4fb0a07e6f4 = (0, $aNwpq.internalGasV3ScreenEventChannel).useEventDispatch;
const $48dc7deec6188f73$export$eb1dac57abae25e8 = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$ab6d20b2228c09c6 = (0, $aNwpq.internalGasV3OperationalEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$cf4d833c52e18bed = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$8eb9a37a282b8ea6 = (0, $k6lJw.createAtlaskitToEventChannelRepackager)($48dc7deec6188f73$export$3c3f21d4489e178a);
const $48dc7deec6188f73$export$d6cab26720f11779 = (0, $aNwpq.breadcrumbMountedEventChannel).Listener;
const $48dc7deec6188f73$export$794ea2871d096951 = (Component, name, attributes)=>(0, $6YLhE.withBreadcrumb)(Component, (0, $aNwpq.Breadcrumb), name, attributes);
module.exports["useSentryExceptionDispatch"] = $48dc7deec6188f73$export$cf4d833c52e18bed;

});

parcelRegister("aNwpq", function(module, exports) {

var $6YLhE = parcelRequire("6YLhE");


var $eUjEX = parcelRequire("eUjEX");

const $48f3d8edf25a7fa7$var$breadcrumbAPI = (0, $6YLhE.createBreadcrumbAPI)();
const $48f3d8edf25a7fa7$export$1622e7b9340efb0 = $48f3d8edf25a7fa7$var$breadcrumbAPI.breadcrumbMountedEventChannel;
const $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc = $48f3d8edf25a7fa7$var$breadcrumbAPI.Breadcrumb;
const $48f3d8edf25a7fa7$export$a841c408695b0137 = $48f3d8edf25a7fa7$var$breadcrumbAPI.useGetBreadcrumbs;
const $48f3d8edf25a7fa7$export$58a908b728d2cddc = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$34eb9485fd3a664a = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$fb5e587076f78057 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$f92d259194a988f8 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$d9c23c680d73705d = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$b7973f9532f3f87f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$5a78c7e669ed705e = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$90a2fbbf51eb525f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$d9101fe70b7457a1 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
module.exports["breadcrumbMountedEventChannel"] = $48f3d8edf25a7fa7$export$1622e7b9340efb0;
module.exports["Breadcrumb"] = $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc;
module.exports["internalGasV3UIEventChannel"] = $48f3d8edf25a7fa7$export$b7973f9532f3f87f;
module.exports["internalGasV3ScreenEventChannel"] = $48f3d8edf25a7fa7$export$5a78c7e669ed705e;
module.exports["internalGasV3TrackEventChannel"] = $48f3d8edf25a7fa7$export$90a2fbbf51eb525f;
module.exports["internalGasV3OperationalEventChannel"] = $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91;
module.exports["internalSentryExceptionChannel"] = $48f3d8edf25a7fa7$export$d9101fe70b7457a1;

});

parcelRegister("6YLhE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eUjEX = parcelRequire("eUjEX");

const $098bf883a354e4d9$var$emptyObject = {};
const $098bf883a354e4d9$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $42omo.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $eUjEX.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $42omo.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $42omo.useRef)(castBreadcrumbPayload);
        (0, $42omo.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $42omo.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $098bf883a354e4d9$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $eUjEX.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $42omo.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $098bf883a354e4d9$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $098bf883a354e4d9$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $l998X.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};
module.exports["createBreadcrumbAPI"] = $098bf883a354e4d9$export$783e5d823c500873;
module.exports["createBreadcrumbedEventChannel"] = $098bf883a354e4d9$export$d3653322274df895;
module.exports["withBreadcrumb"] = $098bf883a354e4d9$export$794ea2871d096951;

});

parcelRegister("eUjEX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $42omo.useContext)(context);
        const fireEventCallback = (0, $42omo.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $e0bd124d99ee3c1b$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $e0bd124d99ee3c1b$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $42omo.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $42omo.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $e0bd124d99ee3c1b$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $42omo.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $e0bd124d99ee3c1b$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};
module.exports["createCatchingEventChannel"] = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e;
module.exports["createEventChannel"] = $e0bd124d99ee3c1b$export$7b182ad6fa711a33;

});

parcelRegister("k6lJw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");

const $39d282bcf5375d57$var$ATLASKIT_CHANNEL = 'atlaskit';
const $39d282bcf5375d57$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $42omo.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $39d282bcf5375d57$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $39d282bcf5375d57$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $39d282bcf5375d57$export$ad0c43fbe23d07ab = (Listener, channel = $39d282bcf5375d57$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $42omo.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};
module.exports["createAtlaskitToEventChannelRepackager"] = $39d282bcf5375d57$export$1ec809871e34d2f0;

});

parcelRegister("1cK19", function(module, exports) {
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $3031758fc3a9c9bd$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};
module.exports["sanitizeUrlString"] = $3031758fc3a9c9bd$export$ceb09b958e605eff;

});

parcelRegister("1EMUC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9Bcp3 = parcelRequire("9Bcp3");

const $fb2833db791c8fde$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $42omo.useState)(()=>new Map(overrides));
    (0, $42omo.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$fb2833db791c8fde$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Bcp3.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $fb2833db791c8fde$export$edb6244a86733174 = ()=>(0, $42omo.useContext)((0, $9Bcp3.overrideContext));
const $fb2833db791c8fde$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $fb2833db791c8fde$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $fb2833db791c8fde$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $fb2833db791c8fde$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $fb2833db791c8fde$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];
module.exports["useCommerceOverride"] = $fb2833db791c8fde$export$cf6f15ae0c6d3b84;

});

parcelRegister("9Bcp3", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $0f5923cabface8ba$export$81b0387840a1a60c = (0, $42omo.createContext)(new Map());
module.exports["overrideContext"] = $0f5923cabface8ba$export$81b0387840a1a60c;

});

parcelRegister("lzJ3V", function(module, exports) {
const $8b805f09b2bef0e7$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
module.exports["getRequestUrl"] = $8b805f09b2bef0e7$export$14619c0eed01a470;

});

parcelRegister("4Twfb", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $b022c09cd7385a9a$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $42omo.useState)(initialState);
    const fetchData = (0, $42omo.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $b022c09cd7385a9a$export$ff7e5879ade03276 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $42omo.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$18e513c1248d8ad5 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$d9765c5cd98039 = (request)=>{
    const service = $b022c09cd7385a9a$export$18e513c1248d8ad5(request);
    return (0, $42omo.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$7077fee76310bc60 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};
module.exports["useFetchService"] = $b022c09cd7385a9a$export$ff7e5879ade03276;
module.exports["useUpdateService"] = $b022c09cd7385a9a$export$18e513c1248d8ad5;

});

parcelRegister("3yFL2", function(module, exports) {
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $46d5cbdb1ec76aac$export$6af268b89fae390b = 'guaranteed';
const $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf = 'maybe';
const $46d5cbdb1ec76aac$export$c53d0f541b41b88e = 'none';
module.exports["GUARANTEED"] = $46d5cbdb1ec76aac$export$6af268b89fae390b;
module.exports["MAYBE"] = $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf;
module.exports["NONE"] = $46d5cbdb1ec76aac$export$c53d0f541b41b88e;

});

parcelRegister("3SLm1", function(module, exports) {
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $a2df338368098843$export$78244dbb77cfa6b6 = 'unknown';
const $a2df338368098843$export$aed27a6561cc0f5c = 'unknown-external';
const $a2df338368098843$export$983d8427a452c1b = 'commerce-libraries';
const $a2df338368098843$export$d5a5208541f78b0 = 'hams';
const $a2df338368098843$export$856303030f6df405 = 'billing-api-gateway';
module.exports["UNKNOWN"] = $a2df338368098843$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_EXTERNAL"] = $a2df338368098843$export$aed27a6561cc0f5c;
module.exports["COMMERCE_LIBRARIES"] = $a2df338368098843$export$983d8427a452c1b;
module.exports["HAMS"] = $a2df338368098843$export$d5a5208541f78b0;
module.exports["BILLING_API_GATEWAY"] = $a2df338368098843$export$856303030f6df405;

});

parcelRegister("cEhot", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3yFL2 = parcelRequire("3yFL2");


var $aNwpq = parcelRequire("aNwpq");


var $in0Xj = parcelRequire("in0Xj");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $d09c0c9679eec46e$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $d09c0c9679eec46e$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $d09c0c9679eec46e$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: _histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$d09c0c9679eec46e$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $42omo.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $3yFL2.MAYBE),
                (0, $3yFL2.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $in0Xj.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $3yFL2.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $3yFL2.GUARANTEED)) {
                    if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $3yFL2.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $d09c0c9679eec46e$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $d09c0c9679eec46e$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $d09c0c9679eec46e$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $42omo.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $42omo.useCallback)(/**
		 * Please note that thrown errors will be interpreted as guaranteed buggy failures.
		 * @param payload This data passed into this function will be shared between both failure and successful tasks
		 */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $3yFL2.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};
module.exports["useTaskTracker"] = $d09c0c9679eec46e$export$8ea5335bded027a0;

});

parcelRegister("in0Xj", function(module, exports) {

var $3yFL2 = parcelRequire("3yFL2");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $2cec5ac4f8c71665$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $3yFL2.GUARANTEED:
            if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $3yFL2.MAYBE:
            return 'warning';
        case 0, $3yFL2.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $2cec5ac4f8c71665$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $2cec5ac4f8c71665$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($2cec5ac4f8c71665$var$severityOrdering.get(severity1) <= $2cec5ac4f8c71665$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $2cec5ac4f8c71665$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $3SLm1.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $2cec5ac4f8c71665$export$bf5f90a1a9d2de58(tags)
    };
};
module.exports["withTelemetryInfoScopeContext"] = $2cec5ac4f8c71665$export$c7063fd1387b3458;

});

parcelRegister("jVQXW", function(module, exports) {

var $3SLm1 = parcelRequire("3SLm1");

const $d91c14f6a33096f8$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $3SLm1.COMMERCE_LIBRARIES) || responsibleService === (0, $3SLm1.UNKNOWN);
module.exports["responsibleServiceIncludesCommerceLibraries"] = $d91c14f6a33096f8$export$6d5fcf71bce583e2;

});

parcelRegister("1Y5Zp", function(module, exports) {
const $1fb762876766bde5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $1fb762876766bde5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $1fb762876766bde5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $1fb762876766bde5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $1fb762876766bde5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $1fb762876766bde5$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $1fb762876766bde5$export$a7324067d5b1efd6;

});

parcelRegister("lh1MN", function(module, exports) {
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};
module.exports["getCcpEntitlementFromQuery"] = $7f1ee6750f4adf66$export$db45730c9afae012;

});

parcelRegister("hfUvC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $bXe73 = parcelRequire("bXe73");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $2XqLN.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $6bHqX.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $42omo.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $bXe73.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error = (0, $bXe73.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error);
                }
            } catch (error) {
                error.message = `useCommerceBackendName: ${error.message}`;
                setError(error);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceRolloutInformation"] = $e7daf7179cc3ad9e$export$44d1450d6b2633f0;

});

parcelRegister("bXe73", function(module, exports) {
const $f975479e12996987$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $f975479e12996987$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $f975479e12996987$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $f975479e12996987$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $f975479e12996987$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $f975479e12996987$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $f975479e12996987$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $f975479e12996987$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $f975479e12996987$export$a7324067d5b1efd6;

});

parcelRegister("dqdrq", function(module, exports) {
/* GradientCTAButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {
/* GradientCTAButtonBase.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("ktelT", function(module, exports) {
/* GradientSubtleLinkButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $izVB4 = parcelRequire("izVB4");

const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71879 _11c82smr _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pmoej _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: ""
    }), children);
};
module.exports["GradientSubtleLinkButton"] = $903332396267b541$export$7e6e2bf13161f2a;

});

parcelRegister("l0DoV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $537ed6b0b56c707f$export$5422bd88477f90e5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uHF1j",
    name: "TryStandardUpflowV2ExperimentTreatmentModalLoadable",
    loader: async ()=>(await (parcelRequire("jZpTz"))).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary
});
module.exports["TryStandardUpflowV2ExperimentTreatmentModalLoadable"] = $537ed6b0b56c707f$export$5422bd88477f90e5;

});

parcelRegister("jZpTz", function(module, exports) {

let $e8d7cd16d547b234$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e8d7cd16d547b234$var$load("6wr18"),
    $e8d7cd16d547b234$var$load("eeaKR"),
    $e8d7cd16d547b234$var$load("ffEVr"),
    $e8d7cd16d547b234$var$load("lTA9n"),
    $e8d7cd16d547b234$var$load("hhss7"),
    $e8d7cd16d547b234$var$load("fYFVU")
]).then(()=>parcelRequire('h60zh'));

});

parcelRegister("fDbEj", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $6mKj3 = parcelRequire("6mKj3");


var $gQY3Y = parcelRequire("gQY3Y");


var $jKFU9 = parcelRequire("jKFU9");

const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition, writeFragmentInterop)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.confluence;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                if ((0, $6mKj3.expValEquals)('remove_usages_of_cache_read_write', 'isEnabled', true)) writeFragmentInterop({
                    fragmentId: '$ROOT_QUERY.confluence_tenantContext',
                    data: {
                        editions: {
                            confluence: polledEdition,
                            __typename: 'ConfluenceEditions'
                        },
                        __typename: 'Tenant'
                    }
                });
                else // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                (0, $hp2SH.getApolloClient)().writeQuery({
                    query: (0, $gQY3Y.waitForEditionChangeQuery),
                    data: {
                        tenant: {
                            editions: {
                                confluence: polledEdition,
                                __typename: 'ConfluenceEditions'
                            },
                            __typename: 'Tenant'
                        }
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};
module.exports["TimeoutError"] = $3737157ebbad3bf6$export$66d311bf29d5c89c;
module.exports["waitForEditionChange"] = $3737157ebbad3bf6$export$d63cfb67ca7b2a0;

});

parcelRegister("gQY3Y", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $eSUdr.default)`query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}`;
module.exports["waitForEditionChangeQuery"] = $1047f6c600fde1f6$export$291c2fa2b3781c67;

});

parcelRegister("jKFU9", function(module, exports) {
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;
module.exports["CHANGE_EDITION_POLL_INTERVAL_SECS"] = $97f7046950ca68f7$export$4f9b7eb5b7999045;
module.exports["CHANGE_EDITION_POLL_DURATION_MINS"] = $97f7046950ca68f7$export$6925031fb600919f;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bhvFb", function(module, exports) {
/* EditionSectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3HQYo = parcelRequire("3HQYo");


var $9wGTI = parcelRequire("9wGTI");


var $gsZdA = parcelRequire("gsZdA");

const $1848832735763b59$var$contentContainerStyles = {
    regular: "_1e0c1txw _2lx21bp4 _16jlkb7n _p12f1lk2",
    isCard: "_p12f1osq"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_11c8nbxd _19pkidpf _syazi7uo",
    regularNew: "_11c8lodh _k48p1wq8 _19pkidpf _syazi7uo",
    inlineModal: "_11c8lodh _19pkze3t _n3tdpxbi"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_19pku2gc",
    noTitle: "_19pkidpf"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_1e0c1txw _1bahesu3 _kqswstnw _154ipxbi _1xi21ejb",
    default: "_154ixy5q _1xi2oahv",
    isCardDefault: "_1xi2xy5q",
    isCard: "_1xi2pxbi"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_1e0c1txw _19pkpxbi",
    right: "_1bahesu3 _166l1sbv _6ufw1q9c",
    inlineModal: "_19pk16xz _1e0c1txw"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_x3do1uh4 _19pkpxbi _otyrpxbi _ca0qutpp"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_2rkofajl _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhk1bhr _1e0c1txw _16jlkb7n",
    withTasteAndToneStyling: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk1j28",
    default: "_1yt44ar7 _16qs130s _p12fasau",
    flat: "_1yt44ar7 _p12fasau",
    inline: "_11c82smr",
    inlineModal: "_p12f1kdj"
};
const $1848832735763b59$export$d8126cfce410377d = ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)('ten_active_boards_in_standard') ? 'regularNew' : 'regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
        },
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};
module.exports["EditionSectionMessage"] = $1848832735763b59$export$d8126cfce410377d;

});

parcelRegister("3HQYo", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $gtD4K = parcelRequire("gtD4K");


var $eEA8O = parcelRequire("eEA8O");

const $0db05c5b00b76da2$var$ELIGIBLE_TOUCHPOINTS = {
    pageInsights: 'Standard',
    archiveUpsellDialog: 'Standard',
    generalAccessLevelSelector: 'Standard',
    shareAndRestrictDialogUpsell: 'Standard',
    quickSummaryUpsellScreen: 'Premium',
    teamCalendarUpsellScreen: 'Premium',
    'whiteboardCreationPaywall-upfrontDialog': 'Premium'
};
const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const offeringName = $0db05c5b00b76da2$var$ELIGIBLE_TOUCHPOINTS[source] ?? '';
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName
        },
        fetchPolicy: 'cache-first',
        skip: !(0, $9wGTI.fg)('connie_end_user_request_kill_switch') || isSiteAdmin || edition !== (0, $d9tcB.ConfluenceEdition).FREE || !(source in $0db05c5b00b76da2$var$ELIGIBLE_TOUCHPOINTS),
        client: (0, $gKr8t.getAGGClient)()
    });
    const isEligibleForEndUserRequest = (0, $42omo.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingToStandardExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingToStandardExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        return Boolean(!loading && !isInCollection && edition === (0, $d9tcB.ConfluenceEdition).FREE && hasPaymentDetailsEntered && !canUpgrade);
    }, [
        data,
        loading,
        edition
    ]);
    return {
        showRequestUpgradeButton: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequest && (0, $9wGTI.fg)('connie_end_user_request_kill_switch') && (0, $6mKj3.expVal)('connie_end_user_request_exp', 'cohort', 'not-enrolled') === 'variation',
        showRequestUpgradeButtonAATest: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequest && (0, $9wGTI.fg)('connie_end_user_request_kill_switch') && (0, $6mKj3.expVal)('connie_end_user_request_exp_aa', 'cohort', 'not-enrolled') !== 'not-enrolled',
        loading: loading
    };
};
const $0db05c5b00b76da2$export$ccc7e3a47fa3a9b0 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        onClick: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })) // dummy placeholder, replace with actual button component
    ;
};
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;
module.exports["EndUserRequestUpgradeButton"] = $0db05c5b00b76da2$export$ccc7e3a47fa3a9b0;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<1718f33f3a73d37e86710901f9bfc3ce>>
 * @relayHash 822f894fb3b9dd84fe8a475ab2533d16
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5b0a450cc5f6e6df4a010f39c351c51ac26cc36dd7b644ad15e7530018651a8
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v10 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "822f894fb3b9dd84fe8a475ab2533d16",
            "id": "a5b0a450cc5f6e6df4a010f39c351c51ac26cc36dd7b644ad15e7530018651a8",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "8e9f0485f2baca6b8f14ef988555d372";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("gLeLL", function(module, exports) {
/* SectionMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $j4WDj = parcelRequire("j4WDj");


var $4WmbV = parcelRequire("4WmbV");

const $103cc6a380e10ff8$export$a36903bd214cec06 = ({ children: children, withGradient: withGradient = true, topBanner: // TODO: refactor topBanner and customPadding per https://product-fabric.atlassian.net/browse/USD-337
// for now since we only support 2 different cases, we give a boolean, going forward, if more use cases surface, we can revisit and design a better API
topBanner = false, customPadding: customPadding, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$Layout, {
        withGradient: withGradient,
        topBanner: topBanner,
        customPadding: customPadding,
        "data-testid": "section-message"
    }, !!children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($103cc6a380e10ff8$var$ChildrenLayout, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true
    }));
const $103cc6a380e10ff8$var$ChildrenLayout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2hwx1ejb _p12f68cl _1ul968cl",
            __cmplp.className
        ])
    });
});
const $103cc6a380e10ff8$var$gradientBackground = `linear-gradient(84.09deg,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_START)} 0%,
  ${(0, $j4WDj.GRADIENT_BACKGROUND_SUBTLEST_END)} 100%)`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $103cc6a380e10ff8$var$Layout = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withGradient: withGradient, customPadding: customPadding, topBanner: topBanner, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1p4ue13": (0, $7sObp.default)($103cc6a380e10ff8$var$gradientBackground),
            "--_krzptn": (0, $7sObp.default)((()=>{
                if (__cmplp.customPadding) return __cmplp.customPadding;
                if (__cmplp.topBanner) return `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"}`;
                return `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`;
            })())
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1yt41r3g _2rko12b0 _1e0c1txw _1bsb1osq _vchhusvi _kqswh2mm",
            __cmplp.withGradient ? "_11q7hu7i" : "_11q7glyw",
            __cmplp.className
        ])
    });
});
module.exports["SectionMessage"] = $103cc6a380e10ff8$export$a36903bd214cec06;

});

parcelRegister("4adOe", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1KmJq = parcelRequire("1KmJq");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $jZABW = parcelRequire("jZABW");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $6uhfT = parcelRequire("6uhfT");


var $3hlsb = parcelRequire("3hlsb");


var $7BnEk = parcelRequire("7BnEk");


var $3PKog = parcelRequire("3PKog");


var $9uaV8 = parcelRequire("9uaV8");


var $cMbwo = parcelRequire("cMbwo");


var $5bmjx = parcelRequire("5bmjx");


var $4Ewfm = parcelRequire("4Ewfm");


var $T5KYq = parcelRequire("T5KYq");


var $cBa8E = parcelRequire("cBa8E");


var $5608P = parcelRequire("5608P");


var $3Ipyu = parcelRequire("3Ipyu");

const $f9a7e940d2f4f7fe$var$ControllerDirectRestrictionsMutation = (0, $eSUdr.default)`mutation ControllerDirectRestrictionsMutation($pageId:ID!$restrictions:PageRestrictionsInput){updatePage(input:{pageId:$pageId restrictions:$restrictions}){page{id}}}`;
const $f9a7e940d2f4f7fe$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $f9a7e940d2f4f7fe$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $f9a7e940d2f4f7fe$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
function $f9a7e940d2f4f7fe$var$useController(controllerProps, controllerExtras) {
    const { fireAnalyticEvent: fireAnalyticEvent, cloudId: cloudId } = controllerExtras;
    const { contentId: contentId, contentType: contentType, publishModalRestrictions: publishModalRestrictions, pushPublishModalRestrictions: pushPublishModalRestrictions, spaceKey: spaceKey, onClose: onClose, onCloseComplete: onCloseComplete, initialDialog: initialDialog, hasRestrictions: hasRestrictions, isUnpublishedDraft: isUnpublishedDraft } = controllerProps;
    const [wasDialogClosedDuringLoading, setWasDialogClosedDuringLoading] = (0, $42omo.useState)(false);
    const [masterState, setMasterState] = (0, $42omo.useState)((0, $7BnEk.makeDefaultMasterState)(initialDialog));
    const dispatchCtaFlowEvent = (0, $5608P.useCtaFlowController)(setMasterState);
    const [shownLoadErrorFlag, setShownLoadErrorFlag] = (0, $42omo.useState)(false);
    const queriesHookResponse = (0, $cMbwo.useQueries)({
        contentId: contentId,
        contentType: contentType,
        publishModalRestrictions: publishModalRestrictions,
        spaceKey: spaceKey,
        cloudId: cloudId
    });
    if (queriesHookResponse.state === 'loading' || // If the user closes the dialog in the loading state, then keep the loading
    // state showing even if the query finally resolves: it's not helpful to
    // replace the dialog contents with a flash of content during the exit
    // transition.
    wasDialogClosedDuringLoading) {
        // If we don't have the bare minimum needed to display the dialog, short-
        // circuit and give hardwired props for the loading state. By doing it this
        // way, the code that later calculates derivedState can rely on all the
        // inputs it needs being available, saving lots of guard code later on.
        const header = {
            titleAndButtons: {
                title: initialDialog === 'accessRequests' ? 'accessRequests' : 'share',
                overflowMenu: undefined,
                onBackClick: initialDialog === 'accessRequests' ? ()=>{} : undefined,
                onCloseClick: ()=>{
                    setWasDialogClosedDuringLoading(true);
                },
                // Needed for the AccessRequestsButton to start preloading early
                accessRequests: {
                    lastTriggeredDialogVariant: null,
                    openAccessRequestsDialog: ()=>{},
                    clearElementToFocus: ()=>{},
                    usdLoading: true
                }
            },
            // principalsStager: undefined,
            // showDraftMessage: false,
            hasNavigationLockout: false
        };
        const publishModalFlowHasSpecificAccess = Boolean(publishModalRestrictions?.some((operation)=>operation?.restrictions.user.results.length));
        const isPublishModalFlow = Boolean(pushPublishModalRestrictions);
        const usdLoadingHeightContext = {
            specificAccessVisible: hasRestrictions || publishModalFlowHasSpecificAccess,
            isDraft: isUnpublishedDraft,
            isPublishModalFlow: isPublishModalFlow,
            isEmbed: contentType === 'embed'
        };
        const shareAndRestrictDialog = {
            onCloseRequest: ()=>{
                setWasDialogClosedDuringLoading(true);
            },
            onCloseComplete: ()=>{
                onClose();
                onCloseComplete?.();
            },
            header: header,
            body: undefined,
            footer: undefined,
            isLoading: true,
            analyticsAttributes: undefined,
            usdLoadingHeightContext: usdLoadingHeightContext
        };
        return wasDialogClosedDuringLoading ? {
            dialogsProps: {}
        } : {
            dialogsProps: {
                shareAndRestrictDialog: shareAndRestrictDialog
            }
        };
    }
    if (queriesHookResponse.state === 'error') {
        controllerExtras.experienceTracker.fail({
            name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE),
            error: new Error('Failed to fetch share and restrictions dialog data')
        });
        fireAnalyticEvent({
            eventType: 'sendTrackEvent',
            action: 'failed',
            actionSubject: 'query',
            actionSubjectId: 'ShareAndRestrictDialog'
        });
        if (!shownLoadErrorFlag) {
            setShownLoadErrorFlag(true);
            controllerExtras.errorFlag('loading-error');
        }
        return {
            dialogsProps: {}
        };
    }
    const { queriesState: queriesState, refetchQueries: refetchQueries } = queriesHookResponse;
    const derivedState = (0, $3PKog.getDerivedState)(masterState, queriesState, controllerProps);
    const actions = (0, $3hlsb.getActions)(controllerProps, controllerExtras, masterState, derivedState, queriesState, setMasterState, dispatchCtaFlowEvent, refetchQueries);
    const statesAndActions = {
        controllerProps: controllerProps,
        controllerExtras: controllerExtras,
        masterState: masterState,
        derivedState: derivedState,
        queriesState: queriesState,
        actions: actions
    };
    return {
        dialogsProps: (0, $9uaV8.makeDialogsProps)(statesAndActions)
    };
}
const $f9a7e940d2f4f7fe$var$i18n = (0, $cgtv4.defineMessages)({
    loadingErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.failed-to-load-title",
        defaultMessage: "Access info failed to load"
    },
    loadingErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.failed-to-load-body",
        defaultMessage: "We couldn\u2019t load some data so the access information may not be accurate. Try refreshing now."
    },
    notificationErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.notification-error-title",
        defaultMessage: "Notification failed to send"
    },
    notificationErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.notification-error-body",
        defaultMessage: "We ran into a problem notifying the people you shared with. Try copying the link."
    },
    listTooLargeNotificationErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.list-too-large-notification-error-title",
        defaultMessage: "Too many recipients"
    },
    listTooLargeNotificationErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.list-too-large-notification-error-body",
        defaultMessage: "You\u2019re sharing with one or more distribution lists that contain too many people to share with at one time."
    },
    mutationErrorTitle: {
        id: "share-and-restrict-dialog.general-access.flags.title.mutation-error-title",
        defaultMessage: "Access change failed"
    },
    mutationErrorBody: {
        id: "share-and-restrict-dialog.general-access.flags.title.mutation-error-body",
        defaultMessage: "We ran into a problem completing your action. Wait a while and try again."
    },
    notificationTitle: {
        id: "share-and-restrict-dialog.flags.title.notification-sent",
        defaultMessage: "Notification sent"
    },
    alreadyHasAccessTitle: {
        id: "share-and-restrict-dialog.flags.title.already-has-access",
        defaultMessage: "The people added already have access"
    },
    contentSharedTitle: {
        id: "share-and-restrict-dialog.flags.title.content-shared",
        defaultMessage: "Content shared"
    },
    draftSharedTitle: {
        id: "share-and-restrict-dialog.flags.title.draft-shared",
        defaultMessage: "Draft shared"
    },
    accessUpdatedTitle: {
        id: "share-and-restrict-dialog.flags.title.access-updated",
        defaultMessage: "Access updated"
    }
});
const $f9a7e940d2f4f7fe$var$flagMap = {
    'loading-error': [
        $f9a7e940d2f4f7fe$var$i18n.loadingErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.loadingErrorBody
    ],
    'notification-error': [
        $f9a7e940d2f4f7fe$var$i18n.notificationErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.notificationErrorBody
    ],
    'list-too-large-error': [
        $f9a7e940d2f4f7fe$var$i18n.listTooLargeNotificationErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.listTooLargeNotificationErrorBody
    ],
    'mutation-error': [
        $f9a7e940d2f4f7fe$var$i18n.mutationErrorTitle,
        $f9a7e940d2f4f7fe$var$i18n.mutationErrorBody
    ]
};
const $f9a7e940d2f4f7fe$var$successFlagMap = {
    'notification-sent': $f9a7e940d2f4f7fe$var$i18n.notificationTitle,
    'content-shared': $f9a7e940d2f4f7fe$var$i18n.contentSharedTitle,
    'draft-shared': $f9a7e940d2f4f7fe$var$i18n.draftSharedTitle,
    'access-updated': $f9a7e940d2f4f7fe$var$i18n.accessUpdatedTitle,
    'has-access-already': $f9a7e940d2f4f7fe$var$i18n.alreadyHasAccessTitle
};
const $f9a7e940d2f4f7fe$export$5ce7431ecd72def8 = (controllerProps)=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { AutoDismissFlag: AutoDismissFlag } = (0, $lsxnT.useChoreographerAssets)();
    const { flags: flags } = controllerProps;
    const { showErrorFlag: showErrorFlag, showFlag: showFlag } = flags;
    const { contentId: contentId, pushPublishModalRestrictions: pushPublishModalRestrictions, refetchButtonData: refetchButtonData, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, hasViewRestrictions: hasViewRestrictions } = controllerProps;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { shareToPrincipals: shareToPrincipals } = (0, $T5KYq.useShareToPrincipals)(contentId);
    const [updateRestrictions] = (0, $1KmJq.useMutation)($f9a7e940d2f4f7fe$var$ControllerDirectRestrictionsMutation);
    const { shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature } = (0, $jZABW.usePublicLinkDisable)({
        source: 'shareAndRestrictDialog'
    });
    const teardownController = (0, $5bmjx.useTeardownController)(()=>{
        controllerProps.onClose();
        controllerProps.onCloseComplete?.();
    });
    const { showSpotlight: isHeaderSpotlightActive } = (0, $3Ipyu.useShouldShowSpotlight)();
    const publicLinkButtonRef = (0, $42omo.useRef)(null);
    const shareToSlackButtonRef = (0, $42omo.useRef)(null);
    /**
   * The functions that the Controller component can provide to the hook.
   * Mutations, flags, fetch requests...
   */ const controllerExtras = {
        errorFlag: (reason)=>{
            const [title, description] = $f9a7e940d2f4f7fe$var$flagMap[reason];
            showErrorFlag({
                title: formatMessage(title),
                description: formatMessage(description)
            });
        },
        successFlag: (reason)=>{
            const title = $f9a7e940d2f4f7fe$var$successFlagMap[reason];
            showFlag({
                type: 'success-circle',
                title: formatMessage(title),
                customComponent: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AutoDismissFlag, {
                        ...props,
                        messageId: `share-and-restrict-dialog-success-flag-${reason}`,
                        messageType: "transactional"
                    })
            });
        },
        showFlag: showFlag,
        showErrorFlag: showErrorFlag,
        sendNotification: async (stagedNotificationRecipients, optionalMessage)=>{
            const notificationRecipients = (0, $cBa8E.getNotificationRecipients)({
                stagedNotificationRecipients: stagedNotificationRecipients
            });
            await shareToPrincipals({
                notificationRecipients: notificationRecipients,
                message: optionalMessage
            });
        },
        callResolveMismatchedRestrictions: async ()=>{
            await updateRestrictions({
                variables: {
                    pageId: contentId,
                    restrictions: {
                        read: {
                            group: [],
                            user: []
                        },
                        update: {
                            group: [],
                            user: []
                        }
                    }
                }
            });
            refetchButtonData();
        },
        mutateContentRestrictions: async (stagedGeneralAccessLevel, principalsMap, currentUser, includeInvites)=>{
            if (stagedGeneralAccessLevel != 'open-can-edit') {
                const currentUserInMap = principalsMap.get(currentUser.id);
                if (!currentUserInMap || currentUserInMap.role == 'can-view') principalsMap.set(currentUser.id, {
                    role: 'can-edit',
                    principal: currentUser,
                    isNewOrUpdatedPrincipal: false
                });
            }
            const restrictions = (0, $4Ewfm.getRestrictionsForMutation)({
                stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                principals: principalsMap
            });
            await updateRestrictions({
                variables: {
                    pageId: contentId,
                    restrictions: {
                        ...restrictions,
                        includeInvites: includeInvites
                    }
                }
            });
            refetchButtonData();
        },
        exportPublishModalRestrictions: (stagedGeneralAccessLevel, principalsMap)=>{
            const restrictions = (0, $4Ewfm.getRestrictionsForPublishModal)({
                stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                principals: principalsMap
            });
            pushPublishModalRestrictions(restrictions);
        },
        teardownController: teardownController,
        fireAnalyticEvent: ({ eventType: eventType, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: source = $f9a7e940d2f4f7fe$export$219d516b185caa05 })=>{
            createAnalyticsEvent({
                type: eventType,
                data: {
                    source: source,
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            }).fire();
        },
        experienceTracker: experienceTracker,
        shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature,
        formatMessage: formatMessage,
        isHeaderSpotlightActive: isHeaderSpotlightActive,
        publicLinkButtonRef: publicLinkButtonRef,
        shareToSlackButtonRef: shareToSlackButtonRef,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        cloudId: cloudId
    };
    const { dialogsProps: dialogsProps } = $f9a7e940d2f4f7fe$var$useController(controllerProps, controllerExtras);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uhfT.Dialogs), dialogsProps);
};
const $f9a7e940d2f4f7fe$export$bd0bf19f25da8474 = (0, $7aRa9.withFlags)($f9a7e940d2f4f7fe$export$5ce7431ecd72def8);
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $f9a7e940d2f4f7fe$export$219d516b185caa05;
module.exports["SAC_CONTENT_ADD_REMOVE_DOCUMENTATION"] = $f9a7e940d2f4f7fe$export$b1e4cd5fa4074c7a;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $f9a7e940d2f4f7fe$export$ce504fce6cf8855f;
module.exports["ControllerComponent"] = $f9a7e940d2f4f7fe$export$5ce7431ecd72def8;
module.exports["Controller"] = $f9a7e940d2f4f7fe$export$bd0bf19f25da8474;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cryCi = parcelRequire("cryCi");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("jZABW", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $917iu = parcelRequire("917iu");


var $inPa6 = parcelRequire("inPa6");


var $1o4fX = parcelRequire("1o4fX");


var $9wGTI = parcelRequire("9wGTI");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");

/**
 * @deprecated to be removed, new implementations should use @atlassian/upgrades-and-purchases
 */ const $0a46a414a356c71f$var$getTrialDaysLeftFromQuery = (queryData)=>{
    const trialEndDate = queryData?.license?.trialEndDate;
    return $0a46a414a356c71f$var$getTrialDaysLeft(trialEndDate);
};
/**
 * @deprecated to be removed, new implementations should use @atlassian/upgrades-and-purchases
 */ const $0a46a414a356c71f$var$getTrialDaysLeft = (trialEndDate)=>{
    if (!trialEndDate) return 0;
    // +1 day to round up for fractional days
    return (0, $917iu.default)(new Date(trialEndDate), new Date()) + 1;
};
const $0a46a414a356c71f$export$872324061aad626b = 'confluence_disable_public_links_on_trial';
const $0a46a414a356c71f$export$9911252fec048faa = ({ source: source })=>{
    const { isLoggedIn: isLoggedIn, userId: userId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    const skipTrialDetailsQuery = isFreeEdition || !isLoggedIn || !userId;
    const { data: trialDetailsData, error: trialDetailsError, loading: trialDetailsLoading } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query usePublicLinkDisableTrialDetailsQuery{license{trialEndDate}}`, {
        skip: skipTrialDetailsQuery
    });
    const daysLeft = (0, $9wGTI.fg)('tako-4040_connie_trial_days_left_standardisation') ? !trialDetailsError && !trialDetailsLoading ? (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialDetailsData?.license?.trialEndDate) ?? 0 : 0 : !trialDetailsError && !trialDetailsLoading ? $0a46a414a356c71f$var$getTrialDaysLeftFromQuery(trialDetailsData) : 0;
    const isTrialEdition = daysLeft > 0;
    const shouldRenderDisablePublicLinkFeature = (isTrialEdition || isFreeEdition) && (0, $9wGTI.fg)('confluence_disable_public_links_on_trial');
    (0, $42omo.useEffect)(()=>{
        if (source && (isFreeEdition || isTrialEdition)) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'feature',
                action: 'exposed',
                source: source,
                attributes: {
                    flagKey: $0a46a414a356c71f$export$872324061aad626b,
                    flagValue: (0, $9wGTI.fg)('confluence_disable_public_links_on_trial'),
                    touchpointId: source,
                    edition: edition
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        edition,
        isFreeEdition,
        isTrialEdition,
        shouldRenderDisablePublicLinkFeature,
        source
    ]);
    return {
        shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature
    };
};
module.exports["usePublicLinkDisable"] = $0a46a414a356c71f$export$9911252fec048faa;

});

parcelRegister("1o4fX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hqNcO = parcelRequire("hqNcO");

function $560b1fdf6e9d95bc$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $hqNcO.MILLISECONDS_IN_A_DAY));
}
function $560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $560b1fdf6e9d95bc$export$954628993bf3188e(trialEndTime - Date.now());
}
function $560b1fdf6e9d95bc$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $560b1fdf6e9d95bc$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $560b1fdf6e9d95bc$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $42omo.useMemo)(()=>$560b1fdf6e9d95bc$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $560b1fdf6e9d95bc$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $560b1fdf6e9d95bc$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $560b1fdf6e9d95bc$export$ee6c4faab08346c;

});

parcelRegister("hqNcO", function(module, exports) {
const $f5358d62f394b358$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $f5358d62f394b358$export$98a7370239de6730;

});

parcelRegister("6uhfT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $gdv5Z = parcelRequire("gdv5Z");


var $erzVD = parcelRequire("erzVD");


var $bCanw = parcelRequire("bCanw");





var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");


var $6cnUO = parcelRequire("6cnUO");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $lsxnT = parcelRequire("lsxnT");


var $4adOe = parcelRequire("4adOe");










const $e2b95a895ee37acd$export$50430938a2360bc5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const recommendedUsersCountRef = (0, $42omo.useRef)(0);
    const addRecommendedUserCount = (0, $42omo.useCallback)(()=>{
        recommendedUsersCountRef.current += 1;
    }, []);
    const sendRecommendedUsersCount = (0, $42omo.useCallback)(()=>{
        const currentCount = recommendedUsersCountRef.current;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'shareRecommendedUsers',
                action: 'usedRecommendedUsers',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    recommendedUsersCount: currentCount
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        addRecommendedUserCount: addRecommendedUserCount,
        sendRecommendedUsersCount: sendRecommendedUsersCount
    };
};









var $eyWa4 = parcelRequire("eyWa4");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $dzImV = parcelRequire("dzImV");

var $bcPlG = parcelRequire("bcPlG");


var $1vRwc = parcelRequire("1vRwc");


var $lisqg = parcelRequire("lisqg");


var $2ZJmt = parcelRequire("2ZJmt");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $6mKj3 = parcelRequire("6mKj3");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $7gpC4 = parcelRequire("7gpC4");




var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");




var $ccHMk = parcelRequire("ccHMk");





var $ep3mz = parcelRequire("ep3mz");


var $bflGB = parcelRequire("bflGB");
















var $9EtP6 = parcelRequire("9EtP6");





var $gQhRa = parcelRequire("gQhRa");




const $ed61e8535624d34f$var$i18n = (0, $cgtv4.defineMessages)({
    optionalMessage: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.optional-message",
        defaultMessage: "Optional message"
    },
    placeholderMessage: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.placeholder.non-final",
        defaultMessage: "Add text, or use /for elements"
    },
    charLimitErrorMessage: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.char-limit-error-message",
        defaultMessage: "Message must be less than 500 characters"
    }
});
const $ed61e8535624d34f$export$5a55f841287167a3 = ({ isLockedOut: isLockedOut, notifyMessage: notifyMessage, rows: rows, isCheckboxUnchecked: isCheckboxUnchecked, onNotifyMessageChange: onNotifyMessageChange })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const characterLimiter = (value)=>{
        const characterLimit = 500;
        if (value && value.length > characterLimit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, formatMessage($ed61e8535624d34f$var$i18n.charLimitErrorMessage));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, value ? value.length : 0, "/", characterLimit);
    };
    // TODO: Message composer optimization: https://product-fabric.atlassian.net/browse/USD-181
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        isDisabled: isLockedOut || isCheckboxUnchecked && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment'),
        placeholder: formatMessage((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? $ed61e8535624d34f$var$i18n.placeholderMessage : $ed61e8535624d34f$var$i18n.optionalMessage),
        value: notifyMessage,
        onChange: (e)=>onNotifyMessageChange(e.target.value),
        minimumRows: rows,
        maxHeight: (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? '120px' : '80px',
        "aria-label": formatMessage($ed61e8535624d34f$var$i18n.optionalMessage)
    }), characterLimiter(notifyMessage));
};


const $06f4c3e4444a6796$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    notifyNewlyAddedUsersLabel: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.notify-newly-added-user-label",
        defaultMessage: "Notify newly added people"
    },
    notifyRecipientsLabel: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.notify-recipients-label",
        defaultMessage: "Notify recipients"
    },
    //TODO: clean up this label is no longer needed
    notifySelectedUsersLabel: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.notify-selected-users-label",
        defaultMessage: "Notify selected users"
    },
    addMessage: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.add-message",
        defaultMessage: "Add message"
    },
    cancelButton: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.cancel-cta",
        defaultMessage: "Cancel"
    },
    shareButton: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.share-cta",
        defaultMessage: "Share"
    },
    saveButton: {
        id: "share-and-restrict-dialog.cta-notify-message-footer.save-cta",
        defaultMessage: "Save"
    }
});
const $06f4c3e4444a6796$var$containerBaseStyling = (0, $ecnYn.xcss)({
    padding: 'space.300'
});
const $06f4c3e4444a6796$var$withButtonsAdjustments = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    maxHeight: '72px'
});
const $06f4c3e4444a6796$var$withButtonsCheckboxAdjustments = (0, $ecnYn.xcss)({
    paddingTop: 'space.200',
    maxHeight: '72px'
});
const $06f4c3e4444a6796$var$withButtonsCheckboxComposerAdjustments = (0, $ecnYn.xcss)({
    paddingTop: 'space.075'
});
const $06f4c3e4444a6796$var$withPSAButtonsCheckboxComposerAdjustments = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $06f4c3e4444a6796$var$withButtonsSpecificAccessDetails = (0, $ecnYn.xcss)({
    paddingTop: 'space.300',
    maxHeight: '80px'
});
const $06f4c3e4444a6796$var$withButtonsCheckboxAndSpecificAccessDetails = (0, $ecnYn.xcss)({
    paddingTop: 'space.300',
    minHeight: '80px'
});
const $06f4c3e4444a6796$var$withButtonsCheckboxComposerAndSpecificAccessDetails = (0, $ecnYn.xcss)({
    marginTop: 'space.025',
    paddingTop: 'space.150'
});
const $06f4c3e4444a6796$var$addMessageButtonStyling = (0, $ecnYn.xcss)({
    width: 'fit-content',
    height: '20px',
    border: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    marginLeft: 'space.300',
    padding: '0',
    paddingInlineStart: 'space.050',
    position: 'relative',
    top: 'space.negative.050',
    flexShrink: 0
});
const $06f4c3e4444a6796$var$iconContainer = (0, $ecnYn.xcss)({
    paddingInlineStart: 'space.025'
});
const $06f4c3e4444a6796$var$ctaButtonContainerStylingWithMessageComposer = (0, $ecnYn.xcss)({
    alignSelf: 'flex-end'
});
const $06f4c3e4444a6796$var$spotLightContainer = (0, $ecnYn.xcss)({
    padding: 'space.075',
    position: 'relative',
    top: 'space.025',
    left: 'space.negative.075',
    boxSizing: 'content-box',
    height: '40px'
});
const $06f4c3e4444a6796$var$psaSpotLightContainer = (0, $ecnYn.xcss)({
    height: 'auto'
});
const $06f4c3e4444a6796$var$NotifyCheckboxComponent = ({ isLockedOut: isLockedOut, notifyCheckbox: notifyCheckbox, checkboxLabel: checkboxLabel, showMessageComposer: showMessageComposer, onNotifyCheckboxClick: onNotifyCheckboxClick, onNotifyAddMessageClick: onNotifyAddMessageClick, isSharingToEmailsDisabled: isSharingToEmailsDisabled })=>{
    const isChecked = notifyCheckbox === 'checked';
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shouldExpandIcon = isChecked && showMessageComposer;
    const getCheckboxLabel = (label)=>{
        switch(label){
            case 'newly-added':
                return $06f4c3e4444a6796$export$a7357cdd1f0b0168.notifyNewlyAddedUsersLabel;
            case 'recipients':
                return $06f4c3e4444a6796$export$a7357cdd1f0b0168.notifyRecipientsLabel;
            case 'selected-users':
            default:
                return $06f4c3e4444a6796$export$a7357cdd1f0b0168.notifySelectedUsersLabel;
        }
    };
    const getChevronIcon = ()=>{
        if (shouldExpandIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        if (!shouldExpandIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignBlock: "center",
        xcss: [
            $06f4c3e4444a6796$var$spotLightContainer,
            (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && $06f4c3e4444a6796$var$psaSpotLightContainer
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        isDisabled: isLockedOut || isSharingToEmailsDisabled,
        isChecked: isChecked,
        label: formatMessage(getCheckboxLabel(checkboxLabel)),
        onChange: ()=>onNotifyCheckboxClick(isChecked)
    }), !(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $06f4c3e4444a6796$var$addMessageButtonStyling,
        onClick: onNotifyAddMessageClick,
        isDisabled: !isChecked || isSharingToEmailsDisabled,
        "aria-expanded": shouldExpandIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        as: "span",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: isChecked && !isSharingToEmailsDisabled ? 'color.text.subtlest' : 'color.text.disabled'
    }, formatMessage($06f4c3e4444a6796$export$a7357cdd1f0b0168.addMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f4c3e4444a6796$var$iconContainer
    }, getChevronIcon()))));
};
const $06f4c3e4444a6796$export$c26ce0b7496e870c = ({ natureOfCta: natureOfCta, notifyCheckbox: notifyCheckbox, checkboxLabel: checkboxLabel, isLockedOut: isLockedOut, isCtaInProgress: isCtaInProgress, messageComposer: messageComposer, sharingType: sharingType, onCtaClick: onCtaClick, onCancelClick: onCancelClick, onNotifyCheckboxClick: onNotifyCheckboxClick, onNotifyAddMessageClick: onNotifyAddMessageClick, isSpecificAccessDetailsVisible: isSpecificAccessDetailsVisible, isLimitExceeded: isLimitExceeded, pageMode: //Specifically for GasV3 events
pageMode, isDraft: isDraft, isLivePage: isLivePage, isSharingToEmailsDisabled: isSharingToEmailsDisabled, contentId: contentId, hasGroups: hasGroups, hasTeams: hasTeams, hasUsers: hasUsers, includeInvites: includeInvites, generalAccessLevel: generalAccessLevel, principalsCount: principalsCount })=>{
    const showNotifyCheckbox = notifyCheckbox !== 'hidden';
    const showMessageComposer = messageComposer !== undefined;
    const charLimitExceeded = showMessageComposer && messageComposer.notifyMessage.length > 500;
    const ctaOptions = {
        share: $06f4c3e4444a6796$export$a7357cdd1f0b0168.shareButton,
        save: $06f4c3e4444a6796$export$a7357cdd1f0b0168.saveButton
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const fireSubmitShareAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                actionSubjectId: 'submitShare',
                action: 'clicked',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    buttonLabel: natureOfCta,
                    isNotifyCheckboxShown: showNotifyCheckbox,
                    isNotify: notifyCheckbox,
                    isMessagePresent: Boolean(messageComposer?.notifyMessage),
                    contentType: contentType,
                    contentId: contentId,
                    pageMode: pageMode,
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    hasGroups: hasGroups,
                    hasTeams: hasTeams,
                    hasUsers: hasUsers,
                    includeInvites: includeInvites,
                    generalAccessLevel: generalAccessLevel,
                    principalsCount: principalsCount
                }
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shared',
                actionSubject: 'page',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    buttonLabel: natureOfCta,
                    isNotifyCheckboxShown: showNotifyCheckbox,
                    isNotify: notifyCheckbox,
                    isMessagePresent: Boolean(messageComposer?.notifyMessage),
                    includeInvites: includeInvites
                }
            }
        }).fire();
    }, [
        contentType,
        contentId,
        createAnalyticsEvent,
        natureOfCta,
        notifyCheckbox,
        showNotifyCheckbox,
        messageComposer,
        pageMode,
        isDraft,
        isLivePage,
        hasGroups,
        hasTeams,
        hasUsers,
        includeInvites,
        generalAccessLevel,
        principalsCount
    ]);
    const fireApplyRestrictionsAnalytics = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'applyRestrictions',
                action: 'applied',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    buttonLabel: natureOfCta,
                    isNotifyCheckboxShown: showNotifyCheckbox,
                    isNotify: notifyCheckbox,
                    isMessagePresent: Boolean(messageComposer?.notifyMessage),
                    contentType: contentType,
                    pageMode: pageMode,
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    contentId: contentId,
                    hasGroups: hasGroups,
                    hasTeams: hasTeams,
                    hasUsers: hasUsers,
                    includeInvites: includeInvites,
                    generalAccessLevel: generalAccessLevel,
                    principalsCount: principalsCount
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        natureOfCta,
        notifyCheckbox,
        showNotifyCheckbox,
        messageComposer,
        contentType,
        pageMode,
        isDraft,
        isLivePage,
        contentId,
        hasGroups,
        hasTeams,
        hasUsers,
        includeInvites,
        generalAccessLevel,
        principalsCount
    ]);
    const handleCtaClick = (0, $42omo.useCallback)(()=>{
        if (sharingType === 'sharing-and-applying-restrictions') {
            fireSubmitShareAnalytics();
            fireApplyRestrictionsAnalytics();
        }
        if (sharingType === 'sharing') fireSubmitShareAnalytics();
        if (sharingType === 'applying-restrictions') fireApplyRestrictionsAnalytics();
        onCtaClick();
    }, [
        sharingType,
        onCtaClick,
        fireApplyRestrictionsAnalytics,
        fireSubmitShareAnalytics
    ]);
    const handleCancelClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                actionSubjectId: 'CancelButton',
                action: 'clicked',
                attributes: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
                }
            }
        }).fire();
        onCancelClick();
    }, [
        createAnalyticsEvent,
        onCancelClick
    ]);
    const buttonsOnlyVisible = !showNotifyCheckbox;
    const buttonsCheckboxVisible = showNotifyCheckbox && !showMessageComposer;
    const buttonsCheckboxComposerVisible = showNotifyCheckbox && showMessageComposer;
    const buttonsSpecificAccessDetailsVisible = buttonsOnlyVisible && isSpecificAccessDetailsVisible;
    const buttonsCheckboxSpecificAccessDetailsVisible = buttonsCheckboxVisible && isSpecificAccessDetailsVisible;
    const buttonsCheckboxComposerSpecifiAccessDetailsVisible = buttonsCheckboxComposerVisible && isSpecificAccessDetailsVisible;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, natureOfCta !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: showMessageComposer ? 'column' : 'row',
        gap: showMessageComposer ? 'space.200' : 'space.100',
        alignItems: "center",
        justifyContent: showNotifyCheckbox ? 'space-between' : 'end',
        xcss: [
            $06f4c3e4444a6796$var$containerBaseStyling,
            buttonsOnlyVisible && $06f4c3e4444a6796$var$withButtonsAdjustments,
            buttonsCheckboxVisible && $06f4c3e4444a6796$var$withButtonsCheckboxAdjustments,
            buttonsCheckboxComposerVisible && $06f4c3e4444a6796$var$withButtonsCheckboxComposerAdjustments,
            buttonsSpecificAccessDetailsVisible && $06f4c3e4444a6796$var$withButtonsSpecificAccessDetails,
            buttonsCheckboxSpecificAccessDetailsVisible && $06f4c3e4444a6796$var$withButtonsCheckboxAndSpecificAccessDetails,
            buttonsCheckboxComposerSpecifiAccessDetailsVisible && $06f4c3e4444a6796$var$withButtonsCheckboxComposerAndSpecificAccessDetails,
            // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && buttonsCheckboxComposerVisible && $06f4c3e4444a6796$var$withPSAButtonsCheckboxComposerAdjustments
        ]
    }, showNotifyCheckbox && showMessageComposer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($06f4c3e4444a6796$var$NotifyCheckboxComponent, {
        isLockedOut: isLockedOut,
        notifyCheckbox: notifyCheckbox,
        checkboxLabel: checkboxLabel,
        onNotifyCheckboxClick: onNotifyCheckboxClick,
        onNotifyAddMessageClick: onNotifyAddMessageClick,
        showMessageComposer: showMessageComposer,
        isSharingToEmailsDisabled: isSharingToEmailsDisabled
    }), messageComposer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed61e8535624d34f$export$5a55f841287167a3), messageComposer)), !showMessageComposer && showNotifyCheckbox && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($06f4c3e4444a6796$var$NotifyCheckboxComponent, {
        isLockedOut: isLockedOut,
        notifyCheckbox: notifyCheckbox,
        checkboxLabel: checkboxLabel,
        onNotifyCheckboxClick: onNotifyCheckboxClick,
        onNotifyAddMessageClick: onNotifyAddMessageClick,
        showMessageComposer: showMessageComposer,
        isSharingToEmailsDisabled: isSharingToEmailsDisabled
    }), !(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: [
            showMessageComposer && $06f4c3e4444a6796$var$ctaButtonContainerStylingWithMessageComposer
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: handleCancelClick,
        isDisabled: isLockedOut
    }, formatMessage($06f4c3e4444a6796$export$a7357cdd1f0b0168.cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleCtaClick,
        isLoading: isCtaInProgress,
        isDisabled: !isCtaInProgress && isLockedOut || charLimitExceeded || isLimitExceeded || isSharingToEmailsDisabled
    }, formatMessage(ctaOptions[natureOfCta]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: [
            'command+enter',
            'ctrl+enter'
        ],
        listener: handleCtaClick,
        allowInDialog: true
    })));
};




















var $7hXDW = parcelRequire("7hXDW");


var $5izcQ = parcelRequire("5izcQ");


var $8tSmd = parcelRequire("8tSmd");


var $3gadb = parcelRequire("3gadb");


var $92V6K = parcelRequire("92V6K");







var $gtD4K = parcelRequire("gtD4K");




var $2gD2K = parcelRequire("2gD2K");















const $472a91e7c0acde39$var$i18n = (0, $cgtv4.defineMessages)({
    canViewOptionLabel: {
        id: "share-and-restrict-dialog.general-access.permission.can-view",
        defaultMessage: "Can view"
    },
    canEditOptionLabel: {
        id: "share-and-restrict-dialog.general-access.permission.can-edit",
        defaultMessage: "Can edit"
    }
});
const $472a91e7c0acde39$var$uneditableGeneralAccessStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    whiteSpace: 'nowrap'
});
const $472a91e7c0acde39$export$380c25a59f1401d = ({ isLockedOut: isLockedOut, generalAccessLevel: generalAccessLevel, onCanViewCanEditChange: onCanViewCanEditChange, isEditable: isEditable, hasInheritedRestrictions: hasInheritedRestrictions, isDraft: isDraft, isLivePage: isLivePage, contentType: contentType, isSaving: isSaving })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const options = [
        {
            label: formatMessage($472a91e7c0acde39$var$i18n.canViewOptionLabel),
            value: 'view'
        },
        {
            label: formatMessage($472a91e7c0acde39$var$i18n.canEditOptionLabel),
            value: 'edit'
        }
    ];
    const handleSelectChange = (selectedOption)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'selected',
                actionSubject: 'option',
                actionSubjectId: 'GeneralAccessPermissionDropdown',
                attributes: {
                    selectedOption: selectedOption?.value,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    contentType: contentType
                }
            }
        }).fire();
        onCanViewCanEditChange(selectedOption?.value === 'edit');
    };
    const value = options[generalAccessLevel === 'open-can-view' ? 0 : 1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLockedOut || isSaving && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment'),
        isSearchable: false,
        options: options,
        value: value,
        onChange: handleSelectChange,
        label: value?.label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $472a91e7c0acde39$var$uneditableGeneralAccessStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), generalAccessLevel === 'open-can-view' ? $472a91e7c0acde39$var$i18n.canViewOptionLabel : $472a91e7c0acde39$var$i18n.canEditOptionLabel)));
};


const $757afac272ae6225$var$i18n = (0, $cgtv4.defineMessages)({
    generalAccessTitle: {
        id: "share-and-restrict-dialog.general-access.title",
        defaultMessage: "General access"
    },
    generalAccessInfoIconLabelText: {
        id: "share-and-restrict-dialog.general-access.info-icon.label-text",
        defaultMessage: "Additional information"
    },
    generalAccessInfoIconMessage: {
        id: "share-and-restrict-dialog.general-access.info-icon.message",
        defaultMessage: "You don't have permission to change access to this content."
    }
});
const $757afac272ae6225$var$generalAccessSectionContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $757afac272ae6225$var$bottomPadding = (0, $ecnYn.xcss)({
    paddingBlockEnd: 'space.100'
});
const $757afac272ae6225$var$levelSelectorSpotLightContainer = (0, $ecnYn.xcss)({
    padding: 'space.075',
    marginInlineStart: 'space.negative.075'
});
const $757afac272ae6225$var$dropdownSpotLightContainer = (0, $ecnYn.xcss)({
    padding: 'space.075',
    marginInlineEnd: 'space.negative.075'
});
const $757afac272ae6225$var$headingStyles = (0, $ecnYn.xcss)({
    maxHeight: '16px'
});
const $757afac272ae6225$export$7e5386ee40f452c8 = ({ generalAccessLevelSelectorProps: generalAccessLevelSelectorProps, generalAccessPermissionDropdownProps: generalAccessPermissionDropdownProps, shouldShowUneditableRestrictionsInfoIcon: shouldShowUneditableRestrictionsInfoIcon, showBottomPadding: showBottomPadding })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        grow: "hug",
        xcss: $757afac272ae6225$var$headingStyles
    }, formatMessage($757afac272ae6225$var$i18n.generalAccessTitle), shouldShowUneditableRestrictionsInfoIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($757afac272ae6225$var$i18n.generalAccessInfoIconMessage),
        position: "right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
        label: formatMessage($757afac272ae6225$var$i18n.generalAccessInfoIconLabelText),
        size: "small"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill",
        spread: "space-between",
        xcss: [
            $757afac272ae6225$var$generalAccessSectionContainer,
            showBottomPadding && $757afac272ae6225$var$bottomPadding
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "generalAccess"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $757afac272ae6225$var$levelSelectorSpotLightContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $92V6K.GeneralAccessLevelSelector), generalAccessLevelSelectorProps))), generalAccessPermissionDropdownProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "permissionDropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $757afac272ae6225$var$dropdownSpotLightContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $472a91e7c0acde39$export$380c25a59f1401d), generalAccessPermissionDropdownProps)))));
};











var $a3fRD = parcelRequire("a3fRD");














var $6O3OC = parcelRequire("6O3OC");











var $3KVX0 = parcelRequire("3KVX0");


var $1LFpx = parcelRequire("1LFpx");


var $7oH3p = parcelRequire("7oH3p");


var $ktS3V = parcelRequire("ktS3V");

const $dbb420cf03103f76$export$e45b57f6c6c40475 = 10;
const $dbb420cf03103f76$export$cb04881201f27da = 'infi-slack-workspace-';
const $dbb420cf03103f76$export$fa39fb16b65ab54f = 'platform';
const $dbb420cf03103f76$export$88ece45bb5b3dbd0 = 'slack';
const $dbb420cf03103f76$export$2d4bcc939d0de9de = (0, $7oH3p.Integration).GOOGLE_SERVICE;
const $dbb420cf03103f76$export$baca96d2908c1d98 = (0, $7oH3p.Integration).MICROSOFT_SERVICE;
const $dbb420cf03103f76$export$ec85cabf318c7730 = (0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE;
const $dbb420cf03103f76$export$f22967b337b5cd11 = (key)=>{
    try {
        return localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};
const $dbb420cf03103f76$export$85295e886b0bc188 = ()=>$dbb420cf03103f76$export$f22967b337b5cd11(`${$dbb420cf03103f76$export$cb04881201f27da}${$dbb420cf03103f76$export$fa39fb16b65ab54f}`);
const $dbb420cf03103f76$export$3f8994ca807e67a6 = async (cloudId)=>{
    if (!cloudId) return {};
    const integrationsResponse = await (0, $ktS3V.fetchExistingIntegrations)(cloudId);
    if (!integrationsResponse) return {};
    return integrationsResponse;
};
const $dbb420cf03103f76$export$459d5a134a493201 = (items)=>{
    return new (0, $3KVX0.default)(items, {
        keys: [
            'displayName',
            'name',
            'email',
            'publicName'
        ],
        threshold: 0.2
    });
};
const $dbb420cf03103f76$export$8727cf0de46a38c5 = (obj)=>{
    Object.keys(obj).filter((k)=>!obj[k]).forEach((k)=>delete obj[k]);
    return obj;
};
const $dbb420cf03103f76$export$6b9f91f1f35a2e37 = (userLists)=>{
    const usersById = userLists.reduce((flatUsersList, users)=>{
        flatUsersList.push(...users);
        return flatUsersList;
    }, []).reduce((result, currentValue)=>{
        const key = currentValue.email || currentValue.id;
        if (!result[key]) result[key] = [];
        result[key].push(currentValue);
        return result;
    }, {});
    return Object.keys(usersById).map((userId)=>{
        return usersById[userId].reduce((result, currentValue)=>{
            const sources = [
                ...new Set([
                    ...result.sources,
                    ...currentValue.sources
                ])
            ];
            const mergedUser = {
                ...$dbb420cf03103f76$export$8727cf0de46a38c5(result),
                ...$dbb420cf03103f76$export$8727cf0de46a38c5(currentValue)
            };
            mergedUser.sources = sources;
            return mergedUser;
        });
    });
};
const $dbb420cf03103f76$export$db16b8d6f03d2f57 = (slackUser)=>({
        id: slackUser.id,
        email: slackUser.email,
        name: slackUser.name,
        publicName: slackUser.displayName,
        avatarUrl: slackUser.avatarUrl,
        sources: [
            $dbb420cf03103f76$export$88ece45bb5b3dbd0
        ],
        type: 'external_user',
        isExternal: true
    });
const $dbb420cf03103f76$export$8faa309b65e883b8 = async (cloudId, createAnalyticsEvent, existingIntegrations)=>{
    if (!cloudId) return {
        slackService: undefined,
        workspaces: [],
        selectedWorkspace: null
    };
    const productSlackService = (0, $1LFpx.slackServiceFactory)(cloudId, 'platform', createAnalyticsEvent);
    if (!existingIntegrations) return {
        slackService: productSlackService,
        workspaces: [],
        selectedWorkspace: null
    };
    const workspaces = existingIntegrations?.integrationMetadata?.[(0, $7oH3p.Integration).PLATFORM_SLACK_SERVICE]?.teams?.filter((workspace)=>workspace.scopeState !== (0, $7oH3p.ScopeState).NO_SCOPE) || [];
    const slackWorkspaceId = $dbb420cf03103f76$export$85295e886b0bc188();
    let selectedWorkspace = null;
    if (workspaces.length > 0 && slackWorkspaceId) selectedWorkspace = workspaces.find((slackWorkspace)=>slackWorkspace.id === slackWorkspaceId) || null;
    return {
        slackService: productSlackService,
        workspaces: workspaces,
        selectedWorkspace: selectedWorkspace
    };
};
const $dbb420cf03103f76$export$5f93f621745f04e9 = async (searchText, cloudId, connectedIntegrations, slackUserSearcher)=>{
    if (!cloudId || !searchText || searchText.trim().length === 0 || connectedIntegrations.size === 0) return [];
    const isNonSlackIntegrationConnected = connectedIntegrations.has($dbb420cf03103f76$export$2d4bcc939d0de9de) || connectedIntegrations.has($dbb420cf03103f76$export$baca96d2908c1d98);
    let users = isNonSlackIntegrationConnected ? await (0, $ktS3V.search)(searchText, cloudId).catch(()=>{
        return [];
    }) : [];
    if (slackUserSearcher.current) {
        const slackUsers = slackUserSearcher.current.search(searchText).map((result)=>result.item);
        users = $dbb420cf03103f76$export$6b9f91f1f35a2e37([
            users,
            slackUsers.slice(0, Math.min(slackUsers.length, $dbb420cf03103f76$export$e45b57f6c6c40475))
        ]);
    }
    const fuse = $dbb420cf03103f76$export$459d5a134a493201(users);
    const searchResult = fuse.search(searchText).map((result)=>result.item);
    return searchResult.slice(0, Math.min(searchResult.length, $dbb420cf03103f76$export$e45b57f6c6c40475));
};
const $dbb420cf03103f76$export$2d6defe8c26b5189 = (cloudId, connectedIntegrations, slackUserSearcher)=>{
    return async (query)=>{
        if ((query ?? '').trim().length === 0) return [];
        const thirdPartyContacts = await $dbb420cf03103f76$export$5f93f621745f04e9(query, cloudId, connectedIntegrations, slackUserSearcher);
        return thirdPartyContacts;
    };
};


const $6ef9c8760de63998$export$f6b50533d71620fe = ({ cloudId: cloudId, createAnalyticsEvent: createAnalyticsEvent, canUserInvite: canUserInvite, onError: onError })=>{
    const slackServiceRef = (0, $42omo.useRef)(undefined);
    const selectedSlackWorkspaceRef = (0, $42omo.useRef)(null);
    const slackUserSearcherRef = (0, $42omo.useRef)((0, $dbb420cf03103f76$export$459d5a134a493201)([]));
    const [isInitializing, setIsInitializing] = (0, $42omo.useState)(false);
    const [isInitialized, setIsInitialized] = (0, $42omo.useState)(false);
    const [thirdPartyResolver, setThirdPartyResolver] = (0, $42omo.useState)(()=>(0, $dbb420cf03103f76$export$2d6defe8c26b5189)(cloudId, new Set(), slackUserSearcherRef));
    const setupSlackUserStreaming = (0, $42omo.useCallback)(()=>{
        slackUserSearcherRef.current = (0, $dbb420cf03103f76$export$459d5a134a493201)([]);
        if (selectedSlackWorkspaceRef.current && slackServiceRef.current) slackServiceRef.current.streamUsers(selectedSlackWorkspaceRef.current.id, (slackUsers)=>{
            if (slackUsers?.ok) slackUsers.result.forEach((slackUser)=>{
                const externalUser = (0, $dbb420cf03103f76$export$db16b8d6f03d2f57)(slackUser);
                slackUserSearcherRef.current.add(externalUser);
            });
        });
    }, []);
    const clearIntegrations = (0, $42omo.useCallback)(()=>{
        if (slackServiceRef.current) slackServiceRef.current.abort();
        slackServiceRef.current = undefined;
        selectedSlackWorkspaceRef.current = null;
        slackUserSearcherRef.current = (0, $dbb420cf03103f76$export$459d5a134a493201)([]);
        setThirdPartyResolver(()=>(0, $dbb420cf03103f76$export$2d6defe8c26b5189)(cloudId, new Set(), slackUserSearcherRef));
    }, [
        cloudId
    ]);
    const initSlackIntegration = (0, $42omo.useCallback)(async (existingIntegrations)=>{
        setIsInitialized(false);
        setIsInitializing(true);
        try {
            if (slackServiceRef.current) slackServiceRef.current.abort();
            const result = await (0, $dbb420cf03103f76$export$8faa309b65e883b8)(cloudId, createAnalyticsEvent, existingIntegrations);
            slackServiceRef.current = result.slackService;
            if (result.selectedWorkspace) selectedSlackWorkspaceRef.current = result.selectedWorkspace;
            setupSlackUserStreaming();
            setIsInitialized(true);
        } catch (error) {
            onError?.(error instanceof Error ? error : new Error('Failed to initialize Slack integration'));
        } finally{
            setIsInitializing(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        onError,
        setupSlackUserStreaming
    ]);
    const initThirdPartyIntegrations = (0, $42omo.useCallback)(async ()=>{
        if (!canUserInvite()) return;
        const existingIntegrations = await (0, $dbb420cf03103f76$export$3f8994ca807e67a6)(cloudId);
        const connectedIntegrations = new Set(existingIntegrations.connectedIntegrations);
        if (!connectedIntegrations) return;
        if (connectedIntegrations.has((0, $dbb420cf03103f76$export$ec85cabf318c7730)) && !slackServiceRef.current) initSlackIntegration(existingIntegrations);
        setThirdPartyResolver(()=>(0, $dbb420cf03103f76$export$2d6defe8c26b5189)(cloudId, connectedIntegrations, slackUserSearcherRef));
        setIsInitialized(true);
    }, [
        cloudId,
        initSlackIntegration,
        canUserInvite
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (slackServiceRef.current) slackServiceRef.current.abort();
        };
    }, []);
    return {
        isInitializing: isInitializing,
        isInitialized: isInitialized,
        initThirdPartyIntegrations: initThirdPartyIntegrations,
        clearIntegrations: clearIntegrations,
        thirdPartyResolver: thirdPartyResolver
    };
};



var $9wGTI = parcelRequire("9wGTI");


var $hpRYU = parcelRequire("hpRYU");













/** @graphql experimental **/ 






var $d4Pk4 = parcelRequire("d4Pk4");








var $eZLpN = parcelRequire("eZLpN");


var $aBfpe = parcelRequire("aBfpe");

const $5f8d5e79eca72e46$export$9ce937d1e3a4cc3d = ({ variables: variables, onCompleted: onCompleted, onError: onError })=>{
    return (0, $eZLpN.useExperimentalLazyQuery)({
        url: `/gateway/api/v3/invitations/capabilities?resource=${variables.resourceARI}`,
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (response)=>{
            for (const item of response){
                if (item?.resourceARI?.includes('confluence')) return {
                    experimentalInvitePermissions: {
                        directInviteMode: item?.directInvite?.mode ?? null,
                        directInviteDomains: item?.directInvite?.domains ?? null,
                        invitePendingApprovalMode: item?.invitePendingApproval?.mode ?? null
                    }
                };
            }
            return {
                experimentalInvitePermissions: {
                    directInviteMode: null,
                    directInviteDomains: null,
                    invitePendingApprovalMode: null
                }
            };
        },
        variables: variables,
        onCompleted: onCompleted,
        onError: onError
    });
};


const $92b5ca72620f412e$export$171021d8e67014af = ()=>{
    const { cloudId: siteId } = (0, $bQm3c.useSessionData)();
    const resourceARI = (0, $d4Pk4.PlatformSiteAri).create({
        siteId: siteId
    }).toString();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onFetchCapabilitiesCompleted = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'success',
                actionSubject: 'useInviteCapabilityShareAndRestrictDialogQuery'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onFetchCapabilitiesError = (0, $42omo.useCallback)((queryError)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'error',
                actionSubject: 'useInviteCapabilityShareAndRestrictDialogQuery',
                attributes: {
                    error: queryError.message
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const [loadInviteCapabilities, { data: data, loading: loading, error: error, called: called }] = (0, $5f8d5e79eca72e46$export$9ce937d1e3a4cc3d)({
        variables: {
            resourceARI: resourceARI
        },
        onCompleted: onFetchCapabilitiesCompleted,
        onError: onFetchCapabilitiesError
    });
    const canUserInvite = (0, $42omo.useCallback)(()=>{
        if (!data || loading || error) return false;
        return data.experimentalInvitePermissions?.invitePendingApprovalMode === 'ANYONE';
    }, [
        data,
        loading,
        error
    ]);
    return {
        loadInviteCapabilities: loadInviteCapabilities,
        canUserInvite: canUserInvite,
        called: called
    };
};











var $eXmBZ = parcelRequire("eXmBZ");
















var $ebrpi = parcelRequire("ebrpi");


var $l998X = parcelRequire("l998X");








var $k4HRJ = parcelRequire("k4HRJ");


var $hCOLa = parcelRequire("hCOLa");


var $1BTvF = parcelRequire("1BTvF");


var $fAdjB = parcelRequire("fAdjB");

const $1cd75fa03a01fd9d$export$8dc567da1fd35a38 = 'growth';
const $1cd75fa03a01fd9d$export$419645f48c6eb251 = 'peopleTeams';









var $dh538 = parcelRequire("dh538");
















var $iXCQx = parcelRequire("iXCQx");


var $aoVih = parcelRequire("aoVih");





var $eWRwJ = parcelRequire("eWRwJ");




const $f0c8ab6594537af0$var$createAndFireEventOnGrowth = (0, $eWRwJ.default)((0, $1cd75fa03a01fd9d$export$8dc567da1fd35a38));
const $f0c8ab6594537af0$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        const fire = $f0c8ab6594537af0$var$createAndFireEventOnGrowth(payload);
        fire(createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    return fireAnalyticsEvent;
};





const $9936e42ed9936f79$var$messages = (0, $cgtv4.defineMessages)({
    error: {
        id: "growth.inline-invite.error-panel.error",
        defaultMessage: "We can't invite {count, plural, one {this person} other {these people}} right now. Share this page with them instead."
    },
    partialSuccess: {
        id: "growth.inline-invite.error-panel.partial-success",
        defaultMessage: "Invitation sent to {count, plural, one {<bold>{email}</bold>} =2 {<bold>{email}</bold> and 1 other} other {<bold>{email}</bold> and {others} others}}."
    },
    partialError: {
        id: "growth.inline-invite.error-panel.partial-error",
        defaultMessage: "We couldn't invite <bold>{count, plural, one {1 other} other {# others}}</bold>. Share this page with them instead."
    },
    maxInvites: {
        id: "growth.inline-invite.error-panel.max-invites",
        defaultMessage: "You can invite a maximum of {max} people at one time"
    }
});
var $9936e42ed9936f79$export$2e2bcd8739ae039 = $9936e42ed9936f79$var$messages;


const $12a8948a54415540$var$bold = (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        weight: "bold",
        children: chunks
    });
const $12a8948a54415540$var$WarningText = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.warning",
        children: children
    });
const $12a8948a54415540$export$21009fc133be621c = 10;
const $12a8948a54415540$var$Message = ({ successEmails: successEmails, errorEmails: errorEmails, exceedsMaxInvites: exceedsMaxInvites, endpointFailure: endpointFailure })=>{
    if (exceedsMaxInvites) return /*#__PURE__*/ (0, $l998X.jsx)($12a8948a54415540$var$WarningText, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $9936e42ed9936f79$export$2e2bcd8739ae039).maxInvites,
            values: {
                max: $12a8948a54415540$export$21009fc133be621c
            }
        })
    });
    // Show this message if the endpoint fails or if there are no successful invites
    if (endpointFailure || successEmails.length === 0) return /*#__PURE__*/ (0, $l998X.jsx)($12a8948a54415540$var$WarningText, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $9936e42ed9936f79$export$2e2bcd8739ae039).error,
            values: {
                count: successEmails.length + errorEmails.length
            }
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.100",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($12a8948a54415540$var$WarningText, {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $9936e42ed9936f79$export$2e2bcd8739ae039).partialSuccess,
                    values: {
                        count: successEmails.length,
                        email: successEmails[0],
                        others: successEmails.length - 1,
                        bold: $12a8948a54415540$var$bold
                    }
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($12a8948a54415540$var$WarningText, {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $9936e42ed9936f79$export$2e2bcd8739ae039).partialError,
                    values: {
                        count: errorEmails.length,
                        bold: $12a8948a54415540$var$bold
                    }
                })
            })
        ]
    });
};
const $12a8948a54415540$export$9f3dc18e1adf5d8f = ({ integration: integration, ...props })=>{
    const fireAnalyticsEvent = (0, $f0c8ab6594537af0$export$e955abb82869dc84)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'inlineInviteError',
            attributes: {
                integration: integration
            }
        });
    }, [
        fireAnalyticsEvent,
        integration
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
        appearance: "warning",
        children: /*#__PURE__*/ (0, $l998X.jsx)($12a8948a54415540$var$Message, {
            ...props
        })
    });
};















var $u9agA = parcelRequire("u9agA");









var $a502B = parcelRequire("a502B");


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");



const $afb27c88c7a12472$var$styles = {
    link: "_4bfu1r31 _1hms8stv _ajmmnqa1 _bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz13af _9oik1r31 _1bnxglyw _jf4cnqa1 _9h8h12zz"
};
const $afb27c88c7a12472$export$cfc7921d29ef7b80 = ({ children: children, onClick: onClick, fontSize: fontSize })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onClick,
        xcss: $afb27c88c7a12472$var$styles.link,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: fontSize || 'small',
            children: children
        })
    });





const $beb4623030507954$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "growth.inline-invite.invite-panel.title",
        defaultMessage: "Invite {count, plural, one {<bold>{email}</bold>} =2 {<bold>{email}</bold> and <bold>1 other</bold>} other {<bold>{email}</bold> and <bold>{others} others</bold>}} to {product}"
    },
    skip: {
        id: "growth.inline-invite.invite-panel.skip",
        defaultMessage: "<action>Skip</action> this if you're sharing to a group email or distribution list."
    },
    invite: {
        id: "growth.inline-invite.invite-panel.invite",
        defaultMessage: "Invite"
    }
});
var $beb4623030507954$export$2e2bcd8739ae039 = $beb4623030507954$var$messages;


const $9600b550c90ef084$export$1b4c768cc9f5f1c = {
    confluence: 'Confluence'
};


const $866cc464bc19f83d$export$fcaf0466bc17a9da = ({ emails: emails, product: product, onInvite: onInvite, onDismiss: onDismiss, isRecaptchaLoaded: isRecaptchaLoaded, integration: integration })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const fireAnalyticsEvent = (0, $f0c8ab6594537af0$export$e955abb82869dc84)();
    const attributes = (0, $42omo.useMemo)(()=>({
            users: emails.length,
            integration: integration
        }), [
        emails.length,
        integration
    ]);
    const handleInvite = (0, $42omo.useCallback)(async ()=>{
        setIsLoading(true);
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'inlineInvite',
            attributes: attributes
        });
        await onInvite();
        setIsLoading(false);
    }, [
        fireAnalyticsEvent,
        attributes,
        onInvite
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        fireAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'inlineInviteDismissed',
            attributes: attributes
        });
        onDismiss();
    }, [
        fireAnalyticsEvent,
        attributes,
        onDismiss
    ]);
    if (emails.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
        appearance: "information",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            spread: "space-between",
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "medium",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $beb4623030507954$export$2e2bcd8739ae039).title,
                                values: {
                                    email: emails[0],
                                    product: (0, $9600b550c90ef084$export$1b4c768cc9f5f1c)[product],
                                    count: emails.length,
                                    others: emails.length - 1,
                                    bold: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            weight: "bold",
                                            children: chunks
                                        })
                                }
                            })
                        }),
                        isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a502B.default), {})
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $beb4623030507954$export$2e2bcd8739ae039).skip,
                                values: {
                                    action: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $afb27c88c7a12472$export$cfc7921d29ef7b80), {
                                            onClick: handleDismiss,
                                            children: chunks
                                        })
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    appearance: "primary",
                    spacing: "compact",
                    isLoading: isLoading || !isRecaptchaLoaded,
                    onClick: handleInvite,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $beb4623030507954$export$2e2bcd8739ae039).invite
                    })
                })
            ]
        })
    });
};





















const $3d6d71e9aa560020$var$messages = (0, $cgtv4.defineMessages)({
    allInvited: {
        id: "growth.inline-invite.success-panel.all-invited",
        defaultMessage: "Invitation sent to <bold>{invitedCount, plural, one {{email}} other {everyone}}</bold>"
    },
    allRequested: {
        id: "growth.inline-invite.success-panel.all-requested",
        defaultMessage: "Access request sent to your admin for <bold>{requestedCount, plural, one {{email}} other {everyone}}</bold>"
    },
    hybridOneRequested: {
        id: "growth.inline-invite.success-panel.hybrid-one-requested",
        defaultMessage: "You've added <bold>{invitedCount, plural, one {1 person} other {# people}}</bold>, and requested access for {email}"
    },
    hybridOneInvited: {
        id: "growth.inline-invite.success-panel.hybrid-one-invited",
        defaultMessage: "You've added <bold>{email}</bold>, and requested access for {requestedCount} others"
    },
    hybrid: {
        id: "growth.inline-invite.success-panel.hybrid",
        defaultMessage: "You've added <bold>{invitedCount} people</bold>, and requested access for {requestedCount} others"
    }
});
var $3d6d71e9aa560020$export$2e2bcd8739ae039 = $3d6d71e9aa560020$var$messages;


const $fad9a5c512a13310$var$getMessage = ({ invitedEmails: invitedEmails, requestedEmails: requestedEmails })=>{
    if (invitedEmails.length === 0 && requestedEmails.length === 0) return {
        message: null,
        email: null
    };
    if (invitedEmails.length >= 1 && requestedEmails.length === 0) return {
        message: (0, $3d6d71e9aa560020$export$2e2bcd8739ae039).allInvited,
        email: invitedEmails[0]
    };
    if (invitedEmails.length === 0 && requestedEmails.length >= 1) return {
        message: (0, $3d6d71e9aa560020$export$2e2bcd8739ae039).allRequested,
        email: requestedEmails[0]
    };
    if (invitedEmails.length >= 1 && requestedEmails.length === 1) return {
        message: (0, $3d6d71e9aa560020$export$2e2bcd8739ae039).hybridOneRequested,
        email: requestedEmails[0]
    };
    if (invitedEmails.length === 1 && requestedEmails.length >= 1) return {
        message: (0, $3d6d71e9aa560020$export$2e2bcd8739ae039).hybridOneInvited,
        email: invitedEmails[0]
    };
    return {
        message: (0, $3d6d71e9aa560020$export$2e2bcd8739ae039).hybrid,
        email: null
    };
};
const $fad9a5c512a13310$export$66605d97e5700218 = ({ invitedEmails: invitedEmails, requestedEmails: requestedEmails, integration: integration })=>{
    const fireAnalyticsEvent = (0, $f0c8ab6594537af0$export$e955abb82869dc84)();
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent({
            eventType: 'screen',
            name: 'inlineInviteSuccess',
            attributes: {
                invitedUsers: invitedEmails.length,
                requestedUsers: requestedEmails.length,
                integration: integration
            }
        });
    }, [
        fireAnalyticsEvent,
        invitedEmails.length,
        requestedEmails.length,
        integration
    ]);
    const { message: message, email: email } = (0, $42omo.useMemo)(()=>$fad9a5c512a13310$var$getMessage({
            invitedEmails: invitedEmails,
            requestedEmails: requestedEmails
        }), [
        invitedEmails,
        requestedEmails
    ]);
    if (!message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
        appearance: "success",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "medium",
            color: "color.text.success",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...message,
                values: {
                    invitedCount: invitedEmails.length,
                    requestedCount: requestedEmails.length,
                    email: email,
                    bold: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "bold",
                            children: chunks
                        })
                }
            })
        })
    });
};


const $239decd3b90c4604$export$239222a132fbd063 = ({ emails: emails, product: product, invite: invite, onInviteComplete: onInviteComplete, onDismiss: onDismiss, continueUrl: continueUrl, resources: resources, integration: integration, touchpoint: touchpoint, isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken })=>{
    const [activePanel, setActivePanel] = (0, $42omo.useState)('invite');
    const [inviteResult, setInviteResult] = (0, $42omo.useState)({
        invited: [],
        requested: [],
        error: []
    });
    const [exceedsMaxInvites, setExceedsMaxInvites] = (0, $42omo.useState)(false);
    const [endpointFailure, setEndpointFailure] = (0, $42omo.useState)(false);
    const handleInvite = (0, $42omo.useCallback)(async ()=>{
        const recaptchaToken = await getRecaptchaToken('invite').catch(()=>undefined);
        const recaptchaAction = `InlineInvite_${integration}`;
        if (emails.length > (0, $12a8948a54415540$export$21009fc133be621c)) {
            setExceedsMaxInvites(true);
            setActivePanel('error');
            return;
        }
        const users = emails.map((email)=>({
                email: email
            }));
        const [response] = await Promise.all([
            invite({
                continueUrl: continueUrl,
                users: users,
                resources: resources,
                integration: integration,
                touchpoint: touchpoint,
                recaptchaOptions: {
                    recaptchaToken: recaptchaToken,
                    recaptchaAction: recaptchaAction
                }
            }),
            /* Delay to give the user enough time to read the recaptcha message */ new Promise((resolve)=>{
                setTimeout(resolve, 2500);
            })
        ]);
        let failure = false;
        if ((0, $dh538.fg)('expansion-services-in-core-invites')) {
            const result = (0, $1BTvF.mapInviteResult)(response);
            failure = !!result.failure;
        } else failure = response.every((res)=>res.inviteStatus === null);
        if (failure) {
            setEndpointFailure(true);
            const res = {
                invited: [],
                requested: [],
                error: users
            };
            setInviteResult(res);
            onInviteComplete(res);
            setActivePanel('error');
            return;
        }
        const { invited: invited, requested: requested, error: error } = (0, $1BTvF.mapInviteResult)(response);
        const res = {
            invited: invited.map(({ email: email, id: id })=>({
                    email: email,
                    id: id
                })),
            requested: requested.map(({ email: email, id: id })=>({
                    email: email,
                    id: id
                })),
            error: error.map(({ email: email })=>({
                    email: email
                }))
        };
        setInviteResult(res);
        onInviteComplete(res);
        if (error.length > 0) {
            setActivePanel('error');
            return;
        }
        setActivePanel('success');
    }, [
        invite,
        continueUrl,
        emails,
        resources,
        integration,
        touchpoint,
        getRecaptchaToken,
        onInviteComplete
    ]);
    switch(activePanel){
        case 'invite':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $866cc464bc19f83d$export$fcaf0466bc17a9da), {
                emails: emails,
                product: product,
                onInvite: handleInvite,
                onDismiss: onDismiss,
                isRecaptchaLoaded: isRecaptchaLoaded,
                integration: integration
            });
        case 'success':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $fad9a5c512a13310$export$66605d97e5700218), {
                invitedEmails: inviteResult.invited.map(({ email: email })=>email),
                requestedEmails: inviteResult.requested.map(({ email: email })=>email),
                integration: integration
            });
        case 'error':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $12a8948a54415540$export$9f3dc18e1adf5d8f), {
                endpointFailure: endpointFailure,
                exceedsMaxInvites: exceedsMaxInvites,
                successEmails: [
                    ...inviteResult.invited.map(({ email: email })=>email),
                    ...inviteResult.requested.map(({ email: email })=>email)
                ],
                errorEmails: inviteResult.error.map(({ email: email })=>email),
                integration: integration
            });
    }
};


const $de9ce521ea4455f4$var$RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $de9ce521ea4455f4$var$RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $de9ce521ea4455f4$var$RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
const $de9ce521ea4455f4$var$DEV_ENV_HOSTNAMES = [
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'statlas.atl-paas.net',
    'atlaskit.atlassian.com'
];
const $de9ce521ea4455f4$var$isProd = ()=>window.location.host.includes('-dev.com') ? false : true;
const $de9ce521ea4455f4$var$isDevEnv = ()=>$de9ce521ea4455f4$var$DEV_ENV_HOSTNAMES.includes(window.location.hostname);
const $de9ce521ea4455f4$export$f6c02f8ff560b96f = ()=>$de9ce521ea4455f4$var$isDevEnv() ? $de9ce521ea4455f4$var$RECAPTCHA_SITE_KEY_DEV : $de9ce521ea4455f4$var$isProd() ? $de9ce521ea4455f4$var$RECAPTCHA_SITE_KEY_PROD : $de9ce521ea4455f4$var$RECAPTCHA_SITE_KEY_STAGING;


const $d2a31a94f2999b7d$var$fetchJson = async (input)=>{
    const url = input.url;
    const options = input;
    try {
        const response = await fetch(url, options);
        if (response.ok) return response.json();
        else throw new Error(`Fetch failed with status ${response.status}`);
    } catch (error) {
        if (error instanceof Error) error.message = `Error while executing fetch for ${url}: ${error.message}`;
        throw error;
    }
};
const $d2a31a94f2999b7d$export$d97f432445435a6a = (props)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, product: product } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken } = (0, $fAdjB.useInvisibleRecaptcha)({
        siteKey: (0, $de9ce521ea4455f4$export$f6c02f8ff560b96f)(),
        displayBadge: false,
        analyticsChannel: (0, $1cd75fa03a01fd9d$export$8dc567da1fd35a38),
        analyticsSource: `InlineInvite_${props.integration}`
    });
    const deps = (0, $42omo.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: $d2a31a94f2999b7d$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>atlassianAccountId,
            getCurrentProduct: ()=>product
        }), [
        createAnalyticsEvent,
        cloudId,
        atlassianAccountId,
        product
    ]);
    const invite = (0, $hCOLa.useService)((0, $1BTvF.invite), deps);
    const resources = [
        (0, $k4HRJ.AnyAri).create({
            resourceOwner: product,
            resourceType: 'site',
            resourceId: cloudId
        })
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $239decd3b90c4604$export$239222a132fbd063), {
        ...props,
        invite: invite,
        resources: resources,
        isRecaptchaLoaded: isRecaptchaLoaded,
        getRecaptchaToken: getRecaptchaToken
    });
};



var $hSHWm = parcelRequire("hSHWm");


var $egeZH = parcelRequire("egeZH");


var $koZ31 = parcelRequire("koZ31");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");











var $cOQPm = parcelRequire("cOQPm");





var $bYWO7 = parcelRequire("bYWO7");

const $dd7e67c9494e21e2$var$i18n = (0, $cgtv4.defineMessages)({
    inviteMessage: {
        id: "share-and-restrict-dialog.button.restriction.message.invite.text",
        defaultMessage: "Invite <b>{userEmail} {userCount, plural, =0 {} one {and # other} other {and # others}}</b> to join Confluence? Otherwise, we\u2019ll just send a notification when you select Share."
    },
    warningInviteMessage: {
        id: "share-and-restrict-dialog.button.restriction.message.warning.invite.text",
        defaultMessage: "Sharing to emails isn\u2019t available on the Free plan. You can invite emails to join Confluence, or remove them to continue sharing."
    },
    invitePeopleCta: {
        id: "share-and-restrict-dialog.button.restriction.invite.action.text",
        defaultMessage: "Invite them"
    },
    inviteToConfluenceCta: {
        id: "share-and-restrict-dialog.button.restriction.inviteToConfluence.action.text",
        defaultMessage: "Invite to Confluence"
    },
    notifyUser: {
        id: "share-and-restrict-dialog.button.restriction.notify.action.text",
        defaultMessage: "Notify only"
    },
    inviteAndNotifyMessage: {
        id: "share-and-restrict-dialog.button.restriction.message.inviteOrNotify.text",
        defaultMessage: "To view the shared page, <b>{userEmail}</b> <b> {userCount, plural, =0 {} one {and # other} other {and # others}}</b> might need Confluence access. Invite them to get started. If sharing with a group or list, you can choose to notify only."
    }
});
const $dd7e67c9494e21e2$var$inviteMessageContainer = (0, $ecnYn.xcss)({
    padding: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $dd7e67c9494e21e2$var$warningInviteMessageContainer = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.warning',
    marginTop: 'space.200',
    marginLeft: 'space.200',
    marginRight: 'space.200'
});
const $dd7e67c9494e21e2$var$iconContainer = (0, $ecnYn.xcss)({
    marginTop: 'space.050'
});
const $dd7e67c9494e21e2$var$Bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "bold"
    }, chunks);
const $dd7e67c9494e21e2$export$3ce7a79809b1a783 = ({ userEmails: userEmails, resolvedPrincipals: resolvedPrincipals, setResolvedPrincipals: setResolvedPrincipals, showEmailWarningMessage: showEmailWarningMessage, markPrincipalsAsInvited: markPrincipalsAsInvited, markPrincipalsAsSkipped: markPrincipalsAsSkipped })=>{
    const { openCoreInvites: openCoreInvites } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        if (!openCoreInvites || !userEmails || userEmails?.length === 0) return;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'informInviteOnShare',
                attributes: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    inviteImprovementsM2Gate: (0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate'),
                    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
                    inviteImprovementsM2Cohort: (0, $6mKj3.UNSAFE_expValNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled')
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        openCoreInvites,
        userEmails
    ]);
    if (!openCoreInvites || !userEmails || userEmails?.length === 0) return null;
    const allResolvedEmails = new Set(resolvedPrincipals.all.map((email)=>email.email));
    const emailsToInvite = userEmails.filter((email)=>!allResolvedEmails.has(email));
    const fireButtonClickedAnalytics = ()=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'invitePeople',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
                    inviteImprovementsM2Cohort: (0, $6mKj3.UNSAFE_expValNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled'),
                    emailCount: emailsToInvite.length
                }
            }
        }).fire();
    const handleCtaClick = ()=>{
        openCoreInvites((0, $koZ31.CoreInvitesSource).SHARE_AND_RESTRICT_DIALOG, undefined, emailsToInvite.map((email)=>({
                id: email,
                email: email,
                name: email,
                type: 'email'
            })));
        fireButtonClickedAnalytics();
    };
    const onInviteComplete = ({ invited: invited, requested: requested, error: error })=>{
        setResolvedPrincipals((prev)=>({
                ...prev,
                invited: [
                    ...prev.invited,
                    ...invited,
                    ...requested
                ],
                all: [
                    ...prev.all,
                    ...invited,
                    ...requested
                ]
            }));
        markPrincipalsAsInvited([
            ...invited,
            ...requested
        ], error);
        (0, $cOQPm.updateCachedInvites)(invited.map(({ id: id })=>id));
        fireButtonClickedAnalytics();
    };
    const onDismiss = ()=>{
        const skippedPrincipals = emailsToInvite.map((email)=>({
                id: email,
                email: email
            }));
        setResolvedPrincipals({
            ...resolvedPrincipals,
            skipped: [
                ...resolvedPrincipals.skipped,
                ...skippedPrincipals
            ],
            all: [
                ...resolvedPrincipals.all,
                ...skippedPrincipals
            ]
        });
        markPrincipalsAsSkipped(emailsToInvite);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'notifyOnly',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    emailCount: emailsToInvite?.length
                }
            }
        }).fire();
    };
    return(// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate') && (0, $6mKj3.expValEquals)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d2a31a94f2999b7d$export$d97f432445435a6a), {
        key: userEmails.join(','),
        continueUrl: (0, $egeZH.getCurrentUrl)(),
        integration: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
        touchpoint: "Share Dialog",
        emails: emailsToInvite,
        product: "confluence",
        onInviteComplete: onInviteComplete,
        onDismiss: onDismiss,
        atlassianAccountId: userId || '',
        cloudId: cloudId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "start",
        space: "space.200",
        xcss: [
            $dd7e67c9494e21e2$var$inviteMessageContainer,
            showEmailWarningMessage && $dd7e67c9494e21e2$var$warningInviteMessageContainer
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $dd7e67c9494e21e2$var$iconContainer
    }, showEmailWarningMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        align: "start",
        color: "color.text.subtle",
        size: "medium"
    }, showEmailWarningMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $dd7e67c9494e21e2$var$i18n.warningInviteMessage) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$dd7e67c9494e21e2$var$i18n.inviteMessage,
        values: {
            userEmail: userEmails[0],
            userCount: userEmails?.length - 1,
            b: $dd7e67c9494e21e2$var$Bold
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.link",
        weight: "semibold",
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYWO7.PressableLink), {
        isBlue: true,
        onClick: handleCtaClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $dd7e67c9494e21e2$var$i18n.invitePeopleCta))))));
};
const $dd7e67c9494e21e2$export$535acf9a3f0f5a83 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dd7e67c9494e21e2$export$3ce7a79809b1a783, props));









var $g5gZt = parcelRequire("g5gZt");














var $kpYGL = parcelRequire("kpYGL");


var $59MXn = parcelRequire("59MXn");





var $lf3m6 = parcelRequire("lf3m6");

const $b1b24f27fe328b73$var$ENTRY_DURATION = 0.24;
const $b1b24f27fe328b73$var$EXIT_DURATION = 0.12;
const $b1b24f27fe328b73$var$MAX_SUGGESTIONS = 3;
const $b1b24f27fe328b73$var$containerStyles = (0, $ecnYn.xcss)({
    minHeight: '32px',
    marginTop: 'space.025',
    width: 'calc(100% + 8px)',
    position: 'relative',
    top: '-4px',
    left: '-4px'
});
const $b1b24f27fe328b73$var$entryStyles = (0, $ecnYn.xcss)({
    flex: '0 1 auto',
    maxWidth: '42%',
    opacity: 0,
    padding: 'space.050',
    transition: `opacity ${$b1b24f27fe328b73$var$ENTRY_DURATION}s ease-in`
});
const $b1b24f27fe328b73$var$baseStyles = (0, $ecnYn.xcss)({
    flex: '0 1 auto',
    maxWidth: '42%',
    opacity: 1,
    padding: 'space.050',
    overflow: 'hidden',
    transition: `opacity ${$b1b24f27fe328b73$var$ENTRY_DURATION}s ease-in`
});
const $b1b24f27fe328b73$var$exitStyles = (0, $ecnYn.xcss)({
    flex: '0 1 auto',
    maxWidth: '0%',
    opacity: 0,
    overflow: 'hidden',
    padding: 'space.0',
    transition: `all ${$b1b24f27fe328b73$var$EXIT_DURATION}s ease-out`
});
const $b1b24f27fe328b73$var$skeletonWrapperStyles = (0, $ecnYn.xcss)({
    height: '32px',
    padding: 'space.050'
});
const $b1b24f27fe328b73$var$SuggestedUserPill = ({ user: user, onClick: onClick, indexPosition: indexPosition })=>{
    const [animationState, setAnimationState] = (0, $42omo.useState)('entry');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleUserPillClick = (_, buttonEvent)=>{
        setAnimationState('exit');
        setTimeout(()=>{
            onClick(user);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...buttonEvent.payload,
                    actionSubjectId: 'SuggestedShareUserButton',
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    attributes: {
                        indexPosition: indexPosition + 1
                    }
                }
            }).fire();
        }, $b1b24f27fe328b73$var$EXIT_DURATION * 1000);
    };
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            setAnimationState('base');
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: animationState === 'entry' ? $b1b24f27fe328b73$var$entryStyles : animationState === 'exit' ? $b1b24f27fe328b73$var$exitStyles : $b1b24f27fe328b73$var$baseStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        spacing: "compact",
        appearance: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        onClick: handleUserPillClick
    }, user.name));
};
const $b1b24f27fe328b73$var$SuggestedUserPillLoader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        xcss: $b1b24f27fe328b73$var$skeletonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        width: "148px",
        height: "20px",
        borderRadius: 3
    }));
const $b1b24f27fe328b73$export$2d945aea04d67cdf = ({ onSuggestedUserClick: onSuggestedUserClick, currentPickedPrincipalIds: currentPickedPrincipalIds, defaultSuggestedUsers: defaultSuggestedUsers })=>{
    const hasDefaultSuggestedUsers = !!(defaultSuggestedUsers && defaultSuggestedUsers.length > 0);
    const { contentId: contentId, spaceId: spaceId, contextType: contextType, mentionsSessionId: mentionsSessionId } = (0, $lf3m6.useUserSuggestionsMentionsExperiment)();
    const { suggestedUsers: fetchedSuggestedUsers, loading: loading } = (0, $59MXn.useUserSuggestions)({
        currentPickedPrincipalIds: currentPickedPrincipalIds,
        contextType: contextType,
        containerId: spaceId,
        objectId: contentId,
        mentionsSessionId: mentionsSessionId
    });
    // Combine default users with fetched users
    const suggestedUsers = (0, $42omo.useMemo)(()=>{
        if (!hasDefaultSuggestedUsers) // No default users, just use fetched users
        return fetchedSuggestedUsers;
        // Filter out already picked users from default users
        const filteredDefaultUsers = defaultSuggestedUsers.filter((user)=>!currentPickedPrincipalIds.includes(user.id));
        if (!fetchedSuggestedUsers) // Only have default users, no fetched users yet
        return filteredDefaultUsers;
        const defaultUserIds = filteredDefaultUsers.map((user)=>user.id);
        const additionalUsers = fetchedSuggestedUsers.filter((user)=>!defaultUserIds.includes(user.id));
        return [
            ...filteredDefaultUsers,
            ...additionalUsers
        ].slice(0, 3);
    }, [
        defaultSuggestedUsers,
        fetchedSuggestedUsers,
        hasDefaultSuggestedUsers,
        currentPickedPrincipalIds
    ]);
    const isInitialLoad = loading && suggestedUsers === null;
    if (!loading && suggestedUsers && suggestedUsers.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        wrap: "nowrap",
        justifyContent: "start",
        alignItems: "center",
        direction: "row",
        xcss: $b1b24f27fe328b73$var$containerStyles
    }, isInitialLoad ? Array.from({
        length: $b1b24f27fe328b73$var$MAX_SUGGESTIONS
    }).map((_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1b24f27fe328b73$var$SuggestedUserPillLoader, {
            key: i
        })) : suggestedUsers?.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1b24f27fe328b73$var$SuggestedUserPill, {
            key: user.id,
            user: user,
            indexPosition: index,
            onClick: onSuggestedUserClick
        })));
};


const $b17f567cc82483a4$var$i18n = (0, $cgtv4.defineMessages)({
    canView: {
        id: "share-and-restrict-dialog.principals-stager.can-view",
        defaultMessage: "Can view"
    },
    canEdit: {
        id: "share-and-restrict-dialog.principals-stager.can-edit",
        defaultMessage: "Can edit"
    },
    placeholder: {
        id: "share-and-restrict-dialog.principals-stager.placeholder",
        defaultMessage: "Add names, groups, or emails"
    },
    placeholderWithTeams: {
        id: "share-and-restrict-dialog.principals-stager.placeholder-with-teams",
        defaultMessage: "Add names, teams, groups, or emails"
    },
    capacityExceeded: {
        id: "share-and-restrict-dialog.permissions-select.capacity-exceeded",
        defaultMessage: "Maximum capacity of 200 users and 200 groups exceeded."
    },
    capacityExceededWithTeams: {
        id: "share-and-restrict-dialog.permissions-select.capacity-exceeded-with-teams",
        defaultMessage: "Maximum capacity of 200 users and 200 teams or groups exceeded."
    },
    userLimitExceeded: {
        id: "share-and-restrict-dialog.permissions-select.user-limit-exceeded",
        defaultMessage: "Please remove {userOverflow, plural, one {# user} other {# users}} to continue."
    },
    groupLimitExceeded: {
        id: "share-and-restrict-dialog.permissions-select.group-limit-exceeded",
        defaultMessage: "Please remove {groupOverflow, plural, one {# group} other {# groups}} to continue."
    },
    groupTeamLimitExceeded: {
        id: "share-and-restrict-dialog.permissions-select.group-team-limit-exceeded",
        defaultMessage: "Please remove {groupOverflow, plural, one {# team or group} other {# teams or groups}} to continue."
    },
    userAndGroupLimitExceededUser: {
        id: "share-and-restrict-dialog.permissions-select.user-and-group-limit-exceeded-prefix",
        defaultMessage: "Please remove {userOverflow, plural, one {# user} other {# users}}"
    },
    userAndGroupLimitExceededGroup: {
        id: "share-and-restrict-dialog.permissions-select.user-and-group-limit-exceeded-suffix",
        defaultMessage: "and {groupOverflow, plural, one {# group} other {# groups}} to continue."
    },
    userAndGroupTTeamLimitExceededGroup: {
        id: "share-and-restrict-dialog.permissions-select.user-and-group-team-limit-exceeded-suffix",
        defaultMessage: "and {groupOverflow, plural, one {# team or group} other {# teams or groups}} to continue."
    },
    shareButton: {
        id: "share-and-restrict-dialog.principal-stager.share-cta",
        defaultMessage: "Share"
    },
    saveButton: {
        id: "share-and-restrict-dialog.principal-stager.save-cta",
        defaultMessage: "Save"
    }
});
const $b17f567cc82483a4$var$errorText = (0, $ecnYn.xcss)({
    color: 'color.text.danger'
});
const $b17f567cc82483a4$var$dropdownContainer = (0, $ecnYn.xcss)({
    width: '100%',
    minWidth: '112px'
});
const $b17f567cc82483a4$var$principalsStagerDropdownContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $b17f567cc82483a4$var$uneditableDropdownContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`,
    borderRadius: 'radius.small',
    paddingLeft: 'space.100',
    paddingRight: 'space.500',
    paddingBlock: 'space.100',
    lineHeight: '22px',
    height: '32px',
    display: 'flex',
    alignItems: 'center'
});
const $b17f567cc82483a4$var$stagerContainer = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $b17f567cc82483a4$var$noOptionsStyle = (0, $ecnYn.xcss)({});
const $b17f567cc82483a4$var$PrincipalsStagerDropdown = ({ isLockedOut: isLockedOut, dropdown: dropdown, onChangeDropdown: onChangeDropdown, isEditable: isEditable, principals: principals })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const options = [
        {
            label: formatMessage($b17f567cc82483a4$var$i18n.canView),
            value: 'can-view'
        },
        {
            label: formatMessage($b17f567cc82483a4$var$i18n.canEdit),
            value: 'can-edit'
        }
    ];
    const value = options[dropdown === 'can-view' ? 0 : 1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b17f567cc82483a4$var$principalsStagerDropdownContainer
    }, isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b17f567cc82483a4$var$dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        isDisabled: isLockedOut,
        options: options,
        isSearchable: false,
        value: value,
        onChange: (option)=>onChangeDropdown(option === options[0] ? 'as-viewer' : 'as-editor', principals),
        spacing: (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? 'compact' : 'default'
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b17f567cc82483a4$var$uneditableDropdownContainer
    }, value.label));
};
const $b17f567cc82483a4$export$e78986608e5a94ec = (shouldShowInlineInviteStyles)=>(provided, state)=>{
        if (state?.options.length === 0 && shouldShowInlineInviteStyles) return {
            ...provided,
            display: 'none'
        };
        return provided;
    };
const $b17f567cc82483a4$export$6cb4f855320cf988 = (provided, state, isSharingToEmailsDisabled, shouldShowInviteMessage)=>{
    const { data: dataObject } = state;
    const isAEmail = dataObject.data.type === 'email';
    return {
        ...provided,
        borderColor: isSharingToEmailsDisabled && shouldShowInviteMessage && isAEmail ? "var(--ds-border-warning, #E06C00)" : provided.borderColor
    };
};
const $b17f567cc82483a4$export$7e8d7ac501edf4f1 = ({ isLockedOut: isLockedOut, principals: principals, exceededLimit: exceededLimit, dropdown: dropdown, isDropdownEditable: isDropdownEditable, onChangePrincipals: onChangePrincipals, onSuggestedUserClick: onSuggestedUserClick, onChangeDropdown: onChangeDropdown, specificAccessIds: specificAccessIds, isSharingToEmailsDisabled: isSharingToEmailsDisabled, contentId: contentId, defaultSuggestedUsers: defaultSuggestedUsers = [], currentUserEmailDomain: currentUserEmailDomain, markPrincipalsAsInvited: markPrincipalsAsInvited, markPrincipalsAsSkipped: markPrincipalsAsSkipped, handleCtaClick: handleCtaClick, isCtaInProgress: isCtaInProgress, charLimitExceeded: charLimitExceeded, natureOfCta: natureOfCta })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [resolvedPrincipals, setResolvedPrincipals] = (0, $42omo.useState)({
        invited: [],
        skipped: [],
        all: []
    });
    const { isLimitExceeded: isLimitExceeded, userOverFlow: userOverFlow, groupOverFlow: groupOverFlow } = exceededLimit;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { canUserInvite: canUserInvite, loadInviteCapabilities: loadInviteCapabilities, called: inviteCapabilitiesHasBeenCalled } = (0, $92b5ca72620f412e$export$171021d8e67014af)();
    const { thirdPartyResolver: thirdPartyResolver, initThirdPartyIntegrations: initThirdPartyIntegrations, isInitialized: isInitialized, isInitializing: isInitializing } = (0, $6ef9c8760de63998$export$f6b50533d71620fe)({
        cloudId: cloudId,
        createAnalyticsEvent: createAnalyticsEvent,
        canUserInvite: canUserInvite
    });
    const [suggestEmailsForDomain, setSuggestEmailsForDomain] = (0, $42omo.useState)();
    const ctaOptions = {
        share: $b17f567cc82483a4$var$i18n.shareButton,
        save: $b17f567cc82483a4$var$i18n.saveButton
    };
    const getLimitOverflowMessage = (userOverflow, groupOverflow)=>{
        if (userOverflow && groupOverflow) // This needs to be concatenated due to double pluralization
        return `${formatMessage($b17f567cc82483a4$var$i18n.userAndGroupLimitExceededUser, {
            userOverflow: userOverflow
        })} ${formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $b17f567cc82483a4$var$i18n.userAndGroupTTeamLimitExceededGroup : $b17f567cc82483a4$var$i18n.userAndGroupLimitExceededGroup, {
            groupOverflow: groupOverflow
        })}`;
        if (userOverflow) return formatMessage($b17f567cc82483a4$var$i18n.userLimitExceeded, {
            userOverflow: userOverflow
        });
        return formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $b17f567cc82483a4$var$i18n.groupTeamLimitExceeded : $b17f567cc82483a4$var$i18n.groupLimitExceeded, {
            groupOverflow: groupOverflow
        });
    };
    (0, $42omo.useEffect)(()=>{
        if (isLimitExceeded) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: 'exceededLimit',
                action: 'warning',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    isLimitExceeded: isLimitExceeded,
                    userOverFlow: Boolean(userOverFlow),
                    groupOverFlow: Boolean(groupOverFlow),
                    contentId: contentId
                }
            }
        }).fire();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLimitExceeded,
        userOverFlow,
        groupOverFlow
    ]);
    const userEmails = (0, $42omo.useMemo)(()=>{
        const allResolvedEmails = new Set(resolvedPrincipals.all.map((email)=>email.email));
        return principals.reduce((acc, principal)=>{
            switch(principal.type){
                case 'email':
                    acc.push(principal.id);
                    return acc;
                case 'user':
                    if (principal.email && allResolvedEmails.has(principal.email)) acc.push(principal.email);
                    return acc;
                case 'external_user':
                    if (principal.email) acc.push(principal.email);
                    return acc;
                default:
                    return acc;
            }
        }, []);
    }, [
        principals,
        resolvedPrincipals
    ]);
    const areEmailsPresent = userEmails.length > 0;
    const shouldShowInviteMessage = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate') && [
        'control',
        'variation'
    ].includes((0, $6mKj3.UNSAFE_expValNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled')) ? areEmailsPresent && canUserInvite() : areEmailsPresent;
    const hasDropdown = dropdown !== 'hidden';
    const userPickerWidth = (()=>{
        if (hasDropdown) return '436px';
        return '552px';
    })();
    const handleSuggestedUserClick = (selectedUser)=>{
        onChangePrincipals([
            ...principals,
            selectedUser
        ]);
        onSuggestedUserClick?.();
    };
    const currentPickedPrincipalIds = (0, $42omo.useMemo)(()=>{
        const principalIds = principals.filter(({ type: type })=>type === 'user').map(({ id: id })=>id);
        return [
            ...new Set([
                ...principalIds,
                ...specificAccessIds
            ])
        ];
    }, [
        principals,
        specificAccessIds
    ]);
    const shouldShowInlineInviteStyles = shouldShowInviteMessage && isMenuOpen && (0, $6mKj3.expValEquals)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation');
    const multiValueStyleFn = (provided, state)=>$b17f567cc82483a4$export$6cb4f855320cf988(provided, state, isSharingToEmailsDisabled, shouldShowInviteMessage);
    const onFocus = ()=>{
        if (shouldShowInviteMessage) setIsMenuOpen(true);
        if (!(0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate')) return;
        if (!inviteCapabilitiesHasBeenCalled && [
            'control',
            'variation'
        ].includes((0, $6mKj3.expVal)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled'))) {
            loadInviteCapabilities();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'principalStager',
                    action: 'focused',
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    attributes: {
                        inviteImprovementsM2Gate: (0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate'),
                        inviteImprovementsM2Cohort: (0, $6mKj3.expVal)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled')
                    }
                }
            }).fire();
        }
        if (!(0, $6mKj3.expValEquals)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation')) return;
        if (!isInitialized && !isInitializing) initThirdPartyIntegrations();
        if (!suggestEmailsForDomain) setSuggestEmailsForDomain(currentUserEmailDomain);
    };
    const onSelectOption = (value)=>{
        setIsMenuOpen(shouldShowInviteMessage);
        if (value && Array.isArray(value)) {
            const selected = value[value.length - 1];
            if (selected && selected.type === 'external_user') {
                setIsMenuOpen(true);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        actionSubject: 'option',
                        action: 'selected',
                        actionSubjectId: 'externalUser',
                        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        attributes: {
                            canUserInvite: canUserInvite(),
                            inviteImprovementsM2Cohort: (0, $6mKj3.expVal)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled')
                        }
                    }
                }).fire();
            }
        }
    };
    const onCreateOption = (value)=>{
        if (value && Array.isArray(value)) {
            const created = value[value.length - 1];
            const domain = created.id.split('@')[1]; // if the created email is already invited, mark it as invited and convert it to `user` principals
            const invitedPrincipal = resolvedPrincipals.invited.find((email)=>email.email === created.id);
            if (created.type === 'email' && invitedPrincipal) markPrincipalsAsInvited([
                invitedPrincipal
            ], []);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'option',
                    action: 'created',
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    attributes: {
                        canUserInvite: canUserInvite(),
                        isDefaultDomain: !!suggestEmailsForDomain && domain === suggestEmailsForDomain,
                        inviteImprovementsM2Cohort: (0, $6mKj3.expVal)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled')
                    }
                }
            }).fire();
        }
    };
    const onRemoveValue = (value)=>{
        if (value && Array.isArray(value)) {
            const removed = principals.find((principal)=>!value.find((v)=>v.id === principal.id));
            if (removed?.type !== 'email' && removed?.type !== 'user' && removed?.type !== 'external_user') return;
            const email = removed.type === 'email' ? removed.id : removed.email;
            const domain = email?.split('@')[1];
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'option',
                    action: 'removed',
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    attributes: {
                        userType: removed.type,
                        canUserInvite: canUserInvite(),
                        wasUserInvited: !!email && !!resolvedPrincipals.invited.find((principal)=>principal.email === email),
                        isDefaultDomain: !!suggestEmailsForDomain && domain === suggestEmailsForDomain,
                        inviteImprovementsM2Cohort: (0, $6mKj3.expVal)('twcg-444-invite-usd-improvements-m2', 'cohort', 'not-enrolled')
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill",
        space: "space.075",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b17f567cc82483a4$var$stagerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpRYU.UserAndGroupSearchPicker), {
        key: `user-picker-${principals.length}`,
        ariaLabel: formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $b17f567cc82483a4$var$i18n.placeholderWithTeams : $b17f567cc82483a4$var$i18n.placeholder),
        smart: true,
        open: isMenuOpen,
        onInputChange: ()=>setIsMenuOpen(true),
        // Without onBlur, the user picker would stay open due to onInputChange keeping it open,
        // and would only close when a user is selected.
        onBlur: ()=>setIsMenuOpen(false),
        // when the user clicks into the User Picker
        onFocus: onFocus,
        isDisabled: isLockedOut,
        fieldId: "share-and-restrict-dialog:user-and-group-search:user-and-group-picker",
        value: principals,
        onChange: // In practice, the user picker always returns OptionData[] for
        // this configuration, but TypeScript doesn't know that, so handle
        // all cases
        (value, action)=>{
            if (!value) onChangePrincipals([]);
            else if (Array.isArray(value)) onChangePrincipals(value);
            else onChangePrincipals([
                value
            ]);
            switch(action){
                case 'select-option':
                    onSelectOption(value);
                    break;
                case 'create-option':
                    onCreateOption(value);
                    break;
                case 'remove-value':
                    onRemoveValue(value);
                    break;
                default:
                    break;
            }
        },
        onKeyDown: (e)=>{
            if (e.key === 'Escape') e.stopPropagation();
        },
        onClose: ()=>setIsMenuOpen(false),
        // A noOptionsMessage must be present in order to show the InviteMessage header
        noOptionsMessage: ()=>shouldShowInviteMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $b17f567cc82483a4$var$noOptionsStyle
            }) : null,
        header: shouldShowInviteMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd7e67c9494e21e2$export$535acf9a3f0f5a83), {
            userEmails: userEmails,
            showEmailWarningMessage: isSharingToEmailsDisabled,
            resolvedPrincipals: resolvedPrincipals,
            setResolvedPrincipals: setResolvedPrincipals,
            markPrincipalsAsInvited: markPrincipalsAsInvited,
            markPrincipalsAsSkipped: markPrincipalsAsSkipped
        }) : null,
        addMoreMessage: "",
        includeGroup: true,
        isMulti: true,
        placeholder: formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $b17f567cc82483a4$var$i18n.placeholderWithTeams : $b17f567cc82483a4$var$i18n.placeholder),
        width: "100%",
        allowEmail: true,
        displayEmailInByline: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-permissions-surfaces', 'isEnabled', false),
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-permissions-surfaces', 'isEnabled', false),
        allowEmailSelectionWhenEmailMatched: !(0, $6mKj3.expVal)('confluence-enable-email-ux-in-permissions-surfaces', 'isEnabled', false),
        styles: {
            control: (provided)=>({
                    ...provided,
                    ...exceededLimit.isLimitExceeded && {
                        border: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-warning, #E06C00)"}`
                    },
                    ...(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? {
                        minHeight: '30px'
                    } : {
                        minHeight: '40px'
                    },
                    maxHeight: '117px',
                    maxWidth: userPickerWidth,
                    overflowY: 'auto',
                    overflowX: 'auto'
                }),
            valueContainer: (provided)=>({
                    ...provided,
                    ...(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? {
                        paddingTop: "var(--ds-space-025, 2px)",
                        paddingBottom: "var(--ds-space-0, 0px)"
                    } : {
                        paddingTop: "var(--ds-space-025, 2px)",
                        paddingBottom: "var(--ds-space-025, 2px)"
                    }
                }),
            multiValue: multiValueStyleFn,
            menuList: $b17f567cc82483a4$export$e78986608e5a94ec(shouldShowInlineInviteStyles)
        },
        includeTeams: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals'),
        includeTeamsUpdates: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals'),
        transformOptions: (options)=>{
            const allUserEmails = new Set([
                ...options,
                ...principals
            ].filter((0, $6O3OC.isUser)).map((item)=>item.email));
            const filteredOptions = options.filter((option)=>{
                if ((0, $6O3OC.isExternalUser)(option)) return option.email && !allUserEmails.has(option.email);
                return true;
            });
            return Promise.resolve(filteredOptions);
        },
        userResolvers: [
            thirdPartyResolver
        ]
    })), hasDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b17f567cc82483a4$var$PrincipalsStagerDropdown, {
        isLockedOut: isLockedOut,
        dropdown: dropdown,
        onChangeDropdown: onChangeDropdown,
        isEditable: isDropdownEditable,
        principals: principals
    }), natureOfCta !== 'none' && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleCtaClick,
        isLoading: isCtaInProgress,
        isDisabled: !isCtaInProgress && isLockedOut || charLimitExceeded || isLimitExceeded || isSharingToEmailsDisabled
    }, formatMessage(ctaOptions[natureOfCta]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1b24f27fe328b73$export$2d945aea04d67cdf), {
        currentPickedPrincipalIds: currentPickedPrincipalIds,
        onSuggestedUserClick: handleSuggestedUserClick,
        defaultSuggestedUsers: defaultSuggestedUsers
    }), isLimitExceeded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b17f567cc82483a4$var$errorText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $b17f567cc82483a4$var$i18n.capacityExceededWithTeams : $b17f567cc82483a4$var$i18n.capacityExceeded)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, getLimitOverflowMessage(userOverFlow, groupOverFlow))))), (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: [
            'command+enter',
            'ctrl+enter'
        ],
        listener: handleCtaClick,
        allowInDialog: true
    }));
};













var $1qfLF = parcelRequire("1qfLF");


var $bPdpL = parcelRequire("bPdpL");







var $8TTLA = parcelRequire("8TTLA");

var $d8eRd = parcelRequire("d8eRd");


var $jhTeh = parcelRequire("jhTeh");













var $c4sKh = parcelRequire("c4sKh");













var $6SeRB = parcelRequire("6SeRB");

const $3a8ae97437224896$var$i18n = (0, $cgtv4.defineMessages)({
    buttonTitle: {
        id: "access-requests.button-title",
        defaultMessage: "Requests"
    }
});
const $3a8ae97437224896$export$60de088d75c2b3 = ({ tryCacheFirst: tryCacheFirst = false, delayShowing: delayShowing = false, shouldAutoFocus: shouldAutoFocus, source: source, onClick: onClick, onAutoFocus: onAutoFocus, onDataLoaded: onDataLoaded })=>{
    const [fetchPolicy] = (0, $42omo.useState)(tryCacheFirst ? 'cache-and-network' : 'network-only');
    const buttonRef = (0, $42omo.useRef)(null);
    const { requests: requests, error: error, hasFullyLoaded: hasFullyLoaded, contentId: contentId } = (0, $6SeRB.useAccessRequests)(fetchPolicy, 'accessRequestsButton');
    const count = requests?.length ?? 0;
    const showButton = count > 0 && !delayShowing && !error;
    (0, $42omo.useEffect)(()=>{
        if (shouldAutoFocus) {
            buttonRef.current?.focus();
            onAutoFocus?.();
        }
    }, [
        shouldAutoFocus,
        onAutoFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasFullyLoaded) onDataLoaded?.(showButton);
    }, [
        hasFullyLoaded,
        onDataLoaded,
        showButton
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (showButton) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'accessRequestsButton',
                source: source,
                attributes: {
                    count: count > 10 ? '10+' : count,
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        showButton,
        createAnalyticsEvent,
        source,
        count,
        contentId
    ]);
    if (!showButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        onClick: onClick,
        ref: buttonRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3a8ae97437224896$var$i18n.buttonTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
        appearance: "important",
        max: 9
    }, count)));
};




















var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");









var $7yOcR = parcelRequire("7yOcR");


var $29DUH = parcelRequire("29DUH");


var $6uGcC = parcelRequire("6uGcC");





var $euL71 = parcelRequire("euL71");










var $1s5hv = parcelRequire("1s5hv");







var $gLeLL = parcelRequire("gLeLL");

const $326b514c08c54cb5$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    inspectPermissions: {
        id: "change-edition.share-and-restrict-dialog.inspect-permissions.upsell-title",
        defaultMessage: "Inspect permissions"
    },
    inspectPermissionsUpsellInfo: {
        id: "change-edition.share-and-restrict-dialog.inspect-permissions.upsell-info",
        defaultMessage: "Upgrade to Premium to troubleshoot how users are being denied access to content."
    },
    learnMoreLink: {
        id: "change-edition.share-and-restrict-dialog.inspect-permissions.learn-more-link",
        defaultMessage: "Learn more"
    }
});
const $326b514c08c54cb5$var$SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
const $326b514c08c54cb5$export$39be326b00ee126f = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
        withGradient: false,
        title: formatMessage($326b514c08c54cb5$export$a7357cdd1f0b0168.inspectPermissions),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($326b514c08c54cb5$export$a7357cdd1f0b0168.inspectPermissionsUpsellInfo)), children),
        learnMoreLink: {
            href: $326b514c08c54cb5$var$SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION,
            ariaLabel: $326b514c08c54cb5$export$a7357cdd1f0b0168.learnMoreLink
        },
        source: "shareAndRestrictDialogUpsell",
        customPadding: "0",
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: "inspectPermissionsUpsellTryNow"
    });
};



var $1NBp8 = parcelRequire("1NBp8");


var $3P1RK = parcelRequire("3P1RK");
















var $biiXa = parcelRequire("biiXa");





var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");







const $eb9501d5dc68d67f$var$i18n = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "share-and-restrict-dialog.feedback-collector.title",
        defaultMessage: "Give feedback"
    },
    feedbackTitleDetails: {
        id: "share-and-restrict-dialog.feedback-collector.title-details",
        defaultMessage: "Overall, how satisfied or dissatisfied are you with your experience sharing and managing access?"
    }
});
const $eb9501d5dc68d67f$var$ENTRYPOINT_ID = '2ecc0711-3ab4-459c-88b9-4c44c9754f0b';
const $eb9501d5dc68d67f$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $eb9501d5dc68d67f$export$db78c6bd0e460769 = ({ contentId: contentId, onClose: onClose, onSubmit: onSubmit })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { displayName: displayName, userId: userId, cloudId: cloudId, edition: edition, environment: environment } = (0, $bQm3c.useSessionData)();
    const getFeedbackMetadata = ()=>{
        const feedbackMetadata = {
            location: window.location.hostname,
            userId: userId,
            cloudId: cloudId,
            contentId: contentId,
            edition: edition,
            source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            environment: environment
        };
        return JSON.stringify(feedbackMetadata, null, 2);
    };
    return (0, $9wGTI.fg)('confluence_modernize_feedback_consolidation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcvq8.GlobalFeedbackCollector), {
        showTypeField: false,
        onClose: onClose,
        onCloseComplete: ()=>{},
        feedbackSource: (0, $lx6jn.FeedbackSource).SHARE_DIALOG,
        additionalFields: {
            source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        onClose: ()=>{
            onClose();
        },
        onSubmit: ()=>{
            onSubmit();
        },
        locale: locale,
        name: displayName || '',
        entrypointId: $eb9501d5dc68d67f$var$ENTRYPOINT_ID,
        atlassianAccountId: userId ?? undefined,
        showTypeField: false,
        feedbackTitle: formatMessage($eb9501d5dc68d67f$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($eb9501d5dc68d67f$var$i18n.feedbackTitleDetails),
        additionalFields: [
            {
                id: $eb9501d5dc68d67f$var$FEEDBACK_CONTEXT_ID,
                value: getFeedbackMetadata()
            }
        ]
    });
};


const $47fba872113fb172$var$i18n = (0, $cgtv4.defineMessages)({
    inspectPermissions: {
        id: "share-and-restrict-dialog.overflow-menu.inspect-permissions",
        defaultMessage: "Inspect permissions"
    },
    learnMore: {
        id: "share-and-restrict-dialog.overflow-menu.learn-more",
        defaultMessage: "Learn more about restrictions"
    },
    manageSpace: {
        id: "share-and-restrict-dialog.overflow-menu.manage-space",
        defaultMessage: "Manage space access"
    },
    moreActions: {
        id: "share-and-restrict-dialog.overflow-menu.more",
        defaultMessage: "More actions"
    },
    giveFeedbackLink: {
        id: "share-and-restrict-dialog.give-feedback-icon",
        defaultMessage: "Give feedback"
    }
});
const $47fba872113fb172$var$wrapperStyles = (0, $ecnYn.xcss)({
    width: '254px'
});
const $47fba872113fb172$export$f62801e1786d0b09 = ({ spaceKey: spaceKey, isSpaceAdmin: isSpaceAdmin, edition: edition, openInspectPermsDialog: openInspectPermsDialog, contentId: contentId })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isFeedbackCollectorOpen, setIsFeedbackCollectorOpen] = (0, $42omo.useState)(false);
    const [displayFeedbackCollectorFlag, setDisplayFeedbackCollectorFlag] = (0, $42omo.useState)(false);
    const showInspectPerms = edition && edition !== (0, $euL71.ConfluenceEdition).FREE && edition !== (0, $euL71.ConfluenceEdition).STANDARD;
    const handleUpsell = (e)=>{
        e.stopPropagation();
    };
    const handleInspectPermsClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'inspectPermissions',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
            }
        }).fire();
        openInspectPermsDialog();
    }, [
        createAnalyticsEvent,
        openInspectPermsDialog
    ]);
    const handleLearnMoreClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'overflowLearnMore',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: intl.formatMessage($47fba872113fb172$var$i18n.moreActions),
                appearance: "subtle",
                ref: triggerRef
            }),
        shouldRenderToParent: true,
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, showInspectPerms ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleInspectPermsClick
    }, intl.formatMessage($47fba872113fb172$var$i18n.inspectPermissions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jhTeh.ReverseTrialLozengeExperiment), {
        edition: (0, $euL71.ConfluenceEdition).PREMIUM,
        touchpointId: "confluence_inspect_permissions_overflow_list_item"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleUpsell
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $47fba872113fb172$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $326b514c08c54cb5$export$39be326b00ee126f), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: !showInspectPerms
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: handleLearnMoreClick,
        href: (0, $4adOe.SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION),
        target: "_blank"
    }, intl.formatMessage($47fba872113fb172$var$i18n.learnMore)), isSpaceAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: (0, $3P1RK.SpacePermissionsTabKey).Users
        }),
        target: "_blank"
    }, intl.formatMessage($47fba872113fb172$var$i18n.manageSpace))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        hasSeparator: !showInspectPerms
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>{
            setIsFeedbackCollectorOpen(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
        label: ""
    }), intl.formatMessage($47fba872113fb172$var$i18n.giveFeedbackLink))))), isFeedbackCollectorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eb9501d5dc68d67f$export$db78c6bd0e460769), {
        contentId: contentId,
        onClose: ()=>{
            setIsFeedbackCollectorOpen(false);
        },
        onSubmit: ()=>setDisplayFeedbackCollectorFlag(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: ()=>setDisplayFeedbackCollectorFlag(false)
    }, displayFeedbackCollectorFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $29DUH.default), null)));
};


const $da53f43c40648bd7$var$titles = (0, $cgtv4.defineMessages)({
    share: {
        id: "share-and-restrict-dialog.header.title.share",
        defaultMessage: "Share"
    },
    publicLink: {
        id: "share-and-restrict-dialog.header.title.public-link",
        defaultMessage: "Public link"
    },
    slack: {
        id: "share-and-restrict-dialog.header.title.slack",
        defaultMessage: "Share to Slack"
    },
    accessRequests: {
        id: "share-and-restrict-dialog.header.title.accessRequests",
        defaultMessage: "Requests"
    },
    specificAccess: {
        id: "share-and-restrict-dialog.header.title.specificAccess",
        defaultMessage: "Specific access"
    }
});
const $da53f43c40648bd7$var$i18n = (0, $cgtv4.defineMessages)({
    close: {
        id: "share-and-restrict-dialog.header.close",
        defaultMessage: "Close"
    },
    back: {
        id: "share-and-restrict-dialog.header.back",
        defaultMessage: "Back"
    }
});
const $da53f43c40648bd7$export$a145f1cf7abdad76 = ({ title: title, overflowMenu: overflowMenu, onCloseClick: onCloseClick, onBackClick: onBackClick, accessRequests: accessRequests })=>{
    const focusRef = (0, $42omo.useRef)(null);
    const [shouldFocusAccessRequestsButton, setShouldFocusAccessRequestsButton] = (0, $42omo.useState)(false);
    const skipCloseButtonFocusWhenAccessRequestsButtonIsPresent = !!accessRequests && (0, $9wGTI.fg)('confluence_frontend_stateful_access_requests');
    const onAccessRequestsButtonDataLoaded = (isVisible)=>{
        if (accessRequests?.lastTriggeredDialogVariant === 'accessRequests') {
            accessRequests.clearElementToFocus();
            if (isVisible) setShouldFocusAccessRequestsButton(true);
            else focusRef.current?.focus();
        }
    };
    /** Determine if we should focus Close button */ (0, $42omo.useEffect)(()=>{
        // When the dialog title changes, it means the content inside has changed.
        // For example, in the public links or Slack dialogs, this could cause focus to be lost.
        // This check helps make sure focus stays where it should.
        if (!skipCloseButtonFocusWhenAccessRequestsButtonIsPresent && focusRef.current && title) focusRef.current.focus();
    }, [
        title,
        skipCloseButtonFocusWhenAccessRequestsButtonIsPresent
    ]);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill",
        alignBlock: "center",
        space: "space.150"
    }, onBackClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
        label: formatMessage($da53f43c40648bd7$var$i18n.back),
        appearance: "subtle",
        onClick: onBackClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $da53f43c40648bd7$var$titles[title]), title === 'publicLink' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jhTeh.ReverseTrialLozengeExperiment), {
        touchpointId: "confluence_public_link_dialog_header",
        edition: (0, $d9tcB.ConfluenceEdition).STANDARD
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050"
    }, accessRequests && (0, $9wGTI.fg)('confluence_frontend_stateful_access_requests') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3a8ae97437224896$export$60de088d75c2b3), {
        /**
       * We want to make sure that while USD is loading for the first time
       * That the button is hidden for a more seamless UX
       */ delayShowing: !!accessRequests.usdLoading,
        /** We want to auto focus if coming back from Access Requests Dialog and the button is visible */ shouldAutoFocus: shouldFocusAccessRequestsButton,
        /** Once we know the button is focused we need to clean-up the USD state that tells us to focus it in the first place */ onAutoFocus: ()=>setShouldFocusAccessRequestsButton(false),
        onClick: accessRequests.openAccessRequestsDialog,
        onDataLoaded: onAccessRequestsButtonDataLoaded,
        tryCacheFirst: !!accessRequests.lastTriggeredDialogVariant,
        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
    }), overflowMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $47fba872113fb172$export$f62801e1786d0b09), overflowMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: focusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        label: formatMessage($da53f43c40648bd7$var$i18n.close),
        onClick: onCloseClick
    }))));
};






















var $iHPbg = parcelRequire("iHPbg");


var $1Zr9M = parcelRequire("1Zr9M");





var $buthI = parcelRequire("buthI");


var $1sB5X = parcelRequire("1sB5X");


var $2WE3u = parcelRequire("2WE3u");


var $1ytiN = parcelRequire("1ytiN");






























const $cebbc05e1e571a1f$var$backgroundStyle = (0, $ecnYn.xcss)({
    borderRadius: 'radius.medium',
    padding: 'space.100',
    background: "var(--ds-background-accent-gray-subtlest, #F0F1F2)"
});
const $cebbc05e1e571a1f$export$aff4fc93593c3bcf = ({ text: text, beforeLabel: beforeLabel = '', afterLabel: afterLabel = '', BeforeIcon: BeforeIcon, AfterIcon: AfterIcon, tooltipMessage: tooltipMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "section",
        xcss: $cebbc05e1e571a1f$var$backgroundStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, BeforeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BeforeIcon, {
        label: beforeLabel,
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, text), AfterIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, tooltipMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipMessage,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...tooltipProps,
            icon: AfterIcon,
            label: afterLabel,
            appearance: "subtle",
            spacing: "compact"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AfterIcon, {
        label: afterLabel,
        size: "medium"
    })))));
};


const $7db82cde69f18808$var$shareDialogI18n = (0, $cgtv4.defineMessages)({
    publishPageWarning: {
        id: "share-and-restrict-dialog.publish-modal-warning.publish-page",
        defaultMessage: "Choose the access settings to apply when publishing this page."
    },
    publishBlogWarning: {
        id: "share-and-restrict-dialog.publish-modal-warning.publish-blog",
        defaultMessage: "Choose the access settings to apply when publishing this blog."
    },
    updatePageWarning: {
        id: "share-and-restrict-dialog.publish-modal-warning.update-page",
        defaultMessage: "Choose the access settings to apply when updating this page."
    },
    updateBlogWarning: {
        id: "share-and-restrict-dialog.publish-modal-warning.update-blog",
        defaultMessage: "Choose the access settings to apply when updating this blog."
    }
});
const $7db82cde69f18808$export$616a2987ad965fee = ({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const shareDialogInfoTextI18n = (()=>{
        if (contentType === 'blogpost') return isUnpublishedDraft ? $7db82cde69f18808$var$shareDialogI18n.publishBlogWarning : $7db82cde69f18808$var$shareDialogI18n.updateBlogWarning;
        else // The PublishModal can only display on pages and blogs, so
        // contentType === 'page'
        return isUnpublishedDraft ? $7db82cde69f18808$var$shareDialogI18n.publishPageWarning : $7db82cde69f18808$var$shareDialogI18n.updatePageWarning;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cebbc05e1e571a1f$export$aff4fc93593c3bcf), {
        text: formatMessage(shareDialogInfoTextI18n),
        beforeLabel: "information",
        BeforeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ)))
    });
};



/* AskToEditBox.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");







var $eSUdr = parcelRequire("eSUdr");










var $8cjip = parcelRequire("8cjip");


var $kevJM = parcelRequire("kevJM");





var $fT2ta = parcelRequire("fT2ta");


var $jMyy4 = parcelRequire("jMyy4");





var $308Wd = parcelRequire("308Wd");


var $7aRa9 = parcelRequire("7aRa9");







/**
 * @generated SignedSource<<56c13c51a61096f44b8831d959468186>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $ba9e2a23f4895c91$export$64ed4f32859160d1 = /*#__PURE__*/ function(AccessType) {
    AccessType["EDIT"] = "EDIT";
    AccessType["VIEW"] = "VIEW";
    return AccessType;
}({});


const $efba58f5e2cd63f0$var$i18n = (0, $cgtv4.defineMessages)({
    noPermissionMessage: {
        id: "share-and-restrict-dialog.ask-to-edit-box.no-permission-message",
        defaultMessage: "You have view-only access to this content."
    },
    noPermissionSpaceRestrictedMessage: {
        id: "share-and-restrict-dialog.ask-to-edit-box.no-permission.space-restricted-message",
        defaultMessage: "You don\u2019t have permission to edit content in this space."
    },
    askToEditButton: {
        id: "share-and-restrict-dialog.ask-to-edit-box.ask-to-edit-button",
        defaultMessage: "Ask to edit"
    },
    requestSentMessage: {
        id: "share-and-restrict-dialog.ask-to-edit-box.request-sent-message",
        defaultMessage: "Edit requested"
    },
    requestErrorMessage: {
        id: "share-and-restrict-dialog.ask-to-edit-box.request-error-message",
        defaultMessage: "We ran into a problem sending the request."
    }
});
const $efba58f5e2cd63f0$var$PendingRequestExistsQuery = (0, $eSUdr.default)`query AskToEditBoxPendingRequestExistsQuery($accessRequestedAaid:String!$cloudId:ID!$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid cloudId:$cloudId contentId:$contentId){isPendingAccessRequestExists}}`;
const $efba58f5e2cd63f0$var$RequestPageAccessMutation = (0, $eSUdr.default)`mutation AskToEditBoxRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}`;
const $efba58f5e2cd63f0$var$styles = {
    container: "_2rko12b0 _1yt4utpp _vchhusvi _bfhkhfxm _1tkeckbl _1bsb1osq _19bvu2gc _1e0c1txw _4cvr1h6o",
    buttonContainer: "_16jlidpf _1o9zidpf _i0dl1wug _18u0pxbi",
    iconContainer: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $efba58f5e2cd63f0$var$IconContainer = ({ children: children })=>/*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $efba58f5e2cd63f0$var$styles.iconContainer
        ])
    }, children);
const $efba58f5e2cd63f0$export$aebee76b9109e864 = ({ onClick: onClick, editRequested: editRequested, isLoading: isLoading, hasError: hasError, isLoadingForFirstTime: isLoadingForFirstTime, isRestrictedBySpace: isRestrictedBySpace, intl: intl })=>{
    const editRestrictionCopy = isRestrictedBySpace ? $efba58f5e2cd63f0$var$i18n.noPermissionSpaceRestrictedMessage : $efba58f5e2cd63f0$var$i18n.noPermissionMessage;
    const shouldShowEditRequestedText = editRequested && !isLoading && !hasError;
    const shouldShowEditRequestedButton = !editRequested && !isLoadingForFirstTime && !hasError;
    const [animateFromRight, setAnimateFromRight] = (0, $42omo.useState)(false);
    const handleClick = ()=>{
        setAnimateFromRight(true);
        onClick();
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $efba58f5e2cd63f0$var$styles.container
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        grow: "fill"
    }, /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ $42omo.createElement($efba58f5e2cd63f0$var$IconContainer, null, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        LEGACY_size: "xlarge"
    })), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
        maxLines: 6
    }, intl.formatMessage(editRestrictionCopy))), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $efba58f5e2cd63f0$var$styles.buttonContainer
        ])
    }, shouldShowEditRequestedText && /*#__PURE__*/ $42omo.createElement((0, $fT2ta.default), {
        entranceDirection: animateFromRight ? 'right' : undefined,
        distance: "proportional"
    }, ({ ...props })=>/*#__PURE__*/ $42omo.createElement("div", props, /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.050",
            grow: "hug"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)",
            size: "small"
        }), /*#__PURE__*/ $42omo.createElement((0, $5dK2X.default), {
            maxLines: 4,
            color: "color.text.subtlest",
            weight: "medium"
        }, intl.formatMessage($efba58f5e2cd63f0$var$i18n.requestSentMessage))))), shouldShowEditRequestedButton && /*#__PURE__*/ $42omo.createElement((0, $fT2ta.default), {
        duration: "large"
    }, ({ ...props })=>/*#__PURE__*/ $42omo.createElement("div", props, /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
            spacing: "compact",
            onClick: handleClick,
            isLoading: isLoading
        }, intl.formatMessage($efba58f5e2cd63f0$var$i18n.askToEditButton)))))));
};
const $efba58f5e2cd63f0$var$AskToEditBoxWithFlags = ({ contentId: contentId, stagedGeneralAccessLevel: stagedGeneralAccessLevel, flags: flags })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [hasUpdateError, setUpdateHasError] = (0, $42omo.useState)(false);
    const [isSubmitRequestLoading, setIsSubmitRequestLoading] = (0, $42omo.useState)(false);
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $42omo.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isRestrictedBySpace = stagedGeneralAccessLevel === 'open-can-edit';
    const intl = (0, $8C5kA.default)();
    const { data: data, loading: queryLoading, error: queryError, refetch: refetch } = (0, $jMyy4.useQueryInterop)(/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ $efba58f5e2cd63f0$var$PendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        }
    });
    const editRequested = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    const [submitAccessRequestMutation] = (0, $308Wd.useMutationInterop)($efba58f5e2cd63f0$var$RequestPageAccessMutation);
    const readyToFireShownEvent = !!data && !queryLoading && !queryError && isLoadingForFirstTime;
    (0, $42omo.useEffect)(()=>{
        if (readyToFireShownEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'infoMessage',
                actionSubjectId: 'askToEdit',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                attributes: {
                    accessType: 'edit',
                    contentId: contentId,
                    contentType: contentType,
                    isRestrictedBySpace: isRestrictedBySpace,
                    editRequested: editRequested
                }
            }
        }).fire();
    }, [
        contentId,
        contentType,
        isRestrictedBySpace,
        editRequested,
        readyToFireShownEvent,
        createAnalyticsEvent
    ]);
    const onRequestEditAccessClick = (0, $42omo.useCallback)(async ()=>{
        setIsSubmitRequestLoading(true);
        try {
            // This is fired before the mutation to preserve the pattern from the RestrictedPage and other components
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'requestAccessButton',
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    attributes: {
                        accessType: 'edit',
                        contentId: contentId,
                        contentType: contentType,
                        editDeniedButCanView: true
                    }
                }
            }).fire();
            await submitAccessRequestMutation({
                variables: {
                    requestPageAccessInput: {
                        accessType: (0, $ba9e2a23f4895c91$export$64ed4f32859160d1).EDIT,
                        pageId: contentId
                    }
                }
            });
            await refetch();
        } catch (e) {
            setUpdateHasError(true);
            flags.showErrorFlag({
                id: 'share-and-restrict-dialog.ask-to-edit-box.submit-request.error',
                title: intl.formatMessage($efba58f5e2cd63f0$var$i18n.requestErrorMessage)
            });
        }
        setIsSubmitRequestLoading(false);
    }, [
        submitAccessRequestMutation,
        contentId,
        contentType,
        refetch,
        flags,
        createAnalyticsEvent,
        intl
    ]);
    return /*#__PURE__*/ $42omo.createElement($efba58f5e2cd63f0$export$aebee76b9109e864, {
        editRequested: editRequested,
        onClick: onRequestEditAccessClick,
        isLoading: isSubmitRequestLoading || queryLoading,
        hasError: hasUpdateError || !!queryError,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isRestrictedBySpace: isRestrictedBySpace,
        intl: intl
    });
};
const $efba58f5e2cd63f0$export$134d1cc8ff93c353 = (0, $7aRa9.withFlags)($efba58f5e2cd63f0$var$AskToEditBoxWithFlags);


const $ea83762a0c4c9a10$var$smartLinkWarningI18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "share-and-restrict-dialog.info-message.smart-links-warning.title",
        defaultMessage: "Additional restrictions can\u2019t be set for smart links"
    },
    message: {
        id: "share-and-restrict-dialog.info-message.smart-links-warning.message",
        defaultMessage: "Anyone with access to this item in Confluence can view it, but permissions on the link may affect who can engage with the content."
    },
    action: {
        id: "share-and-restrict-dialog.info-message.smart-links-warning.action",
        defaultMessage: "How do permissions work for Smart Links in the content tree"
    }
});
const $ea83762a0c4c9a10$var$uneditableRestrictionsI18n = (0, $cgtv4.defineMessages)({
    message: {
        id: "share-and-restrict-dialog.info-message.uneditable-restrictions.message",
        defaultMessage: "You don\u2019t have permission to change access to this content."
    }
});
const $ea83762a0c4c9a10$var$draftI18n = (0, $cgtv4.defineMessages)({
    message: {
        id: "share-and-restrict-dialog.info-message.draft.message",
        defaultMessage: "Only people with the link can view and edit drafts."
    },
    beforeLabel: {
        id: "share-and-restrict-dialog.info-message.draft.before-label",
        defaultMessage: "Draft info message"
    },
    afterLabel: {
        id: "share-and-restrict-dialog.info-message.draft.after-label",
        defaultMessage: "More info tooltip"
    },
    tooltipMessage: {
        id: "share-and-restrict-dialog.info-message.draft.tooltip-message",
        defaultMessage: "Only the draft\u2019s creator has access to their draft until they share the link with someone else."
    }
});
const $ea83762a0c4c9a10$var$publicLinkUpsellI18n = (0, $cgtv4.defineMessages)({
    iconLabel: {
        id: "share-and-restrict-dialog.info-message.public-link-free-upsell.icon-label",
        defaultMessage: "Public link"
    }
});
const $ea83762a0c4c9a10$var$freeUpsellBanner = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.raised'
});
const $ea83762a0c4c9a10$var$upsellContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.150'
});
const $ea83762a0c4c9a10$var$SMART_LINKS_LEARN_MORE_LINK = 'https://support.atlassian.com/confluence-cloud/docs/bring-all-your-work-into-confluence/#Restrictions-and-Smart-Links-in-the-content-tree';
const $ea83762a0c4c9a10$export$4bf8682ab34d3383 = ({ messageType: messageType, publishModalInfoBoxProps: publishModalInfoBoxProps, askToEditBoxProps: askToEditBoxProps })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const renderMessage = ()=>{
        switch(messageType){
            case 'freeEditionPublicLinkUpsell':
            case 'freeTrialPublicLinkUpsell':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    space: "space.100",
                    xcss: [
                        $ea83762a0c4c9a10$var$freeUpsellBanner,
                        $ea83762a0c4c9a10$var$upsellContainerStyles
                    ]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                    label: formatMessage($ea83762a0c4c9a10$var$publicLinkUpsellI18n.iconLabel),
                    spacing: "spacious"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1sB5X.PublicLinksUpsell), {
                    isSiteAdmin: isSiteAdmin,
                    upsellSource: "share-and-restrict-dialog"
                }));
            case 'freeEditionUpsell':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $ea83762a0c4c9a10$var$freeUpsellBanner
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2WE3u.ChangeEditionSectionMessageShareAndRestrict), null));
            case 'smartLink':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
                    appearance: "warning",
                    title: formatMessage($ea83762a0c4c9a10$var$smartLinkWarningI18n.title),
                    actions: [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iHPbg.default), {
                            key: "action1",
                            onClick: ()=>{
                                window.open($ea83762a0c4c9a10$var$SMART_LINKS_LEARN_MORE_LINK, '_blank');
                            }
                        }, formatMessage($ea83762a0c4c9a10$var$smartLinkWarningI18n.action))
                    ]
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea83762a0c4c9a10$var$smartLinkWarningI18n.message));
            case 'uneditableRestrictions':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
                    appearance: "information"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ea83762a0c4c9a10$var$uneditableRestrictionsI18n.message));
            case 'publishModal':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, publishModalInfoBoxProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7db82cde69f18808$export$616a2987ad965fee), publishModalInfoBoxProps));
            case 'draft':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cebbc05e1e571a1f$export$aff4fc93593c3bcf), {
                    text: formatMessage($ea83762a0c4c9a10$var$draftI18n.message),
                    beforeLabel: formatMessage($ea83762a0c4c9a10$var$draftI18n.beforeLabel),
                    BeforeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))),
                    afterLabel: formatMessage($ea83762a0c4c9a10$var$draftI18n.afterLabel),
                    AfterIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
                    tooltipMessage: formatMessage($ea83762a0c4c9a10$var$draftI18n.tooltipMessage)
                });
            case 'askToEdit':
                return askToEditBoxProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $efba58f5e2cd63f0$export$134d1cc8ff93c353), askToEditBoxProps) : null;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, messageType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "info-message-test-id"
    }, renderMessage()));
};








































var $6R5uz = parcelRequire("6R5uz");


var $2Pg7f = parcelRequire("2Pg7f");


var $lebfc = parcelRequire("lebfc");


var $lE8sM = parcelRequire("lE8sM");


var $4c48T = parcelRequire("4c48T");


var $Rk8D3 = parcelRequire("Rk8D3");



























var $8oEoE = parcelRequire("8oEoE");

const $8ca6142689641094$var$restrictedI18n = (0, $cgtv4.defineMessages)({
    twoUsers: {
        id: "share-and-restrict-dialog.facepileRow.restricted.two-users",
        defaultMessage: "<b>{name1}</b> and <b>{name2}</b>"
    },
    multipleUsers: {
        id: "share-and-restrict-dialog.facepileRow.restricted.multiple-users",
        defaultMessage: "<b>{name1}, {name2},</b> and <b>{count} {count, plural, one {other} other {others}}</b>"
    },
    youAndOneOther: {
        id: "share-and-restrict-dialog.facepileRow.restricted.you-and-one-other",
        defaultMessage: "<b>You</b> and <b>{name}</b>"
    },
    youAndMultipleOthers: {
        id: "share-and-restrict-dialog.facepileRow.restricted.you-and-multiple-others",
        defaultMessage: "<b>You, {name},</b> and <b>{count} {count, plural, one {other} other {others}}</b>"
    },
    deletedGroups: {
        id: "share-and-restrict-dialog.facepileRow.restricted.deleted-groups",
        defaultMessage: "This group was deleted"
    }
});
const $8ca6142689641094$var$openCanViewI18n = (0, $cgtv4.defineMessages)({
    twoUsers: {
        id: "share-and-restrict-dialog.facepileRow.open-can-view.two-users",
        defaultMessage: "<b>{name1}</b> and <b>{name2}</b> can edit"
    },
    multipleUsers: {
        id: "share-and-restrict-dialog.facepileRow.open-can-view.multiple-users",
        defaultMessage: "<b>{name1}, {name2},</b> and <b>{count} {count, plural, one {other} other {others}}</b> can edit"
    },
    youAndOneOther: {
        id: "share-and-restrict-dialog.facepileRow.open-can-view.you-and-one-other",
        defaultMessage: "<b>You</b> and <b>{name}</b> can edit"
    },
    youAndMultipleOthers: {
        id: "share-and-restrict-dialog.facepileRow.open-can-view.you-and-multiple-others",
        defaultMessage: "<b>You, {name},</b> and <b>{count} {count, plural, one {other} other {others}}</b> can edit"
    }
});
const $8ca6142689641094$var$expandI18n = (0, $cgtv4.defineMessages)({
    expand: {
        id: "share-and-restrict-dialog.facepileRow.icon.expand",
        defaultMessage: "View specific access"
    },
    collapse: {
        id: "share-and-restrict-dialog.facepileRow.icon.collapse",
        defaultMessage: "Collapse"
    },
    facepileExpand: {
        id: "share-and-restrict-dialog.facepileRow.expand",
        defaultMessage: "View specific access details"
    },
    facepileCollapse: {
        id: "share-and-restrict-dialog.facepileRow.collapse",
        defaultMessage: "Collapse specific access details"
    }
});
const $8ca6142689641094$var$groupNameI18n = (0, $cgtv4.defineMessages)({
    group: {
        id: "share-and-restrict-dialog.facepileRow.group-name",
        defaultMessage: "{count} {count, plural, one {group} other {groups}}"
    }
});
const $8ca6142689641094$var$teamNameI18n = (0, $cgtv4.defineMessages)({
    team: {
        id: "share-and-restrict-dialog.facepileRow.team-name",
        defaultMessage: "{count} {count, plural, one {team} other {teams}}"
    }
});
const $8ca6142689641094$var$inlineStyle = (0, $ecnYn.xcss)({
    paddingBlock: 'space.100',
    paddingInline: 'space.100',
    ':hover': {
        background: "var(--ds-surface-hovered, #F0F1F2)"
    },
    borderRadius: 'radius.small'
});
const $8ca6142689641094$var$chevronStyles = (0, $ecnYn.xcss)({
    transform: 'rotate(0deg)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    transition: `all ${(0, $4c48T.durations).small}ms linear`
});
const $8ca6142689641094$var$expandedStyles = (0, $ecnYn.xcss)({
    transform: 'rotate(90deg)'
});
const $8ca6142689641094$var$expandBackgroundStyle = (0, $ecnYn.xcss)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'radius.small',
    paddingBlock: 'space.100',
    paddingInline: 'space.100',
    background: 'none',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $8ca6142689641094$var$bleedStyles = (0, $ecnYn.xcss)({
    width: 'fill-available',
    paddingInlineEnd: 'space.050',
    height: '56px',
    paddingBlock: 'space.025'
});
const $8ca6142689641094$var$pressableStyles = (0, $ecnYn.xcss)({
    padding: 'space.0',
    width: 'fill-available',
    background: 'none'
});
const $8ca6142689641094$var$iconBorderContainer = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    width: '36px',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 'space.0',
    position: 'relative',
    transition: 'transform 200ms',
    // This zIndex is needed to ensure the Group icon overlaps properly with the surrounding Avatars
    // @ts-ignore style-maps.partial.tsx(1146, 2): The expected type comes from property 'zIndex' which is declared here on type 'SafeCSSObject'
    zIndex: 3,
    ':active': {
        transform: 'scale(0.9)'
    },
    backgroundColor: 'elevation.surface.overlay'
});
const $8ca6142689641094$var$teamIconBorderContainer = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    width: '36px',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 'space.0',
    position: 'relative',
    transition: 'transform 200ms',
    // This zIndex is needed to ensure the Group icon overlaps properly with the surrounding Avatars
    // @ts-ignore style-maps.partial.tsx(1146, 2): The expected type comes from property 'zIndex' which is declared here on type 'SafeCSSObject'
    zIndex: 4,
    ':active': {
        transform: 'scale(0.9)'
    },
    backgroundColor: 'elevation.surface.overlay'
});
const $8ca6142689641094$var$iconContainer = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 'space.0',
    position: 'relative',
    '::after': {
        content: '""',
        backgroundColor: 'color.background.neutral.subtle',
        inset: '0px',
        /* Added border-radius style to fix hover issue in safari */ borderRadius: 'radius.full',
        opacity: 0,
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'opacity 200ms',
        width: '100%'
    },
    ':hover': {
        // Need this to show the darkened overlay on hover
        // @ts-ignore Object literal may only specify known properties, and ''::after'' does not exist in type 'Omit<SafeCSSObject, Pseudos | AllMedia>'.
        '::after': {
            backgroundColor: 'color.background.inverse.subtle',
            opacity: 1
        }
    }
});
const $8ca6142689641094$var$AVATAR_KEYS = {
    TEAM: 'teamAvatar',
    GROUP: 'groupAvatar'
};
const $8ca6142689641094$var$AVATAR_TYPES = {
    USER: 'user',
    GROUP: 'group',
    TEAM: 'team'
};
const $8ca6142689641094$var$noop = ()=>{};
const $8ca6142689641094$var$calculateRemainingCount = (avatarGroupData, groupCount)=>{
    const [, second, ...rest] = avatarGroupData;
    const nonGroups = rest.filter((avatar)=>avatar.type !== $8ca6142689641094$var$AVATAR_TYPES.GROUP);
    let baseCount = // when the fg is off we want to make sure we treat group and teams as one
    !(0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') && second?.type === $8ca6142689641094$var$AVATAR_TYPES.TEAM ? nonGroups.length : rest.length; // If second avatar is a team and we have groups, we need to add the group count
    // since the team avatar represents all teams but groups are counted separately
    if (second?.type === $8ca6142689641094$var$AVATAR_TYPES.TEAM && groupCount > 0 && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) baseCount += groupCount;
     // If we have both team and group avatars in the list, we need to subtract 1
    // to avoid double counting since one of them is already represented in the avatar
    const hasGroupAvatar = avatarGroupData.some((avatar)=>avatar.type === $8ca6142689641094$var$AVATAR_TYPES.GROUP);
    if (hasGroupAvatar && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) // We have group avatars, so we need to account for the fact that
    // one group is represented in the avatarGroupData and shouldn't be double counted
    {
        if (second?.type === $8ca6142689641094$var$AVATAR_TYPES.TEAM) // Group avatar is shown, so subtract 1 from group count that's added to teams
        baseCount = baseCount - 1;
    }
    return Math.max(0, baseCount);
};
const $8ca6142689641094$var$getGroupOrTeamDisplayName = (usageType, teamCount, groupCount, formatMessage)=>{
    if (usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) return formatMessage($8ca6142689641094$var$teamNameI18n.team, {
        count: teamCount
    });
    else if (usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION) return formatMessage($8ca6142689641094$var$groupNameI18n.group, {
        count: groupCount + teamCount
    });
    return formatMessage($8ca6142689641094$var$groupNameI18n.group, {
        count: groupCount
    });
};
const $8ca6142689641094$var$TeamAvatarIcon = ({ teamCount: teamCount, formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($8ca6142689641094$var$teamNameI18n.team, {
            count: teamCount
        }),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...tooltipProps,
            xcss: $8ca6142689641094$var$teamIconBorderContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8ca6142689641094$var$iconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
            label: formatMessage($8ca6142689641094$var$teamNameI18n.team, {
                count: teamCount
            }),
            size: "32",
            appearance: "gray",
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc)))
        }))));
const $8ca6142689641094$var$GroupAvatarIcon = ({ groupCount: groupCount, teamCount: teamCount, formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($8ca6142689641094$var$groupNameI18n.group, {
            count: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? groupCount : groupCount + teamCount
        }),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...tooltipProps,
            xcss: teamCount ? $8ca6142689641094$var$iconBorderContainer : $8ca6142689641094$var$teamIconBorderContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8ca6142689641094$var$iconContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
            label: formatMessage($8ca6142689641094$var$groupNameI18n.group, {
                count: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? groupCount : groupCount + teamCount
            }),
            size: "32",
            appearance: "gray",
            shape: "circle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc)))
        }))));
const $8ca6142689641094$var$createAvatarRenderers = (teamCount, groupCount, formatMessage)=>({
        [$8ca6142689641094$var$AVATAR_TYPES.TEAM]: (props, Component)=>{
            if (props.src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: formatMessage($8ca6142689641094$var$teamNameI18n.team, {
                    count: teamCount
                }),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $8ca6142689641094$var$teamIconBorderContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ca6142689641094$var$TeamAvatarIcon, {
                teamCount: teamCount,
                formatMessage: formatMessage
            });
        },
        [$8ca6142689641094$var$AVATAR_TYPES.GROUP]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ca6142689641094$var$GroupAvatarIcon, {
                groupCount: groupCount,
                teamCount: teamCount,
                formatMessage: formatMessage
            }),
        [$8ca6142689641094$var$AVATAR_TYPES.USER]: (props, Component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)
    });
const $8ca6142689641094$export$22cdf4ad96843c3e = ({ avatarGroupData: avatarGroupData, isExpanded: isExpanded, onExpandClick: onExpandClick, onOpenSpecificAccessDialog: onOpenSpecificAccessDialog, generalAccessLevel: generalAccessLevel, groupCount: groupCount, teamCount: teamCount, currentUserHasAccess: currentUserHasAccess, analyticsAttributes: analyticsAttributes })=>{
    const [rowHovered, setRowHovered] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleExpandClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: 'button',
                actionSubjectId: 'facepileRow',
                action: 'clicked',
                attributes: {
                    ...analyticsAttributes,
                    generalAccessLevel: generalAccessLevel,
                    newState: isExpanded ? 'collapsed' : 'expanded'
                }
            }
        }).fire();
        onExpandClick();
    }, [
        createAnalyticsEvent,
        analyticsAttributes,
        generalAccessLevel,
        isExpanded,
        onExpandClick
    ]);
    const handleOpenSpecificAccessDialog = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: 'button',
                actionSubjectId: 'facepileRow',
                action: 'clicked',
                attributes: {
                    ...analyticsAttributes,
                    generalAccessLevel: generalAccessLevel,
                    newState: 'openSpecificAccessDialog'
                }
            }
        }).fire();
        onOpenSpecificAccessDialog();
    }, [
        createAnalyticsEvent,
        analyticsAttributes,
        generalAccessLevel,
        onOpenSpecificAccessDialog
    ]);
    const hasGroup = avatarGroupData.some((a)=>a.type === $8ca6142689641094$var$AVATAR_TYPES.GROUP);
    const hasTeam = avatarGroupData.some((a)=>a.type === $8ca6142689641094$var$AVATAR_TYPES.TEAM);
    const getFacepileDescription = ()=>{
        const [first, second] = avatarGroupData; // Handle single avatar edge case for groups/teams only
        if (avatarGroupData.length === 1) {
            if (first.type === $8ca6142689641094$var$AVATAR_TYPES.GROUP) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, $8ca6142689641094$var$getGroupOrTeamDisplayName(first.usageType, teamCount, groupCount, formatMessage));
            if (first.type === $8ca6142689641094$var$AVATAR_TYPES.TEAM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, $8ca6142689641094$var$getGroupOrTeamDisplayName(first.usageType, teamCount, groupCount, formatMessage));
        }
        const firstName = first.name.split(' ')[0];
        let secondName = '';
        if (second) secondName = second.type === $8ca6142689641094$var$AVATAR_TYPES.USER ? second.name.split(' ')[0] : $8ca6142689641094$var$getGroupOrTeamDisplayName(second.usageType, teamCount, groupCount, formatMessage);
        const remainingCount = $8ca6142689641094$var$calculateRemainingCount(avatarGroupData, groupCount);
        if (generalAccessLevel === 'restricted') {
            if (!(0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') && avatarGroupData.length === 3 && hasGroup && hasTeam || avatarGroupData.length === 2) {
                if (currentUserHasAccess) return formatMessage($8ca6142689641094$var$restrictedI18n.youAndOneOther, {
                    name: secondName,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
                else return formatMessage($8ca6142689641094$var$restrictedI18n.twoUsers, {
                    name1: firstName,
                    name2: secondName,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
            } else if (avatarGroupData.length > 2) {
                if (currentUserHasAccess) return formatMessage($8ca6142689641094$var$restrictedI18n.youAndMultipleOthers, {
                    name: secondName,
                    count: remainingCount,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
                else return formatMessage($8ca6142689641094$var$restrictedI18n.multipleUsers, {
                    name1: firstName,
                    name2: secondName,
                    count: remainingCount,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
            }
        } else {
            if (!(0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') && avatarGroupData.length === 3 && hasGroup && hasTeam || avatarGroupData.length === 2) {
                if (currentUserHasAccess) return formatMessage($8ca6142689641094$var$openCanViewI18n.youAndOneOther, {
                    name: secondName,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
                else return formatMessage($8ca6142689641094$var$openCanViewI18n.twoUsers, {
                    name1: firstName,
                    name2: secondName,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
            } else if (avatarGroupData.length > 2) {
                if (currentUserHasAccess) return formatMessage($8ca6142689641094$var$openCanViewI18n.youAndMultipleOthers, {
                    name: secondName,
                    count: remainingCount,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
                else return formatMessage($8ca6142689641094$var$openCanViewI18n.multipleUsers, {
                    name1: firstName,
                    name2: secondName,
                    count: remainingCount,
                    b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                            weight: "bold"
                        }, chunk)
                });
            }
        }
    };
    const expandMessage = formatMessage(isExpanded ? $8ca6142689641094$var$expandI18n.collapse : $8ca6142689641094$var$expandI18n.expand);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $Rk8D3.default), {
        inline: "space.100",
        xcss: $8ca6142689641094$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? handleOpenSpecificAccessDialog : handleExpandClick,
        onMouseEnter: ()=>setRowHovered(true),
        onMouseLeave: ()=>setRowHovered(false),
        xcss: $8ca6142689641094$var$pressableStyles,
        "aria-label": isExpanded ? formatMessage($8ca6142689641094$var$expandI18n.facepileCollapse) : formatMessage($8ca6142689641094$var$expandI18n.facepileExpand)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $8ca6142689641094$var$inlineStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: avatarGroupData,
        onMoreClick: $8ca6142689641094$var$noop,
        onAvatarClick: $8ca6142689641094$var$noop,
        overrides: {
            Avatar: {
                render: (Component, props)=>{
                    const avatarRenderers = $8ca6142689641094$var$createAvatarRenderers(teamCount, groupCount, formatMessage); // Check if this is a team avatar
                    if (props.key === $8ca6142689641094$var$AVATAR_KEYS.TEAM && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) return avatarRenderers[$8ca6142689641094$var$AVATAR_TYPES.TEAM](props, Component);
                     // Check if this is a team avatar, if FG is off we need to treat teams as groups
                    if (!(0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') && props.key === $8ca6142689641094$var$AVATAR_KEYS.TEAM && !hasGroup) return avatarRenderers[$8ca6142689641094$var$AVATAR_TYPES.GROUP]();
                     // Check if this is a group avatar
                    if (props.key === $8ca6142689641094$var$AVATAR_KEYS.GROUP) return avatarRenderers[$8ca6142689641094$var$AVATAR_TYPES.GROUP]();
                     // Check for user avatar as long as it not a team
                    if (props.key !== $8ca6142689641094$var$AVATAR_KEYS.TEAM) return avatarRenderers[$8ca6142689641094$var$AVATAR_TYPES.USER](props, Component);
                     // if we get to this point it means that Teams feature flag is OFF
                // and both groups and teams exist in avatarGroupData.
                // In that case, teams are treated as groups, so only
                // a single "group" avatar should be rendered.
                }
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, getFacepileDescription())), rowHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: expandMessage
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...tooltipProps,
            "aria-expanded": isExpanded,
            xcss: $8ca6142689641094$var$expandBackgroundStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: [
                $8ca6142689641094$var$chevronStyles,
                isExpanded && $8ca6142689641094$var$expandedStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: expandMessage,
            size: "small"
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null))));
};


const $2aea7ba57d44e731$var$i18n = (0, $cgtv4.defineMessages)({
    specificAccess: {
        id: "share-and-restrict-dialog.specific-access.heading",
        defaultMessage: "Specific access"
    },
    removeAll: {
        id: "share-and-restrict-dialog.remove-all.button",
        defaultMessage: "Remove all"
    }
});
const $2aea7ba57d44e731$var$expandedFacepileStyle = (0, $ecnYn.xcss)({
    // This padding is necessary to make the dialog look just right, and there's no token for 10px
    // @ts-ignore style-maps.partial.tsx(1111, 2): The expected type comes from property 'marginBlockEnd' which is declared here on type 'SafeCSSObject'
    marginBlockEnd: '-10px'
});
const $2aea7ba57d44e731$var$singlePrincipalStyle = (0, $ecnYn.xcss)({
    marginBlockEnd: 'space.negative.025'
});
const $2aea7ba57d44e731$var$removeAllButtonStyle = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    textDecorationLine: 'underline',
    font: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    backgroundColor: 'color.background.neutral.subtle',
    paddingBlockStart: 'space.025'
});
const $2aea7ba57d44e731$var$removeAllButtonContainer = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $2aea7ba57d44e731$var$spotLightContainer = (0, $ecnYn.xcss)({
    padding: 'space.075'
});
const $2aea7ba57d44e731$var$headingContainer = (0, $ecnYn.xcss)({
    marginInlineStart: 'space.negative.075'
});
const $2aea7ba57d44e731$export$c56a1fcd1bc08bc3 = ({ facepileRow: facepileRow, isExpanded: isExpanded, onRemoveAllClick: onRemoveAllClick, edition: edition })=>{
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.050",
        alignInline: "start",
        xcss: facepileRow && isExpanded && $2aea7ba57d44e731$var$expandedFacepileStyle || !facepileRow && $2aea7ba57d44e731$var$singlePrincipalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.0",
        alignBlock: "center",
        xcss: $2aea7ba57d44e731$var$headingContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "specificAccess"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2aea7ba57d44e731$var$spotLightContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $2aea7ba57d44e731$var$i18n.specificAccess)))), onRemoveAllClick && !isFreeEdition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $2aea7ba57d44e731$var$removeAllButtonContainer,
        alignBlock: "start"
    }, "\u2022", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: $2aea7ba57d44e731$var$removeAllButtonStyle,
        onClick: ()=>onRemoveAllClick()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $2aea7ba57d44e731$var$i18n.removeAll)))), facepileRow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100",
        alignInline: "start",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8ca6142689641094$export$22cdf4ad96843c3e), facepileRow)));
};


const $f315c2057873a691$var$psaAdjustments = (0, $ecnYn.xcss)({
    marginBottom: 'space.200'
});
const $f315c2057873a691$export$8b251419efc915eb = ({ titleAndButtons: titleAndButtons, generalAccess: generalAccess, specificAccess: specificAccess, principalsStager: principalsStager, infoMessage: infoMessage, hasNavigationLockout: hasNavigationLockout, onSuggestedUserClick: onSuggestedUserClick, ctaNotifyMessageFooter: ctaNotifyMessageFooter, specificAccessFilter: specificAccessFilter, tabSelection: tabSelection })=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const inTrialFeatureGatesAnalyticsCallback = (0, $42omo.useCallback)((params)=>{
        createAnalyticsEvent((0, $bcPlG.formatEventCallBackPayloadForAtlasKitAnalyticsEvent)(params)).fire();
    }, [
        createAnalyticsEvent
    ]);
    // AB hooks for in trial feature gates experiment - https://hello.atlassian.net/wiki/spaces/Land/pages/4343595130/Project+poster+Confluence+Feature+Gate+Add+Payment+Prompts
    const { canRenderTreatment: canRenderTreatment } = (0, $1vRwc.useInTrialFeatureGatesExperimentEnrollmentAB)({
        featureId: (0, $dzImV.FEATURE_ID_USD_MODAL),
        tenantId: cloudId,
        sendOperationalEvent: inTrialFeatureGatesAnalyticsCallback,
        sendTrackEvent: inTrialFeatureGatesAnalyticsCallback,
        skip: edition === (0, $d9tcB.ConfluenceEdition).FREE,
        extraAnalyticsAttributes: {
            edition: edition?.toLowerCase()
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        grow: "fill",
        space: (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? 'space.0' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: ctaNotifyMessageFooter && $f315c2057873a691$var$psaAdjustments
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $da53f43c40648bd7$export$a145f1cf7abdad76), titleAndButtons)), principalsStager && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b17f567cc82483a4$export$7e8d7ac501edf4f1), {
        ...principalsStager,
        onSuggestedUserClick: onSuggestedUserClick
    }), tabSelection && 'TabSelection', specificAccessFilter && 'SpecificAccessFilter', infoMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea83762a0c4c9a10$export$4bf8682ab34d3383), infoMessage), canRenderTreatment && edition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lisqg.InTrialFeatureGatesBannerWithData), {
        featureId: (0, $dzImV.FEATURE_ID_USD_MODAL),
        edition: edition.toLowerCase(),
        tenantId: cloudId,
        sendOperationalEvent: inTrialFeatureGatesAnalyticsCallback,
        sendTrackEvent: inTrialFeatureGatesAnalyticsCallback,
        sendScreenEvent: inTrialFeatureGatesAnalyticsCallback
    }), ctaNotifyMessageFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06f4c3e4444a6796$export$c26ce0b7496e870c), ctaNotifyMessageFooter), generalAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $757afac272ae6225$export$7e5386ee40f452c8), {
        ...generalAccess,
        showBottomPadding: !Boolean(specificAccess)
    }), specificAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2aea7ba57d44e731$export$c56a1fcd1bc08bc3), specificAccess), hasNavigationLockout && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZJmt.NavigationLockout), null));
};





















var $g9Srd = parcelRequire("g9Srd");



var $bl9WW = parcelRequire("bl9WW");




































const $fd22378577ecedbf$var$i18n = (0, $cgtv4.defineMessages)({
    deletedGroup: {
        id: "share-and-restrict-dialog.makeBodyProps.avatarGroupData.deletedGroup",
        defaultMessage: "This group was deleted"
    },
    deletedGroupOrTeam: {
        id: "share-and-restrict-dialog.makeBodyProps.avatarGroupData.deletedGroupOrTeam",
        defaultMessage: "This group or team was deleted"
    }
});
const $fd22378577ecedbf$var$principalDetailsStyle = (0, $ecnYn.xcss)({
    overflowWrap: 'anywhere'
});
const $fd22378577ecedbf$export$4419ae9c4a1dae0f = ({})=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        label: "",
        size: "32",
        appearance: "gray",
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $fd22378577ecedbf$var$principalDetailsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $fd22378577ecedbf$var$i18n.deletedGroupOrTeam : $fd22378577ecedbf$var$i18n.deletedGroup))))));
};


/**
 * @graphql cc
 */ 











var $j1Ss3 = parcelRequire("j1Ss3");


var $esRft = parcelRequire("esRft");
















var $gvWVt = parcelRequire("gvWVt");





var $7Sm4c = parcelRequire("7Sm4c");


var $1fjr9 = parcelRequire("1fjr9");

/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $62722b210ecd00f7$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
















const $2094308d224d2d63$export$db446949e45d1358 = ({ warningMessage: warningMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)",
        spacing: "spacious",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, warningMessage));
};










const $de1af71286cd6242$var$i18n = (0, $cgtv4.defineMessages)({
    draftAccessWarningMessage: {
        id: "share-and-restrict-dialog.principal-details-warning.draft-access-warning",
        defaultMessage: "Needs \u201CCan edit\u201D to view this draft"
    }
});
const $de1af71286cd6242$export$7486d44190807f60 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $de1af71286cd6242$var$i18n.draftAccessWarningMessage);
};










var $2Nwuj = parcelRequire("2Nwuj");




const $fbab0e65238032f1$var$i18n = (0, $cgtv4.defineMessages)({
    parentAccessWarningMessage: {
        id: "share-and-restrict-dialog.principal-details-warning.principal-details-warning.no-ancestor-permission",
        defaultMessage: "Needs access to a <parentLink>parent</parentLink> first."
    }
});
const $fbab0e65238032f1$export$c26a5b51e21a99c = ({ parentLink: parentLink })=>{
    const getStyledButton = (chunks)=>{
        const { base: base, webui: webui } = parentLink || {};
        if (!base || !webui) return chunks;
        let parentUrl = `${base}${webui}`;
        if (Boolean((0, $1NBp8.FOLDER_VIEW).match(parentUrl))) parentUrl += '?referrer=share-and-restrict-dialog';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: parentUrl,
            appearance: "default",
            target: "_blank"
        }, chunks);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$fbab0e65238032f1$var$i18n.parentAccessWarningMessage,
        values: {
            parentLink: (chunks)=>getStyledButton(chunks)
        }
    });
};









const $5b065510140a35ee$var$i18n = (0, $cgtv4.defineMessages)({
    pendingSiteAccessWarningMessage: {
        id: "share-and-restrict-dialog.principal-details-warning.principal-details-warning.pending-site-access-warning",
        defaultMessage: "Product access pending by admin."
    }
});
const $5b065510140a35ee$export$7a76c8e3840607d5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5b065510140a35ee$var$i18n.pendingSiteAccessWarningMessage);

/**
 * @graphql cc
 */ 





























var $4qzKl = parcelRequire("4qzKl");







const $b9112dc14ff90b5e$var$SpaceAccessWarningSpecificAccessSpaceAdminListQuery = (0, $eSUdr.default)`query SpaceAccessWarningSpecificAccessSpaceAdminListQuery($spaceKey:String!){space(key:$spaceKey){admins(accountType:ATLASSIAN){displayName profilePicture{path}type ...on KnownUser{accountId accountType email}}id}}`;
const $b9112dc14ff90b5e$var$i18n = (0, $cgtv4.defineMessages)({
    spaceAccessWarningMessage: {
        id: "share-and-restrict-dialog.principal-details-warning.no-space-permission",
        defaultMessage: "Needs access to space first. Contact a <spaceAdmin>space admin</spaceAdmin>."
    },
    spaceAccessEditWarningMessage: {
        id: "share-and-restrict-dialog.principal-details-warning.no-space-edit-permission",
        defaultMessage: "Needs edit access to space first. Contact a <spaceAdmin>space admin</spaceAdmin>."
    },
    noSpaceAdminMessage: {
        id: "share-and-restrict-dialog.principal-details-warning.no-space-admin",
        defaultMessage: "This space doesn\u2019t currently have a space admin assigned."
    }
});
const $b9112dc14ff90b5e$export$bf8f3cd4919fd169 = ({ accessWarning: accessWarning })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [getSpaceAdmins, { data: data, loading: loading }] = (0, $j1Ss3.useLazyQuery)($b9112dc14ff90b5e$var$SpaceAccessWarningSpecificAccessSpaceAdminListQuery);
    const filterForSpaceAdmins = (queryData)=>{
        const admins = queryData?.space?.admins || [];
        return admins.filter((admin)=>{
            // Anonymous space admins do not have account ids
            return admin && 'accountId' in admin;
        });
    };
    const spaceAdmins = filterForSpaceAdmins(data);
    const handleOpenChange = ({ isOpen: isOpen })=>{
        if (isOpen && spaceKey) getSpaceAdmins({
            variables: {
                spaceKey: spaceKey
            }
        });
    };
    const warningMessage = accessWarning === 'space-edit-access-warning' ? $b9112dc14ff90b5e$var$i18n.spaceAccessEditWarningMessage : $b9112dc14ff90b5e$var$i18n.spaceAccessWarningMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        placement: "bottom",
        shouldFlip: false,
        onOpenChange: ({ isOpen: isOpen })=>handleOpenChange({
                isOpen: isOpen
            }),
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...warningMessage,
                values: {
                    spaceAdmin: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                            as: "span",
                            ref: triggerRef,
                            ...triggerProps
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYWO7.PressableLink), {
                            showUnderline: true,
                            fontSize: "small",
                            onClick: onClick
                        }, chunks))
                }
            }),
        isLoading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, spaceAdmins.length < 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b9112dc14ff90b5e$var$i18n.noSpaceAdminMessage))) : spaceAdmins.map((admin)=>{
        // Anonymous space admins do not have account ids
        if (admin && 'accountId' in admin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            target: "_blank",
            key: admin.accountId,
            href: (0, $4qzKl.getAtlassianPeopleProfileUrl)(admin.accountId),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
                src: admin?.profilePicture?.path,
                size: "small"
            })
        }, admin.displayName);
    })));
};


const $4d871cc67062ec2e$var$UserDetailsPrincipalDetailsKnownErrorsQuery = (0, $eSUdr.default)`query UserDetailsPrincipalDetailsKnownErrorsQuery($accountId:String$contentId:ID){userWithContentRestrictions(accountId:$accountId contentId:$contentId){hasSpaceEditPermission hasSpaceViewPermission restrictingContent{id links{webui base}}}}`;
const $4d871cc67062ec2e$var$i18n = (0, $cgtv4.defineMessages)({
    isYouText: {
        id: "share-and-restrict-dialog.principal-details.you-text",
        defaultMessage: "(You)"
    }
});
const $4d871cc67062ec2e$var$lozengeStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
const $4d871cc67062ec2e$var$principalDetailsStyle = (0, $ecnYn.xcss)({
    overflowWrap: 'anywhere'
});
const $4d871cc67062ec2e$export$a398983943bbde23 = ({ id: id, avatarUrl: avatarUrl, name: name, email: email, knownErrors: knownErrors, sitePermissionType: sitePermissionType, isYou: isYou, role: role, updateKnownErrors: updateKnownErrors, isDraft: isDraft })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($4d871cc67062ec2e$var$UserDetailsPrincipalDetailsKnownErrorsQuery, {
        skip: knownErrors !== undefined || isYou,
        variables: {
            accountId: id,
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
    (0, $42omo.useEffect)(()=>{
        if (error) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: 'errored',
                    actionSubject: 'principalDetailsQuery',
                    attributes: {
                        message: error?.message,
                        name: error?.name,
                        stack: error?.stack,
                        cause: error?.cause
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        error
    ]);
    function getErrors() {
        if (knownErrors) return knownErrors;
        if (data) {
            const { userWithContentRestrictions: userWithContentRestrictions } = data;
            const { hasSpaceEditPermission: hasSpaceEditPermission = null, hasSpaceViewPermission: hasSpaceViewPermission = null, restrictingContent: restrictingContent = null } = userWithContentRestrictions || {};
            const newErrors = (0, $1fjr9.getKnownErrors)({
                hasSpaceEditPermission: hasSpaceEditPermission,
                hasSpaceViewPermission: hasSpaceViewPermission,
                restrictingContent: restrictingContent
            });
            if (newErrors && updateKnownErrors) updateKnownErrors(id, newErrors);
            return newErrors;
        }
        return undefined;
    }
    const errors = getErrors();
    const [shouldRenderWarningMessage, warningMessage] = (()=>{
        if (errors?.accessWarning === 'parent-access-warning') return [
            true,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fbab0e65238032f1$export$c26a5b51e21a99c), {
                key: errors.accessWarning,
                parentLink: errors.parentLink
            })
        ];
        if (errors?.accessWarning === 'space-view-access-warning') return [
            true,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9112dc14ff90b5e$export$bf8f3cd4919fd169), {
                key: errors.accessWarning,
                accessWarning: "space-view-access-warning"
            })
        ];
        if (errors?.accessWarning === 'space-edit-access-warning' && role !== 'can-view') return [
            true,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9112dc14ff90b5e$export$bf8f3cd4919fd169), {
                key: errors.accessWarning,
                accessWarning: "space-edit-access-warning"
            })
        ];
        if (errors?.accessWarning === 'pending-site-access-warning') return [
            true,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5b065510140a35ee$export$7a76c8e3840607d5), {
                key: errors.accessWarning
            })
        ];
        if (isDraft && role !== 'can-edit') return [
            true,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $de1af71286cd6242$export$7486d44190807f60), {
                key: "draft-edit-access-warning"
            })
        ];
        return [
            false,
            null
        ];
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl,
        isDisabled: shouldRenderWarningMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $4d871cc67062ec2e$var$principalDetailsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: shouldRenderWarningMessage ? 'color.text.subtlest' : 'color.text'
    }, name, isYou && ` ${formatMessage($4d871cc67062ec2e$var$i18n.isYouText)}`), sitePermissionType === (0, $62722b210ecd00f7$export$8995abb8169b2cb8).EXTERNAL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4d871cc67062ec2e$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, email)), shouldRenderWarningMessage && !loading && warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2094308d224d2d63$export$db446949e45d1358), {
        warningMessage: warningMessage
    })));
};




























var $bh5s2 = parcelRequire("bh5s2");










const $c2b7cd1b3718245a$var$i18n = (0, $cgtv4.defineMessages)({
    groupText: {
        id: "share-and-restrict-dialog.principal-details.group-text",
        defaultMessage: "Group"
    },
    adminGroupText: {
        id: "share-and-restrict-dialog.principal-details.admin-group-text",
        defaultMessage: "Admin group"
    },
    teamText: {
        id: "share-and-restrict-dialog.principal-details.team-text",
        defaultMessage: "Team"
    },
    officialTeamText: {
        id: "share-and-restrict-dialog.principal-details.official-team-text",
        defaultMessage: "Official team"
    },
    membersCount: {
        id: "share-and-restrict-dialog.principal-details.members-count.one-person",
        defaultMessage: "{count, plural, one {1 member} other {{count} members}}"
    },
    verifiedTeamToolTip: {
        id: "share-and-restrict-dialog.principal-details.verified-team-tool-tip",
        defaultMessage: "This team is verified because it is controlled by an organization admin."
    }
});
const $c2b7cd1b3718245a$var$principalDetailsStyle = (0, $ecnYn.xcss)({
    overflowWrap: 'anywhere'
});
const $c2b7cd1b3718245a$var$iconContainer = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    width: '36px',
    height: '36px',
    backgroundColor: 'color.background.neutral',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 'space.0'
});
const $c2b7cd1b3718245a$export$921125ffe42777cc = ({ name: name, usageType: usageType, type: type, memberCount: memberCount, isVerified: isVerified, avatarSrc: avatarSrc })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isTeamType = usageType === 'TEAM_COLLABORATION' || type === 'team';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $c2b7cd1b3718245a$var$iconContainer
    }, isTeamType && avatarSrc && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "square",
        src: avatarSrc
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        label: "",
        size: "32",
        appearance: "gray",
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $c2b7cd1b3718245a$var$principalDetailsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignBlock: "center"
    }, name), isTeamType && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center",
        testId: "team-details-subtext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage(isVerified ? $c2b7cd1b3718245a$var$i18n.officialTeamText : $c2b7cd1b3718245a$var$i18n.teamText)), isVerified && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($c2b7cd1b3718245a$var$i18n.verifiedTeamToolTip),
        position: "right",
        hideTooltipOnMouseDown: true,
        ignoreTooltipPointerEvents: true,
        delay: 100
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, ` \u{2022} ${formatMessage($c2b7cd1b3718245a$var$i18n.membersCount, {
        count: memberCount
    })}`)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center",
        testId: "group-details-subtext"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $c2b7cd1b3718245a$var$i18n.adminGroupText : $c2b7cd1b3718245a$var$i18n.groupText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? ` \u{2022} ${formatMessage($c2b7cd1b3718245a$var$i18n.membersCount, {
        count: memberCount
    })}` : ''))));
};


const $cc063aee47938997$export$ca797a32e81c4e2b = ({ principal: { type: type, ...typeSpecificProps }, isYou: isYou, updateKnownErrors: updateKnownErrors, role: role, isDraft: isDraft, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails })=>{
    if (shouldShowDeletedGroupDetails) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd22378577ecedbf$export$4419ae9c4a1dae0f), null);
    if (type === 'user') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4d871cc67062ec2e$export$a398983943bbde23), {
        ...typeSpecificProps,
        isYou: isYou,
        updateKnownErrors: updateKnownErrors,
        role: role,
        isDraft: isDraft
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c2b7cd1b3718245a$export$921125ffe42777cc), typeSpecificProps);
};













var $3hOY6 = parcelRequire("3hOY6");





















const $55e7f8999700042a$var$i18n = (0, $cgtv4.defineMessages)({
    inheritedRestrictionText: {
        id: "share-and-restrict-dialog.principal-access.inherited-restrictions",
        defaultMessage: "Everyone on the parent can already view"
    },
    noInheritedRestrictionText: {
        id: "share-and-restrict-dialog.principal-access.no-inherited-restrictions",
        defaultMessage: "Everyone in this space can already view"
    },
    canViewAccessText: {
        id: "share-and-restrict-dialog.principal-access.can-view-access",
        defaultMessage: "Can view"
    },
    canEditAccessText: {
        id: "share-and-restrict-dialog.principal-access.can-edit-access",
        defaultMessage: "Can edit"
    },
    removeAccessText: {
        id: "share-and-restrict-dialog.principal-access.remove-access",
        defaultMessage: "Remove"
    },
    noAccessText: {
        id: "share-and-restrict-dialog.principal-access.no-access",
        defaultMessage: "No access"
    }
});
const $55e7f8999700042a$var$noTextWrap = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $55e7f8999700042a$var$tooltipHeight = (0, $ecnYn.xcss)({
    height: '24px'
});
const $55e7f8999700042a$var$tooltipText = (0, $ecnYn.xcss)({
    font: 'font.body.small'
});
const $55e7f8999700042a$var$editPrincipalAccessStyle = (0, $ecnYn.xcss)({
    width: 'auto'
});
const $55e7f8999700042a$var$uneditablePrincipalAccessStyle = (0, $ecnYn.xcss)({
    paddingInline: 'space.100',
    whiteSpace: 'nowrap'
});
const $55e7f8999700042a$var$containerStyle = (0, $ecnYn.xcss)({
    flexShrink: 0
});
const $55e7f8999700042a$var$makeOptions = (isCanViewDisabled, hasInheritedRestrictions, isUnpublishedDraft, access, formatMessage)=>{
    if (isUnpublishedDraft && access !== 'can-view') return [
        {
            label: formatMessage($55e7f8999700042a$var$i18n.canEditAccessText),
            value: 'can-edit'
        },
        {
            label: formatMessage($55e7f8999700042a$var$i18n.removeAccessText),
            value: 'remove'
        }
    ];
    return [
        {
            label: formatMessage($55e7f8999700042a$var$i18n.canViewAccessText),
            value: 'can-view',
            isDisabled: isCanViewDisabled,
            toolTipDescription: hasInheritedRestrictions ? formatMessage($55e7f8999700042a$var$i18n.inheritedRestrictionText) : formatMessage($55e7f8999700042a$var$i18n.noInheritedRestrictionText)
        },
        {
            label: formatMessage($55e7f8999700042a$var$i18n.canEditAccessText),
            value: 'can-edit'
        },
        {
            label: formatMessage($55e7f8999700042a$var$i18n.removeAccessText),
            value: 'remove'
        }
    ];
};
const $55e7f8999700042a$var$getAccessText = (access)=>{
    if (access === 'can-view') return $55e7f8999700042a$var$i18n.canViewAccessText;
    else if (access === 'can-edit') return $55e7f8999700042a$var$i18n.canEditAccessText;
    else return $55e7f8999700042a$var$i18n.noAccessText;
};
const $55e7f8999700042a$var$UneditablePrincipalAccess = ({ access: access })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $55e7f8999700042a$var$uneditablePrincipalAccessStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $55e7f8999700042a$var$getAccessText(access)));
};
const $55e7f8999700042a$var$EditablePrincipalAccess = ({ isLockedOut: isLockedOut, access: access, isCanViewDisabled: isCanViewDisabled, hasInheritedRestrictions: hasInheritedRestrictions, isUnpublishedDraft: isUnpublishedDraft, onChange: onChange, onRemove: onRemove, focusRef: focusRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const options = $55e7f8999700042a$var$makeOptions(isCanViewDisabled, hasInheritedRestrictions, isUnpublishedDraft, access, formatMessage);
    const CustomSingleValue = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, props.data.label));
    };
    const CustomOption = (props)=>{
        const isDisabledViewAccess = props.data.label === 'Can view' && props.data.isDisabled;
        const renderCustomOption = ()=>{
            if (isDisabledViewAccess) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center",
                shouldWrap: false
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $55e7f8999700042a$var$noTextWrap
            }, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $55e7f8999700042a$var$tooltipHeight
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: [
                        $55e7f8999700042a$var$tooltipText,
                        $55e7f8999700042a$var$noTextWrap
                    ]
                }, props.data.toolTipDescription),
                position: "right"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                label: "edit-icon",
                spacing: "spacious",
                color: "var(--ds-icon, #292A2E)"
            }))));
            if (props.data.value === 'remove') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.accent.red"
            }, props.data.label);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, props.data.label);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, renderCustomOption());
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $55e7f8999700042a$var$editPrincipalAccessStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        appearance: "subtle",
        spacing: "compact",
        isDisabled: isLockedOut,
        options: options,
        isSearchable: false,
        value: options.find((option)=>option.value === access),
        menuPosition: "fixed",
        onChange: (selectedOption)=>{
            if (!selectedOption) return;
            if (selectedOption.value === 'remove') onRemove();
            else onChange(selectedOption.value);
        },
        components: {
            SingleValue: CustomSingleValue,
            Option: CustomOption
        },
        ref: focusRef
    }));
};
const $55e7f8999700042a$export$9b14ba104b7f65df = ({ isEditable: isEditable, edition: edition, ...otherProps })=>{
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $55e7f8999700042a$var$containerStyle
    }, isEditable && !isFreeEdition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($55e7f8999700042a$var$EditablePrincipalAccess, otherProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($55e7f8999700042a$var$UneditablePrincipalAccess, {
        access: otherProps.access
    }));
};


const $76ba14f0f4a7b6aa$export$34e2b4c4ae5f69fc = ({ principalDetails: principalDetails, principalAccess: principalAccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cc063aee47938997$export$ca797a32e81c4e2b), principalDetails), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $55e7f8999700042a$export$9b14ba104b7f65df), principalAccess));


// The modal body already adds 2px of padding.
// Thus to get to 24px of total distance to the footer
// We need 22px of additional padding. There's no token for that :D
// Hence we do padding `space.250` for 20px and another `space.025` of margin for 2px
const $95f0d82326f2f697$var$specificAccessContainer = (0, $ecnYn.xcss)({
    paddingBottom: 'space.250',
    marginBottom: 'space.025',
    paddingLeft: 'space.0'
});
const $95f0d82326f2f697$export$9be1d5fc4c574a6c = ({ principals: principals })=>{
    const [completedFadeIns, setCompletedFadeIns] = (0, $42omo.useState)(new Set());
    const refElement = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (refElement.current) refElement.current.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.100",
        alignInline: "start",
        grow: "fill",
        xcss: $95f0d82326f2f697$var$specificAccessContainer,
        as: "ul"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g9Srd.default), {
        appear: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bl9WW.default), {
        delayStep: (0, $4c48T.durations).small
    }, principals.map((specificAccessRowProps, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            key: specificAccessRowProps.key,
            duration: "medium",
            entranceDirection: "top",
            exitDirection: "top",
            onFinish: ()=>{
                setCompletedFadeIns((prev)=>{
                    prev.add(specificAccessRowProps.key);
                    return prev;
                });
            },
            // Only show animation for entrance so that rows after removals are not animated
            isPaused: completedFadeIns.has(specificAccessRowProps.key)
        }, (fadeInProps)=>// CSS did not work here, so using style
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                as: "li",
                ...fadeInProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    listStyle: 'none',
                    width: '100%',
                    ...fadeInProps.style
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $76ba14f0f4a7b6aa$export$34e2b4c4ae5f69fc), {
                ...specificAccessRowProps,
                principalAccess: {
                    ...specificAccessRowProps.principalAccess,
                    focusRef: idx === 1 ? refElement : null
                }
            })))))));
};





















var $1bY7o = parcelRequire("1bY7o");





var $cuAuQ = parcelRequire("cuAuQ");


var $82gXq = parcelRequire("82gXq");


var $4noo5 = parcelRequire("4noo5");
























var $8tdj3 = parcelRequire("8tdj3");





var $kfIha = parcelRequire("kfIha");


var $ewQf6 = parcelRequire("ewQf6");


var $22pmH = parcelRequire("22pmH");


var $lbXO9 = parcelRequire("lbXO9");

/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 



var $1KmJq = parcelRequire("1KmJq");







var $1IGAH = parcelRequire("1IGAH");

const $ae93e97e60b651df$var$i18n = (0, $cgtv4.defineMessages)({
    success: {
        id: "public-links.usePublicLinkEnablePageMutation.success.title",
        defaultMessage: "Public link is now on for this content."
    },
    errorTitle: {
        id: "public-links.usePublicLinkEnablePageMutation.error.title",
        defaultMessage: "We couldn\u2019t turn on the public link."
    },
    errorBody: {
        id: "public-links.usePublicLinkEnablePageMutation.error.body",
        defaultMessage: "Open the Share and Restrict dialog to check the current status, or to turn on the public link."
    }
});
const $ae93e97e60b651df$export$1432bd98d8445b1e = ({ pageId: pageId, onCompleted: onCompleted, onError: onError, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [enablePublicLinkMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation usePublicLinkEnablePageMutationPublicLinkEnablePageMutation($pageId:ID!){enablePublicLinkForPage(pageId:$pageId){pageId}}`, {
        refetchQueries: [
            {
                query: (0, $1IGAH.PublicLinkPageQuery),
                variables: {
                    pageId: pageId
                }
            }
        ],
        onCompleted: ()=>{
            flags.showFlag({
                id: 'revokeFromRestrictionsFlagId',
                title: formatMessage($ae93e97e60b651df$var$i18n.success),
                type: 'success-circle',
                close: 'auto'
            });
            onCompleted();
        },
        onError: (error)=>{
            flags.showFlag({
                id: 'revokeFromRestrictionsErrorFlagId',
                title: formatMessage($ae93e97e60b651df$var$i18n.errorTitle),
                description: formatMessage($ae93e97e60b651df$var$i18n.errorBody),
                type: 'error',
                close: 'auto'
            });
            onError(error);
        }
    });
    const enablePublicLinkForPage = (pageId)=>()=>enablePublicLinkMutation({
                variables: {
                    pageId: pageId
                }
            });
    return {
        enablePublicLinkForPage: enablePublicLinkForPage(pageId)
    };
};



var $k030f = parcelRequire("k030f");


var $8y1s8 = parcelRequire("8y1s8");








var $2Snr1 = parcelRequire("2Snr1");










var $7p4As = parcelRequire("7p4As");













var $b3j2Y = parcelRequire("b3j2Y");


var $ari0r = parcelRequire("ari0r");




const $1959548d71457e3e$var$i18n = (0, $cgtv4.defineMessages)({
    linkAllowInAtlassianAdministration: {
        id: "share-and-restrict-dialog.public-links.link-allow-in-atlassian-administration",
        defaultMessage: "Allow in Atlassian Administration"
    },
    linkAllowInSpaceSettings: {
        id: "share-and-restrict-dialog.public-links.link-allow-in-space-settings",
        defaultMessage: "Allow in Space settings"
    },
    linkAllowInSettings: {
        id: "share-and-restrict-dialog.public-links.link-allow-in-settings",
        defaultMessage: "Allow in settings"
    },
    learnMore: {
        id: "share-and-restrict-dialog.public-links.learn-more-link",
        defaultMessage: "Learn more about public links"
    },
    bodyEmpowered: {
        id: "share-and-restrict-dialog.public-links.body-empowered",
        defaultMessage: "If allowed, anyone who can view this content can share it with anyone on the internet without giving them access to Confluence."
    },
    bodyUnempowered: {
        id: "share-and-restrict-dialog.public-links.body-unempowered",
        defaultMessage: "When allowed, you can share this content with anyone on the internet without giving them access to Confluence."
    },
    titleEmpowered: {
        id: "share-and-restrict-dialog.public-links.title-empowered",
        defaultMessage: "This public link isn\u2019t allowed"
    },
    titleUnempowered: {
        id: "share-and-restrict-dialog.public-links.title-unempowered",
        defaultMessage: "Your organization is preventing the use of this public link"
    }
});
const $1959548d71457e3e$export$ce8483c24915216c = ({ publicLinkStatus: publicLinkStatus })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isEmpowered: isEmpowered, empoweredUserSettingsLinkHref: empoweredUserSettingsLinkHref, accessLevel: accessLevel, isSiteAdmin: isSiteAdmin, error: error } = (0, $ari0r.usePublicLinkPrivilegeData)({
        publicLinkStatus: publicLinkStatus ?? null
    });
    const learnMoreLinkHref = accessLevel === 'org' && isSiteAdmin ? (0, $8y1s8.DATA_SECURITY_POLICY_DOCUMENTATION) : (0, $8y1s8.SET_UP_AND_MANAGE_DOCUMENTATION);
    const getSettingsButtonText = (0, $42omo.useCallback)(()=>{
        switch(accessLevel){
            case 'org':
                return formatMessage($1959548d71457e3e$var$i18n.linkAllowInAtlassianAdministration);
            case 'space':
                return formatMessage($1959548d71457e3e$var$i18n.linkAllowInSpaceSettings);
            default:
                return formatMessage($1959548d71457e3e$var$i18n.linkAllowInSettings);
        }
    }, [
        accessLevel,
        formatMessage
    ]);
    const getButtons = (0, $42omo.useCallback)(()=>{
        switch(isEmpowered){
            case false:
                return {
                    primary: {
                        text: formatMessage($1959548d71457e3e$var$i18n.learnMore),
                        href: learnMoreLinkHref
                    },
                    secondary: null
                };
            default:
                return {
                    primary: {
                        text: getSettingsButtonText(),
                        href: empoweredUserSettingsLinkHref
                    },
                    secondary: {
                        text: formatMessage($1959548d71457e3e$var$i18n.learnMore),
                        href: learnMoreLinkHref
                    }
                };
        }
    }, [
        empoweredUserSettingsLinkHref,
        getSettingsButtonText,
        learnMoreLinkHref,
        formatMessage,
        isEmpowered
    ]);
    const { primary: primary, secondary: secondary } = getButtons();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        testId: "public-link-disabled-body",
        appearance: "information",
        title: formatMessage(isEmpowered ? $1959548d71457e3e$var$i18n.titleEmpowered : $1959548d71457e3e$var$i18n.titleUnempowered),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            space: "space.150",
            alignBlock: "center"
        }, primary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "primary",
            href: primary.href ?? '#',
            target: "_blank"
        }, primary.text), secondary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: secondary.href,
            target: "_blank"
        }, secondary.text))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage(isEmpowered ? $1959548d71457e3e$var$i18n.bodyEmpowered : $1959548d71457e3e$var$i18n.bodyUnempowered))));
};


const $5c37d2744cb2c239$var$i18n = (0, $cgtv4.defineMessages)({
    canView: {
        id: "share-and-restrict-dialog.public-links.can-view",
        defaultMessage: "Can view"
    },
    canEdit: {
        id: "share-and-restrict-dialog.public-links.can-edit",
        defaultMessage: "Can edit"
    },
    permissionsDropdownLabel: {
        id: "share-and-restrict-dialog.public-links.permissions-dropdown-label",
        defaultMessage: "Public link permissions"
    },
    learnMore: {
        id: "share-and-restrict-dialog.public-links.learn-more",
        defaultMessage: "Learn more"
    },
    publicLinkOn: {
        id: "share-and-restrict-dialog.public-links.on",
        defaultMessage: "Public link is on"
    },
    publicLinkOff: {
        id: "share-and-restrict-dialog.public-links.off",
        defaultMessage: "Public link is off"
    },
    anyoneWithLink: {
        id: "share-and-restrict-dialog.public-links.anyone-with-link",
        defaultMessage: "Anyone with the link"
    },
    noSignInRequired: {
        id: "share-and-restrict-dialog.public-links.no-sign-in-required",
        defaultMessage: "No sign-in required. <link>Learn more</link>"
    },
    copyButtonText: {
        id: "share-and-restrict-dialog.public-links.copy-button-text",
        defaultMessage: "Copy public link"
    },
    viewPublicLinkLabel: {
        id: "share-and-restrict-dialog.public-links.view-label",
        defaultMessage: "View"
    },
    viewPublicLinkToolTip: {
        id: "share-and-restrict-dialog.public-links.view-tooltip",
        defaultMessage: "Open public link in a new tab"
    },
    smartSectionsMessage: {
        id: "share-and-restrict-dialog.public-links.smart-sections-message",
        defaultMessage: "<b>Smart sections don\u2019t work on public editable whiteboards.</b> Any smart sections will be permanently disabled if the public link is made editable. <link>Learn more</link>"
    }
});
const $5c37d2744cb2c239$var$publicLinkBodyWrapper = (0, $ecnYn.xcss)({
    paddingBottom: 'space.300'
});
const $5c37d2744cb2c239$var$worldIconBackground = (0, $ecnYn.xcss)({
    height: '32px',
    width: '32px',
    borderRadius: 'radius.medium',
    background: "var(--ds-background-accent-gray-subtlest, #F0F1F2)"
});
const $5c37d2744cb2c239$var$textContainerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    flexGrow: 1
});
const $5c37d2744cb2c239$var$dropdownContainer = (0, $ecnYn.xcss)({
    width: '109px',
    marginRight: 'space.100',
    minWidth: '108px',
    maxWidth: '110px'
});
const $5c37d2744cb2c239$var$sectionMessageWrapperStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
}); /**
     * For public link permissions, what level of access is granted for the public link?
     */ 
const $5c37d2744cb2c239$var$SmartSectionsMessage = ()=>{
    const appearance = 'information';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5c37d2744cb2c239$var$sectionMessageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aoVih.default), {
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$5c37d2744cb2c239$var$i18n.smartSectionsMessage,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: (0, $8y1s8.LEARN_MORE_PUBLIC_LINKS_HREF)
                }, chunks)
        }
    }))));
};
const $5c37d2744cb2c239$var$PublicLinkPermissionsDropdown = ({ isEditPublicLink: isEditPublicLink, onChangeDropdown: onChangeDropdown, isDisabled: isDisabled, onMenuOpen: onMenuOpen })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const options = [
        {
            label: formatMessage($5c37d2744cb2c239$var$i18n.canView),
            value: 'view'
        },
        {
            label: formatMessage($5c37d2744cb2c239$var$i18n.canEdit),
            value: 'edit'
        }
    ];
    const value = options[isEditPublicLink ? 1 : 0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5c37d2744cb2c239$var$dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cuAuQ.default), {
        label: formatMessage($5c37d2744cb2c239$var$i18n.permissionsDropdownLabel),
        testId: "public-link-permissions-dropdown",
        target: ({ isOpen: isOpen, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                appearance: "subtle",
                isDisabled: isDisabled,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    })
            }, value.label),
        onMenuOpen: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: 'clicked',
                    actionSubject: 'dropdown',
                    actionSubjectId: 'publicLinkPermissionsDropdown',
                    attributes: {
                        currentState: value.value
                    }
                }
            }).fire();
            onMenuOpen?.();
        },
        options: options,
        isSearchable: false,
        onChange: (option)=>onChangeDropdown(option === options[0] ? 'view' : 'edit'),
        spacing: "compact",
        minMenuWidth: 109,
        popperProps: {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        }
    }));
};
const $5c37d2744cb2c239$export$a7ea5fed4179399f = ({ publicLinkOn: publicLinkOn, publicLinkDisabled: publicLinkDisabled, publicLinkStatus: publicLinkStatus, publicShareUrl: publicShareUrl, canEditPublicLink: canEditPublicLink, isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType, isEditPublicLink: isEditPublicLink, pageId: pageId, shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature, refetchPublicLinkState: refetchPublicLinkState, refetchButtonData: refetchButtonData, flags: flags, hasInheritedRestrictions: // Analytics
hasInheritedRestrictions, generalAccessLevel: generalAccessLevel })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const handleCompleted = ({ refetchState: refetchState, refetchData: refetchData, actionSubject: actionSubject, attributes: attributes })=>{
        refetchState && refetchPublicLinkState();
        refetchData && refetchButtonData();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'updated',
                actionSubject: actionSubject,
                attributes: attributes
            }
        }).fire();
    };
    const handleError = ({ error: error, actionSubject: actionSubject, attributes: attributes })=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'failed',
                actionSubject: actionSubject,
                attributes: {
                    ...attributes,
                    error: error.message
                }
            }
        }).fire();
    };
    const { enablePublicLinkForPage: enablePublicLinkForPage } = (0, $ae93e97e60b651df$export$1432bd98d8445b1e)({
        pageId: pageId,
        onCompleted: ()=>{
            handleCompleted({
                refetchState: true,
                refetchData: true,
                actionSubject: 'publicLinkContentSettings',
                attributes: {
                    previousState: (0, $k030f.PublicLinkPageStatus).OFF,
                    newState: (0, $k030f.PublicLinkPageStatus).ON,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    generalAccessLevel: generalAccessLevel
                }
            });
        },
        onError: (error)=>{
            handleError({
                error: error,
                actionSubject: 'publicLinkContentSettings',
                attributes: {
                    previousState: (0, $k030f.PublicLinkPageStatus).OFF,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    generalAccessLevel: generalAccessLevel
                }
            });
        },
        flags: flags
    });
    const { disablePublicLinkForPage: disablePublicLinkForPage } = (0, $lbXO9.usePublicLinkDisablePageMutation)({
        pageId: pageId,
        onCompleted: ()=>{
            handleCompleted({
                refetchState: true,
                refetchData: true,
                actionSubject: 'publicLinkContentSettings',
                attributes: {
                    previousState: (0, $k030f.PublicLinkPageStatus).ON,
                    newState: (0, $k030f.PublicLinkPageStatus).OFF,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    generalAccessLevel: generalAccessLevel
                }
            });
        },
        onError: (error)=>{
            handleError({
                error: error,
                actionSubject: 'publicLinkContentSettings',
                attributes: {
                    previousState: (0, $k030f.PublicLinkPageStatus).ON,
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    generalAccessLevel: generalAccessLevel
                }
            });
        },
        flags: flags
    });
    const { addPublicLinkPermissions: addPublicLinkPermissions } = (0, $22pmH.useAddPublicLinkPermissionsMutation)({
        objectId: pageId,
        onCompleted: ()=>{
            handleCompleted({
                refetchState: true,
                refetchData: false,
                actionSubject: 'publicLinkPermissionChange',
                attributes: {
                    previousState: 'view',
                    newState: 'edit'
                }
            });
        },
        onError: (error)=>{
            handleError({
                error: error,
                actionSubject: 'publicLinkPermissionChange',
                attributes: {
                    previousState: 'view'
                }
            });
        },
        flags: flags
    });
    const { removePublicLinkPermissions: removePublicLinkPermissions } = (0, $ewQf6.useRemovePublicLinkPermissionsMutation)({
        objectId: pageId,
        onCompleted: ()=>{
            handleCompleted({
                refetchState: true,
                refetchData: false,
                actionSubject: 'publicLinkPermissionChange',
                attributes: {
                    previousState: 'edit',
                    newState: 'view'
                }
            });
        },
        onError: (error)=>{
            handleError({
                error: error,
                actionSubject: 'publicLinkPermissionChange',
                attributes: {
                    previousState: 'edit'
                }
            });
        },
        flags: flags
    });
    const handleToggleChange = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'toggle',
                actionSubjectId: 'pagePublicLinksToggle',
                attributes: {
                    currentState: publicLinkOn ? (0, $k030f.PublicLinkPageStatus).ON : (0, $k030f.PublicLinkPageStatus).OFF,
                    targetState: publicLinkOn ? (0, $k030f.PublicLinkPageStatus).OFF : (0, $k030f.PublicLinkPageStatus).ON,
                    previousState: publicLinkOn ? 'enabled' : 'disabled',
                    newState: publicLinkOn ? 'disabled' : 'enabled',
                    hasInheritedRestrictions: hasInheritedRestrictions,
                    generalAccessLevel: generalAccessLevel
                }
            }
        }).fire();
        publicLinkOn ? disablePublicLinkForPage() : enablePublicLinkForPage();
    };
    const handlePermissionsChange = (newPermission)=>{
        const previousState = isEditPublicLink ? 'edit' : 'view';
        const newState = newPermission;
        if (previousState === newState) return;
        isEditPublicLink ? removePublicLinkPermissions() : addPublicLinkPermissions();
    };
    const iconText = publicLinkOn ? formatMessage($5c37d2744cb2c239$var$i18n.publicLinkOn) : formatMessage($5c37d2744cb2c239$var$i18n.publicLinkOff);
    const renderPublicLinkDisabledBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1959548d71457e3e$export$ce8483c24915216c), {
            publicLinkStatus: publicLinkStatus
        });
    const openPublicLink = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'viewPublicLink'
            }
        }).fire();
        if (publicShareUrl && publicShareUrl !== '') window.open(publicShareUrl, '_blank');
    }, [
        createAnalyticsEvent,
        publicShareUrl
    ]);
    const copyPublicLink = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'copyPublicLink'
            }
        }).fire();
        return copyToClipboard(publicShareUrl || '');
    }, [
        copyToClipboard,
        createAnalyticsEvent,
        publicShareUrl
    ]);
    const shouldShowDropdown = publicLinkOn && isPublicLinkEditAllowedForContentType;
    const renderPublicLinkBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, isPublicLinkEditAllowedForContentType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c37d2744cb2c239$var$SmartSectionsMessage, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            justifyContent: "center",
            alignItems: "center",
            xcss: $5c37d2744cb2c239$var$worldIconBackground
        }, publicLinkOn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Snr1.WorldGreenDotGlyph), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
            label: iconText,
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $5c37d2744cb2c239$var$textContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "medium",
            weight: "bold"
        }, formatMessage($5c37d2744cb2c239$var$i18n.anyoneWithLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            size: "small",
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$5c37d2744cb2c239$var$i18n.noSignInRequired,
            values: {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        target: "_blank",
                        href: (0, $8y1s8.PUBLIC_LINKS_SECURITY_DOCUMENTATION)
                    }, chunks)
            }
        })))), shouldShowDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5c37d2744cb2c239$var$PublicLinkPermissionsDropdown, {
            isEditPublicLink: isEditPublicLink,
            onChangeDropdown: handlePermissionsChange,
            isDisabled: !canEditPublicLink
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
            isChecked: publicLinkOn,
            onChange: handleToggleChange,
            testId: "public-links-toggle",
            isDisabled: !canEditPublicLink
        })), publicLinkOn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            isCompact: true,
            isReadOnly: true,
            value: publicShareUrl || ''
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: copyPublicLink,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o)))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $5c37d2744cb2c239$var$i18n.copyButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($5c37d2744cb2c239$var$i18n.viewPublicLinkToolTip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            label: formatMessage($5c37d2744cb2c239$var$i18n.viewPublicLinkLabel),
            onClick: openPublicLink
        }))));
    };
    const renderBody = ()=>{
        if (publicLinkDisabled) return renderPublicLinkDisabledBody();
        return renderPublicLinkBody();
    };
    if (shouldRenderDisablePublicLinkFeature) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $5c37d2744cb2c239$var$publicLinkBodyWrapper
    }, renderBody());
};






var $hwEdY = parcelRequire("hwEdY");




const $86cec6c4a3747a55$export$2d49cca0383d1499 = ({ onCloseSlack: onCloseSlack, showFlag: showFlag })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hwEdY.default), {
        showFlag: showFlag,
        product: "confluence",
        onClose: onCloseSlack,
        changeTab: ()=>{},
        cloudId: cloudId,
        hideCopyButton: true
    });
};


/* AccessRequestsDialogBody.tsx generated by @compiled/babel-plugin v0.36.1 */ 





/* AccessRequestsTable.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















var $9hlns = parcelRequire("9hlns");








var $4B2M3 = parcelRequire("4B2M3");

/** @graphql cc **/ 


































var $hmuev = parcelRequire("hmuev");


var $cvXh8 = parcelRequire("cvXh8");













/**
 * @generated SignedSource<<181e25eafd383515fa678c4d4e247121>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $f5a789a627edd277$export$9433ffa3560c2762 = /*#__PURE__*/ function(ConfluenceContentAccessRequestStatus) {
    ConfluenceContentAccessRequestStatus["APPROVE"] = "APPROVE";
    ConfluenceContentAccessRequestStatus["DENY"] = "DENY";
    ConfluenceContentAccessRequestStatus["PENDING"] = "PENDING";
    ConfluenceContentAccessRequestStatus["PENDING_SITE_APPROVAL"] = "PENDING_SITE_APPROVAL";
    return ConfluenceContentAccessRequestStatus;
}({});
var $f5a789a627edd277$export$148d27e730d9bad9 = /*#__PURE__*/ function(ConfluenceRequestAccessApprovalDecision) {
    ConfluenceRequestAccessApprovalDecision["APPROVE"] = "APPROVE";
    ConfluenceRequestAccessApprovalDecision["DENY"] = "DENY";
    return ConfluenceRequestAccessApprovalDecision;
}({});
var $f5a789a627edd277$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});


const $2360759cfc1e79ed$var$i18n = (0, $cgtv4.defineMessages)({
    mutationErrorGenericFlagTitle: {
        id: "access-requests.mutation-error-generic-flag-title",
        defaultMessage: "Can't resolve the request"
    },
    mutationErrorGenericFlagDescription: {
        id: "access-requests.mutation-error-generic-flag-description",
        defaultMessage: "We ran into a problem resolving the access request. Try again later."
    },
    mutationErrorAlreadyApprovedEditRequestFlagTitle: {
        id: "access-requests.mutation-error-already-approved-edit-request-error-flag-title",
        defaultMessage: "{approverName} already approved {requesterName}'s request to edit"
    },
    mutationErrorAlreadyApprovedViewRequestFlagTitle: {
        id: "access-requests.mutation-error-already-approved-view-request-error-flag-title",
        defaultMessage: "{approverName} already approved {requesterName}'s request to view"
    },
    mutationErrorAlreadyDeniedEditRequestFlagTitle: {
        id: "access-requests.mutation-error-already-denied-edit-request-error-flag-title",
        defaultMessage: "{approverName} already denied {requesterName}'s request to edit"
    },
    mutationErrorAlreadyDeniedViewRequestFlagTitle: {
        id: "access-requests.mutation-error-already-denied-view-request-error-flag-title",
        defaultMessage: "{approverName} already denied {requesterName}'s request to view"
    },
    accessRequestApproved: {
        id: "access-requests.request-approved",
        defaultMessage: "Approved"
    },
    accessRequestDenied: {
        id: "access-requests.request-denied",
        defaultMessage: "Denied"
    },
    approveButton: {
        id: "access-requests.approve-button",
        defaultMessage: "Approve"
    },
    denyButton: {
        id: "access-requests.deny-button",
        defaultMessage: "Deny"
    },
    accessTypeSelectorLabel_CanView: {
        id: "access-requests.access-type-selector-label-can-view",
        defaultMessage: "Can view"
    },
    accessTypeSelectorLabel_CanEdit: {
        id: "access-requests.access-type-selector-label-can-edit",
        defaultMessage: "Can edit"
    }
});
const $2360759cfc1e79ed$var$rowStyles = (0, $ecnYn.xcss)({
    margin: 'space.0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    listStyle: 'none',
    minHeight: '52px',
    maxHeight: '52px'
});
const $2360759cfc1e79ed$var$nameBoxStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    marginRight: 'auto'
});
const $2360759cfc1e79ed$var$buttonGroupStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.150',
    flexShrink: 0
});
const $2360759cfc1e79ed$var$rowStatusStyles = {
    flexShrink: 0,
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    paddingRight: "var(--ds-space-150, 12px)"
};
const $2360759cfc1e79ed$var$ViewOption = {
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $2360759cfc1e79ed$var$i18n.accessTypeSelectorLabel_CanView),
    value: (0, $f5a789a627edd277$export$8e7b7bb509dc942b).VIEW
};
const $2360759cfc1e79ed$var$EditOption = {
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $2360759cfc1e79ed$var$i18n.accessTypeSelectorLabel_CanEdit),
    value: (0, $f5a789a627edd277$export$8e7b7bb509dc942b).EDIT
};
const $2360759cfc1e79ed$var$accessTypeOptions = [
    $2360759cfc1e79ed$var$ViewOption,
    $2360759cfc1e79ed$var$EditOption
];
const $2360759cfc1e79ed$var$getSelectValueFromAccessType = (accessType)=>$2360759cfc1e79ed$var$accessTypeOptions.find(({ value: value })=>value === accessType) ?? $2360759cfc1e79ed$var$ViewOption;
const $2360759cfc1e79ed$export$8df259dc81598d77 = (0, $eSUdr.default)`mutation AccessRequestsTableRowMutation($cloudId:ID!$updateContentAccessRequestInput:ConfluenceUpdateContentAccessRequestInput!){confluence_updateContentAccessRequest(cloudId:$cloudId updateContentAccessRequestInput:$updateContentAccessRequestInput){success errors{extensions{errorType statusCode ...on ConfluenceUpdateContentAccessRequestMutationErrorExtension{displayName processedRequestStatus}}message}}}`;
const $2360759cfc1e79ed$var$SELECT_STYLES = {
    styles: {
        singleValue: (base)=>({
                ...base,
                minWidth: '62px',
                textAlign: 'left'
            })
    }
};
const $2360759cfc1e79ed$export$f1a3941e86de9bdc = 'REQUEST_ALREADY_PROCESSED';
const $2360759cfc1e79ed$var$isAlreadyProcessedExtension = (extension)=>{
    return extension?.displayName !== undefined;
};
const $2360759cfc1e79ed$var$getAlreadyProcessedErrorMessage = (status, requestType)=>{
    if (status === 'APPROVE') return requestType === (0, $f5a789a627edd277$export$8e7b7bb509dc942b).VIEW ? $2360759cfc1e79ed$var$i18n.mutationErrorAlreadyApprovedViewRequestFlagTitle : $2360759cfc1e79ed$var$i18n.mutationErrorAlreadyApprovedEditRequestFlagTitle;
    return requestType === (0, $f5a789a627edd277$export$8e7b7bb509dc942b).VIEW ? $2360759cfc1e79ed$var$i18n.mutationErrorAlreadyDeniedViewRequestFlagTitle : $2360759cfc1e79ed$var$i18n.mutationErrorAlreadyDeniedEditRequestFlagTitle;
};
const $2360759cfc1e79ed$export$d8adca6c779edd67 = ({ accessRequest: accessRequest, contentId: contentId, flags: flags, isBlockedAccessFlowActive: isBlockedAccessFlowActive, maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser, source: source, shouldBlockRowProcessing: shouldBlockRowProcessing, onRowProcessingStart: onRowProcessingStart, onRowProcessingEnd: onRowProcessingEnd, trackChange: trackChange, clearChanges: clearChanges })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [accessTypeOption, setAccessTypeOption] = (0, $42omo.useState)($2360759cfc1e79ed$var$getSelectValueFromAccessType(accessRequest.requestAccessType));
    const accessType = accessTypeOption.value;
    const accountId = accessRequest.accessRequestedAaid;
    const requestStatus = accessRequest.status;
    const requestId = accessRequest.id;
    const displayName = accessRequest.user?.displayName ?? '';
    const email = accessRequest.user?.emails?.find((e)=>e?.isPrimary)?.value ?? '';
    const avatarUrl = accessRequest.user?.photos?.find((photo)=>photo?.isPrimary)?.value ?? '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleMutationError = (mutationErrors, _)=>{
        const alreadyProcessedError = mutationErrors.find((e)=>e.extensions?.some((ext)=>ext?.errorType === $2360759cfc1e79ed$export$f1a3941e86de9bdc));
        const alreadyProcessedExtension = alreadyProcessedError?.extensions?.find($2360759cfc1e79ed$var$isAlreadyProcessedExtension);
        if (alreadyProcessedExtension?.displayName && alreadyProcessedExtension.processedRequestStatus) {
            const approverName = alreadyProcessedExtension?.displayName;
            const requesterName = accessRequest.user?.displayName;
            const approveOrDenyTemplate = $2360759cfc1e79ed$var$getAlreadyProcessedErrorMessage(alreadyProcessedExtension?.processedRequestStatus, accessType);
            flags.showErrorFlag({
                title: formatMessage(approveOrDenyTemplate, {
                    approverName: approverName,
                    requesterName: requesterName
                })
            });
        } else flags.showErrorFlag({
            title: formatMessage($2360759cfc1e79ed$var$i18n.mutationErrorGenericFlagTitle),
            description: formatMessage($2360759cfc1e79ed$var$i18n.mutationErrorGenericFlagDescription)
        });
        const message = mutationErrors[0]?.message || 'unknown';
        const errorType = mutationErrors[0]?.extensions?.[0]?.errorType || 'unknown';
        const statusCode = mutationErrors[0]?.extensions?.[0]?.statusCode || 'unknown';
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'accessRequestsTableRowMutation',
                source: source,
                attributes: {
                    requestId: requestId,
                    contentId: contentId,
                    accessType: accessType,
                    accountId: accountId,
                    message: message,
                    errorType: errorType,
                    statusCode: statusCode
                }
            }
        }).fire();
    };
    const [updateContentAccessRequestMutation] = (0, $1KmJq.useMutation)($2360759cfc1e79ed$export$8df259dc81598d77);
    const [rowEntryAnimationFinished, setRowEntryAnimationFinished] = (0, $42omo.useState)(false);
    const [rowStatusAnimationFinished, setRowStatusAnimationFinished] = (0, $42omo.useState)(false);
    const [isBlockedAccessFlowStarted, setIsBlockedAccessFlowStarted] = (0, $42omo.useState)(false);
    const [isRowDecisionBeingProcessed, setIsRowDecisionBeingProcessed] = (0, $42omo.useState)(null); /**
                                                                                                                                        * Stops the "processing" look of the row only after the blocked access flow is completed
                                                                                                                                        * This only happens if blocked access was needed in the first place
                                                                                                                                        * */ 
    (0, $42omo.useEffect)(()=>{
        if (isRowDecisionBeingProcessed && isBlockedAccessFlowStarted && !isBlockedAccessFlowActive) {
            setIsRowDecisionBeingProcessed(null);
            setIsBlockedAccessFlowStarted(false);
            onRowProcessingEnd();
        }
    }, [
        isBlockedAccessFlowStarted,
        isBlockedAccessFlowActive,
        isRowDecisionBeingProcessed,
        onRowProcessingEnd
    ]);
    const createCtaHandler = (approvalDecision)=>async ()=>{
            if (shouldBlockRowProcessing) return;
            onRowProcessingStart();
            setIsRowDecisionBeingProcessed(approvalDecision);
            const result = await updateContentAccessRequestMutation({
                variables: {
                    cloudId: cloudId,
                    updateContentAccessRequestInput: {
                        requestId: requestId,
                        contentId: contentId,
                        accessRequestedAccountId: accountId,
                        approvalDecision: approvalDecision,
                        accessType: accessType
                    }
                },
                update (cache, incoming) {
                    if (incoming?.data?.confluence_updateContentAccessRequest?.success) cache.writeFragment({
                        id: `ConfluenceContentAccessRequest:${accessRequest.id}`,
                        fragment: (0, $eSUdr.default)`fragment UpdateConfluenceContentAccessRequest on ConfluenceContentAccessRequest{status}`,
                        data: {
                            status: approvalDecision,
                            __typename: 'ConfluenceContentAccessRequest'
                        }
                    });
                }
            });
            let isRowProcessingDone = true;
            const successfulMutation = result.data?.confluence_updateContentAccessRequest?.success;
            const successfulApproval = successfulMutation && approvalDecision === 'APPROVE';
            const successfulDenial = successfulMutation && approvalDecision === 'DENY';
            if (successfulApproval) {
                const { isBlockedAccessFlowStarted: isFlowStarted } = await maybeStartBlockedAccessFlowForUser({
                    id: accountId,
                    avatarUrl: avatarUrl,
                    name: displayName,
                    email: email,
                    sitePermissionType: accessType,
                    accessType: accessType
                });
                setIsBlockedAccessFlowStarted(isFlowStarted);
                isRowProcessingDone = !isFlowStarted;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'granted',
                        actionSubject: 'access',
                        actionSubjectId: 'grantAccess',
                        source: source,
                        attributes: {
                            accessType: accessType === (0, $f5a789a627edd277$export$8e7b7bb509dc942b).EDIT ? 'edit' : 'view'
                        }
                    }
                }).fire();
            }
            if (successfulDenial) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'denyAccess',
                    source: source,
                    attributes: {
                        accessType: accessType
                    }
                }
            }).fire();
            if (isRowProcessingDone) {
                setIsRowDecisionBeingProcessed(null);
                onRowProcessingEnd();
            }
            if (successfulMutation) // Clear the tracked changes for this request since the mutation was successful
            {
                if (clearChanges) clearChanges();
            } else {
                const mutationErrors = result.data?.confluence_updateContentAccessRequest?.errors ?? [];
                const apolloErrors = result.errors ?? [];
                handleMutationError(mutationErrors, apolloErrors);
            }
        };
    const handleSelectChange = (newlySelectedOption)=>{
        if (newlySelectedOption !== null) {
            setAccessTypeOption(newlySelectedOption); // Track the change for unsaved changes detection
            if (trackChange) trackChange(accessRequest.id, newlySelectedOption.value, accessRequest.requestAccessType);
        }
    };
    const pendingRequestUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        xcss: $2360759cfc1e79ed$var$buttonGroupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
        appearance: "subtle",
        value: accessTypeOption,
        options: $2360759cfc1e79ed$var$accessTypeOptions,
        isSearchable: false,
        menuPosition: "fixed",
        onChange: handleSelectChange,
        isDisabled: isRowDecisionBeingProcessed !== null,
        menuShouldBlockScroll: true,
        ...$2360759cfc1e79ed$var$SELECT_STYLES
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: createCtaHandler((0, $f5a789a627edd277$export$148d27e730d9bad9).DENY),
        isLoading: isRowDecisionBeingProcessed === 'DENY',
        isDisabled: isRowDecisionBeingProcessed === 'APPROVE'
    }, formatMessage($2360759cfc1e79ed$var$i18n.denyButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: createCtaHandler((0, $f5a789a627edd277$export$148d27e730d9bad9).APPROVE),
        isLoading: isRowDecisionBeingProcessed === 'APPROVE',
        isDisabled: isRowDecisionBeingProcessed === 'DENY'
    }, formatMessage($2360759cfc1e79ed$var$i18n.approveButton)));
    const requestApproved = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, formatMessage($2360759cfc1e79ed$var$i18n.accessRequestApproved)));
    const requestDenied = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtle"
    }, formatMessage($2360759cfc1e79ed$var$i18n.accessRequestDenied)));
    const actionedRequestUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        duration: "large",
        entranceDirection: "right",
        isPaused: rowStatusAnimationFinished,
        onFinish: ()=>setRowStatusAnimationFinished(true),
        key: `${accessRequest.id}-request-status`
    }, ({ style: style, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...style,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...$2360759cfc1e79ed$var$rowStatusStyles
            },
            ...rest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.150",
            xcss: $2360759cfc1e79ed$var$buttonGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            space: "space.050"
        }, requestStatus === 'APPROVE' ? requestApproved : requestDenied))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        duration: "large",
        isPaused: rowEntryAnimationFinished,
        onFinish: ()=>setRowEntryAnimationFinished(true)
    }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignInline: "start",
            alignBlock: "center",
            xcss: $2360759cfc1e79ed$var$rowStyles,
            as: "li"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            xcss: $2360759cfc1e79ed$var$nameBoxStyles,
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text",
            maxLines: 1
        }, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 1
        }, email)), (requestStatus === 'PENDING' || isRowDecisionBeingProcessed) && pendingRequestUI, requestStatus !== 'PENDING' && !isRowDecisionBeingProcessed && actionedRequestUI)));
};
const $2360759cfc1e79ed$export$734871f34b00009b = (0, $7aRa9.withFlags)($2360759cfc1e79ed$export$d8adca6c779edd67);





const $c706c16148771b8b$export$5232408bc6463877 = (containerRef)=>{
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!containerRef.current) return;
        const container = containerRef.current;
        const sentinel = document.createElement('div');
        sentinel.style.position = 'absolute';
        sentinel.style.top = '0';
        sentinel.style.height = '1px';
        sentinel.style.width = '100%';
        sentinel.style.pointerEvents = 'none';
        container.prepend(sentinel);
        const observerCallback = (entries)=>{
            const [entry] = entries;
            setIsScrolled(!entry.isIntersecting);
        };
        // eslint-disable-next-line no-restricted-syntax
        const observer = new IntersectionObserver(observerCallback, {
            root: container,
            threshold: 1.0
        });
        observer.observe(sentinel);
        return ()=>{
            observer.disconnect();
            if (sentinel.parentElement) sentinel.parentElement.removeChild(sentinel);
        };
    }, [
        containerRef
    ]);
    return isScrolled;
};















var $gj7hi = parcelRequire("gj7hi");




const $61bd11f99474f912$var$containerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    flexGrow: 1,
    paddingBottom: 'space.300'
});
const $61bd11f99474f912$var$imageStyles = (0, $ecnYn.xcss)({
    width: '96px',
    height: '96px'
});
const $61bd11f99474f912$export$a0ad3fafb97964b = ({ textLine: textLine, secondTextLine: secondTextLine, srcLight: srcLight, srcDark: srcDark })=>{
    const [imageLoading, setImageLoading] = (0, $42omo.useState)(true);
    const [imageAnimationFinished, setImageAnimationFinished] = (0, $42omo.useState)(false);
    const shouldPauseAnimation = imageLoading || imageAnimationFinished;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "center",
        alignBlock: "center",
        xcss: $61bd11f99474f912$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        duration: "large",
        entranceDirection: "top",
        isPaused: shouldPauseAnimation,
        onFinish: ()=>setImageAnimationFinished(true)
    }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $61bd11f99474f912$var$imageStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: srcLight,
            srcDark: srcDark,
            alt: "",
            onLoad: ()=>setImageLoading(false)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        duration: "large"
    }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            alignInline: "center",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "medium",
            align: "center"
        }, textLine), secondTextLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "medium",
            align: "center"
        }, secondTextLine)))));
};





var $70c4474a78de2372$exports = {};
$70c4474a78de2372$exports = new URL("DarkEmptyState.b237e8cb.png", import.meta.url).toString();


var $fd3164075acf95fb$exports = {};
$fd3164075acf95fb$exports = new URL("LightEmptyState.1b72e55d.png", import.meta.url).toString();


var $e1adaabd40971b33$exports = {};
$e1adaabd40971b33$exports = new URL("DarkError.d13c9c5b.png", import.meta.url).toString();


var $dca74f2631dfee8a$exports = {};
$dca74f2631dfee8a$exports = new URL("LightError.5b516166.png", import.meta.url).toString();


const $52ad728a211a093a$var$i18n = (0, $cgtv4.defineMessages)({
    errorFirstLine: {
        id: "access-requests.error-title-first-line",
        defaultMessage: "We couldn't load the requests."
    },
    errorSecondLine: {
        id: "access-requests.error-title-second-line",
        defaultMessage: "Try again later."
    },
    emptyStateTitle: {
        id: "access-requests.empty-state-title",
        defaultMessage: "All requests have been resolved"
    }
});
function $52ad728a211a093a$var$isDefined(value) {
    return value !== null && value !== undefined;
}
const $52ad728a211a093a$export$2d01832e075b5934 = (count)=>{
    if (count < 10) return count;
    if (count >= 100) return '100+';
     // For 10-99, round down to nearest 10 and add '+'
    return `${Math.floor(count / 10) * 10}+`;
};
/**
 * This container with "relative" positioning
 * is necessary for the top border on scroll to
 * correctly anchor itself
 */ const $52ad728a211a093a$var$accessRequestsContainerStyles = null;
const $52ad728a211a093a$var$tableStyles = (0, $ecnYn.xcss)({
    margin: '0',
    padding: 'space.0',
    width: 'calc(100% + 48px)',
    left: 'space.negative.300',
    overflowY: 'scroll',
    position: 'relative',
    flexGrow: 1
});
const $52ad728a211a093a$var$borderDummyStyles = (0, $ecnYn.xcss)({
    height: '1px',
    width: 'calc(100% + 48px)',
    position: 'absolute',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    borderColor: 'color.border',
    top: '-1px',
    left: 'space.negative.300',
    transition: '0.12s opacity ease',
    opacity: 0
});
const $52ad728a211a093a$var$tableBorderTop = (0, $ecnYn.xcss)({
    opacity: 1
});
const $52ad728a211a093a$var$paddingBoxStyles = (0, $ecnYn.xcss)({
    minHeight: '24px',
    width: '100%'
});
const $52ad728a211a093a$var$spinnerContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.300',
    height: '100%',
    width: '100%'
});
const $52ad728a211a093a$export$38419fee2d1c8717 = ({ tryCacheFirst: tryCacheFirst, isBlockedAccessFlowActive: isBlockedAccessFlowActive, maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser, minLoadingHeight: minLoadingHeight, source: source, onHasUnsavedChanges: onHasUnsavedChanges })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [fetchPolicy] = (0, $42omo.useState)(tryCacheFirst ? 'cache-first' : 'network-only');
    const [shouldBlockRowProcessing, setShouldBlockRowProcessing] = (0, $42omo.useState)(false);
    const onRowProcessingStart = (0, $42omo.useCallback)(()=>setShouldBlockRowProcessing(true), []);
    const onRowProcessingEnd = (0, $42omo.useCallback)(()=>setShouldBlockRowProcessing(false), []);
    const { requests: requests, endCursor: endCursor, hasNextPage: hasNextPage, loading: loading, error: error, fetchMore: fetchMore, contentId: contentId, hasFullyLoaded: hasFullyLoaded } = (0, $6SeRB.useAccessRequests)(fetchPolicy, 'accessRequestsTable');
    const [, setChanges] = (0, $42omo.useState)(new Map()); // Track changes internally
    const trackChange = (0, $42omo.useCallback)((requestId, newAccessType, originalAccessType)=>{
        setChanges((prevChanges)=>{
            const newChanges = new Map(prevChanges);
            if (newAccessType === originalAccessType) newChanges.delete(requestId);
            else newChanges.set(requestId, {
                requestId: requestId,
                newAccessType: newAccessType,
                originalAccessType: originalAccessType
            });
            onHasUnsavedChanges?.(newChanges.size > 0);
            return newChanges;
        });
    }, [
        onHasUnsavedChanges
    ]);
    const clearChanges = (0, $42omo.useCallback)(()=>{
        setChanges(new Map());
        onHasUnsavedChanges?.(false);
    }, [
        onHasUnsavedChanges
    ]); // Preserve scroll position when more entries are appended at the bottom of the scrollable container
    const containerRef = (0, $42omo.useRef)(null);
    const scrollTopRef = (0, $42omo.useRef)(0);
    const isScrolled = (0, $c706c16148771b8b$export$5232408bc6463877)(containerRef);
    const totalResults = requests.length;
    const fetchNextPage = async ()=>{
        if (!hasNextPage) return;
        await fetchMore({
            variables: {
                after: endCursor
            },
            updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>{
                // Save the scroll position of the container just before rendering the new results
                if (containerRef.current?.scrollTop) scrollTopRef.current = containerRef.current.scrollTop;
                 // If there's no new data, return the previous result
                if (!fetchMoreResult) return previousResult;
                const previousNodes = previousResult.confluence_contentAccessRequestByStatus?.nodes || [];
                const newNodes = fetchMoreResult.confluence_contentAccessRequestByStatus?.nodes || [];
                const nodes = [
                    ...previousNodes,
                    ...newNodes
                ];
                const latestPageInfo = fetchMoreResult.confluence_contentAccessRequestByStatus?.pageInfo;
                const pageInfo = {
                    endCursor: latestPageInfo?.endCursor || null,
                    startCursor: latestPageInfo?.startCursor || null,
                    hasNextPage: latestPageInfo?.hasNextPage || false,
                    __typename: latestPageInfo?.__typename || 'PageInfo'
                };
                return {
                    ...previousResult,
                    confluence_contentAccessRequestByStatus: {
                        ...previousResult.confluence_contentAccessRequestByStatus,
                        nodes: nodes,
                        pageInfo: pageInfo
                    }
                };
            }
        });
    };
    (0, $42omo.useLayoutEffect)(()=>{
        // Apply the last saved scroll position of the container back to it when new results show up
        // Context: scrollTop gets reset when more entries are added
        // therefore we need to set it to whatever it was just before the entries were added
        if (containerRef.current && scrollTopRef.current) containerRef.current.scrollTop = scrollTopRef.current;
    }, [
        totalResults
    ]);
    const [initialLoadComplete, setInitialLoadComplete] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasFullyLoaded) setInitialLoadComplete(true);
    }, [
        hasFullyLoaded
    ]);
    const loadingHeight = initialLoadComplete ? 'initial' : `${minLoadingHeight}px`;
    const minTableHeight = minLoadingHeight;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (initialLoadComplete) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'accessRequestsTable',
                source: source,
                attributes: {
                    count: $52ad728a211a093a$export$2d01832e075b5934(totalResults),
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        initialLoadComplete,
        createAnalyticsEvent,
        totalResults,
        contentId,
        source
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            height: loadingHeight,
            minHeight: minTableHeight
        },
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1bsb1osq _1e0c1txw _2lx21bp4 _c71l1ber"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61bd11f99474f912$export$a0ad3fafb97964b), {
        textLine: formatMessage($52ad728a211a093a$var$i18n.errorFirstLine),
        secondTextLine: formatMessage($52ad728a211a093a$var$i18n.errorSecondLine),
        srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($dca74f2631dfee8a$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($e1adaabd40971b33$exports)))
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            height: loadingHeight,
            minHeight: minTableHeight
        },
        className: (0, $gMc0m.default)([
            "_kqswh2mm _1bsb1osq _1e0c1txw _2lx21bp4 _c71l1ber"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $52ad728a211a093a$var$borderDummyStyles,
            isScrolled && $52ad728a211a093a$var$tableBorderTop
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: [
            $52ad728a211a093a$var$tableStyles
        ],
        ref: containerRef,
        as: "ul",
        testId: "access-requests-table"
    }, !initialLoadComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "center",
        alignBlock: "center",
        xcss: $52ad728a211a093a$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        testId: "access-requests-table-spinner"
    })), initialLoadComplete && !loading && totalResults === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61bd11f99474f912$export$a0ad3fafb97964b), {
        textLine: formatMessage($52ad728a211a093a$var$i18n.emptyStateTitle),
        srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($fd3164075acf95fb$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($70c4474a78de2372$exports)))
    }), initialLoadComplete && totalResults > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bl9WW.default), null, requests.filter($52ad728a211a093a$var$isDefined).map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2360759cfc1e79ed$export$734871f34b00009b), {
            contentId: contentId,
            accessRequest: node,
            key: node.id,
            isBlockedAccessFlowActive: isBlockedAccessFlowActive,
            maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser,
            source: source,
            shouldBlockRowProcessing: shouldBlockRowProcessing,
            onRowProcessingStart: onRowProcessingStart,
            onRowProcessingEnd: onRowProcessingEnd,
            trackChange: trackChange,
            clearChanges: clearChanges
        }))), hasNextPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4B2M3.ObservableSpinner), {
        onScrollTo: fetchNextPage,
        testId: "access-requests-table-paginating-spinner",
        cursor: endCursor,
        observerOptions: {
            root: containerRef.current,
            rootMargin: '100px 0px 0px 0px'
        }
    }) : initialLoadComplete && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $52ad728a211a093a$var$paddingBoxStyles
    })));
};


class $4f3147580289b283$export$6449f350006c283e {
    get accessRequestsLoadingHeight() {
        // Header above the access requests table is 72px, so need to subtract it
        const modalHeaderAdjustment = 72;
        // The Access Requests dialog adds a 2px negative margin when the body has top/bottom padding
        // This is to counteract the padding that gets added to the ModalBody when the window height is above 888px
        const modalBodyPaddingAdjustment = this.modalBodyHasTopBottomPadding ? 0 : 2;
        const finalHeight = this._lastRecordedContentHeight - modalHeaderAdjustment + modalBodyPaddingAdjustment;
        // We don't want the height to exceed 416px (8 access requests visible), so we cap it
        return Math.min(finalHeight, 416);
    }
    constructor(){
        this._currentHeight = 0;
        this._observeTarget = null;
        this._canRecordCurrentHeight = false;
        this._resizeObserver = void 0;
        this._lastRecordedContentHeight = 0;
        this.modalBodyHasTopBottomPadding = false;
        this.startObservingDialogHeight = (node)=>{
            if (node) {
                this._observeTarget = node;
                this._resizeObserver?.observe(this._observeTarget);
            }
        };
        this.stopObservingDialogHeight = ()=>{
            this._currentHeight = 0;
            this._lastRecordedContentHeight = 0;
            if (this._observeTarget) this._resizeObserver?.unobserve(this._observeTarget);
        };
        this.recordCurrentContentHeight = ()=>{
            this._lastRecordedContentHeight = this._currentHeight;
        };
        this.setCanRecordCurrentHeight = (canRecordCurrentHeight)=>{
            this._canRecordCurrentHeight = canRecordCurrentHeight;
            if (canRecordCurrentHeight) this.recordCurrentContentHeight();
        };
        this.getUsdLoadingHeight = ({ specificAccessVisible: specificAccessVisible, isDraft: isDraft, isPublishModalFlow: isPublishModalFlow })=>{
            // When we do subsequent reloads, we will have a previous height recorded
            if (this._lastRecordedContentHeight > 0) return this._lastRecordedContentHeight;
            // On the very first load we need to manually set the height
            const baseLoadingHeight = specificAccessVisible ? 411 : 319;
            // Drafts have an extra message we need to account for
            // That message gets removed if Specific Access is visible
            const draftMessageAdjustment = isDraft && !specificAccessVisible && !isPublishModalFlow ? 55 : 0;
            const publishModalFlowAdjustment = isPublishModalFlow ? 67 : 0;
            // if window height is above 888, an extra 4px padding gets slapped on the ModalBody
            const modalBodyPaddingAdjustment = specificAccessVisible && this.modalBodyHasTopBottomPadding ? 4 : 0;
            // ToDo: Handle other cases like free edition upsells, embeds, etc etc
            // Store this pre-determined height early, this way access requests can also use it
            this._lastRecordedContentHeight = baseLoadingHeight + draftMessageAdjustment + publishModalFlowAdjustment + modalBodyPaddingAdjustment;
            return this._lastRecordedContentHeight;
        };
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (!isSSR) {
            this._resizeObserver = new ResizeObserver((entries)=>{
                entries.forEach((entry)=>{
                    this._currentHeight = entry.contentRect.height;
                    if (this._canRecordCurrentHeight) this.recordCurrentContentHeight();
                });
            });
            const windowHeight = window.innerHeight || (window.top?.innerHeight ?? 0);
            this.modalBodyHasTopBottomPadding = windowHeight > 888;
        }
    }
}
const $4f3147580289b283$var$USD_LOADING_HEIGHT_INSTANCE = new $4f3147580289b283$export$6449f350006c283e();
const $4f3147580289b283$export$b11515a53220fdee = ()=>$4f3147580289b283$var$USD_LOADING_HEIGHT_INSTANCE;





const $3fcb406df8a940cd$var$modalBodyHeightAdjustment = null;
const $3fcb406df8a940cd$export$db2f99bab3c2f246 = ({ isInitialDialog: isInitialDialog, isBlockedAccessFlowActive: isBlockedAccessFlowActive, maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser, onAccessRequestsChange: onAccessRequestsChange })=>{
    const { accessRequestsLoadingHeight: accessRequestsLoadingHeight, modalBodyHasTopBottomPadding: modalBodyHasTopBottomPadding } = (0, $4f3147580289b283$export$b11515a53220fdee)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "access-requests-dialog-body",
        className: (0, $gMc0m.default)([
            modalBodyHasTopBottomPadding && "_otyr1i6y"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52ad728a211a093a$export$38419fee2d1c8717), {
        tryCacheFirst: isInitialDialog,
        isBlockedAccessFlowActive: isBlockedAccessFlowActive,
        maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser,
        minLoadingHeight: accessRequestsLoadingHeight,
        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
        onHasUnsavedChanges: onAccessRequestsChange
    }));
};


const $2c0e9f044b1f8fc0$export$4b2c32e08f77ff18 = ({ specificAccessDetails: specificAccessDetails, publicLinkDialogBody: publicLinkDialogBody, shareToSlackDialogBody: shareToSlackDialogBody, accessRequestsDialogBody: accessRequestsDialogBody })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        grow: "fill"
    }, specificAccessDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $95f0d82326f2f697$export$9be1d5fc4c574a6c), specificAccessDetails), publicLinkDialogBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5c37d2744cb2c239$export$a7ea5fed4179399f), publicLinkDialogBody), shareToSlackDialogBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $86cec6c4a3747a55$export$2d49cca0383d1499), shareToSlackDialogBody), accessRequestsDialogBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3fcb406df8a940cd$export$db2f99bab3c2f246), accessRequestsDialogBody));
};













const $0f5e738fc7a05785$export$5b59379e75f71555 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill",
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large",
        interactionName: "load"
    })));


/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1Whri = parcelRequire("1Whri");

















var $5spQU = parcelRequire("5spQU");
















var $lzcvT = parcelRequire("lzcvT");

var $T9xHm = parcelRequire("T9xHm");


var $hkzol = parcelRequire("hkzol");
















const $4afbb6a6ff9d5122$export$b33fb54b08bb6422 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 125 125"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, '.prefix__st0{fill:#e01e5a}.prefix__st1{fill:#36c5f0}.prefix__st2{fill:#2eb67d}.prefix__st3{fill:#ecb22e}'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "none",
        id: "prefix__canvas_background",
        d: "M-1-1h127v127H-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "prefix__svg_1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "prefix__svg_2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_3",
        d: "M27.4 79.2c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9h12.9v12.9z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_4",
        d: "M33.9 79.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V79.2z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "prefix__svg_5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_6",
        d: "M46.8 27.4c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v12.9H46.8z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_7",
        d: "M46.8 33.9c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H14.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "prefix__svg_8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_9",
        d: "M98.6 46.8c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H98.6V46.8z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_10",
        d: "M92.1 46.8c0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9V14.5c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9v32.3z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "prefix__svg_11"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_12",
        d: "M79.2 98.6c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.8-12.9-12.9V98.6h12.9z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "prefix__svg_13",
        d: "M79.2 92.1c-7.1 0-12.9-5.8-12.9-12.9 0-7.1 5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9H79.2z",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "prefix__st3"
    })))));
};


const $af2a4c79352f8949$var$FooterStyles = (0, $ecnYn.xcss)({
    boxSizing: 'border-box',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $af2a4c79352f8949$var$i18n = (0, $cgtv4.defineMessages)({
    copyLink: {
        id: "share-and-restrict-dialog.footer.copy-link",
        defaultMessage: "Copy link"
    },
    publicLink: {
        id: "share-and-restrict-dialog.footer.public-link",
        defaultMessage: "Public link"
    },
    publicLinkIsOn: {
        id: "share-and-restrict-dialog.footer.public-link-is-on",
        defaultMessage: "Public link is on"
    },
    slack: {
        id: "share-and-restrict-dialog.footer.slack",
        defaultMessage: "Slack"
    }
});
const $af2a4c79352f8949$export$9a4f33da08d95115 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, pageMode: pageMode, isLockedOut: isLockedOut, isUnpublishedDraft: isUnpublishedDraft, isLivePage: isLivePage, onSlackClick: onSlackClick, onPublicLinkClick: onPublicLinkClick, isPublicLinkOn: isPublicLinkOn, lastTriggeredDialogVariant: lastTriggeredDialogVariant, publicLinkButtonRef: publicLinkButtonRef, shareToSlackButtonRef: shareToSlackButtonRef, clearElementToFocus: clearElementToFocus, natureOfCta: natureOfCta })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isFedRampEnv = (0, $lzcvT.isFedRamp)(); // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP + IC fallback
    const isSlackButtonFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-share-to-slack-button') : !isFedRampEnv && !((0, $T9xHm.isIsolatedCloud)() && (0, $9wGTI.fg)('hide-share-to-slack-for-ic'));
    const shouldShowSlackButton = isSlackButtonFeatureEnabled && !isUnpublishedDraft;
    const shouldShowPublicLinkButton = !isUnpublishedDraft && (contentType === 'page' || contentType === 'whiteboard');
    (0, $42omo.useEffect)(()=>{
        if (!lastTriggeredDialogVariant) return;
        let elementWasFocused = false;
        if (lastTriggeredDialogVariant === 'publicLink' && !!publicLinkButtonRef?.current) {
            publicLinkButtonRef.current.focus();
            elementWasFocused = true;
        } else if (lastTriggeredDialogVariant === 'shareToSlack' && !!shareToSlackButtonRef?.current) {
            shareToSlackButtonRef.current.focus();
            elementWasFocused = true;
        }
        if (elementWasFocused) clearElementToFocus();
    }, [
        lastTriggeredDialogVariant,
        publicLinkButtonRef,
        shareToSlackButtonRef,
        clearElementToFocus
    ]);
    const iconProps = {
        label: '',
        ...isPublicLinkOn ? {
            secondaryColor: "var(--ds-icon-accent-green, #22A06B)"
        } : {}
    };
    const Icon = isPublicLinkOn ? (0, $2Snr1.WorldGreenDotGlyph) : (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    const handleSlackClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'ShareToSlackFooterButton',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    isLivePage: isLivePage,
                    pageMode: pageMode
                }
            }
        }).fire();
        onSlackClick();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center",
        xcss: $af2a4c79352f8949$var$FooterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hkzol.CopyLinkButton), {
        buttonAppearance: "subtle",
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        pageMode: pageMode,
        isDraft: isUnpublishedDraft,
        isLivePage: isLivePage,
        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
        buttonText: intl.formatMessage($af2a4c79352f8949$var$i18n.copyLink),
        isDisabled: isLockedOut
    }), natureOfCta !== 'none' && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? null : shouldShowSlackButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (0, $4afbb6a6ff9d5122$export$b33fb54b08bb6422),
        onClick: handleSlackClick,
        isDisabled: isLockedOut,
        ref: shareToSlackButtonRef
    }, intl.formatMessage($af2a4c79352f8949$var$i18n.slack)), natureOfCta !== 'none' && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? null : shouldShowPublicLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...parentProps,
                ...iconProps
            }),
        onClick: onPublicLinkClick,
        isDisabled: isLockedOut,
        ref: publicLinkButtonRef
    }, isPublicLinkOn ? intl.formatMessage($af2a4c79352f8949$var$i18n.publicLinkIsOn) : intl.formatMessage($af2a4c79352f8949$var$i18n.publicLink))));
};


const $ebe15d80634702e5$var$styles = {
    footer: "_19pk1wug"
};
const $ebe15d80634702e5$export$a06f1c675e846f6f = ({ ctaNotifyMessageFooter: ctaNotifyMessageFooter, distributionFooter: distributionFooter })=>/*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
        grow: "hug",
        xcss: (0, $1Whri.cx)($ebe15d80634702e5$var$styles.footer)
    }, ctaNotifyMessageFooter && !(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') && /*#__PURE__*/ $42omo.createElement((0, $06f4c3e4444a6796$export$c26ce0b7496e870c), ctaNotifyMessageFooter), distributionFooter && /*#__PURE__*/ $42omo.createElement((0, $af2a4c79352f8949$export$9a4f33da08d95115), distributionFooter));


/* ShareAndRestrictDialogNudgeWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
















var $dTk3A = parcelRequire("dTk3A");










var $bxB0V = parcelRequire("bxB0V");

const $ade11f0a0d3e6b9c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "share-and-restrict-dialog.share-nudge-publish.title",
        defaultMessage: "Your work deserves an audience"
    },
    body: {
        id: "share-and-restrict-dialog.share-nudge-publish.body",
        defaultMessage: "Share this page with someone so they can contribute or simply view it."
    },
    cta: {
        id: "share-and-restrict-dialog.share-nudge-publish.cta",
        defaultMessage: "OK"
    }
});
// allows the nudge to properly wrap the whole modal
const $ade11f0a0d3e6b9c$var$NudgeAnchorWrapper = null;
const $ade11f0a0d3e6b9c$var$ContextualNudgeContent = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "medium",
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ade11f0a0d3e6b9c$export$a7357cdd1f0b0168.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ade11f0a0d3e6b9c$export$a7357cdd1f0b0168.body)));
};
const $ade11f0a0d3e6b9c$var$ShareAndRestrictDialogNudge = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isHidden, setIsHidden] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bxB0V.OnboardingNudge), {
        hidden: isHidden,
        setHidden: ()=>{
            setIsHidden(true);
        },
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ade11f0a0d3e6b9c$var$ContextualNudgeContent, null),
        actionSubjectId: "contextualInviteNudge",
        source: "share-and-restrict-dialog-nudge",
        width: 275,
        actions: [
            {
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'shareAndRestrictDialogNudgeOk',
                            source: 'shareAndRestrictDialog'
                        }
                    }).fire();
                    setIsHidden(true);
                },
                text: formatMessage($ade11f0a0d3e6b9c$export$a7357cdd1f0b0168.cta)
            }
        ],
        position: "right-start",
        onShow: ()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'shareAndRestrictDialogNudge'
                }
            }).fire();
        },
        zIndex: (0, $dTk3A.layers).modal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1h6d1j28 _1dqonqa1 _189ee4h9"
        ])
    }, children));
};
const $ade11f0a0d3e6b9c$export$858e12fa2878d932 = ({ children: children, showDialogNudgeSpotlight: showDialogNudgeSpotlight })=>{
    return showDialogNudgeSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ade11f0a0d3e6b9c$var$ShareAndRestrictDialogNudge, null, children) : children;
};



const $7e772903836b296e$export$8ef1f7fd8a31c60d = 888;
const $7e772903836b296e$export$af7cbdc76e7b516a = ()=>{
    const windowHeight = window.innerHeight || (window.top?.innerHeight ?? 0);
    return windowHeight < $7e772903836b296e$export$8ef1f7fd8a31c60d;
};
const $7e772903836b296e$export$d5a59ce640d36cce = ()=>Math.min(600, window.innerWidth - 80);
const $7e772903836b296e$export$9f3b5c28ca763551 = ({ header: header, body: body, footer: footer, onCloseRequest: onCloseRequest, onCloseComplete: onCloseComplete, isLoading: isLoading, usdLoadingHeightContext: usdLoadingHeightContext, analyticsAttributes: analyticsAttributes, showDialogNudgeSpotlight: showDialogNudgeSpotlight, openAccessRequestsDialog: openAccessRequestsDialog, onInitialDialogOpen: onInitialDialogOpen })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    // Extracting the analytics attributes so that the useEffect does not fire with every render
    const { contentId: contentId, contentType: contentType, contentSubType: contentSubType, isLivePage: isLivePage, isDraft: isDraft, pageMode: pageMode, generalAccessLevel: generalAccessLevel, openFrom: openFrom } = analyticsAttributes || {};
    /** Determine modal scrolling behavior */ const defaultShouldScrollInViewport = (0, $42omo.useMemo)($7e772903836b296e$export$af7cbdc76e7b516a, []);
    const [shouldScrollInViewport, setShouldScrollViewport] = (0, $42omo.useState)(defaultShouldScrollInViewport);
    const defaultDialogWidth = (0, $42omo.useMemo)($7e772903836b296e$export$d5a59ce640d36cce, []);
    const [width, setWidth] = (0, $42omo.useState)(defaultDialogWidth);
    const { addRecommendedUserCount: addRecommendedUserCount, sendRecommendedUsersCount: sendRecommendedUsersCount } = (0, $e2b95a895ee37acd$export$50430938a2360bc5)();
    const onSuggestedUserClick = (0, $42omo.useCallback)(()=>{
        addRecommendedUserCount();
    }, [
        addRecommendedUserCount
    ]);
    (0, $42omo.useEffect)(()=>{
        const onResize = ()=>{
            setShouldScrollViewport($7e772903836b296e$export$af7cbdc76e7b516a);
            setWidth($7e772903836b296e$export$d5a59ce640d36cce);
        };
        onResize();
        window.addEventListener('resize', onResize);
        return ()=>{
            window.removeEventListener('resize', onResize);
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        return ()=>sendRecommendedUsersCount();
    }, [
        sendRecommendedUsersCount
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isLoading) {
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: `shareAndRestrictDialogModal`,
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentSubType: contentSubType,
                        isLivePage: isLivePage,
                        isDraft: isDraft,
                        pageMode: pageMode,
                        generalAccessLevel: generalAccessLevel,
                        openFrom: openFrom ?? 'ShareAndRestrictButton',
                        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_LOAD_EXPERIENCE)
            });
        }
    }, [
        experienceTracker,
        isLoading,
        createAnalyticsEvent,
        contentId,
        contentType,
        contentSubType,
        isLivePage,
        isDraft,
        pageMode,
        openFrom,
        generalAccessLevel
    ]);
    const heightObserver = (0, $4f3147580289b283$export$b11515a53220fdee)();
    const isMainShareDialogLoaded = !isLoading && header?.titleAndButtons.title === 'share';
    const height = usdLoadingHeightContext ? heightObserver.getUsdLoadingHeight(usdLoadingHeightContext) : undefined;
    const onCloseCompleteHandler = ()=>{
        heightObserver.stopObservingDialogHeight();
        onCloseComplete();
    };
    (0, $42omo.useEffect)(()=>{
        heightObserver.setCanRecordCurrentHeight(isMainShareDialogLoaded);
    }, [
        heightObserver,
        isMainShareDialogLoaded
    ]);
    /**
	 * Initial dialog opening effect.
	 * Allows for programmatic opening of dialog variants
	 * by specifying the initialDialog property of the Controller.
	 * So far we only have the need to programmatically open Access Requests dialog
	 * But if we need to do so for Public Links or Share to Slack
	 * We can do so by extending this code
	 */ (0, $42omo.useEffect)(()=>{
        /**
		 * This opening method only exists if initialDialog is defined
		 * Note the cleanup function onInitialDialogOpen
		 * The cleanup is needed to avoid getting stuck on whichever
		 * initialDialog was programmatically invoked
		 */ if (openAccessRequestsDialog) {
            openAccessRequestsDialog();
            return ()=>onInitialDialogOpen?.();
        }
    }, [
        openAccessRequestsDialog,
        onInitialDialogOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        height: height,
        width: width,
        onClose: onCloseRequest,
        onCloseComplete: onCloseCompleteHandler,
        onOpenComplete: heightObserver.startObservingDialogHeight,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: "modal-dialog-share-and-restrict"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ade11f0a0d3e6b9c$export$858e12fa2878d932), {
        showDialogNudgeSpotlight: showDialogNudgeSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: false
    }, header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f315c2057873a691$export$8b251419efc915eb), {
        ...header,
        onSuggestedUserClick: onSuggestedUserClick
    })), isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0f5e738fc7a05785$export$5b59379e75f71555), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, body && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c0e9f044b1f8fc0$export$4b2c32e08f77ff18), body))), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ebe15d80634702e5$export$a06f1c675e846f6f), footer))));
};















var $8o1lj = parcelRequire("8o1lj");












var $cryCi = parcelRequire("cryCi");







const $ac305a50b0a2fb25$var$i18n = (0, $cgtv4.defineMessages)({
    heading: {
        id: "share-and-restrict-dialog.close-confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    body: {
        id: "share-and-restrict-dialog.close-confirmation.body",
        defaultMessage: "You have unsaved changes that will be lost if you close the share window. Do you want to discard them?"
    },
    cancelButton: {
        id: "share-and-restrict-dialog.close-confirmation.cancel",
        defaultMessage: "Cancel"
    },
    discardButton: {
        id: "share-and-restrict-dialog.close-confirmation.discard",
        defaultMessage: "Discard"
    }
});
const $ac305a50b0a2fb25$var$CloseConfirmationDialogContent = ({ onDiscard: onDiscard, onCancel: onCancel, focusRef: focusRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'discardShareAndRestrictChanges',
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
            }
        }).fire();
        onDiscard();
    }, [
        createAnalyticsEvent,
        onDiscard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "small",
        shouldReturnFocus: focusRef,
        testId: "modal-dialog-share-close-confirmation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ac305a50b0a2fb25$var$i18n.heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: onCancel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ac305a50b0a2fb25$var$i18n.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onCancel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ac305a50b0a2fb25$var$i18n.cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ac305a50b0a2fb25$var$i18n.discardButton))));
};
const $ac305a50b0a2fb25$export$abc534d217e3575f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ac305a50b0a2fb25$var$CloseConfirmationDialogContent, props));
};


/* GroupNotifyWarningDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 








































var $13PIz = parcelRequire("13PIz");


const $22d819883286f38d$var$styles = {
    spinnerContainer: "_1yt4pxbi _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq"
};
const $22d819883286f38d$var$i18n = (0, $cgtv4.defineMessages)({
    heading: {
        id: "share-and-restrict-dialog.group-notify-warning.heading",
        defaultMessage: "Notify everyone in the group?"
    },
    headingWithTeams: {
        id: "share-and-restrict-dialog.group-notify-warning.heading-with-teams",
        defaultMessage: "Notify everyone?"
    },
    body: {
        id: "share-and-restrict-dialog.group-notify-warning.body",
        defaultMessage: "Groups often contain a lot of people. It might be a little noisy to notify them all. Are you sure you want to notify everyone in these groups?"
    },
    bodyWithTeams: {
        id: "share-and-restrict-dialog.group-notify-warning.body-with-teams",
        defaultMessage: "Teams and groups often contain a lot of people. It might be a little noisy to notify them all. Are you sure you want to notify everyone in these teams and groups?"
    },
    doNotifyButton: {
        id: "share-and-restrict-dialog.group-notify-warning.do-notify",
        defaultMessage: "Notify groups"
    },
    doNotifyButtonWithTeams: {
        id: "share-and-restrict-dialog.group-notify-warning.do-notify-with-teams",
        defaultMessage: "Notify them all"
    },
    doNotNotifyButton: {
        id: "share-and-restrict-dialog.group-notify-warning.do-not-notify",
        defaultMessage: "Share without notifying"
    }
});
const $22d819883286f38d$export$8499307f04b5b8ab = ({ groupNames: groupNames, groupList: groupList, isSaving: isSaving, onDoNotify: onDoNotify, onDoNotNotify: onDoNotNotify, onCloseComplete: onCloseComplete })=>{
    const focusRef = (0, $42omo.useRef)(null);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)(); //This query is called here in order to retrieve the member counts for groups, since those are not accessible from the recommendations service
    //It's not the most performant solution, but it's the only way to get the member counts for groups in the GroupNotifyWarningDialog component
    //The best way to do this would be to have URS return group member counts. Until then, this is the best workaround.
    const { groupAndTeamCountsMap: groupAndTeamCountsMap, isGroupsCountLoading: isGroupsCountLoading } = (0, $13PIz.useGroupsAndTeamCountQuery)({
        data: undefined,
        publishModalRestrictions: undefined,
        error: undefined,
        groupList: groupList
    });
    groupList.forEach((group)=>{
        const count = groupAndTeamCountsMap.get(group.id);
        if (count !== undefined) group.memberCount = count;
    }); // Effectively disable the close button without it looking disabled
    const closeModal = ()=>!isSaving && onDoNotNotify();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "medium",
        autoFocus: focusRef,
        onCloseComplete: onCloseComplete,
        testId: "modal-dialog-share-group-notify-warning"
    }, isGroupsCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $22d819883286f38d$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "large"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $22d819883286f38d$var$i18n.headingWithTeams : $22d819883286f38d$var$i18n.heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $22d819883286f38d$var$i18n.bodyWithTeams : $22d819883286f38d$var$i18n.body), !(0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold"
    }, groupNames.join(', '))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, groupList.map((group)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c2b7cd1b3718245a$export$921125ffe42777cc), {
            key: group.id,
            ...group,
            "data-testid": `group-details-${group.type}`
        });
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        isDisabled: isSaving,
        onClick: onDoNotNotify
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $22d819883286f38d$var$i18n.doNotNotifyButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        isDisabled: isSaving,
        onClick: onDoNotify,
        ref: focusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? $22d819883286f38d$var$i18n.doNotifyButtonWithTeams : $22d819883286f38d$var$i18n.doNotifyButton)))));
};












































var $86H8K = parcelRequire("86H8K");

const $ba48d3b750b06056$var$i18n = (0, $cgtv4.defineMessages)({
    headingSingleUser: {
        id: "share-and-restrict-dialog.restricted-access-warning.heading.single-user",
        defaultMessage: "Someone needs additional access"
    },
    headingMultiUser: {
        id: "share-and-restrict-dialog.restricted-access-warning.heading.multi-user",
        defaultMessage: "Some people need additional access"
    },
    body: {
        id: "share-and-restrict-dialog.restricted-access-warning.body",
        defaultMessage: "They need access elsewhere first before they can have the indicated access to <b>{page}</b>. Contact a space admin or <learnMoreLink>read our troubleshooting guide</learnMoreLink>."
    },
    usersNameList: {
        id: "share-and-restrict-dialog.restricted-access-warning.users",
        defaultMessage: "{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}"
    },
    skipButton: {
        id: "share-and-restrict-dialog.restricted-access-warning.skip",
        defaultMessage: "OK"
    }
});
const $ba48d3b750b06056$export$9d763870238e599f = ({ restrictedUserPrincipals: restrictedUserPrincipals, pageTitle: pageTitle, triggeredBy: triggeredBy, onSkip: onSkip, onCloseComplete: onCloseComplete })=>{
    const focusRef = (0, $42omo.useRef)(null);
    const usersCount = restrictedUserPrincipals ? restrictedUserPrincipals.length : 0;
    const users = restrictedUserPrincipals ? restrictedUserPrincipals.map((restrictedPrincipal)=>restrictedPrincipal.userPrincipal) : undefined;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'RestrictedAccessWarningDialog',
                attributes: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    blockedUsersCount: usersCount,
                    triggeredBy: triggeredBy
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        usersCount,
        restrictedUserPrincipals,
        triggeredBy
    ]);
    const handleSkip = (0, $42omo.useCallback)(()=>{
        onSkip();
    }, [
        onSkip
    ]);
    const avatarGroupData = users ? users.map((user)=>({
            key: user?.email || '',
            name: user?.name || '',
            href: '#',
            src: user?.avatarUrl || ''
        })) : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "medium",
        autoFocus: focusRef,
        onCloseComplete: onCloseComplete,
        testId: "modal-dialog-restricted-access-warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), usersCount == 1 ? $ba48d3b750b06056$var$i18n.headingSingleUser : $ba48d3b750b06056$var$i18n.headingMultiUser)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: handleSkip
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        appearance: "stack",
        data: avatarGroupData,
        maxCount: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$ba48d3b750b06056$var$i18n.usersNameList,
        values: {
            usersCount: usersCount,
            firstUser: users && users[0] ? users[0].name : null,
            secondUser: users && users[1] ? users[1].name : null,
            thirdUser: users && users[2] ? users[2].name : null,
            fourthUser: users && users[3] ? users[3].name : null,
            remainingUserCount: usersCount - 3
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$ba48d3b750b06056$var$i18n.body,
        values: {
            page: pageTitle,
            b: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    weight: "bold"
                }, chunk),
            learnMoreLink: (0, $86H8K.LearnMoreChunk)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: handleSkip,
        ref: focusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ba48d3b750b06056$var$i18n.skipButton))));
};



var $dwkNQ = parcelRequire("dwkNQ");














































const $e642bc0fed522422$export$bae28e68d0aa638c = (0, $eSUdr.default)`mutation ClearRestrictionsForFreeMutation($contentId:ID!){clearRestrictionsForFree(contentId:$contentId){restrictionsHash}}`;


const $16ae16aaa2db8cbc$var$i18n = (0, $cgtv4.defineMessages)({
    title: {
        id: "share-and-restrict-dialog.openAccessWarningDialog.title",
        defaultMessage: "Open up access to everyone"
    },
    body: {
        id: "share-and-restrict-dialog.openAccessWarningDialog.body",
        defaultMessage: "<b>This can\u2019t be undone on the Free plan.</b> This will restore the content\u2019s access level to the following default level:"
    },
    cancelButton: {
        id: "share-and-restrict-dialog.openAccessWarningDialog.cancelButton",
        defaultMessage: "Cancel"
    },
    openAccessButton: {
        id: "share-and-restrict-dialog.openAccessWarningDialog.openAccessButton",
        defaultMessage: "Open up access"
    }
});
const $16ae16aaa2db8cbc$export$ba0d0b4601a5a6f0 = ({ generalAccess: generalAccess, closeOpenAccessWarningDialog: closeOpenAccessWarningDialog, contentId: contentId, successFlag: successFlag, errorFlag: errorFlag, closeShareAndRestricDialog: closeShareAndRestricDialog })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [clearRestrictionsForFreeMutation] = (0, $1KmJq.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $e642bc0fed522422$export$bae28e68d0aa638c), {
        onCompleted: ()=>{
            setIsLoading(false);
            successFlag('access-updated');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: 'success',
                    actionSubject: 'openAccessForFree'
                }
            }).fire();
            closeOpenAccessWarningDialog();
            closeShareAndRestricDialog();
        },
        onError: (error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: 'errored',
                    actionSubject: 'openAccessForFree',
                    attributes: {
                        message: error?.message,
                        name: error?.name,
                        stack: error?.stack,
                        cause: error?.cause
                    }
                }
            }).fire();
            setIsLoading(false);
            errorFlag('mutation-error');
        }
    });
    const onOpenAccess = ()=>{
        setIsLoading(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'openAccessForFree'
            }
        }).fire();
        clearRestrictionsForFreeMutation({
            variables: {
                contentId: contentId
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        width: "small",
        testId: "modal-dialog-open-access-warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, "Open up access to everyone"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
        onClick: closeOpenAccessWarningDialog
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$16ae16aaa2db8cbc$var$i18n.body,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    weight: "bold"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $757afac272ae6225$export$7e5386ee40f452c8), {
        ...generalAccess,
        showBottomPadding: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: closeOpenAccessWarningDialog,
        isDisabled: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $16ae16aaa2db8cbc$var$i18n.cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        onClick: onOpenAccess,
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $16ae16aaa2db8cbc$var$i18n.openAccessButton))))));
};


const $1fa1f80f6463e71f$export$6aea35d848d72744 = ({ shareAndRestrictDialog: shareAndRestrictDialog, restrictedAccessWarningDialog: restrictedAccessWarningDialog, resolveRestrictionsDialog: resolveRestrictionsDialog, groupNotifyWarningDialog: groupNotifyWarningDialog, closeConfirmationDialog: closeConfirmationDialog, spaceAccessDetails: spaceAccessDetails, inspectPermsDialog: inspectPermsDialog, openAccessWarningDialog: openAccessWarningDialog })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onClick: (event)=>event?.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, shareAndRestrictDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7e772903836b296e$export$9f3b5c28ca763551), shareAndRestrictDialog)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, groupNotifyWarningDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22d819883286f38d$export$8499307f04b5b8ab), groupNotifyWarningDialog)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, closeConfirmationDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ac305a50b0a2fb25$export$abc534d217e3575f), closeConfirmationDialog)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, spaceAccessDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCanw.AccessDetailsDialog), spaceAccessDetails)), inspectPermsDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $erzVD.InspectPermissionsDialog), inspectPermsDialog), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, restrictedAccessWarningDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ba48d3b750b06056$export$9d763870238e599f), restrictedAccessWarningDialog)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, resolveRestrictionsDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dwkNQ.ResolveRestrictionsDialog), resolveRestrictionsDialog)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, openAccessWarningDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16ae16aaa2db8cbc$export$ba0d0b4601a5a6f0), openAccessWarningDialog)));
module.exports["Dialogs"] = $1fa1f80f6463e71f$export$6aea35d848d72744;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("4XpKh"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("4XpKh", function(module, exports) {

let $39c0a4a3edb3637b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $39c0a4a3edb3637b$var$load("37ZO9"),
    $39c0a4a3edb3637b$var$load("1GxVg"),
    $39c0a4a3edb3637b$var$load("6wr18"),
    $39c0a4a3edb3637b$var$load("dMOc8"),
    $39c0a4a3edb3637b$var$load("aX0L0"),
    $39c0a4a3edb3637b$var$load("QcHuP"),
    $39c0a4a3edb3637b$var$load("iQ0Jm"),
    $39c0a4a3edb3637b$var$load("coJiW"),
    $39c0a4a3edb3637b$var$load("ijPJo"),
    $39c0a4a3edb3637b$var$load("6FuHS"),
    $39c0a4a3edb3637b$var$load("eyaRC"),
    $39c0a4a3edb3637b$var$load("Wowvf"),
    $39c0a4a3edb3637b$var$load("dTsOE"),
    $39c0a4a3edb3637b$var$load("kHOMt"),
    $39c0a4a3edb3637b$var$load("hhss7"),
    $39c0a4a3edb3637b$var$load("ffEVr"),
    $39c0a4a3edb3637b$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("bCanw", function(module, exports) {
/* AccessDetailsDialog.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $jSnXV = parcelRequire("jSnXV");


var $xQxzY = parcelRequire("xQxzY");


var $9hlns = parcelRequire("9hlns");


var $fT2ta = parcelRequire("fT2ta");


var $inPa6 = parcelRequire("inPa6");


var $1kHsc = parcelRequire("1kHsc");


var $lsxnT = parcelRequire("lsxnT");


var $eyam8 = parcelRequire("eyam8");


var $kDHiY = parcelRequire("kDHiY");

const $9ab331bcf4180daf$var$AccessDetailsDialogSpaceAccessDetailsQuery = (0, $eSUdr.default)`query AccessDetailsDialogSpaceAccessDetailsQuery($spaceKey:String!$first:Int$after:String$filterText:String){space(key:$spaceKey){id key name icon{path(type:ABSOLUTE)isDefault}type}spacePermissions(spaceKey:$spaceKey){subjectsWithPermissions(first:$first after:$after filterText:$filterText){groupCount userCount nodes{permissions subjectKey{id displayName principalType:confluencePrincipalType user:confluencePerson{accountId displayName email permissionType profilePicture{width height isDefault path(type:ABSOLUTE)}}group{id name permissionType usageType}}}pageInfo{hasNextPage endCursor}}}}`;
const $9ab331bcf4180daf$var$AccessDetailsDialogContentAccessDetailsQuery = (0, $eSUdr.default)`query AccessDetailsDialogContentAccessDetailsQuery($contentId:ID!$first:Int$after:String$filterText:String){contentPermissions(contentId:$contentId){subjectsWithEffectiveContentPermissions(first:$first after:$after filterText:$filterText){groupCount userCount nodes{id permissions type displayName group{id name permissionType usageType}user{accountId displayName email permissionType profilePicture{width height isDefault path(type:ABSOLUTE)}}}pageInfo{hasNextPage endCursor}}}singleContent(id:$contentId){id title type links{webui}}}`;
const $9ab331bcf4180daf$var$PAGE_SIZE = 20; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ab331bcf4180daf$var$LoadingSpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _4t3i1cbm",
            __cmplp.className
        ])
    });
});
const $9ab331bcf4180daf$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ab331bcf4180daf$var$LoadingSpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium"
    }));
function $9ab331bcf4180daf$var$mergeFetchMoreSpaceResults(prev, { fetchMoreResult: fetchMoreResult }) {
    const nodes = [
        ...prev?.spacePermissions?.subjectsWithPermissions?.nodes || [],
        ...fetchMoreResult?.spacePermissions?.subjectsWithPermissions?.nodes || []
    ];
    const pageInfo = fetchMoreResult?.spacePermissions?.subjectsWithPermissions?.pageInfo || null;
    return {
        ...prev,
        spacePermissions: {
            ...prev.spacePermissions,
            subjectsWithPermissions: {
                ...prev.spacePermissions.subjectsWithPermissions,
                nodes: nodes,
                pageInfo: pageInfo
            }
        }
    };
}
function $9ab331bcf4180daf$var$mergeFetchMoreContentResults(prev, { fetchMoreResult: fetchMoreResult }) {
    const nodes = [
        ...prev?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || [],
        ...fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || []
    ];
    const pageInfo = fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.pageInfo || null;
    const userCount = fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.userCount || 0;
    const groupCount = fetchMoreResult?.contentPermissions?.subjectsWithEffectiveContentPermissions?.groupCount || 0;
    return {
        ...prev,
        contentPermissions: {
            ...prev?.contentPermissions,
            subjectsWithEffectiveContentPermissions: {
                ...prev?.contentPermissions?.subjectsWithEffectiveContentPermissions,
                pageInfo: pageInfo,
                nodes: nodes,
                userCount: userCount,
                groupCount: groupCount
            }
        }
    };
}
const $9ab331bcf4180daf$export$47f45cf4d14749ea = ({ onClose: onClose, accessDetailsParams: accessDetailsParams })=>{
    const [filterText, setFilterText] = (0, $42omo.useState)('');
    const [appliedFilterText, setAppliedFilterText] = (0, $42omo.useState)('');
    const debouncedSetFilterText = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(setAppliedFilterText, 200), []);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $42omo.useEffect)(()=>{
        debouncedSetFilterText(filterText);
    }, [
        filterText,
        debouncedSetFilterText
    ]);
    const { spaceKey: spaceKey, restrictingContentId: restrictingContentId, hasInheritedRestrictions: hasInheritedRestrictions, experience: experience } = accessDetailsParams;
    const { data: spaceAccessDetails, loading: spaceAccessDetailsLoading, error: spaceAccessDetailsError, fetchMore: spaceAccessDetailsFetchMore } = (0, $xQxzY.useQuery)($9ab331bcf4180daf$var$AccessDetailsDialogSpaceAccessDetailsQuery, {
        variables: {
            spaceKey: spaceKey,
            first: $9ab331bcf4180daf$var$PAGE_SIZE,
            filterText: appliedFilterText
        },
        skip: hasInheritedRestrictions
    });
    const handleSpaceAccessDetailsFetchMore = (0, $42omo.useCallback)((nextPageCursor)=>{
        spaceAccessDetailsFetchMore({
            variables: {
                after: nextPageCursor
            },
            updateQuery: $9ab331bcf4180daf$var$mergeFetchMoreSpaceResults
        });
    }, [
        spaceAccessDetailsFetchMore
    ]);
    const { data: contentAccessDetails, loading: contentAccessDetailsLoading, error: contentAccessDetailsError, fetchMore: contentAccessDetailsFetchMore } = (0, $xQxzY.useQuery)($9ab331bcf4180daf$var$AccessDetailsDialogContentAccessDetailsQuery, {
        variables: {
            contentId: restrictingContentId ?? '',
            filterText: appliedFilterText,
            first: $9ab331bcf4180daf$var$PAGE_SIZE
        },
        skip: !hasInheritedRestrictions
    });
    const handleContentAccessDetailsFetchMore = (0, $42omo.useCallback)((nextPageCursor)=>{
        contentAccessDetailsFetchMore({
            variables: {
                after: nextPageCursor
            },
            updateQuery: $9ab331bcf4180daf$var$mergeFetchMoreContentResults
        });
    }, [
        contentAccessDetailsFetchMore
    ]);
    if (spaceAccessDetailsError || contentAccessDetailsError) {
        if (spaceAccessDetailsError) {
            experienceTracker.fail({
                name: experience,
                error: spaceAccessDetailsError
            });
            throw spaceAccessDetailsError;
        }
        if (contentAccessDetailsError) {
            experienceTracker.fail({
                name: experience,
                error: contentAccessDetailsError
            });
            throw contentAccessDetailsError;
        }
    }
    const isLoading = contentAccessDetailsLoading || spaceAccessDetailsLoading; // Don't render spinner when search bar entires are querying results
    const [initialLoadComplete, setInitialLoadComplete] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!contentAccessDetailsLoading && !spaceAccessDetailsLoading) {
            if (!contentAccessDetailsError && !spaceAccessDetailsError) {
                setInitialLoadComplete(true);
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        source: experience,
                        actionSubjectId: 'ViewSpaceAccessModal',
                        action: 'viewed'
                    }
                }).fire();
            }
        }
    }, [
        contentAccessDetailsLoading,
        spaceAccessDetailsLoading,
        contentAccessDetailsError,
        spaceAccessDetailsError,
        createAnalyticsEvent,
        experience
    ]); //TODO: The body should likely be split into two components, one for content access and one for space access,
    //      either could be passed to a body wrapper component.  That way, there aren't multiple query's data in the same file.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose,
        testId: "space-access-details.drilldown"
    }, isLoading && !initialLoadComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9ab331bcf4180daf$var$LoadingSpinner, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyam8.AccessDetailsDialogHeader), {
            filterText: filterText,
            appliedFilterText: appliedFilterText,
            setFilterText: setFilterText,
            onClose: onClose,
            hasInheritedRestrictions: hasInheritedRestrictions,
            spaceInfo: spaceAccessDetails,
            contentInfo: contentAccessDetails,
            isLoading: isLoading,
            ...props
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDHiY.AccessDetailsDialogBody), {
            spaceInfo: spaceAccessDetails,
            contentInfo: contentAccessDetails,
            hasInheritedRestrictions: hasInheritedRestrictions,
            handleSpaceAccessDetailsFetchMore: handleSpaceAccessDetailsFetchMore,
            handleContentAccessDetailsFetchMore: handleContentAccessDetailsFetchMore,
            isLoading: isLoading,
            ...props
        }))));
};
module.exports["AccessDetailsDialog"] = $9ab331bcf4180daf$export$47f45cf4d14749ea;

});

parcelRegister("eyam8", function(module, exports) {
/* AccessDetailsDialogHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");


var $eEA8O = parcelRequire("eEA8O");


var $4noo5 = parcelRequire("4noo5");


var $bPdpL = parcelRequire("bPdpL");


var $7yDmn = parcelRequire("7yDmn");


var $jluld = parcelRequire("jluld");


var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $u9agA = parcelRequire("u9agA");


var $25ZwL = parcelRequire("25ZwL");


var $i2ukN = parcelRequire("i2ukN");


var $aS5cv = parcelRequire("aS5cv");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b9842932469a1ca3$var$ModalHeaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_jhqfpxbi",
            __cmplp.className
        ])
    });
});
const $b9842932469a1ca3$var$styles = {
    header: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx2vrvc _4cvr1h6o _18u01ejb",
    headerLayout: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx21bp4",
    title: "_n3tdpxbi",
    textField: "_19pkpxbi _1bsbdgin",
    searchIconWrapper: "_1yt41b66 _1e0c116y _4cvr1h6o"
};
const $b9842932469a1ca3$var$i18n = (0, $cgtv4.defineMessages)({
    clearFilterLabel: {
        id: "space-access-details.access-details-dialog.clear-filter",
        defaultMessage: "Clear selection"
    },
    countOfIndividualsSuffix: {
        id: "space-access-details.access-details-dialog.count-of-groups-and-individuals-suffix",
        defaultMessage: "and {countOfIndividuals, plural, one {# individual} other {# individuals}}"
    },
    countOfGroups: {
        id: "space-access-details.access-details-dialog.count-of-groups",
        defaultMessage: "Search {countOfGroups, plural, one {# group} other {# groups}}"
    },
    countOfIndividuals: {
        id: "space-access-details.access-details-dialog.count-of-individuals",
        defaultMessage: "Search {countOfIndividuals, plural, one {# individual} other {# individuals}}"
    },
    countOfTeamsMiddleClause: {
        id: "space-access-details.access-details-dialog.count-of-teams-middle-clause",
        defaultMessage: "{countOfTeams, plural, one {# team} other {# teams}}"
    },
    countOfTeams: {
        id: "space-access-details.access-details-dialog.count-of-teams",
        defaultMessage: "Search {countOfTeams, plural, one {# team} other {# teams}}"
    },
    countOfTeamsSuffix: {
        id: "space-access-details.access-details-dialog.count-of-teams-suffix",
        defaultMessage: "and {countOfTeams, plural, one {# team} other {# teams}}"
    }
});
const $b9842932469a1ca3$export$a96f881061864293 = ({ hasInheritedRestrictions: hasInheritedRestrictions, onClose: onClose, filterText: filterText, setFilterText: setFilterText, spaceInfo: spaceInfo, contentInfo: contentInfo, isLoading: isLoading, appliedFilterText: appliedFilterText })=>{
    const intl = (0, $8C5kA.default)();
    const handleFilterTextChange = (event)=>{
        setFilterText(event.currentTarget.value);
    };
    let countOfIndividuals;
    let countOfGroups;
    let countOfTeams;
    if (hasInheritedRestrictions) {
        countOfIndividuals = contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.userCount;
        countOfTeams = contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes?.filter((subject)=>subject?.group?.usageType === (0, $aS5cv.ConfluenceGroupUsageType).TEAM_COLLABORATION).length;
        const totalCount = contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.groupCount;
        countOfGroups = totalCount && totalCount - countOfTeams;
    } else {
        countOfIndividuals = spaceInfo?.spacePermissions?.subjectsWithPermissions?.userCount || 0;
        countOfTeams = spaceInfo?.spacePermissions?.subjectsWithPermissions?.nodes?.filter((subject)=>subject?.subjectKey?.group?.usageType === (0, $aS5cv.ConfluenceGroupUsageType).TEAM_COLLABORATION).length;
        const totalCount = spaceInfo?.spacePermissions?.subjectsWithPermissions?.groupCount;
        countOfGroups = totalCount && totalCount - countOfTeams;
    }
    let placeholder; // Input cleared but filter is still there - prevent flashing of placeholder
    if (isLoading || appliedFilterText && !filterText) placeholder = '';
    else {
        if (countOfIndividuals && countOfGroups && countOfTeams) placeholder = `${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfGroups, {
            countOfGroups: countOfGroups
        })}, ${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfTeamsMiddleClause, {
            countOfTeams: countOfTeams
        })}, ${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfIndividualsSuffix, {
            countOfIndividuals: countOfIndividuals
        })}`;
        else if (countOfGroups && countOfIndividuals) placeholder = `${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfGroups, {
            countOfGroups: countOfGroups
        })} ${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfIndividualsSuffix, {
            countOfIndividuals: countOfIndividuals
        })}`;
        else if (countOfIndividuals && countOfTeams) placeholder = `${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfTeams, {
            countOfTeams: countOfTeams
        })} ${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfIndividualsSuffix, {
            countOfIndividuals: countOfIndividuals
        })}`;
        else if (countOfTeams && countOfGroups) placeholder = `${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfGroups, {
            countOfGroups: countOfGroups
        })} ${intl.formatMessage($b9842932469a1ca3$var$i18n.countOfTeamsSuffix, {
            countOfTeams: countOfTeams
        })}`;
        else if (countOfTeams) placeholder = intl.formatMessage($b9842932469a1ca3$var$i18n.countOfTeams, {
            countOfTeams: countOfTeams
        });
        else if (countOfGroups) placeholder = intl.formatMessage($b9842932469a1ca3$var$i18n.countOfGroups, {
            countOfGroups: countOfGroups
        });
        else placeholder = intl.formatMessage($b9842932469a1ca3$var$i18n.countOfIndividuals, {
            countOfIndividuals: countOfIndividuals
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9842932469a1ca3$var$ModalHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        className: (0, $gMc0m.default)([
            $b9842932469a1ca3$var$styles.headerLayout
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        className: (0, $gMc0m.default)([
            $b9842932469a1ca3$var$styles.title
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default // TODO: Update the attribute below so it is translated.
    ), {
        // eslint-disable-next-line no-restricted-syntax, @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": "Back",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
            label: ""
        }),
        onClick: onClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, hasInheritedRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "space-access-details.access-details-dialog.restricting-page-header",
        defaultMessage: "Who has access to the parent item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "space-access-details.access-details-dialog.restricting-space-header",
        defaultMessage: "Who has access to this space"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        className: (0, $gMc0m.default)([
            $b9842932469a1ca3$var$styles.header
        ])
    }, !hasInheritedRestrictions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i2ukN.SpaceDescription), {
        spaceInfo: spaceInfo,
        isLoading: isLoading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $25ZwL.ContentDescription), {
        contentInfo: contentInfo,
        isLoading: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
        "aria-label": placeholder,
        autoFocus: true,
        placeholder: placeholder,
        value: filterText,
        onChange: handleFilterTextChange,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            className: (0, $gMc0m.default)([
                $b9842932469a1ca3$var$styles.searchIconWrapper
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
            spacing: "spacious",
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, Boolean(filterText) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle",
            "aria-label": intl.formatMessage($b9842932469a1ca3$var$i18n.clearFilterLabel),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }),
            onClick: ()=>setFilterText('')
        })),
        className: (0, $gMc0m.default)([
            $b9842932469a1ca3$var$styles.textField
        ])
    }))));
};
module.exports["AccessDetailsDialogHeader"] = $b9842932469a1ca3$export$a96f881061864293;

});

parcelRegister("25ZwL", function(module, exports) {
/* ContentDescription.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $13WX1 = parcelRequire("13WX1");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");

const $aef3854608361508$var$PageDescriptionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $aef3854608361508$var$PageDescriptionLabel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _1e0c1o8l _1jtp1r31 _1wxd8stv _1cbrnqa1 _71j9i7uo",
            __cmplp.className
        ])
    });
});
const $aef3854608361508$export$9435e8786e5b8e8f = ({ contentInfo: contentInfo })=>{
    const path = contentInfo?.singleContent?.links?.webui;
    const pageUrl = `${(0, $jlIaF.CONTEXT_PATH)}${path}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($aef3854608361508$var$PageDescriptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13WX1.default), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($aef3854608361508$var$PageDescriptionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        to: pageUrl,
        target: "_blank",
        testId: "parent-page-link"
    }, contentInfo?.singleContent?.title)));
};
module.exports["ContentDescription"] = $aef3854608361508$export$9435e8786e5b8e8f;

});

parcelRegister("8lYIw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8T1Wf = parcelRequire("8T1Wf");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { target: target, name: name, href: href = null, to: to = null, params: params = {} } = props;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: ""
    });
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    return match && target !== '_blank' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
        ...props,
        ref: ref,
        match: match
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
        ...props,
        ref: ref,
        path: path
    });
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $42omo.forwardRef)(({ path: path, ...parentProps }, ref)=>{
    const { children: children, className: className, target: target, testId: testId, style: style, id: id } = parentProps;
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    const onAnchorLinkClick = (e)=>{
        // @ts-ignore this should probably be `e.currentTarget`
        onPageReload(e.target.getAttribute('href'), false);
        if (parentProps.onClick) parentProps.onClick(e);
    };
    const onAnchorContextMenuClick = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: path,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onAnchorLinkClick,
        onContextMenu: onAnchorContextMenuClick,
        target: target,
        id: id,
        rel: target === '_blank' ? 'noreferrer' : undefined,
        "data-testid": testId,
        ref: ref,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children));
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ match: match, ...parentProps }, ref)=>{
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    const onMouseDownCapture = async ()=>preloadRoute(match);
    /**
   * Define the `onClick` handler for `react-router-dom`
   * [Link](https://github.com/ReactTraining/react-router/blob/346153e38365e6a88657ce2e4e5acada290fc430/packages/react-router-dom/modules/Link.js)
   * to make sure the SPA transition will go through RouteManager's push
   * method. Under the hood `RouteManager#push` still calls `history.push`, but
   * in addition it can reach out specified route policy if any. If not
   * eligible for SPA transition, then it will continue delegate to
   * react-router-dom Link to handle the click.
   */ const onClick = (event)=>{
        if (parentProps.onClick) parentProps.onClick(event);
        const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
        if (!event.defaultPrevented && details?.href) {
            event.preventDefault();
            routesContext.push(details.href);
        }
    };
    const onContextMenu = (e)=>{
        parentProps.onContextMenu?.(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8T1Wf.Link), {
        to: `${match.pathname}${match.search}${match.hash}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        onClick: onClick,
        onContextMenu: onContextMenu,
        onMouseDownCapture: onMouseDownCapture,
        innerRef: ref,
        id: id,
        "aria-label": parentProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("8T1Wf", function(module, exports) {

var $QU6QS = parcelRequire("QU6QS");


var $4tRVV = parcelRequire("4tRVV");


var $42omo = parcelRequire("42omo");


var $fgJFQ = parcelRequire("fgJFQ");




var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");


var $dRnqM = parcelRequire("dRnqM");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $6784f6b3e56cd8b3$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $6784f6b3e56cd8b3$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $fgJFQ.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
var $6784f6b3e56cd8b3$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $fgJFQ.createLocation)(to, null, null, currentLocation) : to;
};
var $6784f6b3e56cd8b3$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef === "undefined") $6784f6b3e56cd8b3$var$forwardRef = $6784f6b3e56cd8b3$var$forwardRefShim;
function $6784f6b3e56cd8b3$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $6784f6b3e56cd8b3$var$LinkAnchor = $6784f6b3e56cd8b3$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $bDniu.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $7Q5yr.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$6784f6b3e56cd8b3$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a = $6784f6b3e56cd8b3$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $6784f6b3e56cd8b3$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $bDniu.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var history = context.history;
        var location = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $7Q5yr.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $6784f6b3e56cd8b3$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $fgJFQ.createPath)(context.location) === (0, $fgJFQ.createPath)($6784f6b3e56cd8b3$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim !== $6784f6b3e56cd8b3$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(component, props);
    });
});
var $6784f6b3e56cd8b3$var$toType, $6784f6b3e56cd8b3$var$refType;
var $6784f6b3e56cd8b3$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $6784f6b3e56cd8b3$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef;
if (typeof $6784f6b3e56cd8b3$var$forwardRef$1 === "undefined") $6784f6b3e56cd8b3$var$forwardRef$1 = $6784f6b3e56cd8b3$var$forwardRefShim$1;
function $6784f6b3e56cd8b3$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $6784f6b3e56cd8b3$export$b0d92dbee9b5b60d = $6784f6b3e56cd8b3$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $bDniu.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.__RouterContext).Consumer, null, function(context) {
        !context && (0, $dRnqM.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $6784f6b3e56cd8b3$var$normalizeToLocation($6784f6b3e56cd8b3$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $QU6QS.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $6784f6b3e56cd8b3$var$joinClassnames(className, activeClassName);
            style = (0, $7Q5yr.default)({}, style, activeStyle);
        }
        var props = (0, $7Q5yr.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($6784f6b3e56cd8b3$var$forwardRefShim$1 !== $6784f6b3e56cd8b3$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6784f6b3e56cd8b3$export$a6c7ac8248d6e38a, props);
    });
});
var $6784f6b3e56cd8b3$var$ariaCurrentType;
module.exports["Link"] = $6784f6b3e56cd8b3$export$a6c7ac8248d6e38a;

});

parcelRegister("i2ukN", function(module, exports) {
/* SpaceDescription.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $esRft = parcelRequire("esRft");


var $8lYIw = parcelRequire("8lYIw");


var $1NBp8 = parcelRequire("1NBp8");

const $3f0be1a6cd78921a$var$SpaceDescriptionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $3f0be1a6cd78921a$var$SpaceDescriptionLabel = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _1e0c1o8l _syazi7uo _fzbr1r31 _17ku8stv _1rj5nqa1 _ii85i7uo",
            __cmplp.className
        ])
    });
});

const $3f0be1a6cd78921a$export$cfbfa0f452e3e9c = ({ spaceInfo: spaceInfo, isLoading: isLoading })=>{
    const space = spaceInfo?.space;
    const spaceKey = space?.key;
    const spaceUrl = spaceKey ? (0, $1NBp8.SPACE_OVERVIEW).toUrl({
        spaceKey: spaceKey
    }) : '';
    const [iconPath, setIconPath] = (0, $42omo.useState)(space?.icon?.path);
    const isPersonalSpace = space?.type === 'personal';
    (0, $42omo.useEffect)(()=>{
        if (!isLoading && space?.icon?.path && space?.icon?.path !== iconPath) setIconPath(space.icon.path);
    }, [
        space?.icon?.path,
        isLoading,
        iconPath
    ]);
    const avatarSrc = !isPersonalSpace && iconPath ? iconPath : (parcelRequire("cqnC0"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3f0be1a6cd78921a$var$SpaceDescriptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarSrc,
        size: "xsmall",
        appearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($3f0be1a6cd78921a$var$SpaceDescriptionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
        to: spaceUrl,
        target: "_blank",
        testId: "space-overview-link"
    }, spaceInfo?.space?.name)));
};
module.exports["SpaceDescription"] = $3f0be1a6cd78921a$export$cfbfa0f452e3e9c;

});

parcelRegister("cqnC0", function(module, exports) {
module.exports = new URL("personal_space.c63f5733.png", import.meta.url).toString();

});

parcelRegister("aS5cv", function(module, exports) {
/**
 * @generated SignedSource<<e813746907e0ce5abcc7eca94b3eb380>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $5dbfd5f539b4fa90$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $5dbfd5f539b4fa90$export$7c562381fe299c25 = /*#__PURE__*/ function(ContentPermissionType) {
    ContentPermissionType["EDIT"] = "EDIT";
    ContentPermissionType["VIEW"] = "VIEW";
    return ContentPermissionType;
}({});
var $5dbfd5f539b4fa90$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $5dbfd5f539b4fa90$export$e7c9280c9da1cc0a;
module.exports["SitePermissionType"] = $5dbfd5f539b4fa90$export$8995abb8169b2cb8;

});

parcelRegister("kDHiY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1DHa6 = parcelRequire("1DHa6");


var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $6F6hl = parcelRequire("6F6hl");


var $4B2M3 = parcelRequire("4B2M3");


var $g3thj = parcelRequire("g3thj");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $a7PZ9 = parcelRequire("a7PZ9");


var $aS5cv = parcelRequire("aS5cv");


var $1YM7C = parcelRequire("1YM7C");


var $5pfuH = parcelRequire("5pfuH");

const $c2ed31214ba9baeb$var$specificAccessContainer = (0, $ecnYn.xcss)({
    paddingBottom: 'space.250'
});
const $c2ed31214ba9baeb$var$i18n = (0, $cgtv4.defineMessages)({
    countOfSubjects: {
        id: "space-access-details.access-details-dialog.count-of-subjects",
        defaultMessage: "{countOfSubjects, plural,=0 {No suggestions found.} one {# suggestion found.} other {# suggestions found.}}"
    }
});
function $c2ed31214ba9baeb$var$parseSpaceInfoSubjects(spaceInfo, extraTeamData) {
    return (spaceInfo?.spacePermissions?.subjectsWithPermissions?.nodes || []).map((item)=>{
        if (item?.subjectKey?.principalType === (0, $1YM7C.ConfluencePrincipalType).USER) return {
            id: item?.subjectKey?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).USER,
            displayName: item?.subjectKey?.displayName,
            avatarUrl: item?.subjectKey?.user?.profilePicture?.path || '',
            secondLine: item?.subjectKey?.user?.email,
            isGuest: item?.subjectKey?.user?.permissionType === (0, $1YM7C.SitePermissionType).EXTERNAL
        };
        else if (item?.subjectKey?.principalType === (0, $1YM7C.ConfluencePrincipalType).GROUP && item.subjectKey?.group?.usageType === (0, $aS5cv.ConfluenceGroupUsageType).TEAM_COLLABORATION && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) return {
            id: item?.subjectKey?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).TEAM,
            displayName: item?.subjectKey.displayName,
            isGuest: item?.subjectKey.group?.permissionType === (0, $aS5cv.SitePermissionType).EXTERNAL,
            avatarUrl: extraTeamData?.find((team)=>team.id === item.subjectKey?.id)?.largeAvatarImageUrl,
            verified: extraTeamData?.find((team)=>team.id === item.subjectKey?.id)?.isVerified
        };
        // else not a user, so it must be a group
        return {
            id: item?.subjectKey?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).GROUP,
            displayName: item?.subjectKey?.displayName,
            isGuest: item?.subjectKey?.group?.permissionType === (0, $1YM7C.SitePermissionType).EXTERNAL
        };
    });
}
function $c2ed31214ba9baeb$var$parseContentInfoSubjects(contentInfo, extraTeamData) {
    return (contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || []).map((item)=>{
        if (item?.type === (0, $a7PZ9.PRINCIPAL_TYPE).USER) return {
            id: item?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).USER,
            displayName: item?.displayName,
            isGuest: item?.user?.permissionType === (0, $aS5cv.SitePermissionType).EXTERNAL,
            avatarUrl: item?.user?.profilePicture?.path || '',
            secondLine: item?.user?.email
        };
        else if (item?.type === (0, $a7PZ9.PRINCIPAL_TYPE).GROUP && item.group?.usageType === (0, $aS5cv.ConfluenceGroupUsageType).TEAM_COLLABORATION) return {
            id: item?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).TEAM,
            displayName: item?.displayName,
            isGuest: item?.group?.permissionType === (0, $aS5cv.SitePermissionType).EXTERNAL,
            avatarUrl: extraTeamData?.find((team)=>team.id === item.id)?.largeAvatarImageUrl,
            verified: extraTeamData?.find((team)=>team.id === item.id)?.isVerified
        };
        // else not a user, so it must be a group
        return {
            id: item?.id,
            type: (0, $a7PZ9.PRINCIPAL_TYPE).GROUP,
            displayName: item?.displayName,
            isGuest: item?.group?.permissionType === (0, $aS5cv.SitePermissionType).EXTERNAL
        };
    });
}
const $c2ed31214ba9baeb$export$4459f2b09704bade = ({ spaceInfo: spaceInfo, contentInfo: contentInfo, hasInheritedRestrictions: hasInheritedRestrictions, handleContentAccessDetailsFetchMore: handleContentAccessDetailsFetchMore, handleSpaceAccessDetailsFetchMore: handleSpaceAccessDetailsFetchMore, isLoading: isLoading })=>{
    const intl = (0, $8C5kA.default)();
    const [subjectListCount, setSubjectListCount] = (0, $42omo.useState)(null);
    const [extraTeamData, setExtraTeamData] = (0, $42omo.useState)([]);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    /*
           Removing bold highlighting of search match sections due to:
           https://asecurityteam.atlassian.net/browse/VULN-1084090
            Ticket for bringing that feature back:
           https://product-fabric.atlassian.net/browse/CPE-1437
      */ const subjectList = hasInheritedRestrictions ? $c2ed31214ba9baeb$var$parseContentInfoSubjects(contentInfo, extraTeamData) : $c2ed31214ba9baeb$var$parseSpaceInfoSubjects(spaceInfo, extraTeamData);
    const hasNextPage = hasInheritedRestrictions ? Boolean(contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.pageInfo?.hasNextPage) : Boolean(spaceInfo?.spacePermissions?.subjectsWithPermissions?.pageInfo?.hasNextPage);
    const nextPageCursor = hasInheritedRestrictions ? contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.pageInfo?.endCursor : spaceInfo?.spacePermissions?.subjectsWithPermissions?.pageInfo?.endCursor;
    const handleFetchMore = hasInheritedRestrictions ? handleContentAccessDetailsFetchMore : handleSpaceAccessDetailsFetchMore;
    (0, $42omo.useEffect)(()=>{
        // Delay to ensure Assistive Technology registers the live region before update
        // Also delay so screen readers announce the count last
        const timer = setTimeout(()=>{
            setSubjectListCount(subjectList.length);
        }, 5000);
        return ()=>clearTimeout(timer);
    }, [
        subjectList
    ]);
    (0, $42omo.useEffect)(()=>{
        const teamsFromSpaceInfo = (spaceInfo?.spacePermissions?.subjectsWithPermissions?.nodes || []).filter((item)=>item?.subjectKey?.group && item.subjectKey.group.usageType === (0, $aS5cv.ConfluenceGroupUsageType).TEAM_COLLABORATION);
        const teamIdsFromSpaceInfo = (teamsFromSpaceInfo || []).map((item)=>item?.subjectKey?.group && item?.subjectKey?.group?.id || '');
        const fetchTeamDataFromAPI = async ()=>{
            if (teamIdsFromSpaceInfo && teamIdsFromSpaceInfo.length > 0 && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) {
                const resolveTeamData = async ()=>{
                    const teamData = await (0, $g3thj.fetchTeamData)(cloudId, teamIdsFromSpaceInfo);
                    return {
                        teamData: teamData
                    };
                };
                const { teamData: teamData } = await resolveTeamData();
                if (teamData) setExtraTeamData(teamData);
            }
        };
        fetchTeamDataFromAPI();
    }, [
        spaceInfo,
        cloudId,
        spaceInfo?.spacePermissions?.subjectsWithPermissions?.nodes
    ]);
    (0, $42omo.useEffect)(()=>{
        const teamsFromContentInfo = (contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes || []).filter((item)=>item && item?.group && item.group.usageType === (0, $aS5cv.ConfluenceGroupUsageType).TEAM_COLLABORATION);
        const teamIdsFromContentInfo = teamsFromContentInfo.map((item)=>item?.group && item.group.id || '');
        const fetchTeamDataFromAPI = async ()=>{
            if (teamIdsFromContentInfo && teamIdsFromContentInfo.length > 0 && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) {
                const resolveTeamData = async ()=>{
                    const teamData = await (0, $g3thj.fetchTeamData)(cloudId, teamIdsFromContentInfo);
                    return {
                        teamData: teamData
                    };
                };
                const { teamData: teamData } = await resolveTeamData();
                if (teamData) setExtraTeamData(teamData);
            }
        };
        fetchTeamDataFromAPI();
    }, [
        spaceInfo,
        cloudId,
        contentInfo?.contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.150",
        alignInline: "start",
        grow: "fill",
        as: "div",
        xcss: $c2ed31214ba9baeb$var$specificAccessContainer
    }, subjectList.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pfuH.AccessDetailsPrincipal), {
            ...item,
            key: item.id
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, intl.formatMessage($c2ed31214ba9baeb$var$i18n.countOfSubjects, {
        countOfSubjects: subjectListCount
    }))), !isLoading && hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4B2M3.ObservableSpinner), {
        onScrollTo: ()=>{
            handleFetchMore(nextPageCursor);
        },
        cursor: nextPageCursor,
        testId: "access-details-spinner",
        observerOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        }
    }));
};
module.exports["AccessDetailsDialogBody"] = $c2ed31214ba9baeb$export$4459f2b09704bade;

});

parcelRegister("4B2M3", function(module, exports) {
/* ObservableSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $l8oxh = parcelRequire("l8oxh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd6b86c893b680$var$SpinnerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41bpf _1reo15vq _18m915vq _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$export$9c05ccc6295d539b = ({ onScrollTo: onScrollTo, testId: testId, cursor: cursor, observerOptions: observerOptions, spinnerSize: spinnerSize = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l8oxh.InfiniteScroll), {
        onScrollTo: onScrollTo,
        cursor: cursor,
        observerOptions: observerOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: spinnerSize,
        testId: testId
    }))));
};
module.exports["ObservableSpinner"] = $5ccd6b86c893b680$export$9c05ccc6295d539b;

});

parcelRegister("l8oxh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cb0d4ce40dbff1b4$export$c5295390d6167a3e = ({ onScrollTo: onScrollTo, cursor: cursor, observerOptions: observerOptions, children: children })=>{
    const loaderTarget = (0, $42omo.useRef)(null);
    const previousCursor = (0, $42omo.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const handleIntersect = (0, $42omo.useCallback)((entries)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (entries.length > 1) entries.shift();
        // On the first scroll the previousCursor = null and cursor is a string or undefined
        // Intersection can occur multiple times but we only call onScrollTo again if we have a new cursor.
        if (entries?.[0]?.isIntersecting && cursor !== previousCursor.current) {
            previousCursor.current = cursor;
            onScrollTo();
        }
    }, [
        onScrollTo,
        cursor
    ]);
    // IntersectionObserver detects when our target element becomes visible
    (0, $42omo.useEffect)(()=>{
        // Adding a positive 'rootMargin' and setting 'root' to the scroll container *should* trigger
        // a positive 'intersection' result (thus loading results) before this element even comes into view
        // (when it is Xpx away from the viewport). 'rootMargin' follows CSS 'margin' syntax.
        // However, this doesn't seem to be working, intersection only triggers when element is in viewport.
        // Have also attempted to pass in a ref from the table tree container instead of querying the document,
        // but that also does not work.
        // @TODO figure out what is wrong here.
        // eslint-disable-next-line
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
        const target = loaderTarget?.current;
        if (target) observer.observe(target);
        return ()=>{
            if (target) observer.unobserve(target);
            observer.disconnect();
        };
    }, [
        loaderTarget,
        handleIntersect,
        observerOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb0d4ce40dbff1b4$var$LoaderTarget, {
        ref: loaderTarget
    }, children);
};
const $cb0d4ce40dbff1b4$var$LoaderTarget = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref
    }, children));
module.exports["InfiniteScroll"] = $cb0d4ce40dbff1b4$export$c5295390d6167a3e;

});

parcelRegister("g3thj", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");

const $9b8e67484cd1041b$export$54b1026b74f600fc = async (siteId, teamIds)=>{
    const teamsRestApiUrl = `/gateway/api/v4/teams/withMembers/bulk`;
    const response = await (0, $f7B1p.cfetch)(teamsRestApiUrl, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            siteId: siteId,
            teamIds: teamIds
        })
    });
    const body = await response.json();
    return body.teams.map((team)=>({
            id: team.id,
            isVerified: team.isVerified,
            largeAvatarImageUrl: team.largeAvatarImageUrl
        }));
};
module.exports["fetchTeamData"] = $9b8e67484cd1041b$export$54b1026b74f600fc;

});

parcelRegister("a7PZ9", function(module, exports) {
var $e0035cf7a1f09457$export$6162b8d0c6ca280e = /*#__PURE__*/ function(PRINCIPAL_TYPE) {
    PRINCIPAL_TYPE["GROUP"] = "group";
    PRINCIPAL_TYPE["USER"] = "user";
    PRINCIPAL_TYPE["TEAM"] = "team";
    PRINCIPAL_TYPE["EMAIL"] = "email";
    return PRINCIPAL_TYPE;
}({});
module.exports["PRINCIPAL_TYPE"] = $e0035cf7a1f09457$export$6162b8d0c6ca280e;

});

parcelRegister("1YM7C", function(module, exports) {
/**
 * @generated SignedSource<<37eff0f921f167aa63a8ab54e3b9bd8b>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $a35a95984797f088$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $a35a95984797f088$export$aa5f3445d469c06b = /*#__PURE__*/ function(ConfluencePrincipalType) {
    ConfluencePrincipalType["GROUP"] = "GROUP";
    ConfluencePrincipalType["USER"] = "USER";
    return ConfluencePrincipalType;
}({});
var $a35a95984797f088$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $a35a95984797f088$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["ConfluencePrincipalType"] = $a35a95984797f088$export$aa5f3445d469c06b;
module.exports["SitePermissionType"] = $a35a95984797f088$export$8995abb8169b2cb8;

});

parcelRegister("5pfuH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $lebfc = parcelRequire("lebfc");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $lE8sM = parcelRequire("lE8sM");


var $gvWVt = parcelRequire("gvWVt");


var $9wGTI = parcelRequire("9wGTI");


var $a7PZ9 = parcelRequire("a7PZ9");


var $7hNjr = parcelRequire("7hNjr");

const $da6103091262273a$var$lozengeStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100'
});
const $da6103091262273a$var$groupDetailsStyle = (0, $ecnYn.xcss)({
    overflowWrap: 'anywhere'
});
const $da6103091262273a$var$iconContainer = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full',
    width: '36px',
    height: '36px',
    backgroundColor: 'color.background.neutral',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    marginTop: 'space.0'
});
const $da6103091262273a$export$f007836d4a3cd6a4 = ({ type: type, id: id, displayName: displayName, secondLine: secondLine, avatarUrl: avatarUrl, isGuest: isGuest, verified: verified })=>{
    const groupId = type === (0, $a7PZ9.PRINCIPAL_TYPE).GROUP ? id : null;
    const teamId = type === (0, $a7PZ9.PRINCIPAL_TYPE).TEAM ? id : null;
    if (type === 'user') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl,
        appearance: "circle",
        size: "medium",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, displayName), isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $da6103091262273a$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtlest"
    }, secondLine))));
    else if (type === 'team' && (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        testId: "team-principal",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: avatarUrl,
        appearance: "square",
        size: "medium",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text"
    }, displayName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hNjr.GroupCountComponent), {
        groupId: teamId,
        isGroup: false,
        isVerified: verified
    })))));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        alignBlock: "center",
        testId: "group-principal",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $da6103091262273a$var$iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        label: "",
        size: "32",
        appearance: "gray",
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lebfc)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $da6103091262273a$var$groupDetailsStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), null, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hNjr.GroupCountComponent), {
        groupId: groupId,
        isGroup: type === 'group',
        isVerified: false
    }))));
};
module.exports["AccessDetailsPrincipal"] = $da6103091262273a$export$f007836d4a3cd6a4;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("7hNjr", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $gtD4K = parcelRequire("gtD4K");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $6Arkp = parcelRequire("6Arkp");


var $9wGTI = parcelRequire("9wGTI");

const $2600cade940e6680$var$GroupCountComponentAccessDetailsGroupCountsQuery = (0, $eSUdr.default)`query GroupCountComponentAccessDetailsGroupCountsQuery($groupIdList:[String]){groupCounts(groupIds:$groupIdList){groupCounts{key value}}}`;
const $2600cade940e6680$var$useGroupCount = (id)=>{
    const { loading: loading, data: data } = (0, $xQxzY.useQuery)($2600cade940e6680$var$GroupCountComponentAccessDetailsGroupCountsQuery, {
        variables: {
            groupIdList: id !== undefined ? [
                id
            ] : null
        },
        skip: !id
    });
    if (loading) return null;
    const count = data?.groupCounts?.groupCounts?.[0]?.value;
    if (typeof count === 'number') return count;
};
const $2600cade940e6680$export$70eb39fe733e9d05 = ({ groupId: groupId, isGroup: isGroup, isVerified: isVerified })=>{
    const count = $2600cade940e6680$var$useGroupCount(groupId);
    const teamOrGroupByline = ()=>{
        if (isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "space-access-details.access-details-table.header.admin-group",
            defaultMessage: "Admin group"
        });
        else return isVerified ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "space-access-details.access-details-table.header.official-team",
            defaultMessage: "Official team"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "space-access-details.access-details-table.header.team",
            defaultMessage: "Team"
        });
    };
    if (!count) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        testId: "group-count-component",
        space: "space.050",
        alignBlock: "center"
    }, (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small",
        testId: "member-count-subtext"
    }, teamOrGroupByline()), (isVerified || isGroup) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Arkp.VerifiedTeamLozenge), {
        isTeam: !isGroup,
        spacing: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "space-access-details.access-details-table.header.principal",
        defaultMessage: "\u2022 {count, plural, one {# member} other {# members}}",
        values: {
            count: count
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "space-access-details.access-details-table.header.principal",
        defaultMessage: "{count, plural, one {# person} other {# people}}",
        values: {
            count: count
        }
    }));
};
module.exports["GroupCountComponent"] = $2600cade940e6680$export$70eb39fe733e9d05;

});

parcelRegister("6Arkp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $bh5s2 = parcelRequire("bh5s2");


var $3gadb = parcelRequire("3gadb");

const $872f21f495f2e757$var$i18n = (0, $cgtv4.defineMessages)({
    teamVerifiedLozengeTooltip: {
        id: "space-utils.verified-lozenge.tooltip",
        defaultMessage: "This team is verified because it is controlled by an organization admin."
    },
    groupVerifiedLozengeTooltip: {
        id: "space-utils.verified-lozenge.tooltip",
        defaultMessage: "This group is verified because it is controlled by an organization admin."
    }
});
const $872f21f495f2e757$export$ba3ff7dd3e281a6b = ({ isTeam: isTeam = true, spacing: spacing = 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: isTeam ? formatMessage($872f21f495f2e757$var$i18n.teamVerifiedLozengeTooltip) : formatMessage($872f21f495f2e757$var$i18n.groupVerifiedLozengeTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        label: "verified team",
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: "small",
        spacing: spacing
    }));
};
module.exports["VerifiedTeamLozenge"] = $872f21f495f2e757$export$ba3ff7dd3e281a6b;

});

parcelRegister("dzImV", function(module, exports) {
// Features combined with placements as found in https://www.figma.com/design/c5JCpE4Fdh4B8SVt2xoOvB/Confluence%3A-Prompt-for-payment-on-paid-feautres
const $8cb719031efeaa2b$export$f6d85b85b6c620f5 = 'itfg-bnr-page-analytics-modal';
const $8cb719031efeaa2b$export$2495b6fbc3fc1bff = 'itfg-bnr-page-analytics-page';
const $8cb719031efeaa2b$export$4a7b6a415b5b4246 = 'itfg-bnr-page-restrictions-modal';
const $8cb719031efeaa2b$export$cbd8370df04a657a = 'itfg-bnr-automation-page';
const $8cb719031efeaa2b$export$9743380173eac25c = 'itfg-bnr-space-analytics-page';
const $8cb719031efeaa2b$export$28b898ecceafa8c3 = 'itfg-bnr-team-calendar-page';
const $8cb719031efeaa2b$export$70c25ef275d61c94 = 'itfg-bnr-usd-modal';
const $8cb719031efeaa2b$export$3275adca28abf19a = 'premium';
const $8cb719031efeaa2b$export$2fbb79dba909cd48 = 'standard';
module.exports["FEATURE_ID_PAGE_ANALYTICS_MODAL"] = $8cb719031efeaa2b$export$f6d85b85b6c620f5;
module.exports["FEATURE_ID_PAGE_ANALYTICS_PAGE"] = $8cb719031efeaa2b$export$2495b6fbc3fc1bff;
module.exports["FEATURE_ID_PAGE_RESTRICTIONS_MODAL"] = $8cb719031efeaa2b$export$4a7b6a415b5b4246;
module.exports["FEATURE_ID_AUTOMATION_PAGE"] = $8cb719031efeaa2b$export$cbd8370df04a657a;
module.exports["FEATURE_ID_SPACE_ANALYTICS_PAGE"] = $8cb719031efeaa2b$export$9743380173eac25c;
module.exports["FEATURE_ID_TEAM_CALENDAR_PAGE"] = $8cb719031efeaa2b$export$28b898ecceafa8c3;
module.exports["FEATURE_ID_USD_MODAL"] = $8cb719031efeaa2b$export$70c25ef275d61c94;
module.exports["EDITION_PREMIUM"] = $8cb719031efeaa2b$export$3275adca28abf19a;

});

parcelRegister("bcPlG", function(module, exports) {
const $63f2ffd6f4a8b946$export$e9129b434f0562a = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, source: source, type: type, name: name })=>({
        type: type,
        data: {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            source: source,
            ...name && {
                name: name
            }
        }
    });
module.exports["formatEventCallBackPayloadForAtlasKitAnalyticsEvent"] = $63f2ffd6f4a8b946$export$e9129b434f0562a;

});

parcelRegister("1vRwc", function(module, exports) {
/**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1Tx06 = parcelRequire("1Tx06");


var $6mKj3 = parcelRequire("6mKj3");


var $gKr8t = parcelRequire("gKr8t");


var $jMyy4 = parcelRequire("jMyy4");

const $508339af3e1dbf03$var$UseInTrialFeatureGatesExperimentEnrollmentABQuery = (0, $eSUdr.default)`query useInTrialFeatureGatesExperimentEnrollmentABQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement(where:{AND:[{inTrialOrPreDunning:true}]}){subscription{trial{endTimestamp}accountDetails{invoiceGroup{invoiceable experienceCapabilities{configurePaymentV2{experienceUrl isAvailableToUser}configurePayment{experienceUrl isAvailableToUser}}}}}}}}}`;
const $508339af3e1dbf03$export$45552391e022e54 = (props)=>{
    const aggClient = (0, $gKr8t.getAGGClient)();
    const queryResult = (0, $jMyy4.useQueryInterop)($508339af3e1dbf03$var$UseInTrialFeatureGatesExperimentEnrollmentABQuery, {
        client: aggClient,
        variables: {
            cloudId: props.tenantId
        },
        skip: !(0, $6mKj3.expValEquals)('confluence_relay_migration_no_client_passing', 'isEnabled', true)
    });
    const baseProps = (0, $6mKj3.expValEquals)('confluence_relay_migration_no_client_passing', 'isEnabled', true) ? {
        inTrialFeatureGatesQueryResult: queryResult,
        ...props
    } : {
        aggClient: aggClient,
        ...props
    };
    return (0, $1Tx06.useInTrialFeatureGatesExperimentEnrollmentAB)(baseProps);
};
module.exports["useInTrialFeatureGatesExperimentEnrollmentAB"] = $508339af3e1dbf03$export$45552391e022e54;

});

parcelRegister("1Tx06", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $5Xk8L = parcelRequire("5Xk8L");


var $ddBLb = parcelRequire("ddBLb");


var $j57x0 = parcelRequire("j57x0");

const $7ed1ab4755b609ab$var$COHORT = 'cohort';
const $7ed1ab4755b609ab$export$5b7423264d48ab04 = 'not-enrolled';
const $7ed1ab4755b609ab$export$c6528ba9c08031f7 = ({ experimentName: experimentName, isFeatureGateEnabled: isFeatureGateEnabled, featureId: featureId, sendTrackEvent: sendTrackEvent, sendOperationalEvent: sendOperationalEvent, skip: skip = false, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, tenantId: tenantId, ...props })=>{
    const { isValidAudience: isValidAudience, data: { hasPaymentDetailsOnFile: hasPaymentDetailsOnFile, canUserPayAndUpgrade: canUserPayAndUpgrade, daysLeftInTrial: daysLeftInTrial }, isLoading: isLoading } = (0, $ddBLb.useIsValidAudience)({
        tenantId: tenantId,
        sendOperationalEvent: sendOperationalEvent,
        featureId: featureId,
        skip: !isFeatureGateEnabled || skip,
        ...props
    });
    const { cohort: cohort, isTreatment: isTreatment, isEnrolled: isEnrolled, canRenderTreatment: canRenderTreatment } = (0, $42omo.useMemo)(()=>{
        if (skip || !isFeatureGateEnabled || !isValidAudience) return {
            cohort: (0, $j57x0.COHORTS).NOT_ENROLLED,
            isTreatment: false,
            isEnrolled: false,
            canRenderTreatment: false,
            isLoading: false
        };
        const cohort = (0, $c6GJD.default).getExperimentValue(experimentName, $7ed1ab4755b609ab$var$COHORT, $7ed1ab4755b609ab$export$5b7423264d48ab04, {
            fireExperimentExposure: false
        });
        if (cohort === (0, $j57x0.COHORTS).NOT_ENROLLED) return {
            cohort: (0, $j57x0.COHORTS).NOT_ENROLLED,
            isTreatment: false,
            isEnrolled: false,
            canRenderTreatment: false,
            isLoading: false
        };
        let canRenderTreatment = false;
        if (cohort === (0, $j57x0.COHORTS).TREATMENT && daysLeftInTrial) canRenderTreatment = !(0, $5Xk8L.isFeatureDismissedForPeriodInTrial)(featureId, daysLeftInTrial);
        // manually fire StatSig exposure event
        (0, $c6GJD.default).manuallyLogExperimentExposure(experimentName);
        sendTrackEvent({
            type: 'sendTrackEvent',
            action: 'exposed',
            actionSubject: 'experiment',
            actionSubjectId: `${experimentName}-exposed`,
            attributes: {
                cohort: cohort,
                hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
                canUserPayAndUpgrade: canUserPayAndUpgrade,
                canRenderTreatment: canRenderTreatment,
                daysLeftInTrial: daysLeftInTrial,
                featureId: featureId,
                ...extraAnalyticsAttributes
            },
            source: experimentName
        });
        return {
            cohort: cohort,
            isTreatment: cohort === (0, $j57x0.COHORTS).TREATMENT,
            isEnrolled: cohort === (0, $j57x0.COHORTS).TREATMENT || cohort === (0, $j57x0.COHORTS).CONTROL,
            canRenderTreatment: canRenderTreatment
        };
    // Ignoring createAnalyticsEvent as a dependency since it isn't a primitive value and can cause side effects. It also doesn't change between renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        skip,
        isFeatureGateEnabled,
        isValidAudience,
        experimentName,
        hasPaymentDetailsOnFile,
        canUserPayAndUpgrade,
        daysLeftInTrial,
        featureId,
        tenantId
    ]);
    return {
        cohort: cohort,
        isTreatment: isTreatment,
        isEnrolled: isEnrolled,
        canRenderTreatment: canRenderTreatment,
        isLoading: isLoading
    };
};
const $7ed1ab4755b609ab$export$45552391e022e54 = ({ featureId: featureId, tenantId: tenantId, sendTrackEvent: sendTrackEvent, sendOperationalEvent: sendOperationalEvent, skip: skip = false, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, ...props })=>{
    return $7ed1ab4755b609ab$export$c6528ba9c08031f7({
        experimentName: 'in_trial_feature_gates_ab',
        isFeatureGateEnabled: (0, $dh538.fg)('in_trial_feature_gates_ab_fg'),
        featureId: featureId,
        tenantId: tenantId,
        sendTrackEvent: sendTrackEvent,
        sendOperationalEvent: sendOperationalEvent,
        skip: skip,
        extraAnalyticsAttributes: extraAnalyticsAttributes,
        ...props
    });
};
module.exports["useInTrialFeatureGatesExperimentEnrollmentAB"] = $7ed1ab4755b609ab$export$45552391e022e54;

});

parcelRegister("5Xk8L", function(module, exports) {
function $f5c3a66c1ece75a4$export$476cad7b60124106(featureId, daysLeftInTrial) {
    const suffix = daysLeftInTrial > 3 ? 'sot' : 'eot';
    return `${featureId}_${suffix}`;
}
function $f5c3a66c1ece75a4$export$36992f6c91b0e47e(featureId, daysLeftInTrial) {
    // Adhere to SSR potential issues
    if (typeof window === 'undefined') return false;
    const key = $f5c3a66c1ece75a4$export$476cad7b60124106(featureId, daysLeftInTrial);
    return window.localStorage.getItem(key) !== null;
}
function $f5c3a66c1ece75a4$export$191d939d2860d296(featureId, daysLeftInTrial) {
    // Adhere to SSR potential issues
    if (typeof window === 'undefined') return;
    const key = $f5c3a66c1ece75a4$export$476cad7b60124106(featureId, daysLeftInTrial);
    window.localStorage.setItem(key, 'true');
}
module.exports["isFeatureDismissedForPeriodInTrial"] = $f5c3a66c1ece75a4$export$36992f6c91b0e47e;
module.exports["markFeatureAsDismissedForTrialPeriod"] = $f5c3a66c1ece75a4$export$191d939d2860d296;

});

parcelRegister("ddBLb", function(module, exports) {

var $7jjWP = parcelRequire("7jjWP");

const $a0d8fb5c8cb2a507$export$408b18df0eda87d1 = ({ tenantId: // Apps have different ways of getting the AGG client. Its not always as simple as useClient() and depends on the app's architecture.
// Therefore, we need to pass it in as a prop.
tenantId, sendOperationalEvent: sendOperationalEvent, featureId: featureId, skip: skip = false, ...props })=>{
    const { error: error, hasPaymentDetailsOnFile: hasPaymentDetailsOnFile, canUserPayAndUpgrade: canUserPayAndUpgrade, daysLeftInTrial: daysLeftInTrial, loading: loading } = (0, $7jjWP.useGetInTrialFeatureGateBannerData)({
        sendOperationalEvent: sendOperationalEvent,
        skip: skip,
        tenantId: tenantId,
        featureId: featureId,
        ...props
    });
    if (error || skip) return {
        isValidAudience: false,
        data: {
            hasPaymentDetailsOnFile: false,
            canUserPayAndUpgrade: false,
            daysLeftInTrial: undefined
        },
        isLoading: false
    };
    const isValidAudience = daysLeftInTrial !== undefined && daysLeftInTrial > 0 && !Boolean(hasPaymentDetailsOnFile) && Boolean(canUserPayAndUpgrade);
    return {
        isValidAudience: isValidAudience,
        // Returning the same data as useGetInTrialFeatureGateBannerData to allow us to leverage the same data for exposure analytics
        data: {
            hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
            canUserPayAndUpgrade: canUserPayAndUpgrade,
            daysLeftInTrial: daysLeftInTrial
        },
        isLoading: loading
    };
};
module.exports["useIsValidAudience"] = $a0d8fb5c8cb2a507$export$408b18df0eda87d1;

});

parcelRegister("7jjWP", function(module, exports) {

var $xQxzY = parcelRequire("xQxzY");


var $6ZXYe = parcelRequire("6ZXYe");


var $ekm5c = parcelRequire("ekm5c");

const $e31cbcc0cfebf616$export$cf372f2cfe52e989 = ({ tenantId: // Apps have different ways of getting the AGG client. Its not always as simple as useClient() and depends on the app's architecture.
// Therefore, we need to pass it in as a prop.
tenantId, sendOperationalEvent: sendOperationalEvent, featureId: featureId, skip: skip = false, ...props })=>{
    const aggClient = 'aggClient' in props ? props.aggClient : undefined;
    const { inTrialFeatureGatesQueryResult: inTrialFeatureGatesQueryResult } = 'inTrialFeatureGatesQueryResult' in props ? props : {
        inTrialFeatureGatesQueryResult: undefined
    };
    const queryResult = (0, $xQxzY.useQuery)((0, $6ZXYe.InTrialFeatureGatesBannerQuery), {
        client: aggClient,
        variables: {
            cloudId: tenantId
        },
        skip: skip || !!inTrialFeatureGatesQueryResult
    });
    const { data: data, error: error, loading: loading } = inTrialFeatureGatesQueryResult ?? queryResult;
    if (error) {
        sendOperationalEvent({
            type: 'sendOperationalEvent',
            action: 'error',
            actionSubject: 'luna-growth-experiment-graphql-error',
            actionSubjectId: `in-trial-feature-gates-banner-graphql-error`,
            attributes: {
                error: error?.message,
                extraInfo: 'extraInfo' in error ? error.extraInfo : undefined,
                graphqlErrors: 'graphQLErrors' in error ? error.graphQLErrors : undefined,
                networkErrors: 'networkError' in error ? error.networkError : undefined,
                tenantId: tenantId,
                featureId: featureId
            },
            source: 'in_trial_feature_gates_banner'
        });
        return {
            error: error,
            loading: !!loading,
            paymentFlowExperienceUrl: undefined,
            hasPaymentDetailsOnFile: false,
            canUserPayAndUpgrade: false,
            daysLeftInTrial: undefined
        };
    }
    const invoiceGroup = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup;
    const subscription = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription;
    const experienceCapabilities = invoiceGroup?.experienceCapabilities;
    /**
	 * Calculate core data for the in-trial feature gate banner
	 */ const paymentFlowExperienceUrl = (0, $ekm5c.addOriginToPaymentFlowUrl)({
        paymentExperienceUrlV1: experienceCapabilities?.configurePayment?.experienceUrl,
        paymentExperienceUrlV2: experienceCapabilities?.configurePaymentV2?.experienceUrl
    });
    const hasPaymentDetailsOnFile = !!subscription?.accountDetails?.invoiceGroup?.invoiceable;
    const canUserPayAndUpgrade = !!experienceCapabilities?.configurePaymentV2?.isAvailableToUser || !!experienceCapabilities?.configurePayment?.isAvailableToUser;
    const daysLeftInTrial = (0, $ekm5c.getTrialEndDate)(subscription?.trial?.endTimestamp);
    return {
        error: error,
        loading: !!loading,
        paymentFlowExperienceUrl: paymentFlowExperienceUrl,
        hasPaymentDetailsOnFile: hasPaymentDetailsOnFile,
        canUserPayAndUpgrade: canUserPayAndUpgrade,
        daysLeftInTrial: daysLeftInTrial
    };
};
module.exports["useGetInTrialFeatureGateBannerData"] = $e31cbcc0cfebf616$export$cf372f2cfe52e989;

});

parcelRegister("6ZXYe", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $6886a1d5065d514b$export$cf368a853317d665 = (0, $eSUdr.default)`query InTrialFeatureGatesBannerQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement(where:{AND:[{inTrialOrPreDunning:true}]}){subscription{trial{endTimestamp}accountDetails{invoiceGroup{invoiceable experienceCapabilities{configurePaymentV2{experienceUrl isAvailableToUser}configurePayment{experienceUrl isAvailableToUser}}}}}}}}}`;
module.exports["InTrialFeatureGatesBannerQuery"] = $6886a1d5065d514b$export$cf368a853317d665;

});

parcelRegister("ekm5c", function(module, exports) {

var $6Co6F = parcelRequire("6Co6F");


var $917iu = parcelRequire("917iu");

const $5457c328dde2b413$export$7abd679947855d17 = ({ paymentExperienceUrlV1: paymentExperienceUrlV1, paymentExperienceUrlV2: paymentExperienceUrlV2 })=>{
    const experienceUrl = paymentExperienceUrlV2 || paymentExperienceUrlV1;
    if (!experienceUrl) return undefined;
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(experienceUrl);
};
const $5457c328dde2b413$export$af328981d3bdc5ad = (endTimestamp)=>{
    if (!endTimestamp) return undefined;
    return (0, $917iu.default)(new Date(endTimestamp), new Date()) + 1;
};
module.exports["addOriginToPaymentFlowUrl"] = $5457c328dde2b413$export$7abd679947855d17;
module.exports["getTrialEndDate"] = $5457c328dde2b413$export$af328981d3bdc5ad;

});

parcelRegister("j57x0", function(module, exports) {
const $9dee5a21e345fde3$export$f1a98e82c0c821bd = {
    NOT_ENROLLED: 'not-enrolled',
    CONTROL: 'control',
    TREATMENT: 'treatment'
};
module.exports["COHORTS"] = $9dee5a21e345fde3$export$f1a98e82c0c821bd;

});

parcelRegister("lisqg", function(module, exports) {
/**
 * @graphql agg
 */ 
var $42omo = parcelRequire("42omo");


var $eSUdr = parcelRequire("eSUdr");


var $i1qvR = parcelRequire("i1qvR");


var $6mKj3 = parcelRequire("6mKj3");


var $gKr8t = parcelRequire("gKr8t");


var $jMyy4 = parcelRequire("jMyy4");

const $996b8fc8ba84aa6d$var$InTrialFeatureGatesBannerWithDataQuery = (0, $eSUdr.default)`query InTrialFeatureGatesBannerWithDataQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId])@optIn(to:["CcpAllUserUpgradeAndPay" "HamsAllUserUpgradeAndPay"]){entitlementInfo(hamsProductKey:"confluence.ondemand"){entitlement(where:{AND:[{inTrialOrPreDunning:true}]}){subscription{trial{endTimestamp}accountDetails{invoiceGroup{invoiceable experienceCapabilities{configurePaymentV2{experienceUrl isAvailableToUser}configurePayment{experienceUrl isAvailableToUser}}}}}}}}}`;
const $996b8fc8ba84aa6d$export$bc24d29e6182c1b2 = (props)=>{
    const aggClient = (0, $gKr8t.getAGGClient)();
    const queryResult = (0, $jMyy4.useQueryInterop)($996b8fc8ba84aa6d$var$InTrialFeatureGatesBannerWithDataQuery, {
        client: aggClient,
        variables: {
            cloudId: props.tenantId
        },
        skip: !(0, $6mKj3.expValEquals)('confluence_relay_migration_no_client_passing', 'isEnabled', true)
    });
    const baseProps = (0, $6mKj3.expValEquals)('confluence_relay_migration_no_client_passing', 'isEnabled', true) ? {
        inTrialFeatureGatesQueryResult: queryResult,
        ...props
    } : {
        aggClient: aggClient,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i1qvR.InTrialFeatureGatesBannerWithData), baseProps);
};
module.exports["InTrialFeatureGatesBannerWithData"] = $996b8fc8ba84aa6d$export$bc24d29e6182c1b2;

});

parcelRegister("i1qvR", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $7jjWP = parcelRequire("7jjWP");


const $50ac98d9a22aacea$var$InTrialFeatureGatesBanner = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("50VPq")));
const $50ac98d9a22aacea$export$bc24d29e6182c1b2 = ({ featureId: featureId, tenantId: // AGG client to refetch pre-fetched data from the GQL cache
tenantId, edition: edition, sendOperationalEvent: sendOperationalEvent, sendScreenEvent: sendScreenEvent, sendTrackEvent: sendTrackEvent, ...props })=>{
    const { daysLeftInTrial: daysLeftInTrial, paymentFlowExperienceUrl: paymentFlowExperienceUrl, error: error, loading: loading } = (0, $7jjWP.useGetInTrialFeatureGateBannerData)({
        sendOperationalEvent: sendOperationalEvent,
        tenantId: tenantId,
        featureId: featureId,
        ...props
    });
    // In order for us to even be able to render this experience, we will already have verified that the user is in a valid audience. Adding the payment details and trial check here is just a typecheck for below.
    if (error || loading || !daysLeftInTrial || !paymentFlowExperienceUrl) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {}),
        onError: (error)=>{
            sendOperationalEvent({
                type: 'sendOperationalEvent',
                action: 'error',
                actionSubject: 'luna-growth-experiment-error-boundary',
                actionSubjectId: 'in-trial-feature-gates-banner-error-boundary',
                attributes: {
                    error: error.message,
                    tenantId: tenantId,
                    featureId: featureId
                },
                source: 'in_trial_feature_gates_banner'
            });
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)("div", {}),
            children: /*#__PURE__*/ (0, $l998X.jsx)($50ac98d9a22aacea$var$InTrialFeatureGatesBanner, {
                daysLeftInTrial: daysLeftInTrial,
                paymentFlowExperienceUrl: paymentFlowExperienceUrl,
                featureId: featureId,
                sendScreenEvent: sendScreenEvent,
                sendTrackEvent: sendTrackEvent,
                edition: edition
            })
        })
    });
};
module.exports["InTrialFeatureGatesBannerWithData"] = $50ac98d9a22aacea$export$bc24d29e6182c1b2;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("50VPq", function(module, exports) {

let $3a69cf57454e8e8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3a69cf57454e8e8c$var$load("hhss7"),
    $3a69cf57454e8e8c$var$load("13QWg")
]).then(()=>parcelRequire('kUaha'));

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("618I0"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("618I0", function(module, exports) {

let $4619977a62937b7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4619977a62937b7e$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("7gpC4", function(module, exports) {
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gxtzC = parcelRequire("gxtzC");


var $3654r = parcelRequire("3654r");


var $6MlG5 = parcelRequire("6MlG5");

var $9wgn8 = parcelRequire("9wgn8");

var $cVrnQ = parcelRequire("cVrnQ");

var $hcDON = parcelRequire("hcDON");

const $1f9fb6b4b3bc4020$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgdfik _1dk7dfik _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $1f9fb6b4b3bc4020$var$Checkbox = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $42omo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $42omo.useRef)(null);
    const mergedRefs = (0, $3654r.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $42omo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $9wgn8.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $gMc0m.default)([
                    $1f9fb6b4b3bc4020$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6MlG5.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $cVrnQ.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $hcDON.default), {})
                ]
            })
        ]
    });
}));
$1f9fb6b4b3bc4020$var$Checkbox.displayName = 'Checkbox';
var $1f9fb6b4b3bc4020$export$2e2bcd8739ae039 = $1f9fb6b4b3bc4020$var$Checkbox;
module.exports["default"] = $1f9fb6b4b3bc4020$export$2e2bcd8739ae039;

});

parcelRegister("6MlG5", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $d6Fdl = parcelRequire("d6Fdl");


var $dh538 = parcelRequire("dh538");

const $71feb0a29953fded$var$svgStyles = null;
function $71feb0a29953fded$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        if ((0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $71feb0a29953fded$var$CheckboxIcon = /*#__PURE__*/ (0, $42omo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $42omo.useMemo)(()=>$71feb0a29953fded$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    if ((0, $dh538.fg)('platform-custom-icon-migration')) return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: 'var(--checkbox-background-color)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: 'var(--checkbox-tick-color)'
        },
        role: "presentation",
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d6Fdl.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $71feb0a29953fded$export$2e2bcd8739ae039 = $71feb0a29953fded$var$CheckboxIcon;
module.exports["default"] = $71feb0a29953fded$export$2e2bcd8739ae039;

});

parcelRegister("9wgn8", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf27753e59bf881$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $edf27753e59bf881$var$baseStyles = null;
const $edf27753e59bf881$var$textLabelLayoutStyles = null;
const $edf27753e59bf881$var$disabledStyles = null;
const $edf27753e59bf881$var$labelStyles = null;
function $edf27753e59bf881$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("label", {
        className: (0, $gMc0m.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazi7uo _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1gmx _80om13gf",
            "_h5e31j9a _1nzsr01l _1eszjmqp _yp0j1q28 _ay2wby5v _d51ul4ek _phftrsbi _1g1f1l7x _l6wkjmqp _1dik1q28 _1sfg1bqt _fpdjby5v _1yjc1v1w _oaj1rsbi _1j3h1bqt _eawb5w2r _1rda5w2r _18q02sac _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("cVrnQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c2060f65a94bd0$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f0c2060f65a94bd0$var$labelTextStyles = null;
function $f0c2060f65a94bd0$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("hcDON", function(module, exports) {
$parcel$export(module.exports, "default", () => $a14852587cdb2524$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $a14852587cdb2524$var$requiredIndicatorStyles = null;
function $a14852587cdb2524$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": true,
        className: (0, $gMc0m.default)([
            "_syaz1tmw _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("bflGB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lisKW = parcelRequire("lisKW");

parcelRequire("4ARHe");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($lisKW))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps })=>{
    const deprecatedListener = (0, $42omo.useCallback)((e, combo)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_shortcut_deprecation_flag')) (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
            flags: flags,
            acceleratorTriggered: combo,
            accelerator: accelerator,
            deprecatedAccelerator: deprecatedAccelerator
        });
        listener(e, combo);
    }, [
        listener,
        accelerator,
        deprecatedAccelerator,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /* This 2nd ShortcutListenerInternal is used to also display a flag informing the user
        that the shortcut they used is deprecated, while still triggering the listener. */ deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
        accelerator: deprecatedAccelerator,
        listener: deprecatedListener,
        ...otherProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
        accelerator: accelerator,
        listener: listener,
        ...otherProps
    }));
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("lisKW", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (0, module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("4ARHe", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'ctrl+mod+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $cgtv4.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_zulpv77o _1e0c1txw _4cvr1h6o"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 604800000);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)(appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $dh538.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("4tOXV", function(module, exports) {
/* ShortcutVisualizer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $1Whri = parcelRequire("1Whri");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent;
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_1rjcv77o _1e0c1txw _4cvr1h6o",
    base: "_2rko12b0 _1rjcv77o _18zru2gc _1e0c1o8l _18u0v77o _2hwxv77o",
    contentBefore: "_18u01b66 _2hwxze3t",
    darkBackground: "_bfhk18j9",
    lightBackground: "_bfhkysee"
};
const $05ef07480c610d29$var$i18n = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    // eslint-disable-next-line @atlassian/i18n/require-description
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = ({ shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: isTooltip = false })=>{
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $8C5kA.default)();
    const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const shouldRenderShortcutSegment = (0, $6mKj3.expVal)('confluence_frontend_fix_shortcut_hydration', 'isEnabled', false) ? areKeyboardShortcutsEnabled && !renderServerPlaceholder || isEditorShortcut : areKeyboardShortcutsEnabled || isEditorShortcut; // This is going to be rendered in a <span> so no <div> should be used here.
    // Otherwise it will break HTML structure causing SSR hydration mismatch.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $05ef07480c610d29$var$styles.flexCenter
    }, contentBefore, shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: `${shortcutSegment}-${index}`,
            xcss: (0, $1Whri.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
        }, shortcutSegment)));
};
const $05ef07480c610d29$export$e84ae736f9706c5d = ({ shortcut: shortcut, isEditorShortcut: isEditorShortcut = false })=>{
    const intl = (0, $8C5kA.default)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return undefined;
    const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage); // Editor shortcuts are always enabled
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return undefined;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("e4o8D", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("fZAJP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $42omo.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    (0, $42omo.useEffect)(()=>{
        if (typeof window.__SHORTCUT_ENABLED__ !== 'boolean') {
            if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = // preloadShortcutEnabledState will set window.__SHORTCUT_ENABLED__
            isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
            $640354b193201be7$var$inflightPromise.then(setEnabled);
        }
        $640354b193201be7$var$updaters.add(setEnabled);
        return ()=>{
            $640354b193201be7$var$updaters.delete(setEnabled);
        };
    }, [
        isLoggedIn,
        isLicensed
    ]);
    const notify = (0, $42omo.useCallback)(async (enabled)=>{
        try {
            const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    enabled: enabled
                })
            });
            if (res.ok) {
                const newEnabled = await res.text() === 'true';
                // Any newly created hook instance will get the updated value
                window.__SHORTCUT_ENABLED__ = newEnabled;
                // Notify all the existing hooks on the page that we have updated the value
                $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
            }
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
                attribution: (0, $3IBnw.Attribution).BACKBONE
            });
        }
    }, []);
    return [
        Boolean(enabled),
        notify
    ];
};
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("3y1ko", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (async ()=>{
            const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            return _asyncResult;
        })();
        if (res.ok) enabled = await (async ()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            const _asyncResult2 = await res.text();
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
            return _asyncResult2;
        })() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult3 = await $4c06255176f911bc$export$632d1cf1f5c6210f();
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult3;
    })();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("9EtP6", function(module, exports) {
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");

const $82c18ff824db72a8$var$packageName = "platform-pkg";
const $82c18ff824db72a8$var$packageVersion = "0.0.0-use.local";
const $82c18ff824db72a8$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $82c18ff824db72a8$var$packageName,
    packageVersion: $82c18ff824db72a8$var$packageVersion
};
const $82c18ff824db72a8$var$lineHeightBase = 20;
const $82c18ff824db72a8$var$lineHeightCompact = 16;
const $82c18ff824db72a8$var$compactVerticalPadding = 2;
const $82c18ff824db72a8$var$verticalPadding = 6;
const $82c18ff824db72a8$var$transitionDuration = '0.2s';
const $82c18ff824db72a8$var$borderWidth = 2;
const $82c18ff824db72a8$var$baseStyles = null;
const $82c18ff824db72a8$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pvby5v _19wtrsbi _12yml4ek _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18by5v",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $82c18ff824db72a8$var$fontStyles = {
    default: "_11c81ixg _1tn22smr",
    monospace: "_11c81ixg _ect41odn _1tn22smr _14mdudxr"
};
const $82c18ff824db72a8$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $82c18ff824db72a8$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $82c18ff824db72a8$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $82c18ff824db72a8$var$InnerTextArea = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const ourRef = (0, $42omo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $42omo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$82c18ff824db72a8$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $42omo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $82c18ff824db72a8$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $l998X.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0by5v _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            $82c18ff824db72a8$var$appearanceStyles[appearance],
            $82c18ff824db72a8$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $82c18ff824db72a8$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightCompact * minimumRows + $82c18ff824db72a8$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $7sObp.default)($82c18ff824db72a8$var$lineHeightBase * minimumRows + $82c18ff824db72a8$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $82c18ff824db72a8$var$TextArea = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)($82c18ff824db72a8$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$82c18ff824db72a8$var$TextArea.displayName = 'TextArea';
var $82c18ff824db72a8$export$2e2bcd8739ae039 = $82c18ff824db72a8$var$TextArea;
module.exports["default"] = $82c18ff824db72a8$export$2e2bcd8739ae039;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("6O3OC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $cuAuQ = parcelRequire("cuAuQ");

const $e3824e6fb8890c7f$export$f6058dbcb5980cb = (option)=>option.type === (0, $RMvle.ExternalUserType) || Boolean(option.isExternal);
const $e3824e6fb8890c7f$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $RMvle.UserType);
const $e3824e6fb8890c7f$export$f8c4277cb588611f = (option)=>option.type === (0, $RMvle.TeamType);
const $e3824e6fb8890c7f$export$d7976824e9f55785 = (option)=>option.type === (0, $RMvle.GroupType);
const $e3824e6fb8890c7f$export$7fbbfbca30081d0 = (option)=>option.type === (0, $RMvle.EmailType);
const $e3824e6fb8890c7f$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $RMvle.CustomType);
const $e3824e6fb8890c7f$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $e3824e6fb8890c7f$var$isOptionData = (option)=>option.name !== undefined;
const $e3824e6fb8890c7f$export$3f993c492bd6c728 = (option)=>{
    if ($e3824e6fb8890c7f$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $e3824e6fb8890c7f$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $e3824e6fb8890c7f$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $e3824e6fb8890c7f$export$d2312e68e1f5ad00 = (0, $2XqLN.default)((options)=>options.map($e3824e6fb8890c7f$export$3f993c492bd6c728));
const $e3824e6fb8890c7f$export$e6fda14a194bcbcc = (0, $2XqLN.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($e3824e6fb8890c7f$export$3f993c492bd6c728);
    return $e3824e6fb8890c7f$export$3f993c492bd6c728(defaultValue);
});
const $e3824e6fb8890c7f$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $e3824e6fb8890c7f$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $e3824e6fb8890c7f$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $e3824e6fb8890c7f$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $e3824e6fb8890c7f$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $e3824e6fb8890c7f$export$b4f8f1f54acec99b = (optionData)=>{
    if ($e3824e6fb8890c7f$export$2e44165f1da65304(optionData) || $e3824e6fb8890c7f$export$f8c4277cb588611f(optionData) || $e3824e6fb8890c7f$export$d3a8f0b77e9737fc(optionData) || $e3824e6fb8890c7f$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $e3824e6fb8890c7f$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $cuAuQ.default);
const $e3824e6fb8890c7f$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $e3824e6fb8890c7f$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};
module.exports["isExternalUser"] = $e3824e6fb8890c7f$export$f6058dbcb5980cb;
module.exports["isUser"] = $e3824e6fb8890c7f$export$2e44165f1da65304;
module.exports["isTeam"] = $e3824e6fb8890c7f$export$f8c4277cb588611f;
module.exports["isGroup"] = $e3824e6fb8890c7f$export$d7976824e9f55785;
module.exports["isEmail"] = $e3824e6fb8890c7f$export$7fbbfbca30081d0;
module.exports["isCustom"] = $e3824e6fb8890c7f$export$d3a8f0b77e9737fc;
module.exports["isDefaultValuePopulated"] = $e3824e6fb8890c7f$export$d6978985a41b0c8;
module.exports["extractOptionValue"] = $e3824e6fb8890c7f$export$7ae97131df521bff;
module.exports["isIterable"] = $e3824e6fb8890c7f$export$9652023d9040757;
module.exports["getOptions"] = $e3824e6fb8890c7f$export$d2312e68e1f5ad00;
module.exports["optionToSelectableOptions"] = $e3824e6fb8890c7f$export$e6fda14a194bcbcc;
module.exports["getAvatarSize"] = $e3824e6fb8890c7f$export$695fb564e621339a;
module.exports["isChildInput"] = $e3824e6fb8890c7f$export$3c62cf9a01367f27;
module.exports["isSingleValue"] = $e3824e6fb8890c7f$export$203c2bd2662d1ca2;
module.exports["hasValue"] = $e3824e6fb8890c7f$export$96bdbc84526f3739;
module.exports["callCallback"] = $e3824e6fb8890c7f$export$df325aa844b03c31;
module.exports["getAvatarUrl"] = $e3824e6fb8890c7f$export$b4f8f1f54acec99b;
module.exports["isPopupUserPickerByComponent"] = $e3824e6fb8890c7f$export$4f60a74234178416;
module.exports["isLozengeText"] = $e3824e6fb8890c7f$export$5419897287f5f1c7;

});

parcelRegister("RMvle", function(module, exports) {
const $9aa1f267f5b06881$export$8436e53e45ffe15b = 'user';
const $9aa1f267f5b06881$export$50042ec1d2e00e63 = 'external_user';
const $9aa1f267f5b06881$export$26bc40b960693765 = 'team';
const $9aa1f267f5b06881$export$d460f747b73abb10 = 'group';
const $9aa1f267f5b06881$export$6662b3461398ef8c = 'email';
const $9aa1f267f5b06881$export$eafd0979afa5b224 = 'custom';
module.exports["UserType"] = $9aa1f267f5b06881$export$8436e53e45ffe15b;
module.exports["ExternalUserType"] = $9aa1f267f5b06881$export$50042ec1d2e00e63;
module.exports["TeamType"] = $9aa1f267f5b06881$export$26bc40b960693765;
module.exports["GroupType"] = $9aa1f267f5b06881$export$d460f747b73abb10;
module.exports["EmailType"] = $9aa1f267f5b06881$export$6662b3461398ef8c;
module.exports["CustomType"] = $9aa1f267f5b06881$export$eafd0979afa5b224;

});

parcelRegister("3KVX0", function(module, exports) {
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $2bc29ecddddf3571$var$isArray(value) {
    return !Array.isArray ? $2bc29ecddddf3571$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $2bc29ecddddf3571$var$INFINITY = 1 / 0;
function $2bc29ecddddf3571$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$2bc29ecddddf3571$var$INFINITY ? '-0' : result;
}
function $2bc29ecddddf3571$var$toString(value) {
    return value == null ? '' : $2bc29ecddddf3571$var$baseToString(value);
}
function $2bc29ecddddf3571$var$isString(value) {
    return typeof value === 'string';
}
function $2bc29ecddddf3571$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $2bc29ecddddf3571$var$isBoolean(value) {
    return value === true || value === false || $2bc29ecddddf3571$var$isObjectLike(value) && $2bc29ecddddf3571$var$getTag(value) == '[object Boolean]';
}
function $2bc29ecddddf3571$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $2bc29ecddddf3571$var$isObjectLike(value) {
    return $2bc29ecddddf3571$var$isObject(value) && value !== null;
}
function $2bc29ecddddf3571$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $2bc29ecddddf3571$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $2bc29ecddddf3571$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $2bc29ecddddf3571$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $2bc29ecddddf3571$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $2bc29ecddddf3571$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $2bc29ecddddf3571$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $2bc29ecddddf3571$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $2bc29ecddddf3571$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $2bc29ecddddf3571$var$hasOwn = Object.prototype.hasOwnProperty;
class $2bc29ecddddf3571$var$KeyStore {
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $2bc29ecddddf3571$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
}
function $2bc29ecddddf3571$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($2bc29ecddddf3571$var$isString(key) || $2bc29ecddddf3571$var$isArray(key)) {
        src = key;
        path = $2bc29ecddddf3571$var$createKeyPath(key);
        id = $2bc29ecddddf3571$var$createKeyId(key);
    } else {
        if (!$2bc29ecddddf3571$var$hasOwn.call(key, 'name')) throw new Error($2bc29ecddddf3571$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($2bc29ecddddf3571$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($2bc29ecddddf3571$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $2bc29ecddddf3571$var$createKeyPath(name);
        id = $2bc29ecddddf3571$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $2bc29ecddddf3571$var$createKeyPath(key) {
    return $2bc29ecddddf3571$var$isArray(key) ? key : key.split('.');
}
function $2bc29ecddddf3571$var$createKeyId(key) {
    return $2bc29ecddddf3571$var$isArray(key) ? key.join('.') : key;
}
function $2bc29ecddddf3571$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$2bc29ecddddf3571$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$2bc29ecddddf3571$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($2bc29ecddddf3571$var$isString(value) || $2bc29ecddddf3571$var$isNumber(value) || $2bc29ecddddf3571$var$isBoolean(value))) list.push($2bc29ecddddf3571$var$toString(value));
            else if ($2bc29ecddddf3571$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $2bc29ecddddf3571$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $2bc29ecddddf3571$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $2bc29ecddddf3571$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $2bc29ecddddf3571$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $2bc29ecddddf3571$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $2bc29ecddddf3571$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $2bc29ecddddf3571$var$Config = {
    ...$2bc29ecddddf3571$var$BasicOptions,
    ...$2bc29ecddddf3571$var$MatchOptions,
    ...$2bc29ecddddf3571$var$FuzzyOptions,
    ...$2bc29ecddddf3571$var$AdvancedOptions
};
const $2bc29ecddddf3571$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $2bc29ecddddf3571$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($2bc29ecddddf3571$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $2bc29ecddddf3571$var$FuseIndex {
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($2bc29ecddddf3571$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($2bc29ecddddf3571$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$2bc29ecddddf3571$var$isDefined(doc) || $2bc29ecddddf3571$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$2bc29ecddddf3571$var$isDefined(value)) return;
            if ($2bc29ecddddf3571$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$2bc29ecddddf3571$var$isDefined(value)) continue;
                    if ($2bc29ecddddf3571$var$isString(value) && !$2bc29ecddddf3571$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($2bc29ecddddf3571$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($2bc29ecddddf3571$var$isString(value) && !$2bc29ecddddf3571$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
    constructor({ getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}){
        this.norm = $2bc29ecddddf3571$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
}
function $2bc29ecddddf3571$var$createIndex(keys, docs, { getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $2bc29ecddddf3571$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($2bc29ecddddf3571$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $2bc29ecddddf3571$var$parseIndex(data, { getFn: getFn = $2bc29ecddddf3571$var$Config.getFn, fieldNormWeight: fieldNormWeight = $2bc29ecddddf3571$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $2bc29ecddddf3571$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $2bc29ecddddf3571$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $2bc29ecddddf3571$var$Config.distance, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $2bc29ecddddf3571$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $2bc29ecddddf3571$var$MAX_BITS = 32;
function $2bc29ecddddf3571$var$search(text, pattern, patternAlphabet, { location: location = $2bc29ecddddf3571$var$Config.location, distance: distance = $2bc29ecddddf3571$var$Config.distance, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $2bc29ecddddf3571$var$MAX_BITS) throw new Error($2bc29ecddddf3571$var$PATTERN_LENGTH_TOO_LARGE($2bc29ecddddf3571$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $2bc29ecddddf3571$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $2bc29ecddddf3571$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $2bc29ecddddf3571$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $2bc29ecddddf3571$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $2bc29ecddddf3571$var$BitapSearch {
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $2bc29ecddddf3571$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
    constructor(pattern, { location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $2bc29ecddddf3571$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $2bc29ecddddf3571$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $2bc29ecddddf3571$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $2bc29ecddddf3571$var$MAX_BITS), i);
                i += $2bc29ecddddf3571$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $2bc29ecddddf3571$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
}
class $2bc29ecddddf3571$var$BaseMatch {
    static isMultiMatch(pattern) {
        return $2bc29ecddddf3571$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $2bc29ecddddf3571$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
    constructor(pattern){
        this.pattern = pattern;
    }
}
function $2bc29ecddddf3571$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $2bc29ecddddf3571$var$ExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !fire
class $2bc29ecddddf3571$var$InverseExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: ^file
class $2bc29ecddddf3571$var$PrefixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !^fire
class $2bc29ecddddf3571$var$InversePrefixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: .file$
class $2bc29ecddddf3571$var$SuffixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// Token: !.file$
class $2bc29ecddddf3571$var$InverseSuffixExactMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
class $2bc29ecddddf3571$var$FuzzyMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
    constructor(pattern, { location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $2bc29ecddddf3571$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
}
// Token: 'file
class $2bc29ecddddf3571$var$IncludeMatch extends $2bc29ecddddf3571$var$BaseMatch {
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
    constructor(pattern){
        super(pattern);
    }
}
// ❗Order is important. DO NOT CHANGE.
const $2bc29ecddddf3571$var$searchers = [
    $2bc29ecddddf3571$var$ExactMatch,
    $2bc29ecddddf3571$var$IncludeMatch,
    $2bc29ecddddf3571$var$PrefixExactMatch,
    $2bc29ecddddf3571$var$InversePrefixExactMatch,
    $2bc29ecddddf3571$var$InverseSuffixExactMatch,
    $2bc29ecddddf3571$var$SuffixExactMatch,
    $2bc29ecddddf3571$var$InverseExactMatch,
    $2bc29ecddddf3571$var$FuzzyMatch
];
const $2bc29ecddddf3571$var$searchersLen = $2bc29ecddddf3571$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $2bc29ecddddf3571$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $2bc29ecddddf3571$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $2bc29ecddddf3571$var$parseQuery(pattern, options = {}) {
    return pattern.split($2bc29ecddddf3571$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($2bc29ecddddf3571$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $2bc29ecddddf3571$var$searchersLen){
                const searcher = $2bc29ecddddf3571$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $2bc29ecddddf3571$var$searchersLen){
                const searcher = $2bc29ecddddf3571$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $2bc29ecddddf3571$var$MultiMatchSet = new Set([
    $2bc29ecddddf3571$var$FuzzyMatch.type,
    $2bc29ecddddf3571$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $2bc29ecddddf3571$var$ExtendedSearch {
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($2bc29ecddddf3571$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $2bc29ecddddf3571$var$Config.isCaseSensitive, includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $2bc29ecddddf3571$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $2bc29ecddddf3571$var$Config.ignoreLocation, findAllMatches: findAllMatches = $2bc29ecddddf3571$var$Config.findAllMatches, location: location = $2bc29ecddddf3571$var$Config.location, threshold: threshold = $2bc29ecddddf3571$var$Config.threshold, distance: distance = $2bc29ecddddf3571$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $2bc29ecddddf3571$var$parseQuery(this.pattern, this.options);
    }
}
const $2bc29ecddddf3571$var$registeredSearchers = [];
function $2bc29ecddddf3571$var$register(...args) {
    $2bc29ecddddf3571$var$registeredSearchers.push(...args);
}
function $2bc29ecddddf3571$var$createSearcher(pattern, options) {
    for(let i = 0, len = $2bc29ecddddf3571$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $2bc29ecddddf3571$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $2bc29ecddddf3571$var$BitapSearch(pattern, options);
}
const $2bc29ecddddf3571$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $2bc29ecddddf3571$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $2bc29ecddddf3571$var$isExpression = (query)=>!!(query[$2bc29ecddddf3571$var$LogicalOperator.AND] || query[$2bc29ecddddf3571$var$LogicalOperator.OR]);
const $2bc29ecddddf3571$var$isPath = (query)=>!!query[$2bc29ecddddf3571$var$KeyType.PATH];
const $2bc29ecddddf3571$var$isLeaf = (query)=>!$2bc29ecddddf3571$var$isArray(query) && $2bc29ecddddf3571$var$isObject(query) && !$2bc29ecddddf3571$var$isExpression(query);
const $2bc29ecddddf3571$var$convertToExplicit = (query)=>({
        [$2bc29ecddddf3571$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $2bc29ecddddf3571$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $2bc29ecddddf3571$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$2bc29ecddddf3571$var$isExpression(query)) return next($2bc29ecddddf3571$var$convertToExplicit(query));
        if ($2bc29ecddddf3571$var$isLeaf(query)) {
            const key = isQueryPath ? query[$2bc29ecddddf3571$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$2bc29ecddddf3571$var$KeyType.PATTERN] : query[key];
            if (!$2bc29ecddddf3571$var$isString(pattern)) throw new Error($2bc29ecddddf3571$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $2bc29ecddddf3571$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $2bc29ecddddf3571$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($2bc29ecddddf3571$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$2bc29ecddddf3571$var$isExpression(query)) query = $2bc29ecddddf3571$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $2bc29ecddddf3571$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $2bc29ecddddf3571$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $2bc29ecddddf3571$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$2bc29ecddddf3571$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$2bc29ecddddf3571$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $2bc29ecddddf3571$var$transformScore(result, data) {
    data.score = result.score;
}
function $2bc29ecddddf3571$var$format(results, docs, { includeMatches: includeMatches = $2bc29ecddddf3571$var$Config.includeMatches, includeScore: includeScore = $2bc29ecddddf3571$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($2bc29ecddddf3571$var$transformMatches);
    if (includeScore) transformers.push($2bc29ecddddf3571$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $2bc29ecddddf3571$export$2e2bcd8739ae039 {
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $2bc29ecddddf3571$var$FuseIndex)) throw new Error($2bc29ecddddf3571$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $2bc29ecddddf3571$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$2bc29ecddddf3571$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $2bc29ecddddf3571$var$isString(query) ? $2bc29ecddddf3571$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $2bc29ecddddf3571$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($2bc29ecddddf3571$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $2bc29ecddddf3571$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $2bc29ecddddf3571$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2bc29ecddddf3571$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $2bc29ecddddf3571$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $2bc29ecddddf3571$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($2bc29ecddddf3571$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $2bc29ecddddf3571$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$2bc29ecddddf3571$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$2bc29ecddddf3571$var$isDefined(value)) return [];
        let matches = [];
        if ($2bc29ecddddf3571$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$2bc29ecddddf3571$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
    constructor(docs, options = {}, index){
        this.options = {
            ...$2bc29ecddddf3571$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $2bc29ecddddf3571$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
}
$2bc29ecddddf3571$export$2e2bcd8739ae039.version = '6.6.2';
$2bc29ecddddf3571$export$2e2bcd8739ae039.createIndex = $2bc29ecddddf3571$var$createIndex;
$2bc29ecddddf3571$export$2e2bcd8739ae039.parseIndex = $2bc29ecddddf3571$var$parseIndex;
$2bc29ecddddf3571$export$2e2bcd8739ae039.config = $2bc29ecddddf3571$var$Config;
$2bc29ecddddf3571$export$2e2bcd8739ae039.parseQuery = $2bc29ecddddf3571$var$parse;
$2bc29ecddddf3571$var$register($2bc29ecddddf3571$var$ExtendedSearch);
module.exports["default"] = $2bc29ecddddf3571$export$2e2bcd8739ae039;

});

parcelRegister("1LFpx", function(module, exports) {

var $l5NM4 = parcelRequire("l5NM4");


var $jlluG = parcelRequire("jlluG");


var $fKUsn = parcelRequire("fKUsn");

function $95e303bf94b60ba0$export$b2ac8baa522556a7(cloudId, product, createAnalyticsEvent) {
    switch(product){
        case 'platform':
            return new (0, $fKUsn.default)(cloudId, createAnalyticsEvent);
        case 'confluence':
            return new (0, $l5NM4.default)(cloudId, createAnalyticsEvent);
        default:
            return new (0, $jlluG.default)(cloudId, createAnalyticsEvent);
    }
}
module.exports["slackServiceFactory"] = $95e303bf94b60ba0$export$b2ac8baa522556a7;

});

parcelRegister("l5NM4", function(module, exports) {

var $3RfNn = parcelRequire("3RfNn");


var $9Xcuc = parcelRequire("9Xcuc");


var $3LGCH = parcelRequire("3LGCH");

class $8ac367c87f895520$export$2e2bcd8739ae039 extends (0, $3RfNn.default) {
    async primeConsentUrl() {
        if (this.consentUrl) return;
        const location = typeof window === 'undefined' ? undefined : window.location;
        if (location) {
            const urlResult = await (0, $3LGCH.default)(location, this.confluenceAnalytics, this.abortController?.signal);
            if (urlResult.ok) this.consentUrl = urlResult.result;
            else throw new Error('Failed priming consent URL');
        }
    }
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $9Xcuc.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'confluence', analytics);
        this.confluenceAnalytics = void 0;
        this.confluenceAnalytics = (0, $9Xcuc.getConfluenceSlackServiceAnalytics)(createUIAnalyticsEvent);
    }
}
module.exports["default"] = $8ac367c87f895520$export$2e2bcd8739ae039;

});

parcelRegister("3RfNn", function(module, exports) {

var $6Co6F = parcelRequire("6Co6F");


var $gUoHD = parcelRequire("gUoHD");


var $dQl1W = parcelRequire("dQl1W");


var $lFI1p = parcelRequire("lFI1p");


var $bIHWh = parcelRequire("bIHWh");


var $5UC4z = parcelRequire("5UC4z");


var $6BEN7 = parcelRequire("6BEN7");


var $bGwCT = parcelRequire("bGwCT");

const $525f41710b375d19$var$POPUP_WIDTH = 500;
const $525f41710b375d19$var$POPUP_HEIGHT = 900;
const $525f41710b375d19$var$USER_FETCH_LIMIT = 1000;
const $525f41710b375d19$var$retryOptions = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $525f41710b375d19$export$2e2bcd8739ae039 {
    abort() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        }
    }
    async getConsent(onSuccess) {
        await this.primeConsentUrl();
        this.onSuccess = onSuccess;
        window.addEventListener('message', this.onMessage);
        const popupWindow = window.open(this.consentUrl, this.windowName, (0, $bIHWh.default)($525f41710b375d19$var$POPUP_WIDTH, $525f41710b375d19$var$POPUP_HEIGHT));
        if (popupWindow) this.popupWindow = popupWindow;
    }
    async isSlackEnabled() {
        const result = await (0, $bGwCT.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/enabled?cloudId=${this.cloudId}`, {
                    signal: this.abortController?.signal
                }),
            mapResult: (response)=>response.json().then(({ enabled: enabled })=>enabled),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code ?? '',
                        message: message ?? ''
                    };
                })
        });
        if (result.ok) this.analytics.onGetEnabledSucceeded();
        else if (!result.aborted && !(0, $5UC4z.isAcceptableFailure)(result.status)) this.analytics.onGetEnabledFailed({
            status: result.status,
            errorMessage: result.message
        });
        return result;
    }
    async getTeams() {
        const response = await (0, $bGwCT.fetchItemsWithCursor)({
            url: `${this.baseUrl}/teams`,
            queryParams: {
                cloudId: this.cloudId
            },
            signal: this.abortController?.signal,
            getItems: (response)=>response.teams,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $bGwCT.httpRetryPolicy)($525f41710b375d19$var$retryOptions)
        });
        if (response.ok) {
            this.analytics.onFetchTeamsSucceeded({
                teams: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: (0, (/*@__PURE__*/$parcel$interopDefault($gUoHD)))(response.items, [
                    ({ name: name })=>name.toLowerCase()
                ])
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchTeamsFailed({
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    streamUsers(teamId, onResponse, cursor) {
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $bGwCT.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/recipients${(0, $bGwCT.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor,
                    limit: $525f41710b375d19$var$USER_FETCH_LIMIT
                })}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $bGwCT.httpRetryPolicy)($525f41710b375d19$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchUsersFailed({
                    teamId: teamId,
                    page: this.userStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.recipients.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.recipients,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    streamChannels(teamId, onResponse, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        (0, $bGwCT.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/channels${(0, $bGwCT.buildQueryString)({
                    cloudId: this.cloudId,
                    teamId: teamId,
                    cursor: cursor
                })}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $bGwCT.httpRetryPolicy)($525f41710b375d19$var$retryOptions)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) this.analytics.onFetchChannelsFailed({
                    teamId: teamId,
                    page: this.channelStream.pages,
                    status: resp.status,
                    errorMessage: resp.message
                });
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannels(teamId, onResponse, resp.result.nextCursor);
            else // This event may not consistently fire because it is possible for the user to select and share before
            // all pages have loaded
            this.analytics.onFetchChannelsSucceeded({
                teamId: teamId,
                channels: this.channelStream.count,
                pages: this.channelStream.pages
            });
        });
    }
    async fetchSlackUsers(teamId) {
        const response = await (0, $bGwCT.fetchItemsWithCursor)({
            url: `${this.baseUrl}/recipients`,
            queryParams: {
                cloudId: this.cloudId,
                teamId: teamId
            },
            signal: this.abortController?.signal,
            getItems: (response)=>response.recipients,
            getCursor: (response)=>response.nextCursor,
            canRetryCheck: (0, $bGwCT.httpRetryPolicy)($525f41710b375d19$var$retryOptions)
        });
        if (response.ok) {
            const users = (0, (/*@__PURE__*/$parcel$interopDefault($gUoHD)))(response.items, [
                ({ name: name })=>name.toLowerCase()
            ]);
            this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: response.items.length,
                pages: response.pages
            });
            return {
                ok: true,
                result: users
            };
        } else if (response.aborted) return response;
        else {
            this.analytics.onFetchUsersFailed({
                teamId: teamId,
                page: response.page,
                status: response.status,
                errorMessage: response.message
            });
            return response;
        }
    }
    async share({ teamId: teamId, conversationId: conversationId, conversationType: conversationType, link: link, message: message }) {
        (0, $6BEN7.startUfoExperience)((0, $6BEN7.UfoExperiences).SLACK_REQUEST_SENT);
        const origin = new (0, $6Co6F.default)({
            product: this.product
        });
        const response = await (0, $bGwCT.retryFetch)({
            request: ()=>fetch(`${this.baseUrl}/share`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        cloudId: this.cloudId,
                        teamId: teamId,
                        conversation: {
                            id: conversationId,
                            type: conversationType
                        },
                        link: origin.addToUrl(link),
                        message: message
                    }),
                    signal: this.abortController?.signal
                }),
            mapResult: ()=>Promise.resolve(),
            mapError: (response)=>response.json().then((obj)=>{
                    const { code: code, message: message } = obj;
                    return {
                        code: code ?? '',
                        message: message ?? ''
                    };
                }),
            signal: this.abortController?.signal
        });
        if (response.ok) {
            const successAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: message.length || 0,
                userCount: this.userStream.count
            };
            this.analytics.onShareSucceeded(successAttributes);
            (0, $6BEN7.succeedUfoExperience)((0, $6BEN7.UfoExperiences).SLACK_REQUEST_SENT, successAttributes);
        } else if (!response.aborted && !(0, $5UC4z.isAcceptableFailure)(response.status)) {
            const failedAttributes = {
                product: this.product,
                teamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: response.status,
                errorMessage: response.message
            };
            this.analytics.onShareFailed(failedAttributes);
            (0, $6BEN7.failUfoExperience)((0, $6BEN7.UfoExperiences).SLACK_REQUEST_SENT, failedAttributes);
        }
        return response.ok ? {
            ok: true,
            result: origin
        } : response;
    }
    constructor(cloudId, product, analytics){
        this.cloudId = cloudId;
        this.product = product;
        this.analytics = analytics;
        this.baseUrl = void 0;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.windowName = (0, $dQl1W.v4)();
        this.abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
        this.popupWindow = void 0;
        this.consentUrl = void 0;
        this.onSuccess = void 0;
        this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        // Handle Slack authorization success message from popup window
        this.onMessage = ({ data: data, target: target, source: source })=>{
            if (!source || target !== window || data !== 'success') return;
            window.removeEventListener('message', this.onMessage);
            const popupWindow = source;
            if (!this.popupWindow) return;
            popupWindow.close();
            this.popupWindow = undefined;
            this.onSuccess?.();
        };
        this.baseUrl = `${0, $lFI1p.DEFAULT_SLACK_SERVICE_URL}/${product}`;
    }
}
module.exports["default"] = $525f41710b375d19$export$2e2bcd8739ae039;

});

parcelRegister("gUoHD", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");


var $iKDsH = parcelRequire("iKDsH");


var $9JSQw = parcelRequire("9JSQw");


var $4U5Tv = parcelRequire("4U5Tv");

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $c4f509c7912344de$var$sortBy = $9JSQw(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $4U5Tv(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $4U5Tv(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $iKDsH(collection, $8jC8i(iteratees, 1), []);
});
module.exports = $c4f509c7912344de$var$sortBy;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("iKDsH", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $aT80v = parcelRequire("aT80v");


var $hWvFC = parcelRequire("hWvFC");


var $lKeRq = parcelRequire("lKeRq");


var $gOQdS = parcelRequire("gOQdS");


var $dFnBO = parcelRequire("dFnBO");


var $jFdtX = parcelRequire("jFdtX");


var $eN7zR = parcelRequire("eN7zR");


var $fZxmY = parcelRequire("fZxmY");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $da6b2233b40a111f$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $5ukOg(iteratees, function(iteratee) {
        if ($fZxmY(iteratee)) return function(value) {
            return $aT80v(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $eN7zR
    ];
    var index = -1;
    iteratees = $5ukOg(iteratees, $dFnBO($hWvFC));
    var result = $lKeRq(collection, function(value, key, collection) {
        var criteria = $5ukOg(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $gOQdS(result, function(object, other) {
        return $jFdtX(object, other, orders);
    });
}
module.exports = $da6b2233b40a111f$var$baseOrderBy;

});

parcelRegister("lKeRq", function(module, exports) {

var $iawSg = parcelRequire("iawSg");


var $bRRFB = parcelRequire("bRRFB");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $fd496be5dac0a747$var$baseMap(collection, iteratee) {
    var index = -1, result = $bRRFB(collection) ? Array(collection.length) : [];
    $iawSg(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $fd496be5dac0a747$var$baseMap;

});

parcelRegister("iawSg", function(module, exports) {

var $fh4WQ = parcelRequire("fh4WQ");


var $fKRi0 = parcelRequire("fKRi0");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d3a2a94fdae59b54$var$baseEach = $fKRi0($fh4WQ);
module.exports = $d3a2a94fdae59b54$var$baseEach;

});

parcelRegister("fh4WQ", function(module, exports) {

var $9d5GH = parcelRequire("9d5GH");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b1ec481d92afa1cf$var$baseForOwn(object, iteratee) {
    return object && $9d5GH(object, iteratee, $d6TaN);
}
module.exports = $b1ec481d92afa1cf$var$baseForOwn;

});

parcelRegister("fKRi0", function(module, exports) {

var $bRRFB = parcelRequire("bRRFB");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b7847d143ef17a3d$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$bRRFB(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $b7847d143ef17a3d$var$createBaseEach;

});

parcelRegister("gOQdS", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $c3e9d3328d245367$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $c3e9d3328d245367$var$baseSortBy;

});

parcelRegister("jFdtX", function(module, exports) {

var $ibuun = parcelRequire("ibuun");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $e50c4defe8bb2498$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $ibuun(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $e50c4defe8bb2498$var$compareMultiple;

});

parcelRegister("ibuun", function(module, exports) {

var $hDVEF = parcelRequire("hDVEF");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $d3d0e79173ca78c2$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $hDVEF(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $hDVEF(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $d3d0e79173ca78c2$var$compareAscending;

});

parcelRegister("lFI1p", function(module, exports) {
const $f45a102926fbc670$export$68362b925a39303e = '/gateway/api/slack';
const $f45a102926fbc670$export$83c8d7110915321e = 'invite-people';
const $f45a102926fbc670$export$2c32b0fe4533d89e = 0;
const $f45a102926fbc670$export$9267d266a5449137 = 'NETWORK_ERROR';
const $f45a102926fbc670$export$33789febc109c023 = 'Network error';
const $f45a102926fbc670$export$4804b650706e0b62 = 'CONFLUENCE_METADATA_ERROR';
const $f45a102926fbc670$export$85183a312807388d = 'peopleTeams';
const $f45a102926fbc670$export$d67bd32411617d53 = 480;
const $f45a102926fbc670$export$cce5ee914c2ec5d9 = 924;
const $f45a102926fbc670$export$ab2f49a861856bab = '/gateway/api';
const $f45a102926fbc670$export$127769e597bc5ee5 = '/external-users/third-party';
const $f45a102926fbc670$export$8bad17bb0225d989 = '/external-users/orgs';
const $f45a102926fbc670$export$e468596ea25b5295 = 'integrations';
const $f45a102926fbc670$export$458ba67f45a7f353 = 'Third Party Search';
const $f45a102926fbc670$export$bc2c06c4779f47f2 = 'Organisation Settings';
const $f45a102926fbc670$export$20875166a8676880 = '/growth/invite-3rd-party-teams';
const $f45a102926fbc670$export$3f9855fcc7fa383e = '/slack-channels';
const $f45a102926fbc670$export$2d4bcc939d0de9de = 'google-invites';
const $f45a102926fbc670$export$baca96d2908c1d98 = 'microsoft-invites';
const $f45a102926fbc670$export$89aa938ff9a6aec2 = 3;
module.exports["DEFAULT_SLACK_SERVICE_URL"] = $f45a102926fbc670$export$68362b925a39303e;
module.exports["SOURCE"] = $f45a102926fbc670$export$83c8d7110915321e;
module.exports["CLIENT_ERROR_STATUS"] = $f45a102926fbc670$export$2c32b0fe4533d89e;
module.exports["CLIENT_ERROR_CODE"] = $f45a102926fbc670$export$9267d266a5449137;
module.exports["CLIENT_ERROR_MESSAGE"] = $f45a102926fbc670$export$33789febc109c023;
module.exports["ANALYTICS_CHANNEL"] = $f45a102926fbc670$export$85183a312807388d;
module.exports["WINDOW_WIDTH"] = $f45a102926fbc670$export$d67bd32411617d53;
module.exports["WINDOW_HEIGHT"] = $f45a102926fbc670$export$cce5ee914c2ec5d9;
module.exports["DEFAULT_STARGATE_SERVICE_URL"] = $f45a102926fbc670$export$ab2f49a861856bab;
module.exports["EXUS_THIRDPARTY_PATH"] = $f45a102926fbc670$export$127769e597bc5ee5;
module.exports["EXUS_ORGS_PATH"] = $f45a102926fbc670$export$8bad17bb0225d989;
module.exports["INTEGRATIONS_PATH"] = $f45a102926fbc670$export$e468596ea25b5295;
module.exports["SEARCH_ACTION"] = $f45a102926fbc670$export$458ba67f45a7f353;
module.exports["ORG_SETTINGS_ACTION"] = $f45a102926fbc670$export$bc2c06c4779f47f2;
module.exports["ITPT_PATH"] = $f45a102926fbc670$export$20875166a8676880;
module.exports["ITPT_SLACK_CHANNELS"] = $f45a102926fbc670$export$3f9855fcc7fa383e;
module.exports["INTEGRATIONS_FETCH_RETRIES_COUNT"] = $f45a102926fbc670$export$89aa938ff9a6aec2;

});

parcelRegister("bIHWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $9cb3cfe5389c30cc$export$2e2bcd8739ae039);
function $9cb3cfe5389c30cc$export$2e2bcd8739ae039(preferredWidth, preferredHeight) {
    const width = Math.min(preferredWidth, window.screen.availWidth);
    const height = Math.min(preferredHeight, window.screen.availHeight);
    return Object.entries({
        toolbar: 0,
        menubar: 0,
        location: 0,
        status: 0,
        scrollbars: 1,
        resizable: 0,
        chrome: 'yes',
        width: width,
        height: height,
        left: Math.round((window.innerWidth - width) / 2 + window.screenX),
        top: Math.round((window.innerHeight - height) / 3 + window.screenY)
    }).map(([key, value])=>`${key}=${value}`).join(',');
}

});

parcelRegister("5UC4z", function(module, exports) {
const $47199fd0fdcafb64$export$678d91a98f79a24d = (statusCode)=>!statusCode || statusCode === 400 || statusCode === 401 || statusCode === 403;
module.exports["isAcceptableFailure"] = $47199fd0fdcafb64$export$678d91a98f79a24d;

});

parcelRegister("6BEN7", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

var $9c0bdc1aee58920b$export$72df3c76208340b5 = /*#__PURE__*/ function(UfoExperiences) {
    UfoExperiences["SLACK_SEGMENT_RENDERED"] = "slack-segment-rendered";
    UfoExperiences["SLACK_REQUEST_SENT"] = "slack-request-sent";
    UfoExperiences["SLACK_FORM_ENABLED"] = "share-form-enabled";
    UfoExperiences["PLATFORM_SLACK_USERS_PAGE_FETCHED"] = "platform-slack-users-page-fetched";
    return UfoExperiences;
}({});
var $9c0bdc1aee58920b$var$PlatformComponent = /*#__PURE__*/ function(PlatformComponent) {
    PlatformComponent["ShareToSlack"] = "share-to-slack";
    PlatformComponent["CoreInvites"] = "core-invites";
    return PlatformComponent;
}($9c0bdc1aee58920b$var$PlatformComponent || {});
const $9c0bdc1aee58920b$export$615f888019c45765 = {
    ["slack-request-sent"]: new (0, $5aVN7.UFOExperience)("slack-request-sent", {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["slack-segment-rendered"]: new (0, $5aVN7.UFOExperience)("slack-segment-rendered", {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["share-form-enabled"]: new (0, $5aVN7.UFOExperience)("share-form-enabled", {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "share-to-slack"
        }
    }),
    ["platform-slack-users-page-fetched"]: new (0, $5aVN7.UFOExperience)("platform-slack-users-page-fetched", {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "core-invites"
        }
    })
};
const $9c0bdc1aee58920b$export$5e9287b6a10f8075 = (experienceName, properties)=>{
    const experience = $9c0bdc1aee58920b$export$615f888019c45765[experienceName];
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $9c0bdc1aee58920b$export$c5a5cf072c836c0e = (experienceName, properties)=>{
    const experience = $9c0bdc1aee58920b$export$615f888019c45765[experienceName];
    experience.success({
        metadata: properties
    });
};
const $9c0bdc1aee58920b$export$8dda83bafca11b77 = (experienceName, properties)=>{
    const experience = $9c0bdc1aee58920b$export$615f888019c45765[experienceName];
    experience.failure({
        metadata: properties
    });
};
const $9c0bdc1aee58920b$export$b1021040eb94cdca = (experienceName, properties)=>{
    const experience = $9c0bdc1aee58920b$export$615f888019c45765[experienceName];
    experience.abort({
        metadata: properties
    });
};
module.exports["UfoExperiences"] = $9c0bdc1aee58920b$export$72df3c76208340b5;
module.exports["ufoExperiences"] = $9c0bdc1aee58920b$export$615f888019c45765;
module.exports["startUfoExperience"] = $9c0bdc1aee58920b$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $9c0bdc1aee58920b$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $9c0bdc1aee58920b$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $9c0bdc1aee58920b$export$b1021040eb94cdca;

});

parcelRegister("bGwCT", function(module, exports) {

var $gUoHD = parcelRequire("gUoHD");


var $lFI1p = parcelRequire("lFI1p");


var $RmCMu = parcelRequire("RmCMu");

function $9d5c2d63003c781f$var$defaultErrorMapper(response) {
    return Promise.resolve({
        code: response.status.toString(),
        message: response.statusText
    });
}
function $9d5c2d63003c781f$var$defaultResultMapper(response) {
    return response.json();
}
async function $9d5c2d63003c781f$export$1d3435507f486e79({ url: url, queryParams: queryParams = {}, signal: signal, getItems: getItems, getCursor: getCursor, canRetryCheck: canRetryCheck, mapError: mapError = $9d5c2d63003c781f$var$defaultErrorMapper }) {
    const items = [];
    let response;
    let page = 0;
    do {
        // Bail out here in case the abort signal is fired between requests.
        if (signal?.aborted) return {
            ok: false,
            aborted: true
        };
        const cursor = response?.ok ? getCursor(response.result) : undefined;
        const queryParamsWithCursor = cursor ? {
            ...queryParams,
            cursor: cursor
        } : queryParams;
        const search = Object.entries(queryParamsWithCursor ?? {}).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        const urlWithParams = [
            url,
            search
        ].filter(Boolean).join('?');
        // Get the next page and retry in case of intermittent errors
        response = await $9d5c2d63003c781f$export$635968db05579875({
            request: ()=>fetch(urlWithParams, {
                    signal: signal
                }),
            mapError: mapError,
            signal: signal,
            canRetryCheck: canRetryCheck
        });
        if (!response.ok) return response.aborted ? response : {
            ...response,
            page: page
        };
        items.push.apply(items, getItems(response.result));
        ++page;
    }while (response?.ok && getCursor(response.result));
    return {
        ok: true,
        items: items,
        pages: page
    };
}
async function $9d5c2d63003c781f$export$9369b12211e1fce4({ request: request, canRetryCheck: canRetryCheck, attempt: attempt = 0, signal: signal }) {
    const result = await request(signal);
    if (result.ok || result.aborted || signal?.aborted) return result;
    else {
        const [canRetry, timeToWait] = canRetryCheck(result.status, ++attempt, signal);
        if (canRetry) {
            if (timeToWait) await (0, $RmCMu.wait)(timeToWait);
            return $9d5c2d63003c781f$export$9369b12211e1fce4({
                request: request,
                canRetryCheck: canRetryCheck,
                attempt: attempt,
                signal: signal
            });
        }
    }
    return result;
}
const $9d5c2d63003c781f$var$DEFAULT_MAX_ATTEMPTS = 3;
const $9d5c2d63003c781f$var$DEFAULT_BACKOFF_TIME_MS = 200;
const $9d5c2d63003c781f$var$DEFAULT_BACKOFF_TIME_429_MS = 1000;
function $9d5c2d63003c781f$export$bd28f8bf945907aa({ maxAttempts: maxAttempts = $9d5c2d63003c781f$var$DEFAULT_MAX_ATTEMPTS, backoffTimeMs: backoffTimeMs = $9d5c2d63003c781f$var$DEFAULT_BACKOFF_TIME_MS, rateLimitBackoffTimeMs: rateLimitBackoffTimeMs = $9d5c2d63003c781f$var$DEFAULT_BACKOFF_TIME_429_MS } = {}) {
    return (status, attempts)=>{
        // Stop if attempts are exhausted
        if (attempts >= maxAttempts) return [
            false,
            0
        ];
        switch(status){
            // Unlikely to recover from these
            case 401:
            case 403:
            case 404:
                return [
                    false,
                    0
                ];
            // Probably rate limiting. Back off and try again.
            case 429:
                return [
                    true,
                    rateLimitBackoffTimeMs
                ];
            // Unknown error. Back off and try again.
            default:
                return [
                    true,
                    backoffTimeMs
                ];
        }
    };
}
function $9d5c2d63003c781f$export$635968db05579875({ request: request, mapResult: mapResult = $9d5c2d63003c781f$var$defaultResultMapper, mapError: mapError = $9d5c2d63003c781f$var$defaultErrorMapper, canRetryCheck: canRetryCheck = $9d5c2d63003c781f$export$bd28f8bf945907aa(), signal: signal }) {
    return $9d5c2d63003c781f$export$9369b12211e1fce4({
        request: async ()=>{
            let response;
            try {
                response = await request();
                if (response.ok) return {
                    ok: true,
                    result: await mapResult(response)
                };
                const { code: code, message: message } = await mapError(response);
                // Error status
                return {
                    ok: false,
                    aborted: false,
                    status: response.status,
                    code: code,
                    message: message
                };
            } catch (error) {
                if (error instanceof Error) {
                    // Request aborted client-side
                    if (error.name === 'AbortError') return {
                        ok: false,
                        aborted: true
                    };
                    // Client-side networking error
                    return {
                        ok: false,
                        aborted: false,
                        status: (0, $lFI1p.CLIENT_ERROR_STATUS),
                        code: error.name,
                        message: error.message
                    };
                }
                return {
                    ok: false,
                    aborted: false,
                    status: (0, $lFI1p.CLIENT_ERROR_STATUS),
                    code: (0, $lFI1p.CLIENT_ERROR_CODE),
                    message: (0, $lFI1p.CLIENT_ERROR_MESSAGE)
                };
            }
        },
        canRetryCheck: canRetryCheck,
        signal: signal
    });
}
class $9d5c2d63003c781f$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, errorType){
        super(message);
        this.statusCode = void 0;
        this.errorType = void 0;
        this.name = 'FetchError';
        this.statusCode = statusCode;
        this.errorType = errorType;
    }
}
const $9d5c2d63003c781f$export$6d71b655afe1638d = (url, action, init)=>fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        throw new $9d5c2d63003c781f$export$26e841bcf1aeb894(`Unable to fetch ${action} ${response.statusText}`, response.status);
    });
const $9d5c2d63003c781f$var$isNil = (value)=>value === undefined || value === null;
function $9d5c2d63003c781f$export$6b17a39e52c8ee53(obj) {
    const query = Object.keys(obj).filter((key)=>!$9d5c2d63003c781f$var$isNil(obj[key])).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`).join('&');
    return query ? '?' + query : query;
}
function $9d5c2d63003c781f$export$7932064324870761(values) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gUoHD)))(values, ({ name: name })=>name.toLowerCase());
}
module.exports["fetchItemsWithCursor"] = $9d5c2d63003c781f$export$1d3435507f486e79;
module.exports["retryFetch"] = $9d5c2d63003c781f$export$635968db05579875;
module.exports["httpRetryPolicy"] = $9d5c2d63003c781f$export$bd28f8bf945907aa;
module.exports["FetchError"] = $9d5c2d63003c781f$export$26e841bcf1aeb894;
module.exports["fetchJson"] = $9d5c2d63003c781f$export$6d71b655afe1638d;
module.exports["buildQueryString"] = $9d5c2d63003c781f$export$6b17a39e52c8ee53;
module.exports["sortByName"] = $9d5c2d63003c781f$export$7932064324870761;

});

parcelRegister("RmCMu", function(module, exports) {
async function $f12939a5456f7445$export$5c069c93d2b7493f(delayMs) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, delayMs);
    });
}
module.exports["wait"] = $f12939a5456f7445$export$5c069c93d2b7493f;

});

parcelRegister("9Xcuc", function(module, exports) {

var $7TH2w = parcelRequire("7TH2w");


var $eWRwJ = parcelRequire("eWRwJ");


var $lFI1p = parcelRequire("lFI1p");

const $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams = (0, $eWRwJ.default)((0, $lFI1p.ANALYTICS_CHANNEL));
var $bbe3b4672f8bf6d4$var$AnalyticsActionSubject = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["INTEGRATION_SUCCEEDED"] = "integrationEnabled";
    AnalyticsActionSubject["INTEGRATION_TEAMS"] = "integrationTeams";
    AnalyticsActionSubject["INTEGRATION_CONVERSATIONS"] = "integrationConversations";
    AnalyticsActionSubject["INTEGRATION_METADATA"] = "integrationMetadata";
    AnalyticsActionSubject["INTEGRATION_TOKEN"] = "integrationCsrfToken";
    AnalyticsActionSubject["SHARE"] = "share";
    return AnalyticsActionSubject;
}($bbe3b4672f8bf6d4$var$AnalyticsActionSubject || {});
var $bbe3b4672f8bf6d4$var$AnalyticsAction = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    return AnalyticsAction;
}($bbe3b4672f8bf6d4$var$AnalyticsAction || {});
const $bbe3b4672f8bf6d4$export$e0925453bd625a62 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationEnabled",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$d533ef9287e29338 = (createAnalyticsEvent, { status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationEnabled",
        action: "failed",
        attributes: {
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$10723e48240e4b6a = (createAnalyticsEvent, { teams: teams, pages: pages })=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationTeams",
        action: "succeeded",
        attributes: {
            teams: teams,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$77d7c2557ef0cb5b = (createAnalyticsEvent, { page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationTeams",
        action: "failed",
        attributes: {
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$1fb50f4a006f5510 = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages })=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationConversations",
        action: "succeeded",
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$121a5feec5d3a18f = (createAnalyticsEvent, { slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage })=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationConversations",
        action: "failed",
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$503ff4642f649174 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationMetadata",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$68485a36cbb1a06f = (createAnalyticsEvent, params)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationMetadata",
        action: "failed",
        attributes: {
            ...params
        }
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$5cc3ad7b898341e7 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationMetadata",
        action: "succeeded"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$757b1ed45dd16a84 = (createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "integrationCsrfToken",
        action: "failed"
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$var$productActionSubjectId = {
    jira: 'issue',
    confluence: 'page',
    // default to issue at the moment but should
    // be something else depending on what is actually shared
    // once we implement sharing with the platform slack app
    platform: 'issue'
};
const $bbe3b4672f8bf6d4$export$24b0574fd3374a47 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "share",
        action: "succeeded",
        actionSubjectId: $bbe3b4672f8bf6d4$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            messageLength: messageLength,
            workspaceSize: userCount
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$867fe86603399772 = ({ product: product, slackTeamId: slackTeamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: "share",
        action: "failed",
        actionSubjectId: $bbe3b4672f8bf6d4$var$productActionSubjectId[product],
        attributes: {
            integrationTeamId: slackTeamId,
            integrationConversationType: conversationType,
            integrationConversationId: conversationId,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$5a5d58e4161f41aa = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, conversations: conversations, pages: pages, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: 'integrationConversations',
        action: "succeeded",
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            conversations: conversations,
            pages: pages
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$1286eed6ab074bde = ({ slackTeamId: slackTeamId, conversationTypes: conversationTypes, page: page, status: status, errorMessage: errorMessage, actionSubjectId: actionSubjectId }, createAnalyticsEvent)=>{
    const fireEventWithPayload = $bbe3b4672f8bf6d4$var$createAndFireEventOnPeopleTeams({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: 'integrationConversations',
        action: "failed",
        actionSubjectId: actionSubjectId,
        attributes: {
            integrationTeamId: slackTeamId,
            conversationTypes: conversationTypes,
            page: page,
            status: status,
            errorMessage: errorMessage
        },
        source: 'integrationShareDialog'
    });
    fireEventWithPayload(createAnalyticsEvent);
};
const $bbe3b4672f8bf6d4$export$2b9ff26dd710d5d7 = (createAnalyticsEvent)=>({
        onGetEnabledSucceeded: ()=>$bbe3b4672f8bf6d4$export$e0925453bd625a62(createAnalyticsEvent),
        onGetEnabledFailed: (params)=>$bbe3b4672f8bf6d4$export$d533ef9287e29338(createAnalyticsEvent, params),
        onFetchTeamsSucceeded: (params)=>$bbe3b4672f8bf6d4$export$10723e48240e4b6a(createAnalyticsEvent, params),
        onFetchTeamsFailed: (params)=>$bbe3b4672f8bf6d4$export$77d7c2557ef0cb5b(createAnalyticsEvent, params),
        onFetchUsersSucceeded: ({ teamId: teamId, users: users, pages: pages })=>$bbe3b4672f8bf6d4$export$1fb50f4a006f5510(createAnalyticsEvent, {
                slackTeamId: teamId || '',
                conversationTypes: [
                    'directMessage'
                ],
                conversations: users || 0,
                pages: pages
            }),
        onFetchUsersFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>$bbe3b4672f8bf6d4$export$121a5feec5d3a18f(createAnalyticsEvent, {
                slackTeamId: teamId,
                conversationTypes: [
                    'directMessage'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage
            }),
        onShareSucceeded: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, messageLength: messageLength, userCount: userCount })=>{
            $bbe3b4672f8bf6d4$export$24b0574fd3374a47({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                messageLength: messageLength,
                userCount: userCount
            }, createAnalyticsEvent);
        },
        onShareFailed: ({ product: product, teamId: teamId, conversationType: conversationType, conversationId: conversationId, status: status, errorMessage: errorMessage })=>{
            $bbe3b4672f8bf6d4$export$867fe86603399772({
                product: product,
                slackTeamId: teamId,
                conversationType: conversationType,
                conversationId: conversationId,
                status: status,
                errorMessage: errorMessage
            }, createAnalyticsEvent);
        },
        onFetchChannelsSucceeded: ({ teamId: teamId, channels: channels, pages: pages })=>{
            $bbe3b4672f8bf6d4$export$5a5d58e4161f41aa({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                conversations: channels,
                pages: pages,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        },
        onFetchChannelsFailed: ({ teamId: teamId, page: page, status: status, errorMessage: errorMessage })=>{
            $bbe3b4672f8bf6d4$export$1286eed6ab074bde({
                slackTeamId: teamId,
                conversationTypes: [
                    'public',
                    'private'
                ],
                page: page,
                status: status,
                errorMessage: errorMessage,
                actionSubjectId: 'channels'
            }, createAnalyticsEvent);
        }
    });
const $bbe3b4672f8bf6d4$export$2cc68fa43a97a8c = (createAnalyticsEvent)=>({
        onFetchConnectMetadataSucceeded: ()=>$bbe3b4672f8bf6d4$export$503ff4642f649174(createAnalyticsEvent),
        onFetchConnectMetadataFailed: (params)=>$bbe3b4672f8bf6d4$export$68485a36cbb1a06f(createAnalyticsEvent, params),
        onRefreshIntegrationCsrfTokenSucceeded: ()=>$bbe3b4672f8bf6d4$export$5cc3ad7b898341e7(createAnalyticsEvent),
        onRefreshIntegrationCsrfTokenFailed: ()=>$bbe3b4672f8bf6d4$export$757b1ed45dd16a84(createAnalyticsEvent)
    });
module.exports["getSlackServiceAnalytics"] = $bbe3b4672f8bf6d4$export$2b9ff26dd710d5d7;
module.exports["getConfluenceSlackServiceAnalytics"] = $bbe3b4672f8bf6d4$export$2cc68fa43a97a8c;

});

parcelRegister("3LGCH", function(module, exports) {
$parcel$export(module.exports, "default", () => $14fe988998a6c45b$export$2e2bcd8739ae039);

var $lFI1p = parcelRequire("lFI1p");


var $7ws8R = parcelRequire("7ws8R");


var $fD2m3 = parcelRequire("fD2m3");

const $14fe988998a6c45b$var$consentUrl = {
    prod: `https://confluence-chats-integr.services.atlassian.com/api/slack/teams/login?source=${(0, $lFI1p.SOURCE)}`,
    staging: `https://confluence-chats-integr.stg.services.atlassian.com/api/slack/teams/login?source=${(0, $lFI1p.SOURCE)}`
};
const $14fe988998a6c45b$var$connectKey = {
    prod: 'confluence-chats-integration',
    staging: 'confluence-chats-integration-stg-east'
};
const $14fe988998a6c45b$var$ACQUIRE_CSRF_TIMEOUT_MS = 2000;
async function $14fe988998a6c45b$export$2e2bcd8739ae039(location, analytics, signal) {
    const environment = (0, $7ws8R.default)(location.hostname);
    const response = await $14fe988998a6c45b$var$getConfluenceSlackIntegrationDialogParams(location, signal);
    if (!response.ok) {
        if (!response.aborted) analytics.onFetchConnectMetadataFailed({
            status: response.status,
            errorMessage: response.message
        });
        return response;
    }
    analytics.onFetchConnectMetadataSucceeded();
    const { contextJwt: contextJwt, url: url } = response.result;
    // Prime the consent URL’s origin with any cookies it needs (namely, the CSRF
    // token) which would ordinarily be set by integration’s dialog.
    //
    // Explanation: This ensures a cookie containing a valid CSRF token is set on
    // the Slack consent popup window’s origin. This is a necessary step because
    // the Slack integration requires a valid CSRF token in the consent page
    // request when its URL contains a jwt query parameter. Failure to provide a
    // CSRF token cookie results in an invalid CSRF token error.
    try {
        await (0, $fD2m3.default)(url, $14fe988998a6c45b$var$ACQUIRE_CSRF_TIMEOUT_MS);
        analytics.onRefreshIntegrationCsrfTokenSucceeded();
    } catch (error) {
        analytics.onRefreshIntegrationCsrfTokenFailed();
    // Ignore and hope there’s already a valid CSRF token.
    }
    return {
        ok: true,
        result: `${$14fe988998a6c45b$var$consentUrl[environment]}&jwt=${encodeURIComponent(contextJwt)}`
    };
}
async function $14fe988998a6c45b$var$getConfluenceSlackIntegrationDialogParams(location, signal) {
    const connectPath = $14fe988998a6c45b$var$getConnectPath(location);
    try {
        const response = await fetch(connectPath, {
            method: 'POST',
            headers: {
                'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
            },
            signal: signal,
            body: Object.entries({
                'plugin-key': 'confluence-chats-integration',
                key: 'dialog',
                productContext: '{}',
                classifier: 'json'
            }).map((kvp)=>kvp.map(encodeURIComponent).join('=')).join('&')
        });
        if (response.ok) return {
            ok: true,
            result: await response.json()
        };
        return {
            ok: false,
            aborted: false,
            status: response.status,
            code: `${response.status}`,
            message: await response.text()
        };
    } catch (error) {
        if (error instanceof Error) {
            if (error.name === 'AbortError') return {
                ok: false,
                aborted: true
            };
            return {
                ok: false,
                aborted: false,
                status: (0, $lFI1p.CLIENT_ERROR_STATUS),
                code: (0, $lFI1p.CLIENT_ERROR_CODE),
                message: error.message || (0, $lFI1p.CLIENT_ERROR_MESSAGE)
            };
        }
        return {
            ok: false,
            aborted: false,
            status: (0, $lFI1p.CLIENT_ERROR_STATUS),
            code: (0, $lFI1p.CLIENT_ERROR_CODE),
            message: (0, $lFI1p.CLIENT_ERROR_MESSAGE)
        };
    }
}
function $14fe988998a6c45b$var$getConnectPath(location) {
    const environment = (0, $7ws8R.default)(location.hostname);
    return `/wiki/plugins/servlet/ac/${$14fe988998a6c45b$var$connectKey[environment]}/dialog`;
}

});

parcelRegister("7ws8R", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcc9b46d007c7d7e$export$2e2bcd8739ae039);
function $bcc9b46d007c7d7e$export$2e2bcd8739ae039(hostname) {
    return hostname.endsWith('jira-dev.com') || hostname.endsWith('localhost') ? 'staging' : 'prod';
}

});

parcelRegister("fD2m3", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0dec9e320f3b678$export$2e2bcd8739ae039);
/**
 * Fetch the specified URL, which is expected to set one or more cookies on its
 * origin.
 *
 * In order for this to work, a same-origin request is made by temporarily
 * creating an iframe.
 *
 * @param url       - the URL to fetch
 * @param timeoutMs - milliseconds to wait before timing out
 */ function $d0dec9e320f3b678$export$2e2bcd8739ae039(url, timeoutMs) {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.width = '0';
    iframe.height = '0';
    iframe.style.position = 'absolute';
    iframe.style.visibility = 'hidden';
    iframe.style.borderWidth = '0';
    document.body.appendChild(iframe);
    return new Promise((resolve, reject)=>{
        let completed = false;
        const timeout = setTimeout(()=>{
            completed = true;
            document.body.removeChild(iframe);
            reject();
        }, timeoutMs);
        iframe.onload = ()=>{
            if (!completed) {
                clearTimeout(timeout);
                completed = true;
                document.body.removeChild(iframe);
                resolve();
            }
        };
    });
}

});

parcelRegister("jlluG", function(module, exports) {

var $3RfNn = parcelRequire("3RfNn");


var $9Xcuc = parcelRequire("9Xcuc");


var $6mcys = parcelRequire("6mcys");

class $a356c0d8bf77587d$export$2e2bcd8739ae039 extends (0, $3RfNn.default) {
    async primeConsentUrl() {
        if (!this.consentUrl) this.consentUrl = (0, $6mcys.default)(location);
    }
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $9Xcuc.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'jira', analytics);
    }
}
module.exports["default"] = $a356c0d8bf77587d$export$2e2bcd8739ae039;

});

parcelRegister("6mcys", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4540f82c5f3f9b7$export$2e2bcd8739ae039);

var $lFI1p = parcelRequire("lFI1p");


var $7ws8R = parcelRequire("7ws8R");

const $b4540f82c5f3f9b7$var$consentUrl = {
    prod: `https://atlassian-slack-integration.services.atlassian.com/api/slack/login?source=${(0, $lFI1p.SOURCE)}`,
    staging: `https://atlassian-slack-integration.stg.services.atlassian.com/api/slack/login?source=${(0, $lFI1p.SOURCE)}`
};
function $b4540f82c5f3f9b7$export$2e2bcd8739ae039(location) {
    const environment = (0, $7ws8R.default)(location.hostname);
    return $b4540f82c5f3f9b7$var$consentUrl[environment];
}

});

parcelRegister("fKUsn", function(module, exports) {

var $3RfNn = parcelRequire("3RfNn");


var $9Xcuc = parcelRequire("9Xcuc");


var $lFI1p = parcelRequire("lFI1p");


var $6BEN7 = parcelRequire("6BEN7");


var $bGwCT = parcelRequire("bGwCT");

const $3bef05825ee6019c$var$USER_FETCH_LIMIT = 500;
const $3bef05825ee6019c$var$RETRY_OPTIONS = {
    maxAttempts: 3,
    backoffTimeMs: 200,
    rateLimitBackoffTimeMs: 1000
};
class $3bef05825ee6019c$export$2e2bcd8739ae039 extends (0, $3RfNn.default) {
    streamUsers(teamId, onResponse, cursor) {
        (0, $6BEN7.startUfoExperience)((0, $6BEN7.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
            limit: $3bef05825ee6019c$var$USER_FETCH_LIMIT
        });
        if (!cursor) this.userStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            teamId: teamId,
            cloudId: this.cloudId,
            limit: $3bef05825ee6019c$var$USER_FETCH_LIMIT.toString(),
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $bGwCT.retryFetch)({
            request: ()=>fetch(`${(0, $lFI1p.DEFAULT_STARGATE_SERVICE_URL)}${(0, $lFI1p.EXUS_THIRDPARTY_PATH)}/slack/users?${queryString}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $bGwCT.httpRetryPolicy)($3bef05825ee6019c$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                if (!resp.aborted) {
                    this.analytics.onFetchUsersFailed({
                        teamId: teamId,
                        page: this.userStream.pages,
                        status: resp.status,
                        errorMessage: resp.message
                    });
                    (0, $6BEN7.failUfoExperience)((0, $6BEN7.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                } else (0, $6BEN7.abortUfoExperience)((0, $6BEN7.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED);
                onResponse(resp);
                return;
            }
            this.userStream.pages++;
            this.userStream.count += resp.result.users.length;
            this.userStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.users.map(({ id: id, email: email, displayName: displayName, realName: name, avatar: avatarUrl })=>({
                        id: id,
                        name: name,
                        displayName: displayName,
                        avatarUrl: avatarUrl,
                        email: email,
                        type: 'directMessage'
                    })),
                nextCursor: resp.result.nextCursor
            });
            (0, $6BEN7.succeedUfoExperience)((0, $6BEN7.UfoExperiences).PLATFORM_SLACK_USERS_PAGE_FETCHED, {
                numResults: resp.result.users.length
            });
            if (resp.result.nextCursor) this.streamUsers(teamId, onResponse, resp.result.nextCursor);
            else this.analytics.onFetchUsersSucceeded({
                teamId: teamId,
                users: this.userStream.count,
                pages: this.userStream.pages
            });
        });
    }
    /*
   * Temporary experiment endpoint for Invite 3rd Party Team (ITPT)
   */ streamChannelsExperiment(workspaceId, onResponse, onError, cursor) {
        if (!cursor) this.channelStream = {
            count: 0,
            pages: 0,
            finishedLoading: false
        };
        const queryString = new URLSearchParams({
            workspaceId: workspaceId,
            ...cursor ? {
                cursor: cursor
            } : {}
        });
        (0, $bGwCT.retryFetch)({
            request: ()=>fetch(`${(0, $lFI1p.DEFAULT_STARGATE_SERVICE_URL)}${(0, $lFI1p.ITPT_PATH)}${(0, $lFI1p.ITPT_SLACK_CHANNELS)}?${queryString}`, {
                    signal: this.abortController?.signal
                }),
            canRetryCheck: (0, $bGwCT.httpRetryPolicy)($3bef05825ee6019c$var$RETRY_OPTIONS)
        }).then((resp)=>{
            if (!resp.ok) {
                onResponse(resp);
                return;
            }
            this.channelStream.pages++;
            this.channelStream.count += resp.result.channels.length;
            this.channelStream.finishedLoading = !!resp.result.nextCursor;
            onResponse({
                ok: true,
                result: resp.result.channels,
                nextCursor: resp.result.nextCursor
            });
            if (resp.result.nextCursor) this.streamChannelsExperiment(workspaceId, onResponse, onError, resp.result.nextCursor);
        }).catch((error)=>{
            onError(error);
        });
    }
    // This was necessary since it was abstract in the base class
    // but is not used in this slack service
    async primeConsentUrl() {}
    constructor(cloudId, createUIAnalyticsEvent){
        const analytics = (0, $9Xcuc.getSlackServiceAnalytics)(createUIAnalyticsEvent);
        super(cloudId, 'platform', analytics);
    }
}
module.exports["default"] = $3bef05825ee6019c$export$2e2bcd8739ae039;

});

parcelRegister("hpRYU", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $gtD4K = parcelRequire("gtD4K");


var $kSKAi = parcelRequire("kSKAi");


var $7rus4 = parcelRequire("7rus4");


var $6f0Oj = parcelRequire("6f0Oj");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $6mKj3 = parcelRequire("6mKj3");


var $jjoF2 = parcelRequire("jjoF2");


var $6RGMW = parcelRequire("6RGMW");


var $g3p2i = parcelRequire("g3p2i");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components })=>{
    const [error, setError] = (0, $42omo.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $6RGMW.UserAndGroupSearchQuery));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: components,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId,
        'aria-label': ariaLabel
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        enableEmailSearch: (0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false),
        allowEmailSelectionWhenEmailMatched: !(0, $6mKj3.expVal)('confluence-enable-email-ux-in-user-group-search', 'isEnabled', false)
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("kSKAi", function(module, exports) {
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $bS1VQ = parcelRequire("bS1VQ");

var $2gD2K = parcelRequire("2gD2K");


var $28cxD = parcelRequire("28cxD");


var $42omo = parcelRequire("42omo");


var $89I2S = parcelRequire("89I2S");


var $lugM7 = parcelRequire("lugM7");


var $e1cJ5 = parcelRequire("e1cJ5");


var $dTofT = parcelRequire("dTofT");


var $bYlb2 = parcelRequire("bYlb2");


var $39zOH = parcelRequire("39zOH");


var $aahZc = parcelRequire("aahZc");


var $8hAFq = parcelRequire("8hAFq");


var $dQl1W = parcelRequire("dQl1W");


var $dh538 = parcelRequire("dh538");

function $f70d9dc6cc3ace22$var$_defineProperty(e, r, t) {
    return (r = $f70d9dc6cc3ace22$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f70d9dc6cc3ace22$var$_toPropertyKey(t) {
    var i = $f70d9dc6cc3ace22$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f70d9dc6cc3ace22$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $f70d9dc6cc3ace22$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const experienceForId = (0, $8hAFq.userPickerRenderedUfoExperience).getInstance(this.ufoId); // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
            (0, $28cxD.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $bS1VQ.default) : (0, $2gD2K.default);
        const creatableProps = suggestEmailsForDomain ? (0, $bYlb2.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $dTofT.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8hAFq.UfoErrorBoundary), {
            id: this.ufoId,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $39zOH.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aahZc.ExusUserSourceProvider), {
                    fetchUserSource: loadUserSource,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $89I2S.BaseUserPickerWithoutAnalytics), {
                        ...this.props,
                        forwardedRef: this.props.forwardedRef,
                        width: width,
                        SelectComponent: SelectComponent,
                        styles: (0, $lugM7.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $dh538.fg)('platform-component-visual-refresh'), false, (0, $dh538.fg)('jifjam_bulk_operations') ? this.props.height : undefined),
                        components: (0, $e1cJ5.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
                        pickerProps: pickerProps
                    })
                })
            })
        });
    }
    constructor(props){
        super(props); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        $f70d9dc6cc3ace22$var$_defineProperty(this, "ufoId", void 0);
        this.ufoId = (0, $dQl1W.v4)();
        const experienceForId = (0, $8hAFq.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id,
            (0, $28cxD.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
}
$f70d9dc6cc3ace22$var$_defineProperty($f70d9dc6cc3ace22$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $f70d9dc6cc3ace22$export$83e0c73b09b3a9cd = (0, $1DWH0.default)()($f70d9dc6cc3ace22$export$164f4d95e5d7e2f5);
module.exports["UserPicker"] = $f70d9dc6cc3ace22$export$83e0c73b09b3a9cd;

});

parcelRegister("89I2S", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $28cxD = parcelRequire("28cxD");


var $jSnXV = parcelRequire("jSnXV");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $dQl1W = parcelRequire("dQl1W");


var $dlhVH = parcelRequire("dlhVH");


var $chpH1 = parcelRequire("chpH1");


var $3aPpx = parcelRequire("3aPpx");


var $6O3OC = parcelRequire("6O3OC");


var $8UAzT = parcelRequire("8UAzT");


var $8hAFq = parcelRequire("8hAFq");


var $dh538 = parcelRequire("dh538");

const $c504d7760af5313e$var$loadingMessage = ()=>null;
const $c504d7760af5313e$var$classNamePrefix = 'fabric-user-picker';
class $c504d7760af5313e$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $6O3OC.optionToSelectableOptions)(nextProps.value);
        else if ((0, $6O3OC.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $6O3OC.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    get isCreateTeamA11yEnabled() {
        return (0, $dh538.fg)('a11y-create-team-is-not-focusable-and-has-no-btn');
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused changes from true to false
        if (this.isCreateTeamA11yEnabled && menuIsOpen && prevProps.isFooterFocused === true && this.props.isFooterFocused === false && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $6O3OC.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $dlhVH.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $dlhVH.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $28cxD.UFOExperienceState).STARTED.id,
            (0, $28cxD.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, $l998X.jsx)(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $c504d7760af5313e$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).placeholder
            }),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $c504d7760af5313e$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
    constructor(props){
        super(props);
        this.selectRef = void 0;
        this.session = void 0;
        // session id for focus to blur
        this.journeyId = void 0;
        this.optionsShownUfoExperienceInstance = void 0;
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $6O3OC.callCallback)(onChange, (0, $6O3OC.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $6O3OC.callCallback)(onSelection, (0, $6O3OC.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $dlhVH.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $dlhVH.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $6O3OC.callCallback)(onClear);
                    this.fireEvent((0, $dlhVH.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $dlhVH.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $dlhVH.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $chpH1.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $dlhVH.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $6O3OC.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $28cxD.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $6O3OC.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $6O3OC.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $6O3OC.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleOpen = ()=>{
            (0, $6O3OC.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleBlur = ()=>{
            if (this.isCreateTeamA11yEnabled && this.props.isFooterFocused) return;
            (0, $6O3OC.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $6O3OC.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleClose = ()=>{
            if (this.isCreateTeamA11yEnabled && this.props.isFooterFocused) return;
            this.resetInputState();
            (0, $6O3OC.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $6O3OC.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $dlhVH.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $dlhVH.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $dlhVH.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (this.isCreateTeamA11yEnabled) {
                if (event.key === 'Escape') {
                    this.setState({
                        menuIsOpen: false,
                        options: []
                    });
                    this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                }
                if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            }
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptions = ()=>{
            const options = (0, $6O3OC.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $8UAzT.groupOptionsByType)(options, groupByTypeOrder) : options;
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $8hAFq.userPickerOptionsShownUfoExperience).getInstance((0, $dQl1W.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
}
$c504d7760af5313e$export$b4ff48c8d43b18c3.defaultProps = {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $3aPpx.messages).errorMessage
        }),
    openMenuOnClick: false
};
const $c504d7760af5313e$export$d099ade7b4f4d2a4 = (0, $1DWH0.default)()($c504d7760af5313e$export$b4ff48c8d43b18c3);
module.exports["BaseUserPickerWithoutAnalytics"] = $c504d7760af5313e$export$b4ff48c8d43b18c3;

});

parcelRegister("dlhVH", function(module, exports) {

var $eWRwJ = parcelRequire("eWRwJ");


var $dQl1W = parcelRequire("dQl1W");


var $6O3OC = parcelRequire("6O3OC");

const $02b4d9c4beeba836$var$packageName = "platform-pkg";
const $02b4d9c4beeba836$var$packageVersion = "0.0.0-use.local";
const $02b4d9c4beeba836$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $02b4d9c4beeba836$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $02b4d9c4beeba836$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $02b4d9c4beeba836$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $dQl1W.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $02b4d9c4beeba836$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $02b4d9c4beeba836$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $02b4d9c4beeba836$var$packageName,
            packageVersion: $02b4d9c4beeba836$var$packageVersion,
            ...attributes
        }
    });
const $02b4d9c4beeba836$var$checkValidId = (id)=>{
    return $02b4d9c4beeba836$var$UUID_REGEXP_NEW_AAID.test(id) || $02b4d9c4beeba836$var$UUID_REGEXP_OLD_AAID.test(id) || $02b4d9c4beeba836$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $02b4d9c4beeba836$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $02b4d9c4beeba836$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $6O3OC.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $6O3OC.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $02b4d9c4beeba836$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$02b4d9c4beeba836$var$optionData2Analytics(data));
    }
    return [];
};
const $02b4d9c4beeba836$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $02b4d9c4beeba836$var$sessionId(session),
        pickerType: $02b4d9c4beeba836$var$pickerType(props),
        journeyId: journeyId
    });
const $02b4d9c4beeba836$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('ui', 'focused', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $02b4d9c4beeba836$var$buildValueForAnalytics(state.value)
    });
const $02b4d9c4beeba836$export$7b5800e732182efb = (props, state, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $02b4d9c4beeba836$var$values(state)
    });
const $02b4d9c4beeba836$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$02b4d9c4beeba836$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $02b4d9c4beeba836$var$sessionId(session),
        journeyId: journeyId,
        value: $02b4d9c4beeba836$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $02b4d9c4beeba836$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$02b4d9c4beeba836$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        queryLength: $02b4d9c4beeba836$var$queryLength(args[0]),
        spaceInQuery: $02b4d9c4beeba836$var$spaceInQuery(args[0]),
        upKeyCount: $02b4d9c4beeba836$var$upKeyCount(session),
        downKeyCount: $02b4d9c4beeba836$var$downKeyCount(session)
    });
const $02b4d9c4beeba836$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $02b4d9c4beeba836$var$createEvent('ui', $02b4d9c4beeba836$var$selectEventType(session), 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        position: $02b4d9c4beeba836$var$position(state, args[0]),
        queryLength: $02b4d9c4beeba836$var$queryLength(state),
        spaceInQuery: $02b4d9c4beeba836$var$spaceInQuery(state),
        upKeyCount: $02b4d9c4beeba836$var$upKeyCount(session),
        downKeyCount: $02b4d9c4beeba836$var$downKeyCount(session),
        result: $02b4d9c4beeba836$var$result(args[0]),
        numberOfResults: $02b4d9c4beeba836$var$numberOfResults(state)
    });
};
const $02b4d9c4beeba836$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $02b4d9c4beeba836$var$results(state);
    return $02b4d9c4beeba836$var$createEvent('operational', 'searched', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $02b4d9c4beeba836$var$sessionDuration(session),
        durationSinceInputChange: $02b4d9c4beeba836$var$durationSinceInputChange(session),
        queryLength: $02b4d9c4beeba836$var$queryLength(state),
        isLoading: $02b4d9c4beeba836$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $02b4d9c4beeba836$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$02b4d9c4beeba836$var$createEvent('operational', 'failed', 'userPicker', {
        ...$02b4d9c4beeba836$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $02b4d9c4beeba836$export$f541f04954b0c11e = (sources, accountId)=>$02b4d9c4beeba836$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $02b4d9c4beeba836$var$checkValidId(accountId) ? accountId : null
    });
function $02b4d9c4beeba836$var$queryLength(state) {
    return state.inputValue.length;
}
function $02b4d9c4beeba836$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $02b4d9c4beeba836$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $02b4d9c4beeba836$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $02b4d9c4beeba836$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $02b4d9c4beeba836$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $02b4d9c4beeba836$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $02b4d9c4beeba836$var$sessionId(session) {
    return session && session.id;
}
function $02b4d9c4beeba836$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $02b4d9c4beeba836$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $02b4d9c4beeba836$var$result(option) {
    return option ? $02b4d9c4beeba836$var$optionData2Analytics(option.data) : null;
}
function $02b4d9c4beeba836$var$results(state) {
    return (state.options || []).map($02b4d9c4beeba836$var$optionData2Analytics);
}
function $02b4d9c4beeba836$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $02b4d9c4beeba836$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$02b4d9c4beeba836$var$optionData2Analytics(option.data)) : [
        $02b4d9c4beeba836$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $02b4d9c4beeba836$var$numberOfResults(state) {
    return (state.options || []).length;
}
module.exports["startSession"] = $02b4d9c4beeba836$export$c0d84948cecf78d8;
module.exports["createAndFireEventInElementsChannel"] = $02b4d9c4beeba836$export$53eef0dcd9611650;
module.exports["focusEvent"] = $02b4d9c4beeba836$export$e7818c470f37c4bd;
module.exports["clearEvent"] = $02b4d9c4beeba836$export$7b5800e732182efb;
module.exports["deleteEvent"] = $02b4d9c4beeba836$export$95711ec6c6227e9a;
module.exports["cancelEvent"] = $02b4d9c4beeba836$export$e9caaaecfee38128;
module.exports["selectEvent"] = $02b4d9c4beeba836$export$48143d759475d90f;
module.exports["searchedEvent"] = $02b4d9c4beeba836$export$911fb7184b6037eb;
module.exports["failedEvent"] = $02b4d9c4beeba836$export$c2aec355fef65c9c;
module.exports["userInfoEvent"] = $02b4d9c4beeba836$export$f541f04954b0c11e;

});

parcelRegister("chpH1", function(module, exports) {
function $f35c9d88e8abf7dd$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}
module.exports["batchByKey"] = $f35c9d88e8abf7dd$export$da86c38211c1c0a8;

});

parcelRegister("3aPpx", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4f3ddb26b3e05986$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "fabric.elements.user-picker.placeholder",
        defaultMessage: "Enter people or teams..."
    },
    addMore: {
        id: "fabric.elements.user-picker.placeholder.add-more",
        defaultMessage: "add more people..."
    },
    remove: {
        id: "fabric.elements.user-picker.multi.remove-item",
        defaultMessage: "Remove"
    },
    clear: {
        id: "fabric.elements.user-picker.single.clear",
        defaultMessage: "Clear"
    },
    errorMessage: {
        id: "fabric.elements.user-picker.error.message",
        defaultMessage: "Something went wrong"
    },
    teamByline: {
        id: "fabric.elements.user-picker.team.byline",
        defaultMessage: "Team"
    },
    officialTeamByline: {
        id: "fabric.elements.user-picker.team.byline.official",
        defaultMessage: "Official team {verifiedIcon}"
    },
    officialMemberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count.official",
        defaultMessage: "Official team {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}"
    },
    officialMemberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.official.including.you",
        defaultMessage: "Official team {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.including.you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    officialPlus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official",
        defaultMessage: "Official team {verifiedIcon} \u2022 50+ members"
    },
    officialPlus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official.including.you",
        defaultMessage: "Official team {verifiedIcon} \u2022 50+ members, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    addEmail: {
        id: "fabric.elements.user-picker.email.add",
        defaultMessage: "Add user"
    },
    selectToAddEmail: {
        id: "fabric.elements.user-picker.email.select.to.add",
        defaultMessage: "Select an email address"
    },
    continueToAddEmail: {
        id: "fabric.elements.user-picker.email.add.potential",
        defaultMessage: "Enter an email address"
    },
    adminManagedGroupByline: {
        id: "fabric.elements.user-picker.group.byline.admin-managed",
        defaultMessage: "Admin group {verifiedIcon}"
    },
    groupByline: {
        id: "fabric.elements.user-picker.group.byline",
        defaultMessage: "Admin-managed group"
    },
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    externalUserSourcesError: {
        id: "fabric.elements.user-picker.external.sourced.error",
        defaultMessage: "We can't connect you right now."
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    jiraSource: {
        id: "fabric.elements.user-picker.source.jira",
        defaultMessage: "Jira"
    },
    confluenceSource: {
        id: "fabric.elements.user-picker.source.confluence",
        defaultMessage: "Confluence"
    },
    otherAtlassianSource: {
        id: "fabric.elements.user-picker.source.other-atlassian",
        defaultMessage: "Other Atlassian products"
    },
    otherAtlassianSourceAppify: {
        id: "fabric.elements.user-picker.source.other-atlassian-appify",
        defaultMessage: "Other Atlassian apps"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    },
    userTypeLabel: {
        id: "fabric.elements.user-picker.user.type.label",
        defaultMessage: "People"
    },
    teamTypeLabel: {
        id: "fabric.elements.user-picker.team.type.label",
        defaultMessage: "Teams"
    },
    emailTypeLabel: {
        id: "fabric.elements.user-picker.email.type.label",
        defaultMessage: "Emails"
    },
    groupTypeLabel: {
        id: "fabric.elements.user-picker.group.type.label",
        defaultMessage: "Groups"
    },
    externalUserTypeLabel: {
        id: "fabric.elements.user-picker.external.user.type.label",
        defaultMessage: "External Users"
    },
    customTypeLabel: {
        id: "fabric.elements.user-picker.custom.type.label",
        defaultMessage: "Customs"
    },
    otherTypeLabel: {
        id: "fabric.elements.user-picker.other.type.label",
        defaultMessage: "Others"
    }
});
module.exports["messages"] = $4f3ddb26b3e05986$export$defe85febe8b728c;

});

parcelRegister("8UAzT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $2XqLN = parcelRequire("2XqLN");


var $3aPpx = parcelRequire("3aPpx");

const $ca249474c88b0d42$var$getLabelForType = (type)=>{
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).userTypeLabel
            });
        case 'team':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).teamTypeLabel
            });
        case 'group':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).groupTypeLabel
            });
        case 'custom':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).customTypeLabel
            });
        case 'external_user':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).externalUserTypeLabel
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).otherTypeLabel
            });
    }
};
const $ca249474c88b0d42$export$393a985f7dd07cfe = (0, $2XqLN.default)((options, groupByTypeOrder)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $ca249474c88b0d42$var$getLabelForType(type),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});
module.exports["groupOptionsByType"] = $ca249474c88b0d42$export$393a985f7dd07cfe;

});

parcelRegister("8hAFq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $28cxD = parcelRequire("28cxD");

const $6d031c0252e61ff0$export$b49757166e1acfc2 = new (0, $9801n.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
const $6d031c0252e61ff0$export$135a264e0da507ae = new (0, $9801n.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $iqaft.ExperienceTypes).Operation,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
});
class $6d031c0252e61ff0$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        const instance = $6d031c0252e61ff0$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $28cxD.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["userPickerRenderedUfoExperience"] = $6d031c0252e61ff0$export$b49757166e1acfc2;
module.exports["userPickerOptionsShownUfoExperience"] = $6d031c0252e61ff0$export$135a264e0da507ae;
module.exports["UfoErrorBoundary"] = $6d031c0252e61ff0$export$5ef1c2550074a375;

});

parcelRegister("lugM7", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $eKXGE = parcelRequire("eKXGE");


var $dh538 = parcelRequire("dh538");

const $4ce04523015976a9$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $4ce04523015976a9$export$53937c04f7dfc2ae = 6;
const $4ce04523015976a9$export$2c62ba763e976c54 = 39;
const $4ce04523015976a9$export$ffd58b7f6f099a57 = (0, $2XqLN.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)",
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? "var(--ds-background-danger, #FFECEB)" : state.isFocused ? css[':hover'] ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)" : state.isDisabled ? "var(--ds-background-disabled, #17171708)" : "var(--ds-background-input-hovered, #F8F8F8)"
                },
                padding: 0,
                minHeight: height && (0, $dh538.fg)('jifjam_bulk_operations') || isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height && (0, $dh538.fg)('jifjam_bulk_operations') ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                paddingLeft: isMulti ? $4ce04523015976a9$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$4ce04523015976a9$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $4ce04523015976a9$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: "var(--ds-text-subtlest, #6B6E76)",
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: "var(--ds-text-subtlest, #6B6E76)"
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $eKXGE.mergeStyles)(styles, overrideStyles) : styles;
});
const $4ce04523015976a9$export$4e983f376ad8a3af = (0, $2XqLN.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$4ce04523015976a9$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));
module.exports["getStyles"] = $4ce04523015976a9$export$ffd58b7f6f099a57;

});

parcelRegister("e1cJ5", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $8BxoE = parcelRequire("8BxoE");


var $8Z5lp = parcelRequire("8Z5lp");


var $djtLL = parcelRequire("djtLL");


var $d1LXW = parcelRequire("d1LXW");


var $biJXh = parcelRequire("biJXh");


var $gtKKr = parcelRequire("gtKKr");


var $95uM8 = parcelRequire("95uM8");


var $aoWT3 = parcelRequire("aoWT3");


var $91jwt = parcelRequire("91jwt");


var $8lAE4 = parcelRequire("8lAE4");


var $8LA5n = parcelRequire("8LA5n");

const $55820c8d7312f5f6$export$4e811121b221213b = (0, $2XqLN.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $d1LXW.Option
    };
    else return {
        MultiValue: $8Z5lp.MultiValue,
        DropdownIndicator: null,
        SingleValue: $biJXh.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $8BxoE.ClearIndicator) : null,
        Option: $d1LXW.Option,
        ValueContainer: multi ? (0, $djtLL.MultiValueContainer) : (0, $95uM8.SingleValueContainer),
        Input: $gtKKr.Input,
        Menu: $8lAE4.Menu,
        Control: $8LA5n.default,
        ...customComponents ? customComponents : {}
    };
});
const $55820c8d7312f5f6$export$19205fd341a6bb08 = (0, $2XqLN.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $biJXh.SingleValue,
        ClearIndicator: $8BxoE.ClearIndicator,
        Option: $d1LXW.Option,
        ValueContainer: (0, $95uM8.SingleValueContainer),
        Input: (0, $aoWT3.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $91jwt.PopupControl)
    };
    return baseProps;
});
module.exports["getComponents"] = $55820c8d7312f5f6$export$4e811121b221213b;

});

parcelRegister("8BxoE", function(module, exports) {
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

function $a971b05a8af6e488$var$_defineProperty(e, r, t) {
    return (r = $a971b05a8af6e488$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $a971b05a8af6e488$var$_toPropertyKey(t) {
    var i = $a971b05a8af6e488$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $a971b05a8af6e488$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

const $a971b05a8af6e488$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $a971b05a8af6e488$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $a971b05a8af6e488$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $a971b05a8af6e488$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: Indicator,
            children: /*#__PURE__*/ (0, $l998X.jsx)($a971b05a8af6e488$var$AsyncTooltip, {
                content: clearValueLabel,
                children: Indicator
            })
        }) : Indicator;
    }
    constructor(...args){
        super(...args);
        $a971b05a8af6e488$var$_defineProperty(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
             // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue(); //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
}
module.exports["ClearIndicator"] = $a971b05a8af6e488$export$ecf9cf59142dd54a;

});

parcelRegister("dWRcP", function(module, exports) {

let $a279f6b565ca3fab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a279f6b565ca3fab$var$load("764nc").then(()=>parcelRequire('SMbnh'));

});

parcelRegister("8Z5lp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");


var $9K4OG = parcelRequire("9K4OG");


var $7NrQn = parcelRequire("7NrQn");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $7D93v = parcelRequire("7D93v");


var $cO3Oi = parcelRequire("cO3Oi");

function $926971438bfd3fb0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $926971438bfd3fb0$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $926971438bfd3fb0$var$groupTagContainer = (0, $ecnYn.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $926971438bfd3fb0$var$nameWrapper = {
    name: "1ebbz80",
    styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
class $926971438bfd3fb0$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $926971438bfd3fb0$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps; // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hOY6.components).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dcJ7R.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $926971438bfd3fb0$var$nameWrapper
        }, children), this.getElemAfter()));
    }
    constructor(props){
        super(props);
        this.containerRef = void 0;
        this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $6O3OC.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7NrQn.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $6O3OC.isGroup)(data)) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $926971438bfd3fb0$var$groupTagContainer
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7D93v))), {
                LEGACY_margin: "-2px 0 0 0",
                color: "currentColor",
                label: "",
                LEGACY_size: "small"
            }));
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: "multi",
                src: (0, $6O3OC.getAvatarUrl)(data),
                type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person'
            });
        };
        this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates || (0, $6O3OC.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
    }
}
module.exports["MultiValue"] = $926971438bfd3fb0$export$419cdf50db8b579;

});

parcelRegister("7NrQn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5GDNB = parcelRequire("5GDNB");


var $9K4OG = parcelRequire("9K4OG");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $1a863c2fdda060de$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF5DB)" : "var(--ds-background-neutral, #0515240F)";
    return /*#__PURE__*/ (0, $9K4OG.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $1a863c2fdda060de$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $1a863c2fdda060de$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5GDNB))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        LEGACY_size: isLozenge ? 'small' : 'medium',
        LEGACY_margin: "0 0 0 -2px",
        color: isPendingAction && (0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #9E4C00)" : "var(--ds-text-subtle, #505258)"
    }));
};
module.exports["AddOptionAvatar"] = $1a863c2fdda060de$export$df396db45e491922;

});

parcelRegister("daWcu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $esRft = parcelRequire("esRft");


var $alaek = parcelRequire("alaek");


var $42omo = parcelRequire("42omo");


var $6O3OC = parcelRequire("6O3OC");

class $7c01c0d05ab0848d$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $6O3OC.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $alaek.default), {
            ...props
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
            ...props
        });
    }
}
module.exports["SizeableAvatar"] = $7c01c0d05ab0848d$export$44d81a88129649da;

});

parcelRegister("alaek", function(module, exports) {
$parcel$export(module.exports, "default", () => $21bae01687242d76$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $cmDjE = parcelRequire("cmDjE");

const $21bae01687242d76$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $21bae01687242d76$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
function $21bae01687242d76$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cmDjE.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        })
    });
}

});

parcelRegister("cmDjE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5P3yi = parcelRequire("5P3yi");


var $f2BEc = parcelRequire("f2BEc");

const $bdf91181004cdb95$var$boxShadowCssVar = '--avatar-box-shadow';
const $bdf91181004cdb95$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $bdf91181004cdb95$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $bdf91181004cdb95$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $bdf91181004cdb95$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $bdf91181004cdb95$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $bdf91181004cdb95$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $bdf91181004cdb95$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $bdf91181004cdb95$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const avatarSrc = (0, $f2BEc.getTeamAvatarSrc)(src, teamId); // If src changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if (!avatarSrc || hasImageErrored) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5P3yi.FallbackAvatar), {
        "aria-label": alt,
        width: $bdf91181004cdb95$var$SIZES[size],
        height: $bdf91181004cdb95$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $gMc0m.default)([
            $bdf91181004cdb95$var$unboundStyles.root,
            $bdf91181004cdb95$var$containerStyles.root,
            $bdf91181004cdb95$var$borderRadiusMap[size],
            $bdf91181004cdb95$var$widthHeightMap[size],
            compact ? $bdf91181004cdb95$var$containerStyles.compactSpacing : $bdf91181004cdb95$var$containerStyles.nonCompactSpacing
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            onError: ()=>setHasImageErrored(true),
            className: (0, $gMc0m.default)([
                $bdf91181004cdb95$var$avatarImageStyles.image
            ])
        })
    });
};
module.exports["TeamAvatarImage"] = $bdf91181004cdb95$export$ac3673635a5387be;

});

parcelRegister("5P3yi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

const $2cfa1b514c8db58a$var$styles = {
    wrapper: "_1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
function $2cfa1b514c8db58a$export$eb63dcc490f6bbcd(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($2cfa1b514c8db58a$var$styles.wrapper, props.compact ? $2cfa1b514c8db58a$var$styles.compactWrapperSpacing : $2cfa1b514c8db58a$var$styles.wrapperSpacing),
        children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_2032_552)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "#DCDFE4"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
                            fill: "#44546F"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
                            fill: "#44546F"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_2032_552",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "32",
                            height: "32",
                            rx: "4",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
}
module.exports["FallbackAvatar"] = $2cfa1b514c8db58a$export$eb63dcc490f6bbcd;

});

parcelRegister("f2BEc", function(module, exports) {
/**
 * If a src value is given, we'll use that directly.
 * Otherwise we'll generate a static URL from the teamId.
 * If neither are provided, return undefined so that the fallback will be used.
 */ function $e75bf44959780d0d$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return undefined;
}
module.exports["getTeamAvatarSrc"] = $e75bf44959780d0d$export$59ff7d19feb890b6;

});

parcelRegister("cO3Oi", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bh5s2 = parcelRequire("bh5s2");


var $3gadb = parcelRequire("3gadb");


var $fk7e8 = parcelRequire("fk7e8");

const $5c856781f75583e4$export$d7949f68d31e5edd = ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $fk7e8.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon",
            children: [
                ' ',
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
                    color: "var(--ds-icon-accent-blue, #357DE8)",
                    size: size,
                    label: tooltipContent,
                    spacing: spacing
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
module.exports["VerifiedTeamIcon"] = $5c856781f75583e4$export$d7949f68d31e5edd;

});

parcelRegister("fk7e8", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $81eb31bb2f17e3e1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: "ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip",
        defaultMessage: "Managed teams are verified because they can only be changed by an admin."
    }
});
module.exports["messages"] = $81eb31bb2f17e3e1$export$defe85febe8b728c;

});

parcelRegister("djtLL", function(module, exports) {
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $3hOY6 = parcelRequire("3hOY6");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $3aPpx = parcelRequire("3aPpx");


var $6O3OC = parcelRequire("6O3OC");


var $5zTZv = parcelRequire("5zTZv");

function $583428e46a5d063b$var$_defineProperty(e, r, t) {
    return (r = $583428e46a5d063b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $583428e46a5d063b$var$_toPropertyKey(t) {
    var i = $583428e46a5d063b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $583428e46a5d063b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $583428e46a5d063b$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bv12x7 _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf"
};
class $583428e46a5d063b$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state; //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zTZv.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).ValueContainer, {
                ...props,
                xcss: $583428e46a5d063b$var$valueContainerStyles.root,
                children: this.renderChildren()
            })
        });
    }
    constructor(props){
        super(props);
        $583428e46a5d063b$var$_defineProperty(this, "valueContainerInnerProps", void 0);
        $583428e46a5d063b$var$_defineProperty(this, "timeoutId", null);
        $583428e46a5d063b$var$_defineProperty(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        });
        $583428e46a5d063b$var$_defineProperty(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        $583428e46a5d063b$var$_defineProperty(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(this.props.children, (child)=>(0, $6O3OC.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
                children: children
            });
        });
        $583428e46a5d063b$var$_defineProperty(this, "renderChildren", ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props; // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $3aPpx.messages).addMore,
                children: (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                }
            });
            return this.addPlaceholder(addMoreMessage);
        });
        //@ts-ignore react-select unsupported props
        $583428e46a5d063b$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef()
        };
    }
}
module.exports["MultiValueContainer"] = $583428e46a5d063b$export$cf9cf2a30a59265c;

});

parcelRegister("5zTZv", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $e7cd9ff8a2bfdfe9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $e7cd9ff8a2bfdfe9$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $e7cd9ff8a2bfdfe9$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $e7cd9ff8a2bfdfe9$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $e7cd9ff8a2bfdfe9$export$2e2bcd8739ae039 = $e7cd9ff8a2bfdfe9$var$ValueContainerWrapper;
module.exports["default"] = $e7cd9ff8a2bfdfe9$export$2e2bcd8739ae039;

});

parcelRegister("d1LXW", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $gdv5Z = parcelRequire("gdv5Z");


var $3hOY6 = parcelRequire("3hOY6");


var $3gadb = parcelRequire("3gadb");


var $42omo = parcelRequire("42omo");


var $gIEXj = parcelRequire("gIEXj");


var $5MuqH = parcelRequire("5MuqH");


var $8bByc = parcelRequire("8bByc");


var $gQDzG = parcelRequire("gQDzG");


var $5SlZw = parcelRequire("5SlZw");


var $2OK2a = parcelRequire("2OK2a");


var $6O3OC = parcelRequire("6O3OC");


var $9xsgQ = parcelRequire("9xsgQ");

const $5421d1d84d0948a5$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gIEXj.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $5421d1d84d0948a5$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $6O3OC.isExternalUser)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5MuqH.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $6O3OC.isUser)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gIEXj.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $6O3OC.isEmail)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5SlZw.default), {
        email: data,
        emailValidity: (0, $9xsgQ.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $6O3OC.isTeam)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $8bByc.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $6O3OC.isGroup)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQDzG.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $6O3OC.isCustom)(data)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $2OK2a.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $5421d1d84d0948a5$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: props.data?.data?.tooltip,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ...tooltipProps,
                children: $5421d1d84d0948a5$var$dataOption(props)
            })
    });
    return $5421d1d84d0948a5$var$dataOption(props);
};
const $5421d1d84d0948a5$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
            fallback: $5421d1d84d0948a5$var$defaultOption(props),
            children: $5421d1d84d0948a5$var$dataOptionWithTooltip(props)
        })
    });
module.exports["Option"] = $5421d1d84d0948a5$export$36d18380658d5d20;

});

parcelRegister("gIEXj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5sA9S = parcelRequire("5sA9S");


var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $a1Cju = parcelRequire("a1Cju");


var $a3dA4 = parcelRequire("a3dA4");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $dh538 = parcelRequire("dh538");

const $ca21a62b4eb173f5$var$styles = (color)=>/*#__PURE__*/ (0, $9K4OG.css)({
        display: 'inline',
        verticalAlign: 'top',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        color
    });
class $ca21a62b4eb173f5$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a1Cju.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                    key: "name" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    ,
                    css: (0, $a1Cju.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)")
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a3dA4.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $6O3OC.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)";
                result.push(/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $9K4OG.jsx)("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                , {
                    css: (0, $dh538.fg)('platform_user_picker_firefox_tab_fix') ? $ca21a62b4eb173f5$var$styles(color) : (0, $a1Cju.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a3dA4.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $9K4OG.jsx)("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                css: (0, $a1Cju.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)")
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType }, status: status } = this.props;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: (0, $dh538.fg)('platform-component-visual-refresh') ? 'medium' : 'big',
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(appType) : undefined
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
module.exports["UserOption"] = $ca21a62b4eb173f5$export$8e59f78010871662;

});

parcelRegister("a1Cju", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5nBzc = parcelRequire("5nBzc");


var $6O3OC = parcelRequire("6O3OC");


var $dh538 = parcelRequire("dh538");

function $96ea07b7daa86f4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $96ea07b7daa86f4d$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("dWRcP")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $96ea07b7daa86f4d$var$wrapper = (isDisabled)=>{
    if ((0, $dh538.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $9K4OG.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
};
const $96ea07b7daa86f4d$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$var$optionWrapperFix = {
    name: "18gxn58",
    styles: "display:inline-block;overflow:hidden;min-width:0;max-width:100%;padding-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
    } : {};
    if ((0, $dh538.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $9K4OG.css)({
        margin: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $96ea07b7daa86f4d$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $96ea07b7daa86f4d$export$aa6223da92b253dd = (color)=>{
    if ((0, $dh538.fg)('platform_user_picker_firefox_tab_fix')) return /*#__PURE__*/ (0, $9K4OG.css)({
        display: 'inline-block',
        verticalAlign: 'bottom',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
    return /*#__PURE__*/ (0, $9K4OG.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
};
const $96ea07b7daa86f4d$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $6O3OC.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Suspense, {
                fallback: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($96ea07b7daa86f4d$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5nBzc.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $96ea07b7daa86f4d$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $dh538.fg)('platform_user_picker_firefox_tab_fix') ? $96ea07b7daa86f4d$var$optionWrapperFix : $96ea07b7daa86f4d$var$optionWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $96ea07b7daa86f4d$var$additionalInfo
    }, renderLozenge()));
};
module.exports["textWrapper"] = $96ea07b7daa86f4d$export$aa6223da92b253dd;
module.exports["AvatarItemOption"] = $96ea07b7daa86f4d$export$164a9d9b3b86dd0c;

});

parcelRegister("a3dA4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

class $9b44487d553c26e3$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, $l998X.jsx)("b", {
                children: part.value
            }, index);
            return part.value;
        });
    }
}
module.exports["HighlightText"] = $9b44487d553c26e3$export$bb02e7bc6e1a7119;

});

parcelRegister("5MuqH", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $9552d5b64b4732c1$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("8Fuuk")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $9552d5b64b4732c1$export$2e2bcd8739ae039 = $9552d5b64b4732c1$var$AsyncExternalUserOption;
module.exports["default"] = $9552d5b64b4732c1$export$2e2bcd8739ae039;

});

parcelRegister("8Fuuk", function(module, exports) {

let $64f9cd5d9cdc230d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64f9cd5d9cdc230d$var$load("6wr18"),
    $64f9cd5d9cdc230d$var$load("ffEVr"),
    $64f9cd5d9cdc230d$var$load("lTA9n"),
    $64f9cd5d9cdc230d$var$load("faXeM")
]).then(()=>parcelRequire('antvm'));

});

parcelRegister("8bByc", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $7087fdc05d26f437$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("efg1X")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $7087fdc05d26f437$export$2e2bcd8739ae039 = $7087fdc05d26f437$var$AsyncTeamOption;
module.exports["default"] = $7087fdc05d26f437$export$2e2bcd8739ae039;

});

parcelRegister("efg1X", function(module, exports) {

let $a5eee6b7b14d7452$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5eee6b7b14d7452$var$load("7eOUa").then(()=>parcelRequire('3Ylqf'));

});

parcelRegister("gQDzG", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b48b06ade47a1f85$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("jNY3N")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $b48b06ade47a1f85$export$2e2bcd8739ae039 = $b48b06ade47a1f85$var$AsyncGroupOption;
module.exports["default"] = $b48b06ade47a1f85$export$2e2bcd8739ae039;

});

parcelRegister("jNY3N", function(module, exports) {

let $e6b12e9eee2c8d12$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6b12e9eee2c8d12$var$load("9zjWJ").then(()=>parcelRequire('g2CU3'));

});

parcelRegister("5SlZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $b3aa7260631192b5$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("e2jHL")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $b3aa7260631192b5$export$2e2bcd8739ae039 = $b3aa7260631192b5$var$AsyncEmailOption;
module.exports["default"] = $b3aa7260631192b5$export$2e2bcd8739ae039;

});

parcelRegister("e2jHL", function(module, exports) {

let $a380898d18b524af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a380898d18b524af$var$load("cwwPf").then(()=>parcelRequire('gqFgq'));

});

parcelRegister("2OK2a", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $8b75c704d969ea14$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("hilZh")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $8b75c704d969ea14$export$2e2bcd8739ae039 = $8b75c704d969ea14$var$AsyncCustomOption;
module.exports["default"] = $8b75c704d969ea14$export$2e2bcd8739ae039;

});

parcelRegister("hilZh", function(module, exports) {

let $c9752c5bfc29a902$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9752c5bfc29a902$var$load("3a4K1").then(()=>parcelRequire('1oHUa'));

});

parcelRegister("9xsgQ", function(module, exports) {
const $bade09abd4a5fb04$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $bade09abd4a5fb04$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $bade09abd4a5fb04$export$371e338370561054 = (inputText)=>{
    if (inputText.match($bade09abd4a5fb04$var$validRegex)) return 'VALID';
    if (inputText.match($bade09abd4a5fb04$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};
module.exports["isValidEmail"] = $bade09abd4a5fb04$export$371e338370561054;

});

parcelRegister("biJXh", function(module, exports) {
/* SingleValue.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3hOY6 = parcelRequire("3hOY6");


var $daWcu = parcelRequire("daWcu");


var $6O3OC = parcelRequire("6O3OC");


var $5sA9S = parcelRequire("5sA9S");


var $dh538 = parcelRequire("dh538");


var $cO3Oi = parcelRequire("cO3Oi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");

const $c82e4369df94e7c9$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syazi7uo _1reo15vq _1bto1l2s _o5721q9c"
};
const $c82e4369df94e7c9$var$ElementAfter = (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $6O3OC.isTeam)(data) && data.verified || (0, $6O3OC.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
const $c82e4369df94e7c9$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            xcss: $c82e4369df94e7c9$var$styles.avatarItem,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $daWcu.SizeableAvatar), {
                    src: (0, $6O3OC.getAvatarUrl)(data),
                    appearance: appearance,
                    type: (0, $6O3OC.isTeam)(data) ? 'team' : 'person',
                    avatarAppearanceShape: (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(data.appType) : undefined
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $c82e4369df94e7c9$var$styles.avatarItem,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $c82e4369df94e7c9$var$styles.avatarItemTextWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $c82e4369df94e7c9$var$styles.avatarItemText,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                children: [
                                    label,
                                    /*#__PURE__*/ (0, $l998X.jsx)($c82e4369df94e7c9$var$ElementAfter, {
                                        ...props
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    }) : null;
};
module.exports["SingleValue"] = $c82e4369df94e7c9$export$1949dac661ba6e3a;

});

parcelRegister("gtKKr", function(module, exports) {
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");

function $d235b09878379c1c$var$_defineProperty(e, r, t) {
    return (r = $d235b09878379c1c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d235b09878379c1c$var$_toPropertyKey(t) {
    var i = $d235b09878379c1c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d235b09878379c1c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d235b09878379c1c$var$inputStyles = {
    root: "_5ce61rpy _1ir3kb7n _h5gq1rpy"
};
class $d235b09878379c1c$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
  * Overrides the default behaviour of react-select lib
  *
  * The getter is a workaround for original behaviour of the react-select lib.
  * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
  * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
  * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
  */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $d235b09878379c1c$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args); // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        $d235b09878379c1c$var$_defineProperty(this, "handleKeyPress", (e)=>{
            if (e.key === 'Enter') e.preventDefault();
             //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        });
    }
}
module.exports["Input"] = $d235b09878379c1c$export$f5b8910cec6cf069;

});

parcelRegister("95uM8", function(module, exports) {
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $daWcu = parcelRequire("daWcu");


var $5zTZv = parcelRequire("5zTZv");


var $5sA9S = parcelRequire("5sA9S");


var $dh538 = parcelRequire("dh538");

function $32eecf62664383f6$var$_defineProperty(e, r, t) {
    return (r = $32eecf62664383f6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $32eecf62664383f6$var$_toPropertyKey(t) {
    var i = $32eecf62664383f6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $32eecf62664383f6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $32eecf62664383f6$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf"
};
const $32eecf62664383f6$var$placeholderIconContainer = null;
const $32eecf62664383f6$var$wrapperStyle = null;
const $32eecf62664383f6$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $32eecf62664383f6$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zTZv.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $3hOY6.components).ValueContainer, {
                ...valueContainerProps,
                xcss: $32eecf62664383f6$var$valueContainerStyles.root,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_nd5l1kqh _19bv12x7 _vwz4idpf"
                        ]),
                        children: this.renderAvatar()
                    }),
                    children
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        $32eecf62664383f6$var$_defineProperty(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $l998X.jsx)((0, $daWcu.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $32eecf62664383f6$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined,
                avatarAppearanceShape: value && value.data && (0, $dh538.fg)('jira_ai_agent_avatar_user_picker_user_option') ? (0, $5sA9S.getAppearanceForAppType)(value.data.appType) : undefined
            });
            return null;
        });
        //@ts-ignore react-select unsupported props
        $32eecf62664383f6$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        $32eecf62664383f6$var$_defineProperty(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $gMc0m.default)([
                    "_16jlkb7n"
                ]),
                children: children
            }) : children;
        });
    }
}
module.exports["SingleValueContainer"] = $32eecf62664383f6$export$afa5f855316c6a48;

});

parcelRegister("aoWT3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtKKr = parcelRequire("gtKKr");

class $66df8f81b00f76a0$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtKKr.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
module.exports["PopupInput"] = $66df8f81b00f76a0$export$d8edbfd510a7db82;

});

parcelRegister("91jwt", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $8LA5n = parcelRequire("8LA5n");

function $6b1648b7e3dcb30f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b1648b7e3dcb30f$var$controlWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $6b1648b7e3dcb30f$var$labelStyle = {
    name: "kaippm",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);padding-bottom:var(--ds-space-050, 4px);padding-left:var(--ds-space-0, 0px);padding-right:var(--ds-space-0, 0px);padding-top:var(--ds-space-250, 20px)"
};
class $6b1648b7e3dcb30f$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6b1648b7e3dcb30f$var$controlWrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $6b1648b7e3dcb30f$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8LA5n.default), this.props));
    }
}
module.exports["PopupControl"] = $6b1648b7e3dcb30f$export$a0cb1b4352357fcc;

});

parcelRegister("8LA5n", function(module, exports) {
/* Control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $1bHXt = parcelRequire("1bHXt");

const $c39fb557d4d2ab16$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1v1w _bfhk1j9a _4cvx1v1w _irr31j9a",
    disabled: "_irr3by5v",
    subtle: "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6drsbi _bfhk1j9a _p12f1osq _14regrf3 _4cvxrsbi _irr3l4ek _1a98zg3v",
    compact: "_1tke1wug"
};
const $c39fb557d4d2ab16$var$Control = (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Control, {
        ...props,
        xcss: (0, $1bHXt.cx)($c39fb557d4d2ab16$var$controlStyles.root, isCompact && $c39fb557d4d2ab16$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $c39fb557d4d2ab16$var$controlStyles.subtle, props.isFocused && $c39fb557d4d2ab16$var$controlStyles.focused, props.isInvalid && $c39fb557d4d2ab16$var$controlStyles.invalid, props.isDisabled && $c39fb557d4d2ab16$var$controlStyles.disabled)
    });
};
var $c39fb557d4d2ab16$export$2e2bcd8739ae039 = $c39fb557d4d2ab16$var$Control;
module.exports["default"] = $c39fb557d4d2ab16$export$2e2bcd8739ae039;

});

parcelRegister("8lAE4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $9K4OG = parcelRequire("9K4OG");

const $d10d1e7e5aa26e90$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $d10d1e7e5aa26e90$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3hOY6.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $d10d1e7e5aa26e90$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
module.exports["Menu"] = $d10d1e7e5aa26e90$export$d9b273488cd8ce6f;

});

parcelRegister("dTofT", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $9xsgQ = parcelRequire("9xsgQ");


var $6O3OC = parcelRequire("6O3OC");

const $bfc99c5b192cefdf$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $bfc99c5b192cefdf$var$isValidNewOption = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(inputValue)=>inputValue && $bfc99c5b192cefdf$var$validOption.includes(isValidEmail(inputValue));
const $bfc99c5b192cefdf$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $RMvle.EmailType)
        }
    });
const $bfc99c5b192cefdf$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $bfc99c5b192cefdf$var$isOptionDisabled = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(option)=>{
        if ((0, $6O3OC.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $bfc99c5b192cefdf$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $bfc99c5b192cefdf$var$isValidNewOption(isValidEmail),
        getNewOptionData: $bfc99c5b192cefdf$var$getNewOptionData,
        formatCreateLabel: $bfc99c5b192cefdf$var$formatCreateLabel,
        isOptionDisabled: $bfc99c5b192cefdf$var$isOptionDisabled(isValidEmail)
    };
}
const $bfc99c5b192cefdf$export$36f97d8afa97203d = (0, $2XqLN.default)($bfc99c5b192cefdf$var$creatableProps);
module.exports["getCreatableProps"] = $bfc99c5b192cefdf$export$36f97d8afa97203d;

});

parcelRegister("bYlb2", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $RMvle = parcelRequire("RMvle");


var $9xsgQ = parcelRequire("9xsgQ");


var $6O3OC = parcelRequire("6O3OC");

const $981facf0cd076fa1$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $981facf0cd076fa1$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $981facf0cd076fa1$var$getNewOptionData = (isValidEmail = (0, $9xsgQ.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $981facf0cd076fa1$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $RMvle.EmailType),
                suggestion: true
            }
        };
    };
const $981facf0cd076fa1$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $981facf0cd076fa1$var$isOptionDisabled = (isValidEmail = (0, $9xsgQ.isValidEmail))=>(option)=>{
        if ((0, $6O3OC.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $981facf0cd076fa1$export$34b9dd2dd6a225e5 = (0, $2XqLN.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $981facf0cd076fa1$var$isValidNewOption,
        getNewOptionData: $981facf0cd076fa1$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $981facf0cd076fa1$var$formatCreateLabel,
        isOptionDisabled: $981facf0cd076fa1$var$isOptionDisabled(isValidEmail)
    }));
module.exports["getCreatableSuggestedEmailProps"] = $981facf0cd076fa1$export$34b9dd2dd6a225e5;

});

parcelRegister("39zOH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $czxno = parcelRequire("czxno");

const $f33aff4e4306ad48$var$EMPTY = {};
const $f33aff4e4306ad48$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($f33aff4e4306ad48$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($f33aff4e4306ad48$var$EMPTY);
        (0, $czxno.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f33aff4e4306ad48$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $8C5kA.default)();
    const { children: children } = props;
    const messages = $f33aff4e4306ad48$var$useI18n(intl.locale);
    const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $f33aff4e4306ad48$export$2e2bcd8739ae039 = $f33aff4e4306ad48$var$MessagesIntlProvider;
module.exports["default"] = $f33aff4e4306ad48$export$2e2bcd8739ae039;

});

parcelRegister("czxno", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $4ae2a92de5b04374$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("gGm07")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("iMgoY")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("a2F4a")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("exio3")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ht5Af")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("67KWz")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("2ITUY")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("bmV2y")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("bDfHw")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("l6Jrp")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("5Fgxz")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("giE6R")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aFqW6")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("6qm5B")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("4pTGn")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5KU7n")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6Q6st")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("hfezP")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("5lXJD")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("3NE2V")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("csvdv")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("7xuSk")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("43nDx")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("iV5JJ")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("cnB93")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("vqivz")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("6yfCT")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("1XdJ8")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jUGvI")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("cg7pQ")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $4ae2a92de5b04374$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("exio3")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $4ae2a92de5b04374$export$d0a3169680473b6c;

});

parcelRegister("gGm07", function(module, exports) {

let $c251a28321a837d3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c251a28321a837d3$var$load("9J4KV").then(()=>parcelRequire('g1PaI'));

});

parcelRegister("iMgoY", function(module, exports) {

let $dab96ec43e6f3eb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab96ec43e6f3eb4$var$load("8Y9JE").then(()=>parcelRequire('5cPWG'));

});

parcelRegister("a2F4a", function(module, exports) {

let $74f9f22fcdef1db1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74f9f22fcdef1db1$var$load("gWrRN").then(()=>parcelRequire('1YU5Y'));

});

parcelRegister("exio3", function(module, exports) {

let $a95269083b6eacd9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a95269083b6eacd9$var$load("irKcy").then(()=>parcelRequire('6aEWI'));

});

parcelRegister("ht5Af", function(module, exports) {

let $cb7979ea7781b247$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7979ea7781b247$var$load("1aghR").then(()=>parcelRequire('97wEb'));

});

parcelRegister("67KWz", function(module, exports) {

let $4757cf8a3567ee77$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4757cf8a3567ee77$var$load("3jFnE").then(()=>parcelRequire('F3yzi'));

});

parcelRegister("2ITUY", function(module, exports) {

let $1fbb10fa632caa58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1fbb10fa632caa58$var$load("11Khz").then(()=>parcelRequire('ewRdG'));

});

parcelRegister("bmV2y", function(module, exports) {

let $846dfec790105370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $846dfec790105370$var$load("ap0LY").then(()=>parcelRequire('IpO3b'));

});

parcelRegister("bDfHw", function(module, exports) {

let $877f84210d06b4a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $877f84210d06b4a6$var$load("34Ma8").then(()=>parcelRequire('cp7FA'));

});

parcelRegister("l6Jrp", function(module, exports) {

let $f5dd68287f6311f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f5dd68287f6311f0$var$load("lBwDa").then(()=>parcelRequire('kADLe'));

});

parcelRegister("5Fgxz", function(module, exports) {

let $41fd9caed43226bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $41fd9caed43226bf$var$load("32Pvr").then(()=>parcelRequire('bVNYH'));

});

parcelRegister("giE6R", function(module, exports) {

let $bddd70b947d92280$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bddd70b947d92280$var$load("b7bFd").then(()=>parcelRequire('3MhWk'));

});

parcelRegister("aFqW6", function(module, exports) {

let $7c42a0a6d53b297d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c42a0a6d53b297d$var$load("6h8Ae").then(()=>parcelRequire('461Di'));

});

parcelRegister("6qm5B", function(module, exports) {

let $4ad64e444a7941dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4ad64e444a7941dc$var$load("dW8Ws").then(()=>parcelRequire('2gGqw'));

});

parcelRegister("4pTGn", function(module, exports) {

let $3374b0a133257fc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3374b0a133257fc8$var$load("fJZdm").then(()=>parcelRequire('b0fTR'));

});

parcelRegister("5KU7n", function(module, exports) {

let $0114d9ed76b2fdf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0114d9ed76b2fdf6$var$load("kfTIE").then(()=>parcelRequire('e3XiS'));

});

parcelRegister("6Q6st", function(module, exports) {

let $4fac9be16220acb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4fac9be16220acb5$var$load("b8M9e").then(()=>parcelRequire('k1tgV'));

});

parcelRegister("hfezP", function(module, exports) {

let $c8df2505f9f73711$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8df2505f9f73711$var$load("jMchi").then(()=>parcelRequire('6tsQH'));

});

parcelRegister("5lXJD", function(module, exports) {

let $3e5d400f8ffeb9df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e5d400f8ffeb9df$var$load("2xsmF").then(()=>parcelRequire('8LiMQ'));

});

parcelRegister("3NE2V", function(module, exports) {

let $2c450305321bb93d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2c450305321bb93d$var$load("hHyCx").then(()=>parcelRequire('5jasV'));

});

parcelRegister("csvdv", function(module, exports) {

let $9120508f7983bf02$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9120508f7983bf02$var$load("gw4Pw").then(()=>parcelRequire('9yLSY'));

});

parcelRegister("7xuSk", function(module, exports) {

let $57d390a3a4646107$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57d390a3a4646107$var$load("8rhcn").then(()=>parcelRequire('abrYV'));

});

parcelRegister("43nDx", function(module, exports) {

let $2f39c70088433ef0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2f39c70088433ef0$var$load("fh5Vk").then(()=>parcelRequire('hBPGx'));

});

parcelRegister("iV5JJ", function(module, exports) {

let $dc62000857df1f57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc62000857df1f57$var$load("aP4eD").then(()=>parcelRequire('8ch0x'));

});

parcelRegister("cnB93", function(module, exports) {

let $903472462aaf91f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $903472462aaf91f1$var$load("aJWAE").then(()=>parcelRequire('7qoEH'));

});

parcelRegister("vqivz", function(module, exports) {

let $05e74b813d03b672$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $05e74b813d03b672$var$load("b96A2").then(()=>parcelRequire('6WyHk'));

});

parcelRegister("6yfCT", function(module, exports) {

let $4c520a22aa4bea6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c520a22aa4bea6b$var$load("g0ukK").then(()=>parcelRequire('1CggD'));

});

parcelRegister("1XdJ8", function(module, exports) {

let $16c5f30bb0fb803b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16c5f30bb0fb803b$var$load("8DuKk").then(()=>parcelRequire('d2VHY'));

});

parcelRegister("jUGvI", function(module, exports) {

let $e7f4390275d6775d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e7f4390275d6775d$var$load("5aSRq").then(()=>parcelRequire('f5vpO'));

});

parcelRegister("cg7pQ", function(module, exports) {

let $8eccbb4928f4b8f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8eccbb4928f4b8f1$var$load("eQT38").then(()=>parcelRequire('5Olm2'));

});

parcelRegister("aahZc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $60cba41939987423$var$ExusUserSourceContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $60cba41939987423$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)($60cba41939987423$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        },
        children: children
    });
const $60cba41939987423$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $42omo.useContext)($60cba41939987423$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const abortController = (0, $42omo.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $42omo.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};
module.exports["ExusUserSourceProvider"] = $60cba41939987423$export$bcd5c65b586ee3c3;
module.exports["useUserSource"] = $60cba41939987423$export$c6c0c1a2bac363f;

});

parcelRegister("7rus4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8JuIs = parcelRequire("8JuIs");


var $44RZm = parcelRequire("44RZm");


var $hnmbx = parcelRequire("hnmbx");

const $e8ee834aaf2971c0$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $hnmbx.useUFOConcurrentExperience)((0, $hnmbx.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnmbx.UfoErrorBoundary), {
        id: ufoId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $44RZm.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8JuIs.SmartUserPicker), {
                ...props
            })
        })
    });
};
var $e8ee834aaf2971c0$export$2e2bcd8739ae039 = $e8ee834aaf2971c0$var$SmartUserPickerWithIntlProvider;
module.exports["default"] = $e8ee834aaf2971c0$export$2e2bcd8739ae039;

});

parcelRegister("8JuIs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");


var $dQl1W = parcelRequire("dQl1W");


var $1DWH0 = parcelRequire("1DWH0");


var $2XqLN = parcelRequire("2XqLN");


var $gmMgo = parcelRequire("gmMgo");


var $28cxD = parcelRequire("28cxD");


var $kSKAi = parcelRequire("kSKAi");

var $6O3OC = parcelRequire("6O3OC");

var $9xsgQ = parcelRequire("9xsgQ");


var $dh538 = parcelRequire("dh538");


var $8CB5E = parcelRequire("8CB5E");


var $44RZm = parcelRequire("44RZm");


var $b4tkb = parcelRequire("b4tkb");


var $5kTPO = parcelRequire("5kTPO");

var $52K9w = parcelRequire("52K9w");


var $hnmbx = parcelRequire("hnmbx");

const $40c1c58d6de383a6$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $40c1c58d6de383a6$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $40c1c58d6de383a6$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $40c1c58d6de383a6$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $40c1c58d6de383a6$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $40c1c58d6de383a6$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $40c1c58d6de383a6$var$isEmailQuery = (query)=>{
    return (0, $9xsgQ.isValidEmail)(query.trim()) === 'VALID';
};
class $40c1c58d6de383a6$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    async componentDidMount() {
        try {
            const value = await (0, $52K9w.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId);
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $dQl1W.v4)();
            this.fireEvent((0, $8CB5E.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($40c1c58d6de383a6$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $28cxD.UFOExperienceState).FAILED.id,
                (0, $28cxD.UFOExperienceState).SUCCEEDED.id,
                (0, $28cxD.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            // Only allow email selection if we're in an email search that found no matches
            const isCurrentQueryEmail = $40c1c58d6de383a6$var$isEmailQuery(this.state.query);
            shouldAllowEmail = !isCurrentQueryEmail || !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $44RZm.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kSKAi.UserPicker), {
                ...restProps,
                allowEmail: shouldAllowEmail,
                onInputChange: this.onInputChange,
                onBlur: this.onBlur,
                onFocus: this.onFocus,
                defaultValue: this.state.defaultValue,
                isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
                options: this.filterUsers(),
                menuIsOpen: this.props.menuIsOpen
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        };
        // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false;
        this.optionsShownUfoExperienceInstance = void 0;
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $28cxD.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $8CB5E.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        };
        this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users;
        this.memoizedFilterOptions = (0, $2XqLN.default)(this.filterOptions);
        this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, orgId: orgId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, searchQueryFilter: searchQueryFilter, siteId: siteId, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $40c1c58d6de383a6$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                /*
        	For email-based searches, we have decided to filter out apps.
        	Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
        	when filter is empty, they have been added here to maintain consistency.
        		Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
         */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $8CB5E.requestUsersEvent));
                let recommendedUsers;
                if ((0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $5kTPO.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $8CB5E.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $5kTPO.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isUser)(option) || (0, $6O3OC.isExternalUser)(option) || (0, $6O3OC.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isUser)(option) || (0, $6O3OC.isExternalUser)(option)) {
                        if (option.userType === (0, $b4tkb.UserEntityType).DEFAULT || option.userType === (0, $b4tkb.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $6O3OC.isGroup)(option) || (0, $6O3OC.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) this.lastEmailSearchFoundMatches = recommendedUsers.length > 0;
                else this.lastEmailSearchFoundMatches = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $8CB5E.successfulRequestUsersEvent), {
                        users: $40c1c58d6de383a6$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $40c1c58d6de383a6$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $dh538.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $40c1c58d6de383a6$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch (error) {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($40c1c58d6de383a6$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $8CB5E.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0);
        this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        };
        this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $8CB5E.filterUsersEvent), {
                    filtered: $40c1c58d6de383a6$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $40c1c58d6de383a6$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$40c1c58d6de383a6$var$stringContains(user.name, query));
            this.fireEvent((0, $8CB5E.filterUsersEvent), {
                filtered: $40c1c58d6de383a6$var$getUsersForAnalytics(queryFilteredUsers),
                all: $40c1c58d6de383a6$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        };
        this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $8CB5E.preparedUsersLoadedEvent), {
                users: $40c1c58d6de383a6$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        };
        this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $hnmbx.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
}
// TODO: Smart User picker team will have to add a type annotation here
$40c1c58d6de383a6$export$9b9bd453d1d4e4ce.defaultProps = {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeTeamsUpdates: false,
    includeNonLicensedUsers: false,
    displayEmailInByline: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $40c1c58d6de383a6$var$DEFAULT_DEBOUNCE_TIME_MS,
    userResolvers: [],
    enableEmailSearch: false,
    allowEmailSelectionWhenEmailMatched: true
};
const $40c1c58d6de383a6$export$9eedb6e5d313efdb = (0, $1DWH0.default)()((0, $gmMgo.default)($40c1c58d6de383a6$export$9b9bd453d1d4e4ce));
module.exports["SmartUserPicker"] = $40c1c58d6de383a6$export$9eedb6e5d313efdb;

});

parcelRegister("8CB5E", function(module, exports) {

var $eWRwJ = parcelRequire("eWRwJ");


var $dQl1W = parcelRequire("dQl1W");

const $652153700385f927$var$packageName = "platform-pkg";
const $652153700385f927$var$packageVersion = "0.0.0-use.local";
const $652153700385f927$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $dQl1W.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $652153700385f927$export$53eef0dcd9611650 = (0, $eWRwJ.default)('fabric-elements');
const $652153700385f927$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $652153700385f927$var$packageName,
            packageVersion: $652153700385f927$var$packageVersion,
            ...attributes
        }
    });
const $652153700385f927$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $652153700385f927$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$652153700385f927$var$createEvent('operational', action, actionSubect, attributes)
    });
const $652153700385f927$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$fbba77127d7cb173 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('requested', 'users', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$bfc020018aa738d0 = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$738aca68b593db8e = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $652153700385f927$export$b9358131e14a4b0b = (props, state, attributes = {})=>$652153700385f927$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$652153700385f927$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
module.exports["createAndFireEventInElementsChannel"] = $652153700385f927$export$53eef0dcd9611650;
module.exports["preparedUsersLoadedEvent"] = $652153700385f927$export$185f4c3d9b7ef9bf;
module.exports["mountedWithPrefetchEvent"] = $652153700385f927$export$9cfb4251e50d7b91;
module.exports["filterUsersEvent"] = $652153700385f927$export$fbba77127d7cb173;
module.exports["requestUsersEvent"] = $652153700385f927$export$1762ed8845ff2d9b;
module.exports["successfulRequestUsersEvent"] = $652153700385f927$export$bfc020018aa738d0;
module.exports["failedRequestUsersEvent"] = $652153700385f927$export$738aca68b593db8e;
module.exports["failedUserResolversEvent"] = $652153700385f927$export$b9358131e14a4b0b;

});

parcelRegister("44RZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc4fb65506569ed6$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $lRpQD = parcelRequire("lRpQD");

const $bc4fb65506569ed6$var$EMPTY = {};
const $bc4fb65506569ed6$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($bc4fb65506569ed6$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($bc4fb65506569ed6$var$EMPTY);
        (0, $lRpQD.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $bc4fb65506569ed6$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $bc4fb65506569ed6$var$useI18n(intl.locale);
    const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: intl.locale,
        messages: mergedMessages,
        children: children
    });
};
var $bc4fb65506569ed6$export$2e2bcd8739ae039 = (0, $gmMgo.default)($bc4fb65506569ed6$var$MessagesIntlProvider);

});

parcelRegister("lRpQD", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $c819b58c07849348$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("bTsn1")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("6GCvk")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("aVRkS")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("9RUlw")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("9qWAB")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("hwi20")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ffmF0")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("7akr7")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("dG5bn")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("ixFnS")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("b4pNT")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("jY0MO")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("OdTh3")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("9xDn8")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("edhsD")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("6HDVJ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("a1EUA")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("6eF92")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("e84Bi")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("i6OJ2")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("b2Ob5")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("epyll")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("87x5R")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("gKeCQ")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("ViznQ")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("gRnrF")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("fTMVb")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("5RDfj")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("g6dca")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $c819b58c07849348$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("9RUlw")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $c819b58c07849348$export$d0a3169680473b6c;

});

parcelRegister("bTsn1", function(module, exports) {

let $8a8ad67e7884d3ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8a8ad67e7884d3ee$var$load("9J4KV").then(()=>parcelRequire('cn04M'));

});

parcelRegister("6GCvk", function(module, exports) {

let $4de488764c6cfa0a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4de488764c6cfa0a$var$load("8Y9JE").then(()=>parcelRequire('1zktf'));

});

parcelRegister("aVRkS", function(module, exports) {

let $7f58999a79e6349b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7f58999a79e6349b$var$load("gWrRN").then(()=>parcelRequire('8wiEy'));

});

parcelRegister("9RUlw", function(module, exports) {

let $72f4c575475b8ff2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72f4c575475b8ff2$var$load("irKcy").then(()=>parcelRequire('gOk31'));

});

parcelRegister("9qWAB", function(module, exports) {

let $6de3fd6373f80610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6de3fd6373f80610$var$load("1aghR").then(()=>parcelRequire('fy2oQ'));

});

parcelRegister("hwi20", function(module, exports) {

let $cc13697e056477b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc13697e056477b4$var$load("11Khz").then(()=>parcelRequire('5oLnX'));

});

parcelRegister("ffmF0", function(module, exports) {

let $b199d5a16bac3489$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b199d5a16bac3489$var$load("ap0LY").then(()=>parcelRequire('lsKPD'));

});

parcelRegister("7akr7", function(module, exports) {

let $537951d668c4233a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $537951d668c4233a$var$load("34Ma8").then(()=>parcelRequire('qBAp9'));

});

parcelRegister("dG5bn", function(module, exports) {

let $9f5337b8d9e430bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9f5337b8d9e430bb$var$load("lBwDa").then(()=>parcelRequire('iwM0U'));

});

parcelRegister("ixFnS", function(module, exports) {

let $d7fb6910ad50dffa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7fb6910ad50dffa$var$load("32Pvr").then(()=>parcelRequire('emQB1'));

});

parcelRegister("b4pNT", function(module, exports) {

let $80f415843c58387f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80f415843c58387f$var$load("b7bFd").then(()=>parcelRequire('gsrSx'));

});

parcelRegister("jY0MO", function(module, exports) {

let $e8943b15c1095f0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e8943b15c1095f0b$var$load("6h8Ae").then(()=>parcelRequire('fy2dB'));

});

parcelRegister("OdTh3", function(module, exports) {

let $096f71fe6a133344$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $096f71fe6a133344$var$load("dW8Ws").then(()=>parcelRequire('gaGnN'));

});

parcelRegister("9xDn8", function(module, exports) {

let $6f25bca05c93306d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6f25bca05c93306d$var$load("fJZdm").then(()=>parcelRequire('h47Xp'));

});

parcelRegister("edhsD", function(module, exports) {

let $a58fd2ef4859e4c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a58fd2ef4859e4c2$var$load("kfTIE").then(()=>parcelRequire('kPwYW'));

});

parcelRegister("6HDVJ", function(module, exports) {

let $4e15bb82c38bbb9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e15bb82c38bbb9b$var$load("b8M9e").then(()=>parcelRequire('2ghCe'));

});

parcelRegister("a1EUA", function(module, exports) {

let $74c9bb98590c44dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $74c9bb98590c44dc$var$load("jMchi").then(()=>parcelRequire('5Dvg5'));

});

parcelRegister("6eF92", function(module, exports) {

let $48a3f75c40936ce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48a3f75c40936ce0$var$load("2xsmF").then(()=>parcelRequire('7JChl'));

});

parcelRegister("e84Bi", function(module, exports) {

let $a49561987d0955ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a49561987d0955ea$var$load("hHyCx").then(()=>parcelRequire('iYJQV'));

});

parcelRegister("i6OJ2", function(module, exports) {

let $d2f0228f4b9611b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2f0228f4b9611b3$var$load("gw4Pw").then(()=>parcelRequire('8RsTW'));

});

parcelRegister("b2Ob5", function(module, exports) {

let $80a6cde59d00f370$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $80a6cde59d00f370$var$load("8rhcn").then(()=>parcelRequire('cpBhe'));

});

parcelRegister("epyll", function(module, exports) {

let $a7de0a56fe167aca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a7de0a56fe167aca$var$load("fh5Vk").then(()=>parcelRequire('1qgZZ'));

});

parcelRegister("87x5R", function(module, exports) {

let $5e98a5df9723a0ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e98a5df9723a0ca$var$load("aP4eD").then(()=>parcelRequire('bkrR7'));

});

parcelRegister("gKeCQ", function(module, exports) {

let $c30c498bdaf770fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c30c498bdaf770fc$var$load("aJWAE").then(()=>parcelRequire('7VxDp'));

});

parcelRegister("ViznQ", function(module, exports) {

let $0ac3ba8ab2ce85a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ac3ba8ab2ce85a5$var$load("b96A2").then(()=>parcelRequire('aq3KW'));

});

parcelRegister("gRnrF", function(module, exports) {

let $c463c852d03859d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c463c852d03859d2$var$load("g0ukK").then(()=>parcelRequire('djjDV'));

});

parcelRegister("fTMVb", function(module, exports) {

let $b931f0d132593dec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b931f0d132593dec$var$load("8DuKk").then(()=>parcelRequire('7D0E8'));

});

parcelRegister("5RDfj", function(module, exports) {

let $4450586e03add784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4450586e03add784$var$load("5aSRq").then(()=>parcelRequire('cU76k'));

});

parcelRegister("g6dca", function(module, exports) {

let $bb8771308e18862d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bb8771308e18862d$var$load("eQT38").then(()=>parcelRequire('5c5SM'));

});

parcelRegister("b4tkb", function(module, exports) {
var $bc15afc2f3227082$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $bc15afc2f3227082$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});
module.exports["EntityType"] = $bc15afc2f3227082$export$8eda7e02f8f033b2;
module.exports["UserEntityType"] = $bc15afc2f3227082$export$ef0ef29634e52a6b;

});

parcelRegister("5kTPO", function(module, exports) {

var $74ZOc = parcelRequire("74ZOc");


var $g2dtt = parcelRequire("g2dtt");

const $fb7b59d200301a0e$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $g2dtt.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $74ZOc.transformUsers)(response, intl));
};
var $fb7b59d200301a0e$export$2e2bcd8739ae039 = $fb7b59d200301a0e$var$getUserRecommendations;
module.exports["default"] = $fb7b59d200301a0e$export$2e2bcd8739ae039;

});

parcelRegister("74ZOc", function(module, exports) {

var $RMvle = parcelRequire("RMvle");


var $bicYK = parcelRequire("bicYK");


var $b4tkb = parcelRequire("b4tkb");

const $465f7c420800703a$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $bicYK.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $b4tkb.EntityType).GROUP ? (0, $bicYK.messages).guestGroupLozengeTooltip : (0, $bicYK.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $bicYK.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    return undefined;
};
const $465f7c420800703a$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $b4tkb.EntityType).USER) {
        const user = item;
        const lozenge = $465f7c420800703a$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $RMvle.ExternalUserType) : (0, $RMvle.UserType),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined
        };
    }
    if (type === (0, $b4tkb.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $RMvle.TeamType),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified
        };
    }
    if (type === (0, $b4tkb.EntityType).GROUP) {
        const group = item;
        const lozenge = $465f7c420800703a$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $RMvle.GroupType),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $465f7c420800703a$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$465f7c420800703a$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
module.exports["transformUsers"] = $465f7c420800703a$export$fb8c90bfc4beaa59;

});

parcelRegister("bicYK", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $5083ba0e2c523183$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
module.exports["messages"] = $5083ba0e2c523183$export$defe85febe8b728c;

});

parcelRegister("g2dtt", function(module, exports) {
const $bdd893fcacf86342$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};
module.exports["config"] = $bdd893fcacf86342$export$e506a1d27d1eaa20;

});

parcelRegister("52K9w", function(module, exports) {

var $RMvle = parcelRequire("RMvle");


var $g2dtt = parcelRequire("g2dtt");


var $5tNjN = parcelRequire("5tNjN");


var $byRSb = parcelRequire("byRSb");


var $1h51z = parcelRequire("1h51z");

const $19437af1da52fb39$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $g2dtt.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $19437af1da52fb39$var$transformJiraUsers : $19437af1da52fb39$var$transformConfluenceUsers);
};
const $19437af1da52fb39$var$transformJiraUsers = (userResponse)=>userResponse.values.map($19437af1da52fb39$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $19437af1da52fb39$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $RMvle.UserType),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $19437af1da52fb39$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($19437af1da52fb39$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $19437af1da52fb39$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $RMvle.UserType),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $19437af1da52fb39$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $1h51z.UNKNOWN)
        };
    });
};
const $19437af1da52fb39$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $19437af1da52fb39$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $byRSb.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $19437af1da52fb39$var$hydrateAccountIds = async (baseUrl, productKey, values)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $19437af1da52fb39$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $5tNjN.default)(baseUrl, accountIds);
};
async function $19437af1da52fb39$var$hydrateDefaultValues(baseUrl, value, productKey, siteId) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$19437af1da52fb39$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $19437af1da52fb39$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$19437af1da52fb39$var$isOptionData(val) && val.type === 'user')),
        $19437af1da52fb39$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$19437af1da52fb39$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$19437af1da52fb39$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $19437af1da52fb39$var$sortResults(hydratedOptions, values);
}
var $19437af1da52fb39$export$2e2bcd8739ae039 = $19437af1da52fb39$var$hydrateDefaultValues;
module.exports["default"] = $19437af1da52fb39$export$2e2bcd8739ae039;

});

parcelRegister("5tNjN", function(module, exports) {

var $1h51z = parcelRequire("1h51z");


var $5y06K = parcelRequire("5y06K");


var $g2dtt = parcelRequire("g2dtt");

/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $26288bf672f514b3$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $26288bf672f514b3$var$makeRequest = async (url, accountIds)=>{
    const query = $26288bf672f514b3$var$buildUsersQuery(accountIds);
    return await (0, $5y06K.graphqlQuery)(url, query);
};
const $26288bf672f514b3$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $26288bf672f514b3$var$getHydratedUsers = (baseUrl, userIds)=>{
    const url = (0, $g2dtt.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $26288bf672f514b3$var$makeRequest(url, userIds).then((data)=>{
            resolve($26288bf672f514b3$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $1h51z.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $26288bf672f514b3$export$2e2bcd8739ae039 = $26288bf672f514b3$var$getHydratedUsers;
module.exports["default"] = $26288bf672f514b3$export$2e2bcd8739ae039;

});

parcelRegister("1h51z", function(module, exports) {
const $690e1ddcc04ff137$export$78244dbb77cfa6b6 = 'Unknown';
const $690e1ddcc04ff137$export$d1f5101c0939e3fe = {
    id: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    name: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    type: 'user'
};
const $690e1ddcc04ff137$export$8144dcfc9025ca57 = {
    id: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    name: $690e1ddcc04ff137$export$78244dbb77cfa6b6,
    type: 'team'
};
module.exports["UNKNOWN"] = $690e1ddcc04ff137$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_USER"] = $690e1ddcc04ff137$export$d1f5101c0939e3fe;
module.exports["UNKNOWN_TEAM"] = $690e1ddcc04ff137$export$8144dcfc9025ca57;

});

parcelRegister("5y06K", function(module, exports) {
const $7113235240a12c5e$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $7113235240a12c5e$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $7113235240a12c5e$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $7113235240a12c5e$export$74eb8d79ae3e02b5;

});

parcelRegister("byRSb", function(module, exports) {

var $g2dtt = parcelRequire("g2dtt");


var $1h51z = parcelRequire("1h51z");

const $5847a110ae2c5370$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl
    };
};
const $5847a110ae2c5370$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $g2dtt.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $5847a110ae2c5370$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $1h51z.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $5847a110ae2c5370$export$2e2bcd8739ae039 = $5847a110ae2c5370$var$hydrateTeamFromLegion;
module.exports["default"] = $5847a110ae2c5370$export$2e2bcd8739ae039;

});

parcelRegister("hnmbx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

var $28cxD = parcelRequire("28cxD");

const $06ae62c086839e8d$var$COMPONENT_NAME = 'smart-user-picker';
const $06ae62c086839e8d$export$df77da4c0210f1c1 = new (0, $9801n.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $06ae62c086839e8d$var$COMPONENT_NAME
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
});
const $06ae62c086839e8d$export$a0e7cca3ab9586eb = new (0, $9801n.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $06ae62c086839e8d$var$COMPONENT_NAME
    },
    type: (0, $iqaft.ExperienceTypes).Operation,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
});
const $06ae62c086839e8d$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $42omo.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $42omo.useEffect)(()=>{
        if (experienceForId.state !== (0, $28cxD.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $28cxD.UFOExperienceState)['STARTED'],
                (0, $28cxD.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $06ae62c086839e8d$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch() {
        $06ae62c086839e8d$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["smartUserPickerRenderedUfoExperience"] = $06ae62c086839e8d$export$df77da4c0210f1c1;
module.exports["smartUserPickerOptionsShownUfoExperience"] = $06ae62c086839e8d$export$a0e7cca3ab9586eb;
module.exports["useUFOConcurrentExperience"] = $06ae62c086839e8d$export$e5e0512991825310;
module.exports["UfoErrorBoundary"] = $06ae62c086839e8d$export$5ef1c2550074a375;

});

parcelRegister("83Z6R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

function $b847dc1d37d68706$export$dcf9d4e77de27956(...[query, params]) {
    const resolversRef = (0, $42omo.useRef)();
    /**
	 * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
	 */ const [doQuery, { data: data, error: error }] = (0, $jxs8y.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        params
    ]);
    (0, $42omo.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $42omo.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $cgtv4.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("11dKl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $f9006b515271a00f$var$i18n = (0, $cgtv4.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/**
 * @generated SignedSource<<40e2b37836ef7625e634b9236789b118>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("6RGMW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");

const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $eSUdr.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;
module.exports["UserAndGroupSearchQuery"] = $88fbd0e78227b736$export$9eed0d08b5194ae7;

});

parcelRegister("d4Pk4", function(module, exports) {

var $94jtO = parcelRequire("94jtO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/platform/site/manifest.ts
var $985375b928439e07$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $94jtO.PlatformSiteAriResourceOwner),
    resourceType: (0, $94jtO.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $985375b928439e07$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $985375b928439e07$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $985375b928439e07$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $985375b928439e07$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $985375b928439e07$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $985375b928439e07$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["PlatformSiteAri"] = $985375b928439e07$export$62388e9e87e2e1c9;

});

parcelRegister("94jtO", function(module, exports) {
// src/platform/site/types.ts
var $69a39916eb9c41be$export$2866935ccba4694c = "platform", $69a39916eb9c41be$export$c9ae8b227ea4b550 = "site";
module.exports["PlatformSiteAriResourceOwner"] = $69a39916eb9c41be$export$2866935ccba4694c;
module.exports["PlatformSiteAriResourceType"] = $69a39916eb9c41be$export$c9ae8b227ea4b550;

});

parcelRegister("eZLpN", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $2589de0f689b9a54$export$fc06099c27831dd7({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy = 'cache-first', variables: variables, pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $2589de0f689b9a54$export$846a05bdbd4f6c21({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $2589de0f689b9a54$export$846a05bdbd4f6c21(params) {
    const { queryState: queryState, execute: baseExecute, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        ...params,
        isLazyQuery: true
    });
    const execute = (0, $26Yfd.useStableCallback)(async (options)=>{
        await baseExecute(options?.variables);
    });
    return [
        execute,
        {
            ...queryState ?? (0, $7ji4X.INITIAL_IDLE_STATE),
            stopPolling: stopPolling
        }
    ];
}
module.exports["useExperimentalLazyQuery"] = $2589de0f689b9a54$export$fc06099c27831dd7;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: headers,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("fqCbQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $42omo.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $42omo.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("bjeS8", function(module, exports) {

var $aAxiE = parcelRequire("aAxiE");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $aAxiE.GraphQLError)(message, null, null, null, null, originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("7ji4X", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $9zUhf.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $9zUhf.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("iXGsw", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $42omo.useRef)(null);
    const stopPolling = (0, $42omo.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $42omo.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $42omo.useMemo)(()=>{
        if (!pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $42omo.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("hCOLa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7DBey = parcelRequire("7DBey");

function $e28c424ef32ed9ff$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $7DBey.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $e28c424ef32ed9ff$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }


const $5c38ed4eae58ec94$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $42omo.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$5c38ed4eae58ec94$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $e28c424ef32ed9ff$export$388f24d19a29b0a2)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $5c38ed4eae58ec94$var$DIFFERENT = false;
const $5c38ed4eae58ec94$var$EQUAL = true;
const $5c38ed4eae58ec94$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $5c38ed4eae58ec94$var$EQUAL;
    if (!prevObject || !nextObject) return $5c38ed4eae58ec94$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $5c38ed4eae58ec94$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $5c38ed4eae58ec94$var$DIFFERENT;
        }
        return $5c38ed4eae58ec94$var$EQUAL;
    }
};
module.exports["useService"] = $5c38ed4eae58ec94$export$6de4685a6c88b4e9;

});

parcelRegister("1BTvF", function(module, exports) {
/**
 * This file defines the invite() service.
 */ 
var $6Co6F = parcelRequire("6Co6F");


var $dh538 = parcelRequire("dh538");


var $k4HRJ = parcelRequire("k4HRJ");


var $7DBey = parcelRequire("7DBey");

/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 


const $26f4407bbf6764a3$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $26f4407bbf6764a3$export$ddb1688281a3443e = (0, $7DBey.unimplementedAbstractService)('getCurrentCloudId');
const $26f4407bbf6764a3$export$5ebc6cb2748e1881 = (0, $7DBey.unimplementedAbstractService)('getCurrentUserId');
const $26f4407bbf6764a3$export$d01408ed6f850a64 = (0, $7DBey.unimplementedAbstractService)('getCurrentProduct');
const $26f4407bbf6764a3$export$a48841c0475a8073 = (0, $7DBey.unimplementedAbstractService)('createAnalyticsEvent');
const $26f4407bbf6764a3$export$a27c21aa3ed8f0f1 = (0, $7DBey.unimplementedAbstractService)('fireErrorAnalytics');
class $26f4407bbf6764a3$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $26f4407bbf6764a3$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: err instanceof $26f4407bbf6764a3$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $26f4407bbf6764a3$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $26f4407bbf6764a3$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $26f4407bbf6764a3$export$1f2663aaa83f036d = 'Failed to fetch';
const $26f4407bbf6764a3$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $26f4407bbf6764a3$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $26f4407bbf6764a3$export$6827a0909c1bf12f = [
    $26f4407bbf6764a3$export$1f2663aaa83f036d,
    $26f4407bbf6764a3$export$65e55894e6e38a89,
    $26f4407bbf6764a3$export$f25400ad927aa79c
];
const $26f4407bbf6764a3$export$e1b6bb1617649e83 = (errorMessage)=>$26f4407bbf6764a3$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $26f4407bbf6764a3$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $26f4407bbf6764a3$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $26f4407bbf6764a3$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $26f4407bbf6764a3$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $26f4407bbf6764a3$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $26f4407bbf6764a3$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $26f4407bbf6764a3$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $26f4407bbf6764a3$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $26f4407bbf6764a3$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $26f4407bbf6764a3$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $26f4407bbf6764a3$export$80a3c1a1eb6f063 || errorMessage === $26f4407bbf6764a3$export$e089e1d2018847da;
const $26f4407bbf6764a3$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $26f4407bbf6764a3$export$678d91a98f79a24d(message, status) || status === 400 && ($26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$c53f16dd5442ef61) || $26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$e27975535396141b)) || status === 412 && $26f4407bbf6764a3$export$395f41a02d6a8be0(key, message);
};
const $26f4407bbf6764a3$export$9de493bcd9b1d977 = 'bad-request';
const $26f4407bbf6764a3$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $26f4407bbf6764a3$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $26f4407bbf6764a3$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $26f4407bbf6764a3$export$e5254cb9f7678ab9) return false;
    return true;
};





const $c1aca408fa9ca14a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $7DBey.unimplementedAbstractService)('fetchJSON');


const $1c3a325003f470c5$var$getInstanceUrl = ()=>{
    return window.location.origin;
};
const $1c3a325003f470c5$var$landingPathMap = {
    confluence: '/wiki',
    compass: '/compass',
    avp: '/analytics',
    mercury: '/focus'
};
const $1c3a325003f470c5$var$getLandingPathByProduct = (product)=>$1c3a325003f470c5$var$landingPathMap[product] ?? '';
const $1c3a325003f470c5$export$ab36e4577f8d8354 = (continueUrl, resources, origin, source)=>{
    const instanceUrl = $1c3a325003f470c5$var$getInstanceUrl();
    let productContinueUrl = continueUrl;
    const targetProducts = resources.map((resource)=>resource.resourceOwner);
    if (continueUrl && origin.containsOrigin(continueUrl)) throw new Error('continueUrl contains Origin Tracing query parameter');
    if (!productContinueUrl) productContinueUrl = resources.length === 1 ? `${instanceUrl}${$1c3a325003f470c5$var$getLandingPathByProduct(targetProducts[0])}` : instanceUrl;
    // Also try to find urls that forward newly invited users to jira setting pages and redirect them to a product landing page instead.
    // We should do this so newly invited users are not seeing a permission denied screen when accessing restricted pages.
    if (productContinueUrl.match(/.*\/jira.*\/settings/gim)) productContinueUrl = targetProducts.length === 1 ? `${instanceUrl}${$1c3a325003f470c5$var$getLandingPathByProduct(targetProducts[0])}` : instanceUrl;
    const productContinueUrlWithOrigin = origin.addToUrl(productContinueUrl);
    return `${productContinueUrlWithOrigin}&source=${source}`;
};


const $135e52b0113e9793$export$ff8f647a32d0f23c = [
    'INVITED',
    'USER_EXISTS',
    'INVITED_PENDING_APPROVAL',
    'PENDING_INVITE_EXISTS',
    'NOT_INVITED',
    'ERROR'
];
// Dependencies - generally common to all invites:
const $135e52b0113e9793$var$dependencies = {
    fetchJSON: $c1aca408fa9ca14a$export$81bec6e38e8b706b,
    createAnalyticsEvent: $26f4407bbf6764a3$export$a48841c0475a8073,
    getStargateURL: $26f4407bbf6764a3$export$c7904a8284e43beb,
    getCurrentUserId: $26f4407bbf6764a3$export$5ebc6cb2748e1881,
    getCurrentCloudId: $26f4407bbf6764a3$export$ddb1688281a3443e,
    getCurrentProduct: $26f4407bbf6764a3$export$d01408ed6f850a64
};
const $135e52b0113e9793$export$dd37b42f82fee9c3 = Object.assign($135e52b0113e9793$var$inviteImpl, {
    dependencies: $135e52b0113e9793$var$dependencies
});
async function $135e52b0113e9793$var$inviteImpl(input, context) {
    const deps = context.dependencies();
    let results;
    const usersWithOrigin = input.users.map((user)=>{
        const origin = new (0, $6Co6F.default)({
            product: deps.getCurrentProduct()
        });
        const continueUrl = (0, $1c3a325003f470c5$export$ab36e4577f8d8354)(input.continueUrl, input.resources, origin, input.touchpoint.replace(/ /g, '_'));
        return {
            user: {
                ...user,
                continueUrl: continueUrl
            },
            origin: origin
        };
    });
    const users = usersWithOrigin.map(({ user: user })=>user);
    try {
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/v3/invitations/invite'),
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...input.recaptchaOptions?.recaptchaToken ? {
                    'G-Recaptcha-Token': input.recaptchaOptions.recaptchaToken
                } : {},
                ...input.recaptchaOptions?.recaptchaAction ? {
                    'Recaptcha-Action': input.recaptchaOptions.recaptchaAction
                } : {}
            },
            body: JSON.stringify({
                users: (0, $dh538.fg)('expansion-services-in-core-invites') ? users : input.users,
                resources: input.resources.map((resource)=>resource.toString()),
                ...(0, $dh538.fg)('expansion-services-in-core-invites') ? {} : {
                    continueUrl: input.continueUrl
                },
                ...(0, $dh538.fg)('expansion-services-in-core-invites') ? {
                    metadata: {
                        touchpoint: input.touchpoint,
                        sourceProduct: deps.getCurrentProduct()
                    }
                } : {}
            })
        });
        results = $135e52b0113e9793$export$aa38717ddd608a8e(response, usersWithOrigin, input.touchpoint, input.integration);
    } catch (error) {
        const errorReason = (0, $26f4407bbf6764a3$export$33e83b6fee5d732d)(error);
        const { code: code, message: message, status: status } = errorReason;
        const attributes = {
            code: code,
            message: message,
            status: status
        };
        if (!(0, $26f4407bbf6764a3$export$678d91a98f79a24d)(message, status)) $135e52b0113e9793$var$inviteFailedSLO(input.touchpoint, attributes, context);
        results = [
            {
                inviteStatus: null,
                error: (0, $7DBey.toError)(error),
                errorReason: errorReason
            }
        ];
    }
    results.forEach((result)=>$135e52b0113e9793$var$fireInviteAnalytics(result, context, input.getAdditionalAttributes));
    return results;
}
const $135e52b0113e9793$export$aa38717ddd608a8e = (response, usersWithOrigin, touchpoint, integration)=>response.flatMap((user)=>{
        const origin = usersWithOrigin.find((userWithOrigin)=>userWithOrigin.user.id === user.id || userWithOrigin.user.email === user.email)?.origin;
        return Object.keys(user.results).map((resource)=>{
            const inviteStatus = user.results[resource];
            const resourceAri = (0, $k4HRJ.AnyAri).parse(resource);
            const common = {
                id: user.id,
                email: user.email,
                origin: origin,
                integration: integration,
                touchpoint: touchpoint,
                resource: resourceAri
            };
            if (inviteStatus === 'ERROR') return {
                ...common,
                inviteStatus: inviteStatus,
                // errorReasons should always be present for error responses
                error: user.errorReasons?.[resource] ?? {
                    code: 'UNKNOWN_ERROR',
                    message: 'Unknown error'
                }
            };
            return {
                ...common,
                inviteStatus: inviteStatus,
                error: null
            };
        });
    });
const $135e52b0113e9793$var$isInvited = (res)=>{
    return res.inviteStatus === 'INVITED' || res.inviteStatus === 'USER_EXISTS';
};
const $135e52b0113e9793$var$isRequested = (res)=>{
    return res.inviteStatus === 'INVITED_PENDING_APPROVAL' || res.inviteStatus === 'PENDING_INVITE_EXISTS';
};
const $135e52b0113e9793$var$isError = (res)=>{
    return res.inviteStatus === 'NOT_INVITED' || res.inviteStatus === 'ERROR';
};
const $135e52b0113e9793$export$e0d12419555d8733 = (result)=>result.reduce((accumulator, res)=>{
        switch(res.inviteStatus){
            case 'INVITED':
            case 'USER_EXISTS':
                $135e52b0113e9793$var$isInvited(res) && accumulator.invited.push(res);
                break;
            case 'INVITED_PENDING_APPROVAL':
            case 'PENDING_INVITE_EXISTS':
                $135e52b0113e9793$var$isRequested(res) && accumulator.requested.push(res);
                break;
            case 'NOT_INVITED':
            case 'ERROR':
                $135e52b0113e9793$var$isError(res) && accumulator.error.push(res);
                break;
            default:
                if ((0, $dh538.fg)('expansion-services-in-core-invites')) accumulator.failure = res;
                else throw new Error('Unexpected return type from invite user response');
        }
        return accumulator;
    }, {
        invited: [],
        requested: [],
        error: [],
        failure: undefined
    });
// Analytics functions for these common events might later become
// exported for standalone use
function $135e52b0113e9793$var$fireInviteAnalytics(result, context, getAdditionalAttributes) {
    if (!result.error) {
        const originAttributes = result.origin?.toAnalyticsAttributes({
            hasGeneratedId: true
        }) ?? {};
        const attributes = {
            ...getAdditionalAttributes?.(result) ?? {},
            ...originAttributes,
            // The id is always present for success responses
            userAaid: result.id,
            actorAaid: context.dependencies().getCurrentUserId(),
            inviteStatus: result.inviteStatus,
            targetProduct: result.resource.resourceOwner,
            targetTenantId: result.resource.resourceId,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            integration: result.integration,
            touchpoint: result.touchpoint
        };
        $135e52b0113e9793$var$inviteSucceededSLO(result.touchpoint, context);
        if (result.inviteStatus === 'INVITED') $135e52b0113e9793$var$fireUserInvited(attributes, context);
        if (result.inviteStatus === 'INVITED_PENDING_APPROVAL') $135e52b0113e9793$var$fireProductAccessRequested(attributes, context);
    } else if (result.inviteStatus === 'ERROR') {
        const failure = result.error;
        // There should not be a failure SLO event if the error is a user network failure error
        if (!(0, $26f4407bbf6764a3$export$1c4c1f7e2d529330)(failure)) {
            if ((0, $26f4407bbf6764a3$export$90cda429f609d666)(failure)) $135e52b0113e9793$var$inviteFailedSLO(result.touchpoint, failure, context);
            else $135e52b0113e9793$var$inviteSucceededSLO(result.touchpoint, context);
        }
    }
}
/**
 * Valid values are defined in IIS:
 * https://bitbucket.org/atlassian/id-invitations-service/src/master/src/main/java/com/atlassian/identity/invitations/model/EnablementTouchpoint.java
 */ const $135e52b0113e9793$var$EnablementTouchpoint = {
    CORE_INVITES: 'Core Invites',
    SHARE_DIALOG: 'Share Dialog',
    TEAMS_MENU: 'Teams Menu',
    MENTIONS: 'Mentions',
    JIRA_ASSIGNS: 'Jira Assigns',
    PROMPT_INVITE_ON_LINK_INSERT: 'Prompt invite on link insert',
    CROSSJOIN_NUDGE: 'Crossjoin Nudge'
};
function $135e52b0113e9793$var$fireProductAccessRequested(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: attributes.targetProduct,
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $135e52b0113e9793$var$fireUserInvited(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'user',
            action: 'invited',
            actionSubjectId: attributes.userAaid,
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
const $135e52b0113e9793$var$inviteFailedSLO = (touchpoint, attributes, context)=>{
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'sloInviteRequest',
            action: 'failed',
            source: touchpoint,
            attributes: {
                ...attributes,
                touchpoint: touchpoint
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
};
const $135e52b0113e9793$var$inviteSucceededSLO = (touchpoint, context)=>{
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'sloInviteRequest',
            action: 'succeeded',
            source: touchpoint,
            attributes: {
                touchpoint: touchpoint
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
};
module.exports["invite"] = $135e52b0113e9793$export$dd37b42f82fee9c3;
module.exports["mapInviteResult"] = $135e52b0113e9793$export$e0d12419555d8733;

});

parcelRegister("fAdjB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3fNls = parcelRequire("3fNls");


var $e0dFR = parcelRequire("e0dFR");

const $289b76b44af560c7$export$9a22eec761fce66 = ({ siteKey: siteKey, displayBadge: displayBadge = true, analyticsChannel: analyticsChannel, analyticsSource: analyticsSource, preventUnloadRecaptchaOnCleanup: preventUnloadRecaptchaOnCleanup })=>{
    const triggerEvent = (0, $3fNls.useAnalytics)(analyticsChannel, analyticsSource);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = (0, $42omo.useState)(false);
    const [recaptchaLoadErrorReason, setRecaptchaLoadErrorReason] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        const initRecaptcha = async ()=>{
            try {
                await (0, $e0dFR.loadRecaptcha)(siteKey);
                if (!displayBadge) (0, $e0dFR.hideRecaptchaBadge)(siteKey);
                triggerEvent((0, $3fNls.recaptchaLoaded));
                if (isMounted) {
                    setIsRecaptchaLoaded(true);
                    setRecaptchaLoadErrorReason(undefined);
                }
            } catch (err) {
                const errorMessage = String(err);
                triggerEvent((0, $3fNls.recaptchaLoadFailed), errorMessage);
                if (isMounted) setRecaptchaLoadErrorReason(errorMessage);
            }
        };
        initRecaptcha();
        return ()=>{
            !preventUnloadRecaptchaOnCleanup && (0, $e0dFR.unloadRecaptcha)(siteKey);
            setRecaptchaLoadErrorReason(undefined);
            isMounted = false;
        };
    }, [
        displayBadge,
        siteKey,
        triggerEvent,
        preventUnloadRecaptchaOnCleanup
    ]);
    const getRecaptchaToken = (0, $42omo.useCallback)(async (action)=>{
        try {
            if (!isRecaptchaLoaded || !window?.grecaptcha?.enterprise?.execute) throw new (0, $e0dFR.RecaptchaError)('Execute function not ready');
            return await window.grecaptcha.enterprise.execute(siteKey, {
                action: action
            });
        } catch (err) {
            triggerEvent((0, $3fNls.recaptchaExecuteFailed), String(err));
            throw err;
        }
    }, [
        isRecaptchaLoaded,
        siteKey,
        triggerEvent
    ]);
    return {
        isRecaptchaLoaded: isRecaptchaLoaded,
        getRecaptchaToken: getRecaptchaToken,
        recaptchaLoadErrorReason: recaptchaLoadErrorReason,
        unloadRecaptchaForSite: ()=>(0, $e0dFR.unloadRecaptcha)(siteKey)
    };
};
module.exports["useInvisibleRecaptcha"] = $289b76b44af560c7$export$9a22eec761fce66;

});

parcelRegister("3fNls", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7TH2w = parcelRequire("7TH2w");


var $eWRwJ = parcelRequire("eWRwJ");

var $inPa6 = parcelRequire("inPa6");

const $7c3df9c3bb69d23f$var$ACTION_SUBJECT = 'recaptcha';
const $7c3df9c3bb69d23f$export$e955abb82869dc84 = (channel, source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const triggerEvent = (0, $42omo.useCallback)((eventFactory, ...args)=>{
        const analyticsEvent = {
            source: source,
            ...eventFactory(...args)
        };
        (0, $eWRwJ.default)(channel)(analyticsEvent)(createAnalyticsEvent);
    }, [
        source,
        channel,
        createAnalyticsEvent
    ]);
    return triggerEvent;
};
const $7c3df9c3bb69d23f$export$b97b16bc7fe47920 = ()=>({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: $7c3df9c3bb69d23f$var$ACTION_SUBJECT,
        action: 'loaded'
    });
const $7c3df9c3bb69d23f$export$3a46331396e3fda = (errorMessage)=>({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: $7c3df9c3bb69d23f$var$ACTION_SUBJECT,
        actionSubjectId: 'load',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });
const $7c3df9c3bb69d23f$export$ea782407790eb26c = (errorMessage)=>({
        eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
        actionSubject: $7c3df9c3bb69d23f$var$ACTION_SUBJECT,
        actionSubjectId: 'execute',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });
module.exports["useAnalytics"] = $7c3df9c3bb69d23f$export$e955abb82869dc84;
module.exports["recaptchaLoaded"] = $7c3df9c3bb69d23f$export$b97b16bc7fe47920;
module.exports["recaptchaLoadFailed"] = $7c3df9c3bb69d23f$export$3a46331396e3fda;
module.exports["recaptchaExecuteFailed"] = $7c3df9c3bb69d23f$export$ea782407790eb26c;

});

parcelRegister("e0dFR", function(module, exports) {
const $01edda88c39dafc3$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise';
const $01edda88c39dafc3$export$b8e8ecca99719d00 = 'https://www.recaptcha.net/recaptcha/enterprise.js';
const $01edda88c39dafc3$var$RECAPTCHA_BADGE_SELECTOR = '.grecaptcha-badge';
const $01edda88c39dafc3$export$29933d84054794ee = (siteKey)=>new Promise((resolve, reject)=>{
        if ($01edda88c39dafc3$var$isRecaptchaLoaded(siteKey)) {
            resolve();
            return;
        }
        const scriptElement = document.createElement('script');
        scriptElement.src = `${$01edda88c39dafc3$export$b8e8ecca99719d00}?render=${siteKey}`;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.id = siteKey;
        scriptElement.onload = ()=>{
            if (!window?.grecaptcha?.enterprise) reject($01edda88c39dafc3$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
            else window.grecaptcha.enterprise.ready(resolve);
        };
        scriptElement.onerror = (error)=>{
            reject(typeof error === 'string' ? error : error.message ?? $01edda88c39dafc3$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
        };
        document.body.appendChild(scriptElement);
    });
const $01edda88c39dafc3$var$isRecaptchaLoaded = (siteKey)=>Boolean(document.getElementById(siteKey));
const $01edda88c39dafc3$export$cfad80fecff3cb16 = (siteKey)=>{
    $01edda88c39dafc3$var$removeRecaptchaScriptElement(siteKey);
    $01edda88c39dafc3$var$removeRecaptchaBadgeStyleElement(siteKey);
    $01edda88c39dafc3$var$removeRecaptchaBadge();
};
const $01edda88c39dafc3$export$924e44702e93d253 = (siteKey)=>{
    const id = `${siteKey}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = `${siteKey}-styles`;
    styleElement.innerText = `${$01edda88c39dafc3$var$RECAPTCHA_BADGE_SELECTOR} { visibility: hidden; }`;
    document.head.appendChild(styleElement);
};
const $01edda88c39dafc3$var$removeRecaptchaScriptElement = (siteKey)=>{
    const scriptElement = document.getElementById(siteKey);
    if (scriptElement) scriptElement.remove();
};
const $01edda88c39dafc3$var$removeRecaptchaBadgeStyleElement = (siteKey)=>{
    const styleElement = document.getElementById(`${siteKey}-styles`);
    if (styleElement) styleElement.remove();
};
const $01edda88c39dafc3$var$removeRecaptchaBadge = ()=>{
    const badgeElements = document.querySelectorAll($01edda88c39dafc3$var$RECAPTCHA_BADGE_SELECTOR);
    // @ts-ignore "TS2488: Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator." occurs within Jira due to missing DOM.Iterable. We've dropped IE support so we shouldn't need it.
    for (const el of badgeElements)el.remove();
};
class $01edda88c39dafc3$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        // fixing the `instanceof` operators, see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $01edda88c39dafc3$export$e037dc82f45cc746.prototype);
    }
}
module.exports["loadRecaptcha"] = $01edda88c39dafc3$export$29933d84054794ee;
module.exports["unloadRecaptcha"] = $01edda88c39dafc3$export$cfad80fecff3cb16;
module.exports["hideRecaptchaBadge"] = $01edda88c39dafc3$export$924e44702e93d253;
module.exports["RecaptchaError"] = $01edda88c39dafc3$export$e037dc82f45cc746;

});

parcelRegister("a502B", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $agqgM = parcelRequire("agqgM");


var $3fe4D = parcelRequire("3fe4D");

const $62b0641164ba13b9$var$RecaptchaTermsAndPolicy = ({ tagName: tagName = 'span' })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $agqgM.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $3fe4D.default).termsAndPolicy,
            tagName: tagName,
            values: {
                privacyPolicy: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $3fe4D.default).privacyPolicy
                    })
                }),
                termsOfService: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $3fe4D.default).termsOfService
                    })
                })
            }
        })
    });
var $62b0641164ba13b9$export$2e2bcd8739ae039 = $62b0641164ba13b9$var$RecaptchaTermsAndPolicy;
module.exports["default"] = $62b0641164ba13b9$export$2e2bcd8739ae039;

});

parcelRegister("agqgM", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");


var $iKqYl = parcelRequire("iKqYl");

const $9314b900d90498c2$var$IntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { messages: messages } = (0, $iKqYl.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        messages: messages,
        locale: locale,
        children: children
    }, locale);
};
var $9314b900d90498c2$export$2e2bcd8739ae039 = $9314b900d90498c2$var$IntlProvider;
module.exports["default"] = $9314b900d90498c2$export$2e2bcd8739ae039;

});

parcelRegister("iKqYl", function(module, exports) {
/* eslint-disable import/dynamic-import-chunkname */ 
var $42omo = parcelRequire("42omo");


























function $765ca54b282a0d48$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("jGLVl"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("bVxyy"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("7ZmmJ"));
        case 'en-GB':
            return (parcelRequire("79s2Z"));
        case 'en-US':
        case 'en':
            return (parcelRequire("aiu8D"));
        case 'en-ZZ':
            return (parcelRequire("4f7vy"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("d1zMz"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("cRrzR"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("c3bM3"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("euOwt"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("9FplM"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("gKFud"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("3goJ9"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("d7YKh"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("cCVx9"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("asGZ2"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("1MEpQ"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("aLpxg"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("bPgnc"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("d0K23"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("bwKTl"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("lD1Cx"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("hHdfw"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("4CdOK"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("eqQqW"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $765ca54b282a0d48$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                const module = await $765ca54b282a0d48$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages
    };
}
module.exports["useFetchMessagesByLocale"] = $765ca54b282a0d48$export$5ac26fa9b941854e;

});

parcelRegister("jGLVl", function(module, exports) {

let $e5571d46941d8131$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5571d46941d8131$var$load("35VU5").then(()=>parcelRequire('6EPYm'));

});

parcelRegister("bVxyy", function(module, exports) {

let $8aef0c2f036927f1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8aef0c2f036927f1$var$load("6W6gh").then(()=>parcelRequire('fNXPx'));

});

parcelRegister("7ZmmJ", function(module, exports) {

let $5d0f944624b59fc2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5d0f944624b59fc2$var$load("bfTAm").then(()=>parcelRequire('a3iQa'));

});

parcelRegister("79s2Z", function(module, exports) {

let $534f213e9a0a6684$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $534f213e9a0a6684$var$load("fP9up").then(()=>parcelRequire('kZxFX'));

});

parcelRegister("aiu8D", function(module, exports) {

let $77f2f6ae84e7f44f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77f2f6ae84e7f44f$var$load("hc0i6").then(()=>parcelRequire('c56JU'));

});

parcelRegister("4f7vy", function(module, exports) {

let $316e630dcc1ae5dc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $316e630dcc1ae5dc$var$load("15E48").then(()=>parcelRequire('6csUz'));

});

parcelRegister("d1zMz", function(module, exports) {

let $97b71ffde1967598$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97b71ffde1967598$var$load("jLWG0").then(()=>parcelRequire('l48Qc'));

});

parcelRegister("cRrzR", function(module, exports) {

let $95cfd38fb954c163$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $95cfd38fb954c163$var$load("9J49E").then(()=>parcelRequire('fNycq'));

});

parcelRegister("c3bM3", function(module, exports) {

let $8c5ee5ed1676e9d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c5ee5ed1676e9d9$var$load("br9SP").then(()=>parcelRequire('72OPL'));

});

parcelRegister("euOwt", function(module, exports) {

let $a8db0ece189b6a7e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a8db0ece189b6a7e$var$load("5h4sF").then(()=>parcelRequire('dfboX'));

});

parcelRegister("9FplM", function(module, exports) {

let $709b9b705eb9c105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $709b9b705eb9c105$var$load("1MV5Z").then(()=>parcelRequire('cUqc4'));

});

parcelRegister("gKFud", function(module, exports) {

let $c3211f897cea01a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3211f897cea01a7$var$load("iV5Fv").then(()=>parcelRequire('6RiYZ'));

});

parcelRegister("3goJ9", function(module, exports) {

let $26060c07f257385a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26060c07f257385a$var$load("7R5mJ").then(()=>parcelRequire('2JhxH'));

});

parcelRegister("d7YKh", function(module, exports) {

let $98eb0c92fb86694e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98eb0c92fb86694e$var$load("5XMUp").then(()=>parcelRequire('16SCI'));

});

parcelRegister("cCVx9", function(module, exports) {

let $9315a9a0eaa20955$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9315a9a0eaa20955$var$load("jaDFz").then(()=>parcelRequire('e1eeN'));

});

parcelRegister("asGZ2", function(module, exports) {

let $79dddc847e19fd10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $79dddc847e19fd10$var$load("LOg5S").then(()=>parcelRequire('93ddA'));

});

parcelRegister("1MEpQ", function(module, exports) {

let $14c99fe84e21dc2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $14c99fe84e21dc2a$var$load("lnJdQ").then(()=>parcelRequire('441Ql'));

});

parcelRegister("aLpxg", function(module, exports) {

let $7d6219f91d4251a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d6219f91d4251a2$var$load("hqsLl").then(()=>parcelRequire('gp4rr'));

});

parcelRegister("bPgnc", function(module, exports) {

let $89c1287fdf837749$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $89c1287fdf837749$var$load("j0btO").then(()=>parcelRequire('4I7v4'));

});

parcelRegister("d0K23", function(module, exports) {

let $978efb74727e187e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $978efb74727e187e$var$load("2YEqr").then(()=>parcelRequire('5C7tx'));

});

parcelRegister("bwKTl", function(module, exports) {

let $86470e990fb6e6f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86470e990fb6e6f3$var$load("7zFV7").then(()=>parcelRequire('g6aPf'));

});

parcelRegister("lD1Cx", function(module, exports) {

let $fbee7f4beee44ab1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fbee7f4beee44ab1$var$load("fZ22O").then(()=>parcelRequire('8K8sb'));

});

parcelRegister("hHdfw", function(module, exports) {

let $ce20badb71881f1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ce20badb71881f1d$var$load("4tleS").then(()=>parcelRequire('kzIYe'));

});

parcelRegister("4CdOK", function(module, exports) {

let $35c56de6a79c653f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35c56de6a79c653f$var$load("bE6tX").then(()=>parcelRequire('cQFQ4'));

});

parcelRegister("eqQqW", function(module, exports) {

let $a81c2aa12c579571$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a81c2aa12c579571$var$load("esYD7").then(()=>parcelRequire('inthu'));

});

parcelRegister("3fe4D", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3b0ce4b0f45a050d$var$messages = (0, $cgtv4.defineMessages)({
    termsAndPolicy: {
        id: "growth.google-recaptcha.terms-and-policy.text",
        defaultMessage: "This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply."
    },
    privacyPolicy: {
        id: "growth.google-recaptcha.terms-and-policy.privacy-policy",
        defaultMessage: "Privacy Policy"
    },
    termsOfService: {
        id: "growth.google-recaptcha.terms-and-policy.terms-of-service",
        defaultMessage: "Terms of Service"
    }
});
var $3b0ce4b0f45a050d$export$2e2bcd8739ae039 = $3b0ce4b0f45a050d$var$messages;
module.exports["default"] = $3b0ce4b0f45a050d$export$2e2bcd8739ae039;

});

parcelRegister("hSHWm", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $42omo.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("egeZH", function(module, exports) {
const $564fc67913055f3a$export$fb6903bb2f126554 = ()=>`${window.location.protocol}//${window.location.host}/wiki`;
const $564fc67913055f3a$export$dc90482e4ef07afd = ()=>`${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;
const $564fc67913055f3a$export$436d54e7edf750dc = ()=>`${$564fc67913055f3a$export$fb6903bb2f126554()}?continue=${encodeURIComponent($564fc67913055f3a$export$dc90482e4ef07afd())}`;
module.exports["getConfluenceHomeUrl"] = $564fc67913055f3a$export$fb6903bb2f126554;
module.exports["getCurrentUrl"] = $564fc67913055f3a$export$dc90482e4ef07afd;
module.exports["getCurrentUrlRedirect"] = $564fc67913055f3a$export$436d54e7edf750dc;

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("cOQPm", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $e09975e6fa5c8d51$export$1b73a1e3cf498433 = 'ids-invited-from-usd';
const $e09975e6fa5c8d51$export$96b35192759235f0 = ()=>{
    const cachedInvites = (0, $17wUi.confluenceSessionStorageInstance).getItem($e09975e6fa5c8d51$export$1b73a1e3cf498433);
    return cachedInvites ? JSON.parse(cachedInvites) : [];
};
const $e09975e6fa5c8d51$export$eb106122e112a025 = (invites)=>{
    (0, $17wUi.confluenceSessionStorageInstance).setItem($e09975e6fa5c8d51$export$1b73a1e3cf498433, JSON.stringify(invites));
};
const $e09975e6fa5c8d51$export$15440e49d0130132 = (invites)=>{
    const cachedInvites = $e09975e6fa5c8d51$export$96b35192759235f0();
    $e09975e6fa5c8d51$export$eb106122e112a025([
        ...cachedInvites,
        ...invites
    ]);
};
module.exports["getCachedInvites"] = $e09975e6fa5c8d51$export$96b35192759235f0;
module.exports["updateCachedInvites"] = $e09975e6fa5c8d51$export$15440e49d0130132;

});

parcelRegister("59MXn", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $inPa6 = parcelRequire("inPa6");


var $6fil2 = parcelRequire("6fil2");

var $f7B1p = parcelRequire("f7B1p");

var $flE5X = parcelRequire("flE5X");


var $bQm3c = parcelRequire("bQm3c");

/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7lu50 = parcelRequire("7lu50");

const $5cc409285e24cb50$export$7a601c0e3c28bd14 = ({ skip: skip = false } = {})=>{
    const { loading: loading, data: data } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`, {
        skip: skip
    });
    return {
        isEntitledExternalCollaboration: (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) ?? false,
        loading: loading
    };
};



var $4adOe = parcelRequire("4adOe");


var $lf3m6 = parcelRequire("lf3m6");

class $ca931691e16eb076$var$UserSuggestionsCache {
    setContext(siteId, orgId, userId, contextType, containerId, objectId, mentionsSessionId) {
        this._siteId = siteId;
        this._orgId = orgId;
        this._userId = userId;
        this._contextType = contextType;
        this._containerId = containerId;
        this._objectId = objectId;
        this._mentionsSessionId = mentionsSessionId;
    }
    setSiteId(siteId) {
        this._siteId = siteId;
    }
    setOrgId(orgId) {
        this._orgId = orgId;
    }
    fullCacheAndStateReset() {
        this._abortAndResetAbortController();
        this._resetUserSuggestionsPromiseState();
        this._resetUserSuggestionsCacheState();
    }
    async hydrateUserSuggestionsCache(isEntitledExternalCollaboration) {
        /** Any errors here will get caught in the usePreloadUserSuggestions hook */ await this._fetchAndCacheUserSuggestions(isEntitledExternalCollaboration);
        return this._userSuggestions;
    }
    async getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults = this._maxNumberOfDisplayResults, shouldFetchMoreResults = true, contextType, siteId, orgId, containerId, objectId, mentionsSessionId) {
        /** Any errors here will get caught in the useUserSuggestions hook */ if (this._userSuggestionsPromiseState === 'empty' || this._shouldFetchAdditionalSuggestions) {
            if (!this._siteId && siteId) this.setSiteId(siteId);
            if (!this._orgId && orgId) this.setOrgId(orgId);
            if (!this._contextType && contextType) this._contextType = contextType;
            if (!this._containerId && containerId) this._containerId = containerId;
            if (!this._objectId && objectId) this._objectId = objectId;
            if (!this._mentionsSessionId && mentionsSessionId) this._mentionsSessionId = mentionsSessionId;
            await this._fetchAndCacheUserSuggestions(isEntitledExternalCollaboration, contextType, containerId, objectId, mentionsSessionId);
        }
        const usersIdsExcludedFromShownSuggestions = [
            ...currentPickedPrincipalIds,
            this._userId
        ];
        const unfilteredServerResults = await this._userSuggestions;
        // Although we allow for maxDisplayResults to be any number, we only fetch 10 at a time so realistically we only display 10 max
        const userFacingDisplayResults = unfilteredServerResults.filter(({ id: id })=>!usersIdsExcludedFromShownSuggestions.includes(id)).slice(0, maxDisplayResults);
        this._shouldFetchAdditionalSuggestions = userFacingDisplayResults.length < this._criticallyLowDisplayResults && this._currentRequestedServerResults <= this._requestedServerResultsHardCap && this._userSuggestionsPromiseState === 'resolved' && this._noMoreServerResults === false && shouldFetchMoreResults;
        if (this._shouldFetchAdditionalSuggestions) {
            this._currentRequestedServerResults += this._serverResultsIncreaseDelta;
            return this.getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults, shouldFetchMoreResults, contextType, siteId, orgId, containerId, objectId, mentionsSessionId);
        }
        return userFacingDisplayResults;
    }
    _abortAndResetAbortController() {
        this._abortController?.abort();
        this._abortController = new AbortController();
    }
    _resetUserSuggestionsPromiseState() {
        this._userSuggestions = new Promise((resolve, reject)=>{
            this._resolveUserSuggestions = resolve;
            this._rejectUserSuggestions = reject;
        });
        this._userSuggestionsPromiseState = 'empty';
    }
    _resetUserSuggestionsCacheState() {
        this._shouldFetchAdditionalSuggestions = false;
        this._currentRequestedServerResults = 10;
        this._noMoreServerResults = false;
    }
    createContextPayload(contextType, containerId, objectId, mentionsSessionId) {
        return (0, $dWJ5i.match)({
            contextType: contextType || this._contextType,
            containerId: containerId || this._containerId,
            objectId: objectId || this._objectId,
            mentionsSessionId: mentionsSessionId || this._mentionsSessionId,
            siteId: this._siteId,
            orgId: this._orgId
        }).with({
            contextType: (0, $dWJ5i.P).string,
            containerId: (0, $dWJ5i.P).string,
            objectId: (0, $dWJ5i.P).string,
            mentionsSessionId: (0, $dWJ5i.P).string
        }, (res)=>({
                contextType: res.contextType,
                containerId: res.containerId,
                objectId: res.objectId,
                mentionsSessionId: res.mentionsSessionId,
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            })).with({
            contextType: (0, $dWJ5i.P).string
        }, (res)=>({
                contextType: res.contextType,
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            })).otherwise((res)=>({
                contextType: 'share-and-restrict-dialog:user-and-group-search:suggested-share-users',
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            }));
    }
    async _fetchAndCacheUserSuggestions(isEntitledExternalCollaboration, contextType, containerId, objectId, mentionsSessionId) {
        try {
            /** No more fetching in the same dialog session if we got an error */ if (this._userSuggestionsPromiseState === 'rejected') return this._userSuggestions;
            this._abortAndResetAbortController();
            this._resetUserSuggestionsPromiseState();
            this._userSuggestionsPromiseState = 'pending';
            const contextPayload = this.createContextPayload(contextType, containerId, objectId, mentionsSessionId);
            const response = await (0, $f7B1p.cfetch)(this._recommendationsApi, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    context: contextPayload,
                    searchQuery: {
                        cpusQueryHighlights: {
                            query: '',
                            field: ''
                        },
                        customQuery: '',
                        customerDirectoryId: '',
                        minimumAccessLevel: 'APPLICATION',
                        productAccessPermissionIds: isEntitledExternalCollaboration ? [
                            'write',
                            'external-collaborator-write'
                        ] : [
                            'write'
                        ],
                        queryString: '',
                        restrictTo: {
                            userIds: [],
                            groupIds: []
                        },
                        searchUserbase: false
                    },
                    includeNonLicensedUsers: false,
                    includeTeams: false,
                    includeGroups: false,
                    includeUsers: true,
                    performSearchQueryOnly: false,
                    maxNumberOfResults: this._currentRequestedServerResults
                }),
                signal: this._abortController?.signal
            });
            const { recommendedUsers: recommendedUsers } = await response.json();
            const formattedUsers = recommendedUsers.map(({ id: id, name: name, email: email, avatarUrl: avatarUrl })=>({
                    type: 'user',
                    id: id,
                    name: name,
                    email: email,
                    avatarUrl: avatarUrl
                }));
            this._resolveUserSuggestions(formattedUsers);
            this._noMoreServerResults = formattedUsers.length < this._currentRequestedServerResults;
            this._userSuggestionsPromiseState = 'resolved';
        } catch (e) {
            if (e instanceof (0, $flE5X.NoNetworkError) && (0, $6fil2.causedByAbortError)(e)) ;
            else {
                /** Any errors here will get caught in the consuming methods or hooks */ this._rejectUserSuggestions(e);
                this._userSuggestionsPromiseState = 'rejected';
            }
        } finally{
            this._shouldFetchAdditionalSuggestions = false;
        }
    }
    constructor(){
        this._userSuggestions = void 0;
        this._resolveUserSuggestions = void 0;
        this._rejectUserSuggestions = void 0;
        this._userSuggestionsPromiseState = void 0;
        /** URS API Route */ this._recommendationsApi = '/gateway/api/v1/recommendations';
        /** The number of displayed suggestions below which we trigger a fetch */ this._criticallyLowDisplayResults = 3;
        /** Max number of user suggestions shown at any one time */ this._maxNumberOfDisplayResults = 3;
        /** Self-imposed limit, which if reached turns off additional fetching */ this._requestedServerResultsHardCap = 60;
        /** The amount by which we increase the requested results every time we fetch.
     * Since the API is not paginated, we have to increase the amount of suggestions
     * we request from the API for the user to see additional suggestions. Each additional
     * round we increase the requested results by 10 until we reach the self-imposed hard-cap.
     */ this._serverResultsIncreaseDelta = 10;
        /** After initial hydration we look at this variable to know whether to trigger another fetch */ this._shouldFetchAdditionalSuggestions = false;
        /** The current amount of suggestions we request from the API. Gets increased by _serverResultsIncreaseDelta
     * with every following fetch until the hard cap of _requestedServerResultsHardCap is reached
     * At that point we stop allowing fetching of additional results to avoid abusing the API
     */ this._currentRequestedServerResults = 10;
        /** If _currentRequestedServerResults is 10, but the API only returns 5 back, then we assume
     * that there are _noMoreServerResults, a.k.a it becomes true
     */ this._noMoreServerResults = false;
        /** Cancel in-flight requests when needed */ this._abortController = void 0;
        this._siteId = '';
        this._orgId = '';
        this._userId = '';
        this._contextType = undefined;
        this._containerId = undefined;
        this._objectId = undefined;
        this._mentionsSessionId = undefined;
        this.fullCacheAndStateReset();
    }
}
const $ca931691e16eb076$export$434f68299dc91067 = new $ca931691e16eb076$var$UserSuggestionsCache();
const $ca931691e16eb076$export$8ac1bc9725285cbb = ({ currentPickedPrincipalIds: currentPickedPrincipalIds, maxDisplayResults: maxDisplayResults, shouldFetchMoreResults: shouldFetchMoreResults, contextType: contextType, siteId: siteId, orgId: orgId, source: source, skip: skip = false, containerId: containerId, objectId: objectId, mentionsSessionId: mentionsSessionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isEntitledExternalCollaboration: isEntitledExternalCollaboration, loading: isEntitledExternalCollaborationLoading } = (0, $5cc409285e24cb50$export$7a601c0e3c28bd14)();
    const [suggestedUsers, setSuggestedUsers] = (0, $42omo.useState)(null);
    const [error, setError] = (0, $42omo.useState)();
    const [loading, setLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const _fetchUserSuggestions = async ()=>{
            if (skip) return;
            setLoading(true);
            if (!isEntitledExternalCollaborationLoading) try {
                setSuggestedUsers(await $ca931691e16eb076$export$434f68299dc91067.getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults, shouldFetchMoreResults, contextType, siteId, orgId, containerId, objectId, mentionsSessionId));
                /** Reset error state after successful fetch */ setError(undefined);
            } catch (e) {
                setError(e);
            } finally{
                setLoading(false);
            }
        };
        _fetchUserSuggestions();
    }, [
        currentPickedPrincipalIds,
        isEntitledExternalCollaboration,
        isEntitledExternalCollaborationLoading,
        maxDisplayResults,
        shouldFetchMoreResults,
        contextType,
        siteId,
        orgId,
        skip,
        containerId,
        objectId,
        mentionsSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: source || (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'useUserSuggestions',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        source,
        createAnalyticsEvent
    ]);
    return {
        suggestedUsers: suggestedUsers,
        loading: loading,
        error: error
    };
};
const $ca931691e16eb076$export$a7906c54c2a4948b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, orgId: unsafeOrgId, userId: unsafeUserId } = (0, $bQm3c.useSessionData)();
    const { isEntitledExternalCollaboration: isEntitledExternalCollaboration, loading: isEntitledExternalCollaborationLoading } = (0, $5cc409285e24cb50$export$7a601c0e3c28bd14)();
    const { contentId: contentId, spaceId: spaceId, contextType: contextType, mentionsSessionId: mentionsSessionId } = (0, $lf3m6.useUserSuggestionsMentionsExperiment)();
    const [error, setError] = (0, $42omo.useState)();
    const orgId = unsafeOrgId ?? '';
    const userId = unsafeUserId ?? '';
    (0, $42omo.useEffect)(()=>{
        const hydrate = async ()=>{
            try {
                $ca931691e16eb076$export$434f68299dc91067.setContext(cloudId, orgId, userId, contextType, spaceId, contentId, mentionsSessionId);
                await $ca931691e16eb076$export$434f68299dc91067.hydrateUserSuggestionsCache(isEntitledExternalCollaboration);
            } catch (e) {
                setError(e);
            }
        };
        if (!isEntitledExternalCollaborationLoading) hydrate();
        return ()=>{
            $ca931691e16eb076$export$434f68299dc91067.fullCacheAndStateReset();
        };
    }, [
        cloudId,
        orgId,
        userId,
        isEntitledExternalCollaboration,
        isEntitledExternalCollaborationLoading,
        contextType,
        spaceId,
        contentId,
        mentionsSessionId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'usePreloadUserSuggestions',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
};
module.exports["useUserSuggestions"] = $ca931691e16eb076$export$8ac1bc9725285cbb;
module.exports["usePreloadUserSuggestions"] = $ca931691e16eb076$export$a7906c54c2a4948b;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $7kzZ3 = parcelRequire("7kzZ3");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled } = (0, $16xFS.useLayering)();
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose)
        }), [
        isLayerDisabled,
        onClose
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("29DUH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $aD1SW = parcelRequire("aD1SW");


var $8Y8Qi = parcelRequire("8Y8Qi");


var $dh538 = parcelRequire("dh538");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $36b921ab0de27528$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $aD1SW.default), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Y8Qi))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $fSdY7.messages).feedbackSuccessFlagDescriptionAppify : (0, $fSdY7.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $fSdY7.messages).feedbackSuccessFlagTitle)
    });
};
const $36b921ab0de27528$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: props.locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($36b921ab0de27528$var$FeedbackFlag, {
            ...props
        })
    });
var $36b921ab0de27528$export$2e2bcd8739ae039 = $36b921ab0de27528$var$FeedbackFlagWithIntl;
module.exports["default"] = $36b921ab0de27528$export$2e2bcd8739ae039;

});

parcelRegister("fSdY7", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $a10dc5cbcf39e7b4$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    }
});
module.exports["messages"] = $a10dc5cbcf39e7b4$export$defe85febe8b728c;

});

parcelRegister("giCws", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $1tbUg = parcelRequire("1tbUg");

const $9a574d55f4cfa28d$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $42omo.useState)();
    (0, $42omo.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $1tbUg.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale,
        children: children
    });
};
module.exports["IntlProviderWithResolvedMessages"] = $9a574d55f4cfa28d$export$f793de1293176fe6;

});

parcelRegister("1tbUg", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $c02f8c9a6f146725$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["getMessagesForLocale"] = $c02f8c9a6f146725$export$d0a3169680473b6c;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("biiXa", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c4c27c8e6323826$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("29DUH")).default);


var $hrGQb = parcelRequire("hrGQb");


var $29DUH = parcelRequire("29DUH");


var $3c4c27c8e6323826$export$2e2bcd8739ae039 = (0, $hrGQb.default);

});

parcelRegister("hrGQb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $iA9co = parcelRequire("iA9co");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $2KPHZ = parcelRequire("2KPHZ");


var $gpfq4 = parcelRequire("gpfq4");


var $8zkrp = parcelRequire("8zkrp");

const $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $6b78f3070669f383$var$singleLineTruncatedText = (text, length = $6b78f3070669f383$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $gpfq4.default)(singleLineText, length);
};
class $6b78f3070669f383$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $6b78f3070669f383$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $2KPHZ.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $6b78f3070669f383$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8zkrp.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            locale: this.props.locale,
            anonymousFeedback: (0, $dh538.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $2KPHZ.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $iA9co.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$6b78f3070669f383$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $6b78f3070669f383$export$2e2bcd8739ae039;

});

parcelRegister("2KPHZ", function(module, exports) {
const $defa15de0313af4d$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $defa15de0313af4d$export$f0f6fc934288a17c;

});

parcelRegister("gpfq4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bab40c5fbb12059f$export$2e2bcd8739ae039);
function $bab40c5fbb12059f$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("8zkrp", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $7gpC4 = parcelRequire("7gpC4");


var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $kuB2l = parcelRequire("kuB2l");

var $jVhgp = parcelRequire("jVhgp");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $aoVih = parcelRequire("aoVih");


var $2gD2K = parcelRequire("2gD2K");


var $9EtP6 = parcelRequire("9EtP6");


var $fSdY7 = parcelRequire("fSdY7");


var $giCws = parcelRequire("giCws");

const $27c5bd5943874410$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        },
        children: children
    });
};
const $27c5bd5943874410$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $42omo.useState)(false);
    const [description, setDescription] = (0, $42omo.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $42omo.useState)(false);
    const [type, setType] = (0, $42omo.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $42omo.useState)(false);
    const [validationErrors, setValidationErrors] = (0, $42omo.useState)({});
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isTypeSelected = ()=>type !== 'empty';
    const canShowTextField = isTypeSelected() || !showTypeField;
    const hasDescription = description || hasDescriptionDefaultValue; // Feature flag determines validation behavior
    const useNewValidation = (0, $dh538.fg)('feedback-collector-custom-validation');
    const isDisabled = useNewValidation ? isSubmitting || disableSubmitButton // New: only disable when submitting or explicitly disabled
     : disableSubmitButton || (showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription); // Old: disable based on form validation
    const getValidationErrors = ()=>{
        const errors = {}; // Validate type selection if showTypeField is true
        if (showTypeField && !isTypeSelected()) errors.type = formatMessage((0, $fSdY7.messages).validationErrorTypeRequired);
         // Validate description if showDefaultTextFields is true
        if (showDefaultTextFields && !hasDescription) errors.description = formatMessage((0, $fSdY7.messages).validationErrorDescriptionRequired);
        return errors;
    };
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $fSdY7.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $fSdY7.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $fSdY7.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $fSdY7.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $fSdY7.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $fSdY7.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $fSdY7.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $fSdY7.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $fSdY7.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $42omo.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $fSdY7.messages).canBeContactedLabelWithoutLink;
        return (0, $fSdY7.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = /*#__PURE__*/ (0, $l998X.jsxs)("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        },
        children: [
            formatMessage((0, $fSdY7.messages).requiredFieldsSummary),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
        ]
    });
    const feedbackIsAnonymous = /*#__PURE__*/ (0, $l998X.jsx)("p", {
        children: formatMessage((0, $fSdY7.messages).feedbackIsAnonymous)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true,
        children: (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                if (useNewValidation) {
                    // New validation: validate on submit and show errors
                    const errors = getValidationErrors(); // If there are validation errors, show them and don't submit
                    if (Object.keys(errors).length > 0) {
                        setValidationErrors(errors);
                        return;
                    }
                } // Submit the form (both old and new validation paths reach here)
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $fSdY7.messages).feedbackTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                    children: [
                        (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                        feedbackTitleDetails,
                        customContent,
                        showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                            name: "topic",
                            label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                            isRequired: true,
                            children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                            ...restProps,
                                            onChange: (option)=>{
                                                if (!option || option instanceof Array) return;
                                                setType(option.value); // Clear validation error when user selects a type (only for new validation)
                                                if (useNewValidation && validationErrors.type) setValidationErrors((prev)=>({
                                                        ...prev,
                                                        type: undefined
                                                    }));
                                            },
                                            menuPortalTarget: document.body,
                                            styles: {
                                                menuPortal: (base)=>({
                                                        ...base,
                                                        zIndex: 9999
                                                    })
                                            },
                                            options: selectOptions,
                                            ref: focusRef,
                                            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                            inputId: id
                                        }),
                                        useNewValidation && validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                            children: validationErrors.type
                                        })
                                    ]
                                })
                        }) : null,
                        showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                    isRequired: true,
                                    name: "description",
                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                    ...fieldProps,
                                                    name: "foo",
                                                    minimumRows: 6,
                                                    placeholder: summaryPlaceholder || undefined,
                                                    onChange: (e)=>{
                                                        setDescription(e.target.value); // Clear validation error when user types
                                                        if (useNewValidation && validationErrors.description) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                description: undefined
                                                            }));
                                                    },
                                                    value: description
                                                }),
                                                useNewValidation && validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.description
                                                })
                                            ]
                                        })
                                }),
                                !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                            "aria-hidden": false,
                                            hidden: true,
                                            children: "Atlassian opt-in options"
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "can-be-contacted",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                    values: {
                                                                        a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                target: "_blank",
                                                                                children: chunks
                                                                            })
                                                                    }
                                                                }
                                                            }),
                                                            onChange: (event)=>setCanBeContacted(event.target.checked)
                                                        }),
                                                        canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: canBeContactedLink
                                                        }),
                                                        !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                href: "https://www.atlassian.com/legal/privacy-policy",
                                                                target: "_blank",
                                                                children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            name: "enroll-in-research-group",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                            ...fieldProps,
                                                            "aria-describedby": undefined,
                                                            label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                        }),
                                                        enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                            children: enrolInResearchLink
                                                        })
                                                    ]
                                                })
                                        })
                                    ]
                                }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: 'anonymousFeedback',
                                        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                appearance: 'information',
                                                children: feedbackIsAnonymous
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $fSdY7.messages).cancelButtonLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "primary",
                            type: "submit",
                            isDisabled: isSubmitting || isDisabled,
                            testId: "feedbackCollectorSubmitBtn",
                            children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $fSdY7.messages).submitButtonLabel
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
            onSubmit: async ()=>{
                if (useNewValidation) {
                    // New validation: validate on submit and show errors
                    const errors = getValidationErrors(); // If there are validation errors, show them and don't submit
                    if (Object.keys(errors).length > 0) {
                        setValidationErrors(errors);
                        return;
                    }
                } // Submit the form (both old and new validation paths reach here)
                setIsSubmitting(true);
                try {
                    await onSubmit({
                        canBeContacted: canBeContacted,
                        description: description,
                        enrollInResearchGroup: enrollInResearchGroup,
                        type: type
                    });
                } finally{
                    setIsSubmitting(false);
                }
            },
            children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                            hasCloseButton: true,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                                children: feedbackTitle || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $fSdY7.messages).feedbackTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                            children: [
                                (0, $dh538.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary,
                                feedbackTitleDetails,
                                customContent,
                                showTypeField ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                    name: "topic",
                                    label: selectLabel || formatMessage((0, $fSdY7.messages).selectionOptionDefaultLabel),
                                    isRequired: true,
                                    children: ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $2gD2K.default), {
                                                    ...restProps,
                                                    onChange: (option)=>{
                                                        if (!option || option instanceof Array) return;
                                                        setType(option.value); // Clear validation error when user selects a type (only for new validation)
                                                        if (useNewValidation && validationErrors.type) setValidationErrors((prev)=>({
                                                                ...prev,
                                                                type: undefined
                                                            }));
                                                    },
                                                    menuPortalTarget: document.body,
                                                    styles: {
                                                        menuPortal: (base)=>({
                                                                ...base,
                                                                zIndex: 9999
                                                            })
                                                    },
                                                    options: selectOptions,
                                                    ref: focusRef,
                                                    placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                                                    inputId: id
                                                }),
                                                useNewValidation && validationErrors.type && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                    children: validationErrors.type
                                                })
                                            ]
                                        })
                                }) : null,
                                showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $fSdY7.messages).defaultCustomTextAreaLabel),
                                            isRequired: true,
                                            name: "description",
                                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                                            ...fieldProps,
                                                            name: "foo",
                                                            minimumRows: 6,
                                                            placeholder: summaryPlaceholder || undefined,
                                                            onChange: (e)=>{
                                                                setDescription(e.target.value); // Clear validation error when user types
                                                                if (useNewValidation && validationErrors.description) setValidationErrors((prev)=>({
                                                                        ...prev,
                                                                        description: undefined
                                                                    }));
                                                            },
                                                            value: description
                                                        }),
                                                        useNewValidation && validationErrors.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                            children: validationErrors.description
                                                        })
                                                    ]
                                                })
                                        }),
                                        !anonymousFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $kuB2l.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)("legend", {
                                                    "aria-hidden": false,
                                                    hidden: true,
                                                    children: "Atlassian opt-in options"
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "can-be-contacted",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: canBeContactedLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                                        ...(0, $dh538.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                                                                        ...!(0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                                                                            values: {
                                                                                a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                                        target: "_blank",
                                                                                        children: chunks
                                                                                    })
                                                                            }
                                                                        }
                                                                    }),
                                                                    onChange: (event)=>setCanBeContacted(event.target.checked)
                                                                }),
                                                                canBeContactedLabel && canBeContactedLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: canBeContactedLink
                                                                }),
                                                                !canBeContactedLabel && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                                        href: "https://www.atlassian.com/legal/privacy-policy",
                                                                        target: "_blank",
                                                                        children: formatMessage((0, $fSdY7.messages).privacyPolicy)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                    name: "enroll-in-research-group",
                                                    children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                                                    ...fieldProps,
                                                                    "aria-describedby": undefined,
                                                                    label: enrolInResearchLabel || formatMessage((0, $fSdY7.messages).enrolInResearchLabel),
                                                                    onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
                                                                }),
                                                                enrolInResearchLabel && enrolInResearchLink && (0, $dh538.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$LinkWrapper, {
                                                                    children: enrolInResearchLink
                                                                })
                                                            ]
                                                        })
                                                })
                                            ]
                                        }) || /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                                name: 'anonymousFeedback',
                                                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aoVih.default), {
                                                        title: formatMessage((0, $fSdY7.messages).feedbackIsAnonymousTitle),
                                                        appearance: 'information',
                                                        children: feedbackIsAnonymous
                                                    })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "subtle",
                                    onClick: onClose,
                                    children: cancelButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $fSdY7.messages).cancelButtonLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isDisabled: isSubmitting || isDisabled,
                                    testId: "feedbackCollectorSubmitBtn",
                                    children: submitButtonLabel || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                        ...(0, $fSdY7.messages).submitButtonLabel
                                    })
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
const $27c5bd5943874410$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $giCws.IntlProviderWithResolvedMessages), {
        locale: locale,
        children: /*#__PURE__*/ (0, $l998X.jsx)($27c5bd5943874410$var$FeedbackForm, {
            ...props
        })
    });
};
var $27c5bd5943874410$export$2e2bcd8739ae039 = $27c5bd5943874410$var$FeedbackFormWithIntl;
module.exports["default"] = $27c5bd5943874410$export$2e2bcd8739ae039;

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("iLjL8"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("iLjL8"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("iLjL8", function(module, exports) {

let $da8bf18d9869c3f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da8bf18d9869c3f0$var$load("Wowvf"),
    $da8bf18d9869c3f0$var$load("6wr18"),
    $da8bf18d9869c3f0$var$load("ffEVr"),
    $da8bf18d9869c3f0$var$load("hhss7"),
    $da8bf18d9869c3f0$var$load("cyGuT"),
    $da8bf18d9869c3f0$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("1sB5X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6Co6F = parcelRequire("6Co6F");


var $inPa6 = parcelRequire("inPa6");


var $bUlM5 = parcelRequire("bUlM5");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $7p4As = parcelRequire("7p4As");


var $gLeLL = parcelRequire("gLeLL");


var $dqdrq = parcelRequire("dqdrq");


var $c50VH = parcelRequire("c50VH");


var $4WmbV = parcelRequire("4WmbV");

const $ee38dc3a43c4cf99$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    upsellButtonText: {
        id: "change-edition.public-links.upsell.upgrade-button-text",
        defaultMessage: "Upgrade"
    },
    upsellLearnMoreButtonText: {
        id: "change-edition.public-links.upsell.upgrade-learn-more-button-text",
        defaultMessage: "Learn more"
    },
    upsellTitle: {
        id: "change-edition.public-links.upsell.share-page-title",
        defaultMessage: "Share this content publicly"
    },
    upsellDescription: {
        id: "change-edition.public-links.upsell.share-page-description",
        defaultMessage: "Your team can use public links to share content with anyone on the internet."
    }
});
const $ee38dc3a43c4cf99$var$PUBLIC_LINK_LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/share-content-externally-with-public-links';
const $ee38dc3a43c4cf99$export$fb45fda976643d56 = '/admin/billing';
const $ee38dc3a43c4cf99$var$containerStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.200'
});
const $ee38dc3a43c4cf99$var$TEXT_MIN_WIDTH = '59px';
const $ee38dc3a43c4cf99$var$TEXT_MAX_WIDTH = '155px';
const $ee38dc3a43c4cf99$export$3aaf1fe988b8c09e = ({ inverted: inverted = true })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return inverted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c50VH.GradientCTAInvertedButton), {
        href: origin.addToUrl($ee38dc3a43c4cf99$export$fb45fda976643d56),
        target: "_blank",
        textMinWidth: $ee38dc3a43c4cf99$var$TEXT_MIN_WIDTH,
        textMaxWidth: $ee38dc3a43c4cf99$var$TEXT_MAX_WIDTH
    }, formatMessage($ee38dc3a43c4cf99$export$a7357cdd1f0b0168.upsellButtonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dqdrq.GradientCTAButton), {
        href: origin.addToUrl($ee38dc3a43c4cf99$export$fb45fda976643d56),
        target: "_blank"
    }, formatMessage($ee38dc3a43c4cf99$export$a7357cdd1f0b0168.upsellButtonText));
};
const $ee38dc3a43c4cf99$export$a6c8abcf711ddfd3 = ({ appearance: appearance = 'default', href: href = $ee38dc3a43c4cf99$var$PUBLIC_LINK_LEARN_MORE_URL, target: target = '_blank', onClick: onClick = ()=>{}, children: children })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: appearance,
        href: href,
        target: target,
        onClick: onClick
    }, children ?? formatMessage($ee38dc3a43c4cf99$export$a7357cdd1f0b0168.upsellLearnMoreButtonText));
};
const $ee38dc3a43c4cf99$export$9eff97ea066f2ae8 = ({ upsellSource: upsellSource = 'publicLinksUpsell', appearance: appearance, href: href, target: target, onClick: onClick = ()=>{} })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/73864
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'upsell',
                actionSubjectId: 'publicLinksUpsell',
                source: 'publicLinksUpsell',
                attributes: {
                    touchpointId: upsellSource
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        upsellSource
    ]);
    const handleLearnMoreLinkClicked = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/28345
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'learnMoreLink',
                source: 'publicLinksUpsell',
                attributes: {
                    touchpointId: upsellSource
                }
            }
        }).fire();
        onClick(e, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onClick,
        upsellSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
        withGradient: false,
        title: formatMessage($ee38dc3a43c4cf99$export$a7357cdd1f0b0168.upsellTitle),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage($ee38dc3a43c4cf99$export$a7357cdd1f0b0168.upsellDescription)),
        buttonConfig: (0, $4WmbV.SectionMessageButtonConfig).NONE,
        source: upsellSource,
        customPadding: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "row",
        gap: "space.050",
        xcss: $ee38dc3a43c4cf99$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ee38dc3a43c4cf99$export$a6c8abcf711ddfd3, {
        appearance: appearance || 'default',
        href: href,
        target: target,
        onClick: handleLearnMoreLinkClicked
    }, formatMessage($ee38dc3a43c4cf99$export$a7357cdd1f0b0168.upsellLearnMoreButtonText))));
};
module.exports["PublicLinksLearnMoreButton"] = $ee38dc3a43c4cf99$export$a6c8abcf711ddfd3;
module.exports["PublicLinksUpsell"] = $ee38dc3a43c4cf99$export$9eff97ea066f2ae8;

});

parcelRegister("c50VH", function(module, exports) {
/* GradientCTAInvertedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $42omo = parcelRequire("42omo");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $c38e200f31d7f698$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END)),
            "--_1vedxvh": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_SELECTED_START)),
            "--_480e6g": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_SELECTED_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tnqfajl _u3091kx8 _d16p1ano _1c04idpf _1khaidpf _zqu5idpf _3zhzidpf _btpd1ul9 _16hg15cr _1w90ya33 _1vy1ya33 _h99ltlke _gd3615cr _10hl1nf8 _1xlotlke _1l5a15cr _1jfw15cr _y9nnz89h",
            __cmplp.className
        ])
    });
});
const $c38e200f31d7f698$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { textMinWidth: textMinWidth, textMaxWidth: textMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1doqf6v": (0, $7sObp.default)(__cmplp.textMinWidth),
            "--_oxr9kp": (0, $7sObp.default)(__cmplp.textMaxWidth),
            "--_1mkuz4m": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_INVERTED_BORDER_START)),
            "--_10oi9u3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_INVERTED_BORDER_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c82smr _1reo15vq _18m915vq _1ul9qaf7 _p12f1f1n _1e0c1ule _y3gn1h6o _1bto1l2s _o5721q9c _1itk558n _pjrq1kdv _1y1m1kdv _syaz1j28",
            __cmplp.className
        ])
    });
});
const $c38e200f31d7f698$var$GradientBorderBox = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1mkuz4m": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_INVERTED_BORDER_START)),
            "--_10oi9u3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_INVERTED_BORDER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END)),
            "--_1vedxvh": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_SELECTED_START)),
            "--_480e6g": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_SELECTED_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4e4h9 _2rkofajl _1e0c116y _1itk19z7 _ctqnk5xx _1aq019bo",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient border, intended to be used as a product edition upgrade CTA button.
     */ 
const $c38e200f31d7f698$export$898ce05330dc59e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ textMaxWidth: textMaxWidth, textMinWidth: textMinWidth, children: children, ...buttonProps }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c38e200f31d7f698$var$GradientBorderBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c38e200f31d7f698$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c38e200f31d7f698$var$ButtonText, {
        textMaxWidth: textMaxWidth,
        textMinWidth: textMinWidth
    }, children)));
});
module.exports["GradientCTAInvertedButton"] = $c38e200f31d7f698$export$898ce05330dc59e;

});

parcelRegister("2Pg7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $esRft = parcelRequire("esRft");


var $4JWgN = parcelRequire("4JWgN");


var $ee7An = parcelRequire("ee7An");


var $loiTn = parcelRequire("loiTn");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $lGgRw = parcelRequire("lGgRw");


var $3gadb = parcelRequire("3gadb");


var $fj4Q9 = parcelRequire("fj4Q9");


var $crJ46 = parcelRequire("crJ46");


var $6MWy1 = parcelRequire("6MWy1");


var $2cWqt = parcelRequire("2cWqt");


var $2LGbr = parcelRequire("2LGbr");


var $6Ac15 = parcelRequire("6Ac15");


var $1DG7o = parcelRequire("1DG7o");

const $49cfd043cf935c3d$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $49cfd043cf935c3d$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, $42omo.createElement)(Component, {
                    ...props,
                    key: (0, $1DG7o.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props
                }),
            ...overrides && overrides.MoreIndicator
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $49cfd043cf935c3d$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $esRft.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $42omo.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $ee7An.default;
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4JWgN.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $4JWgN.KEY_DOWN)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>$49cfd043cf935c3d$var$getOverrides(overrides).MoreIndicator.render((0, $2LGbr.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6MWy1.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cWqt.default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            titleId: labelId,
                            testId: `${testId}--section`,
                            children: data.slice(max).map((avatar, index)=>$49cfd043cf935c3d$var$getOverrides(overrides).AvatarGroupItem.render((0, $fj4Q9.default), {
                                    avatar: avatar,
                                    onAvatarClick: onAvatarClick,
                                    testId: testId && `${testId}--avatar-group-item-${index + max}`,
                                    index: index + max
                                }, // This index holds the true index,
                                // adding up the index of non-overflowed avatars and overflowed avatars.
                                index + max))
                        })
                    })
                }),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $49cfd043cf935c3d$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const groupId = (0, $c0qxy.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $6Ac15.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $crJ46.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        children: [
            data.slice(0, maxAvatar).map((avatarData, idx)=>{
                const callback = avatarData.onClick || onAvatarClick;
                const finalAvatar = $49cfd043cf935c3d$var$getOverrides(overrides).Avatar.render(avatar, {
                    ...avatarData,
                    size: size,
                    borderColor: borderColor || avatarData.borderColor,
                    testId: testId && `${testId}--avatar-${idx}`,
                    onClick: callback ? (event, analyticsEvent)=>{
                        callback(event, analyticsEvent, idx);
                    } : undefined,
                    stackIndex: max - idx
                }, idx);
                return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: avatarData.name,
                    testId: testId && `${testId}--tooltip-${idx}`,
                    position: tooltipPosition,
                    children: finalAvatar
                }, (0, $1DG7o.composeUniqueKey)(avatarData, idx)) : finalAvatar;
            }),
            renderMoreDropdown(+maxAvatar, total, groupId)
        ]
    });
};
var $49cfd043cf935c3d$export$2e2bcd8739ae039 = $49cfd043cf935c3d$var$AvatarGroup;
module.exports["default"] = $49cfd043cf935c3d$export$2e2bcd8739ae039;

});

parcelRegister("fj4Q9", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");

var $d77M1 = parcelRequire("d77M1");

var $cGtPE = parcelRequire("cGtPE");


var $atkCk = parcelRequire("atkCk");

const $b02c3981c986946c$var$AvatarGroupItem = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $atkCk.default)();
    const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
        return /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref,
            tabIndex: tabIndex,
            "data-testid": testId,
            ...props,
            children: children
        });
    };
    const AvatarIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index),
        children: name
    });
    if (typeof callback === 'function') return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        children: name
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId,
        children: name
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b02c3981c986946c$export$2e2bcd8739ae039 = $b02c3981c986946c$var$AvatarGroupItem;
module.exports["default"] = $b02c3981c986946c$export$2e2bcd8739ae039;

});

parcelRegister("atkCk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6MWy1 = parcelRequire("6MWy1");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $f69e73e233725633$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $f69e73e233725633$export$2e2bcd8739ae039 = $f69e73e233725633$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f69e73e233725633$export$2e2bcd8739ae039;

});

parcelRegister("6MWy1", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $1ztii = parcelRequire("1ztii");

const $5d9c84f5f87b7a1d$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic
 */ const $5d9c84f5f87b7a1d$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $42omo.useEffect)(()=>{
        (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $1ztii.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $fFa3V.bind)(window, {
                type: 'keydown',
                listener: (0, $1ztii.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($5d9c84f5f87b7a1d$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $5d9c84f5f87b7a1d$export$2e2bcd8739ae039 = $5d9c84f5f87b7a1d$var$FocusManager;
module.exports["FocusManagerContext"] = $5d9c84f5f87b7a1d$export$f18c1d4fc7326096;
module.exports["default"] = $5d9c84f5f87b7a1d$export$2e2bcd8739ae039;

});

parcelRegister("1ztii", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cbf707a7ad85d1$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");

const $15cbf707a7ad85d1$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $15cbf707a7ad85d1$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $15cbf707a7ad85d1$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $15cbf707a7ad85d1$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $15cbf707a7ad85d1$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $15cbf707a7ad85d1$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("crJ46", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $97f44b6287529f93$var$gutter = "var(--ds-space-negative-050, -4px)";
const $97f44b6287529f93$var$listStyles = null;
const $97f44b6287529f93$var$listStylesFlagged = null;
const $97f44b6287529f93$var$listItemStyles = null;
const $97f44b6287529f93$var$Grid = ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$97f44b6287529f93$export$2e2bcd8739ae039 = $97f44b6287529f93$var$Grid;
module.exports["default"] = $97f44b6287529f93$export$2e2bcd8739ae039;

});

parcelRegister("2cWqt", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $6MWy1 = parcelRequire("6MWy1");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $fd056483eb698f52$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $6MWy1.FocusManagerContext));
    (0, $42omo.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest,
        children: children
    });
};
var $fd056483eb698f52$export$2e2bcd8739ae039 = $fd056483eb698f52$var$PopupAvatarGroup;
module.exports["default"] = $fd056483eb698f52$export$2e2bcd8739ae039;

});

parcelRegister("2LGbr", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $965bb25f1302cdca$var$boxShadowCssVar = '--avatar-box-shadow';
const $965bb25f1302cdca$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _1q8w1np6 _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _t9ec1np6 _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon"
};
const $965bb25f1302cdca$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $965bb25f1302cdca$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $965bb25f1302cdca$var$fontMap = {
    small: "_11c81o8v",
    medium: "_11c81o8v",
    large: "_11c8dcr7",
    xlarge: "_11c81ixg",
    xxlarge: "_11c81ixg"
};
const $965bb25f1302cdca$var$MAX_DISPLAY_COUNT = 99;
const $965bb25f1302cdca$var$MoreIndicator = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $965bb25f1302cdca$var$MAX_DISPLAY_COUNT ? $965bb25f1302cdca$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$965bb25f1302cdca$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $gMc0m.default)([
            $965bb25f1302cdca$var$styles.root,
            $965bb25f1302cdca$var$borderRadiusMap[size],
            appearance === 'circle' && $965bb25f1302cdca$var$styles.circle,
            $965bb25f1302cdca$var$widthHeightMap[size],
            $965bb25f1302cdca$var$fontMap[size],
            isActive && $965bb25f1302cdca$var$styles.active
        ]),
        children: [
            "+",
            displayCount
        ]
    });
});
$965bb25f1302cdca$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $965bb25f1302cdca$export$2e2bcd8739ae039 = $965bb25f1302cdca$var$MoreIndicator;
module.exports["default"] = $965bb25f1302cdca$export$2e2bcd8739ae039;

});

parcelRegister("6Ac15", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");

const $7b5befcdc2ab883e$var$listStyles = null;
const $7b5befcdc2ab883e$var$listSmallStyles = null;
const $7b5befcdc2ab883e$var$listItemStyles = null;
const $7b5befcdc2ab883e$var$listItemSmallStyles = null;
const $7b5befcdc2ab883e$var$Stack = ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ (0, $l998X.jsx)("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ]),
        children: (0, $42omo.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $l998X.jsx)("li", {
                className: (0, $gMc0m.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === 'small' && (0, $dh538.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
                ]),
                children: child
            }))
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7b5befcdc2ab883e$export$2e2bcd8739ae039 = $7b5befcdc2ab883e$var$Stack;
module.exports["default"] = $7b5befcdc2ab883e$export$2e2bcd8739ae039;

});

parcelRegister("1DG7o", function(module, exports) {
const $e8b8a534df2444a6$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $e8b8a534df2444a6$export$b067756944994c79;

});

parcelRegister("8oEoE", function(module, exports) {
/**
 * @generated SignedSource<<b737a884b4d09b51b8ecb9521d585d5a>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("1fjr9", function(module, exports) {

var $8oEoE = parcelRequire("8oEoE");

function $6ae0cc53b6a5ae8c$export$ea5292b0643714e2(restrictions, currentUser) {
    const readAndUpdateLists = $6ae0cc53b6a5ae8c$var$convertRestrictionsObject(restrictions);
    const { groupCount: groupCount, teamCount: teamCount, principals: principals, currentUserHasAccess: currentUserHasAccess } = $6ae0cc53b6a5ae8c$export$9910d0d832defd77(readAndUpdateLists, currentUser);
    return {
        generalAccessLevel: $6ae0cc53b6a5ae8c$export$348a31f6b2aa49f4(readAndUpdateLists),
        principals: principals,
        groupCount: groupCount,
        teamCount: teamCount,
        currentUserHasAccess: currentUserHasAccess
    };
}
/**
 * Converts the 'read' and 'update' structures from the query data into their
 * structural equivalents but using our own Principal
 */ function $6ae0cc53b6a5ae8c$var$convertRestrictionsObject(source) {
    const ret = {
        read: {
            users: [],
            groups: []
        },
        update: {
            users: [],
            groups: []
        }
    };
    const { read: read, update: update, groupAndTeamCountsMap: groupAndTeamCountsMap, teamData: teamData } = source;
    if (read) $6ae0cc53b6a5ae8c$var$convertUsersAndGroups(read, ret.read, groupAndTeamCountsMap, teamData);
    if (update) $6ae0cc53b6a5ae8c$var$convertUsersAndGroups(update, ret.update, groupAndTeamCountsMap, teamData);
    return ret;
}
/**
 * Iterates through the users and groups nodes of query data, converting
 * entries into Principal format, and pushing them to accumulators
 */ function $6ae0cc53b6a5ae8c$var$convertUsersAndGroups(source, { users: users, groups: groups }, groupAndTeamCountsMap, teamData) {
    const { restrictions: restrictions } = source;
    if (restrictions) {
        const { userWithRestrictions: userWithRestrictions, group: group } = restrictions;
        if (userWithRestrictions) $6ae0cc53b6a5ae8c$var$pushUserNodes(userWithRestrictions, users);
        if (group) $6ae0cc53b6a5ae8c$var$pushGroupNodes(group, groups, groupAndTeamCountsMap, teamData);
    }
}
function $6ae0cc53b6a5ae8c$export$348a31f6b2aa49f4({ read: { groups: readGroups, users: readUsers }, update: { groups: updateGroups, users: updateUsers } }) {
    const hasViewPrincipals = readGroups.length + readUsers.length > 0;
    const hasEditPrincipals = updateGroups.length + updateUsers.length > 0;
    if (hasViewPrincipals) return 'restricted';
    if (hasEditPrincipals) return 'open-can-view';
    return 'open-can-edit';
}
function $6ae0cc53b6a5ae8c$export$9910d0d832defd77({ read: read, update: update }, currentUser) {
    const map = new Map();
    const addToMapWithRole = (principals, role)=>principals.forEach((principal)=>map.set(principal.id, {
                role: role,
                principal: principal
            }));
    // Initially, populate the map with viewers
    addToMapWithRole([
        ...read.users,
        ...read.groups
    ], 'can-view');
    // Do another pass for the editors, potentially overwriting entries set in the
    // first pass, with their edit role
    addToMapWithRole([
        ...update.users,
        ...update.groups
    ], 'can-edit');
    // Convert the map to a PrincipalAndRole array, and sort by name
    const unsortedArray = Array.from(map).map(([, principalAndRole])=>principalAndRole);
    const { groupCount: groupCount, teamCount: teamCount } = unsortedArray.reduce((counts, { principal: principal })=>{
        if (principal.type === 'group') {
            if (principal.usageType === (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP) counts.groupCount++;
            else if (principal.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION) counts.teamCount++;
            else if (principal.usageType === null) // When usageType is null (because the BE sends the data but teams are not yet supported on the FE),
            // fall back to default user base group behavior
            counts.groupCount++;
        }
        return counts;
    }, {
        groupCount: 0,
        teamCount: 0
    });
    const currentUserHasAccess = unsortedArray.some(({ principal: principal })=>principal.id === currentUser.id);
    return {
        principals: Array.from(map).map(([, principalAndRole])=>principalAndRole).sort(({ principal: { name: a } }, { principal: { name: b } })=>{
            if (a === b) return 0;
            else if (a > b) return 1;
            return -1;
        }),
        currentUserHasAccess: currentUserHasAccess,
        groupCount: groupCount,
        teamCount: teamCount
    };
}
/**
 * Converts groups from query format to Principal format, and pushes them to an accumulator
 */ function $6ae0cc53b6a5ae8c$var$pushGroupNodes(source, dest, groupAndTeamCountsMap, teamData) {
    const { nodes: nodes } = source;
    if (nodes) for (const node of nodes){
        if (!node) continue;
        const id = node?.id || '';
        const team = node?.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION ? teamData?.[id] : undefined;
        dest.push({
            type: 'group',
            id: node.id || '',
            name: node.name || '',
            usageType: node.usageType,
            memberCount: groupAndTeamCountsMap.get(node.id || '') ?? 0,
            isVerified: team?.isVerified ?? false,
            avatarSrc: team?.largeAvatarImageUrl ?? ''
        });
    }
}
/**
 * Converts users from query format to Principal format, and pushes them to an accumulator
 */ function $6ae0cc53b6a5ae8c$var$pushUserNodes(source, dest) {
    const { nodes: nodes } = source;
    if (nodes) for (const node of nodes){
        if (!node) continue;
        /**
			 * TODO: there are some fields we were querying for in the Restrictions
			 * dialog, but not using here (yet):
			 * • type
			 */ dest.push({
            type: 'user',
            id: node.accountId || '',
            name: node.displayName || '',
            avatarUrl: node.profilePicture?.path || '',
            email: node.email || '',
            knownErrors: $6ae0cc53b6a5ae8c$export$9bc75062b1d89a4d(node),
            sitePermissionType: node.permissionType || ''
        });
    }
}
function $6ae0cc53b6a5ae8c$export$9bc75062b1d89a4d(node) {
    const { restrictingContent: restrictingContent, hasSpaceEditPermission: hasSpaceEditPermission, hasSpaceViewPermission: hasSpaceViewPermission } = node;
    if (hasSpaceViewPermission === false) return {
        accessWarning: 'space-view-access-warning',
        parentLink: null
    };
    if (restrictingContent) return {
        accessWarning: 'parent-access-warning',
        parentLink: {
            webui: restrictingContent.links?.webui,
            base: restrictingContent.links?.base
        }
    };
    // TODO: Implement a check for the principal's current access level.
    // If the access level is 'view', it's not relevant.
    // If the access level is 'edit', it is relevant.
    if (hasSpaceEditPermission === false) return {
        accessWarning: 'space-edit-access-warning',
        parentLink: null
    };
    return undefined;
}
module.exports["getContentRestrictions"] = $6ae0cc53b6a5ae8c$export$ea5292b0643714e2;
module.exports["getPrincipalsAndRoles"] = $6ae0cc53b6a5ae8c$export$9910d0d832defd77;
module.exports["getGeneralAccessLevel"] = $6ae0cc53b6a5ae8c$export$348a31f6b2aa49f4;
module.exports["getKnownErrors"] = $6ae0cc53b6a5ae8c$export$9bc75062b1d89a4d;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("ewQf6", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $7pcfM = parcelRequire("7pcfM");

const $673c8461c855d796$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "public-links.useRemovePublicLinkPermissionsMutation.error.title",
        defaultMessage: "We couldn\u2019t change the public link permission."
    },
    errorBody: {
        id: "public-links.useRemovePublicLinkPermissionsMutation.error.body",
        defaultMessage: "Open the Share and Restrict dialog to check the current status, or to update the permission."
    }
});
const $673c8461c855d796$export$962097a6d602bff3 = ({ objectId: objectId, objectType: objectType = (0, $7pcfM.PublicLinkPermissionsObjectType).CONTENT, permissions: permissions = [
    (0, $7pcfM.PublicLinkPermissionsType).EDIT
], onCompleted: onCompleted, onError: onError, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [removePublicLinkPermissionsMutation, { loading: loading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useRemovePublicLinkPermissionsMutationRemovePublicLinkPermissionsMutation($removePublicLinkPermissionsInput:RemovePublicLinkPermissionsInput!){removePublicLinkPermissions(input:$removePublicLinkPermissionsInput){success errors{message}}}`, {
        onCompleted: ()=>{
            onCompleted();
        },
        onError: (error)=>{
            flags.showFlag({
                id: 'updatePublicLinkPermissionsErrorFlagId',
                title: formatMessage($673c8461c855d796$var$i18n.errorTitle),
                description: formatMessage($673c8461c855d796$var$i18n.errorBody),
                type: 'error',
                close: 'auto'
            });
            onError(error);
        }
    });
    const removePublicLinkPermissions = ({ objectId: objectId, objectType: objectType, permissions: permissions })=>()=>removePublicLinkPermissionsMutation({
                variables: {
                    removePublicLinkPermissionsInput: {
                        objectId: objectId,
                        objectType: objectType,
                        permissions: permissions
                    }
                }
            });
    return {
        removePublicLinkPermissions: removePublicLinkPermissions({
            objectId: objectId,
            objectType: objectType,
            permissions: permissions
        }),
        loading: loading
    };
};
module.exports["useRemovePublicLinkPermissionsMutation"] = $673c8461c855d796$export$962097a6d602bff3;

});

parcelRegister("7pcfM", function(module, exports) {
/**
 * @generated SignedSource<<354ee8af8fe393e94c341b24ba26b373>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $376e0bc8c0efe94e$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $376e0bc8c0efe94e$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $376e0bc8c0efe94e$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $376e0bc8c0efe94e$export$1d899d09218cc934;

});

parcelRegister("22pmH", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $jVDOb = parcelRequire("jVDOb");

const $d9c6edc75a72fbb7$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitle: {
        id: "public-links.useAddPublicLinkPermissionsMutation.error.title",
        defaultMessage: "We couldn\u2019t change the public link permission."
    },
    errorBody: {
        id: "public-links.useAddPublicLinkPermissionsMutation.error.body",
        defaultMessage: "Open the Share and Restrict dialog to check the current status, or to update the permission."
    }
});
const $d9c6edc75a72fbb7$export$42b5ba64d3bbb80 = ({ objectId: objectId, objectType: objectType = (0, $jVDOb.PublicLinkPermissionsObjectType).CONTENT, permissions: permissions = [
    (0, $jVDOb.PublicLinkPermissionsType).EDIT
], onCompleted: onCompleted, onError: onError, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [addPublicLinkPermissionsMutation, { loading: loading }] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation useAddPublicLinkPermissionsMutationAddPublicLinkPermissionsMutation($addPublicLinkPermissionsInput:AddPublicLinkPermissionsInput!){addPublicLinkPermissions(input:$addPublicLinkPermissionsInput){success errors{message}}}`, {
        onCompleted: ()=>{
            onCompleted();
        },
        onError: (error)=>{
            flags.showFlag({
                id: 'updatePublicLinkPermissionsErrorFlagId',
                title: formatMessage($d9c6edc75a72fbb7$var$i18n.errorTitle),
                description: formatMessage($d9c6edc75a72fbb7$var$i18n.errorBody),
                type: 'error',
                close: 'auto'
            });
            onError(error);
        }
    });
    const addPublicLinkPermissions = ({ objectId: objectId, objectType: objectType, permissions: permissions })=>()=>addPublicLinkPermissionsMutation({
                variables: {
                    addPublicLinkPermissionsInput: {
                        objectId: objectId,
                        objectType: objectType,
                        permissions: permissions
                    }
                }
            });
    return {
        addPublicLinkPermissions: addPublicLinkPermissions({
            objectId: objectId,
            objectType: objectType,
            permissions: permissions
        }),
        loading: loading
    };
};
module.exports["useAddPublicLinkPermissionsMutation"] = $d9c6edc75a72fbb7$export$42b5ba64d3bbb80;

});

parcelRegister("jVDOb", function(module, exports) {
/**
 * @generated SignedSource<<2535b2c8c8fcd0d4e624a7399b49f3a9>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $750d4f44621e9fc6$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $750d4f44621e9fc6$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $750d4f44621e9fc6$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $750d4f44621e9fc6$export$1d899d09218cc934;

});

parcelRegister("lbXO9", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1IGAH = parcelRequire("1IGAH");

const $b66f63d9e0e0a7b3$var$i18n = (0, $cgtv4.defineMessages)({
    success: {
        id: "public-links.usePublicLinkDisablePageMutation.success.title",
        defaultMessage: "Public link is now off for this content."
    },
    errorTitle: {
        id: "public-links.usePublicLinkDisablePageMutation.error.title",
        defaultMessage: "We couldn\u2019t turn off the public link."
    },
    errorBody: {
        id: "public-links.usePublicLinkDisablePageMutation.error.body",
        defaultMessage: "Open the Share dialog to check the current status, or to turn off the public link."
    }
});
const $b66f63d9e0e0a7b3$export$7eac4bd73184138d = ({ pageId: pageId, onCompleted: onCompleted, onError: onError, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [disablePublicLinkMutation] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation usePublicLinkDisablePageMutationPublicLinkDisablePageMutation($pageId:ID!){disablePublicLinkForPage(pageId:$pageId){pageId}}`, {
        refetchQueries: [
            {
                query: (0, $1IGAH.PublicLinkPageQuery),
                variables: {
                    pageId: pageId
                }
            }
        ],
        onCompleted: ()=>{
            flags.showFlag({
                id: 'revokeFromRestrictionsFlagId',
                title: formatMessage($b66f63d9e0e0a7b3$var$i18n.success),
                type: 'success-circle',
                close: 'auto'
            });
            onCompleted();
        },
        onError: (error)=>{
            flags.showFlag({
                id: 'revokeFromRestrictionsErrorFlagId',
                title: formatMessage($b66f63d9e0e0a7b3$var$i18n.errorTitle),
                description: formatMessage($b66f63d9e0e0a7b3$var$i18n.errorBody),
                type: 'error',
                close: 'auto'
            });
            onError(error);
        }
    });
    const disablePublicLinkForPage = (pageId)=>()=>disablePublicLinkMutation({
                variables: {
                    pageId: pageId
                }
            });
    return {
        disablePublicLinkForPage: disablePublicLinkForPage(pageId)
    };
};
module.exports["usePublicLinkDisablePageMutation"] = $b66f63d9e0e0a7b3$export$7eac4bd73184138d;

});

parcelRegister("1IGAH", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $66e1cfc06d637f41$export$bdeeee9961612604 = (0, $eSUdr.default)`query PublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId pageStatus publicLinkUrlPath}}`;
module.exports["PublicLinkPageQuery"] = $66e1cfc06d637f41$export$bdeeee9961612604;

});

parcelRegister("k030f", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $556a376b27e42aa4$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $556a376b27e42aa4$export$cb24eb3958583602;

});

parcelRegister("8y1s8", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $ccf9837a697995d7$export$d9966e2dc944fbfa = 'publicLinksPagesActionConfirmationModal';
var $ccf9837a697995d7$export$75b1e1d060e17f91 = /*#__PURE__*/ function(ChangeboardingTypes) {
    ChangeboardingTypes["INTRODUCTION"] = "introduction";
    ChangeboardingTypes["TOGGLE_SPOTLIGHT"] = "toggle-spotlight";
    ChangeboardingTypes["MENU_SPOTLIGHT"] = "menu-spotlight";
    ChangeboardingTypes["NONE"] = "none";
    return ChangeboardingTypes;
}({});
const $ccf9837a697995d7$export$49832baccfe11a28 = 'https://support.atlassian.com/confluence-cloud/docs/set-up-and-manage-public-links/';
const $ccf9837a697995d7$export$3cad030b6f1e0556 = 'https://support.atlassian.com/security-and-access-policies/docs/prevent-public-links/';
const $ccf9837a697995d7$export$c077bb99fd334e2d = 'https://support.atlassian.com/confluence-cloud/docs/how-secure-are-public-links/';
const $ccf9837a697995d7$export$abc0dd76bd8e2feb = 'https://support.atlassian.com/confluence-cloud/docs/share-content-externally-with-public-links/';
module.exports["PAGES_TABLE_CONFIRMATION_SOURCE"] = $ccf9837a697995d7$export$d9966e2dc944fbfa;
module.exports["ChangeboardingTypes"] = $ccf9837a697995d7$export$75b1e1d060e17f91;
module.exports["SET_UP_AND_MANAGE_DOCUMENTATION"] = $ccf9837a697995d7$export$49832baccfe11a28;
module.exports["DATA_SECURITY_POLICY_DOCUMENTATION"] = $ccf9837a697995d7$export$3cad030b6f1e0556;
module.exports["PUBLIC_LINKS_SECURITY_DOCUMENTATION"] = $ccf9837a697995d7$export$c077bb99fd334e2d;
module.exports["LEARN_MORE_PUBLIC_LINKS_HREF"] = $ccf9837a697995d7$export$abc0dd76bd8e2feb;

});

parcelRegister("2Snr1", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $455278fb4860e860$export$fad5f226cecfdfbf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.8837 13.367C19.9601 12.9228 20 12.466 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.466 20 12.9228 19.9601 13.367 19.8837C13.1304 19.3023 13 18.6664 13 18C13 17.8036 13.0113 17.6099 13.0333 17.4195C12.9034 17.622 12.7713 17.7875 12.6409 17.9161C12.3763 18.1772 12.1606 18.25 12 18.25C11.8394 18.25 11.6237 18.1772 11.3591 17.9161C11.0913 17.6518 10.8157 17.2321 10.568 16.6543C10.1416 15.6593 9.84191 14.2977 9.76783 12.75L14.2322 12.75C14.1914 13.6024 14.0821 14.3983 13.921 15.1076C14.3759 14.4673 14.9778 13.9386 15.6776 13.5709C15.7028 13.3018 15.7216 13.0278 15.7337 12.75H18.4572C18.4469 12.8397 18.4348 12.9289 18.4208 13.0175C18.9344 13.0603 19.426 13.1807 19.8837 13.367ZM10.568 7.34569C10.1416 8.34074 9.84191 9.70234 9.76783 11.25L14.2322 11.25C14.1581 9.70234 13.8584 8.34074 13.432 7.34569C13.1843 6.7679 12.9087 6.34823 12.6409 6.08391C12.3763 5.82276 12.1606 5.75 12 5.75C11.8394 5.75 11.6237 5.82276 11.3591 6.08391C11.0913 6.34823 10.8157 6.7679 10.568 7.34569ZM15.7337 11.25L18.4572 11.25C18.1804 8.84094 16.5866 6.83252 14.4139 5.96299C14.5588 6.20973 14.6909 6.47541 14.8107 6.75481C15.328 7.96182 15.6587 9.53144 15.7337 11.25ZM5.5428 11.25L8.26628 11.25C8.34127 9.53144 8.67203 7.96182 9.18932 6.75481C9.30907 6.47541 9.44124 6.20974 9.58609 5.96299C7.41342 6.83252 5.81958 8.84094 5.5428 11.25ZM8.26628 12.75H5.5428C5.81958 15.1591 7.41342 17.1675 9.58609 18.037C9.44124 17.7903 9.30906 17.5246 9.18932 17.2452C8.67203 16.0382 8.34127 14.4686 8.26628 12.75Z",
        fill: "var(--ds-text-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "3",
        fill: "var(--ds-icon-accent-green, #22A06B)"
    }));
module.exports["WorldGreenDotGlyph"] = $455278fb4860e860$export$fad5f226cecfdfbf;

});

parcelRegister("ari0r", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1NBp8 = parcelRequire("1NBp8");


var $ep3mz = parcelRequire("ep3mz");


var $7QM6o = parcelRequire("7QM6o");


var $bQm3c = parcelRequire("bQm3c");


var $k030f = parcelRequire("k030f");


var $1yUaH = parcelRequire("1yUaH");


var $7EdWc = parcelRequire("7EdWc");

const $ada79c8987c2ef5b$var$publicLinkStatusToAccessLevelMappings = {
    [(0, $k030f.PublicLinkPageStatus).SITE_DISABLED]: 'site',
    [(0, $k030f.PublicLinkPageStatus).SPACE_BLOCKED]: 'site',
    [(0, $k030f.PublicLinkPageStatus).BLOCKED_BY_PRODUCT]: 'site',
    [(0, $k030f.PublicLinkPageStatus).SPACE_DISABLED]: 'space',
    [(0, $k030f.PublicLinkPageStatus).BLOCKED_BY_SPACE]: 'space',
    [(0, $k030f.PublicLinkPageStatus).BLOCKED_BY_ORG]: 'org',
    [(0, $k030f.PublicLinkPageStatus).SITE_BLOCKED]: 'org',
    [(0, $k030f.PublicLinkPageStatus).BLOCKED_BY_CLASSIFICATION_LEVEL]: 'org',
    [(0, $k030f.PublicLinkPageStatus).BLOCKED_BY_CONTAINER_POLICY]: 'org'
};
const $ada79c8987c2ef5b$export$b9fbfaea37882ee = ({ publicLinkStatus: publicLinkStatus })=>{
    const { environment: environment, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    const { isEmpoweredUser: isEmpowered, isSiteAdmin: isSiteAdmin, isSpaceAdmin: isSpaceAdmin, error: error } = (0, $7EdWc.useIsPLEmpoweredUser)({
        publicLinkStatus: publicLinkStatus,
        skip: !publicLinkStatus
    });
    const accessLevel = publicLinkStatus ? $ada79c8987c2ef5b$var$publicLinkStatusToAccessLevelMappings[publicLinkStatus] : null;
    const adminUrls = (0, $42omo.useMemo)(()=>({
            globalPublicLinksTab: (0, $1yUaH.getAdminGlobalPermsPublicLinksUrl)(),
            globalPublicLinksSpaceDetails: (0, $1yUaH.getAdminGlobalPermsPublicLinksUrl)(spaceId),
            spacePublicLinksTab: spaceKey && (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
                spaceKey: spaceKey,
                tab: 'public-links'
            }),
            adminHubDataSecurityPoliciesTab: (0, $1yUaH.getAdminDataSecurityPolicyUrl)(environment, orgId || '')
        }), [
        spaceId,
        spaceKey,
        environment,
        orgId
    ]);
    const getEmpoweredUserSettingsLinkHref = (0, $42omo.useCallback)((publicLinkStatus)=>{
        if (accessLevel === 'space') return isSpaceAdmin ? adminUrls.spacePublicLinksTab : adminUrls.globalPublicLinksSpaceDetails;
        else if (accessLevel === 'site') switch(publicLinkStatus){
            case (0, $k030f.PublicLinkPageStatus).SITE_DISABLED:
            case (0, $k030f.PublicLinkPageStatus).SPACE_BLOCKED:
                return adminUrls.globalPublicLinksTab;
            case (0, $k030f.PublicLinkPageStatus).BLOCKED_BY_PRODUCT:
                return adminUrls.globalPublicLinksSpaceDetails;
        }
        else if (accessLevel === 'org') return isSiteAdmin ? adminUrls.adminHubDataSecurityPoliciesTab : adminUrls.globalPublicLinksSpaceDetails;
    }, [
        accessLevel,
        isSpaceAdmin,
        isSiteAdmin,
        adminUrls
    ]);
    return {
        isEmpowered: isEmpowered,
        empoweredUserSettingsLinkHref: getEmpoweredUserSettingsLinkHref(publicLinkStatus),
        accessLevel: accessLevel,
        isSpaceAdmin: isSpaceAdmin,
        isSiteAdmin: isSiteAdmin,
        error: error
    };
};
module.exports["usePublicLinkPrivilegeData"] = $ada79c8987c2ef5b$export$b9fbfaea37882ee;

});

parcelRegister("1yUaH", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $6330c4f1726ccfe6$export$13b14bbaaf4eab95 = (environment, orgId)=>environment === 'PRODUCTION' ? `https://admin.atlassian.com/o/${orgId}/data-security-policies` : `https://admin.stg.atlassian.com/o/${orgId}/data-security-policies`;
const $6330c4f1726ccfe6$export$7ff4c55b73be0f0d = (spaceId)=>spaceId ? `${(0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()}?tab=public-links&space=${spaceId}` : `${(0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()}?tab=public-links`;
const $6330c4f1726ccfe6$export$5cf3dc8353fd3d8b = ({ isSpaceBlockedByOrg: isSpaceBlockedByOrg, environment: environment, orgId: orgId })=>isSpaceBlockedByOrg ? $6330c4f1726ccfe6$export$13b14bbaaf4eab95(environment, orgId) : $6330c4f1726ccfe6$export$7ff4c55b73be0f0d();
module.exports["getAdminDataSecurityPolicyUrl"] = $6330c4f1726ccfe6$export$13b14bbaaf4eab95;
module.exports["getAdminGlobalPermsPublicLinksUrl"] = $6330c4f1726ccfe6$export$7ff4c55b73be0f0d;
module.exports["getPublicLinksSpaceSettingsBlockedStateUrl"] = $6330c4f1726ccfe6$export$5cf3dc8353fd3d8b;

});

parcelRegister("7EdWc", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $ep3mz = parcelRequire("ep3mz");


var $w033M = parcelRequire("w033M");


var $1JEqL = parcelRequire("1JEqL");


var $hC6vw = parcelRequire("hC6vw");

var $8766384911629fab$var$AccessLevelRequired = /*#__PURE__*/ function(AccessLevelRequired) {
    AccessLevelRequired["space"] = "space";
    AccessLevelRequired["org"] = "org";
    AccessLevelRequired["product"] = "product";
    return AccessLevelRequired;
}($8766384911629fab$var$AccessLevelRequired || {});
const $8766384911629fab$var$publicLinkStatusToAccessLevelRequiredMappings = {
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_SPACE]: "space",
    [(0, $hC6vw.PublicLinkPageStatus).SPACE_DISABLED]: "space",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_PRODUCT]: "product",
    [(0, $hC6vw.PublicLinkPageStatus).SITE_DISABLED]: "product",
    [(0, $hC6vw.PublicLinkPageStatus).SPACE_BLOCKED]: "product",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_ORG]: "org",
    [(0, $hC6vw.PublicLinkPageStatus).SITE_BLOCKED]: "org",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_CONTAINER_POLICY]: "org",
    [(0, $hC6vw.PublicLinkPageStatus).BLOCKED_BY_CLASSIFICATION_LEVEL]: "org"
};
const $8766384911629fab$var$getAccessLevelRequired = (publicLinkStatus)=>{
    if (!publicLinkStatus) return null;
    return $8766384911629fab$var$publicLinkStatusToAccessLevelRequiredMappings[publicLinkStatus] || null;
};
const $8766384911629fab$export$69022991fc7a5580 = ({ publicLinkStatus: publicLinkStatus, skip: skip })=>{
    // get admin level of current user, and derive their access level
    // get access level needed to unblock public link
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsPLEmpoweredUserPublicLinkUserAdminStatusQuery($key:String){user:confluence_atlassianUser(current:true){id confluence{operations{operation targetType}}}isSiteAdmin hasUserAccessAdminRole space(key:$key){currentUser{isAdmin}}}`, {
        variables: {
            key: spaceKey
        },
        skip: skip || !publicLinkStatus
    });
    if (skip || !publicLinkStatus) return {
        isEmpoweredUser: false
    };
    const isSpaceAdmin = Boolean(data?.space?.currentUser?.isAdmin);
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(data);
    const accessLevelRequired = $8766384911629fab$var$getAccessLevelRequired(publicLinkStatus);
    const isEmpoweredUserForAccessLevel = (accessLevelRequired)=>{
        // User is not blocked, is empowered automatically
        if (!accessLevelRequired) return true;
        // If user is site admin, they can make any needed changes
        if (accessLevelRequired === "org") return isSiteAdmin;
        return isProductOrSiteAdmin || // Otherwise, they can only fix it if it's a space access issue and they
        // are space admin
        accessLevelRequired === "space" && isSpaceAdmin;
    };
    return {
        isEmpoweredUser: isEmpoweredUserForAccessLevel(accessLevelRequired),
        isSpaceAdmin: isSpaceAdmin,
        isSiteAdmin: isSiteAdmin,
        error: error
    };
};
module.exports["useIsPLEmpoweredUser"] = $8766384911629fab$export$69022991fc7a5580;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("1JEqL", function(module, exports) {

var $eJhXX = parcelRequire("eJhXX");


var $icMDs = parcelRequire("icMDs");

function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}
module.exports["getIsProductOrSiteAdminFromQuery"] = $e18808c613ab8370$export$138f02318593ab4;

});

parcelRegister("eJhXX", function(module, exports) {

var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("hwEdY", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bb7acda33ff9212$export$2e2bcd8739ae039);

var $1LFpx = parcelRequire("1LFpx");



var $bGwCT = parcelRequire("bGwCT");



var $34HzT = parcelRequire("34HzT");

var $2bb7acda33ff9212$export$2e2bcd8739ae039 = (0, $34HzT.default);

});

parcelRegister("34HzT", function(module, exports) {
$parcel$export(module.exports, "default", () => $33eca9f889c5cce5$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $hQK66 = parcelRequire("hQK66");


var $9vcPV = parcelRequire("9vcPV");


var $6BEN7 = parcelRequire("6BEN7");


var $agy0l = parcelRequire("agy0l");


function $33eca9f889c5cce5$export$2e2bcd8739ae039(props) {
    const WrappedLoadable = (0, $hQK66.useMemoOne)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
            __loadable_id__: "UdouG",
            name: "platform.packages.growth.integrations.src.share-to-slack.ui.index",
            loader: ()=>(parcelRequire("8sCHa")),
            loading: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $agy0l.default), {})
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9vcPV.default), {
        onError: ()=>{
            (0, $6BEN7.failUfoExperience)((0, $6BEN7.UfoExperiences).SLACK_SEGMENT_RENDERED);
            (0, $6BEN7.failUfoExperience)((0, $6BEN7.UfoExperiences).SLACK_FORM_ENABLED);
        },
        channel: 'shareToSlack',
        data: {},
        children: /*#__PURE__*/ (0, $l998X.jsx)(WrappedLoadable, {
            ...props
        })
    });
}

});

parcelRegister("9vcPV", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $5kH4g = parcelRequire("5kH4g");

class $4ecfbba62430f741$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError) {
            if (ErrorComponent) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5kH4g.default), {
                data: data,
                children: /*#__PURE__*/ (0, $l998X.jsx)(ErrorComponent, {})
            });
            return null;
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5kH4g.default), {
            data: data,
            children: children
        });
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["default"] = $4ecfbba62430f741$export$2e2bcd8739ae039;

});

parcelRegister("agy0l", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a8c3e7da08fe2db$export$2e2bcd8739ae039);
/* Loading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $9hlns = parcelRequire("9hlns");

const $1a8c3e7da08fe2db$var$styles = {
    wrapper: "_1rjcv77o _18zr1ejb",
    innerWrapper: "_1tke1lze"
};
function $1a8c3e7da08fe2db$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "share-to-slack-loading",
        xcss: $1a8c3e7da08fe2db$var$styles.wrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            alignBlock: "center",
            alignInline: "center",
            xcss: $1a8c3e7da08fe2db$var$styles.innerWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                size: "large"
            })
        })
    });
}

});

parcelRegister("8sCHa", function(module, exports) {

let $628ef45281317155$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $628ef45281317155$var$load("7Q5vz"),
    $628ef45281317155$var$load("8JZKd"),
    $628ef45281317155$var$load("a0ogJ"),
    $628ef45281317155$var$load("6wr18"),
    $628ef45281317155$var$load("8LPnw"),
    $628ef45281317155$var$load("kHOMt"),
    $628ef45281317155$var$load("hhss7"),
    $628ef45281317155$var$load("ffEVr"),
    $628ef45281317155$var$load("k0hwN")
]).then(()=>parcelRequire('gxvVr'));

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cv8Bu = parcelRequire("cv8Bu");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $cv8Bu.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("cv8Bu", function(module, exports) {
/* theme-provider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $8z9j5 = parcelRequire("8z9j5");

var $hY0xh = parcelRequire("hY0xh");

var $bRSdj = parcelRequire("bRSdj");

var $60yhz = parcelRequire("60yhz");

const $d32a212d6e794c84$var$defaultThemeSettings = ()=>({
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    });
const $d32a212d6e794c84$var$ColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetColorModeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$ThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $d32a212d6e794c84$var$SetThemeContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined); /**
                                                                                                  * __UNSAFE_useColorModeForMigration()__
                                                                                                  *
                                                                                                  * Returns the current color mode when inside the app provider.
                                                                                                  * Unlike useColorMode, this utility returns undefined, instead of throwing an error, when the app provider is missing.
                                                                                                  * This allows it to be used by components that need to operate with and without an app provider.
                                                                                                  */ 
function $d32a212d6e794c84$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    return value;
}
function $d32a212d6e794c84$export$20f3076712c8dfa() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$ColorModeContext);
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $42omo.useState)(colorMode || 'light');
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $60yhz.default)((theme)=>{
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $d32a212d6e794c84$export$e2afe7397c3d11c7() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
} /**
   * __useTheme()__
   *
   * Returns the current theme settings when inside the app provider.
   */ 
function $d32a212d6e794c84$export$93d4e7f90805808f() {
    const theme = (0, $42omo.useContext)($d32a212d6e794c84$var$ThemeContext);
    const [resolvedTheme, setResolvedTheme] = (0, $42omo.useState)(theme || (0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        const observer = new (0, $60yhz.default)(setResolvedTheme);
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
} /**
   * __useSetTheme()__
   *
   * Returns the theme setter when inside the app provider.
   */ 
function $d32a212d6e794c84$export$501aa0dcd5527a48() {
    const value = (0, $42omo.useContext)($d32a212d6e794c84$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
const $d32a212d6e794c84$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $d32a212d6e794c84$var$prefersDarkModeMql = $d32a212d6e794c84$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined; // TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $d32a212d6e794c84$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $d32a212d6e794c84$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
    return colorMode;
}
const $d32a212d6e794c84$var$contentStyles = {
    body: "_1e0c1bgi"
};
function $d32a212d6e794c84$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode, defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $42omo.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $42omo.useState)($d32a212d6e794c84$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $42omo.useState)(()=>({
            ...$d32a212d6e794c84$var$defaultThemeSettings(),
            ...defaultTheme
        }));
    const setColorMode = (0, $42omo.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($d32a212d6e794c84$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $42omo.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // If fg enabled avoid mounting themes
        if ((0, $dh538.fg)('platform-static-theme-loading')) return;
        /**
    * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
    * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
    * `data-color-mode` attribute on the root element).
    *
    * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
    * applying the new theme.
    *
    * Without this, we can end up in the following scenario:
    * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
    * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
    * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
    * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
    */ const cleanupLastFnCall = async ()=>{
            if (lastSetGlobalThemePromiseRef.current) {
                const unbindFn = await lastSetGlobalThemePromiseRef.current;
                unbindFn();
                lastSetGlobalThemePromiseRef.current = null;
            }
        };
        const safelySetGlobalTheme = async ()=>{
            await cleanupLastFnCall();
            const promise = (0, $bRSdj.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
            lastSetGlobalThemePromiseRef.current = promise;
        };
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!$d32a212d6e794c84$var$prefersDarkModeMql) return;
        const unbindListener = (0, $fFa3V.bind)($d32a212d6e794c84$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = (0, $hY0xh.default)({
        ...theme,
        colorMode: reconciledColorMode
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ColorModeContext.Provider, {
        value: reconciledColorMode,
        children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetColorModeContext.Provider, {
            value: setColorMode,
            children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$ThemeContext.Provider, {
                value: theme,
                children: /*#__PURE__*/ (0, $l998X.jsx)($d32a212d6e794c84$var$SetThemeContext.Provider, {
                    value: setPartialTheme,
                    children: (0, $dh538.fg)('platform-static-theme-loading') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-theme": attrs['data-theme'],
                        "data-color-mode": attrs['data-color-mode'],
                        className: (0, $gMc0m.default)([
                            $d32a212d6e794c84$var$contentStyles.body
                        ]),
                        children: children
                    }) : children
                })
            })
        })
    });
}
var $d32a212d6e794c84$export$2e2bcd8739ae039 = $d32a212d6e794c84$var$ThemeProvider;
module.exports["UNSAFE_useColorModeForMigration"] = $d32a212d6e794c84$export$ce91654eb9fea460;

});

parcelRegister("5spQU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $jYbwE = parcelRequire("jYbwE");

Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $jYbwE.isEnvironmentBlockEnabled;
    }
});



Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $jYbwE.isFeatureEnabled;
    }
});

});

parcelRegister("jYbwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $5RB5d = parcelRequire("5RB5d");


var $bRppy = parcelRequire("bRppy");

/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $e89c8fa7bf5c28ec$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $e89c8fa7bf5c28ec$var$getBoundaryKey();
    return (0, $bRppy.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $e89c8fa7bf5c28ec$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @returns if the feature is available in the current cloud environment
 */ function $e89c8fa7bf5c28ec$var$isFeatureEnabled(environmentBlockName, featureName) {
    const boundaryKey = $e89c8fa7bf5c28ec$var$getBoundaryKey();
    return (0, $bRppy.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
}
module.exports.isFeatureEnabled = $e89c8fa7bf5c28ec$var$isFeatureEnabled;
function $e89c8fa7bf5c28ec$var$getBoundaryKey() {
    if ((0, $5RB5d.isFedrampModerate)()) return $bRppy.FED_MOD_KEY;
    if ((0, $5RB5d.isIsolatedCloud)()) return $bRppy.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $bRppy.COMMERCIAL_KEY;
}

});

parcelRegister("5RB5d", function(module, exports) {

var $9vFIg = parcelRequire("9vFIg");


var $iG8l7 = parcelRequire("iG8l7");

function $444eaaec2c4d71fe$export$9186ccba8effc5de() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $9vFIg.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $444eaaec2c4d71fe$export$104cb891a6e90b3a() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $9vFIg.FEDRAMP_MODERATE);
}
function $444eaaec2c4d71fe$export$80638ee198476daf() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $444eaaec2c4d71fe$export$839b022803d38d4d() {
    const atlCtxCookieValues = (0, $iG8l7.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
module.exports["isIsolatedCloud"] = $444eaaec2c4d71fe$export$9186ccba8effc5de;
module.exports["isFedrampModerate"] = $444eaaec2c4d71fe$export$104cb891a6e90b3a;

});

parcelRegister("9vFIg", function(module, exports) {
const $6ec75da0edf32757$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $6ec75da0edf32757$export$f005e2e9f707cb5f = 'commercial';
const $6ec75da0edf32757$export$a739cd5aac835909 = 'staging';
const $6ec75da0edf32757$export$42dd0cdd351a4a9 = 'prod';
const $6ec75da0edf32757$export$404582bc18fe4d9e = 'dev';
const $6ec75da0edf32757$export$d8347b4aae768c2d = [
    $6ec75da0edf32757$export$f005e2e9f707cb5f
];
const $6ec75da0edf32757$export$b1b1ccc8f3e7f954 = [
    $6ec75da0edf32757$export$f005e2e9f707cb5f,
    $6ec75da0edf32757$export$ce553301d55c2fd8
];
const $6ec75da0edf32757$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $6ec75da0edf32757$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $6ec75da0edf32757$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
module.exports["FEDRAMP_MODERATE"] = $6ec75da0edf32757$export$ce553301d55c2fd8;
module.exports["ISOLATED_CLOUD_PERIMETERS"] = $6ec75da0edf32757$export$d8347b4aae768c2d;
module.exports["ATL_CTX_PERIMETER"] = $6ec75da0edf32757$export$87285944378c596;
module.exports["ATL_CTX_ISOLATION_CONTEXT_DOMAIN"] = $6ec75da0edf32757$export$715603e81922c3ec;
module.exports["ATL_CTX_ISOLATION_CONTEXT_ID"] = $6ec75da0edf32757$export$a0ffa0598c95dfb7;

});

parcelRegister("iG8l7", function(module, exports) {

var $9vFIg = parcelRequire("9vFIg");

/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $d9929e543e364378$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $d9929e543e364378$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $d9929e543e364378$var$getRawCookieValue((0, $9vFIg.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}
module.exports["parseAtlCtxCookies"] = $d9929e543e364378$export$3fa7b7af96286cc9;

});

parcelRegister("bRppy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $bW2zJ = parcelRequire("bW2zJ");

Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $bW2zJ.isEnvironmentBlockEnabledForBoundary;
    }
});



Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $bW2zJ.isFeatureEnabledForBoundary;
    }
});

var $dAnKm = parcelRequire("dAnKm");

Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $dAnKm.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});

parcelRegister("bW2zJ", function(module, exports) {
"use strict";
var $8b071be3717020b1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $8b071be3717020b1$var$sdk_data_json_1 = $8b071be3717020b1$var$__importDefault((parcelRequire("leq11")));
const $8b071be3717020b1$var$aemEnvironmentBlockData = $8b071be3717020b1$var$sdk_data_json_1.default;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $8b071be3717020b1$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $8b071be3717020b1$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $8b071be3717020b1$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $8b071be3717020b1$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        return environmentBlockData.features[featureName]?.compositions[boundaryKey] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $8b071be3717020b1$var$isFeatureEnabledForBoundary;
function $8b071be3717020b1$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    return $8b071be3717020b1$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName]?.compositions[boundaryKey] === true;
}

});

parcelRegister("leq11", function(module, exports) {
module.exports = JSON.parse("{\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-actor-profiles\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-add-product\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-admin-insights\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-app-requests\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-app-updates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-audit-log\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-automatic-product-discovery\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-billing-console\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-brie\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-byok\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-content-scanning\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-custom-email-addresses\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-data-classifications\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-data-management\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-data-residency\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-discovered-apps\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-dlp-partner-integrations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-enforced-2-step-verification\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-enforced-data-security-policy-by-classification\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-experiment-controls\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-hippa-compliance\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-last-active-date\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-multiple-idps\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-org-deletion\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-product-recommendation\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-release-tracks\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-remediation-api\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-remediation-recommendations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-remediation-workflows\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-saml-sso\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-sandbox\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-self-service-product-acquisition\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-siem-integrations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-site-rename\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-third-party-contacts\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-url-subdomain-updates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-user-access-invites\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-access-settings\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-counts\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-impersonation\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"adminhub-user-provisioning\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"assets\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"assets-data-manager\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"assets-reports\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"atlassian-analytics\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"bitbucket\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"bitbucket-slack-app\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"pipelines\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"chat\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"compass\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"ccma\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-ai\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-company-hub\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-content-archiving\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-content-manager\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-databases\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-editing-experience\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-editor-offline-storage\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-employee-directory\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-loom-integration\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-mission-control\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-mobile-app\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-page-analytics\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-public-links\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-questions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-search\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-slack-integration\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-smart-links\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-space-analytics\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-team-calendars\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"confluence-whiteboards\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"customer-service-management\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"focus\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"goals\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"guard-standard\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"home\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"home-status-backend\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"jira\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"jcma\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-audit-log\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-backlogs\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-boards-and-views\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-calendar-view\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-components\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-forms\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-github-for-jira\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-github-workflows\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-in-product-help\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-insights\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-mobile-app\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jira-plans\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-project-archiving\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-project-templates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-releases\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-site-optimiser\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-slack\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-smart-links\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-team-managed-projects\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-workflow-configuration\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"jira-align\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"jira-service-management-help-center\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-ai-ops\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-ai-services\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-approvals\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-automation-playbook\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-canned-responses\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-change-calendar\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-change-risk-assessment\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-chat-ops\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-chat\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-csat\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-developer-escalations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-email-requests\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-forms\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-help-center\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-journey-builder\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-queues\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-related-issues\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-reports-operations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"jsm-services\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-sla-management\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-templates-and-views\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"opsgenie\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"loom\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"projects\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{\"rovo-ai-3p-connections\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-app-availability\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-projects\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"rovo-dev\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"statuspage\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"studio\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"talent\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"teams\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"trello\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"anti-abuse-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"application-tunnels\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"atlassian-visualization-platform-plato\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"collaboration-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"commerce-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"commerce-platform-self-serve\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"cross-product-search\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"customer-support-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"ecosystem-oauth\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"forge-cli\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge-system-apps\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"forge\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"experience-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"growth-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"identity\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"identity-virality\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"machine-learning-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"marketplace\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"migrations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"data-center-to-agc\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"migration-link-fixing\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}}}},\"migrations-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"post-office\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"product-integrations-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"reactions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"smartlinks\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"analytics-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"asset-readiness-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-graphql-gateway\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"atlassian-platform-deployer\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-branches\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"automation-platform-conditions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-templates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true}},\"automation-platform-triggers\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"aws-cloud-management\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"bifrost\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"build-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"core-network-automation\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"cross-gateway\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-access-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-classification-governance-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-depot-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-exchange-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{\"aqui\":{\"compositions\":{\"isolated-commercial-cloud-ga\":false,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":false}}}},\"data-management-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-movement-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-platform-services\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"data-telemetry-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"decisions-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"detection-and-response-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"edge\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"encryption-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"environment-management-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"eureka-streaming-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"job-execution-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"kitt-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"knowledge-graph\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"mail-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"media-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"networking\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"observability-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"resiliency-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"security-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"socrates\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"targeting-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"tdp-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"teamwork-graph-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"tenant-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"trusted-change-platform\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"vdi\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"isolated-commercial-cloud-ga\":true,\"commercial-cloud\":true,\"google-cloud-platform\":true,\"fedramp-moderate\":true},\"features\":{}}}}");

});

parcelRegister("dAnKm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-commercial-cloud-ga";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];

});

parcelRegister("hkzol", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $1bY7o = parcelRequire("1bY7o");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $cgtv4.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $8C5kA.default)();
    const cleanupCopiedTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $42omo.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $42omo.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $42omo.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    // urlOverride is a new prop and acts as a pseudo feature gate
    // This logic can eventually be moved to the main return
    if (urlOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return confirmationText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $kfIha = parcelRequire("kfIha");


var $hkzol = parcelRequire("hkzol");

const $68bb0af1984f782c$var$useCopyContentLinkCopyLinkQuery = (0, $eSUdr.default)`query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id links{editui webui tinyui base}}}`;
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $42omo.useState)();
    const { toUrl: toUrl } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $j1Ss3.useQuery)($68bb0af1984f782c$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip
    });
    const makeContentLink = (0, $42omo.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            // omit databases and other unsupported content types
            default:
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $42omo.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("jooGc", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $1P1Tu.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $9zUhf.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $9zUhf.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("bxB0V", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $42omo = parcelRequire("42omo");


const $e62143ad7e34aa24$export$c09847f3a2ea8c56 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vnIuw",
    name: "OnboardingNudge",
    loader: async ()=>(await (parcelRequire("41Jtg"))).OnboardingNudge,
    loading: ({ children: children, renderChildrenWhileLoading: renderChildrenWhileLoading })=>renderChildrenWhileLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children) : null
});
module.exports["OnboardingNudge"] = $e62143ad7e34aa24$export$c09847f3a2ea8c56;

});

parcelRegister("41Jtg", function(module, exports) {

let $2eea8703027b9e1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2eea8703027b9e1e$var$load("8bVS2"),
    $2eea8703027b9e1e$var$load("k9ktU")
]).then(()=>parcelRequire('iFaMg'));

});

parcelRegister("dwkNQ", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1KmJq = parcelRequire("1KmJq");


var $inPa6 = parcelRequire("inPa6");


var $8TTLA = parcelRequire("8TTLA");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $2Nwuj = parcelRequire("2Nwuj");


var $2Pg7f = parcelRequire("2Pg7f");


var $3hOY6 = parcelRequire("3hOY6");

var $2gD2K = parcelRequire("2gD2K");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $iquRY = parcelRequire("iquRY");


var $lsxnT = parcelRequire("lsxnT");


var $4adOe = parcelRequire("4adOe");

/**
 * @generated SignedSource<<5bfeae744e81088f6a2ce57e566c5895>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $1565541f45629689$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $1565541f45629689$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});



var $1chEN = parcelRequire("1chEN");










var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");





var $9Q2dU = parcelRequire("9Q2dU");


var $5tmwS = parcelRequire("5tmwS");


var $6B0jU = parcelRequire("6B0jU");


var $ZDq1z = parcelRequire("ZDq1z");


var $8jHAi = parcelRequire("8jHAi");


var $7hXDW = parcelRequire("7hXDW");


var $iKskQ = parcelRequire("iKskQ");




const $c3b447d238ca71b0$var$i18n = (0, $cgtv4.defineMessages)({
    needsAccess: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.needs-access",
        defaultMessage: "needs access in {resourcesCount} {resourcesCount, plural, one {place} other {places}}:"
    },
    space: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.space",
        defaultMessage: "Space"
    },
    parentItems: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.parent-items",
        defaultMessage: "Parent items"
    }
});
const $c3b447d238ca71b0$var$getContenTypeIcon = (type)=>{
    switch(type){
        case (0, $1chEN.ResourceType).DATABASE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
                label: "Databse"
            });
        case (0, $1chEN.ResourceType).WHITEBOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                label: "Whiteboard"
            });
        case (0, $1chEN.ResourceType).PAGE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                label: "Page"
            });
        case (0, $1chEN.ResourceType).FOLDER:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                label: "Page"
            });
        case (0, $1chEN.ResourceType).SPACE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
                size: "xsmall",
                src: "/images/logo/default-space-logo-256.png"
            });
    }
};
const $c3b447d238ca71b0$var$SingleResourcesDetails = ({ restrictedResource: restrictedResource, showLock: showLock })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, showLock ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }) : null, restrictedResource && $c3b447d238ca71b0$var$getContenTypeIcon(restrictedResource.resourceType), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, restrictedResource ? restrictedResource.resourceTitle : ''));
};
const $c3b447d238ca71b0$export$c6de5a3e56b68494 = ({ user: user, restrictedResources: restrictedResources })=>{
    const resourcesWithoutSpace = restrictedResources && restrictedResources.filter((resource)=>{
        if (resource?.resourceType == (0, $1chEN.ResourceType).SPACE) return false;
        return true;
    });
    const restrictedSpaces = restrictedResources && restrictedResources.filter((resource)=>{
        if (resource?.resourceType == (0, $1chEN.ResourceType).SPACE) return true;
        return false;
    });
    const resourcesWithoutSpaceCount = resourcesWithoutSpace ? resourcesWithoutSpace.length : 0;
    const restrictedSpacesCount = restrictedSpaces ? restrictedSpaces.length : 0;
    const resourcesCount = resourcesWithoutSpaceCount + restrictedSpacesCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: user && user.avatarUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text",
        weight: "bold"
    }, user && user.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        values: {
            resourcesCount: resourcesCount
        },
        ...$c3b447d238ca71b0$var$i18n.needsAccess
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingInlineStart: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        alignBlock: "center"
    }, restrictedSpaces && restrictedSpaces.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c3b447d238ca71b0$var$i18n.space)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingInlineStart: "space.150"
    }, restrictedSpaces.map((resource)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
            restrictedResource: resource,
            showLock: false,
            key: resource?.resourceId
        })))) : null, resourcesWithoutSpace && resourcesWithoutSpace.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7hXDW.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c3b447d238ca71b0$var$i18n.parentItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        paddingInlineStart: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200",
        alignBlock: "center"
    }, resourcesWithoutSpace.map((resource)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
            restrictedResource: resource,
            showLock: true,
            key: resource?.resourceId
        }))))) : null)));
};



var $86H8K = parcelRequire("86H8K");

const $a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation = (0, $eSUdr.default)`mutation ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!$contentId:Long!$subjects:[BlockedAccessSubjectInput]!$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType contentId:$contentId subjects:$subjects spaceRoleId:$spaceRoleId}){success errors{message}}}`;
const $a159289724029162$var$i18n = (0, $cgtv4.defineMessages)({
    headingSingleUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.single-user",
        defaultMessage: "Someone needs additional access"
    },
    headingMultiUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.multi-user",
        defaultMessage: "Some people need additional access"
    },
    parentAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    parentAccessRolesRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.roles-update.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access."
    },
    spaceAccessViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view and edit permissions only. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.roles-update.body",
        defaultMessage: "They need edit access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully edit <bold>{pageTitle}</bold>."
    },
    spaceAccessViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.roles-update.body",
        defaultMessage: "They need view access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>."
    },
    spaceAccessRoleSelectionForViewAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-view-access.body",
        defaultMessage: "<bold>Role</bold>"
    },
    spaceAccessRoleSelectionForEditAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-edit-access.body",
        defaultMessage: "<bold>Roles that allow editing</bold>"
    },
    skipButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.skip-button",
        defaultMessage: "Skip for now"
    },
    addToParentButton: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.add-to-parent-button",
        defaultMessage: "Add to parent"
    },
    addToSpaceButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.add-to-space-button",
        defaultMessage: "Add to space"
    },
    addToAllButton: {
        id: "share-and-restrict-dialog.resolve-restriction.add-to-all-button",
        defaultMessage: "Add to all"
    },
    multiUserSpaceViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with edit access at the space level only. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserSpaceViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserParentViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserParentViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. They\u2019ll be added to any parent items with view-only access."
    },
    multiUserViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs to be granted view access in other places first before they can successfully view <bold>{pageTitle}</bold>. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserViewSpaceIncludedRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.space-included.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    usersNameList: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.single-restriction.body",
        defaultMessage: "{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}"
    },
    errorFlagTitle: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.title",
        defaultMessage: "Can\u2019t add guests"
    },
    errorFlagBodyDescription: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.body",
        defaultMessage: "One or more guests can\u2019t be added to the space because they have access to another space already. Guests can only access one space at a time."
    }
});
const $a159289724029162$var$collaboratorSystemRoleId = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $a159289724029162$var$selectStyle = (0, $ecnYn.xcss)({
    width: '150px'
});
const $a159289724029162$var$menuItemStyle = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $a159289724029162$export$51715d98ed95f9db = (restrictedPrincipals = [])=>{
    const hasSpaceRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
    const hasParentRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType !== (0, $1chEN.ResourceType).SPACE));
    if (hasSpaceRestriction && hasParentRestriction) return 'space-and-parent';
    else if (hasSpaceRestriction) return 'space';
    else return 'parent';
};
const $a159289724029162$var$hasSpaceRestriction = (restrictedPrincipals = [])=>{
    return restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
};
const $a159289724029162$var$mapSpaceRoleToOption = (role)=>({
        id: role.roleId,
        label: role.roleName,
        value: role.roleId,
        description: role.roleDescription
    });
const $a159289724029162$export$b8299340c4128c03 = ({ restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection, pageTitle: pageTitle, contentId: contentId, addMode: addMode, onComplete: onComplete, onClose: onClose, onCloseComplete: onCloseComplete, onSkip: onSkip, showErrorFlag: showErrorFlag, triggeredBy: triggeredBy })=>{
    const intl = (0, $8C5kA.default)();
    const focusRef = (0, $42omo.useRef)(null);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const roleOptions = assignableSpaceRolesIntersection?.map($a159289724029162$var$mapSpaceRoleToOption) || [];
    const [selectedRole, setSelectedRole] = (0, $42omo.useState)(()=>{
        // Try to find the collaborator role as the default selection
        const collaboratorRole = roleOptions.find((role)=>role.id === $a159289724029162$var$collaboratorSystemRoleId);
        if (collaboratorRole) return collaboratorRole;
        // Otherwise use the first option
        return roleOptions[0] || null;
    });
    const onCloseButtonClick = ()=>{
        onSkip();
        onClose?.();
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const usersCount = restrictedUserPrincipals ? restrictedUserPrincipals.length : 0;
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'ResolveRestrictionsDialog',
                attributes: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    triggeredBy: triggeredBy
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        triggeredBy
    ]);
    const blockedAccessSubjects = restrictedUserPrincipals?.map((user)=>{
        const blockedAccessSubject = {
            subjectId: user?.userPrincipal?.id || '',
            subjectType: (0, $1565541f45629689$export$43eb1e191ddb78c0).USER
        };
        return blockedAccessSubject;
    });
    const [resolveRestrictionsForSubjectsMutation] = (0, $1KmJq.useMutation)($a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation, {
        onCompleted: (data)=>{
            if (data?.resolveRestrictionsForSubjects?.success) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: 'success',
                        actionSubject: 'resolveRestrictionsForSubjects',
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                onComplete();
                onClose?.();
            } else {
                const errors = data?.resolveRestrictionsForSubjects?.errors;
                const isGuestError = errors?.some((error)=>error.message === 'ExcoSingleSpaceException: Failed to save permission for guest: guest already has access to another space');
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: 'failure',
                        actionSubject: 'resolveRestrictionsForSubjects',
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            errors: errors,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                if (isGuestError) {
                    // There's an edge case when resolving guest restrictions that causes an error.
                    // This is a quick fix to alert the user about the issue.
                    // We plan to improve this experience in the future.
                    //https://product-fabric.atlassian.net/browse/USD-633
                    showErrorFlag({
                        title: intl.formatMessage($a159289724029162$var$i18n.errorFlagTitle),
                        description: intl.formatMessage($a159289724029162$var$i18n.errorFlagBodyDescription),
                        isAutoDismiss: true
                    });
                    onSkip(isGuestError);
                    onClose?.();
                }
            }
        },
        onError: (error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: 'errored',
                    actionSubject: 'resolveRestrictionsForSubjects',
                    attributes: {
                        message: error?.message,
                        name: error?.name,
                        stack: error?.stack,
                        cause: error?.cause,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            setIsLoading(false);
        //TODO Ashima: show error flag after confirming with UX
        }
    });
    const handleAdd = ()=>{
        setIsLoading(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AddResolveRestrictions',
                attributes: {
                    blockedUsersCount: usersCount,
                    blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                    contentType: contentType,
                    triggeredBy: triggeredBy
                }
            }
        }).fire();
        resolveRestrictionsForSubjectsMutation({
            variables: {
                contentId: contentId,
                accessType: addMode == 'as-editor' ? (0, $1565541f45629689$export$8e7b7bb509dc942b).EDIT : (0, $1565541f45629689$export$8e7b7bb509dc942b).VIEW,
                subjects: blockedAccessSubjects || [],
                spaceRoleId: selectedRole?.value || null
            }
        });
    };
    const handleSkip = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'SkipResolveRestrictions',
                attributes: {
                    blockedUsersCount: usersCount,
                    blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                    contentType: contentType,
                    triggeredBy: triggeredBy
                }
            }
        }).fire();
        onSkip();
        onClose?.();
    };
    if (usersCount < 1) return null;
    const isSingleUserAndSingleRestriction = restrictedUserPrincipals?.length == 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1;
    const firstRestriction = restrictedUserPrincipals && restrictedUserPrincipals?.length > 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1 && restrictedUserPrincipals[0].restrictedResources[0];
    const isMultiUserSingleRestriction = !isSingleUserAndSingleRestriction && restrictedUserPrincipals?.every((obj)=>{
        if (obj?.restrictedResources?.length == 1) {
            if (firstRestriction && obj?.restrictedResources[0]?.resourceId == firstRestriction?.resourceId) return true;
        }
        return false;
    });
    const renderSpaceRoleSelector = ()=>{
        if (!isRbacEnabled || !$a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals)) return null;
        const roleSelectionBody = addMode === 'as-viewer' ? $a159289724029162$var$i18n.spaceAccessRoleSelectionForViewAccessBody : $a159289724029162$var$i18n.spaceAccessRoleSelectionForEditAccessBody;
        const SELECT_STYLE_PROPS = {
            isSearchable: false,
            menuPortalTarget: document.body,
            styles: {
                menu: (base)=>({
                        ...base,
                        width: '320px'
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 600
                    })
            }
        };
        const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).SingleValue, props, props.data.label));
        const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $a159289724029162$var$menuItemStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, props.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.subtlest"
            }, props.data.description))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text",
            testId: "selectRoleText"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: {
                bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks)
            },
            ...roleSelectionBody
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a159289724029162$var$selectStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2gD2K.default), {
            options: roleOptions,
            value: selectedRole,
            onChange: (option)=>setSelectedRole(option),
            components: {
                SingleValue: CustomSingleValue,
                Option: CustomOption
            },
            ...SELECT_STYLE_PROPS
        })));
    };
    if (isSingleUserAndSingleRestriction) {
        const singleUserPrincipal = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal;
        const singleRestrictedResource = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].restrictedResources && restrictedUserPrincipals[0].restrictedResources[0];
        let resourceUrl = (singleRestrictedResource && singleRestrictedResource.resourceLink.base || '') + (singleRestrictedResource && singleRestrictedResource.resourceLink.webUi || '');
        if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl)) resourceUrl += '?referrer=share-and-restrict-dialog';
        const resourceTitle = singleRestrictedResource && singleRestrictedResource.resourceTitle;
        const spaceAccessViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const parentAccessBody = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const editorMessage = addMode === 'as-editor' ? spaceAccessViewAndEdit : spaceAccessView;
        const singleUserBodyMessageId = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? editorMessage : parentAccessBody;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            width: "500px",
            autoFocus: focusRef,
            onClose: onClose,
            onCloseComplete: onCloseComplete,
            testId: "modal-dialog-resolve-restrictions"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.headingSingleUser)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            onClick: onCloseButtonClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: singleUserPrincipal && singleUserPrincipal.avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text"
        }, singleUserPrincipal && singleUserPrincipal.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: {
                pageTitle: pageTitle,
                resourceTitle: resourceTitle,
                resourceLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        target: "_blank",
                        href: resourceUrl
                    }, chunks),
                bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            },
            ...singleUserBodyMessageId
        }), renderSpaceRoleSelector())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: handleSkip,
            isDisabled: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.skipButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleAdd,
            ref: focusRef,
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton))));
    } else if (isMultiUserSingleRestriction) {
        const avatarGroupData = restrictedUserPrincipals ? restrictedUserPrincipals.map((user)=>({
                key: user?.userPrincipal?.email || '',
                name: user?.userPrincipal?.name || '',
                href: '#',
                src: user?.userPrincipal?.avatarUrl || ''
            })) : [];
        let resourceUrl = (firstRestriction && firstRestriction.resourceLink.base || '') + (firstRestriction && firstRestriction.resourceLink.webUi || '');
        if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl)) resourceUrl += '?referrer=share-and-restrict-dialog';
        const spaceAccessViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const i18nSpaceAccess = addMode === 'as-editor' ? spaceAccessViewAndEdit : spaceAccessView;
        const parentAccessBody = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const multiUserSingleRestrictionBodyMessageId = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? i18nSpaceAccess : parentAccessBody;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            width: "500px",
            autoFocus: focusRef,
            onClose: onClose,
            onCloseComplete: onCloseComplete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.headingMultiUser)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            onClick: onCloseButtonClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
            appearance: "stack",
            data: avatarGroupData,
            maxCount: 4
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$a159289724029162$var$i18n.usersNameList,
            values: {
                usersCount: usersCount,
                firstUser: restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null,
                secondUser: restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null,
                thirdUser: restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null,
                fourthUser: restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null,
                remainingUserCount: usersCount - 3
            }
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            values: {
                pageTitle: pageTitle,
                resourceTitle: firstRestriction && firstRestriction.resourceTitle,
                resourceLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                        target: "_blank",
                        href: resourceUrl
                    }, chunks),
                bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, chunks),
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            },
            ...multiUserSingleRestrictionBodyMessageId
        }), renderSpaceRoleSelector())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: handleSkip,
            isDisabled: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.skipButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleAdd,
            ref: focusRef,
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton))));
    } else {
        const hasSpaceRestricted = $a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals);
        const multiUserSpaceViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.multiUserSpaceViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserSpaceViewAndEditBody;
        const multiUserParentViewAndEditBody = isRbacEnabled ? $a159289724029162$var$i18n.multiUserParentViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserParentViewAndEditBody;
        const multiUserViewAndEditI18n = hasSpaceRestricted ? multiUserSpaceViewAndEdit : multiUserParentViewAndEditBody;
        const multiUserViewRolesUpdateBody = hasSpaceRestricted ? $a159289724029162$var$i18n.multiUserViewSpaceIncludedRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewRolesUpdateBody;
        const multiUserViewBody = isRbacEnabled ? multiUserViewRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewBody;
        const multiUsersBodyMessageId = addMode === 'as-editor' ? multiUserViewAndEditI18n : multiUserViewBody;
        const isSingleUser = restrictedUserPrincipals?.length === 1;
        const modalHeight = isSingleUser ? 'inherit' : '600px';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            width: "500px",
            height: modalHeight,
            autoFocus: focusRef,
            onClose: onClose,
            onCloseComplete: onCloseComplete
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.headingSingleUser)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            onClick: onCloseButtonClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...multiUsersBodyMessageId,
            values: {
                usersCount: usersCount,
                firstUser: restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null,
                secondUser: restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null,
                thirdUser: restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null,
                fourthUser: restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null,
                remainingUserCount: usersCount - 3,
                pageTitle: pageTitle,
                bold: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                        weight: "bold"
                    }, chunk),
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            }
        }))), renderSpaceRoleSelector(), restrictedUserPrincipals && restrictedUserPrincipals.map((user)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.050",
                key: user.userPrincipal?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
                role: "presentation",
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    width: '100%'
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                key: user.userPrincipal?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c3b447d238ca71b0$export$c6de5a3e56b68494), {
                user: user.userPrincipal,
                restrictedResources: user.restrictedResources
            })));
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "subtle",
            onClick: handleSkip,
            isDisabled: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.skipButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleAdd,
            ref: focusRef,
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a159289724029162$var$i18n.addToAllButton))));
    }
};
module.exports["ResolveRestrictionsDialog"] = $a159289724029162$export$b8299340c4128c03;

});

parcelRegister("iquRY", function(module, exports) {

var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        variables: {
            cloudId: cloudId
        },
        onError: (error)=>{
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== 'PRE_ROLES' : false;
    return {
        spaceRoleMode: data?.confluence_spaceRoleMode,
        isRbacEnabled: isNotPreRoles,
        loading: loading
    };
};
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<fca40edcd431a6c5f3bb28df1ad0109c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("1chEN", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $597ccb3a2cb4013d$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $597ccb3a2cb4013d$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
var $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["DATABASE"] = "DATABASE";
    ResourceType["FOLDER"] = "FOLDER";
    ResourceType["PAGE"] = "PAGE";
    ResourceType["SPACE"] = "SPACE";
    ResourceType["WHITEBOARD"] = "WHITEBOARD";
    return ResourceType;
}({});
var $597ccb3a2cb4013d$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["BlockedAccessSubjectType"] = $597ccb3a2cb4013d$export$43eb1e191ddb78c0;
module.exports["ResourceAccessType"] = $597ccb3a2cb4013d$export$8e7b7bb509dc942b;
module.exports["ResourceType"] = $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb;

});

parcelRegister("iKskQ", function(module, exports) {
/* SpaceIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $buthI = parcelRequire("buthI");


var $4wwVl = parcelRequire("4wwVl");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $42omo.memo)(({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $42omo.useState)(!src);
    const setLoaded = (0, $42omo.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("3hlsb", function(module, exports) {

var $6O3OC = parcelRequire("6O3OC");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7QoAs = parcelRequire("7QoAs");


var $f2UnK = parcelRequire("f2UnK");

const $d45f9e9292e71caa$export$31a6fc2aeeeb8b81 = (setMasterState, refetchQueries, additionalStateUpdates)=>{
    return async ()=>{
        try {
            await refetchQueries();
            setMasterState((s)=>({
                    ...s,
                    isSaving: false,
                    sessionState: 'shareAndRestrict',
                    ...additionalStateUpdates
                }));
        } catch (error) {
        //TODO add experience handling here https://product-fabric.atlassian.net/browse/CCPERMS-4897
        }
    };
};



var $fec5t = parcelRequire("fec5t");


var $lTbRO = parcelRequire("lTbRO");

/**
 * Adds principals to the principal map and stages them in the staged addition list.
 * The staged addition list holds principal that will be processed when the CTA is clicked.
 *
 * This callback is currently used for:
 * - Updating the principal stager list
 * - Handling dropdown changes for permissions
 */ function $c55d965f1ec8fe6e$var$addPrincipals({ principalsStagerPrincipals: principalsStagerPrincipals, addMode: addMode, queriesState: queriesState, setMasterState: setMasterState }) {
    const currentUser = queriesState.currentUser;
    // Note that this will not work with multiple pages and we will need a state for table principals
    const currentUserIsNotInBaseQuery = !queriesState.contentRestrictions.principals.some(({ principal: principal })=>principal.id === currentUser.id);
    // Add the staged principals, one at a time, such that the first will end
    // up on top
    for (const platformPrincipal of [
        ...principalsStagerPrincipals
    ].reverse()){
        if (platformPrincipal.type === 'email' || platformPrincipal.type === 'external_user') continue;
        const principal = (0, $fec5t.convertUserPickerPrincipal)(platformPrincipal);
        const isCurrentUser = principal.id === currentUser.id;
        if (!isCurrentUser) (0, $fec5t.stagePrincipalAddition)(setMasterState, principal, addMode);
        else // If current user is not gaining initial access, don't allow them to demote themselves
        currentUserIsNotInBaseQuery && (0, $fec5t.stagePrincipalAddition)(setMasterState, principal, addMode);
    }
    // Remove any staged additions not present in the updated principals list
    (0, $fec5t.filterStagedAdditionsByPrincipals)(setMasterState, principalsStagerPrincipals);
    // Update the staged principals list
    setMasterState((s)=>({
            ...s,
            principalsStagerPrincipals: principalsStagerPrincipals.map((principal)=>{
                if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (0, $6O3OC.isEmail)(principal) && principal.isPendingAction === undefined && (0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate') && (0, $6mKj3.expValEquals)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation')) return {
                    ...principal,
                    isPendingAction: true
                };
                return principal;
            })
        }));
}
function $c55d965f1ec8fe6e$var$createApplyGeneralAccessMutation({ controllerProps: controllerProps, controllerExtras: controllerExtras, stateContext: { masterState: masterState, derivedState: derivedState, queriesState: queriesState }, handlers: { setMasterState: setMasterState, dispatchCtaFlowEvent: dispatchCtaFlowEvent, refetchQueries: refetchQueries }, liveGeneralAccessLevel: liveGeneralAccessLevel }) {
    return ()=>{
        const { contentId: contentId, contentType: contentType, contentSubType: contentSubType } = controllerProps;
        const { addMode: addMode, optionalMessage: optionalMessage, shouldResolveMismatchedRestrictions: shouldResolveMismatchedRestrictions } = masterState;
        const { edition: edition, numberOfAncestors: numberOfAncestors, userCanEditRestrictions: userCanEditRestrictions } = queriesState;
        const { mutateContentRestrictions: mutateContentRestrictions, sendNotification: sendNotification, successFlag: successFlag, errorFlag: errorFlag, fireAnalyticEvent: fireAnalyticEvent, experienceTracker: experienceTracker, callResolveMismatchedRestrictions: callResolveMismatchedRestrictions } = controllerExtras;
        const refreshDialogState = (0, $d45f9e9292e71caa$export$31a6fc2aeeeb8b81)(setMasterState, refetchQueries);
        const updatedPrincipalMap = (0, $lTbRO.makePrincipalsMap)(masterState, queriesState, {
            isCtaClick: true,
            stagedGeneralAccessLevel: liveGeneralAccessLevel
        });
        dispatchCtaFlowEvent({
            contentId: contentId,
            edition: edition,
            numberOfAncestors: numberOfAncestors,
            type: 'cta',
            addMode: addMode,
            mutateContentRestrictions: mutateContentRestrictions,
            currentUser: queriesState.currentUser,
            sendNotification: sendNotification,
            successFlag: successFlag,
            errorFlag: errorFlag,
            beginTeardown: ()=>{},
            isMutatingAction: true,
            isNotifyingAction: false,
            userCanEditRestrictions: userCanEditRestrictions,
            stagedGeneralAccessLevel: liveGeneralAccessLevel,
            principalsMap: updatedPrincipalMap,
            optionalMessage: optionalMessage,
            principalsStagerPrincipals: masterState.principalsStagerPrincipals,
            stagedNotificationRecipients: [],
            validateRestrictedPrincipals: $7QoAs.validateRestrictedPrincipals,
            experienceTracker: experienceTracker,
            fireAnalyticEvent: fireAnalyticEvent,
            contentSubType: contentSubType,
            contentType: contentType,
            callResolveMismatchedRestrictions: callResolveMismatchedRestrictions,
            isResolvingAction: shouldResolveMismatchedRestrictions,
            isUnpublishedDraft: controllerProps.isUnpublishedDraft,
            includeInvites: derivedState.includeInvites,
            refreshDialogState: refreshDialogState
        });
    };
}
function $c55d965f1ec8fe6e$var$createApplyRemoveAllMutation({ controllerProps: controllerProps, controllerExtras: controllerExtras, stateContext: { masterState: masterState, derivedState: derivedState, queriesState: queriesState }, handlers: { setMasterState: setMasterState, dispatchCtaFlowEvent: dispatchCtaFlowEvent, refetchQueries: refetchQueries } }) {
    return ()=>{
        const { contentId: contentId, contentType: contentType, contentSubType: contentSubType } = controllerProps;
        const { addMode: addMode, optionalMessage: optionalMessage, shouldResolveMismatchedRestrictions: shouldResolveMismatchedRestrictions } = masterState;
        const { edition: edition, numberOfAncestors: numberOfAncestors, userCanEditRestrictions: userCanEditRestrictions } = queriesState;
        const { stagedGeneralAccessLevel: stagedGeneralAccessLevel } = derivedState;
        const { mutateContentRestrictions: mutateContentRestrictions, sendNotification: sendNotification, successFlag: successFlag, errorFlag: errorFlag, fireAnalyticEvent: fireAnalyticEvent, experienceTracker: experienceTracker, callResolveMismatchedRestrictions: callResolveMismatchedRestrictions } = controllerExtras;
        const refreshDialogState = (0, $d45f9e9292e71caa$export$31a6fc2aeeeb8b81)(setMasterState, refetchQueries);
        const updatedPrincipalMap = (0, $lTbRO.makePrincipalsMap)(masterState, queriesState, {
            isCtaClick: false,
            stagedGeneralAccessLevel: stagedGeneralAccessLevel
        });
        dispatchCtaFlowEvent({
            contentId: contentId,
            edition: edition,
            numberOfAncestors: numberOfAncestors,
            type: 'cta',
            addMode: addMode,
            mutateContentRestrictions: mutateContentRestrictions,
            currentUser: queriesState.currentUser,
            sendNotification: sendNotification,
            successFlag: successFlag,
            errorFlag: errorFlag,
            beginTeardown: ()=>{},
            isMutatingAction: true,
            isNotifyingAction: false,
            userCanEditRestrictions: userCanEditRestrictions,
            stagedGeneralAccessLevel: stagedGeneralAccessLevel,
            principalsMap: updatedPrincipalMap,
            optionalMessage: optionalMessage,
            principalsStagerPrincipals: masterState.principalsStagerPrincipals,
            stagedNotificationRecipients: [],
            validateRestrictedPrincipals: $7QoAs.validateRestrictedPrincipals,
            experienceTracker: experienceTracker,
            fireAnalyticEvent: fireAnalyticEvent,
            contentSubType: contentSubType,
            contentType: contentType,
            callResolveMismatchedRestrictions: callResolveMismatchedRestrictions,
            isResolvingAction: shouldResolveMismatchedRestrictions,
            isUnpublishedDraft: controllerProps.isUnpublishedDraft,
            includeInvites: derivedState.includeInvites,
            refreshDialogState: refreshDialogState
        });
    };
}
function $c55d965f1ec8fe6e$export$fe3955935f564b31(controllerProps, controllerExtras, masterState, derivedState, queriesState, setMasterState, dispatchCtaFlowEvent, refetchQueries) {
    const applyGeneralAccessMutation = (liveGeneralAccessLevel)=>$c55d965f1ec8fe6e$var$createApplyGeneralAccessMutation({
            controllerProps: controllerProps,
            controllerExtras: controllerExtras,
            stateContext: {
                masterState: masterState,
                derivedState: derivedState,
                queriesState: queriesState
            },
            handlers: {
                setMasterState: setMasterState,
                dispatchCtaFlowEvent: dispatchCtaFlowEvent,
                refetchQueries: refetchQueries
            },
            liveGeneralAccessLevel: liveGeneralAccessLevel
        });
    const applyRemoveAllMutation = (latestMasterState)=>$c55d965f1ec8fe6e$var$createApplyRemoveAllMutation({
            controllerProps: controllerProps,
            controllerExtras: controllerExtras,
            stateContext: {
                masterState: latestMasterState,
                derivedState: derivedState,
                queriesState: queriesState
            },
            handlers: {
                setMasterState: setMasterState,
                dispatchCtaFlowEvent: dispatchCtaFlowEvent,
                refetchQueries: refetchQueries
            }
        })();
    return {
        dismiss () {
            // TODO: if we're in the middle of saving, we should probably ignore this
            // request. Check with designers.
            const { isChanged: isChanged } = derivedState;
            const { principalsStagerPrincipals: principalsStagerPrincipals } = masterState;
            if (isChanged || principalsStagerPrincipals.length > 0) setMasterState((s)=>({
                    ...s,
                    isCloseConfirmationOpen: true
                }));
            else {
                controllerExtras.teardownController.tearDownAfterPotentialFinalDialogCompletesClose();
                setMasterState((s)=>({
                        ...s,
                        sessionState: 'exiting'
                    }));
            }
        },
        dismissCloseConfirmationDialog () {
            setMasterState((s)=>({
                    ...s,
                    isCloseConfirmationOpen: false
                }));
        },
        potentialFinalDialogDidCompleteClose () {
            controllerExtras.teardownController.potentialFinalDialogDidCompleteClose();
        },
        closeWithoutSaving () {
            controllerExtras.teardownController.tearDownAfterPotentialFinalDialogCompletesClose();
            setMasterState((s)=>({
                    ...s,
                    isCloseConfirmationOpen: false,
                    sessionState: 'exiting',
                    hasAccessRequestsChanges: false
                }));
        },
        changeGeneralAccessOpenRestricted (becomeRestricted) {
            const { isUnpublishedDraft: isUnpublishedDraft } = controllerProps;
            const { stagedGeneralAccessLevel: stagedGeneralAccessLevel, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails } = derivedState;
            const { principalsStagerPrincipals: principalsStagerPrincipals } = masterState;
            const openLevelToSet = isUnpublishedDraft || shouldShowDeletedGroupDetails ? 'open-can-edit' : 'open-can-view';
            /** This is when the user changes general access to open to "clear" deleted group's restrictions on page.
			 * We need to communicate to the singleContent query that hasRestrictions now needs to be false, we set a value in the master state
			 * called shouldResolveMismatchedRestrictions to true which decides that the unlockIcon now needs to be shown, and fires off updateRestrictions in the
			 * flow controller later on.
			 */ if (shouldShowDeletedGroupDetails) //check that user picker list is empty, otherwise proceed as usual
            {
                if (principalsStagerPrincipals.length === 0) {
                    setMasterState((s)=>({
                            ...s,
                            generalAccessDelta: 'open-can-edit',
                            shouldResolveMismatchedRestrictions: true
                        }));
                    if ((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) applyGeneralAccessMutation(becomeRestricted ? 'restricted' : openLevelToSet)();
                    return;
                }
            }
            // If the general access level did not change, don't do anything
            if (becomeRestricted && stagedGeneralAccessLevel === 'restricted' || !shouldShowDeletedGroupDetails && !becomeRestricted && (stagedGeneralAccessLevel === 'open-can-view' || stagedGeneralAccessLevel === 'open-can-edit')) return;
            setMasterState((s)=>({
                    ...s,
                    generalAccessDelta: becomeRestricted ? 'restricted' : openLevelToSet
                }));
            if ((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) applyGeneralAccessMutation(becomeRestricted ? 'restricted' : openLevelToSet)();
        },
        changeGeneralAccessCanViewCanEdit (becomeCanEdit) {
            const { stagedGeneralAccessLevel: stagedGeneralAccessLevel } = derivedState;
            // If the general access level did not change, don't do anything
            if (becomeCanEdit && stagedGeneralAccessLevel === 'open-can-edit' || !becomeCanEdit && stagedGeneralAccessLevel === 'open-can-view') return;
            setMasterState((s)=>({
                    ...s,
                    generalAccessDelta: becomeCanEdit ? 'open-can-edit' : 'open-can-view'
                }));
            if ((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) applyGeneralAccessMutation(becomeCanEdit ? 'open-can-edit' : 'open-can-view')();
        },
        changeStagedPrincipals (principalsStagerPrincipals) {
            $c55d965f1ec8fe6e$var$addPrincipals({
                principalsStagerPrincipals: principalsStagerPrincipals,
                queriesState: queriesState,
                setMasterState: setMasterState
            });
        },
        changeAddMode (addMode, principalsStagerPrincipals) {
            $c55d965f1ec8fe6e$var$addPrincipals({
                principalsStagerPrincipals: principalsStagerPrincipals,
                addMode: addMode,
                queriesState: queriesState,
                setMasterState: setMasterState
            });
        },
        changeSpecificAccessRole (role, id) {
            (0, $fec5t.stagePrincipalReassignment)(setMasterState, role, id);
        },
        removeSpecificAccessPrincipal (id) {
            (0, $fec5t.stagePrincipalRemoval)(setMasterState, id);
        },
        removeAllSpecificAccessPrincipals () {
            setMasterState((s)=>{
                const nextUpdatedState = {
                    ...s,
                    specificAccessDelta: {
                        ...s.specificAccessDelta,
                        removeAll: true,
                        removals: new Set(),
                        reassignments: new Map()
                    },
                    isSpecificAccessExpanded: false
                };
                if ((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) applyRemoveAllMutation(nextUpdatedState);
                return nextUpdatedState;
            });
        },
        dismissSpaceAccessDetails () {
            setMasterState((s)=>({
                    ...s,
                    isSpaceAccessDetailsOpen: false
                }));
        },
        openSpaceAccessDetails () {
            setMasterState((s)=>({
                    ...s,
                    isSpaceAccessDetailsOpen: true
                }));
        },
        showOpenAccessWarningDialog () {
            setMasterState((s)=>({
                    ...s,
                    isOpenAccessWarningDialogOpen: true,
                    shouldGeneralAccessSelectMenuBeControlled: true
                }));
        },
        closeOpenAccessWarningDialog () {
            setMasterState((s)=>({
                    ...s,
                    isOpenAccessWarningDialogOpen: false,
                    shouldGeneralAccessSelectMenuBeControlled: false
                }));
        },
        openInspectPermsDialog () {
            setMasterState((s)=>({
                    ...s,
                    isInspectPermsDialogOpen: true
                }));
        },
        dismissInspectPermsDialog () {
            setMasterState((s)=>({
                    ...s,
                    isInspectPermsDialogOpen: false
                }));
        },
        openPublicLinkDialog () {
            setMasterState((s)=>({
                    ...s,
                    isPublicLinkDialogOpen: true
                }));
        },
        closePublicLinkDialog () {
            setMasterState((s)=>({
                    ...s,
                    isPublicLinkDialogOpen: false,
                    lastTriggeredDialogVariant: 'publicLink'
                }));
        },
        openShareToSlackDialog () {
            setMasterState((s)=>({
                    ...s,
                    isShareToSlackDialogOpen: true
                }));
        },
        closeShareToSlackDialog () {
            setMasterState((s)=>({
                    ...s,
                    isShareToSlackDialogOpen: false,
                    lastTriggeredDialogVariant: 'shareToSlack'
                }));
        },
        openAccessRequestsDialog () {
            setMasterState((s)=>({
                    ...s,
                    isAccessRequestsDialogOpen: true
                }));
        },
        closeAccessRequestsDialog () {
            const { hasAccessRequestsChanges: hasAccessRequestsChanges } = masterState;
            // Check if there are unsaved changes in the access requests dialog
            if (hasAccessRequestsChanges) setMasterState((s)=>({
                    ...s,
                    isCloseConfirmationOpen: true
                }));
            else {
                setMasterState((s)=>({
                        ...s,
                        isAccessRequestsDialogOpen: false,
                        lastTriggeredDialogVariant: 'accessRequests'
                    }));
                refetchQueries();
            }
        },
        clearElementToFocus () {
            setMasterState((s)=>({
                    ...s,
                    lastTriggeredDialogVariant: null
                }));
        },
        showFlag (flag) {
            return controllerExtras.showFlag(flag);
        },
        showErrorFlag (flag) {
            return controllerExtras.showErrorFlag(flag);
        },
        handleCtaClick () {
            const { contentId: contentId, contentType: contentType, contentSubType: contentSubType, isUnpublishedDraft: isUnpublishedDraft } = controllerProps;
            const { numberOfAncestors: numberOfAncestors, userCanEditRestrictions: userCanEditRestrictions, currentUser: currentUser, edition: edition } = queriesState;
            const { principalsStagerPrincipals: principalsStagerPrincipals, optionalMessage: optionalMessage, shouldResolveMismatchedRestrictions: shouldResolveMismatchedRestrictions } = masterState;
            const { isChanged: isChanged, stagedGeneralAccessLevel: stagedGeneralAccessLevel, natureOfCta: natureOfCta, stagedNotificationRecipients: stagedNotificationRecipients, isPublishModalFlow: isPublishModalFlow, includeInvites: includeInvites } = derivedState;
            const { addMode: addMode } = masterState;
            const { mutateContentRestrictions: mutateContentRestrictions, exportPublishModalRestrictions: exportPublishModalRestrictions, sendNotification: sendNotification, successFlag: successFlag, errorFlag: errorFlag, fireAnalyticEvent: fireAnalyticEvent, teardownController: { tearDownAfterPotentialFinalDialogCompletesClose: tearDownAfterPotentialFinalDialogCompletesClose }, experienceTracker: experienceTracker, callResolveMismatchedRestrictions: callResolveMismatchedRestrictions } = controllerExtras;
            const beginTeardown = ()=>{
                // Tell the teardown manager to unmount the controller after the dialog
                // closes
                tearDownAfterPotentialFinalDialogCompletesClose();
                // Switch the active dialog to an empty one, to close it. Its
                // `onCloseComplete` will trigger the unmounting
                setMasterState((s2)=>({
                        ...s2,
                        sessionState: 'exiting',
                        hasAccessRequestsChanges: false
                    }));
            };
            const refreshDialogState = (0, $d45f9e9292e71caa$export$31a6fc2aeeeb8b81)(setMasterState, refetchQueries, {
                principalsStagerPrincipals: [],
                // Clear all deltas - this lets the fresh queriesState data show through
                generalAccessDelta: 'none',
                specificAccessDelta: {
                    removeAll: false,
                    stagedAdditions: [],
                    removals: new Set(),
                    reassignments: new Map()
                }
            });
            // We need to ensure we retrieve the most updated principal map to use during a CTA click.
            const updatedPrincipalMap = (0, $lTbRO.makePrincipalsMap)(masterState, queriesState, {
                isCtaClick: true,
                stagedGeneralAccessLevel: stagedGeneralAccessLevel
            });
            if (isPublishModalFlow) {
                exportPublishModalRestrictions(stagedGeneralAccessLevel, updatedPrincipalMap);
                beginTeardown();
            } else dispatchCtaFlowEvent({
                contentId: contentId,
                edition: edition,
                numberOfAncestors: numberOfAncestors,
                type: 'cta',
                addMode: addMode,
                mutateContentRestrictions: mutateContentRestrictions,
                currentUser: currentUser,
                sendNotification: sendNotification,
                successFlag: successFlag,
                errorFlag: errorFlag,
                beginTeardown: beginTeardown,
                isMutatingAction: isChanged,
                isNotifyingAction: natureOfCta === 'share',
                userCanEditRestrictions: userCanEditRestrictions,
                stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                principalsMap: updatedPrincipalMap,
                optionalMessage: optionalMessage,
                principalsStagerPrincipals: principalsStagerPrincipals,
                stagedNotificationRecipients: stagedNotificationRecipients,
                validateRestrictedPrincipals: $7QoAs.validateRestrictedPrincipals,
                experienceTracker: experienceTracker,
                fireAnalyticEvent: fireAnalyticEvent,
                contentSubType: contentSubType,
                contentType: contentType,
                callResolveMismatchedRestrictions: callResolveMismatchedRestrictions,
                isResolvingAction: shouldResolveMismatchedRestrictions,
                isUnpublishedDraft: isUnpublishedDraft,
                includeInvites: includeInvites,
                refreshDialogState: refreshDialogState
            });
        },
        changeOptionalMessage (message) {
            setMasterState((s)=>({
                    ...s,
                    optionalMessage: message
                }));
        },
        setNotifyChecked (newValue) {
            setMasterState((s)=>({
                    ...s,
                    notifyCheckedIfAvailable: newValue,
                    // If we're unchecking the box, then if we check it again we want the
                    // 'Add message' textarea to not show by default
                    showMessageComposerUnderCheckbox: newValue ? s.showMessageComposerUnderCheckbox : false
                }));
        },
        toggleNotifyAddMessage () {
            setMasterState((s)=>({
                    ...s,
                    showMessageComposerUnderCheckbox: !s.showMessageComposerUnderCheckbox
                }));
        },
        doNotifyGroupsConfirmed () {
            dispatchCtaFlowEvent({
                type: 'doNotifyGroups'
            });
        },
        doNotNotifyGroupsConfirmed () {
            dispatchCtaFlowEvent({
                type: 'doNotNotifyGroups'
            });
        },
        // Defaulting isGuestError to false as this is an edge case that is being handled.
        // A better solution for handling guest errors will be implemented in the future.
        // https://product-fabric.atlassian.net/browse/USD-633
        ignoreRestrictionsAndContinue (isGuestError = false) {
            dispatchCtaFlowEvent({
                type: 'ignoreRestrictions',
                shouldSkipFlagRaise: isGuestError
            });
        },
        resolveRestrictionsComplete () {
            dispatchCtaFlowEvent({
                type: 'resolveRestrictionsComplete'
            });
        },
        toggleSpecificAccessExpanded () {
            setMasterState((s)=>({
                    ...s,
                    isSpecificAccessExpanded: !s.isSpecificAccessExpanded
                }));
        },
        openSpecificAccessDialog () {
            setMasterState((s)=>({
                    ...s,
                    isSpecificAccessDialogOpen: true
                }));
        },
        closeSpecificAccessDialog () {
            setMasterState((s)=>({
                    ...s,
                    isSpecificAccessDialogOpen: false
                }));
        },
        closeAccessRequestsResolveRestrictionsDialog () {
            setMasterState((s)=>({
                    ...s,
                    isAccessRequestsResolveRestrictionsDialogOpen: false,
                    accessRequestsCurrentUserAddMode: undefined
                }));
        },
        closeAccessRequestsWarnRestrictionsDialog () {
            setMasterState((s)=>({
                    ...s,
                    isAccessRequestsWarnRestrictionsDialogOpen: false
                }));
        },
        async maybeStartBlockedAccessFlowForUser ({ id: id, avatarUrl: avatarUrl, name: name, email: email, sitePermissionType: sitePermissionType, accessType: accessType }) {
            const { contentId: contentId } = controllerProps;
            const { numberOfAncestors: numberOfAncestors, edition: edition } = queriesState;
            const { fireAnalyticEvent: fireAnalyticEvent, cloudId: cloudId } = controllerExtras;
            const addMode = accessType === 'EDIT' ? 'as-editor' : 'as-viewer';
            const userPrincipal = {
                id: id,
                avatarUrl: avatarUrl,
                name: name,
                email: email,
                sitePermissionType: sitePermissionType,
                knownErrors: undefined
            };
            // validate if restricted access can be fixed and preload space role mode in parallel
            const [validationResult] = await Promise.all([
                (0, $7QoAs.validateRestrictedPrincipals)({
                    contentId: contentId,
                    cloudId: cloudId,
                    edition: edition,
                    numberOfAncestors: numberOfAncestors,
                    addMode: addMode,
                    stagedUserPrincipals: [
                        userPrincipal
                    ],
                    setMasterState: setMasterState,
                    fireAnalyticEvent: fireAnalyticEvent
                }),
                (0, $f2UnK.preloadSpaceRoleMode)(cloudId)
            ]);
            const { showWarnRestrictionsDialog: showWarnRestrictionsDialog, showResolveRestrictionsDialog: showResolveRestrictionsDialog } = validationResult;
            if (showWarnRestrictionsDialog) setMasterState((s)=>({
                    ...s,
                    isAccessRequestsWarnRestrictionsDialogOpen: true
                }));
            if (showResolveRestrictionsDialog) setMasterState((s)=>({
                    ...s,
                    isAccessRequestsResolveRestrictionsDialogOpen: true,
                    accessRequestsCurrentUserAddMode: addMode
                }));
            return {
                isBlockedAccessFlowStarted: showWarnRestrictionsDialog || showResolveRestrictionsDialog
            };
        },
        setAccessRequestsChanges (hasChanges) {
            setMasterState((s)=>({
                    ...s,
                    hasAccessRequestsChanges: hasChanges
                }));
        },
        markPrincipalsAsSkipped (skippedPrincipals) {
            const { principalsStagerPrincipals: principalsStagerPrincipals } = masterState;
            setMasterState((s)=>({
                    ...s,
                    principalsStagerPrincipals: principalsStagerPrincipals.map((principal)=>{
                        if ((0, $6O3OC.isEmail)(principal) && skippedPrincipals.includes(principal.id)) return {
                            ...principal,
                            isPendingAction: false
                        };
                        return principal;
                    })
                }));
        },
        markPrincipalsAsInvited (invitedPrincipals, errorPrincipals) {
            const { principalsStagerPrincipals: principalsStagerPrincipals } = masterState;
            const principalsToAdd = invitedPrincipals.map(({ email: email, id: id })=>{
                const principal = principalsStagerPrincipals.find((p)=>email === p.id);
                return {
                    type: 'user',
                    id: id,
                    email: email,
                    name: principal?.name || email,
                    avatarUrl: principal?.avatarUrl || '',
                    knownErrors: {
                        accessWarning: 'pending-site-access-warning',
                        parentLink: null
                    },
                    sitePermissionType: 'none'
                };
            });
            principalsToAdd.forEach((principal)=>{
                (0, $fec5t.stagePrincipalAddition)(setMasterState, principal);
            });
            setMasterState((s)=>({
                    ...s,
                    principalsStagerPrincipals: s.principalsStagerPrincipals.map((principal)=>{
                        const invitedPrincipal = principalsToAdd.find(({ email: email })=>email === principal.id);
                        if (invitedPrincipal && ((0, $6O3OC.isEmail)(principal) || (0, $6O3OC.isExternalUser)(principal))) return invitedPrincipal;
                        const errorPrincipal = errorPrincipals.find(({ email: email })=>email === principal.id);
                        if ((0, $6O3OC.isEmail)(principal) && errorPrincipal) return {
                            ...principal,
                            isPendingAction: false
                        };
                        return principal;
                    })
                }));
        }
    };
}
module.exports["getActions"] = $c55d965f1ec8fe6e$export$fe3955935f564b31;

});

parcelRegister("7QoAs", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $d9tcB = parcelRequire("d9tcB");


var $4adOe = parcelRequire("4adOe");


var $4Ewfm = parcelRequire("4Ewfm");


var $1chEN = parcelRequire("1chEN");


var $eSUdr = parcelRequire("eSUdr");

const $805e122bee13043d$export$563114fe01e5ec42 = (0, $eSUdr.default)`query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!$contentId:Long!$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType contentId:$contentId subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId subjectType}restrictedResources{resourceId resourceTitle resourceLink{base webUi}requiredAccessType resourceType}}blockedAccessEmpowerment{subjectId isCurrentUserEmpowered}blockedAccessAssignableSpaceRolesIntersection{roleId roleDescription roleName roleType}canFixRestrictionsForAllSubjects}}`;





const $d6dad978bdbdb5b9$export$19191d5d5173163b = (0, $eSUdr.default)`query UsersContentAccessQuery($accessType:ResourceAccessType!$accountIds:[String]!$cloudId:ID!$contentId:ID!){confluence_userContentAccess(accessType:$accessType accountIds:$accountIds cloudId:$cloudId contentId:$contentId){canAccessList cannotAccessList}}`;


const $164b2844d962585d$var$blockedAccessUsersLimit = 10;
const $164b2844d962585d$var$blockedAccessLevelsLimit = 10;
const $164b2844d962585d$export$4da22e4767045266 = async ({ contentId: contentId, cloudId: cloudId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, stagedUserPrincipals: stagedUserPrincipals, setMasterState: setMasterState, fireAnalyticEvent: fireAnalyticEvent })=>{
    const client = (0, $hp2SH.getApolloClient)();
    //The validation  is skipped if free edition
    if (edition == (0, $d9tcB.ConfluenceEdition).FREE) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    const activeStagedUserPrincipals = stagedUserPrincipals.filter((user)=>!(0, $4Ewfm.isUserPendingAccess)({
            type: 'user',
            ...user
        }));
    //The validation  is skipped if staged user count is 0
    if (activeStagedUserPrincipals.length == 0) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    // if staged user count is greater than 10,
    // or content is more than 10 levels deep
    if (activeStagedUserPrincipals.length > $164b2844d962585d$var$blockedAccessUsersLimit || numberOfAncestors > $164b2844d962585d$var$blockedAccessLevelsLimit) {
        fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'BlockedAccessCheckLimitExceeded',
            actionSubject: 'BlockedAccessCheck',
            source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            attributes: {
                NewUsersCount: activeStagedUserPrincipals.length,
                numberOfAncestors: numberOfAncestors
            }
        });
        const accountIds = activeStagedUserPrincipals.map((user)=>{
            return user.id;
        });
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: usersContentAccessData, errors: usersContentAccessErrors } = await client.query({
            query: (0, $d6dad978bdbdb5b9$export$19191d5d5173163b),
            variables: {
                accessType: addMode == 'as-editor' ? (0, $1chEN.ResourceAccessType).EDIT : (0, $1chEN.ResourceAccessType).VIEW,
                accountIds: accountIds,
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only'
        });
        if (usersContentAccessErrors) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'UsersContentAccessQuery',
                actionSubjectId: 'validateRestrictedPrincipals',
                attributes: {
                    message: usersContentAccessErrors[0]?.message
                }
            });
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: false
            };
        }
        const canNotAccessList = usersContentAccessData?.confluence_userContentAccess?.cannotAccessList;
        if (canNotAccessList != null && canNotAccessList.length > 0) {
            const restrictedUserPrincipalsList = canNotAccessList.map((userId)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === userId),
                    restrictedResources: null
                };
                return restrictedPrincipal;
            });
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList
                }));
            return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
        }
    } else {
        const blockedAccessSubjects = activeStagedUserPrincipals.map((user)=>{
            const blockedAccessSubject = {
                subjectId: user.id,
                subjectType: (0, $1chEN.BlockedAccessSubjectType).USER
            };
            return blockedAccessSubject;
        });
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data, errors: errors } = await client.query({
            query: (0, $805e122bee13043d$export$563114fe01e5ec42),
            variables: {
                contentId: contentId,
                accessType: addMode == 'as-editor' ? (0, $1chEN.ResourceAccessType).EDIT : (0, $1chEN.ResourceAccessType).VIEW,
                subjects: blockedAccessSubjects
            },
            fetchPolicy: 'network-only'
        });
        if (errors) fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'errored',
            actionSubject: 'BlockedAccessRestrictionsQuery',
            actionSubjectId: 'validateRestrictedPrincipals',
            attributes: {
                message: errors[0]?.message
            }
        });
        if (data?.blockedAccessRestrictions?.blockedAccessRestrictionSummary.length > 0) {
            const restrictedUserPrincipalsList = data.blockedAccessRestrictions.blockedAccessRestrictionSummary.map((restrictedUser)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === restrictedUser?.subject?.subjectId),
                    restrictedResources: restrictedUser?.restrictedResources
                };
                return restrictedPrincipal;
            });
            const assignableSpaceRolesIntersection = data.blockedAccessRestrictions.blockedAccessAssignableSpaceRolesIntersection;
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
                }));
            //current user is not empowered to fix at least one of the selected user's restrictions
            if (!data.blockedAccessRestrictions.canFixRestrictionsForAllSubjects) return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: true,
                // Expose this extra info for Realtime requests to consume
                // In USD these get set directly on the masterState
                // But realtime requests don't have access to masterState
                restrictedUserPrincipals: restrictedUserPrincipalsList,
                assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
            };
        }
    }
    // all added principles can access or blocked access was skipped
    return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
};
module.exports["validateRestrictedPrincipals"] = $164b2844d962585d$export$4da22e4767045266;

});

parcelRegister("4Ewfm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $8oEoE = parcelRequire("8oEoE");

const $b2ff9ab7087360b2$export$3b523c26f78a7afe = (principal)=>{
    if (principal.type === 'user') {
        const warning = principal.knownErrors?.accessWarning;
        return warning === 'pending-site-access-warning' || warning === 'pending-userbase-propagation-warning';
    }
    return false;
};
function $b2ff9ab7087360b2$export$9871f41355e50e43({ principals: principals, removals: removals, principalsPendingAccess: principalsPendingAccess, removeAll: removeAll }) {
    if (!(0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate')) return false;
    if (!(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation')) return false;
    if (Array.from(principals.values()).some(({ principal: principal })=>$b2ff9ab7087360b2$export$3b523c26f78a7afe(principal))) return true;
    if (principalsPendingAccess.some(({ principal: { id: id } })=>removals.has(id))) return true;
    if (removeAll && principalsPendingAccess.length > 0) return true;
    return false;
}
function $b2ff9ab7087360b2$export$e84d96463240149a({ stagedGeneralAccessLevel: stagedGeneralAccessLevel, principals: principals }) {
    return $b2ff9ab7087360b2$var$getRestrictions({
        stagedGeneralAccessLevel: stagedGeneralAccessLevel,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
}
function $b2ff9ab7087360b2$export$50e102a305a0ed72({ stagedGeneralAccessLevel: stagedGeneralAccessLevel, principals: principals }) {
    const currentRestrictions = $b2ff9ab7087360b2$var$getRestrictions({
        stagedGeneralAccessLevel: stagedGeneralAccessLevel,
        principals: principals,
        restrictionType: 'publish-modal-restrictions'
    });
    const read = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const update = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const { publishModalReadRestrictions: publishModalReadRestrictions, publishModalUpdateRestrictions: publishModalUpdateRestrictions } = $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions);
    return [
        publishModalReadRestrictions,
        publishModalUpdateRestrictions
    ];
}
/**
 * Generates restrictions based on the general access level, the provided principals map and restrictionType.
 */ function $b2ff9ab7087360b2$var$getRestrictions({ stagedGeneralAccessLevel: stagedGeneralAccessLevel, principals: principals, restrictionType: restrictionType }) {
    switch(stagedGeneralAccessLevel){
        case 'restricted':
            return {
                read: $b2ff9ab7087360b2$var$getReadList(principals, restrictionType),
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        case 'open-can-view':
            return {
                read: {
                    group: [],
                    user: []
                },
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        default:
            return {
                read: {
                    group: [],
                    user: []
                },
                update: {
                    group: [],
                    user: []
                }
            };
    }
}
/**
 * Converts the current state to publish modal restrictions by transforming user and group lists.
 *
 * @param {ContentRestriction} read - The read restrictions content.
 * @param {ContentRestriction} update - The update restrictions content.
 * @param {PageRestrictionsInput} currentRestrictions - The current restrictions input.
 * @returns {{ publishModalReadRestrictions: ContentRestriction, publishModalUpdateRestrictions: ContentRestriction }} The transformed publish modal restrictions.
 */ function $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions) {
    const { restrictions: { user: { results: readUserList }, group: { results: readGroupList } } } = read;
    const { restrictions: { user: { results: updateUserList }, group: { results: updateGroupList } } } = update;
    const { read: currentReadList, update: currentUpdateList } = currentRestrictions;
    $b2ff9ab7087360b2$var$pushTransformedUser(readUserList, currentReadList.user);
    $b2ff9ab7087360b2$var$pushTransformedUser(updateUserList, currentUpdateList.user);
    $b2ff9ab7087360b2$var$pushTransformedGroup(readGroupList, currentReadList.group);
    $b2ff9ab7087360b2$var$pushTransformedGroup(updateGroupList, currentUpdateList.group);
    return {
        publishModalReadRestrictions: read,
        publishModalUpdateRestrictions: update
    };
}
/**
 * Transforms and adds user restrictions to the publish modal user list.
 */ function $b2ff9ab7087360b2$var$pushTransformedUser(list, users) {
    for (const user of users){
        if (!user) continue;
        list.push({
            ...user,
            type: 'known',
            publicName: user.displayName,
            isExternalCollaborator: false
        });
    }
}
/**
 * Transforms and adds group restrictions to the publish modal group list.
 */ function $b2ff9ab7087360b2$var$pushTransformedGroup(list, groups) {
    for (const group of groups){
        if (!group) continue;
        list.push(group);
    }
}
const $b2ff9ab7087360b2$var$getUsageType = (principal)=>{
    if ((principal.type === 'group' || principal.type === 'team') && 'usageType' in principal && principal.usageType) return principal.usageType;
    if (principal.type === 'group') return (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
    if (principal.type === 'team') return (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
};
/**
 * Generates a list of principals with 'can-edit' access for the update list.
 */ function $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && role === 'can-edit') groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && role === 'can-edit') userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
/**
 * Generates a list of principals with 'can-view' access for the read list.
 */ function $b2ff9ab7087360b2$var$getReadList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && (role === 'can-view' || role === 'can-edit')) groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && (role === 'can-view' || role === 'can-edit')) userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
module.exports["isUserPendingAccess"] = $b2ff9ab7087360b2$export$3b523c26f78a7afe;
module.exports["shouldMutationIncludeInvites"] = $b2ff9ab7087360b2$export$9871f41355e50e43;
module.exports["getRestrictionsForMutation"] = $b2ff9ab7087360b2$export$e84d96463240149a;
module.exports["getRestrictionsForPublishModal"] = $b2ff9ab7087360b2$export$50e102a305a0ed72;

});

parcelRegister("f2UnK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $eSUdr = parcelRequire("eSUdr");


var $dYU3e = parcelRequire("dYU3e");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery = (0, $eSUdr.default)`query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}`;
const $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d = (cloudId)=>{
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (()=>{
            const _beforeResult2 = (0, $4JHZe.beforePreloaderAsyncCall)();
            return (0, $dYU3e.query)({
                /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ query: $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery,
                variables: {
                    cloudId: cloudId
                },
                fetchPolicy: 'cache-first'
            }).then(({ data: data, hasErrors: hasErrors })=>{
                (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult2);
                if (hasErrors) // Handle errors silently for preloading
                return null;
                return data?.confluence_spaceRoleMode || null;
            });
        })().catch((error)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        });
    })();
};
const $0ac8a6fa9069d7d8$export$c715e7f8018f9029 = async (cloudId)=>{
    await (async ()=>{
        const _beforeResult3 = (0, $4JHZe.beforePreloaderAsyncCall)();
        const _asyncResult = await $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d(cloudId);
        (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult3);
        return _asyncResult;
    })();
};
module.exports["preloadSpaceRoleMode"] = $0ac8a6fa9069d7d8$export$c715e7f8018f9029;

});

parcelRegister("dYU3e", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");



var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $7Lnfv = parcelRequire("7Lnfv");


var $jQ6FG = parcelRequire("jQ6FG");


var $3joiD = parcelRequire("3joiD");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");


const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   * In component: query getQueryParamsAndSetFetchPolicyForNetworkOnlyQuery or getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    const queryName = (0, $jQ6FG.getQueryName)(name, variables);
    let single = true;
    // If the query has already been preloaded with network only
    // Subsequent query with same name and variable should be done with cache-first to avoid duplicate network request
    (0, $3joiD.flagQueryPreloadedByNetworkOnly)(queryName, variables, fetchPolicy);
    const queryContext = {
        single: single,
        ...context
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // Save current boundary context
    const currentBoundary = window.__PRELOAD_BOUNDARY_NAME__;
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return client.query({
            query: query,
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            context: queryContext
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // Restore the previous boundary context as soon as the query resolves
            window.__PRELOAD_BOUNDARY_NAME__ = currentBoundary;
            const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
            return {
                ...result,
                hasErrors: hasErrors
            };
        });
    })();
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("7BnEk", function(module, exports) {
function $c4e3a3de9260f082$export$2dec6941172235c4(initialDialog = null) {
    return {
        sessionState: 'shareAndRestrict',
        isCloseConfirmationOpen: false,
        principalsStagerPrincipals: [],
        addMode: 'as-editor',
        accessRequestsCurrentUserAddMode: undefined,
        hasAddWarning: false,
        generalAccessDelta: 'none',
        shouldGeneralAccessSelectMenuBeControlled: false,
        specificAccessDelta: {
            removeAll: false,
            stagedAdditions: [],
            removals: new Set(),
            reassignments: new Map()
        },
        isSpaceAccessDetailsOpen: false,
        isInspectPermsDialogOpen: false,
        isPublicLinkDialogOpen: false,
        isShareToSlackDialogOpen: false,
        isSpecificAccessDialogOpen: false,
        isOpenAccessWarningDialogOpen: false,
        isAccessRequestsDialogOpen: initialDialog === 'accessRequests',
        isAccessRequestsResolveRestrictionsDialogOpen: false,
        isAccessRequestsWarnRestrictionsDialogOpen: false,
        notifyCheckedIfAvailable: true,
        notifyMode: 'notify',
        optionalMessage: '',
        showMessageComposerUnderCheckbox: false,
        isSaving: false,
        restrictedUserPrincipals: undefined,
        assignableSpaceRolesIntersection: undefined,
        isSpecificAccessExpanded: false,
        lastTriggeredDialogVariant: null,
        shouldResolveMismatchedRestrictions: false,
        hasAccessRequestsChanges: false
    };
}
module.exports["makeDefaultMasterState"] = $c4e3a3de9260f082$export$2dec6941172235c4;

});

parcelRegister("3PKog", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

function $508022ce31d30869$export$6e8d58535e65a60a({ removeAll: removeAll }, stagedGeneralAccessLevel, principalsMap, currentUserId, queryPrincipals, principalsPendingAccess) {
    const ids = new Set();
    let hasPrincipalsBesidesCurrentUser = false;
    /**
	 * Calculates if a principal's role would not grant them access beyond what
	 * the General Access level would automatically afford them.
	 */ function isCoveredByGeneralAccess(id) {
        const theirRole = principalsMap.get(id)?.role;
        if (theirRole === 'can-edit') {
            if (stagedGeneralAccessLevel === 'open-can-edit') return true;
        } else if (theirRole === 'can-view') {
            if (stagedGeneralAccessLevel === 'open-can-edit') return true;
            if (stagedGeneralAccessLevel === 'open-can-view') return true;
        }
        return false;
    }
    // List (You) first, if the current user is even on there as an individual
    if (principalsMap.has(currentUserId)) {
        if (!isCoveredByGeneralAccess(currentUserId)) ids.add(currentUserId);
    }
    // Next, all the principals from the query, if 'Remove all' was never pressed,
    // omitting the ones that have already been pushed
    if (!removeAll) for (const { principal: { id: id } } of [
        ...queryPrincipals,
        ...principalsPendingAccess
    ]){
        // Omit (You)
        if (id === currentUserId) continue;
        // Omit removals
        if (!principalsMap.has(id)) continue;
        // Omit roles that don't go beyond current General Access allowances
        if (isCoveredByGeneralAccess(id)) continue;
        ids.add(id);
        hasPrincipalsBesidesCurrentUser = true;
    }
    return {
        ids: Array.from(ids),
        hasPrincipalsBesidesCurrentUser: hasPrincipalsBesidesCurrentUser
    };
}



var $lTbRO = parcelRequire("lTbRO");


var $fec5t = parcelRequire("fec5t");


var $4Ewfm = parcelRequire("4Ewfm");


var $8oEoE = parcelRequire("8oEoE");

function $eb928b5ef8fa0439$var$getIsChanged({ generalAccessDelta: generalAccessDelta, specificAccessDelta: { removeAll: removeAll, removals: removals, reassignments: reassignments }, principalsStagerPrincipals: principalsStagerPrincipals, hasAccessRequestsChanges: hasAccessRequestsChanges }) {
    if (removeAll && !(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) return true;
    // When persistence_specific_access_gate is enabled, general access changes are applied
    // immediately (not staged), so they don't count as pending changes requiring a Save button
    if (generalAccessDelta !== 'none' && !(0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) return true;
    if (principalsStagerPrincipals.length > 0) return true;
    if (removals.size > 0) return true;
    if (reassignments.size > 0) return true;
    if (hasAccessRequestsChanges) return true;
    return false;
}
function $eb928b5ef8fa0439$var$getIsRestrictionChange({ generalAccessDelta: generalAccessDelta, specificAccessDelta: { removeAll: removeAll, removals: removals, reassignments: reassignments } }) {
    if (removeAll) return true;
    if (generalAccessDelta !== 'none') return true;
    if (removals.size > 0) return true;
    if (reassignments.size > 0) return true;
    return false;
}
/**
 * Reduces a list of principals to calculate user and group counts.
 */ const $eb928b5ef8fa0439$var$reducePrincipalCounts = ({ principalList: principalList, counts: counts, removals: removals = new Set(), isRemovalPhase: isRemovalPhase = false, isRemoveAllPhase: isRemoveAllPhase = false })=>{
    return isRemoveAllPhase ? {
        users: 0,
        groups: 0
    } : principalList.reduce((acc, { principal: { type: type, id: id } })=>{
        if (isRemovalPhase) {
            if (removals.has(id)) {
                if (type === 'user') acc.users--;
                if (type === 'group') acc.groups--;
            }
        } else {
            if (type === 'user') acc.users++;
            if (type === 'group') acc.groups++;
        }
        return acc;
    }, {
        ...counts
    });
};
function $eb928b5ef8fa0439$var$checkForExceededLimit({ contentRestrictions: contentRestrictions, specificAccessDelta: specificAccessDelta }) {
    const LIMIT = 200;
    const { removals: removals, removeAll: removeAll, stagedAdditions: stagedAdditions } = specificAccessDelta;
    // Calculate counts step by step
    const initialPrincipalCounts = $eb928b5ef8fa0439$var$reducePrincipalCounts({
        principalList: contentRestrictions.principals,
        counts: {
            users: 0,
            groups: 0
        }
    });
    const countsWithRemovals = $eb928b5ef8fa0439$var$reducePrincipalCounts({
        principalList: contentRestrictions.principals,
        counts: initialPrincipalCounts,
        removals: removals,
        isRemovalPhase: true,
        isRemoveAllPhase: removeAll
    });
    const finalCountsWithAdditions = $eb928b5ef8fa0439$var$reducePrincipalCounts({
        principalList: stagedAdditions,
        counts: countsWithRemovals
    });
    const calculateOverflow = (count)=>count > LIMIT ? count - LIMIT : null;
    return {
        /** Indicates if either user or group limits are exceeded */ isLimitExceeded: finalCountsWithAdditions.users > LIMIT || finalCountsWithAdditions.groups > LIMIT,
        /** Number of groups exceeding the limit, or null if within limit */ groupOverFlow: calculateOverflow(finalCountsWithAdditions.groups),
        /** Number of users exceeding the limit, or null if within limit */ userOverFlow: calculateOverflow(finalCountsWithAdditions.users)
    };
}
function $eb928b5ef8fa0439$export$996c19daeda1246e(masterState, queriesState) {
    const { generalAccessDelta: generalAccessDelta } = masterState;
    const { contentRestrictions: { generalAccessLevel: generalAccessLevel } } = queriesState;
    return generalAccessDelta === 'none' ? generalAccessLevel : generalAccessDelta;
}
function $eb928b5ef8fa0439$var$getNatureOfCta({ isChanged: isChanged, isCheckboxVisible: isCheckboxVisible, notifyCheckedIfAvailable: notifyCheckedIfAvailable, isPublishModalFlow: isPublishModalFlow }) {
    if (isPublishModalFlow) return 'save';
    if (isChanged) {
        if (isCheckboxVisible && notifyCheckedIfAvailable) return 'share';
        return 'save';
    }
    return 'none';
}
function $eb928b5ef8fa0439$var$getPrincipalCountByType(removals, principals, currentCount, usageType) {
    let updatedCount = currentCount;
    for (const removalId of removals){
        const principalToRemove = principals.find((p)=>p.principal.id === removalId);
        if (principalToRemove && principalToRemove.principal.usageType === usageType) updatedCount--;
    }
    return updatedCount;
}
function $eb928b5ef8fa0439$export$c7377cc1a3839fd9(masterState, queriesState, controllerProps) {
    const { specificAccessDelta: specificAccessDelta, principalsStagerPrincipals: principalsStagerPrincipals, notifyCheckedIfAvailable: notifyCheckedIfAvailable, shouldGeneralAccessSelectMenuBeControlled: shouldGeneralAccessSelectMenuBeControlled, generalAccessDelta: generalAccessDelta, addMode: addMode } = masterState;
    const { contentType: contentType, allowRestrictions: allowRestrictions, isUnpublishedDraft: isUnpublishedDraft, isSuperAdmin: isSuperAdmin, pushPublishModalRestrictions: pushPublishModalRestrictions, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, hasViewRestrictions: hasViewRestrictions } = controllerProps;
    const { edition: edition, contentRestrictions: contentRestrictions, disableSharingToEmails: disableSharingToEmails, groupCount: groupCount, teamCount: teamCount } = queriesState;
    const isPublishModalFlow = Boolean(pushPublishModalRestrictions);
    const isChanged = $eb928b5ef8fa0439$var$getIsChanged(masterState);
    const stagedGeneralAccessLevel = $eb928b5ef8fa0439$export$996c19daeda1246e(masterState, queriesState);
    //Determines if the general access level is different from the queried restrictions
    const hasMismatchWithQueryRestrictions = (()=>{
        if ((hasRestrictions || hasInheritedRestrictions) === (stagedGeneralAccessLevel === 'restricted')) return false;
        if (hasViewRestrictions === (stagedGeneralAccessLevel === 'open-can-view')) return false;
        if (hasRestrictions !== (stagedGeneralAccessLevel === 'open-can-edit')) return true;
        return true;
    })();
    const shouldShowDeletedGroupDetails = isSuperAdmin && hasMismatchWithQueryRestrictions && (0, $9wGTI.fg)('confluence_frontend_perms_deleted_groups_treatment');
    const isRestrictionsEditable = contentType !== 'embed' && (queriesState.userCanEditRestrictions || edition === (0, $d9tcB.ConfluenceEdition).FREE) && allowRestrictions;
    const stagedNotificationRecipients = masterState.principalsStagerPrincipals.map((0, $fec5t.convertUserPickerPrincipal));
    const principalsMap = (0, $lTbRO.makePrincipalsMap)(masterState, queriesState, {
        isCtaClick: false,
        stagedGeneralAccessLevel: stagedGeneralAccessLevel
    });
    const { ids: ids, hasPrincipalsBesidesCurrentUser: hasPrincipalsBesidesCurrentUser } = (0, $508022ce31d30869$export$6e8d58535e65a60a)(specificAccessDelta, stagedGeneralAccessLevel, principalsMap, queriesState.currentUser.id, queriesState.contentRestrictions.principals, queriesState.principalsPendingAccess);
    const isCheckboxVisible = (()=>{
        if (isPublishModalFlow) return false;
        // Show the checkbox if someone is chosen in the user picker and
        // the stagedGeneralAccessLevel doesn't affect the stagedPrincipalAction.
        if (principalsStagerPrincipals.length > 0) return true;
        // Otherwise, it's present if there's net anyone new for the mutation
        return stagedNotificationRecipients.length > 0;
    })();
    const natureOfCta = $eb928b5ef8fa0439$var$getNatureOfCta({
        principalsStagerPrincipals: principalsStagerPrincipals,
        isChanged: isChanged,
        isCheckboxVisible: isCheckboxVisible,
        notifyCheckedIfAvailable: notifyCheckedIfAvailable,
        isPublishModalFlow: isPublishModalFlow,
        generalAccessDelta: generalAccessDelta
    });
    const willBeUnpublishedAfterApplying = isUnpublishedDraft && !isPublishModalFlow;
    const shouldGeneralAccessMenuBeOpen = (()=>{
        if (shouldGeneralAccessSelectMenuBeControlled) return false;
        // Returning undefined allows the menu to manage its own open/close state,
        // relinquishing control.
        return undefined;
    })();
    const exceededLimit = $eb928b5ef8fa0439$var$checkForExceededLimit({
        contentRestrictions: contentRestrictions,
        specificAccessDelta: specificAccessDelta
    });
    const areEmailsOnlyPresent = (()=>{
        const hasEmails = principalsStagerPrincipals.some((principal)=>principal.type === 'email');
        const hasNonEmails = principalsStagerPrincipals.some((principal)=>principal.type !== 'email');
        return hasEmails && !hasNonEmails;
    })();
    const determinedSharingType = (()=>{
        // Determine if the notification checkbox is visible and checked.
        const isNotificationEnabled = isCheckboxVisible && notifyCheckedIfAvailable;
        const isRestrictedOrOpenViewAsEditor = stagedGeneralAccessLevel === 'restricted' || stagedGeneralAccessLevel === 'open-can-view' && addMode === 'as-editor';
        const isRestrictionChange = $eb928b5ef8fa0439$var$getIsRestrictionChange(masterState);
        // When notifications are enabled and sharing is either restricted or open can view as editor
        if (isNotificationEnabled && isRestrictedOrOpenViewAsEditor) return 'sharing-and-applying-restrictions';
        // When notifications are disabled but sharing is still either restricted or open view as editor
        // or when there has been a change to restrictions
        if (!isNotificationEnabled && isRestrictedOrOpenViewAsEditor || isRestrictionChange) return 'applying-restrictions';
        // Check if sharing is happening at an "open-can-edit" level,
        // or at an "open-can-view" level where the added mode is "as-viewer"
        if (stagedGeneralAccessLevel === 'open-can-edit' || stagedGeneralAccessLevel === 'open-can-view' && addMode === 'as-viewer') return 'sharing';
        return null;
    })();
    const userEmails = principalsStagerPrincipals.filter((principal)=>principal.type === 'email' || principal.type === 'external_user');
    const areEmailsPresent = userEmails.length > 0;
    const principalsForCTAClick = (0, $lTbRO.makePrincipalsMap)(masterState, queriesState, {
        isCtaClick: true,
        stagedGeneralAccessLevel: stagedGeneralAccessLevel
    });
    const includeInvites = (0, $4Ewfm.shouldMutationIncludeInvites)({
        principals: principalsForCTAClick,
        removals: specificAccessDelta.removals,
        principalsPendingAccess: queriesState.principalsPendingAccess,
        removeAll: specificAccessDelta.removeAll
    });
    const updatedGroupCount = $eb928b5ef8fa0439$var$getPrincipalCountByType(specificAccessDelta.removals, contentRestrictions.principals, groupCount, (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP);
    const updatedTeamCount = $eb928b5ef8fa0439$var$getPrincipalCountByType(specificAccessDelta.removals, contentRestrictions.principals, teamCount, (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION);
    return {
        shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails,
        hasRestrictions: hasRestrictions,
        hasInheritedRestrictions: hasInheritedRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        hasMismatchWithQueryRestrictions: hasMismatchWithQueryRestrictions,
        isLockedOut: false,
        isRestrictionsEditable: isRestrictionsEditable,
        isChanged: isChanged,
        principalsMap: principalsMap,
        stagedGeneralAccessLevel: stagedGeneralAccessLevel,
        specificAccessIds: ids,
        hasPrincipalsBesidesCurrentUser: hasPrincipalsBesidesCurrentUser,
        natureOfCta: natureOfCta,
        stagedNotificationRecipients: stagedNotificationRecipients,
        isCheckboxVisible: isCheckboxVisible,
        isPublishModalFlow: isPublishModalFlow,
        isUnpublishedDraft: isUnpublishedDraft,
        willBeUnpublishedAfterApplying: willBeUnpublishedAfterApplying,
        isRemoveAllButtonVisible: hasPrincipalsBesidesCurrentUser,
        shouldGeneralAccessMenuBeOpen: shouldGeneralAccessMenuBeOpen,
        exceededLimit: exceededLimit,
        areEmailsOnlyPresent: areEmailsOnlyPresent,
        sharingType: determinedSharingType,
        isSharingToEmailsDisabled: disableSharingToEmails && areEmailsPresent,
        includeInvites: includeInvites,
        updatedGroupCount: updatedGroupCount,
        updatedTeamCount: updatedTeamCount
    };
}
module.exports["getDerivedState"] = $eb928b5ef8fa0439$export$c7377cc1a3839fd9;

});

parcelRegister("9uaV8", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");


var $d9tcB = parcelRequire("d9tcB");


var $6mKj3 = parcelRequire("6mKj3");


var $8oEoE = parcelRequire("8oEoE");


var $euL71 = parcelRequire("euL71");





var $4Ewfm = parcelRequire("4Ewfm");

function $0bd64daed89f93f8$export$a5b33d4c110952eb(statesAndActions) {
    const { masterState: { isPublicLinkDialogOpen: isPublicLinkDialogOpen, isShareToSlackDialogOpen: isShareToSlackDialogOpen, isAccessRequestsDialogOpen: isAccessRequestsDialogOpen, isSpecificAccessExpanded: isSpecificAccessExpanded, isSpecificAccessDialogOpen: isSpecificAccessDialogOpen }, queriesState: { edition: edition }, derivedState: { specificAccessIds: specificAccessIds, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails, natureOfCta: natureOfCta } } = statesAndActions;
    const isAnotherDialogOpen = isPublicLinkDialogOpen || isShareToSlackDialogOpen || isAccessRequestsDialogOpen;
    const shouldShowSpecificAccessDetails = specificAccessIds.length === 1 || specificAccessIds.length > 1 && isSpecificAccessExpanded || shouldShowDeletedGroupDetails;
    if (isSpecificAccessDialogOpen && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) return {
        specificAccessDetails: $0bd64daed89f93f8$export$77a8a4378967e36f(statesAndActions),
        publicLinkDialogBody: undefined,
        shareToSlackDialogBody: undefined
    };
    if (!isAnotherDialogOpen) return shouldShowSpecificAccessDetails ? {
        specificAccessDetails: natureOfCta !== 'none' && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? undefined : $0bd64daed89f93f8$export$77a8a4378967e36f(statesAndActions),
        publicLinkDialogBody: undefined,
        shareToSlackDialogBody: undefined
    } : undefined;
    return {
        specificAccessDetails: undefined,
        publicLinkDialogBody: isPublicLinkDialogOpen && edition !== (0, $euL71.ConfluenceEdition).FREE ? $0bd64daed89f93f8$var$makePublicLinkDialogBodyProps(statesAndActions) : undefined,
        shareToSlackDialogBody: isShareToSlackDialogOpen ? $0bd64daed89f93f8$var$makeShareToSlackDialogBodyProps(statesAndActions) : undefined,
        accessRequestsDialogBody: isAccessRequestsDialogOpen ? $0bd64daed89f93f8$var$makeAccessRequestsDialogBodyProps(statesAndActions) : undefined
    };
}
function $0bd64daed89f93f8$var$makePublicLinkDialogBodyProps(statesAndActions) {
    const { queriesState: { publicLinkPageData: publicLinkPageData, hasInheritedRestrictions: hasInheritedRestrictions, contentRestrictions: { generalAccessLevel: generalAccessLevel } }, controllerProps: { refetchButtonData: refetchButtonData, flags: flags }, controllerExtras: { shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature } } = statesAndActions;
    return {
        publicLinkDisabled: publicLinkPageData?.isLoading ? false : !publicLinkPageData.isPublicLinkAdminEnabled,
        publicLinkOn: publicLinkPageData?.isLoading ? false : publicLinkPageData.isPublicLinkFullyEnabled,
        publicLinkStatus: publicLinkPageData?.isLoading ? null : publicLinkPageData.publicLinkStatus ?? null,
        canEditPublicLink: publicLinkPageData?.isLoading ? false : publicLinkPageData.canEditPublicLink,
        publicShareUrl: publicLinkPageData?.isLoading ? '' : `${window.location.origin}${publicLinkPageData.publicLinkSharePath}`,
        isPublicLinkEditAllowedForContentType: publicLinkPageData?.isLoading ? false : publicLinkPageData.isPublicLinkEditAllowedForContentType,
        isEditPublicLink: publicLinkPageData?.isLoading ? false : publicLinkPageData.isEditPublicLink,
        pageId: statesAndActions.controllerProps.contentId,
        shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature,
        refetchPublicLinkState: publicLinkPageData.isLoading ? ()=>{} : publicLinkPageData.refetch,
        refetchButtonData: refetchButtonData,
        flags: flags,
        hasInheritedRestrictions: // Analytics
        hasInheritedRestrictions,
        generalAccessLevel: generalAccessLevel
    };
}
function $0bd64daed89f93f8$var$makeShareToSlackDialogBodyProps(statesAndActions) {
    const { actions: { closeShareToSlackDialog: closeShareToSlackDialog, showFlag: showFlag } } = statesAndActions;
    return {
        onCloseSlack: closeShareToSlackDialog,
        showFlag: showFlag
    };
}
function $0bd64daed89f93f8$var$makeAccessRequestsDialogBodyProps(statesAndActions) {
    const { masterState: { isAccessRequestsWarnRestrictionsDialogOpen: isAccessRequestsWarnRestrictionsDialogOpen, isAccessRequestsResolveRestrictionsDialogOpen: isAccessRequestsResolveRestrictionsDialogOpen }, controllerProps: { initialDialog: initialDialog }, actions: { maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser, setAccessRequestsChanges: setAccessRequestsChanges } } = statesAndActions;
    return {
        isInitialDialog: initialDialog === 'accessRequests',
        isBlockedAccessFlowActive: isAccessRequestsWarnRestrictionsDialogOpen || isAccessRequestsResolveRestrictionsDialogOpen,
        maybeStartBlockedAccessFlowForUser: maybeStartBlockedAccessFlowForUser,
        onAccessRequestsChange: setAccessRequestsChanges
    };
}
function $0bd64daed89f93f8$export$77a8a4378967e36f(statesAndActions) {
    const { derivedState: { specificAccessIds: specificAccessIds, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails } } = statesAndActions;
    if (shouldShowDeletedGroupDetails) return {
        principals: [
            $0bd64daed89f93f8$var$makeSpecificAccessRowProps(statesAndActions, 'deleted-group')
        ]
    };
    const principals = specificAccessIds.map((id)=>$0bd64daed89f93f8$var$makeSpecificAccessRowProps(statesAndActions, id));
    return {
        principals: principals
    };
}
/**
 * Naming scheme caveat: this performs the functionality that would have been
 * covered by makePrincipalDetailsProps and makePrincipalAccessProps, if they
 * existed separately.
 */ function $0bd64daed89f93f8$var$makeSpecificAccessRowProps(statesAndActions, principalId) {
    const { derivedState: { principalsMap: principalsMap, isLockedOut: isLockedOut, stagedGeneralAccessLevel: stagedGeneralAccessLevel, isRestrictionsEditable: isRestrictionsEditable, willBeUnpublishedAfterApplying: willBeUnpublishedAfterApplying, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails }, queriesState: { currentUser: currentUser, hasInheritedRestrictions: hasInheritedRestrictions, edition: edition }, actions: { changeSpecificAccessRole: changeSpecificAccessRole, removeSpecificAccessPrincipal: removeSpecificAccessPrincipal } } = statesAndActions;
    const isYou = principalId === currentUser.id;
    let principal;
    let role;
    const mapEntry = principalsMap.get(principalId);
    // If the principal is in the map, then we know specifically what role they've
    // been assigned to
    if (mapEntry) {
        principal = mapEntry.principal;
        role = mapEntry.role;
        // If the principal is newly added or reassigned, we need to know about it for better errors.
        if (mapEntry.isNewOrUpdatedPrincipal && principal.type === 'user' && !(0, $4Ewfm.isUserPendingAccess)(principal)) principal = {
            ...principal,
            knownErrors: undefined
        };
    } else {
        role = ({
            'open-can-edit': 'can-edit',
            'open-can-view': 'can-view',
            restricted: 'no-access'
        })[stagedGeneralAccessLevel];
        /** Adding this dummy principal group to show that a group that holds restrictions to the content has been deleted.
		 * This only is accessible, and only happens, when the viewing user is using admin key to view the content.
		 * Please see CONFCLOUD-80781 for more details. https://jira.atlassian.com/browse/CONFCLOUD-80781
		 */ if (shouldShowDeletedGroupDetails) principal = {
            type: 'group',
            id: '',
            name: '',
            usageType: null
        };
        if (isYou) principal = currentUser;
        else // Things have gone very wrong if we get to this point. We can't not
        // supply props, so we'll just show the id as their name.
        principal = {
            type: 'user',
            id: principalId,
            avatarUrl: '',
            name: principalId,
            email: '',
            knownErrors: undefined,
            sitePermissionType: ''
        };
    }
    const updateKnownErrors = (id, errors)=>{
        const currentPrincipal = principalsMap.get(id);
        if (currentPrincipal && currentPrincipal.principal.type === 'user') currentPrincipal.principal.knownErrors = errors;
    };
    const isEditable = ()=>{
        if (shouldShowDeletedGroupDetails) return false;
        return !isYou && isRestrictionsEditable;
    };
    return {
        key: principal.id,
        principalAccess: {
            isLockedOut: isLockedOut,
            access: role,
            isEditable: isEditable(),
            isCanViewDisabled: stagedGeneralAccessLevel !== 'restricted',
            hasInheritedRestrictions: hasInheritedRestrictions,
            isUnpublishedDraft: willBeUnpublishedAfterApplying,
            edition: edition,
            onChange: (changedRole)=>{
                changeSpecificAccessRole(changedRole, principalId);
            },
            onRemove: ()=>{
                removeSpecificAccessPrincipal(principalId);
            },
            focusRef: null
        },
        principalDetails: {
            principal: principal,
            isYou: isYou,
            role: role,
            updateKnownErrors: updateKnownErrors,
            isDraft: willBeUnpublishedAfterApplying,
            shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails
        }
    };
}



var $k030f = parcelRequire("k030f");





var $lTbRO = parcelRequire("lTbRO");

function $54136b5c7c1b0d84$export$9bdff362a7bad17f(statesAndActions) {
    const { derivedState: { natureOfCta: natureOfCta, isPublishModalFlow: isPublishModalFlow } } = statesAndActions;
    return natureOfCta === 'none' ? {
        ctaNotifyMessageFooter: undefined,
        distributionFooter: isPublishModalFlow ? undefined : $54136b5c7c1b0d84$var$makeDistributionFooterProps(statesAndActions)
    } : {
        ctaNotifyMessageFooter: $54136b5c7c1b0d84$export$4282260c0ab9cae7(statesAndActions),
        distributionFooter: isPublishModalFlow ? undefined : $54136b5c7c1b0d84$var$makeDistributionFooterProps(statesAndActions)
    };
}
function $54136b5c7c1b0d84$var$isPublicLinkEditAllowedForContentType(statesAndActions) {
    const { publicLinkPageData: publicLinkPageData } = statesAndActions.queriesState;
    return publicLinkPageData.isLoading ? false : publicLinkPageData.isPublicLinkEditAllowedForContentType;
}
function $54136b5c7c1b0d84$var$isPublicLinkOn(statesAndActions) {
    const { publicLinkPageData: publicLinkPageData } = statesAndActions.queriesState;
    if (!publicLinkPageData.isLoading && publicLinkPageData.publicLinkStatus === (0, $k030f.PublicLinkPageStatus).ON) return true;
    return false;
}
function $54136b5c7c1b0d84$var$makeDistributionFooterProps(statesAndActions) {
    const { actions: { openPublicLinkDialog: openPublicLinkDialog, openShareToSlackDialog: openShareToSlackDialog, clearElementToFocus: clearElementToFocus }, controllerProps: { contentId: contentId, contentType: contentType, contentSubType: contentSubType, pageMode: pageMode, isUnpublishedDraft: isUnpublishedDraft }, queriesState: { spaceKey: spaceKey }, derivedState: { isLockedOut: isLockedOut, natureOfCta: natureOfCta }, controllerExtras: { publicLinkButtonRef: publicLinkButtonRef, shareToSlackButtonRef: shareToSlackButtonRef } } = statesAndActions;
    return {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        pageMode: pageMode,
        isLockedOut: isLockedOut,
        isUnpublishedDraft: isUnpublishedDraft,
        isLivePage: contentSubType === 'live',
        onSlackClick: openShareToSlackDialog,
        onPublicLinkClick: openPublicLinkDialog,
        isPublicLinkOn: $54136b5c7c1b0d84$var$isPublicLinkOn(statesAndActions),
        isPublicLinkEditAllowedForContentType: $54136b5c7c1b0d84$var$isPublicLinkEditAllowedForContentType(statesAndActions),
        lastTriggeredDialogVariant: statesAndActions.masterState.lastTriggeredDialogVariant,
        clearElementToFocus: clearElementToFocus,
        publicLinkButtonRef: publicLinkButtonRef,
        shareToSlackButtonRef: shareToSlackButtonRef,
        natureOfCta: natureOfCta
    };
}
function $54136b5c7c1b0d84$var$makeMessageComposerProps(statesAndActions, rows, notifyCheckbox) {
    const { derivedState: { isLockedOut: isLockedOut }, masterState: { optionalMessage: optionalMessage }, actions: { changeOptionalMessage: changeOptionalMessage } } = statesAndActions;
    return {
        isLockedOut: isLockedOut,
        notifyMessage: optionalMessage,
        rows: rows,
        isCheckboxUnchecked: notifyCheckbox === 'unchecked',
        onNotifyMessageChange: changeOptionalMessage
    };
}
function $54136b5c7c1b0d84$export$4282260c0ab9cae7(statesAndActions) {
    const { masterState: { isSaving: isSaving, notifyCheckedIfAvailable: notifyCheckedIfAvailable, showMessageComposerUnderCheckbox: showMessageComposerUnderCheckbox, isSpecificAccessExpanded: isSpecificAccessExpanded, principalsStagerPrincipals: principalsStagerPrincipals }, derivedState: { isLockedOut: isLockedOut, natureOfCta: natureOfCta, isCheckboxVisible: isCheckboxVisible, areEmailsOnlyPresent: areEmailsOnlyPresent, sharingType: sharingType, specificAccessIds: specificAccessIds, exceededLimit: exceededLimit, isSharingToEmailsDisabled: isSharingToEmailsDisabled, includeInvites: includeInvites, stagedGeneralAccessLevel: stagedGeneralAccessLevel }, actions: actions, controllerProps: { pageMode: pageMode, isUnpublishedDraft: isUnpublishedDraft, contentSubType: contentSubType, contentId: contentId } } = statesAndActions;
    const notifyCheckbox = (()=>{
        if (!isCheckboxVisible) return 'hidden';
        return notifyCheckedIfAvailable ? 'checked' : 'unchecked';
    })();
    const shouldShowMessageComposer = (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') || notifyCheckbox === 'checked' && showMessageComposerUnderCheckbox;
    const checkboxLabel = (()=>{
        if ((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) return 'notify-them';
        if (areEmailsOnlyPresent) return 'recipients';
        return 'newly-added';
    })();
    const isSpecificAccessDetailsVisible = specificAccessIds.length > 0 && isSpecificAccessExpanded;
    const hasGroups = principalsStagerPrincipals.some((p)=>p.type === 'group');
    const hasTeams = principalsStagerPrincipals.some((p)=>p.type === 'team');
    const hasUsers = principalsStagerPrincipals.some((p)=>p.type && [
            'user',
            'guest',
            'email'
        ].includes(p.type));
    const principalsCount = (0, $lTbRO.makePrincipalsMap)(statesAndActions.masterState, statesAndActions.queriesState, {
        isCtaClick: true,
        stagedGeneralAccessLevel: stagedGeneralAccessLevel
    }).size;
    const messageComposerRows = (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? 5 : 3;
    return {
        natureOfCta: natureOfCta,
        notifyCheckbox: notifyCheckbox,
        checkboxLabel: checkboxLabel,
        isLockedOut: isLockedOut,
        isCtaInProgress: isSaving,
        messageComposer: shouldShowMessageComposer ? $54136b5c7c1b0d84$var$makeMessageComposerProps(statesAndActions, messageComposerRows, notifyCheckbox) : undefined,
        sharingType: sharingType,
        onCtaClick: actions.handleCtaClick,
        onCancelClick: actions.dismiss,
        isSpecificAccessDetailsVisible: isSpecificAccessDetailsVisible,
        onNotifyCheckboxClick: ()=>{
            actions.setNotifyChecked(!notifyCheckedIfAvailable);
        },
        onNotifyAddMessageClick: actions.toggleNotifyAddMessage,
        isLimitExceeded: exceededLimit.isLimitExceeded,
        pageMode: pageMode,
        isDraft: isUnpublishedDraft,
        isLivePage: contentSubType === 'live',
        isSharingToEmailsDisabled: isSharingToEmailsDisabled,
        contentId: contentId,
        hasGroups: hasGroups,
        hasTeams: hasTeams,
        hasUsers: hasUsers,
        includeInvites: includeInvites,
        generalAccessLevel: stagedGeneralAccessLevel,
        principalsCount: principalsCount
    };
}


function $30289176ede6cef8$export$65579a897c625295(statesAndActions) {
    const { masterState: { isPublicLinkDialogOpen: isPublicLinkDialogOpen, isShareToSlackDialogOpen: isShareToSlackDialogOpen, isAccessRequestsDialogOpen: isAccessRequestsDialogOpen, isSpecificAccessDialogOpen: isSpecificAccessDialogOpen }, derivedState: { isChanged: isChanged, specificAccessIds: specificAccessIds, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails, natureOfCta: natureOfCta } } = statesAndActions;
    const isAnotherDialogOpen = isPublicLinkDialogOpen || isShareToSlackDialogOpen || isAccessRequestsDialogOpen || isSpecificAccessDialogOpen;
    const hideSpecificAccessDetails = ()=>{
        if (shouldShowDeletedGroupDetails) return false;
        return isAnotherDialogOpen || specificAccessIds.length === 0 || natureOfCta !== 'none' && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment');
    };
    return {
        titleAndButtons: $30289176ede6cef8$var$makeTitleAndButtonsProps(statesAndActions),
        generalAccess: natureOfCta !== 'none' && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') || isAnotherDialogOpen ? undefined : $30289176ede6cef8$export$e8476d69fc2f2601(statesAndActions),
        principalsStager: isAnotherDialogOpen ? undefined : $30289176ede6cef8$export$9d1f24bd004942b(statesAndActions),
        tabSelection: isSpecificAccessDialogOpen && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? $30289176ede6cef8$var$makeTabSelectionProps() : undefined,
        specificAccessFilter: isSpecificAccessDialogOpen && (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? $30289176ede6cef8$var$makeSpecificAccessFilterProps() : undefined,
        infoMessage: $30289176ede6cef8$var$makeInfoMessageProps(statesAndActions),
        hasNavigationLockout: isChanged,
        specificAccess: hideSpecificAccessDetails() ? undefined : $30289176ede6cef8$var$makeSpecificAccessProps(statesAndActions),
        ctaNotifyMessageFooter: (0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment') ? (0, $54136b5c7c1b0d84$export$4282260c0ab9cae7)(statesAndActions) : undefined
    };
}
function $30289176ede6cef8$var$makeInfoMessageProps(statesAndActions) {
    const { controllerProps: { contentType: contentType, contentId: contentId }, queriesState: { edition: edition }, derivedState: { isRestrictionsEditable: isRestrictionsEditable, isPublishModalFlow: isPublishModalFlow, willBeUnpublishedAfterApplying: willBeUnpublishedAfterApplying, stagedGeneralAccessLevel: stagedGeneralAccessLevel }, masterState: { isPublicLinkDialogOpen: isPublicLinkDialogOpen }, controllerExtras: { shouldRenderDisablePublicLinkFeature: shouldRenderDisablePublicLinkFeature } } = statesAndActions;
    const messageType = $30289176ede6cef8$var$getMessageType(contentType, isRestrictionsEditable, isPublishModalFlow, willBeUnpublishedAfterApplying, edition, stagedGeneralAccessLevel, isPublicLinkDialogOpen, $30289176ede6cef8$export$fb9d88d05ca6623f(statesAndActions), shouldRenderDisablePublicLinkFeature);
    return messageType === undefined ? undefined : {
        messageType: messageType,
        publishModalInfoBoxProps: isPublishModalFlow ? $30289176ede6cef8$var$makePublishModalInfoBoxProps(statesAndActions) : undefined,
        askToEditBoxProps: messageType === 'askToEdit' ? {
            contentId: contentId,
            stagedGeneralAccessLevel: stagedGeneralAccessLevel
        } : undefined
    };
}
function $30289176ede6cef8$export$fb9d88d05ca6623f(statesAndActions) {
    const { queriesState: { userCanEditContent: userCanEditContent } } = statesAndActions;
    if (userCanEditContent) return false;
    const { principals: principals } = (0, $0bd64daed89f93f8$export$77a8a4378967e36f)(statesAndActions);
    const currentUserHasSpecificAccessToEdit = principals.some((principal)=>principal.principalDetails.isYou && principal.principalAccess.access === 'can-edit');
    if (currentUserHasSpecificAccessToEdit) // We don't show Ask to Edit Info Message if user has specific access to EDIT
    // BTW they are most likely blocked at space / parent level, because
    // at this point we know for a fact they cannot edit the document
    return false;
    return true;
}
function $30289176ede6cef8$var$getMessageType(contentType, isRestrictionsEditable, isPublishModalFlow, willBeUnpublishedAfterApplying, edition, generalAccessLevel, isPublicLinkDialogOpen, isReadyToShowAskToEditInfoMessage, shouldRenderDisablePublicLinkFeature) {
    if (edition === 'FREE') {
        // Free edition upsell is only shown for open-can-edit
        if (isPublicLinkDialogOpen) return 'freeEditionPublicLinkUpsell';
        return generalAccessLevel === 'open-can-edit' ? 'freeEditionUpsell' : undefined;
    } else {
        if (shouldRenderDisablePublicLinkFeature && isPublicLinkDialogOpen) return 'freeTrialPublicLinkUpsell';
    }
    if (contentType === 'embed') return 'smartLink';
    if (!isRestrictionsEditable && !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_contextual_ask_to_edit', 'cohort', 'experiment')) return 'uneditableRestrictions';
    if (isPublishModalFlow) return 'publishModal';
    if (willBeUnpublishedAfterApplying && generalAccessLevel !== 'restricted') return 'draft';
    if (isReadyToShowAskToEditInfoMessage && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_contextual_ask_to_edit', 'cohort', 'experiment')) return 'askToEdit';
    return undefined;
}
function $30289176ede6cef8$var$makePublishModalInfoBoxProps(statesAndActions) {
    const { controllerProps: { contentType: contentType }, derivedState: { isUnpublishedDraft: isUnpublishedDraft } } = statesAndActions;
    return {
        isUnpublishedDraft: isUnpublishedDraft,
        contentType: contentType
    };
}
function $30289176ede6cef8$var$makeTitleAndButtonsProps(statesAndActions) {
    const { actions: { dismiss: dismiss, closePublicLinkDialog: closePublicLinkDialog, closeShareToSlackDialog: closeShareToSlackDialog, closeAccessRequestsDialog: closeAccessRequestsDialog, openAccessRequestsDialog: openAccessRequestsDialog, clearElementToFocus: clearElementToFocus, closeSpecificAccessDialog: closeSpecificAccessDialog }, masterState: { isPublicLinkDialogOpen: isPublicLinkDialogOpen, isShareToSlackDialogOpen: isShareToSlackDialogOpen, isAccessRequestsDialogOpen: isAccessRequestsDialogOpen, lastTriggeredDialogVariant: lastTriggeredDialogVariant, isSpecificAccessDialogOpen: isSpecificAccessDialogOpen } } = statesAndActions;
    let title, onBackClick, accessRequests;
    if (isShareToSlackDialogOpen) {
        title = 'slack';
        onBackClick = closeShareToSlackDialog;
    } else if (isPublicLinkDialogOpen) {
        title = 'publicLink';
        onBackClick = closePublicLinkDialog;
    } else if (isAccessRequestsDialogOpen) {
        title = 'accessRequests';
        onBackClick = closeAccessRequestsDialog;
    } else if (isSpecificAccessDialogOpen) {
        title = 'specificAccess';
        onBackClick = closeSpecificAccessDialog;
    } else {
        title = 'share';
        // These are the properties for the Access Requests Button
        // Which we only want on the main Share dialog and nowhere else
        accessRequests = {
            lastTriggeredDialogVariant: lastTriggeredDialogVariant,
            clearElementToFocus: clearElementToFocus,
            openAccessRequestsDialog: openAccessRequestsDialog
        };
    }
    return {
        title: title,
        overflowMenu: $30289176ede6cef8$var$makeOverflowMenuProps(statesAndActions),
        onCloseClick: dismiss,
        onBackClick: onBackClick,
        accessRequests: accessRequests
    };
}
function $30289176ede6cef8$export$e8476d69fc2f2601(statesAndActions) {
    const { derivedState: { isRestrictionsEditable: isRestrictionsEditable, stagedGeneralAccessLevel: stagedGeneralAccessLevel, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails } } = statesAndActions;
    return {
        shouldShowUneditableRestrictionsInfoIcon: !isRestrictionsEditable && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_contextual_ask_to_edit', 'cohort', 'experiment'),
        generalAccessLevelSelectorProps: $30289176ede6cef8$var$makeGeneralAccessLevelSelectorProps(statesAndActions),
        generalAccessPermissionDropdownProps: stagedGeneralAccessLevel === 'restricted' || shouldShowDeletedGroupDetails ? undefined : $30289176ede6cef8$var$makeGeneralAccessPermissionDropdownProps(statesAndActions)
    };
}
function $30289176ede6cef8$var$makeOverflowMenuProps(statesAndActions) {
    const { queriesState: { spaceKey: spaceKey, edition: edition }, actions: { openInspectPermsDialog: openInspectPermsDialog }, controllerProps: { contentId: contentId } } = statesAndActions;
    return {
        spaceKey: spaceKey,
        isSpaceAdmin: false,
        edition: // TODO
        edition,
        openInspectPermsDialog: openInspectPermsDialog,
        contentId: contentId
    };
}
function $30289176ede6cef8$var$makeGeneralAccessLevelSelectorProps(statesAndActions) {
    const { controllerProps: { contentType: contentType, contentSubType: contentSubType }, derivedState: { isLockedOut: isLockedOut, stagedGeneralAccessLevel: stagedGeneralAccessLevel, isRestrictionsEditable: isRestrictionsEditable, willBeUnpublishedAfterApplying: willBeUnpublishedAfterApplying, shouldGeneralAccessMenuBeOpen: shouldGeneralAccessMenuBeOpen, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails, hasRestrictions: hasRestrictions, hasViewRestrictions: hasViewRestrictions, hasInheritedRestrictions: hasInheritedRestrictions }, queriesState: { parentPageLink: parentPageLink, edition: edition }, actions: { changeGeneralAccessOpenRestricted: changeGeneralAccessOpenRestricted, openSpaceAccessDetails: openSpaceAccessDetails, showOpenAccessWarningDialog: showOpenAccessWarningDialog }, masterState: { shouldResolveMismatchedRestrictions: shouldResolveMismatchedRestrictions, isSaving: isSaving } } = statesAndActions;
    return {
        isLockedOut: isLockedOut,
        isDraft: willBeUnpublishedAfterApplying,
        hasInheritedRestrictions: hasInheritedRestrictions,
        onOpenRestrictedChange: changeGeneralAccessOpenRestricted,
        openSpaceAccessDetails: openSpaceAccessDetails,
        handleOpenAccessWarningDialog: showOpenAccessWarningDialog,
        shouldGeneralAccessMenuBeOpen: shouldGeneralAccessMenuBeOpen,
        isEditable: isRestrictionsEditable,
        showLongSubtext: false,
        generalAccessLevel: stagedGeneralAccessLevel,
        parentPageLink: parentPageLink,
        isLivePage: contentSubType === 'live',
        contentType: contentType,
        edition: edition,
        hasRestrictions: hasRestrictions,
        hasViewRestrictions: hasViewRestrictions,
        shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails,
        shouldResolveMismatchedRestrictions: shouldResolveMismatchedRestrictions,
        isSaving: isSaving
    };
}
function $30289176ede6cef8$var$makeGeneralAccessPermissionDropdownProps(statesAndActions) {
    const { controllerProps: { contentType: contentType, contentSubType: contentSubType }, derivedState: { isLockedOut: isLockedOut, stagedGeneralAccessLevel: stagedGeneralAccessLevel, isRestrictionsEditable: isRestrictionsEditable, willBeUnpublishedAfterApplying: willBeUnpublishedAfterApplying, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails }, queriesState: { hasInheritedRestrictions: hasInheritedRestrictions, edition: edition }, actions: { changeGeneralAccessCanViewCanEdit: changeGeneralAccessCanViewCanEdit }, masterState: { isSaving: isSaving } } = statesAndActions;
    return {
        isLockedOut: isLockedOut,
        generalAccessLevel: contentType === 'embed' ? 'open-can-view' : stagedGeneralAccessLevel,
        onCanViewCanEditChange: changeGeneralAccessCanViewCanEdit,
        // Drafts only have an Edit mode by nature, so dropdown is not editable
        isEditable: shouldShowDeletedGroupDetails || isRestrictionsEditable && !willBeUnpublishedAfterApplying && edition !== (0, $d9tcB.ConfluenceEdition).FREE,
        hasInheritedRestrictions: hasInheritedRestrictions,
        isDraft: willBeUnpublishedAfterApplying,
        isLivePage: contentSubType === 'live',
        contentType: contentType,
        isSaving: isSaving
    };
}
function $30289176ede6cef8$var$makeSpecificAccessProps(statesAndActions) {
    const { derivedState: { isRemoveAllButtonVisible: isRemoveAllButtonVisible, isRestrictionsEditable: isRestrictionsEditable, specificAccessIds: specificAccessIds }, masterState: { isSpecificAccessExpanded: isSpecificAccessExpanded }, actions: { removeAllSpecificAccessPrincipals: removeAllSpecificAccessPrincipals }, queriesState: { edition: edition } } = statesAndActions;
    return {
        facepileRow: specificAccessIds.length > 1 ? $30289176ede6cef8$var$makeFacepileRowProps(statesAndActions) : undefined,
        isExpanded: isSpecificAccessExpanded,
        onRemoveAllClick: isRestrictionsEditable && isRemoveAllButtonVisible ? removeAllSpecificAccessPrincipals : undefined,
        edition: edition
    };
}
const $30289176ede6cef8$var$youNameI18n = (0, $cgtv4.defineMessages)({
    you: {
        id: "share-and-restrict-dialog.makeBodyProps.avatarGroupData.you",
        defaultMessage: "{name} (You)"
    }
});
function $30289176ede6cef8$export$a225624054864e33(statesAndActions) {
    const { derivedState: { principalsMap: principalsMap, specificAccessIds: specificAccessIds, shouldShowDeletedGroupDetails: shouldShowDeletedGroupDetails }, queriesState: { currentUserHasAccess: currentUserHasAccess }, controllerExtras: { formatMessage: formatMessage } } = statesAndActions;
    const result = [];
    const addTeamAvatar = (usageType, avatarSrc)=>{
        // only one team avatar total; it prefers slot 1 (right after "You")
        const alreadyHasTeam = result.some((principal)=>principal.type === 'team');
        if (alreadyHasTeam) return;
        const team = {
            key: 'teamAvatar',
            name: '',
            type: 'team',
            usageType: usageType || (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION,
            src: avatarSrc
        };
        if (!result[1]) // slot 1 is empty, pushing places it there if "You" is at index 0
        result.push(team);
        else if (result[1].type === 'user' || result[1].type === 'group') // displace user/group at position 1 (teams have priority)
        result.splice(1, 0, team);
    };
    const addGroupAvatar = (usageType)=>{
        // only one userbase group avatar total; it must not displace teams
        const alreadyHasGroup = result.some((principal)=>principal.type === 'group');
        if (alreadyHasGroup) return;
        const group = {
            key: 'groupAvatar',
            name: '',
            type: 'group',
            usageType: usageType
        };
        if (!result[1] || shouldShowDeletedGroupDetails) // take position 1 if empty, or when showing deleted group details
        result.push(group);
        else if (result[1].type === 'user') // can displace a user at position 1
        result.splice(1, 0, group);
        else // position 1 is a team — append to end
        result.push(group);
    };
    const addUserAvatar = (principal, isFirst)=>{
        const name = isFirst && currentUserHasAccess ? formatMessage($30289176ede6cef8$var$youNameI18n.you, {
            name: principal.name
        }) : principal.name;
        result.push({
            key: principal.id,
            name: name,
            src: principal.avatarUrl,
            type: 'user'
        });
    };
    specificAccessIds.forEach((id, idx)=>{
        const entry = principalsMap.get(id);
        if (!entry) return;
        const { principal: principal } = entry;
        // When showing deleted group details, we prioritize the group visuals
        if (principal.type === 'group' || shouldShowDeletedGroupDetails) {
            if (principal.type === 'group') {
                const isTeamCollaboration = principal.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
                const isUserbaseGroup = principal.usageType === (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
                if (isTeamCollaboration) {
                    // All team collaboration groups should create team avatars
                    const avatarSrc = 'avatarSrc' in principal ? principal.avatarSrc : undefined;
                    addTeamAvatar(principal.usageType, avatarSrc);
                    return;
                }
                if (isUserbaseGroup && principal.usageType) {
                    addGroupAvatar(principal.usageType);
                    return;
                }
                // When usageType is null (because the BE sends the data but teams are not yet supported on the FE),
                // fall back to default user base group behavior.
                if (principal.usageType === null) {
                    addGroupAvatar((0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP);
                    return;
                }
            }
            // If shouldShowDeletedGroupDetails === true but this principal isn't a group,
            // we intentionally skip adding a user here.
            return;
        }
        if (principal.type === 'user') addUserAvatar({
            id: principal.id,
            name: principal.name,
            avatarUrl: principal.avatarUrl
        }, idx === 0);
    });
    return result;
}
function $30289176ede6cef8$var$makeFacepileRowProps(statesAndActions) {
    const { derivedState: { stagedGeneralAccessLevel: stagedGeneralAccessLevel, isUnpublishedDraft: isUnpublishedDraft, updatedGroupCount: updatedGroupCount, updatedTeamCount: updatedTeamCount }, masterState: { isSpecificAccessExpanded: isExpanded }, queriesState: { currentUserHasAccess: currentUserHasAccess }, controllerProps: { contentId: contentId, contentType: contentType, contentSubType: contentSubType, pageMode: pageMode }, actions: { toggleSpecificAccessExpanded: toggleSpecificAccessExpanded, openSpecificAccessDialog: openSpecificAccessDialog } } = statesAndActions;
    return {
        avatarGroupData: $30289176ede6cef8$export$a225624054864e33(statesAndActions),
        groupCount: updatedGroupCount,
        teamCount: updatedTeamCount,
        isExpanded: isExpanded,
        onExpandClick: toggleSpecificAccessExpanded,
        onOpenSpecificAccessDialog: openSpecificAccessDialog,
        generalAccessLevel: stagedGeneralAccessLevel,
        currentUserHasAccess: currentUserHasAccess,
        analyticsAttributes: {
            contentId: contentId,
            contentType: contentType,
            contentSubType: contentSubType,
            isLivePage: contentSubType === 'live',
            isDraft: isUnpublishedDraft,
            isPublicLinkOn: false,
            pageMode: pageMode
        }
    };
}
function $30289176ede6cef8$export$9d1f24bd004942b(statesAndActions) {
    const { masterState: { principalsStagerPrincipals: principals, addMode: addMode, optionalMessage: optionalMessage, isSaving: isSaving }, derivedState: { isLockedOut: isLockedOut, stagedGeneralAccessLevel: stagedGeneralAccessLevel, areEmailsOnlyPresent: areEmailsOnlyPresent, isRestrictionsEditable: isRestrictionsEditable, willBeUnpublishedAfterApplying: willBeUnpublishedAfterApplying, exceededLimit: exceededLimit, specificAccessIds: specificAccessIds, isSharingToEmailsDisabled: isSharingToEmailsDisabled, natureOfCta: natureOfCta }, actions: { changeStagedPrincipals: changeStagedPrincipals, changeAddMode: changeAddMode, markPrincipalsAsInvited: markPrincipalsAsInvited, markPrincipalsAsSkipped: markPrincipalsAsSkipped, handleCtaClick: handleCtaClick }, controllerProps: { contentId: contentId, defaultSuggestedUsers: defaultSuggestedUsers }, queriesState: { currentUser: currentUser } } = statesAndActions;
    const noStagedPrincipals = principals.length === 0;
    function getDropdown() {
        if (stagedGeneralAccessLevel === 'open-can-edit') return 'hidden';
        if (noStagedPrincipals) return 'hidden';
        if (areEmailsOnlyPresent) return 'hidden';
        if (!isRestrictionsEditable) return 'hidden';
        return addMode === 'as-editor' ? 'can-edit' : 'can-view';
    }
    const currentUserEmailDomain = currentUser?.type === 'user' ? currentUser.email?.split('@')[1] : undefined;
    const charLimitExceeded = optionalMessage.length > 500;
    return {
        isLockedOut: isLockedOut,
        principals: principals,
        exceededLimit: exceededLimit,
        dropdown: getDropdown(),
        isDropdownEditable: !willBeUnpublishedAfterApplying,
        onChangePrincipals: changeStagedPrincipals,
        onChangeDropdown: changeAddMode,
        specificAccessIds: specificAccessIds,
        isSharingToEmailsDisabled: isSharingToEmailsDisabled,
        contentId: contentId,
        defaultSuggestedUsers: defaultSuggestedUsers,
        currentUserEmailDomain: currentUserEmailDomain,
        markPrincipalsAsInvited: markPrincipalsAsInvited,
        markPrincipalsAsSkipped: markPrincipalsAsSkipped,
        handleCtaClick: handleCtaClick,
        isCtaInProgress: isSaving,
        charLimitExceeded: charLimitExceeded,
        natureOfCta: natureOfCta
    };
}
function $30289176ede6cef8$var$makeSpecificAccessFilterProps() {
    return 'show specific access filter';
}
function $30289176ede6cef8$var$makeTabSelectionProps() {
    return 'show tab selection';
}





var $4adOe = parcelRequire("4adOe");

function $a19e9ce590690ace$export$a5f2eef130400ce1(statesAndActions) {
    const { masterState: { sessionState: sessionState, isCloseConfirmationOpen: isCloseConfirmationOpen, isSpaceAccessDetailsOpen: isSpaceAccessDetailsOpen, isInspectPermsDialogOpen: isInspectPermsDialogOpen, isOpenAccessWarningDialogOpen: isOpenAccessWarningDialogOpen, isAccessRequestsWarnRestrictionsDialogOpen: isAccessRequestsWarnRestrictionsDialogOpen, isAccessRequestsResolveRestrictionsDialogOpen: isAccessRequestsResolveRestrictionsDialogOpen } } = statesAndActions;
    return {
        shareAndRestrictDialog: sessionState === 'shareAndRestrict' ? $a19e9ce590690ace$var$makeShareAndRestrictDialogProps(statesAndActions) : undefined,
        restrictedAccessWarningDialog: sessionState === 'warnRestrictedAccess' || isAccessRequestsWarnRestrictionsDialogOpen ? $a19e9ce590690ace$var$makeRestrictedAccessWarningDialog(statesAndActions) : undefined,
        groupNotifyWarningDialog: sessionState === 'confirmGroupNotifications' ? $a19e9ce590690ace$var$makeGroupNotifyWarningDialog(statesAndActions) : undefined,
        resolveRestrictionsDialog: sessionState === 'resolveRestrictions' || isAccessRequestsResolveRestrictionsDialogOpen ? $a19e9ce590690ace$var$makeResolveRestrictionsDialogProps(statesAndActions) : undefined,
        closeConfirmationDialog: isCloseConfirmationOpen ? $a19e9ce590690ace$var$makeCloseConfirmationProps(statesAndActions) : undefined,
        spaceAccessDetails: isSpaceAccessDetailsOpen ? $a19e9ce590690ace$var$makeSpaceAccessDetailsProps(statesAndActions) : undefined,
        inspectPermsDialog: isInspectPermsDialogOpen ? $a19e9ce590690ace$var$makeInspectPermsDialogProps(statesAndActions) : undefined,
        openAccessWarningDialog: isOpenAccessWarningDialogOpen ? $a19e9ce590690ace$var$makeOpenAccessWarningDialogProps(statesAndActions) : undefined
    };
}
function $a19e9ce590690ace$var$makeShareAndRestrictDialogProps(statesAndActions) {
    const { actions: { dismiss: dismiss, potentialFinalDialogDidCompleteClose: potentialFinalDialogDidCompleteClose, openAccessRequestsDialog: openAccessRequestsDialog }, masterState: { isPublicLinkDialogOpen: isPublicLinkDialogOpen, isShareToSlackDialogOpen: isShareToSlackDialogOpen, isAccessRequestsDialogOpen: isAccessRequestsDialogOpen, isSpecificAccessDialogOpen: isSpecificAccessDialogOpen }, derivedState: { isUnpublishedDraft: isUnpublishedDraft, stagedGeneralAccessLevel: stagedGeneralAccessLevel }, queriesState: { hasInheritedRestrictions: hasInheritedRestrictions }, controllerProps: { contentId: contentId, contentType: contentType, contentSubType: contentSubType, pageMode: pageMode, openFrom: openFrom, showDialogNudgeSpotlight: showDialogNudgeSpotlight, initialDialog: initialDialog, onInitialDialogOpen: onInitialDialogOpen } } = statesAndActions;
    const isAnotherDialogOpen = isPublicLinkDialogOpen || isShareToSlackDialogOpen || isAccessRequestsDialogOpen || isSpecificAccessDialogOpen;
    const hideFooter = isAnotherDialogOpen;
    return {
        header: (0, $30289176ede6cef8$export$65579a897c625295)(statesAndActions),
        body: (0, $0bd64daed89f93f8$export$a5b33d4c110952eb)(statesAndActions),
        footer: hideFooter ? undefined : (0, $54136b5c7c1b0d84$export$9bdff362a7bad17f)(statesAndActions),
        onCloseRequest: dismiss,
        onCloseComplete: potentialFinalDialogDidCompleteClose,
        showDialogNudgeSpotlight: showDialogNudgeSpotlight,
        openAccessRequestsDialog: (initialDialog && openAccessRequestsDialog) ?? undefined,
        onInitialDialogOpen: onInitialDialogOpen,
        analyticsAttributes: {
            contentId: contentId,
            contentType: contentType,
            contentSubType: contentSubType,
            isLivePage: contentSubType === 'live',
            isDraft: isUnpublishedDraft,
            pageMode: pageMode,
            generalAccessLevel: stagedGeneralAccessLevel,
            hasInheritedRestrictions: hasInheritedRestrictions,
            openFrom: openFrom
        }
    };
}
function $a19e9ce590690ace$var$makeGroupNotifyWarningDialog(statesAndActions) {
    const { masterState: { isSaving: isSaving }, derivedState: { stagedNotificationRecipients: stagedNotificationRecipients }, actions: { doNotifyGroupsConfirmed: doNotifyGroupsConfirmed, doNotNotifyGroupsConfirmed: doNotNotifyGroupsConfirmed, potentialFinalDialogDidCompleteClose: potentialFinalDialogDidCompleteClose } } = statesAndActions;
    const groupNames = stagedNotificationRecipients.filter(({ type: type })=>type === 'group').map(({ name: name })=>name);
    const groupList = stagedNotificationRecipients.filter((recipient)=>recipient.type === 'group' || recipient.type === 'team');
    return {
        groupNames: groupNames,
        groupList: groupList,
        isSaving: isSaving,
        onDoNotify: doNotifyGroupsConfirmed,
        onDoNotNotify: doNotNotifyGroupsConfirmed,
        onCloseComplete: potentialFinalDialogDidCompleteClose
    };
}
function $a19e9ce590690ace$var$makeRestrictedAccessWarningDialog(statesAndActions) {
    const { controllerProps: { pageTitle: pageTitle }, masterState: { restrictedUserPrincipals: restrictedUserPrincipals, isAccessRequestsWarnRestrictionsDialogOpen: isAccessRequestsWarnRestrictionsDialogOpen }, actions: { ignoreRestrictionsAndContinue: ignoreRestrictionsAndContinue, potentialFinalDialogDidCompleteClose: potentialFinalDialogDidCompleteClose, closeAccessRequestsWarnRestrictionsDialog: closeAccessRequestsWarnRestrictionsDialog } } = statesAndActions;
    if (isAccessRequestsWarnRestrictionsDialogOpen) return {
        restrictedUserPrincipals: restrictedUserPrincipals,
        pageTitle: pageTitle,
        onSkip: closeAccessRequestsWarnRestrictionsDialog,
        triggeredBy: 'accessRequests',
        onCloseComplete: ()=>{}
    };
    return {
        restrictedUserPrincipals: restrictedUserPrincipals,
        pageTitle: pageTitle,
        triggeredBy: 'share',
        onSkip: ignoreRestrictionsAndContinue,
        onCloseComplete: potentialFinalDialogDidCompleteClose
    };
}
function $a19e9ce590690ace$var$makeCloseConfirmationProps(statesAndActions) {
    const { actions: { dismissCloseConfirmationDialog: dismissCloseConfirmationDialog, closeWithoutSaving: closeWithoutSaving }, controllerProps: { focusRef: focusRef } } = statesAndActions;
    return {
        onCancel: dismissCloseConfirmationDialog,
        onDiscard: closeWithoutSaving,
        focusRef: focusRef
    };
}
function $a19e9ce590690ace$var$makeSpaceAccessDetailsProps(statesAndActions) {
    const { controllerProps: controllerProps, actions: actions, queriesState: queriesState } = statesAndActions;
    return {
        onClose: actions.dismissSpaceAccessDetails,
        accessDetailsParams: {
            restrictingContentId: controllerProps.contentId,
            spaceKey: queriesState.spaceKey,
            hasInheritedRestrictions: queriesState.hasInheritedRestrictions,
            experience: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE)
        }
    };
}
function $a19e9ce590690ace$var$makeInspectPermsDialogProps(statesAndActions) {
    const { controllerProps: controllerProps, actions: actions } = statesAndActions;
    return {
        onClose: actions.dismissInspectPermsDialog,
        contentId: controllerProps.contentId
    };
}
function $a19e9ce590690ace$var$makeResolveRestrictionsDialogProps(statesAndActions) {
    const { controllerProps: { pageTitle: pageTitle, contentId: contentId }, masterState: { restrictedUserPrincipals: restrictedUserPrincipals, isAccessRequestsResolveRestrictionsDialogOpen: isAccessRequestsResolveRestrictionsDialogOpen, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection, addMode: addMode, accessRequestsCurrentUserAddMode: accessRequestsCurrentUserAddMode }, actions: { resolveRestrictionsComplete: resolveRestrictionsComplete, potentialFinalDialogDidCompleteClose: potentialFinalDialogDidCompleteClose, ignoreRestrictionsAndContinue: ignoreRestrictionsAndContinue, showErrorFlag: showErrorFlag, closeAccessRequestsResolveRestrictionsDialog: closeAccessRequestsResolveRestrictionsDialog } } = statesAndActions;
    if (isAccessRequestsResolveRestrictionsDialogOpen) {
        // This is mainly to satisfy the compiler
        // In practice we shouldn't have a case where Resolve Restrictions Dialog
        // Is open for Access Requests and the add mode is not specified
        if (!accessRequestsCurrentUserAddMode) return;
        return {
            contentId: contentId,
            pageTitle: pageTitle,
            restrictedUserPrincipals: restrictedUserPrincipals,
            assignableSpaceRolesIntersection: assignableSpaceRolesIntersection,
            addMode: accessRequestsCurrentUserAddMode,
            triggeredBy: 'accessRequests',
            onComplete: closeAccessRequestsResolveRestrictionsDialog,
            onCloseComplete: ()=>{},
            onSkip: closeAccessRequestsResolveRestrictionsDialog,
            showErrorFlag: showErrorFlag
        };
    }
    return {
        contentId: contentId,
        pageTitle: pageTitle,
        restrictedUserPrincipals: restrictedUserPrincipals,
        assignableSpaceRolesIntersection: assignableSpaceRolesIntersection,
        addMode: addMode,
        triggeredBy: 'share',
        onComplete: resolveRestrictionsComplete,
        onCloseComplete: potentialFinalDialogDidCompleteClose,
        onSkip: ignoreRestrictionsAndContinue,
        showErrorFlag: showErrorFlag
    };
}
function $a19e9ce590690ace$var$makeOpenAccessWarningDialogProps(statesAndActions) {
    const { actions: { closeOpenAccessWarningDialog: closeOpenAccessWarningDialog, closeWithoutSaving: closeWithoutSaving }, controllerProps: { contentId: contentId, refetchButtonData: refetchButtonData }, controllerExtras: { successFlag: successFlag, errorFlag: errorFlag } } = statesAndActions;
    const closeShareAndRestricDialog = ()=>{
        closeWithoutSaving();
        refetchButtonData();
    };
    return {
        generalAccess: (0, $30289176ede6cef8$export$e8476d69fc2f2601)(statesAndActions),
        closeOpenAccessWarningDialog: closeOpenAccessWarningDialog,
        successFlag: successFlag,
        errorFlag: errorFlag,
        closeShareAndRestricDialog: closeShareAndRestricDialog,
        contentId: contentId
    };
}
module.exports["makeDialogsProps"] = $a19e9ce590690ace$export$a5f2eef130400ce1;

});

parcelRegister("cMbwo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $dwp40 = parcelRequire("dwp40");


var $6SeRB = parcelRequire("6SeRB");


var $gabmL = parcelRequire("gabmL");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $4adOe = parcelRequire("4adOe");


var $2rrpN = parcelRequire("2rrpN");


var $1vrmd = parcelRequire("1vrmd");


var $1fjr9 = parcelRequire("1fjr9");





var $8oEoE = parcelRequire("8oEoE");

function $8e71fdfb647f76e1$export$b4fc4afbf9b55a0d({ publishModalRestrictions: publishModalRestrictions, spaceKey: spaceKey, publicLinkPageData: publicLinkPageData, data: data, contentType: contentType, edition: edition, groupAndTeamCountsMap: groupAndTeamCountsMap, teamData: teamData }) {
    if (!publishModalRestrictions) return null;
    const currentUser = (0, $1vrmd.getCurrentUserPrincipal)(data.user);
    if (!currentUser) return null;
    const contentData = $8e71fdfb647f76e1$var$getContentData(publishModalRestrictions, data.content, currentUser, groupAndTeamCountsMap, teamData);
    if (!contentData) return null;
    return {
        ...contentData,
        spaceKey: spaceKey,
        currentUser: currentUser,
        publicLinkPageData: publicLinkPageData,
        userCanEditRestrictions: (0, $2rrpN.canSetRestrictions)(data, contentData.contentRestrictions.generalAccessLevel, contentType),
        edition: edition,
        currentUserHasAccess: contentData.currentUserHasAccess,
        disableSharingToEmails: false,
        principalsPendingAccess: [],
        userCanEditContent: false
    };
}
function $8e71fdfb647f76e1$var$getContentData(publishModalRestrictions, content, currentUser, groupAndTeamCountsMap, teamData) {
    if (!content) return null;
    const { nodes: nodes } = content;
    if (!nodes) return null;
    const [node0] = nodes;
    if (!node0) return null;
    const { hasInheritedRestrictions: hasInheritedRestrictions, ancestors: ancestors } = node0;
    const contentRestrictionsAndCounts = $8e71fdfb647f76e1$var$getContentRestrictions(publishModalRestrictions, currentUser, groupAndTeamCountsMap, teamData);
    const parentPageLink = hasInheritedRestrictions ? (0, $2rrpN.getClosestAncestorWithViewRestrictions)(ancestors) : null;
    return {
        contentRestrictions: {
            generalAccessLevel: contentRestrictionsAndCounts.generalAccessLevel,
            principals: contentRestrictionsAndCounts.principals
        },
        numberOfAncestors: ancestors?.length || 0,
        groupCount: contentRestrictionsAndCounts.groupCount,
        teamCount: contentRestrictionsAndCounts.teamCount,
        currentUserHasAccess: contentRestrictionsAndCounts.currentUserHasAccess,
        hasInheritedRestrictions: hasInheritedRestrictions,
        parentPageLink: parentPageLink
    };
}
function $8e71fdfb647f76e1$var$getContentRestrictions(publishModalRestrictions, currentUser, groupAndTeamCountsMap, teamData) {
    const readAndUpdateLists = $8e71fdfb647f76e1$var$convertPublishModalRestrictions(publishModalRestrictions, groupAndTeamCountsMap, teamData);
    const { principals: principals, groupCount: groupCount, teamCount: teamCount, currentUserHasAccess: currentUserHasAccess } = (0, $1fjr9.getPrincipalsAndRoles)(readAndUpdateLists, currentUser);
    return {
        generalAccessLevel: (0, $1fjr9.getGeneralAccessLevel)(readAndUpdateLists),
        principals: principals,
        groupCount: groupCount,
        teamCount: teamCount,
        currentUserHasAccess: currentUserHasAccess
    };
}
function $8e71fdfb647f76e1$var$convertPublishModalRestrictions(publishModalRestrictions, groupAndTeamCountsMap, teamData) {
    const ret = {
        read: {
            users: [],
            groups: []
        },
        update: {
            users: [],
            groups: []
        }
    };
    const { read: read, update: update } = ret;
    for (const data of publishModalRestrictions){
        const { operation: operation } = data;
        if (operation === 'read') {
            $8e71fdfb647f76e1$var$convertAndPushUsers({
                users: data.restrictions.user.results,
                destination: read.users
            });
            $8e71fdfb647f76e1$var$convertAndPushGroups({
                groups: data.restrictions.group.results,
                destination: read.groups,
                groupAndTeamCountsMap: groupAndTeamCountsMap,
                teamData: teamData
            });
        }
        if (operation === 'update') {
            $8e71fdfb647f76e1$var$convertAndPushUsers({
                users: data.restrictions.user.results,
                destination: update.users
            });
            $8e71fdfb647f76e1$var$convertAndPushGroups({
                groups: data.restrictions.group.results,
                destination: update.groups,
                groupAndTeamCountsMap: groupAndTeamCountsMap,
                teamData: teamData
            });
        }
    }
    return ret;
}
function $8e71fdfb647f76e1$var$convertAndPushGroups({ groups: groups, destination: destination, groupAndTeamCountsMap: groupAndTeamCountsMap, teamData: teamData }) {
    for (const group of groups){
        if (!group) continue;
        const id = group?.id || '';
        const team = group?.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION ? teamData?.[id] : undefined;
        destination.push({
            type: 'group',
            id: group.id,
            name: group.name,
            usageType: group.usageType || (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP,
            memberCount: groupAndTeamCountsMap.get(group.id || '') ?? 0,
            isVerified: team?.isVerified ?? false,
            avatarSrc: team?.largeAvatarImageUrl ?? ''
        });
    }
}
function $8e71fdfb647f76e1$var$convertAndPushUsers({ users: users, destination: destination }) {
    for (const user of users){
        if (!user) continue;
        destination.push({
            type: 'user',
            id: user.accountId,
            avatarUrl: user.profilePicture?.path || '',
            name: user.displayName,
            email: user.email,
            knownErrors: undefined,
            sitePermissionType: 'INTERNAL'
        });
    }
}



var $59MXn = parcelRequire("59MXn");


var $13PIz = parcelRequire("13PIz");








var $g3thj = parcelRequire("g3thj");







const $097f65d6096e0201$export$c74c6c55d17d31bd = (cloudId, publishModalRestrictions, data)=>{
    const [teamData, setTeamData] = (0, $42omo.useState)(null);
    const [isTeamDataLoading, setIsTeamDataLoading] = (0, $42omo.useState)(false);
    const [teamDataError, setTeamDataError] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const teamIds = (0, $42omo.useMemo)(()=>{
        const teamIdSet = new Set();
        if (publishModalRestrictions) for (const item of publishModalRestrictions){
            const groups = item?.restrictions?.group?.results ?? [];
            for (const group of groups)if (group?.id && group.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION) teamIdSet.add(group.id);
        }
        if (data?.content?.nodes?.[0]?.restrictions) {
            const readNodes = data.content.nodes[0].restrictions.read?.restrictions?.group?.nodes ?? [];
            const updateNodes = data.content.nodes[0].restrictions.update?.restrictions?.group?.nodes ?? [];
            const allNodes = [
                ...readNodes,
                ...updateNodes
            ];
            for (const node of allNodes)if (node?.id && node?.usageType === (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION) teamIdSet.add(node.id);
        }
        return Array.from(teamIdSet);
    }, [
        publishModalRestrictions,
        data
    ]);
    (0, $42omo.useEffect)(()=>{
        if (teamIds.length > 0) {
            setIsTeamDataLoading(true);
            setTeamDataError(null);
            (0, $g3thj.fetchTeamData)(cloudId, teamIds).then((fetchedData)=>{
                // Convert array to map where key is the team ID and value is the team data
                const teamDataMap = {};
                fetchedData.forEach((teamItem)=>{
                    if (teamItem.id) teamDataMap[teamItem.id] = teamItem;
                });
                setTeamData(teamDataMap);
                setTeamDataError(null);
            }).catch((error)=>{
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: 'errored',
                        actionSubject: 'useTeamData',
                        attributes: {
                            error: error,
                            teamIds: teamIds
                        }
                    }
                }).fire();
                setTeamData(null);
                setTeamDataError(error instanceof Error ? error : new Error(String(error)));
            }).finally(()=>{
                setIsTeamDataLoading(false);
            });
        } else {
            setTeamData(null);
            setIsTeamDataLoading(false);
            setTeamDataError(null);
        }
    }, [
        cloudId,
        teamIds,
        createAnalyticsEvent
    ]);
    return {
        teamData: teamData,
        isTeamDataLoading: isTeamDataLoading,
        teamDataError: teamDataError
    };
};


const $75b6dac8e2674712$var$useQueriesShareAndRestrictDialogQuery = (0, $eSUdr.default)`query useQueriesShareAndRestrictDialogQuery($contentId:ID!$status:[String]$draftShareId:String$spaceKey:String!){content(id:$contentId status:$status draftShareId:$draftShareId){nodes{id ancestors{id hasViewRestrictions links{webui}}hasInheritedRestrictions operations{operation targetType}restrictions{read{restrictions{userWithRestrictions(start:0){count nodes{type displayName email accountId profilePicture{path}hasSpaceViewPermission hasSpaceEditPermission permissionType restrictingContent{id links{webui base}}}pageInfo{hasNextPage endCursor}}group(start:0){count nodes{id name permissionType usageType}pageInfo{hasNextPage endCursor}}}}update{restrictions{userWithRestrictions(start:0){count nodes{type displayName email accountId profilePicture{path}hasSpaceViewPermission hasSpaceEditPermission permissionType restrictingContent{id links{webui base}}}pageInfo{hasNextPage endCursor}}group(start:0){count nodes{id name permissionType usageType}pageInfo{hasNextPage endCursor}}}}}}}user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}photos{value isPrimary}}space(key:$spaceKey){id currentUser{isAdmin}}}`;
const $75b6dac8e2674712$var$DEFAULT_SHARE_SERVICE_URL = '/gateway/api';
const $75b6dac8e2674712$var$useDraftShareId = (0, $dPJCf.createSingleQueryParamHook)('draftShareId');
async function $75b6dac8e2674712$var$fetchConfig(cloudId) {
    const serviceConfig = {
        url: $75b6dac8e2674712$var$DEFAULT_SHARE_SERVICE_URL
    };
    const options = {
        path: `${(0, $9wGTI.fg)('confluence_new_share_service_content_share') ? 'contentShare' : 'share'}/configuration`,
        queryParams: {
            cloudId: cloudId
        },
        requestInit: {
            method: 'get'
        }
    };
    return (0, $dwp40.utils).requestService(serviceConfig, options);
}
const $75b6dac8e2674712$export$408667c6c87da1e5 = ({ contentId: contentId, contentType: contentType, publishModalRestrictions: publishModalRestrictions, spaceKey: inputSpaceKey, cloudId: cloudId })=>{
    const [defaultSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = inputSpaceKey || defaultSpaceKey;
    const draftShareId = $75b6dac8e2674712$var$useDraftShareId() ?? '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [configData, setConfigData] = (0, $42omo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $j1Ss3.useQuery)($75b6dac8e2674712$var$useQueriesShareAndRestrictDialogQuery, {
        variables: {
            contentId: contentId,
            // In order to allow us to fetch any data for draft content always we need to specify the status
            status: [
                'current',
                'draft',
                'archived'
            ],
            draftShareId: draftShareId,
            spaceKey: spaceKey || ''
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
    });
    (0, $42omo.useEffect)(()=>{
        $75b6dac8e2674712$var$fetchConfig(cloudId).then((result)=>{
            setConfigData(result);
        }).catch((err)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: 'errored',
                    actionSubject: 'disableSharingToEmails',
                    attributes: {
                        message: err?.message,
                        name: err?.name,
                        stack: err?.stack,
                        cause: err?.cause
                    }
                }
            }).fire();
        });
    }, [
        cloudId,
        createAnalyticsEvent
    ]);
    const publicLinkPageData = (0, $gabmL.usePublicLinkPageDataProvider)({
        pageId: contentId,
        fetchPolicy: 'network-only'
    });
    (0, $59MXn.usePreloadUserSuggestions)();
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'shareAndRestrictDialogQuery',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    const { isGroupsCountLoading: isGroupsCountLoading, groupAndTeamCountsMap: groupAndTeamCountsMap } = (0, $13PIz.useGroupsAndTeamCountQuery)({
        data: data,
        publishModalRestrictions: publishModalRestrictions,
        error: error
    });
    const { teamData: teamData, isTeamDataLoading: isTeamDataLoading } = (0, $097f65d6096e0201$export$c74c6c55d17d31bd)(cloudId, publishModalRestrictions, data);
    const { requests: requestedUsersPendingApproval, loading: isAccessRequestsLoading } = (0, $6SeRB.useAccessRequests)('network-only', (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE), publishModalRestrictions !== undefined || !(0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate') || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation'), 'PENDING_SITE_APPROVAL');
    if (loading || isGroupsCountLoading || isTeamDataLoading || isAccessRequestsLoading) return {
        state: 'loading'
    };
    if (error) // We never expect any errors here. Don't mark it as handled.
    return {
        state: 'error'
    };
    // Translate the query to our internal state. If that was unsuccessful
    // (most likely because of insufficient data), consider it an error
    if (!data) return {
        state: 'error'
    };
    const queriesState = (()=>{
        if (publishModalRestrictions) return data && edition ? (0, $8e71fdfb647f76e1$export$b4fc4afbf9b55a0d)({
            publishModalRestrictions: publishModalRestrictions,
            spaceKey: spaceKey || '',
            data: data,
            publicLinkPageData: publicLinkPageData,
            contentType: contentType,
            edition: edition,
            groupAndTeamCountsMap: groupAndTeamCountsMap,
            teamData: teamData
        }) : undefined;
        return data && edition ? (0, $2rrpN.dataToQueriesState)(data, publicLinkPageData, spaceKey || '', contentType, edition, configData?.disableSharingToEmails, groupAndTeamCountsMap, teamData, requestedUsersPendingApproval) : undefined;
    })();
    if (!queriesState) return {
        state: 'error'
    };
    return {
        state: 'loaded',
        queriesState: queriesState,
        refetchQueries: refetch
    };
};
module.exports["useQueries"] = $75b6dac8e2674712$export$408667c6c87da1e5;

});

parcelRegister("gabmL", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $cgtv4.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && edition === (0, $euL71.ConfluenceEdition).PREMIUM && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const canEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') pageData.refetch();
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $8C5kA.default)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId pageStatus publicLinkUrlPath}}`, {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $42omo.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $42omo.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;
module.exports["PublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b86a4cadf4c50ae1;

});

parcelRegister("1X7PR", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const isSpaceAdmin = Boolean(data?.space?.currentUser.isAdmin);
    const canEditPage = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
    return {
        contentType: contentType,
        canEditPublicLink: (isSpaceAdmin || canEditPage) && !isExternalCollaborator
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!$spaceKey:String!$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id type operations{operation targetType}}}space(key:$spaceKey)@include(if:$hasSpaceKey){id currentUser{isAdmin}}}`, {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        }
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator)
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("cLo2u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    // Space-level data is used to retrieve information about a space's external collaborators
    // in multiple places across the package. Attempt to get spaceKey from a range of sources.
    // If we are in a view-page context, spaceKey data may be available from PageState.
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // Otherwise, RoutesContext may contain the information we need
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    // Now that our context hooks have executed, we can return if we have a match.
    // Return statements are separated out for optimum readability.
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    // Legacy server-rendered UI pages do not have the "match" object in RoutesContext, but
    // they can contain space information in the <meta> data tag.
    const documentMetaSpaceKey = typeof document !== 'undefined' ? document.querySelector('meta#confluence-space-key')?.content : null;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bgRei", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId objectType:$objectType){permissions}}`, {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip
    });
    (0, $42omo.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("2rrpN", function(module, exports) {

var $cOQPm = parcelRequire("cOQPm");


var $1fjr9 = parcelRequire("1fjr9");


var $1vrmd = parcelRequire("1vrmd");

const $f0b77ee9aa683a00$var$addGroupAndTeamData = (restrictions, groupAndTeamCountsMap, teamData)=>({
        ...restrictions,
        groupAndTeamCountsMap: groupAndTeamCountsMap,
        teamData: teamData
    });
function $f0b77ee9aa683a00$export$1864618d14e03dd7(data, publicLinkPageData, spaceKey, contentType, edition, disableSharingToEmails = false, groupAndTeamCountsMap, teamData, requestedUsersPendingApproval) {
    const currentUser = (0, $1vrmd.getCurrentUserPrincipal)(data.user);
    if (!currentUser) return null;
    const contentData = $f0b77ee9aa683a00$var$getContentData(data.content, currentUser, groupAndTeamCountsMap, teamData);
    if (!contentData) return null;
    const principalsPendingAccess = $f0b77ee9aa683a00$export$406b6435d7a02517(contentData.contentRestrictions.principals, requestedUsersPendingApproval);
    return {
        ...contentData,
        spaceKey: spaceKey,
        currentUser: currentUser,
        publicLinkPageData: publicLinkPageData,
        userCanEditContent: $f0b77ee9aa683a00$export$84b461ed686ebfb9(data, contentType),
        userCanEditRestrictions: $f0b77ee9aa683a00$export$d407e9ce7f74386b(data, contentData.contentRestrictions.generalAccessLevel, contentType),
        edition: edition,
        disableSharingToEmails: disableSharingToEmails,
        principalsPendingAccess: principalsPendingAccess
    };
}
function $f0b77ee9aa683a00$export$84b461ed686ebfb9(data, contentType) {
    const contentNode = data?.content?.nodes?.[0];
    const operationsData = contentNode?.operations || [];
    return operationsData.some((operation)=>operation?.operation === 'update' && operation?.targetType === contentType);
}
function $f0b77ee9aa683a00$export$d407e9ce7f74386b(data, generalAccessLevel, contentType) {
    const contentNode = data?.content?.nodes?.[0];
    const operationsData = contentNode?.operations || [];
    const isSpaceAdmin = data?.space?.currentUser?.isAdmin || false;
    // Check if the current content type has a restrict_content operation
    const canRestrictContent = operationsData.some((operation)=>operation?.operation === 'restrict_content' && operation?.targetType === contentType);
    if (generalAccessLevel === 'open-can-edit') return canRestrictContent;
    const userHasEditRestrictions = operationsData.some((operation)=>operation?.operation === 'update' && operation?.targetType === contentType);
    return canRestrictContent && userHasEditRestrictions || isSpaceAdmin;
}
/**  Extracts all the QueriesState data that can be obtained from the `content` node */ function $f0b77ee9aa683a00$var$getContentData(content, currentUser, groupAndTeamCountsMap, teamData) {
    if (!content) return null;
    const { nodes: nodes } = content;
    if (!nodes) return null;
    const [node0] = nodes;
    if (!node0) return null;
    const { restrictions: restrictions, hasInheritedRestrictions: hasInheritedRestrictions, ancestors: ancestors } = node0;
    if (!restrictions) return null;
    const restrictionsWithGroupAndTeamData = $f0b77ee9aa683a00$var$addGroupAndTeamData(restrictions, groupAndTeamCountsMap, teamData);
    const contentRestrictionsAndCounts = (0, $1fjr9.getContentRestrictions)(restrictionsWithGroupAndTeamData, currentUser);
    if (!contentRestrictionsAndCounts) return null;
    const parentPageLink = hasInheritedRestrictions ? $f0b77ee9aa683a00$export$152ce6697c74bacb(ancestors) : null;
    return {
        contentRestrictions: {
            generalAccessLevel: contentRestrictionsAndCounts.generalAccessLevel,
            principals: contentRestrictionsAndCounts.principals
        },
        numberOfAncestors: ancestors?.length || 0,
        groupCount: contentRestrictionsAndCounts.groupCount,
        teamCount: contentRestrictionsAndCounts.teamCount,
        currentUserHasAccess: contentRestrictionsAndCounts.currentUserHasAccess,
        hasInheritedRestrictions: hasInheritedRestrictions,
        parentPageLink: parentPageLink
    };
}
function $f0b77ee9aa683a00$export$152ce6697c74bacb(ancestors) {
    const closestBoundingPage = {
        id: '',
        link: null
    };
    // Last ancestor is closest bounding
    if (ancestors) {
        for(let i = ancestors.length - 1; i >= 0; i--)if (ancestors[i]?.hasViewRestrictions) {
            closestBoundingPage.id = ancestors[i]?.id || '';
            closestBoundingPage.link = ancestors[i]?.links?.webui;
            break;
        }
    }
    return closestBoundingPage.link;
}
function $f0b77ee9aa683a00$export$406b6435d7a02517(existingPrincipals, requestedUsersPendingApproval) {
    return requestedUsersPendingApproval.filter((node)=>node !== null).filter((node)=>!existingPrincipals.some((principal)=>principal.principal.id === node.accessRequestedAaid)).map((node)=>{
        const avatarUrl = node.user?.photos?.find((photo)=>photo?.isPrimary === true)?.value ?? '';
        const email = node.user?.emails?.find((e)=>e?.isPrimary === true)?.value ?? '';
        const cachedInvites = (0, $cOQPm.getCachedInvites)();
        const knownErrors = {
            accessWarning: cachedInvites.includes(node.accessRequestedAaid) ? 'pending-userbase-propagation-warning' : 'pending-site-access-warning',
            parentLink: null
        };
        const principal = {
            type: 'user',
            id: node.accessRequestedAaid,
            name: node.user?.displayName ?? '',
            avatarUrl: avatarUrl,
            email: email,
            knownErrors: knownErrors,
            sitePermissionType: ''
        };
        let role;
        if (node.requestAccessType === 'EDIT') role = 'can-edit';
        else if (node.requestAccessType === 'VIEW') role = 'can-view';
        else role = 'no-access';
        return {
            principal: principal,
            role: role
        };
    });
}
module.exports["dataToQueriesState"] = $f0b77ee9aa683a00$export$1864618d14e03dd7;
module.exports["canSetRestrictions"] = $f0b77ee9aa683a00$export$d407e9ce7f74386b;
module.exports["getClosestAncestorWithViewRestrictions"] = $f0b77ee9aa683a00$export$152ce6697c74bacb;

});

parcelRegister("1vrmd", function(module, exports) {
function $979045d6a0d5e8cc$export$ebb637dbfb7941d3(user) {
    if (!user) return null;
    // Insist on a bare minimum of profile data
    const { id: id, displayName: displayName, photos: photos, emails: emails } = user;
    if (!id) return null;
    if (!displayName) return null;
    return {
        type: 'user',
        id: id,
        name: displayName,
        avatarUrl: $979045d6a0d5e8cc$var$getPrimaryValue(photos),
        email: $979045d6a0d5e8cc$var$getPrimaryValue(emails),
        knownErrors: undefined,
        sitePermissionType: 'INTERNAL'
    };
}
function $979045d6a0d5e8cc$var$getPrimaryValue(maybeList) {
    let best = '';
    if (maybeList) for (const item of maybeList){
        if (!item) continue;
        const { value: value, isPrimary: isPrimary } = item;
        if (!value) continue;
        best = value;
        if (isPrimary) break;
    }
    return best;
}
module.exports["getCurrentUserPrincipal"] = $979045d6a0d5e8cc$export$ebb637dbfb7941d3;

});

parcelRegister("5bmjx", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $fef408561d1b0f61$export$1c624363b22048c1(teardown) {
    const shouldTearDownOnNextClose = (0, $42omo.useRef)(false);
    return {
        potentialFinalDialogDidCompleteClose () {
            if (shouldTearDownOnNextClose.current) teardown();
        },
        tearDownAfterPotentialFinalDialogCompletesClose () {
            shouldTearDownOnNextClose.current = true;
        }
    };
}
module.exports["useTeardownController"] = $fef408561d1b0f61$export$1c624363b22048c1;

});

parcelRegister("T5KYq", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $6Co6F = parcelRequire("6Co6F");


var $inPa6 = parcelRequire("inPa6");


var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $a5Dk4 = parcelRequire("a5Dk4");

var $hHhbz = parcelRequire("hHhbz");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $cb6fO = parcelRequire("cb6fO");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $gEtAQ = parcelRequire("gEtAQ");


var $bQm3c = parcelRequire("bQm3c");


var $gw4Eo = parcelRequire("gw4Eo");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $6abPE = parcelRequire("6abPE");


var $4adOe = parcelRequire("4adOe");

const $1a4b25e76b1344c0$var$useShareToPrincipalsShareToPrincipalsContentQuery = (0, $eSUdr.default)`query useShareToPrincipalsShareToPrincipalsContentQuery($contentId:ID!){singleContent(id:$contentId){title type id}}`;
const $1a4b25e76b1344c0$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $1a4b25e76b1344c0$var$i18n = (0, $cgtv4.defineMessages)({
    emptyTitleDefault: {
        id: "share-and-restrict-dialog.default.title",
        defaultMessage: "Untitled"
    }
});
const $1a4b25e76b1344c0$export$3bb5b6748490a3c9 = ({ activationId: activationId, cloudId: cloudId, contentId: contentId, contentType: contentType })=>{
    // Build ARI for embeds via `getConfluenceContentAri` until support is added to `@atlassian/ari`
    // TODO: Replace with `@atlassian/ari` https://hello.jira.atlassian.cloud/browse/CTIA-1835
    if (contentType === 'embed') return (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    if (contentType === 'database') return (0, $iH7AG.ConfluenceDatabaseAri).create({
        siteId: cloudId,
        databaseId: contentId,
        activationId: activationId
    }).toString();
    let ari = null;
    // A space ari should not have spacekey as it is UGC (HOT-96075)
    // A space should have a page based ARI as only then it will generate the
    // notification that will be propagated to mobile as well and will be consistent with Mobile.
    // So a space will also have page based ARI. (Discussed in HOT-96778)
    switch(contentType){
        case 'blogpost':
            ari = (0, $eB56w.ConfluenceBlogpostAri).create({
                siteId: cloudId,
                blogpostId: contentId
            });
            break;
        case 'whiteboard':
            ari = (0, $a5Dk4.ConfluenceWhiteboardAri).create({
                siteId: cloudId,
                whiteboardId: contentId
            });
            break;
        case 'folder':
            ari = (0, $lb1Mg.ConfluenceFolderAri).create({
                siteId: cloudId,
                folderId: contentId,
                activationId: activationId
            });
            break;
        default:
            ari = (0, $a2xFu.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: contentId
            });
            break;
    }
    return ari.toString();
};
const $1a4b25e76b1344c0$export$6b48d216ed523828 = ({ routesContext: routesContext, contentType: contentType, contentId: contentId, spaceKey: spaceKey, isEditMode: isEditMode, makeContentLink: makeContentLink })=>{
    const draftShareId = (0, $c3Qwv.getSingleParam)(routesContext.getQueryParams(), 'draftShareId');
    /**
   * Use the refactored version if in edit mode (for presence feature).
   * If `makeContentLink` returns undefined, fall back to the original logic.
   */ const contentShareLink = makeContentLink();
    if (isEditMode && contentShareLink) return contentShareLink;
    /**
   * Generate the "view content" link based on the current route context.
   * If the user is on an edit page (excluding drafts), generate a "view" URL.
   */ const generateViewLink = ()=>{
        // ShareButton constructs the URL to send based on routes context (current
        // location in Confluence app). We are matching ShareButton logic as closely
        // as we can to provide a consistent experience, but given that we could
        // embed Share anywhere in the app, we should consider constructing URLs
        // based on a combination of content data from the BE (eg fetch content
        // type, status etc) + consumer specifications (give me a view vs edit URL)
        // and maintain an explicit set of link generation rules in this package.
        const namedRoute = routesContext.match;
        // If user is coming from edit page/blog, we want to send a "view content"
        // link, NOT the current edit URL. (Drafts are an exception; they have
        // no valid view page URL so we must construct a separate link.
        if (namedRoute && (0, $gEtAQ.isEditPage)(String(namedRoute)) && !draftShareId) {
            const spaceKeyParam = spaceKey ?? namedRoute?.params.spaceKey;
            const viewRoute = contentType === 'blog' ? (0, $1NBp8.VIEW_BLOG) : (0, $1NBp8.VIEW_PAGE);
            return new URL(viewRoute.toUrl({
                spaceKey: spaceKeyParam,
                contentId: contentId
            }), document.baseURI).toString();
        }
        return null;
    };
    const viewLink = generateViewLink();
    if (viewLink) return viewLink;
    // At this point we know we want to share content in the VIEW mode + double checks that getCopyContentLink didn't return undefined
    if (contentShareLink) return contentShareLink;
    /**
   * If no custom link or view link is available, fall back to the current URL
   * with the content slug and possibly add a draft share ID as a query parameter.
   */ // eslint-disable-next-line no-restricted-syntax
    const fallbackLink = (0, $cb6fO.removeEverythingAfterContentSlug)(window.location.href);
    return draftShareId ? (0, $cb6fO.addQueryParams)(fallbackLink, {
        draftShareId: draftShareId
    }) : fallbackLink;
};
const $1a4b25e76b1344c0$export$2a802a801ccf3bf0 = (contentId)=>{
    const SHARE_ENDPOINT = '/gateway/api/contentShare';
    // Query the backend as the source of truth for content type,
    // with page context (routes-based) as a fallback
    const { data: data, error: error } = (0, $xQxzY.useQuery)($1a4b25e76b1344c0$var$useShareToPrincipalsShareToPrincipalsContentQuery, {
        variables: {
            contentId: contentId
        }
    });
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentTypeFromPageContext] = (0, $ep3mz.useContentType)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // eslint-disable-next-line no-restricted-syntax
    const routesContext = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const namedRoute = routesContext.match;
    const isEditMode = (0, $gEtAQ.isEditPage)(namedRoute?.name ?? '');
    // Determine content type from query data or fallback to page context
    const contentType = data?.singleContent?.type ?? contentTypeFromPageContext ?? '';
    const contentTitle = data?.singleContent?.title;
    const originTracingFactory = (0, $42omo.useCallback)(()=>new (0, $6Co6F.default)({
            product: 'confluence'
        }), []);
    const { makeContentLink: makeContentLink } = (0, $6abPE.useCopyContentLink)({
        contentType: contentType,
        pageMode: isEditMode ? 'edit' : 'view',
        contentId: contentId,
        spaceKey: spaceKey || '',
        source: 'useShareToPrincipals'
    });
    // Handle potential errors silently; missing data won't significantly impact users
    if (error) {
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'shareToPrincipalsContentQuery',
                actionSubjectId: 'useShareToPrincipals',
                attributes: {
                    message: error.message
                }
            }
        }).fire();
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return {
        shareToPrincipals: async ({ notificationRecipients: notificationRecipients, message: message })=>{
            $1a4b25e76b1344c0$var$throwError(contentId, contentType);
            try {
                const requestBody = {
                    content: {
                        link: (0, $lpPVE.generatePathWithFeatureCodesQueryParam)($1a4b25e76b1344c0$export$6b48d216ed523828({
                            routesContext: routesContext,
                            contentType: contentType,
                            contentId: contentId,
                            spaceKey: spaceKey,
                            isEditMode: isEditMode,
                            makeContentLink: makeContentLink
                        }), [
                            (0, $71GjD.FeatureCode).SHARE_AND_RESTRICT_DIALOG
                        ]),
                        ari: $1a4b25e76b1344c0$export$3bb5b6748490a3c9({
                            activationId: activationId,
                            contentId: contentId,
                            cloudId: cloudId,
                            contentType: contentType
                        }),
                        workspaceAri: (0, $hHhbz.ConfluenceWorkspaceAri).create({
                            siteId: cloudId,
                            activationId: activationId
                        }).toString(),
                        title: contentTitle || intl.formatMessage($1a4b25e76b1344c0$var$i18n.emptyTitleDefault),
                        type: contentType
                    },
                    recipients: notificationRecipients,
                    comment: {
                        format: 'plain_text',
                        value: message || ''
                    },
                    metadata: {
                        productId: 'confluence',
                        atlOriginId: String(originTracingFactory().id),
                        // even if we are in edit mode we want to share the "view" page URL, not edit
                        shareeAction: isEditMode ? 'edit' : 'view'
                    }
                };
                await (0, $f7B1p.cfetch)(SHARE_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8'
                    },
                    body: JSON.stringify(requestBody)
                });
            } catch (err) {
                const response = (0, $hBkCm.BadStatusError).isBadStatusError(err) ? err.response : undefined;
                if (response) {
                    const errDetails = await err.response.json();
                    const isListTooLargeError = errDetails?.messagesDetails.some((errObj)=>errObj?.errorCode === 'share-to-large-group-forbidden');
                    if (isListTooLargeError) throw new Error('list-too-large-error');
                }
                throw new Error(err);
            }
        }
    };
};
function $1a4b25e76b1344c0$var$throwError(contentId, contentType) {
    if (!$1a4b25e76b1344c0$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) throw new Error('Not a supported content type');
    if (!contentId) throw new Error('No content ID');
}
module.exports["useShareToPrincipals"] = $1a4b25e76b1344c0$export$2a802a801ccf3bf0;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("hHhbz", function(module, exports) {

var $5O1YC = parcelRequire("5O1YC");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/workspace/manifest.ts
var $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5O1YC.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $5O1YC.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ce23c8815c812c15$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ce23c8815c812c15$export$d47d8a7e69df1865;

});

parcelRegister("5O1YC", function(module, exports) {
// src/confluence/workspace/types.ts
var $43a327cfc847ac6c$export$19f1a63686ec0369 = "confluence", $43a327cfc847ac6c$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $43a327cfc847ac6c$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $43a327cfc847ac6c$export$f1c423a93fbc71;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = ()=>Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3a15fff847513284 = ()=>Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE
};
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("cBa8E", function(module, exports) {
function $1e941ec6b3e5ef56$export$f8f6d2ae4209df71({ stagedNotificationRecipients: stagedNotificationRecipients }) {
    const notificationRecipients = [];
    $1e941ec6b3e5ef56$var$addRecipientsToList(notificationRecipients, stagedNotificationRecipients);
    return notificationRecipients;
}
function $1e941ec6b3e5ef56$var$addRecipientsToList(list, recipients) {
    recipients.forEach((recipient)=>{
        if (recipient.type === 'email') list.push({
            email: recipient.id,
            type: 'user'
        });
        else if (recipient.type === 'external_user') list.push({
            email: recipient.email,
            type: 'user'
        });
        else list.push({
            id: recipient.id,
            type: recipient.type
        });
    });
}
module.exports["getNotificationRecipients"] = $1e941ec6b3e5ef56$export$f8f6d2ae4209df71;

});

parcelRegister("5608P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irVI7 = parcelRequire("irVI7");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $f2UnK = parcelRequire("f2UnK");

const $b01594d0f49f4819$export$629b25426d01cf1e = (setMasterState)=>{
    const ref = (0, $42omo.useRef)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // Common React pattern for useRef taking a value instead of a value-creating
    // function
    function lazyGetFlowController() {
        const existingController = ref.current;
        if (existingController !== null) return existingController;
        const newController = $b01594d0f49f4819$var$startCtaFlow(setMasterState, cloudId);
        ref.current = newController;
        return newController;
    }
    return lazyGetFlowController();
};
/**
 * Creates a transmitter/receiver pair for events that the UI actions need to
 * give the flow controller
 */ function $b01594d0f49f4819$var$createEventChannel() {
    let awaiter = null;
    const dispatchEvent = (event)=>{
        if (awaiter) {
            awaiter(event);
            awaiter = null;
        }
    // No awaiter? Drop the event. Let the user click again.
    };
    const awaitEvent = (filter)=>{
        return new Promise((resolve)=>{
            awaiter = (event)=>{
                if (filter.includes(event.type)) resolve(event);
            };
        });
    };
    return [
        awaitEvent,
        dispatchEvent
    ];
}
function $b01594d0f49f4819$var$startCtaFlow(setMasterState, cloudId) {
    // Build a channel for the flow to consume events
    const [awaitFlowEvent, dispatchFlowEvent] = $b01594d0f49f4819$var$createEventChannel();
    // Start the CTA flow
    $b01594d0f49f4819$export$ca765b7647afa895(awaitFlowEvent, setMasterState, cloudId);
    // Give the sender a way to interact with it
    return dispatchFlowEvent;
}
function $b01594d0f49f4819$export$4f3f8e68f31fcd27({ flowEventType: flowEventType, isNotifyingAction: isNotifyingAction, isMutatingAction: isMutatingAction, stagedGeneralAccessLevel: stagedGeneralAccessLevel, principalsMap: principalsMap, showWarnRestrictionsDialog: showWarnRestrictionsDialog, showResolveRestrictionsDialog: showResolveRestrictionsDialog, doNotNotifyGroups: doNotNotifyGroups, userCanEditRestrictions: userCanEditRestrictions, successFlag: successFlag, isUnpublishedDraft: isUnpublishedDraft }) {
    const isRestrictionsFlow = showWarnRestrictionsDialog || showResolveRestrictionsDialog;
    let areCanEditPrincipalsBeingAdded = false;
    const contentOrDraft = isUnpublishedDraft ? 'draft-shared' : 'content-shared';
    /**
	 * Check if any new principals are being added in this session.
	 * If yes, verify if any of them have the "can edit" role.
	 */ const hasNewPrincipals = Array.from(principalsMap.values()).some((principal)=>{
        const { isNewOrUpdatedPrincipal: isNewOrUpdatedPrincipal, role: role } = principal;
        if (isNewOrUpdatedPrincipal) areCanEditPrincipalsBeingAdded = role === 'can-edit';
        return isNewOrUpdatedPrincipal;
    });
    // Handle "notification" flows first
    if (isNotifyingAction) {
        const emailPrincipalsOnly = principalsMap.size === 0;
        if (isRestrictionsFlow) {
            if (flowEventType === 'ignoreRestrictions') successFlag(contentOrDraft);
            else if (flowEventType === 'resolveRestrictionsComplete') successFlag('access-updated');
            return;
        }
        // If no restrictions
        if (doNotNotifyGroups) {
            successFlag('access-updated');
            return;
        }
        // If only emails being notify
        if (emailPrincipalsOnly) {
            successFlag('notification-sent');
            return;
        }
        // Double-check if there are any other principals at this general access level. If there aren't, we are sending them an email notification
        if ((stagedGeneralAccessLevel === 'open-can-view' || stagedGeneralAccessLevel === 'restricted') && !hasNewPrincipals) {
            successFlag('notification-sent');
            return;
        }
        // Check if the user is sharing but doesn't have permission to edit
        if (stagedGeneralAccessLevel === 'restricted' && !userCanEditRestrictions) {
            successFlag(contentOrDraft);
            return;
        }
        // Distinguish content-sharing from simple notification
        const message = stagedGeneralAccessLevel === 'open-can-edit' || stagedGeneralAccessLevel === 'open-can-view' ? contentOrDraft : 'access-updated';
        successFlag(message);
        return;
    }
    // Otherwise handle "mutation" flows
    if (isMutatingAction) {
        if (isRestrictionsFlow) {
            if (flowEventType === 'ignoreRestrictions') successFlag(isUnpublishedDraft ? 'draft-shared' : 'access-updated');
            else if (flowEventType === 'resolveRestrictionsComplete') successFlag('access-updated');
            return;
        }
        // If new principals with the "can edit" role is added to this access level.
        if (areCanEditPrincipalsBeingAdded && hasNewPrincipals && stagedGeneralAccessLevel === 'open-can-view') {
            successFlag('access-updated');
            return;
        }
        // If principals are present and have access to this level.
        if (hasNewPrincipals) {
            if (stagedGeneralAccessLevel === 'open-can-edit' || stagedGeneralAccessLevel === 'open-can-view') {
                successFlag('has-access-already');
                return;
            }
        }
        // Default mutation scenario
        successFlag('access-updated');
    }
}
const $b01594d0f49f4819$export$ca765b7647afa895 = async (awaitFlowEvent, setMasterState, cloudId)=>{
    while(true){
        // In case we've re-entered this loop by a go-back from another dialog,
        // make sure the main shareAndRestrict mode is showing
        setMasterState((s)=>({
                ...s,
                isSaving: false,
                sessionState: 'shareAndRestrict'
            }));
        // Wait for the user to click the main dialog's CTA
        const { contentId: contentId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, mutateContentRestrictions: mutateContentRestrictions, currentUser: currentUser, sendNotification: sendNotification, successFlag: successFlag, errorFlag: errorFlag, beginTeardown: beginTeardown, isMutatingAction: isMutatingAction, isNotifyingAction: isNotifyingAction, userCanEditRestrictions: userCanEditRestrictions, stagedGeneralAccessLevel: stagedGeneralAccessLevel, principalsMap: principalsMap, optionalMessage: optionalMessage, stagedNotificationRecipients: stagedNotificationRecipients, experienceTracker: experienceTracker, validateRestrictedPrincipals: validateRestrictedPrincipals, fireAnalyticEvent: fireAnalyticEvent, contentSubType: contentSubType, contentType: contentType, callResolveMismatchedRestrictions: callResolveMismatchedRestrictions, isResolvingAction: isResolvingAction, isUnpublishedDraft: isUnpublishedDraft, includeInvites: includeInvites, refreshDialogState: refreshDialogState } = await awaitFlowEvent([
            'cta'
        ]);
        // Raise the loading spinner
        setMasterState((s)=>({
                ...s,
                isSaving: true
            }));
        if (isMutatingAction && contentType !== 'embed') experienceTracker.start({
            name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SAVE_ACTION_EXPERIENCE)
        });
        // Figure out if the user elected to send notifications, and included groups
        const stagedNotificationRecipientsHasGroups = stagedNotificationRecipients.some(({ type: type })=>type === 'group' || type === 'team');
        // If so, ask if they really intended to send notifications to all the group
        // members. Whittle down the final notification recipients list.
        let finalNotificationRecipients = stagedNotificationRecipients;
        // if we are going to send notification start the experience tracking
        if (isNotifyingAction && finalNotificationRecipients.length > 0) experienceTracker.start({
            name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SHARE_ACTION_EXPERIENCE)
        });
        // In case user choses not to notify groups then the success flag will show
        //'access update' even though individual users still will be notified
        let doNotNotifyGroups = false;
        if (isNotifyingAction && stagedNotificationRecipientsHasGroups) {
            // End the saving state and switch dialogs
            setMasterState((s)=>({
                    ...s,
                    sessionState: 'confirmGroupNotifications',
                    isSaving: false
                }));
            // Await a button click
            const { type: flowEventType } = await awaitFlowEvent([
                'doNotifyGroups',
                'doNotNotifyGroups'
            ]);
            // Filter the final list if they chose not to notify groups
            if (flowEventType === 'doNotNotifyGroups') {
                finalNotificationRecipients = stagedNotificationRecipients.filter(({ type: type })=>type !== 'group');
                doNotNotifyGroups = true;
            }
            // Bring back the lockout
            setMasterState((s)=>({
                    ...s,
                    isSaving: true
                }));
        }
        if (isResolvingAction) try {
            await callResolveMismatchedRestrictions();
        } catch (error) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'resolveMismatchedRestrictions',
                actionSubjectId: 'flowController',
                attributes: {
                    message: error.message
                }
            });
            errorFlag('mutation-error');
            experienceTracker.fail({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SAVE_ACTION_EXPERIENCE),
                error: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack
                },
                attributes: {
                    type: 'resolveMismatchedRestrictions'
                }
            });
            continue;
        }
        // If there's a content restrictions mutation staged, kick it off now
        // We do not want to mutate, we only want to notify for smart links
        if (isMutatingAction && contentType !== 'embed' && !isResolvingAction) try {
            if (userCanEditRestrictions) await mutateContentRestrictions(stagedGeneralAccessLevel, principalsMap, currentUser, includeInvites);
            experienceTracker.succeed({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SAVE_ACTION_EXPERIENCE)
            });
        } catch (error) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'mutateContentRestrictions',
                actionSubjectId: 'flowController',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                    userCanEditRestrictions: userCanEditRestrictions,
                    contentType: contentType,
                    principalListSize: principalsMap.size,
                    notificationRecipientsListSize: finalNotificationRecipients.length,
                    userErrors: currentUser.type === 'user' && currentUser.knownErrors?.accessWarning,
                    addMode: addMode,
                    contentSubType: contentSubType
                }
            });
            errorFlag('mutation-error');
            experienceTracker.fail({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SAVE_ACTION_EXPERIENCE),
                error: error,
                attributes: {
                    type: 'mutateContentRestrictions',
                    stagedGeneralAccessLevel: stagedGeneralAccessLevel,
                    userCanEditRestrictions: userCanEditRestrictions,
                    contentType: contentType,
                    principalListSize: principalsMap.size,
                    notificationRecipientsListSize: finalNotificationRecipients.length,
                    userErrors: currentUser.type === 'user' && currentUser.knownErrors?.accessWarning,
                    addMode: addMode,
                    contentSubType: contentSubType
                }
            });
            continue;
        }
        // If there are notifications to be sent, do that now
        if (isNotifyingAction && finalNotificationRecipients.length > 0 && !isResolvingAction) try {
            await sendNotification(finalNotificationRecipients, optionalMessage);
            experienceTracker.succeed({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SHARE_ACTION_EXPERIENCE)
            });
        } catch (error) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'sendNotification',
                actionSubjectId: 'flowController',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    isLivePage: contentSubType === 'live',
                    contentType: contentType,
                    contentSubType: contentSubType,
                    notificationRecipientsListSize: finalNotificationRecipients.length,
                    userErrors: currentUser.type === 'user' && currentUser.knownErrors?.accessWarning,
                    addMode: addMode,
                    optionalMessage: optionalMessage !== ''
                }
            });
            if (error?.message === 'list-too-large-error') errorFlag('list-too-large-error');
            else errorFlag('notification-error');
            experienceTracker.fail({
                name: (0, $irVI7.SHARE_AND_RESTRICT_DIALOG_SHARE_ACTION_EXPERIENCE),
                error: error,
                attributes: {
                    type: 'sendNotification',
                    isLivePage: contentSubType === 'live',
                    contentType: contentType,
                    contentSubType: contentSubType,
                    notificationRecipientsListSize: finalNotificationRecipients.length,
                    userErrors: currentUser.type === 'user' && currentUser.knownErrors?.accessWarning,
                    addMode: addMode,
                    optionalMessage: optionalMessage !== ''
                }
            });
        }
        const stagedNotificationUsersOnly = stagedNotificationRecipients.filter((val)=>{
            if (val.type == 'user') return val;
        });
        // validate if restricted access can be fixed and preload space role mode in parallel
        const [validationResult] = await Promise.all([
            validateRestrictedPrincipals({
                contentId: contentId,
                cloudId: cloudId,
                edition: edition,
                numberOfAncestors: numberOfAncestors,
                addMode: addMode,
                stagedUserPrincipals: stagedNotificationUsersOnly,
                setMasterState: setMasterState,
                fireAnalyticEvent: fireAnalyticEvent
            }),
            (0, $f2UnK.preloadSpaceRoleMode)(cloudId)
        ]);
        const { showWarnRestrictionsDialog: showWarnRestrictionsDialog, showResolveRestrictionsDialog: showResolveRestrictionsDialog } = validationResult;
        let flowEventType = null;
        let skipFlagRaise = false;
        if (showWarnRestrictionsDialog) {
            setMasterState((s)=>({
                    ...s,
                    sessionState: 'warnRestrictedAccess',
                    isSaving: false
                }));
            // Await a button click
            await awaitFlowEvent([
                'ignoreRestrictions'
            ]);
        }
        if (showResolveRestrictionsDialog) {
            setMasterState((s)=>({
                    ...s,
                    sessionState: 'resolveRestrictions',
                    isSaving: false
                }));
            // Await a button click
            const flowEvent = await awaitFlowEvent([
                'ignoreRestrictions',
                'resolveRestrictionsComplete'
            ]);
            const { type: type } = flowEvent;
            flowEventType = type;
            if (type === 'ignoreRestrictions') {
                const { shouldSkipFlagRaise: shouldSkipFlagRaise } = flowEvent;
                skipFlagRaise = shouldSkipFlagRaise;
            }
        }
        if (!skipFlagRaise) $b01594d0f49f4819$export$4f3f8e68f31fcd27({
            flowEventType: flowEventType,
            isNotifyingAction: isNotifyingAction,
            isMutatingAction: isMutatingAction,
            stagedGeneralAccessLevel: stagedGeneralAccessLevel,
            principalsMap: principalsMap,
            showWarnRestrictionsDialog: showWarnRestrictionsDialog,
            showResolveRestrictionsDialog: showResolveRestrictionsDialog,
            doNotNotifyGroups: doNotNotifyGroups,
            userCanEditRestrictions: userCanEditRestrictions,
            successFlag: successFlag,
            isUnpublishedDraft: isUnpublishedDraft
        });
        if ((0, $6mKj3.expValEquals)('persistence_specific_access_gate', 'cohort', 'experiment')) // Continue the loop and the session
        await refreshDialogState();
        else {
            // Break the loop and end the session
            beginTeardown();
            return;
        }
    }
};
module.exports["useCtaFlowController"] = $b01594d0f49f4819$export$629b25426d01cf1e;

});

parcelRegister("3Ipyu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $eSUdr = parcelRequire("eSUdr");


var $inPa6 = parcelRequire("inPa6");


var $ivb8S = parcelRequire("ivb8S");


var $bQm3c = parcelRequire("bQm3c");


var $eoU1C = parcelRequire("eoU1C");


var $6mKj3 = parcelRequire("6mKj3");


var $gqypm = parcelRequire("gqypm");


var $4adOe = parcelRequire("4adOe");

const $c4db89d3fe9dbc82$var$NewUserQuery = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query useSpotlightStateNewUserQuery($cloudId:String!$userId:String!)@experimental{experimentalSiteUserPersonalization(cloudId:$cloudId userId:$userId){attributes{name value}}}`;
const $c4db89d3fe9dbc82$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
function $c4db89d3fe9dbc82$export$1e2f426591a842cb() {
    const { isExistingUser: isExistingUser } = $c4db89d3fe9dbc82$export$6b9c87952ca5dfc5();
    const { isSpotlightActive: isSpotlightActive } = $c4db89d3fe9dbc82$export$a771c137b2620ff2();
    //Only existing users will see the spotlights
    if (isExistingUser) return {
        showSpotlight: isSpotlightActive
    };
    return {
        showSpotlight: false
    };
}
function $c4db89d3fe9dbc82$export$a771c137b2620ff2() {
    const spotlightKey = (0, $eoU1C.ONBOARDING_SHARE_AND_RESTRICT_DIALOG).GENERAL_AND_SPECIFIC_ACCESS_SEEN;
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const { data: data, loading: loading, error: spotlightError } = (0, $ivb8S.useGetOnboardingState)(spotlightKey);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (data && !loading && !spotlightError) {
            const spotlightSeen = data?.onboardingState?.find((prop)=>prop.key === spotlightKey)?.value === 'true';
            if (!spotlightSeen) setIsSpotlightActive(true);
        }
    }, [
        data,
        loading,
        spotlightError,
        spotlightKey
    ]);
    (0, $42omo.useEffect)(()=>{
        if (spotlightError && !loading) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                actionSubject: spotlightKey,
                action: 'spotlight failed'
            }
        }).fire();
    }, [
        spotlightKey,
        spotlightError,
        loading,
        createAnalyticsEvent
    ]);
    return {
        isSpotlightActive: isSpotlightActive
    };
}
const $c4db89d3fe9dbc82$export$6b9c87952ca5dfc5 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const queryArgs = {
        variables: {
            cloudId: cloudId,
            userId: userId ?? ''
        },
        skip: !userId || !cloudId
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data, loading: loading, error: error } = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_personalization', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    (0, $gqypm.useExperimentalSiteUserPersonalization)(queryArgs) : // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    (0, $j1Ss3.useQuery)($c4db89d3fe9dbc82$var$NewUserQuery, queryArgs);
    if (loading || error) return {
        isExistingUser: false
    };
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    const firstActiveValue = attributes?.find(({ name: name })=>name === $c4db89d3fe9dbc82$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const currentDate = Date.now();
    const firstActiveDate = new Date(firstActiveValue ?? '');
    // Check if the date is invalid. If it is, we assume the user is new
    // and return true to avoid mistakenly showing the onboarding message.
    // Related ticket: https://product-fabric.atlassian.net/browse/USD-698
    const isNotValidDate = isNaN(firstActiveDate.getTime()) || isNaN(currentDate);
    if (isNotValidDate) return {
        isExistingUser: false
    };
    const diffTime = Math.abs(currentDate - firstActiveDate.getTime());
    const diffDays = Math.floor(diffTime / 86400000);
    return {
        isExistingUser: Boolean(diffDays > 7)
    };
};
module.exports["useShouldShowSpotlight"] = $c4db89d3fe9dbc82$export$1e2f426591a842cb;

});

parcelRegister("ivb8S", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $cbOce = parcelRequire("cbOce");


var $6mKj3 = parcelRequire("6mKj3");

const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) onboardingState.forEach(({ key: key, value: value })=>{
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) return;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    });
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $eSUdr.default)`mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`, {
        update (cache, { data: data }) {
            const states = data.setOnboardingState;
            states.forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                cache.writeFragment({
                    id: `OnboardingState:${key}`,
                    fragment: (0, $eSUdr.default)`fragment myKey on OnboardingState{key value}`,
                    data: {
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $6mKj3.expVal)('confluence_consolidate_onboarding_state_queries', 'isEnabled', false) ? // eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Preloaded GraphQL Operation
    (0, $eSUdr.default)`query GetOnboardingState($key:[String]){onboardingState(key:$key){key value}}` : (0, $eSUdr.default)`query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key value}}`, {
        variables: {
            key: key
        },
        skip: skipQuery
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = [
    ...Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b)
];
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("dK51B", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval
    });
    (0, $42omo.useEffect)(()=>{
        if (!skip) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("79vw2", function(module, exports) {

var $99WQy = parcelRequire("99WQy");

var $7MMjM = parcelRequire("7MMjM");

var $dsdUb = parcelRequire("dsdUb");

var $l6lJr = parcelRequire("l6lJr");

var $9WUug = parcelRequire("9WUug");

var $4sK6R = parcelRequire("4sK6R");

var $ccQw1 = parcelRequire("ccQw1");

var $hUifo = parcelRequire("hUifo");


var $9JHBV = parcelRequire("9JHBV");


var $lyclm = parcelRequire("lyclm");

const $56d3cb5a2f4b0466$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.displayName;
    return (0, $hUifo.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.url;
    return (0, $l6lJr.extractLink)(response?.data);
};
const $56d3cb5a2f4b0466$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.ari || (0, $lyclm.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $99WQy.extractAri)(data);
};
const $56d3cb5a2f4b0466$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $lyclm.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $9JHBV.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $56d3cb5a2f4b0466$export$ff753ed519e96e9e = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityProvider)(response);
    return response?.data && (0, $ccQw1.extractProvider)(response?.data);
};
const $56d3cb5a2f4b0466$export$7a685df468cbf38f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdAt;
    return response?.data && (0, $7MMjM.extractDateCreated)(response.data);
};
const $56d3cb5a2f4b0466$export$75047940e157fd1f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $dsdUb.extractDateUpdated)(response.data);
};
const $56d3cb5a2f4b0466$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $9WUug.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $56d3cb5a2f4b0466$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $9WUug.extractPersonCreatedBy)(response.data);
};
const $56d3cb5a2f4b0466$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $4sK6R.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $56d3cb5a2f4b0466$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkTitle"] = $56d3cb5a2f4b0466$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $56d3cb5a2f4b0466$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $56d3cb5a2f4b0466$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $56d3cb5a2f4b0466$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $56d3cb5a2f4b0466$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $56d3cb5a2f4b0466$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $56d3cb5a2f4b0466$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $56d3cb5a2f4b0466$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $56d3cb5a2f4b0466$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $56d3cb5a2f4b0466$export$96ed4c1b14ac210a;

});

parcelRegister("99WQy", function(module, exports) {
const $7b9cf113c389991e$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
module.exports["extractAri"] = $7b9cf113c389991e$export$be18a6294fd426ec;

});

parcelRegister("7MMjM", function(module, exports) {
const $e4034aced29ead60$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $e4034aced29ead60$export$e1226a5e0bbbf862;

});

parcelRegister("dsdUb", function(module, exports) {
const $d35ebe54446110dc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $d35ebe54446110dc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("l6lJr", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $d3adf1d8ff29df55$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $kzBLz.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $d3adf1d8ff29df55$export$63f54cf4c5883620;

});

parcelRegister("kzBLz", function(module, exports) {
const $8554b737f5c5cb14$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $8554b737f5c5cb14$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
module.exports["extractUrlFromLinkJsonLd"] = $8554b737f5c5cb14$export$396ba4ef2e37dc65;

});

parcelRegister("9WUug", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $7710b1270e0d3189$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $7710b1270e0d3189$export$a66235cba0c9d11a;

});

parcelRegister("kzSaQ", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $141d786062a33a3a$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $141d786062a33a3a$export$c471ae5fddcf1392;

});

parcelRegister("8hlRK", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $15c3e8c19f3e9f93$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};
module.exports["extractUrlFromIconJsonLd"] = $15c3e8c19f3e9f93$export$67f3d92c824fd850;

});

parcelRegister("4sK6R", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $120900a6e202ebd4$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $120900a6e202ebd4$export$8a2d1ed7e6f336f0;

});

parcelRegister("ccQw1", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");





var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");


var $8hlRK = parcelRequire("8hlRK");

var $kzBLz = parcelRequire("kzBLz");

const $56eab8749893649b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $56eab8749893649b$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $56eab8749893649b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $56eab8749893649b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $3fvfu.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $56eab8749893649b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $56eab8749893649b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID);
};
module.exports["extractProvider"] = $56eab8749893649b$export$a832871718466647;
module.exports["extractProviderIcon"] = $56eab8749893649b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $56eab8749893649b$export$38df542ff03a4183;

});

parcelRegister("3fvfu", function(module, exports) {
const $443f0fc151c7533d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $443f0fc151c7533d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $443f0fc151c7533d$export$84a73a0383f58180 = 'JiraTask';
const $443f0fc151c7533d$export$c6c83963a9378a67 = 'JiraSubTask';
const $443f0fc151c7533d$export$58af3c426c111a6d = 'JiraStory';
const $443f0fc151c7533d$export$ac9898a63417219e = 'JiraBug';
const $443f0fc151c7533d$export$54db5e3fb12e39cd = 'JiraEpic';
const $443f0fc151c7533d$export$2f54a5a217202c85 = 'JiraIncident';
const $443f0fc151c7533d$export$d097371052bfc411 = 'JiraServiceRequest';
const $443f0fc151c7533d$export$efd9452ad16c6676 = 'JiraChange';
const $443f0fc151c7533d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $443f0fc151c7533d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
module.exports["CONFLUENCE_GENERATOR_ID"] = $443f0fc151c7533d$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $443f0fc151c7533d$export$f654d825189934a7;

});

parcelRegister("hUifo", function(module, exports) {

var $2LN0V = parcelRequire("2LN0V");


var $aliCf = parcelRequire("aliCf");

const $ca558e6955be7d7f$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $2LN0V.extractContext)(jsonLd);
    const type = (0, $aliCf.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
module.exports["extractTitle"] = $ca558e6955be7d7f$export$b05803156e5015b6;

});

parcelRegister("2LN0V", function(module, exports) {

var $aliCf = parcelRequire("aliCf");


var $8hlRK = parcelRequire("8hlRK");

const $1aa29b094fdafad8$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $aliCf.extractType)(context)
            };
        }
    }
    return undefined;
};
module.exports["extractContext"] = $1aa29b094fdafad8$export$efdbd45f3e77a161;

});

parcelRegister("aliCf", function(module, exports) {
const $b71c91ab48ca7fcb$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
module.exports["extractType"] = $b71c91ab48ca7fcb$export$2e9ae379995d99e3;

});

parcelRegister("9JHBV", function(module, exports) {

var $lmIyd = parcelRequire("lmIyd");


var $kzBLz = parcelRequire("kzBLz");

const $619c28d037f806e9$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $lmIyd.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
module.exports["extractPreview"] = $619c28d037f806e9$export$4b0d98b1b7f6d115;

});

parcelRegister("lmIyd", function(module, exports) {
const $0d1a0b98f1eafbac$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
module.exports["extractPlatformIsSupported"] = $0d1a0b98f1eafbac$export$3e8ad908070b68b2;

});

parcelRegister("lyclm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");





var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");

const $fe608b0eca8c0821$export$8beff7405d020ddf = (response)=>response?.entityData;
const $fe608b0eca8c0821$export$c7168210b81d9383 = (response)=>Boolean($fe608b0eca8c0821$export$8beff7405d020ddf(response));
const $fe608b0eca8c0821$export$f97663ee76ac5b24 = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $fe608b0eca8c0821$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $3fvfu.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $3fvfu.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $fe608b0eca8c0821$export$19346520e937a99f = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};
module.exports["extractEntity"] = $fe608b0eca8c0821$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $fe608b0eca8c0821$export$c7168210b81d9383;
module.exports["extractEntityEmbedUrl"] = $fe608b0eca8c0821$export$f97663ee76ac5b24;
module.exports["extractEntityProvider"] = $fe608b0eca8c0821$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $fe608b0eca8c0821$export$19346520e937a99f;

});

parcelRegister("btw9C", function(module, exports) {
const $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $2b201a7ae9d0ebd0$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $2b201a7ae9d0ebd0$export$b70265791d2079d4;

});

parcelRegister("jHnts", function(module, exports) {
class $65b10cace4bd92e7$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $65b10cace4bd92e7$export$3e5b797e39668f84;

});

parcelRegister("k8ulM", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== 'undefined' ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 3);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var RushaCore = __webpack_require__(5);
            var _require = __webpack_require__(1), toHex = _require.toHex, ceilHeapSize = _require.ceilHeapSize;
            var conv = __webpack_require__(6);
            // Calculate the length of buffer that the sha1 routine uses
            // including the padding.
            var padlen = function(len) {
                for(len += 9; len % 64 > 0; len += 1);
                return len;
            };
            var padZeroes = function(bin, len) {
                var h8 = new Uint8Array(bin.buffer);
                var om = len % 4, align = len - om;
                switch(om){
                    case 0:
                        h8[align + 3] = 0;
                    case 1:
                        h8[align + 2] = 0;
                    case 2:
                        h8[align + 1] = 0;
                    case 3:
                        h8[align + 0] = 0;
                }
                for(var i = (len >> 2) + 1; i < bin.length; i++)bin[i] = 0;
            };
            var padData = function(bin, chunkLen, msgLen) {
                bin[chunkLen >> 2] |= 0x80 << 24 - (chunkLen % 4 << 3);
                // To support msgLen >= 2 GiB, use a float division when computing the
                // high 32-bits of the big-endian message length in bits.
                bin[((chunkLen >> 2) + 2 & -16) + 14] = msgLen / 536870912 | 0;
                bin[((chunkLen >> 2) + 2 & -16) + 15] = msgLen << 3;
            };
            var getRawDigest = function(heap, padMaxChunkLen) {
                var io = new Int32Array(heap, padMaxChunkLen + 320, 5);
                var out = new Int32Array(5);
                var arr = new DataView(out.buffer);
                arr.setInt32(0, io[0], false);
                arr.setInt32(4, io[1], false);
                arr.setInt32(8, io[2], false);
                arr.setInt32(12, io[3], false);
                arr.setInt32(16, io[4], false);
                return out;
            };
            var Rusha = function() {
                function Rusha(chunkSize) {
                    _classCallCheck(this, Rusha);
                    chunkSize = chunkSize || 65536;
                    if (chunkSize % 64 > 0) throw new Error('Chunk size must be a multiple of 128 bit');
                    this._offset = 0;
                    this._maxChunkLen = chunkSize;
                    this._padMaxChunkLen = padlen(chunkSize);
                    // The size of the heap is the sum of:
                    // 1. The padded input message size
                    // 2. The extended space the algorithm needs (320 byte)
                    // 3. The 160 bit state the algoritm uses
                    this._heap = new ArrayBuffer(ceilHeapSize(this._padMaxChunkLen + 320 + 20));
                    this._h32 = new Int32Array(this._heap);
                    this._h8 = new Int8Array(this._heap);
                    this._core = new RushaCore({
                        Int32Array: Int32Array
                    }, {}, this._heap);
                }
                Rusha.prototype._initState = function _initState(heap, padMsgLen) {
                    this._offset = 0;
                    var io = new Int32Array(heap, padMsgLen + 320, 5);
                    io[0] = 1732584193;
                    io[1] = -271733879;
                    io[2] = -1732584194;
                    io[3] = 271733878;
                    io[4] = -1009589776;
                };
                Rusha.prototype._padChunk = function _padChunk(chunkLen, msgLen) {
                    var padChunkLen = padlen(chunkLen);
                    var view = new Int32Array(this._heap, 0, padChunkLen >> 2);
                    padZeroes(view, chunkLen);
                    padData(view, chunkLen, msgLen);
                    return padChunkLen;
                };
                Rusha.prototype._write = function _write(data, chunkOffset, chunkLen, off) {
                    conv(data, this._h8, this._h32, chunkOffset, chunkLen, off || 0);
                };
                Rusha.prototype._coreCall = function _coreCall(data, chunkOffset, chunkLen, msgLen, finalize) {
                    var padChunkLen = chunkLen;
                    this._write(data, chunkOffset, chunkLen);
                    if (finalize) padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                };
                Rusha.prototype.rawDigest = function rawDigest(str) {
                    var msgLen = str.byteLength || str.length || str.size || 0;
                    this._initState(this._heap, this._padMaxChunkLen);
                    var chunkOffset = 0, chunkLen = this._maxChunkLen;
                    for(chunkOffset = 0; msgLen > chunkOffset + chunkLen; chunkOffset += chunkLen)this._coreCall(str, chunkOffset, chunkLen, msgLen, false);
                    this._coreCall(str, chunkOffset, msgLen - chunkOffset, msgLen, true);
                    return getRawDigest(this._heap, this._padMaxChunkLen);
                };
                Rusha.prototype.digest = function digest(str) {
                    return toHex(this.rawDigest(str).buffer);
                };
                Rusha.prototype.digestFromString = function digestFromString(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromBuffer = function digestFromBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.digestFromArrayBuffer = function digestFromArrayBuffer(str) {
                    return this.digest(str);
                };
                Rusha.prototype.resetState = function resetState() {
                    this._initState(this._heap, this._padMaxChunkLen);
                    return this;
                };
                Rusha.prototype.append = function append(chunk) {
                    var chunkOffset = 0;
                    var chunkLen = chunk.byteLength || chunk.length || chunk.size || 0;
                    var turnOffset = this._offset % this._maxChunkLen;
                    var inputLen = void 0;
                    this._offset += chunkLen;
                    while(chunkOffset < chunkLen){
                        inputLen = Math.min(chunkLen - chunkOffset, this._maxChunkLen - turnOffset);
                        this._write(chunk, chunkOffset, inputLen, turnOffset);
                        turnOffset += inputLen;
                        chunkOffset += inputLen;
                        if (turnOffset === this._maxChunkLen) {
                            this._core.hash(this._maxChunkLen, this._padMaxChunkLen);
                            turnOffset = 0;
                        }
                    }
                    return this;
                };
                Rusha.prototype.getState = function getState() {
                    var turnOffset = this._offset % this._maxChunkLen;
                    var heap = void 0;
                    if (!turnOffset) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        heap = io.buffer.slice(io.byteOffset, io.byteOffset + io.byteLength);
                    } else heap = this._heap.slice(0);
                    return {
                        offset: this._offset,
                        heap: heap
                    };
                };
                Rusha.prototype.setState = function setState(state) {
                    this._offset = state.offset;
                    if (state.heap.byteLength === 20) {
                        var io = new Int32Array(this._heap, this._padMaxChunkLen + 320, 5);
                        io.set(new Int32Array(state.heap));
                    } else this._h32.set(new Int32Array(state.heap));
                    return this;
                };
                Rusha.prototype.rawEnd = function rawEnd() {
                    var msgLen = this._offset;
                    var chunkLen = msgLen % this._maxChunkLen;
                    var padChunkLen = this._padChunk(chunkLen, msgLen);
                    this._core.hash(padChunkLen, this._padMaxChunkLen);
                    var result = getRawDigest(this._heap, this._padMaxChunkLen);
                    this._initState(this._heap, this._padMaxChunkLen);
                    return result;
                };
                Rusha.prototype.end = function end() {
                    return toHex(this.rawEnd().buffer);
                };
                return Rusha;
            }();
            module1.exports = Rusha;
            module1.exports._core = RushaCore;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /* eslint-env commonjs, browser */ //
            // toHex
            //
            var precomputedHex = new Array(256);
            for(var i = 0; i < 256; i++)precomputedHex[i] = (i < 0x10 ? '0' : '') + i.toString(16);
            module1.exports.toHex = function(arrayBuffer) {
                var binarray = new Uint8Array(arrayBuffer);
                var res = new Array(arrayBuffer.byteLength);
                for(var _i = 0; _i < res.length; _i++)res[_i] = precomputedHex[binarray[_i]];
                return res.join('');
            };
            //
            // ceilHeapSize
            //
            module1.exports.ceilHeapSize = function(v) {
                // The asm.js spec says:
                // The heap object's byteLength must be either
                // 2^n for n in [12, 24) or 2^24 * n for n ≥ 1.
                // Also, byteLengths smaller than 2^16 are deprecated.
                var p = 0;
                // If v is smaller than 2^16, the smallest possible solution
                // is 2^16.
                if (v <= 65536) return 65536;
                // If v < 2^24, we round up to 2^n,
                // otherwise we round up to 2^24 * n.
                if (v < 16777216) {
                    for(p = 1; p < v; p = p << 1);
                } else {
                    for(p = 16777216; p < v; p += 16777216);
                }
                return p;
            };
            //
            // isDedicatedWorkerScope
            //
            module1.exports.isDedicatedWorkerScope = function(self1) {
                var isRunningInWorker = 'WorkerGlobalScope' in self1 && self1 instanceof self1.WorkerGlobalScope;
                var isRunningInSharedWorker = 'SharedWorkerGlobalScope' in self1 && self1 instanceof self1.SharedWorkerGlobalScope;
                var isRunningInServiceWorker = 'ServiceWorkerGlobalScope' in self1 && self1 instanceof self1.ServiceWorkerGlobalScope;
                // Detects whether we run inside a dedicated worker or not.
                //
                // We can't just check for `DedicatedWorkerGlobalScope`, since IE11
                // has a bug where it only supports `WorkerGlobalScope`.
                //
                // Therefore, we consider us as running inside a dedicated worker
                // when we are running inside a worker, but not in a shared or service worker.
                //
                // When new types of workers are introduced, we will need to adjust this code.
                return isRunningInWorker && !isRunningInSharedWorker && !isRunningInServiceWorker;
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, worker */ module1.exports = function() {
                var Rusha = __webpack_require__(0);
                var hashData = function(hasher, data, cb) {
                    try {
                        return cb(null, hasher.digest(data));
                    } catch (e) {
                        return cb(e);
                    }
                };
                var hashFile = function(hasher, readTotal, blockSize, file, cb) {
                    var reader = new self.FileReader();
                    reader.onloadend = function onloadend() {
                        if (reader.error) return cb(reader.error);
                        var buffer = reader.result;
                        readTotal += reader.result.byteLength;
                        try {
                            hasher.append(buffer);
                        } catch (e) {
                            cb(e);
                            return;
                        }
                        if (readTotal < file.size) hashFile(hasher, readTotal, blockSize, file, cb);
                        else cb(null, hasher.end());
                    };
                    reader.readAsArrayBuffer(file.slice(readTotal, readTotal + blockSize));
                };
                var workerBehaviourEnabled = true;
                self.onmessage = function(event) {
                    if (!workerBehaviourEnabled) return;
                    var data = event.data.data, file = event.data.file, id = event.data.id;
                    if (typeof id === 'undefined') return;
                    if (!file && !data) return;
                    var blockSize = event.data.blockSize || 4194304;
                    var hasher = new Rusha(blockSize);
                    hasher.resetState();
                    var done = function(err, hash) {
                        if (!err) self.postMessage({
                            id: id,
                            hash: hash
                        });
                        else self.postMessage({
                            id: id,
                            error: err.name
                        });
                    };
                    if (data) hashData(hasher, data, done);
                    if (file) hashFile(hasher, 0, blockSize, file, done);
                };
                return function() {
                    workerBehaviourEnabled = false;
                };
            };
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /* eslint-env commonjs, browser */ var work = __webpack_require__(4);
            var Rusha = __webpack_require__(0);
            var createHash = __webpack_require__(7);
            var runWorker = __webpack_require__(2);
            var _require = __webpack_require__(1), isDedicatedWorkerScope = _require.isDedicatedWorkerScope;
            var isRunningInDedicatedWorker = typeof self !== 'undefined' && isDedicatedWorkerScope(self);
            Rusha.disableWorkerBehaviour = isRunningInDedicatedWorker ? runWorker() : function() {};
            Rusha.createWorker = function() {
                var worker = work(/*require.resolve*/ 2);
                var terminate = worker.terminate;
                worker.terminate = function() {
                    URL.revokeObjectURL(worker.objectURL);
                    terminate.call(worker);
                };
                return worker;
            };
            Rusha.createHash = createHash;
            module1.exports = Rusha;
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            function webpackBootstrapFunc(modules) {
                /******/ // The module cache
                /******/ var installedModules = {};
                /******/ // The require function
                /******/ function __webpack_require__(moduleId) {
                    /******/ // Check if module is in cache
                    /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
                    /******/ // Create a new module (and put it into the cache)
                    /******/ var module1 = installedModules[moduleId] = {
                        /******/ i: moduleId,
                        /******/ l: false,
                        /******/ exports: {}
                    };
                    /******/ // Execute the module function
                    /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
                    /******/ // Flag the module as loaded
                    /******/ module1.l = true;
                    /******/ // Return the exports of the module
                    /******/ return module1.exports;
                /******/ }
                /******/ // expose the modules object (__webpack_modules__)
                /******/ __webpack_require__.m = modules;
                /******/ // expose the module cache
                /******/ __webpack_require__.c = installedModules;
                /******/ // identity function for calling harmony imports with the correct context
                /******/ __webpack_require__.i = function(value) {
                    return value;
                };
                /******/ // define getter function for harmony exports
                /******/ __webpack_require__.d = function(exports, name, getter) {
                    /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                        /******/ configurable: false,
                        /******/ enumerable: true,
                        /******/ get: getter
                    });
                /******/ };
                /******/ // define __esModule on exports
                /******/ __webpack_require__.r = function(exports) {
                    /******/ Object.defineProperty(exports, '__esModule', {
                        value: true
                    });
                /******/ };
                /******/ // getDefaultExport function for compatibility with non-harmony modules
                /******/ __webpack_require__.n = function(module1) {
                    /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                        return module1['default'];
                    } : /******/ function getModuleExports() {
                        return module1;
                    };
                    /******/ __webpack_require__.d(getter, 'a', getter);
                    /******/ return getter;
                /******/ };
                /******/ // Object.prototype.hasOwnProperty.call
                /******/ __webpack_require__.o = function(object, property) {
                    return Object.prototype.hasOwnProperty.call(object, property);
                };
                /******/ // __webpack_public_path__
                /******/ __webpack_require__.p = "/";
                /******/ // on error function for async loading
                /******/ __webpack_require__.oe = function(err) {
                    console.error(err);
                    throw err;
                };
                var f = __webpack_require__(__webpack_require__.s = ENTRY_MODULE);
                return f.default || f // try to call default if defined to also support babel esmodule exports
                ;
            }
            var moduleNameReqExp = '[\\.|\\-|\\+|\\w|\/|@]+';
            var dependencyRegExp = '\\((\/\\*.*?\\*\/)?\s?.*?(' + moduleNameReqExp + ').*?\\)' // additional chars when output.pathinfo is true
            ;
            // http://stackoverflow.com/a/2593661/130442
            function quoteRegExp(str) {
                return (str + '').replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
            }
            function getModuleDependencies(sources, module1, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module1.toString();
                var wrapperSignature = fnString.match(/^function\s?\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                // main bundle deps
                var re = new RegExp('(\\\\n|\\W)' + quoteRegExp(webpackRequireName) + dependencyRegExp, 'g');
                var match;
                while(match = re.exec(fnString)){
                    if (match[3] === 'dll-reference') continue;
                    retval[queueName].push(match[3]);
                }
                // dll deps
                re = new RegExp('\\(' + quoteRegExp(webpackRequireName) + '\\("(dll-reference\\s(' + moduleNameReqExp + '))"\\)\\)' + dependencyRegExp, 'g');
                while(match = re.exec(fnString)){
                    if (!sources[match[2]]) {
                        retval[queueName].push(match[1]);
                        sources[match[2]] = __webpack_require__(match[1]).m;
                    }
                    retval[match[2]] = retval[match[2]] || [];
                    retval[match[2]].push(match[4]);
                }
                return retval;
            }
            function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function(hasValues, key) {
                    return hasValues || queues[key].length > 0;
                }, false);
            }
            function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                    main: [
                        moduleId
                    ]
                };
                var requiredModules = {
                    main: []
                };
                var seenModules = {
                    main: {}
                };
                while(hasValuesInQueues(modulesQueue)){
                    var queues = Object.keys(modulesQueue);
                    for(var i = 0; i < queues.length; i++){
                        var queueName = queues[i];
                        var queue = modulesQueue[queueName];
                        var moduleToCheck = queue.pop();
                        seenModules[queueName] = seenModules[queueName] || {};
                        if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                        seenModules[queueName][moduleToCheck] = true;
                        requiredModules[queueName] = requiredModules[queueName] || [];
                        requiredModules[queueName].push(moduleToCheck);
                        var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                        var newModulesKeys = Object.keys(newModules);
                        for(var j = 0; j < newModulesKeys.length; j++){
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                            modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                        }
                    }
                }
                return requiredModules;
            }
            module1.exports = function(moduleId, options) {
                options = options || {};
                var sources = {
                    main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                    main: Object.keys(sources)
                } : getRequiredModules(sources, moduleId);
                var src = '';
                Object.keys(requiredModules).filter(function(m) {
                    return m !== 'main';
                }).forEach(function(module1) {
                    var entryModule = 0;
                    while(requiredModules[module1][entryModule])entryModule++;
                    requiredModules[module1].push(entryModule);
                    sources[module1][entryModule] = '(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })';
                    src = src + 'var ' + module1 + ' = (' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(entryModule)) + ')({' + requiredModules[module1].map(function(id) {
                        return '' + JSON.stringify(id) + ': ' + sources[module1][id].toString();
                    }).join(',') + '});\n';
                });
                src = src + '(' + webpackBootstrapFunc.toString().replace('ENTRY_MODULE', JSON.stringify(moduleId)) + ')({' + requiredModules.main.map(function(id) {
                    return '' + JSON.stringify(id) + ': ' + sources.main[id].toString();
                }).join(',') + '})(self);';
                var blob = new window.Blob([
                    src
                ], {
                    type: 'text/javascript'
                });
                if (options.bare) return blob;
                var URL1 = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL1.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
            };
        /***/ },
        /* 5 */ /***/ function(module1, exports) {
            // The low-level RushCore module provides the heart of Rusha,
            // a high-speed sha1 implementation working on an Int32Array heap.
            // At first glance, the implementation seems complicated, however
            // with the SHA1 spec at hand, it is obvious this almost a textbook
            // implementation that has a few functions hand-inlined and a few loops
            // hand-unrolled.
            module1.exports = function RushaCore(stdlib$840, foreign$841, heap$842) {
                'use asm';
                var H$843 = new stdlib$840.Int32Array(heap$842);
                function hash$844(k$845, x$846) {
                    // k in bytes
                    k$845 = k$845 | 0;
                    x$846 = x$846 | 0;
                    var i$847 = 0, j$848 = 0, y0$849 = 0, z0$850 = 0, y1$851 = 0, z1$852 = 0, y2$853 = 0, z2$854 = 0, y3$855 = 0, z3$856 = 0, y4$857 = 0, z4$858 = 0, t0$859 = 0, t1$860 = 0;
                    y0$849 = H$843[x$846 + 320 >> 2] | 0;
                    y1$851 = H$843[x$846 + 324 >> 2] | 0;
                    y2$853 = H$843[x$846 + 328 >> 2] | 0;
                    y3$855 = H$843[x$846 + 332 >> 2] | 0;
                    y4$857 = H$843[x$846 + 336 >> 2] | 0;
                    for(i$847 = 0; (i$847 | 0) < (k$845 | 0); i$847 = i$847 + 64 | 0){
                        z0$850 = y0$849;
                        z1$852 = y1$851;
                        z2$854 = y2$853;
                        z3$856 = y3$855;
                        z4$858 = y4$857;
                        for(j$848 = 0; (j$848 | 0) < 64; j$848 = j$848 + 4 | 0){
                            t1$860 = H$843[i$847 + j$848 >> 2] | 0;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[k$845 + j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 64 | 0; (j$848 | 0) < (k$845 + 80 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | ~y1$851 & y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1518500249 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 80 | 0; (j$848 | 0) < (k$845 + 160 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) + 1859775393 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 160 | 0; (j$848 | 0) < (k$845 + 240 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 & y2$853 | y1$851 & y3$855 | y2$853 & y3$855) | 0) + ((t1$860 + y4$857 | 0) - 1894007588 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        for(j$848 = k$845 + 240 | 0; (j$848 | 0) < (k$845 + 320 | 0); j$848 = j$848 + 4 | 0){
                            t1$860 = (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) << 1 | (H$843[j$848 - 12 >> 2] ^ H$843[j$848 - 32 >> 2] ^ H$843[j$848 - 56 >> 2] ^ H$843[j$848 - 64 >> 2]) >>> 31;
                            t0$859 = ((y0$849 << 5 | y0$849 >>> 27) + (y1$851 ^ y2$853 ^ y3$855) | 0) + ((t1$860 + y4$857 | 0) - 899497514 | 0) | 0;
                            y4$857 = y3$855;
                            y3$855 = y2$853;
                            y2$853 = y1$851 << 30 | y1$851 >>> 2;
                            y1$851 = y0$849;
                            y0$849 = t0$859;
                            H$843[j$848 >> 2] = t1$860;
                        }
                        y0$849 = y0$849 + z0$850 | 0;
                        y1$851 = y1$851 + z1$852 | 0;
                        y2$853 = y2$853 + z2$854 | 0;
                        y3$855 = y3$855 + z3$856 | 0;
                        y4$857 = y4$857 + z4$858 | 0;
                    }
                    H$843[x$846 + 320 >> 2] = y0$849;
                    H$843[x$846 + 324 >> 2] = y1$851;
                    H$843[x$846 + 328 >> 2] = y2$853;
                    H$843[x$846 + 332 >> 2] = y3$855;
                    H$843[x$846 + 336 >> 2] = y4$857;
                }
                return {
                    hash: hash$844
                };
            };
        /***/ },
        /* 6 */ /***/ function(module1, exports) {
            var _this = this;
            /* eslint-env commonjs, browser */ var reader = void 0;
            if (typeof self !== 'undefined' && typeof self.FileReaderSync !== 'undefined') reader = new self.FileReaderSync();
            // Convert a binary string and write it to the heap.
            // A binary string is expected to only contain char codes < 256.
            var convStr = function(str, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = str.charCodeAt(start + 3);
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = str.charCodeAt(start + 2);
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = str.charCodeAt(start + 1);
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = str.charCodeAt(start);
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2] = str.charCodeAt(start + i) << 24 | str.charCodeAt(start + i + 1) << 16 | str.charCodeAt(start + i + 2) << 8 | str.charCodeAt(start + i + 3);
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = str.charCodeAt(start + j + 2);
                    case 2:
                        H8[off + j + 2 | 0] = str.charCodeAt(start + j + 1);
                    case 1:
                        H8[off + j + 3 | 0] = str.charCodeAt(start + j);
                }
            };
            // Convert a buffer or array and write it to the heap.
            // The buffer or array is expected to only contain elements < 256.
            var convBuf = function(buf, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                switch(om){
                    case 0:
                        H8[off] = buf[start + 3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[start + 2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[start + 1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[start];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[start + i] << 24 | buf[start + i + 1] << 16 | buf[start + i + 2] << 8 | buf[start + i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[start + j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[start + j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[start + j];
                }
            };
            var convBlob = function(blob, H8, H32, start, len, off) {
                var i = void 0, om = off % 4, lm = (len + om) % 4, j = len - lm;
                var buf = new Uint8Array(reader.readAsArrayBuffer(blob.slice(start, start + len)));
                switch(om){
                    case 0:
                        H8[off] = buf[3];
                    case 1:
                        H8[off + 1 - (om << 1) | 0] = buf[2];
                    case 2:
                        H8[off + 2 - (om << 1) | 0] = buf[1];
                    case 3:
                        H8[off + 3 - (om << 1) | 0] = buf[0];
                }
                if (len < lm + (4 - om)) return;
                for(i = 4 - om; i < j; i = i + 4 | 0)H32[off + i >> 2 | 0] = buf[i] << 24 | buf[i + 1] << 16 | buf[i + 2] << 8 | buf[i + 3];
                switch(lm){
                    case 3:
                        H8[off + j + 1 | 0] = buf[j + 2];
                    case 2:
                        H8[off + j + 2 | 0] = buf[j + 1];
                    case 1:
                        H8[off + j + 3 | 0] = buf[j];
                }
            };
            module1.exports = function(data, H8, H32, start, len, off) {
                if (typeof data === 'string') return convStr(data, H8, H32, start, len, off);
                if (data instanceof Array) return convBuf(data, H8, H32, start, len, off);
                // Safely doing a Buffer check using "this" to avoid Buffer polyfill to be included in the dist
                if (_this && _this.Buffer && _this.Buffer.isBuffer(data)) return convBuf(data, H8, H32, start, len, off);
                if (data instanceof ArrayBuffer) return convBuf(new Uint8Array(data), H8, H32, start, len, off);
                if (data.buffer instanceof ArrayBuffer) return convBuf(new Uint8Array(data.buffer, data.byteOffset, data.byteLength), H8, H32, start, len, off);
                if (data instanceof Blob) return convBlob(data, H8, H32, start, len, off);
                throw new Error('Unsupported data type.');
            };
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /* eslint-env commonjs, browser */ var Rusha = __webpack_require__(0);
            var _require = __webpack_require__(1), toHex = _require.toHex;
            var Hash = function() {
                function Hash() {
                    _classCallCheck(this, Hash);
                    this._rusha = new Rusha();
                    this._rusha.resetState();
                }
                Hash.prototype.update = function update(data) {
                    this._rusha.append(data);
                    return this;
                };
                Hash.prototype.digest = function digest(encoding) {
                    var digest = this._rusha.rawEnd().buffer;
                    if (!encoding) return digest;
                    if (encoding === 'hex') return toHex(digest);
                    throw new Error('unsupported digest encoding');
                };
                _createClass(Hash, [
                    {
                        key: 'state',
                        get: function() {
                            return this._rusha.getState();
                        },
                        set: function(state) {
                            this._rusha.setState(state);
                        }
                    }
                ]);
                return Hash;
            }();
            module1.exports = function() {
                return new Hash();
            };
        /***/ }
    ]);
});

});

parcelRegister("5nZsM", function(module, exports) {

var $iKCFj = parcelRequire("iKCFj");


var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $3ebec708b133657c$var$camelCase = $2Ed9T(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $iKCFj(word) : word);
});
module.exports = $3ebec708b133657c$var$camelCase;

});

parcelRegister("iKCFj", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");


var $12IaO = parcelRequire("12IaO");

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $da6a84003d7bc8a2$var$capitalize(string) {
    return $12IaO($fPVB6(string).toLowerCase());
}
module.exports = $da6a84003d7bc8a2$var$capitalize;

});

parcelRegister("2Ed9T", function(module, exports) {

var $52wl7 = parcelRequire("52wl7");


var $iOvMY = parcelRequire("iOvMY");


var $bT49y = parcelRequire("bT49y");

/** Used to compose unicode capture groups. */ var $1ed9863c2ebfed04$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $1ed9863c2ebfed04$var$reApos = RegExp($1ed9863c2ebfed04$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $1ed9863c2ebfed04$var$createCompounder(callback) {
    return function(string) {
        return $52wl7($bT49y($iOvMY(string).replace($1ed9863c2ebfed04$var$reApos, '')), callback, '');
    };
}
module.exports = $1ed9863c2ebfed04$var$createCompounder;

});

parcelRegister("52wl7", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3ab639a44a152d0d$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3ab639a44a152d0d$var$arrayReduce;

});

parcelRegister("iOvMY", function(module, exports) {

var $i2ByD = parcelRequire("i2ByD");


var $fPVB6 = parcelRequire("fPVB6");

/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $db258e1bec5616a7$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $db258e1bec5616a7$var$rsComboMarksRange = '\\u0300-\\u036f', $db258e1bec5616a7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $db258e1bec5616a7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $db258e1bec5616a7$var$rsComboRange = $db258e1bec5616a7$var$rsComboMarksRange + $db258e1bec5616a7$var$reComboHalfMarksRange + $db258e1bec5616a7$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $db258e1bec5616a7$var$rsCombo = '[' + $db258e1bec5616a7$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $db258e1bec5616a7$var$reComboMark = RegExp($db258e1bec5616a7$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $db258e1bec5616a7$var$deburr(string) {
    string = $fPVB6(string);
    return string && string.replace($db258e1bec5616a7$var$reLatin, $i2ByD).replace($db258e1bec5616a7$var$reComboMark, '');
}
module.exports = $db258e1bec5616a7$var$deburr;

});

parcelRegister("i2ByD", function(module, exports) {

var $jghHU = parcelRequire("jghHU");

/** Used to map Latin Unicode letters to basic Latin letters. */ var $d2258c0d042ca0c6$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $d2258c0d042ca0c6$var$deburrLetter = $jghHU($d2258c0d042ca0c6$var$deburredLetters);
module.exports = $d2258c0d042ca0c6$var$deburrLetter;

});

parcelRegister("jghHU", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $e05d3f3448b226c6$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $e05d3f3448b226c6$var$basePropertyOf;

});

parcelRegister("bT49y", function(module, exports) {

var $011qA = parcelRequire("011qA");


var $1Xhyy = parcelRequire("1Xhyy");


var $fPVB6 = parcelRequire("fPVB6");


var $heRFI = parcelRequire("heRFI");

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $8a780d7d3205113e$var$words(string, pattern, guard) {
    string = $fPVB6(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $1Xhyy(string) ? $heRFI(string) : $011qA(string);
    return string.match(pattern) || [];
}
module.exports = $8a780d7d3205113e$var$words;

});

parcelRegister("011qA", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $003133aba52e1295$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $003133aba52e1295$var$asciiWords(string) {
    return string.match($003133aba52e1295$var$reAsciiWord) || [];
}
module.exports = $003133aba52e1295$var$asciiWords;

});

parcelRegister("1Xhyy", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $16c8eb795c50bf79$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $16c8eb795c50bf79$var$hasUnicodeWord(string) {
    return $16c8eb795c50bf79$var$reHasUnicodeWord.test(string);
}
module.exports = $16c8eb795c50bf79$var$hasUnicodeWord;

});

parcelRegister("heRFI", function(module, exports) {
/** Used to compose unicode character classes. */ var $c8cd609b21904ab0$var$rsAstralRange = '\\ud800-\\udfff', $c8cd609b21904ab0$var$rsComboMarksRange = '\\u0300-\\u036f', $c8cd609b21904ab0$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c8cd609b21904ab0$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c8cd609b21904ab0$var$rsComboRange = $c8cd609b21904ab0$var$rsComboMarksRange + $c8cd609b21904ab0$var$reComboHalfMarksRange + $c8cd609b21904ab0$var$rsComboSymbolsRange, $c8cd609b21904ab0$var$rsDingbatRange = '\\u2700-\\u27bf', $c8cd609b21904ab0$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $c8cd609b21904ab0$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $c8cd609b21904ab0$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $c8cd609b21904ab0$var$rsPunctuationRange = '\\u2000-\\u206f', $c8cd609b21904ab0$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $c8cd609b21904ab0$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $c8cd609b21904ab0$var$rsVarRange = '\\ufe0e\\ufe0f', $c8cd609b21904ab0$var$rsBreakRange = $c8cd609b21904ab0$var$rsMathOpRange + $c8cd609b21904ab0$var$rsNonCharRange + $c8cd609b21904ab0$var$rsPunctuationRange + $c8cd609b21904ab0$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $c8cd609b21904ab0$var$rsApos = "['\u2019]", $c8cd609b21904ab0$var$rsBreak = '[' + $c8cd609b21904ab0$var$rsBreakRange + ']', $c8cd609b21904ab0$var$rsCombo = '[' + $c8cd609b21904ab0$var$rsComboRange + ']', $c8cd609b21904ab0$var$rsDigits = '\\d+', $c8cd609b21904ab0$var$rsDingbat = '[' + $c8cd609b21904ab0$var$rsDingbatRange + ']', $c8cd609b21904ab0$var$rsLower = '[' + $c8cd609b21904ab0$var$rsLowerRange + ']', $c8cd609b21904ab0$var$rsMisc = '[^' + $c8cd609b21904ab0$var$rsAstralRange + $c8cd609b21904ab0$var$rsBreakRange + $c8cd609b21904ab0$var$rsDigits + $c8cd609b21904ab0$var$rsDingbatRange + $c8cd609b21904ab0$var$rsLowerRange + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c8cd609b21904ab0$var$rsModifier = '(?:' + $c8cd609b21904ab0$var$rsCombo + '|' + $c8cd609b21904ab0$var$rsFitz + ')', $c8cd609b21904ab0$var$rsNonAstral = '[^' + $c8cd609b21904ab0$var$rsAstralRange + ']', $c8cd609b21904ab0$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c8cd609b21904ab0$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c8cd609b21904ab0$var$rsUpper = '[' + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c8cd609b21904ab0$var$rsMiscLower = '(?:' + $c8cd609b21904ab0$var$rsLower + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsMiscUpper = '(?:' + $c8cd609b21904ab0$var$rsUpper + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsOptContrLower = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $c8cd609b21904ab0$var$rsOptContrUpper = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $c8cd609b21904ab0$var$reOptMod = $c8cd609b21904ab0$var$rsModifier + '?', $c8cd609b21904ab0$var$rsOptVar = '[' + $c8cd609b21904ab0$var$rsVarRange + ']?', $c8cd609b21904ab0$var$rsOptJoin = '(?:' + $c8cd609b21904ab0$var$rsZWJ + '(?:' + [
    $c8cd609b21904ab0$var$rsNonAstral,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + ')*', $c8cd609b21904ab0$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $c8cd609b21904ab0$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $c8cd609b21904ab0$var$rsSeq = $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + $c8cd609b21904ab0$var$rsOptJoin, $c8cd609b21904ab0$var$rsEmoji = '(?:' + [
    $c8cd609b21904ab0$var$rsDingbat,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsSeq;
/** Used to match complex or compound words. */ var $c8cd609b21904ab0$var$reUnicodeWord = RegExp([
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsMiscUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper + $c8cd609b21904ab0$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsMiscLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower,
    $c8cd609b21904ab0$var$rsUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper,
    $c8cd609b21904ab0$var$rsOrdUpper,
    $c8cd609b21904ab0$var$rsOrdLower,
    $c8cd609b21904ab0$var$rsDigits,
    $c8cd609b21904ab0$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $c8cd609b21904ab0$var$unicodeWords(string) {
    return string.match($c8cd609b21904ab0$var$reUnicodeWord) || [];
}
module.exports = $c8cd609b21904ab0$var$unicodeWords;

});

parcelRegister("7uLCZ", function(module, exports) {

var $bDniu = parcelRequire("bDniu");


var $4tRVV = parcelRequire("4tRVV");



var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $2HVlJ = parcelRequire("2HVlJ");



var $lPGZG = parcelRequire("lPGZG");


var $dlky5 = parcelRequire("dlky5");

var $575047a4d1f8def0$export$bb38bb9a1161268 = 'unmounted';
var $575047a4d1f8def0$export$84cbff306f539230 = 'exited';
var $575047a4d1f8def0$export$df38205c966be359 = 'entering';
var $575047a4d1f8def0$export$78e9e6e3e014d60a = 'entered';
var $575047a4d1f8def0$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $575047a4d1f8def0$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $4tRVV.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
                _this.appearStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else initialStatus = $575047a4d1f8def0$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $575047a4d1f8def0$export$bb38bb9a1161268;
        else initialStatus = $575047a4d1f8def0$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $575047a4d1f8def0$export$bb38bb9a1161268) return {
            status: $575047a4d1f8def0$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $575047a4d1f8def0$export$df38205c966be359 && status !== $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$df38205c966be359;
            } else if (status === $575047a4d1f8def0$export$df38205c966be359 || status === $575047a4d1f8def0$export$78e9e6e3e014d60a) nextStatus = $575047a4d1f8def0$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $575047a4d1f8def0$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $dlky5.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $575047a4d1f8def0$export$84cbff306f539230) this.setState({
            status: $575047a4d1f8def0$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $575047a4d1f8def0$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $575047a4d1f8def0$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $2HVlJ.default).disabled) {
            this.safeSetState({
                status: $575047a4d1f8def0$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $575047a4d1f8def0$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $575047a4d1f8def0$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $575047a4d1f8def0$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $bDniu.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lPGZG.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component);
$575047a4d1f8def0$var$Transition.contextType = (0, $lPGZG.default);
$575047a4d1f8def0$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $575047a4d1f8def0$var$noop() {}
$575047a4d1f8def0$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $575047a4d1f8def0$var$noop,
    onEntering: $575047a4d1f8def0$var$noop,
    onEntered: $575047a4d1f8def0$var$noop,
    onExit: $575047a4d1f8def0$var$noop,
    onExiting: $575047a4d1f8def0$var$noop,
    onExited: $575047a4d1f8def0$var$noop
};
$575047a4d1f8def0$var$Transition.UNMOUNTED = $575047a4d1f8def0$export$bb38bb9a1161268;
$575047a4d1f8def0$var$Transition.EXITED = $575047a4d1f8def0$export$84cbff306f539230;
$575047a4d1f8def0$var$Transition.ENTERING = $575047a4d1f8def0$export$df38205c966be359;
$575047a4d1f8def0$var$Transition.ENTERED = $575047a4d1f8def0$export$78e9e6e3e014d60a;
$575047a4d1f8def0$var$Transition.EXITING = $575047a4d1f8def0$export$4aacc83d4d59139f;
var $575047a4d1f8def0$export$2e2bcd8739ae039 = $575047a4d1f8def0$var$Transition;
module.exports["default"] = $575047a4d1f8def0$export$2e2bcd8739ae039;

});

parcelRegister("2HVlJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f8c1559a495fd3f$export$2e2bcd8739ae039);
var $1f8c1559a495fd3f$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("lPGZG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4fb61bd619d593$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var $fe4fb61bd619d593$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);

});

parcelRegister("dlky5", function(module, exports) {
var $9b6d2d196fd1178d$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $9b6d2d196fd1178d$export$7d26bbb1236dafd6;

});

parcelRegister("k9Smn", function(module, exports) {

var $7Q5yr = parcelRequire("7Q5yr");


var $bDniu = parcelRequire("bDniu");

//      
var $eaced0a9c3d84a94$var$charCodeOfDot = ".".charCodeAt(0);
var $eaced0a9c3d84a94$var$reEscapeChar = /\\(\\)?/g;
var $eaced0a9c3d84a94$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $eaced0a9c3d84a94$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $eaced0a9c3d84a94$var$charCodeOfDot) result.push("");
    string.replace($eaced0a9c3d84a94$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($eaced0a9c3d84a94$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $eaced0a9c3d84a94$var$keysCache = {};
var $eaced0a9c3d84a94$var$keysRegex = /[.[\]]+/;
var $eaced0a9c3d84a94$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($eaced0a9c3d84a94$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $eaced0a9c3d84a94$var$keysCache[key] = key.split($eaced0a9c3d84a94$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $eaced0a9c3d84a94$var$keysCache[key] = $eaced0a9c3d84a94$var$stringToPath(key);
    }
    return $eaced0a9c3d84a94$var$keysCache[key];
};
//      
var $eaced0a9c3d84a94$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $eaced0a9c3d84a94$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $eaced0a9c3d84a94$var$_toPropertyKey(arg) {
    var key = $eaced0a9c3d84a94$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eaced0a9c3d84a94$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eaced0a9c3d84a94$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $bDniu.default)(current, [
                key
            ].map($eaced0a9c3d84a94$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $7Q5yr.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $eaced0a9c3d84a94$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $eaced0a9c3d84a94$var$setInRecursor(state, 0, $eaced0a9c3d84a94$var$toPath(key), value1, destroyArrays);
};
var $eaced0a9c3d84a94$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $eaced0a9c3d84a94$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $eaced0a9c3d84a94$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(values, name);
    var error = $eaced0a9c3d84a94$export$c52e5867d5879e24(errors, name);
    if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) error = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
    var submitError = submitErrors && $eaced0a9c3d84a94$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $eaced0a9c3d84a94$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $eaced0a9c3d84a94$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $eaced0a9c3d84a94$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $eaced0a9c3d84a94$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$eaced0a9c3d84a94$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $eaced0a9c3d84a94$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$41e855cb628c1b55, $eaced0a9c3d84a94$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $eaced0a9c3d84a94$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $eaced0a9c3d84a94$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $eaced0a9c3d84a94$var$subscriptionFilter(result, state, previousState, subscription, $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3, $eaced0a9c3d84a94$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $eaced0a9c3d84a94$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$eaced0a9c3d84a94$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $eaced0a9c3d84a94$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $eaced0a9c3d84a94$export$83d89fbfd8236492 = "4.20.10";
var $eaced0a9c3d84a94$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $eaced0a9c3d84a94$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $eaced0a9c3d84a94$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $eaced0a9c3d84a94$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $eaced0a9c3d84a94$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $eaced0a9c3d84a94$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $eaced0a9c3d84a94$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($eaced0a9c3d84a94$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $eaced0a9c3d84a94$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $7Q5yr.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $7Q5yr.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $7Q5yr.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $7Q5yr.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $7Q5yr.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $eaced0a9c3d84a94$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $eaced0a9c3d84a94$export$e6bdf135a54e021b,
                    shallowEqual: $eaced0a9c3d84a94$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $7Q5yr.default)({}, state.formState.values)); // clone to avoid writing
            if ($eaced0a9c3d84a94$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $eaced0a9c3d84a94$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $eaced0a9c3d84a94$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $7Q5yr.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $eaced0a9c3d84a94$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$eaced0a9c3d84a94$export$735bebc8ffabf28a]) {
                    var existing = $eaced0a9c3d84a94$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$eaced0a9c3d84a94$export$735bebc8ffabf28a] = error[$eaced0a9c3d84a94$export$735bebc8ffabf28a];
                    merged = $eaced0a9c3d84a94$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$eaced0a9c3d84a94$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $eaced0a9c3d84a94$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $eaced0a9c3d84a94$var$notify(fieldSubscriber, fieldState, lastFieldState, $eaced0a9c3d84a94$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $eaced0a9c3d84a94$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $7Q5yr.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$eaced0a9c3d84a94$var$hasAnyError(formState.errors) && !(formState.submitErrors && $eaced0a9c3d84a94$var$hasAnyError(formState.submitErrors));
        var nextFormState = $eaced0a9c3d84a94$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $eaced0a9c3d84a94$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $eaced0a9c3d84a94$var$notify(state.subscribers, nextFormState, lastFormState, $eaced0a9c3d84a94$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $7Q5yr.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $7Q5yr.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key), $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $eaced0a9c3d84a94$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $eaced0a9c3d84a94$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $eaced0a9c3d84a94$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.values, name) === $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $eaced0a9c3d84a94$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $eaced0a9c3d84a94$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $7Q5yr.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $eaced0a9c3d84a94$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$eaced0a9c3d84a94$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $7Q5yr.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $eaced0a9c3d84a94$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $eaced0a9c3d84a94$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $eaced0a9c3d84a94$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $eaced0a9c3d84a94$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $eaced0a9c3d84a94$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $eaced0a9c3d84a94$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $eaced0a9c3d84a94$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $eaced0a9c3d84a94$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $eaced0a9c3d84a94$export$83d89fbfd8236492;
module.exports["createForm"] = $eaced0a9c3d84a94$export$f681a8129d2e9d28;

});

parcelRegister("jTvbt", function(module, exports) {

var $k9Smn = parcelRequire("k9Smn");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $e7bb57e5fe20696d$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $e7bb57e5fe20696d$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $e7bb57e5fe20696d$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $k9Smn.getIn)(errors, input.name);
    });
};
//      
var $e7bb57e5fe20696d$var$noop = function noop() {};
var $e7bb57e5fe20696d$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $e7bb57e5fe20696d$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $e7bb57e5fe20696d$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $e7bb57e5fe20696d$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $e7bb57e5fe20696d$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($e7bb57e5fe20696d$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$e7bb57e5fe20696d$export$2e2bcd8739ae039 = $e7bb57e5fe20696d$var$createDecorator;
module.exports["default"] = $e7bb57e5fe20696d$export$2e2bcd8739ae039;

});

parcelRegister("abN8T", function(module, exports) {

var $92z90 = parcelRequire("92z90");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $76b10d1eacd527b2$var$set(object, path, value) {
    return object == null ? object : $92z90(object, path, value);
}
module.exports = $76b10d1eacd527b2$var$set;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("1To4a", function(module, exports) {


var $1vDIt = parcelRequire("1vDIt");


var $kyRHQ = parcelRequire("kyRHQ");

function $cd5eb1a9b0824c7e$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $1vDIt.default)[tokenId];
    let tokenValue = fallback;
    typeof $kyRHQ;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $cd5eb1a9b0824c7e$export$2e2bcd8739ae039 = $cd5eb1a9b0824c7e$var$getTokenValue;
module.exports["default"] = $cd5eb1a9b0824c7e$export$2e2bcd8739ae039;

});

parcelRegister("g7Pc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34dc1cd2084e09d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");


var $lHMuy = parcelRequire("lHMuy");

function $e34dc1cd2084e09d$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: label,
        tag: $e34dc1cd2084e09d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lHMuy.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lHMuy.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $e34dc1cd2084e09d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});

parcelRegister("lHMuy", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");

const $994b46f1e25bb927$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $994b46f1e25bb927$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $994b46f1e25bb927$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $l998X.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}
module.exports["Decorator"] = $994b46f1e25bb927$export$a592b67c93d52467;

});

parcelRegister("03WRT", function(module, exports) {
$parcel$export(module.exports, "default", () => $484d2d2be4c10078$export$2e2bcd8739ae039);
const $484d2d2be4c10078$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $484d2d2be4c10078$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($484d2d2be4c10078$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("cTQmR", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $a6db6a3439cd9017$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $a6db6a3439cd9017$export$7c77c3a9bb93870d;

});

parcelRegister("dIxHZ", function(module, exports) {

var $2Hy4R = parcelRequire("2Hy4R");


var $dlSEv = parcelRequire("dlSEv");

var $73c40f69a74688ac$var$FORMATS = /*#__PURE__*/ function(FORMATS) {
    FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
    FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    return FORMATS;
}($73c40f69a74688ac$var$FORMATS || {});
const $73c40f69a74688ac$export$56c3660a4ee2196a = (timestamp)=>{
    const date = new Date(Number(timestamp));
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return {
        day: day,
        month: month,
        year: year
    };
};
const $73c40f69a74688ac$export$6297728405c48562 = ()=>{
    const today = new Date(Date.now());
    const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
    return todayInUTC.toString();
};
const $73c40f69a74688ac$var$addLeadingZero = (val)=>{
    if (val < 10) return `0${val}`;
    return val;
};
const $73c40f69a74688ac$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $73c40f69a74688ac$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
    if (!intl || pattern === "YYYY-MM-DD") return $73c40f69a74688ac$export$70a1b7b6fffe4dd1(timestamp);
    const date = new Date(Number(timestamp));
    return intl.formatDate(date, {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        formatMatcher: 'best fit'
    });
};
const $73c40f69a74688ac$export$70a1b7b6fffe4dd1 = (timestamp)=>{
    const date = new Date(Number(timestamp));
    return `${date.getUTCFullYear()}-${$73c40f69a74688ac$var$addLeadingZero(date.getUTCMonth() + 1)}-${$73c40f69a74688ac$var$addLeadingZero(date.getUTCDate())}`;
};
const $73c40f69a74688ac$export$e6cc7bfc6e0e363e = (timestamp)=>{
    return (0, $dlSEv.default)(new Date(Number(timestamp)), new Date(Number($73c40f69a74688ac$export$6297728405c48562())));
};
const $73c40f69a74688ac$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
    const curDate = new Date(Number($73c40f69a74688ac$export$6297728405c48562()));
    const givenDate = new Date(Number(timestamp));
    const distance = (0, $2Hy4R.default)(givenDate, curDate);
    if (intl && [
        -1,
        0,
        1
    ].indexOf(distance) > -1) return $73c40f69a74688ac$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
        numeric: 'auto'
    }));
    return $73c40f69a74688ac$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
};
module.exports["timestampToUTCDate"] = $73c40f69a74688ac$export$56c3660a4ee2196a;
module.exports["todayTimestampInUTC"] = $73c40f69a74688ac$export$6297728405c48562;
module.exports["timestampToString"] = $73c40f69a74688ac$export$48755a044ef883a0;
module.exports["timestampToIsoFormat"] = $73c40f69a74688ac$export$70a1b7b6fffe4dd1;
module.exports["isPastDate"] = $73c40f69a74688ac$export$e6cc7bfc6e0e363e;
module.exports["timestampToTaskContext"] = $73c40f69a74688ac$export$fbc04a9e57b04a80;

});

parcelRegister("lgqac", function(module, exports) {
const $a2012143faf474ac$export$85183a312807388d = 'media';
const $a2012143faf474ac$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $a2012143faf474ac$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $a2012143faf474ac$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $a2012143faf474ac$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $a2012143faf474ac$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $a2012143faf474ac$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($a2012143faf474ac$export$85183a312807388d);
};
module.exports["ANALYTICS_CHANNEL"] = $a2012143faf474ac$export$85183a312807388d;
module.exports["context"] = $a2012143faf474ac$export$a078c61943f9dbbe;
module.exports["TrackQuickActionType"] = $a2012143faf474ac$export$72af824fa910c33e;
module.exports["TrackQuickActionFailureReason"] = $a2012143faf474ac$export$c89e475f7f7174c2;
module.exports["SmartLinkEvents"] = $a2012143faf474ac$export$b91e0203b928470c;

});

parcelRegister("kKODE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $1PKWZ = parcelRequire("1PKWZ");


var $cGziR = parcelRequire("cGziR");

const $5b5d947ab1fa491a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $cGziR.default)(...params));
        event.fire((0, $1PKWZ.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $5b5d947ab1fa491a$export$5bf35293e545f20c;

});

parcelRegister("1PKWZ", function(module, exports) {
const $6678419bc4dceb3a$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $6678419bc4dceb3a$export$3f072f06b90c3985;

});

parcelRegister("cGziR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $4575fec4bf8df71a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4575fec4bf8df71a$export$2e2bcd8739ae039 = $4575fec4bf8df71a$var$createEventPayload;
module.exports["default"] = $4575fec4bf8df71a$export$2e2bcd8739ae039;

});

parcelRegister("bIll3", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $fe01df8db47f84d1$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
};
const $fe01df8db47f84d1$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9801n.ConcurrentExperience)('smart-link-rendered', $fe01df8db47f84d1$var$renderExperience),
    'smart-link-authenticated': new (0, $9801n.ConcurrentExperience)('smart-link-authenticated', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9801n.ConcurrentExperience)('smart-link-action-invocation', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9801n.ConcurrentExperience)('smart-link-ai-summary', $fe01df8db47f84d1$var$aiExperience)
};
const $fe01df8db47f84d1$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $fe01df8db47f84d1$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};
module.exports["startUfoExperience"] = $fe01df8db47f84d1$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $fe01df8db47f84d1$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $fe01df8db47f84d1$export$8dda83bafca11b77;
module.exports["addMetadataToExperience"] = $fe01df8db47f84d1$export$4084c0df4a03a6af;

});

parcelRegister("5TXU5", function(module, exports) {
const $d747218f543c7aaa$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d747218f543c7aaa$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d747218f543c7aaa$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d747218f543c7aaa$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d747218f543c7aaa$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $d747218f543c7aaa$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $d747218f543c7aaa$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $d747218f543c7aaa$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $d747218f543c7aaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $d747218f543c7aaa$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $d747218f543c7aaa$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $d747218f543c7aaa$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $d747218f543c7aaa$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $d747218f543c7aaa$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $d747218f543c7aaa$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $d747218f543c7aaa$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $d747218f543c7aaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $d747218f543c7aaa$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $d747218f543c7aaa$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $d747218f543c7aaa$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});
module.exports["CONTENT_URL_SECURITY_AND_PERMISSIONS"] = $d747218f543c7aaa$export$5c881701926acbef;
module.exports["CONTENT_URL_3P_ACCOUNT_AUTH"] = $d747218f543c7aaa$export$93d67ab022d9f8d2;
module.exports["CONTENT_URL_AI"] = $d747218f543c7aaa$export$70d24f0465ae60f8;
module.exports["CONTENT_URL_AI_TROUBLESHOOTING"] = $d747218f543c7aaa$export$a3ed5c4e9d9599b7;
module.exports["CONTENT_URL_ACCEPTABLE_USE_POLICY"] = $d747218f543c7aaa$export$73b198e73554a323;
module.exports["SmartLinkAlignment"] = $d747218f543c7aaa$export$8910bf86027fe6be;
module.exports["SmartLinkDirection"] = $d747218f543c7aaa$export$60831686b0574c86;
module.exports["SmartLinkPosition"] = $d747218f543c7aaa$export$d58e6377644d1dcf;
module.exports["SmartLinkSize"] = $d747218f543c7aaa$export$51f13ced115cbdae;
module.exports["SmartLinkStatus"] = $d747218f543c7aaa$export$61cff06be26816f;
module.exports["SmartLinkTheme"] = $d747218f543c7aaa$export$aed0f1e801ad691f;
module.exports["SmartLinkInternalTheme"] = $d747218f543c7aaa$export$9aafec380d7005da;
module.exports["SmartLinkWidth"] = $d747218f543c7aaa$export$19c60054ee783de6;
module.exports["ElementName"] = $d747218f543c7aaa$export$d65b168331104a46;
module.exports["ActionName"] = $d747218f543c7aaa$export$9c95d6e1614bad84;
module.exports["InternalActionName"] = $d747218f543c7aaa$export$4871a84b35cf8eb9;
module.exports["IconType"] = $d747218f543c7aaa$export$13ff1290a9e22e77;
module.exports["MediaType"] = $d747218f543c7aaa$export$483c11740a902fcd;
module.exports["MediaPlacement"] = $d747218f543c7aaa$export$f9f4737e25ab90fa;
module.exports["CardDisplay"] = $d747218f543c7aaa$export$6ca4ef8b3dc2c804;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ]),
        children: children
    });
}

});

parcelRegister("6iY4P", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("5MkWK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $c6GJD = parcelRequire("c6GJD");


var $1xKpK = parcelRequire("1xKpK");


var $eIleF = parcelRequire("eIleF");


var $6q0AE = parcelRequire("6q0AE");


var $dh538 = parcelRequire("dh538");


var $lz9QA = parcelRequire("lz9QA");


var $lgqac = parcelRequire("lgqac");

const $9dd53b67e285af98$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $1xKpK.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $9dd53b67e285af98$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $lgqac.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $9dd53b67e285af98$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const state = store ? (0, $6q0AE.getUrl)(store, url) : undefined;
    return (0, $42omo.useMemo)(()=>{
        return $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $9dd53b67e285af98$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $lz9QA.useSmartCardState)(url);
    const data = $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: data
    }, children);
};
module.exports["useSmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$ac28ada90c4970b7;
module.exports["SmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$eaff10f7ec59c455;

});

parcelRegister("1xKpK", function(module, exports) {

var $btw9C = parcelRequire("btw9C");


var $8Wacp = parcelRequire("8Wacp");


var $dh538 = parcelRequire("dh538");

const $6804f58a391a686f$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $btw9C.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $8Wacp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};
module.exports["getResolvedAttributes"] = $6804f58a391a686f$export$7243431f5325a7b;

});

parcelRegister("8Wacp", function(module, exports) {
const $637663634becf001$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};
module.exports["getDisplayCategory"] = $637663634becf001$export$28ddbae335bd80b5;

});

parcelRegister("eIleF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $38c931550e91452f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $38c931550e91452f$export$e1d190b530cf0ee9() {
    const context = (0, $42omo.useContext)($38c931550e91452f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $38c931550e91452f$export$10e9cca30e50f657 = ()=>$38c931550e91452f$var$useContextMemoized($38c931550e91452f$export$156b523e63b4f63a);
const $38c931550e91452f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
function $38c931550e91452f$var$useContextMemoized(reactContext) {
    const value = (0, $42omo.useContext)(reactContext);
    const context = (0, $42omo.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $38c931550e91452f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $l998X.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $38c931550e91452f$export$2e2bcd8739ae039 = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["SmartCardContext"] = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["useSmartLinkContext"] = $38c931550e91452f$export$e1d190b530cf0ee9;
module.exports["useSmartCardContext"] = $38c931550e91452f$export$10e9cca30e50f657;
module.exports["EditorSmartCardProviderValueGuard"] = $38c931550e91452f$export$797e3658f090919c;
module.exports["EditorSmartCardProvider"] = $38c931550e91452f$export$2a29ca11e08dc129;

});

parcelRegister("6q0AE", function(module, exports) {
const $30e97e7594f3b00b$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};
module.exports["getUrl"] = $30e97e7594f3b00b$export$94df0e59ebebf4a7;

});

parcelRegister("lz9QA", function(module, exports) {

var $hpRUx = parcelRequire("hpRUx");


var $eIleF = parcelRequire("eIleF");

const $206782ec364200b6$var$PENDING_STATE = {
    status: 'pending'
};
function $206782ec364200b6$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const cardState = (0, $hpRUx.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $206782ec364200b6$var$PENDING_STATE;
}
module.exports["useSmartCardState"] = $206782ec364200b6$export$b0444d00ba7313c6;

});

parcelRegister("4P6U3", function(module, exports) {
const $9f845e05fed92a58$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9f845e05fed92a58$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9f845e05fed92a58$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9f845e05fed92a58$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9f845e05fed92a58$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9f845e05fed92a58$var$result.android = /Android \d/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9f845e05fed92a58$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9f845e05fed92a58$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9f845e05fed92a58$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9f845e05fed92a58$export$3f2684e5d7cb1006() {
    return $9f845e05fed92a58$var$result;
}
module.exports["browser"] = $9f845e05fed92a58$export$3f2684e5d7cb1006;

});

parcelRegister("afp1H", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8ae4cb49ca93b6d8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    actions: {
        id: "fabric.linking.actions",
        defaultMessage: "Actions"
    },
    add_account: {
        id: "fabric.linking.add_account",
        defaultMessage: "Add account"
    },
    ai_summarize: {
        id: "fabric.linking.ai_summarize",
        defaultMessage: "Summarize"
    },
    ai_summarized: {
        id: "fabric.linking.ai_summarized",
        defaultMessage: "Summarized by Atlassian Intelligence"
    },
    ai_summarized_abbreviation: {
        id: "fabric.linking.ai_summarized_abbreviation",
        defaultMessage: "Summarized by AI"
    },
    ai_summarized_info: {
        id: "fabric.linking.ai_summarized_info",
        defaultMessage: "Information quality may vary. <a>Learn more</a>"
    },
    ai_summarized_info_short: {
        id: "fabric.linking.ai_summarized_info_short",
        defaultMessage: "Content quality may vary"
    },
    ai_summarizing: {
        id: "fabric.linking.ai_summarizing",
        defaultMessage: "Atlassian Intelligence is working..."
    },
    ai_summary_error_generic: {
        id: "fabric.linking.ai_summary_error_generic",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>."
    },
    ai_summary_error_acceptable_use_violation: {
        id: "fabric.linking.ai_summary_error_acceptable_use_violation",
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>."
    },
    ai_summary_error_hipaa_content_detected: {
        id: "fabric.linking.ai_summary_error_hipaa_content_detected",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content."
    },
    ai_summary_error_exceeding_context_length_error: {
        id: "fabric.linking.ai_summary_error_exceeding_context_length_error",
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize."
    },
    assigned_to: {
        id: "fabric.linking.assigned_to",
        defaultMessage: "Assigned to {context}"
    },
    automation_action_title: {
        id: "fabric.linking.automation-action.title",
        defaultMessage: "View automation rules"
    },
    automation_action_icon_label: {
        id: "fabric.linking.automation-action.icon.label",
        defaultMessage: "Automation icon"
    },
    automation_action_tooltip: {
        id: "fabric.linking.automation-action.tooltip",
        defaultMessage: "Select an automation rule to run"
    },
    automation_action_confluence_page_modal_title: {
        id: "fabric.linking.automation-action.confluence.page.modal.title",
        defaultMessage: "Page automations"
    },
    automation_action_confluence_page_modal_description: {
        id: "fabric.linking.automation-action.confluence.page.modal.description",
        defaultMessage: "Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators."
    },
    cancel: {
        id: "fabric.linking.cancel",
        defaultMessage: "Cancel"
    },
    beta: {
        id: "fabric.linking.beta",
        defaultMessage: "Beta"
    },
    cannot_connect: {
        id: "fabric.linking.cannot_connect",
        defaultMessage: "Can't connect, try again"
    },
    cannot_find_link: {
        id: "fabric.linking.cannot_find_link",
        defaultMessage: "Can't find link"
    },
    click_to_join: {
        id: "fabric.linking.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.linking.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    close: {
        id: "fabric.linking.close",
        defaultMessage: "Close"
    },
    check_this_link: {
        id: "fabric.linking.check_this_link",
        defaultMessage: "Check this link"
    },
    compass_applied_components_count: {
        id: "compass.applied_components_count.non-final",
        defaultMessage: "Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component} other {{numberOfComponents, number} components}}"
    },
    connect_to: {
        id: "fabric.linking.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.linking.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.linking.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.linking.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.linking.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.linking.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    connect_unauthorised_account_action: {
        id: "fabric.linking.connect_unauthorised_account_action",
        defaultMessage: "Connect to {context}"
    },
    connect_unauthorised_account_description: {
        id: "fabric.linking.connect_unauthorised_account_description",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian products."
    },
    connect_unauthorised_account_description_no_provider: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider",
        defaultMessage: "Connect your account to collaborate on work across Atlassian products."
    },
    continue: {
        id: "fabric.linking.continue",
        defaultMessage: "Continue"
    },
    copy_url_to_clipboard: {
        id: "fabric.linking.copy_url_to_clipboard",
        defaultMessage: "Copy link"
    },
    copied_url_to_clipboard: {
        id: "fabric.linking.copied_url_to_clipboard",
        defaultMessage: "Copied!"
    },
    could_not_load_link: {
        id: "fabric.linking.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    created_by: {
        id: "fabric.linking.created_by",
        defaultMessage: "Created by {context}"
    },
    created_on_relative: {
        id: "fabric.linking.create_on_relative",
        defaultMessage: "Created {context}"
    },
    created_on_absolute: {
        id: "fabric.linking.create_on_absolute",
        defaultMessage: "Created on {context}"
    },
    delete: {
        id: "fabric.linking.delete",
        defaultMessage: "Delete"
    },
    download: {
        id: "fabric.linking.download",
        defaultMessage: "Download"
    },
    download_description: {
        id: "fabric.linking.download_description",
        defaultMessage: "Download this file into your local storage"
    },
    download_file: {
        id: "fabric.linking.download_file",
        defaultMessage: "Download file"
    },
    ai_summary_action: {
        id: "fabric.linking.ai_summary_action",
        defaultMessage: "Summarize with AI"
    },
    ai_summary_action_description: {
        id: "fabric.linking.ai_summary_action_description",
        defaultMessage: "Summarize the content of this link using Atlassian Intelligence."
    },
    copy_summary_action: {
        id: "fabric.linking.copy_summary_action",
        defaultMessage: "Copy summary"
    },
    copy_summary_action_description: {
        id: "fabric.linking.copy_summary_action_description",
        defaultMessage: "Copy summary"
    },
    copied_summary_action_description: {
        id: "fabric.linking.copied_summary_action_description",
        defaultMessage: "Copied summary to clipboard"
    },
    edit: {
        id: "fabric.linking.edit",
        defaultMessage: "Edit"
    },
    follow: {
        id: "fabric.linking.follow",
        defaultMessage: "Follow"
    },
    follow_project_description: {
        id: "fabric.linking.follow_project_description",
        defaultMessage: "Follow to get notifications on this project"
    },
    follow_project: {
        id: "fabric.linking.follow_project",
        defaultMessage: "Follow project"
    },
    follow_project_error: {
        id: "fabric.linking.follow_project_error",
        defaultMessage: "We encountered an error while trying to follow the project. Check your connection or refresh the page and try again."
    },
    follow_goal_description: {
        id: "fabric.linking.follow_goal_description",
        defaultMessage: "Follow this goal to get notifications on updates"
    },
    follow_goal: {
        id: "fabric.linking.follow_goal",
        defaultMessage: "Follow goal"
    },
    follow_goal_error: {
        id: "fabric.linking.follow_goal_error",
        defaultMessage: "We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again."
    },
    go_back: {
        id: "fabric.linking.go_back",
        defaultMessage: "Go back"
    },
    invalid_permissions: {
        id: "fabric.linking.invalid_permissions",
        defaultMessage: "Restricted content"
    },
    invalid_permissions_description: {
        id: "fabric.linking.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    join_to_view: {
        id: "fabric.linking.join_to_view",
        defaultMessage: "Join {context} to view this issue"
    },
    learn_more_about_smart_links: {
        id: "fabric.linking.learn_more_about_smart_links",
        defaultMessage: "Learn more about Smart Links."
    },
    learn_more_about_connecting_account: {
        id: "fabric.linking.learn_more_about_connecting_account",
        defaultMessage: "Learn more about connecting your account to Atlassian products."
    },
    loading: {
        id: "fabric.linking.loading",
        defaultMessage: "Loading..."
    },
    modified_by: {
        id: "fabric.linking.updated_by",
        defaultMessage: "Modified by {context}"
    },
    modified_on_relative: {
        id: "fabric.linking.modified_on_relative",
        defaultMessage: "Updated {context}"
    },
    modified_on_absolute: {
        id: "fabric.linking.modified_on_absolute",
        defaultMessage: "Updated on {context}"
    },
    more_actions: {
        id: "fabric.linking.more_actions",
        defaultMessage: "More actions"
    },
    open_issue_in_jira: {
        id: "fabric.linking.open_issue_in_jira",
        defaultMessage: "Open issue in Jira"
    },
    open_link_in_a_new_tab: {
        id: "fabric.linking.open_link_in_a_new_tab",
        defaultMessage: "Open link in a new tab"
    },
    owned_by: {
        id: "fabric.linking.owned_by",
        defaultMessage: "Owned by {context}"
    },
    owned_by_override: {
        id: "fabric.linking.owned_by_override",
        defaultMessage: "By {context}"
    },
    preview_description: {
        id: "fabric.linking.preview_description",
        defaultMessage: "Open a full screen preview of this link"
    },
    preview_improved: {
        id: "fabric.linking.preview_improved",
        defaultMessage: "Open preview"
    },
    preview_modal: {
        id: "fabric.linking.preview_modal",
        defaultMessage: "Open preview modal"
    },
    preview_panel: {
        id: "fabric.linking.preview_panel",
        defaultMessage: "Open preview panel"
    },
    preview_close: {
        id: "fabric.linking.preview_close",
        defaultMessage: "Close preview"
    },
    preview_max_size: {
        id: "fabric.linking.preview_max_size",
        defaultMessage: "View full screen"
    },
    preview_min_size: {
        id: "fabric.linking.preview_min_size",
        defaultMessage: "Close full screen"
    },
    priority_blocker: {
        id: "fabric.linking.priority_blocker",
        defaultMessage: "Blocker"
    },
    priority_critical: {
        id: "fabric.linking.priority_critical",
        defaultMessage: "Critical"
    },
    priority_high: {
        id: "fabric.linking.priority_high",
        defaultMessage: "High"
    },
    priority_highest: {
        id: "fabric.linking.priority_highest",
        defaultMessage: "Highest"
    },
    priority_low: {
        id: "fabric.linking.priority_low",
        defaultMessage: "Low"
    },
    priority_lowest: {
        id: "fabric.linking.priority_lowest",
        defaultMessage: "Lowest"
    },
    priority_major: {
        id: "fabric.linking.priority_major",
        defaultMessage: "Major"
    },
    priority_medium: {
        id: "fabric.linking.priority_medium",
        defaultMessage: "Medium"
    },
    priority_minor: {
        id: "fabric.linking.priority_minor",
        defaultMessage: "Minor"
    },
    priority_trivial: {
        id: "fabric.linking.priority_trivial",
        defaultMessage: "Trivial"
    },
    priority_undefined: {
        id: "fabric.linking.priority_undefined",
        defaultMessage: "Undefined"
    },
    forbidden_access: {
        id: "fabric.linking.forbidden_access",
        defaultMessage: "Your access is forbidden"
    },
    pending_request: {
        id: "fabric.linking.pending_request",
        defaultMessage: "Your access request is pending"
    },
    read_time: {
        id: "fabric.linking.read_time",
        defaultMessage: "{context} min read"
    },
    restricted_link: {
        id: "fabric.linking.restricted_link",
        defaultMessage: "Restricted link, try another account"
    },
    request_access_to_view: {
        id: "fabric.linking.request_access_to_view",
        defaultMessage: "Request access to {context} to view this issue"
    },
    request_denied: {
        id: "fabric.linking.request_denied",
        defaultMessage: "Your access request was denied"
    },
    retry: {
        id: "fabric.linking.retry",
        defaultMessage: "Retry"
    },
    save: {
        id: "fabric.linking.save",
        defaultMessage: "Save"
    },
    sent_on_relative: {
        id: "fabric.linking.sent_on_relative",
        defaultMessage: "Sent {context}"
    },
    sent_on_absolute: {
        id: "fabric.linking.sent_on_absolute",
        defaultMessage: "Sent on {context}"
    },
    status_change_load_error: {
        id: "fabric.linking.status_change_load_error",
        defaultMessage: "We couldn\u2019t load the statuses and transitions"
    },
    status_change_permission_error: {
        id: "fabric.linking.status_change_permission_error",
        defaultMessage: "You don\u2019t have permission to transition this issue."
    },
    status_change_update_error: {
        id: "fabric.linking.status_change_update_error",
        defaultMessage: "We couldn\u2019t update the status"
    },
    try_again: {
        id: "fabric.linking.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.linking.try_another_account",
        defaultMessage: "Try another account"
    },
    link_safety_warning_message: {
        id: "fabric.linking.link_safety_warning_message",
        defaultMessage: "The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>"
    },
    unauthorised_account_description: {
        id: "fabric.linking.unauthorised_account_description",
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_description_no_provider: {
        id: "fabric.linking.unauthorised_account_description_no_provider",
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_name: {
        id: "fabric.linking.unauthorised_account_name",
        defaultMessage: "We can't display private pages from {context}"
    },
    unauthorised_account_name_no_provider: {
        id: "fabric.linking.unauthorised_account_name_no_provider",
        defaultMessage: "We can't display private pages"
    },
    unassigned: {
        id: "fabric.linking.unassigned",
        defaultMessage: "Unassigned"
    },
    unfollow: {
        id: "fabric.linking.unfollow",
        defaultMessage: "Unfollow"
    },
    unfollow_project_description: {
        id: "fabric.linking.unfollow_project_description",
        defaultMessage: "Unfollow to stop receiving project notifications"
    },
    unfollow_project: {
        id: "fabric.linking.unfollow_project",
        defaultMessage: "Unfollow project"
    },
    unfollow_project_error: {
        id: "fabric.linking.unfollow_project_error",
        defaultMessage: "We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again."
    },
    unfollow_goal_description: {
        id: "fabric.linking.unfollow_goal_description",
        defaultMessage: "Unfollow to stop receiving notifications for this goal"
    },
    unfollow_goal: {
        id: "fabric.linking.unfollow_goal",
        defaultMessage: "Unfollow goal"
    },
    unfollow_goal_error: {
        id: "fabric.linking.unfollow_goal_error",
        defaultMessage: "We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again."
    },
    unlink_account: {
        id: "fabric.linking.unlink_account",
        defaultMessage: "Unlink Account"
    },
    view: {
        id: "fabric.linking.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.linking.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.linking.srclinkunknown",
        defaultMessage: "View Original"
    },
    default_no_access_title: {
        id: "fabric.linking.no_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_title: {
        id: "fabric.linking.direct_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_description: {
        id: "fabric.linking.direct_access_description",
        defaultMessage: "Your team uses {product} to collaborate and you can start using it right away!"
    },
    direct_access: {
        id: "fabric.linking.direct_access",
        defaultMessage: "Join now"
    },
    request_access_description: {
        id: "fabric.linking.request_access_description",
        defaultMessage: "Your team uses {product} to collaborate. Send your admin a request for access."
    },
    request_access: {
        id: "fabric.linking.request_access",
        defaultMessage: "Request access"
    },
    request_access_pending_title: {
        id: "fabric.linking.request_access_pending_title",
        defaultMessage: "Access to {product} is pending"
    },
    request_access_pending_description: {
        id: "fabric.linking.request_access_pending_description",
        defaultMessage: "Your request to access {hostname} is awaiting admin approval."
    },
    request_access_pending: {
        id: "fabric.linking.request_access_pending",
        defaultMessage: "Pending approval"
    },
    request_denied_description: {
        id: "fabric.linking.request_denied_description",
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}."
    },
    access_exists_description: {
        id: "fabric.linking.access_exists_description",
        defaultMessage: "Request access to view this content from {hostname}."
    },
    not_found_description: {
        id: "fabric.linking.not_found_description",
        defaultMessage: "The page doesn't exist or it may have changed after this link was added."
    },
    not_found_title: {
        id: "fabric.linking.not_found_title",
        defaultMessage: "We can't show you this {product} page"
    },
    forbidden_title: {
        id: "fabric.linking.forbidden_title",
        defaultMessage: "You don't have access to this content"
    },
    forbidden_description: {
        id: "fabric.linking.forbidden_description",
        defaultMessage: "Contact your admin to request access to {hostname}."
    },
    related: {
        id: "fabric.linking.related",
        defaultMessage: "Related"
    },
    generic_error_message: {
        id: "fabric.linking.generic_error_message",
        defaultMessage: "An error occurred"
    },
    related_links_modal_title: {
        id: "fabric.linking.related_links_modal_title",
        defaultMessage: "Related links"
    },
    related_links_view_related_urls: {
        id: "fabric.linking.related_links_view_related_urls",
        defaultMessage: "View recent links"
    },
    related_links_view_related_links: {
        id: "fabric.linking.related_links_view_related_links",
        defaultMessage: "View related links"
    },
    related_links_found_in: {
        id: "fabric.linking.related_links_found_in",
        defaultMessage: "Found in"
    },
    related_links_not_found: {
        id: "fabric.linking.related_links_not_found",
        defaultMessage: "We didn't find any links to show here."
    },
    related_links_includes_links_to: {
        id: "fabric.linking.related_links_includes_links_to",
        defaultMessage: "Includes links to"
    },
    related_links_modal_error_title: {
        id: "fabric.linking.related_links_modal_error_title",
        defaultMessage: "We're having trouble loading related links"
    },
    related_links_modal_unavailable_title: {
        id: "fabric.linking.related_links_modal_unavailable_title",
        defaultMessage: "We couldn't find any related links"
    },
    related_links_modal_error_description: {
        id: "fabric.linking.related_links_modal_error_description",
        defaultMessage: "Check your connection or refresh the page to try again"
    },
    related_links_modal_unavailable_description: {
        id: "fabric.linking.related_links_modal_unavailable_description",
        defaultMessage: "We continuously review and add related links for updated pages or other content types"
    },
    join_to_viewIssueTermRefresh: {
        id: "fabric.linking.join_to_view-issue-term-refresh",
        defaultMessage: "Join {context} to view this work item"
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: "fabric.linking.open_issue_in_jira-issue-term-refresh",
        defaultMessage: "Open work item in Jira"
    },
    request_access_to_viewIssueTermRefresh: {
        id: "fabric.linking.request_access_to_view-issue-term-refresh",
        defaultMessage: "Request access to {context} to view this work item"
    },
    status_change_permission_errorIssueTermRefresh: {
        id: "fabric.linking.status_change_permission_error-issue-term-refresh",
        defaultMessage: "You don\u2019t have permission to transition this work item."
    },
    team_members_count: {
        id: "fabric.linking.team_members_count",
        defaultMessage: "{context} members"
    },
    user_attributes: {
        id: "fabric.linking.user_attributes",
        defaultMessage: "{context}"
    },
    follow_project_descriptionGalaxia: {
        id: "fabric.linking.follow_project_description-galaxia",
        defaultMessage: "Follow to get notifications on this space"
    },
    follow_project_errorGalaxia: {
        id: "fabric.linking.follow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to follow the space. Check your connection or refresh the page and try again."
    },
    unfollow_project_descriptionGalaxia: {
        id: "fabric.linking.unfollow_project_description-galaxia",
        defaultMessage: "Unfollow to stop receiving space notifications"
    },
    unfollow_project_errorGalaxia: {
        id: "fabric.linking.unfollow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again."
    },
    connect_unauthorised_account_description_appify: {
        id: "fabric.linking.connect_unauthorised_account_description-appify",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian apps."
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider-appify",
        defaultMessage: "Connect your account to collaborate on work across Atlassian apps."
    },
    learn_more_about_connecting_account_appify: {
        id: "fabric.linking.learn_more_about_connecting_account-appify",
        defaultMessage: "Learn more about connecting your account to Atlassian apps."
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: "fabric.linking.learn_more_about_connecting_account_experiment_short",
        defaultMessage: "Turn your URLs into rich, interactive previews."
    }
});
module.exports["messages"] = $8ae4cb49ca93b6d8$export$defe85febe8b728c;

});

parcelRegister("7DSoa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lyclm = parcelRequire("lyclm");


var $eIleF = parcelRequire("eIleF");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $4IQbU = parcelRequire("4IQbU");

const $8fe2ac6ef7785039$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $4IQbU.default)();
    return (0, $42omo.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $lyclm.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $bIll3.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $8fe2ac6ef7785039$export$2e2bcd8739ae039 = $8fe2ac6ef7785039$var$useResolve;
module.exports["default"] = $8fe2ac6ef7785039$export$2e2bcd8739ae039;

});

parcelRegister("4IQbU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");

var $jHnts = parcelRequire("jHnts");

var $btw9C = parcelRequire("btw9C");


var $5TXU5 = parcelRequire("5TXU5");


var $4ibS1 = parcelRequire("4ibS1");


var $bKqKH = parcelRequire("bKqKH");

const $afe444b12e732e06$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $42omo.useCallback)((url, metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $42omo.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: url
        }, (0, $4ibS1.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $42omo.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $42omo.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $btw9C.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fallback', hostname, (0, $bKqKH.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fatal', hostname, (0, $bKqKH.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('error', hostname, (0, $bKqKH.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $jTxSS.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $42omo.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $afe444b12e732e06$export$2e2bcd8739ae039 = $afe444b12e732e06$var$useResponse;
module.exports["default"] = $afe444b12e732e06$export$2e2bcd8739ae039;

});

parcelRegister("9gPkz", function(module, exports) {
// TODO: eventually move this file to @atlaskit/link-actions
const $4165c6e5bfa202ae$export$6e470aad5ba8952e = 'pending';
const $4165c6e5bfa202ae$export$9a6a932a0a39498e = 'resolving';
const $4165c6e5bfa202ae$export$63ec8bc7a8a75482 = 'resolved';
const $4165c6e5bfa202ae$export$b8cfaa842c9ab487 = 'reloading';
const $4165c6e5bfa202ae$export$6d8ed3f9433dd372 = 'errored';
const $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6 = 'fallback';
const $4165c6e5bfa202ae$export$76b5c1aca20759c6 = 'preload';
const $4165c6e5bfa202ae$export$2c5edb971b673330 = 'metadata';
const $4165c6e5bfa202ae$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });
module.exports["ACTION_PENDING"] = $4165c6e5bfa202ae$export$6e470aad5ba8952e;
module.exports["ACTION_RESOLVING"] = $4165c6e5bfa202ae$export$9a6a932a0a39498e;
module.exports["ACTION_RESOLVED"] = $4165c6e5bfa202ae$export$63ec8bc7a8a75482;
module.exports["ACTION_RELOADING"] = $4165c6e5bfa202ae$export$b8cfaa842c9ab487;
module.exports["ACTION_ERROR"] = $4165c6e5bfa202ae$export$6d8ed3f9433dd372;
module.exports["ACTION_ERROR_FALLBACK"] = $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6;
module.exports["ACTION_UPDATE_METADATA_STATUS"] = $4165c6e5bfa202ae$export$2c5edb971b673330;
module.exports["cardAction"] = $4165c6e5bfa202ae$export$a884a52152489cc3;

});

parcelRegister("4ibS1", function(module, exports) {
const $edbc823e59ec01a7$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $edbc823e59ec01a7$export$2796a804c6e44f63 = ()=>$edbc823e59ec01a7$var$emptyData;
const $edbc823e59ec01a7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
const $edbc823e59ec01a7$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
module.exports["getEmptyJsonLd"] = $edbc823e59ec01a7$export$2796a804c6e44f63;
module.exports["getUnauthorizedJsonLd"] = $edbc823e59ec01a7$export$b9482e0f6d365cc7;
module.exports["getForbiddenJsonLd"] = $edbc823e59ec01a7$export$e32193033a594efb;

});

parcelRegister("bKqKH", function(module, exports) {
const $96d7cda9026a4858$export$297c39c8b9bfca0 = 'resolving';
const $96d7cda9026a4858$export$b64a888338c24e0e = 'errored';
const $96d7cda9026a4858$export$677b6edfa0002c70 = 'fallback';
const $96d7cda9026a4858$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $96d7cda9026a4858$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $96d7cda9026a4858$export$338f7d9ccca1975d = 'Error resolving metadata.';
module.exports["ERROR_MESSAGE_OAUTH"] = $96d7cda9026a4858$export$3e81ce851ffda0ad;
module.exports["ERROR_MESSAGE_FATAL"] = $96d7cda9026a4858$export$45e7dda0d43d7f55;
module.exports["ERROR_MESSAGE_METADATA"] = $96d7cda9026a4858$export$338f7d9ccca1975d;

});

parcelRegister("9oOnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $bIll3 = parcelRequire("bIll3");

const $458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $458a31c3ca98bc55$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $42omo.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $l6tPN.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $bIll3.startUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $l6tPN.mark(markName, 'resolved');
            (0, $bIll3.succeedUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $l6tPN.mark(markName, 'errored');
            (0, $bIll3.failUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $458a31c3ca98bc55$export$2e2bcd8739ae039 = $458a31c3ca98bc55$var$useInvokeClientAction;
module.exports["default"] = $458a31c3ca98bc55$export$2e2bcd8739ae039;

});

parcelRegister("l6tPN", function(module, exports) {
const $f72103dc56ec53a8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $f72103dc56ec53a8$var$hasPerformanceAPIAvailable = $f72103dc56ec53a8$var$isPerformanceAPIAvailable();
const $f72103dc56ec53a8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $f72103dc56ec53a8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $f72103dc56ec53a8$export$1a717feb4df1a945 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $f72103dc56ec53a8$export$de42547d395c8271 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $f72103dc56ec53a8$var$getMark = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $f72103dc56ec53a8$export$185802fd694ee1f5 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measure = $f72103dc56ec53a8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $f72103dc56ec53a8$var$getMark(id, 'pending');
            const endMark = $f72103dc56ec53a8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};
module.exports["clearMarks"] = $f72103dc56ec53a8$export$1a717feb4df1a945;
module.exports["clearMeasures"] = $f72103dc56ec53a8$export$de42547d395c8271;
module.exports["getMeasure"] = $f72103dc56ec53a8$export$d6e97a903ae9a3aa;
module.exports["mark"] = $f72103dc56ec53a8$export$bf7f2fce5c1cf636;
module.exports["create"] = $f72103dc56ec53a8$export$185802fd694ee1f5;

});

parcelRegister("4gM1A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6wQZE = parcelRequire("6wQZE");

var $77752028a2bf334b$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $77752028a2bf334b$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $77752028a2bf334b$var$isNotLeftClick = (event)=>event.button !== 0;
const $77752028a2bf334b$export$df67f318ded0283c = (onMouseDown)=>{
    return $77752028a2bf334b$export$5993d3ca6c85f774(onMouseDown, $77752028a2bf334b$var$isNotLeftClick);
};
module.exports["useLinkClicked"] = $77752028a2bf334b$export$5993d3ca6c85f774;
module.exports["useMouseDownEvent"] = $77752028a2bf334b$export$df67f318ded0283c;

});

parcelRegister("6wQZE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4P6U3 = parcelRequire("4P6U3");


var $1I43V = parcelRequire("1I43V");


var $1oCLl = parcelRequire("1oCLl");


var $4gM1A = parcelRequire("4gM1A");


var $lgqac = parcelRequire("lgqac");

const $8b02aa09be31a1d9$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $8b02aa09be31a1d9$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $8b02aa09be31a1d9$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $8b02aa09be31a1d9$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4P6U3.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($8b02aa09be31a1d9$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $8b02aa09be31a1d9$var$linkClickedEventOld = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $8b02aa09be31a1d9$var$linkClickedEventWithShortLink = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented, isConfluenceShortLink: isConfluenceShortLink })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    });
const $8b02aa09be31a1d9$export$880d2168464029dd = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$fb40cb818618aeeb = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    let isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$7fedc699766c16de = (0, $1I43V.functionWithCondition)(()=>(0, $1oCLl.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test'), $8b02aa09be31a1d9$export$fb40cb818618aeeb, $8b02aa09be31a1d9$export$880d2168464029dd);
const $8b02aa09be31a1d9$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $8b02aa09be31a1d9$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
const $8b02aa09be31a1d9$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $8b02aa09be31a1d9$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4gM1A.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4gM1A.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$8b02aa09be31a1d9$var$getDisplayName(WrappedComponent)})`;
    return Component;
}
module.exports["fireLinkClickedEvent"] = $8b02aa09be31a1d9$export$7987de3055fbdcb0;
module.exports["withLinkClickedEvent"] = $8b02aa09be31a1d9$export$263352d59c0c5966;

});

parcelRegister("1I43V", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $4bac077259c47cd6$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}
module.exports["functionWithCondition"] = $4bac077259c47cd6$export$af3c0e82a18fc057;

});

parcelRegister("aeAfU", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $g68Gk = parcelRequire("g68Gk");


var $7Rqpr = parcelRequire("7Rqpr");


var $8ihu7 = parcelRequire("8ihu7");

function $92366aa0166a9d31$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $8ihu7._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $8ihu7._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $g68Gk.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $92366aa0166a9d31$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
 * Use to check a any param value for an experiment without firing an exposure event
 *
 * **Note**: this will return the default value when the experiment;
 * - is not being served to the client (ie. pre start)
 * - or is not configured in experiments-config
 *
 * @example
 * ```ts
 * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
 * await new Promise(res => setTimeout(res, delay)
 * ```
 */ 
function $92366aa0166a9d31$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expVal"] = $92366aa0166a9d31$export$9db1624a8af791a4;
module.exports["expValNoExposure"] = $92366aa0166a9d31$export$94f132839aec533f;

});

parcelRegister("a43ao", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");


var $3uVVG = parcelRequire("3uVVG");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $5XwvY = parcelRequire("5XwvY");


var $bIll3 = parcelRequire("bIll3");


var $226XV = parcelRequire("226XV");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");

const $35a2bf75aa5e3412$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $7DSoa.default)();
    const invokeClientAction = (0, $9oOnT.default)({});
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $42omo.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5TXU5.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $42omo.useCallback)((metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $42omo.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        if (definitionId) (0, $226XV.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $42omo.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $42omo.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        const extensionKey = (0, $226XV.getExtensionKey)(details);
        const services = (0, $226XV.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            const shouldShowInPopupWindow = status === 'unauthorized' && (0, $c6GJD.default).getExperimentValue('platform_sl_3p_auth_window_experiment', 'cohort', 'control') === 'test';
            const windowFeatures = shouldShowInPopupWindow ? (0, $5XwvY.getWindowOpenFeatures)((0, $5XwvY.AUTH_WINDOW_HEIGHT), (0, $5XwvY.AUTH_WINDOW_WIDTH)) : undefined;
            (0, $3uVVG.auth)(services[0].url, windowFeatures).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $42omo.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $42omo.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};
module.exports["useSmartCardActions"] = $35a2bf75aa5e3412$export$f7c340395f31e832;

});

parcelRegister("3uVVG", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");


var $9P47v = parcelRequire("9P47v");

function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $81514351a4f15f99$export$73693bad9f5880b0;

});

parcelRegister("uvNb9", function(module, exports) {
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $2c5766e42a4da15d$export$145273558d58e0ac;

});

parcelRegister("9P47v", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $cd3cb472abe3f4ba$export$400e64c8451aa84f;

});

parcelRegister("5XwvY", function(module, exports) {
const $3af44201ab5fb54a$var$BROWSER_SIZE_THRESHOLD = 38;
const $3af44201ab5fb54a$export$9737b997a3f49711 = 760;
const $3af44201ab5fb54a$export$9a6efef0b9731ce2 = 620;
const $3af44201ab5fb54a$export$ae408235f8b77e96 = (popupHeight, popupWidth)=>{
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const vl = window.screenLeft || 0;
    const vt = window.screenTop || 0;
    // Center the popup window
    const left = (vw - popupWidth) / 2 + vl;
    const top = (vh - popupHeight) / 2 + vt;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > popupWidth + $3af44201ab5fb54a$var$BROWSER_SIZE_THRESHOLD && vh > popupHeight + $3af44201ab5fb54a$var$BROWSER_SIZE_THRESHOLD ? `width=${popupWidth},height=${popupHeight},left=${left},top=${top}` : undefined;
    return windowFeatures;
};
module.exports["AUTH_WINDOW_HEIGHT"] = $3af44201ab5fb54a$export$9737b997a3f49711;
module.exports["AUTH_WINDOW_WIDTH"] = $3af44201ab5fb54a$export$9a6efef0b9731ce2;
module.exports["getWindowOpenFeatures"] = $3af44201ab5fb54a$export$ae408235f8b77e96;

});

parcelRegister("226XV", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $15C2j = parcelRequire("15C2j");

const $c8f51fccdd166527$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $c8f51fccdd166527$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $15C2j.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $c8f51fccdd166527$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $c8f51fccdd166527$export$218d96312e385949 = (details)=>details?.meta?.key;
const $c8f51fccdd166527$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $c8f51fccdd166527$export$e029950864672b4 = (details)=>{
    if ((0, $dh538.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $c8f51fccdd166527$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $dh538.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $c8f51fccdd166527$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $c8f51fccdd166527$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $c8f51fccdd166527$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $c8f51fccdd166527$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $c8f51fccdd166527$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c8f51fccdd166527$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $c8f51fccdd166527$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $c8f51fccdd166527$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $c8f51fccdd166527$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $c8f51fccdd166527$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $c8f51fccdd166527$export$ac5d414b1ebfab5a = (details)=>details && $c8f51fccdd166527$export$cd41ae544cfc2a65(details) && $c8f51fccdd166527$export$795910f5f15a9633(details);
const $c8f51fccdd166527$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $c8f51fccdd166527$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $c8f51fccdd166527$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $c8f51fccdd166527$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $c8f51fccdd166527$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $c8f51fccdd166527$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $c8f51fccdd166527$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $c8f51fccdd166527$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $c8f51fccdd166527$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getByDefinitionId"] = $c8f51fccdd166527$export$f75b0b690ab4dfb9;
module.exports["getClickUrl"] = $c8f51fccdd166527$export$cf3c5acf9e9d0f02;
module.exports["getDefinitionId"] = $c8f51fccdd166527$export$46fa3e7718c82e41;
module.exports["getExtensionKey"] = $c8f51fccdd166527$export$218d96312e385949;
module.exports["getObjectAri"] = $c8f51fccdd166527$export$81164c1570bcd038;
module.exports["getThirdPartyARI"] = $c8f51fccdd166527$export$e029950864672b4;
module.exports["getFirstPartyIdentifier"] = $c8f51fccdd166527$export$48b4e58cdb8031ba;
module.exports["getObjectName"] = $c8f51fccdd166527$export$5615361d76a8be5;
module.exports["getObjectIconUrl"] = $c8f51fccdd166527$export$bcf275804417edda;
module.exports["getResourceType"] = $c8f51fccdd166527$export$16c0ebb0de9b767b;
module.exports["getServices"] = $c8f51fccdd166527$export$a009e3a1163d46fb;
module.exports["isFinalState"] = $c8f51fccdd166527$export$d590d08942abc17a;
module.exports["hasAuthScopeOverrides"] = $c8f51fccdd166527$export$3f9446bb21b945a0;

});

parcelRegister("15C2j", function(module, exports) {
const $4a791b5829124355$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};
module.exports["extractVisitUrl"] = $4a791b5829124355$export$c81497d3681f24f4;

});

parcelRegister("7Vxvp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fVUfS = parcelRequire("fVUfS");


var $aeAfU = parcelRequire("aeAfU");

const $fee91c6d88bcaa54$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v"
};
const $fee91c6d88bcaa54$var$experimentEnabledStyles = {
    control: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    test1: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk",
    test2: "_syaz15cr _80omtlke _bfhk1i45 _qrwqlb4i _1o0zlb4i _irr3byip _1di61van"
};
const $fee91c6d88bcaa54$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    const experimentValue = viewType === 'unauthorised' ? (0, $aeAfU.expVal)('platform_inline_smartcard_connect_button_exp', 'cohort', 'control') : 'control';
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $fee91c6d88bcaa54$var$styles.button
    }, /*#__PURE__*/ $42omo.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $gMc0m.default)([
            $fee91c6d88bcaa54$var$styles.innerContainer,
            isDisabled ? $fee91c6d88bcaa54$var$styles.disabled : experimentValue !== 'control' ? $fee91c6d88bcaa54$var$experimentEnabledStyles[experimentValue] : $fee91c6d88bcaa54$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $fee91c6d88bcaa54$export$cfc7921d29ef7b80;

});

parcelRegister("dLAsE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lgqac = parcelRequire("lgqac");

function $ff5fb1232cd87c62$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $42omo.useMemo)(()=>new (0, $lgqac.SmartLinkEvents)(), []);
    return events;
}
function $ff5fb1232cd87c62$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}
module.exports["useSmartLinkEvents"] = $ff5fb1232cd87c62$export$ed70996d478e16d3;
module.exports["useFire3PWorkflowsClickEvent"] = $ff5fb1232cd87c62$export$e682245dc886cff2;

});

parcelRegister("2daQU", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("gAARK", function(module, exports) {
const $42341a766fe51017$export$5937600f4cc784f0 = 24;
const $42341a766fe51017$export$71d660e8ca5b8f73 = 320;
const $42341a766fe51017$export$cd11d7d46412c89b = 3;
const $42341a766fe51017$export$71482734bb54ac3 = 10;
const $42341a766fe51017$export$fd2b09475ada41cc = 12;
const $42341a766fe51017$export$8c5ac0b0c62a3d21 = 8;
const $42341a766fe51017$export$68d0abe4f03863fb = $42341a766fe51017$export$fd2b09475ada41cc * 2;
const $42341a766fe51017$export$d722b7527b1834a8 = 250;
const $42341a766fe51017$export$da894f7669b4e67c = 200;
const $42341a766fe51017$export$e13825c38da2ce1 = 100;
var $42341a766fe51017$export$c84671f46d6a1ca = /*#__PURE__*/ function(Layout) {
    Layout["FULL_WIDTH"] = "full-width";
    Layout["WIDE"] = "wide";
    Layout["CENTER"] = "center";
    Layout["ALIGN_START"] = "align-start";
    Layout["ALIGN_END"] = "align-end";
    Layout["WRAP_RIGHT"] = "wrap-right";
    Layout["WRAP_LEFT"] = "wrap-left";
    return Layout;
}({});
const $42341a766fe51017$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $42341a766fe51017$export$4d41d008e9cd4f34 = 0.5;
const $42341a766fe51017$export$b4b560efd3c61856 = 'caption-placeholder';
module.exports["MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH"] = $42341a766fe51017$export$5937600f4cc784f0;
module.exports["MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH"] = $42341a766fe51017$export$71d660e8ca5b8f73;
module.exports["MEDIA_SINGLE_SNAP_GAP"] = $42341a766fe51017$export$cd11d7d46412c89b;
module.exports["MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN"] = $42341a766fe51017$export$8c5ac0b0c62a3d21;
module.exports["MEDIA_SINGLE_GUTTER_SIZE"] = $42341a766fe51017$export$68d0abe4f03863fb;
module.exports["DEFAULT_IMAGE_WIDTH"] = $42341a766fe51017$export$d722b7527b1834a8;
module.exports["DEFAULT_IMAGE_HEIGHT"] = $42341a766fe51017$export$da894f7669b4e67c;
module.exports["MEDIA_SINGLE_RESIZE_THROTTLE_TIME"] = $42341a766fe51017$export$e13825c38da2ce1;
module.exports["wrappedLayouts"] = $42341a766fe51017$export$405baca3d8bc263d;
module.exports["DEFAULT_ROUNDING_INTERVAL"] = $42341a766fe51017$export$4d41d008e9cd4f34;
module.exports["CAPTION_PLACEHOLDER_ID"] = $42341a766fe51017$export$b4b560efd3c61856;

});

parcelRegister("lqWNh", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");


var $3UbBx = parcelRequire("3UbBx");

const $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
    return (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
};
const $f9e9293fb4fd549c$export$607795ead6e50626 = [
    'center',
    'wide',
    'full-width'
];
const $f9e9293fb4fd549c$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
const $f9e9293fb4fd549c$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
    return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
const $f9e9293fb4fd549c$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = $f9e9293fb4fd549c$export$607795ead6e50626.indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = $f9e9293fb4fd549c$export$607795ead6e50626.indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $3UbBx.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $3UbBx.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
function $f9e9293fb4fd549c$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $3UbBx.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $3UbBx.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $aFUXX.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}
module.exports["shouldAddDefaultWrappedWidth"] = $f9e9293fb4fd549c$export$7cd5aab2c4f1fb1e;
module.exports["nonWrappedLayouts"] = $f9e9293fb4fd549c$export$607795ead6e50626;
module.exports["floatingLayouts"] = $f9e9293fb4fd549c$export$7c0073a4d21b222d;
module.exports["isRichMediaInsideOfBlockNode"] = $f9e9293fb4fd549c$export$55fb9d6810f2e04b;
module.exports["alignAttributes"] = $f9e9293fb4fd549c$export$b2258912a400ba32;
module.exports["calculateSnapPoints"] = $f9e9293fb4fd549c$export$de65085e667b4bf1;

});

parcelRegister("3UbBx", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $gAARK = parcelRequire("gAARK");

const $7bd202241742fd44$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $7bd202241742fd44$export$adfc02948d64a4f2 = (layout)=>$7bd202241742fd44$var$validWidthModes.indexOf(layout) > -1;
function $7bd202241742fd44$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7bd202241742fd44$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}
function $7bd202241742fd44$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
function $7bd202241742fd44$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}
const $7bd202241742fd44$export$405baca3d8bc263d = [
    'wrap-left',
    'wrap-right',
    'align-end',
    'align-start'
];
const $7bd202241742fd44$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($7bd202241742fd44$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $7bd202241742fd44$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $7bd202241742fd44$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $7bd202241742fd44$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $aFUXX.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $aFUXX.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ($7bd202241742fd44$export$405baca3d8bc263d.indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return Math.min(calculatedPctWidth, origWidth);
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && $7bd202241742fd44$export$405baca3d8bc263d.indexOf(layout) !== -1) {
        const halfLineLength = Math.ceil((lineLength || width) / 2);
        return origWidth <= halfLineLength ? origWidth : halfLineLength;
    }
    return origWidth;
};
const $7bd202241742fd44$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = $7bd202241742fd44$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
    const columnSpan = Math.round($7bd202241742fd44$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
    const alignedWidth = $7bd202241742fd44$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};
module.exports["calcPxFromColumns"] = $7bd202241742fd44$export$1e3701608f0cee80;
module.exports["calcColumnsFromPx"] = $7bd202241742fd44$export$10912f14d8d54640;
module.exports["calcPctFromPx"] = $7bd202241742fd44$export$55ddb36b3404ec6d;
module.exports["wrappedLayouts"] = $7bd202241742fd44$export$405baca3d8bc263d;
module.exports["calcMediaPxWidth"] = $7bd202241742fd44$export$5e51fc02b9ada5af;

});

parcelRegister("fPkhr", function(module, exports) {
function $b85b59ac70a06546$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $b85b59ac70a06546$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $b85b59ac70a06546$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $b85b59ac70a06546$export$967a6b9924a689f7(a, b);
    return $b85b59ac70a06546$export$3e67810a3f0e9f1c(a, b);
}
module.exports["shallowEqualObjects"] = $b85b59ac70a06546$export$3e67810a3f0e9f1c;

});

parcelRegister("52s3i", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab2e6405264a6ac$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $3ab2e6405264a6ac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("7aUsh", function(module, exports) {
$parcel$export(module.exports, "default", () => $5395425e245a8a7a$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $52s3i = parcelRequire("52s3i");


var $jBv2F = parcelRequire("jBv2F");


var $b5utg = parcelRequire("b5utg");

function $5395425e245a8a7a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    return (0, $52s3i.default)(date).getTime() === (0, $jBv2F.default)(date).getTime();
}

});

parcelRegister("jBv2F", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4598d57c80bb5c7$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $e4598d57c80bb5c7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("hn4RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81c36a83f2b3e0f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $ggbZE = parcelRequire("ggbZE");


var $c6GJD = parcelRequire("c6GJD");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");


var $6wR36 = parcelRequire("6wR36");


var $18ASy = parcelRequire("18ASy");


var $gIdjl = parcelRequire("gIdjl");


var $jUMCq = parcelRequire("jUMCq");


var $lKhNz = parcelRequire("lKhNz");

const $e81c36a83f2b3e0f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $e81c36a83f2b3e0f$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $e81c36a83f2b3e0f$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $e81c36a83f2b3e0f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $fBMbo.di)($e81c36a83f2b3e0f$export$8c0773eab230d49e, (0, $lKhNz.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $lKhNz.useLinkWarningModal)();
    const resolveHyperlinkFG = (0, $c6GJD.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $gIdjl.HyperlinkWithSmartLinkResolver) : (0, $18ASy.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR36.LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUMCq.default), linkWarningModalProps));
    }
    const Link = isLinkComponent ? $e81c36a83f2b3e0f$export$8c0773eab230d49e : $e81c36a83f2b3e0f$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6wR36.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUMCq.default), linkWarningModalProps));
};
var $e81c36a83f2b3e0f$export$2e2bcd8739ae039 = (0, $ggbZE.default)($e81c36a83f2b3e0f$var$PACKAGE_DATA)($e81c36a83f2b3e0f$var$LinkUrl);

});

parcelRegister("6wR36", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $13440d2ce08719fa$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};
module.exports["LinkAnalyticsContext"] = $13440d2ce08719fa$export$9458cdec663b9ff1;

});

parcelRegister("18ASy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");

const $3be2cafa97b66d1a$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $3be2cafa97b66d1a$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $3be2cafa97b66d1a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $3be2cafa97b66d1a$export$8c0773eab230d49e : $3be2cafa97b66d1a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $3be2cafa97b66d1a$export$2e2bcd8739ae039 = $3be2cafa97b66d1a$var$Hyperlink;
module.exports["default"] = $3be2cafa97b66d1a$export$2e2bcd8739ae039;

});

parcelRegister("gIdjl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $gmMgo = parcelRequire("gmMgo");


var $c6GJD = parcelRequire("c6GJD");


var $79vw2 = parcelRequire("79vw2");


var $dh538 = parcelRequire("dh538");


var $226XV = parcelRequire("226XV");


var $jMHhY = parcelRequire("jMHhY");


var $g6cf7 = parcelRequire("g6cf7");


var $5MkWK = parcelRequire("5MkWK");


var $8jBuy = parcelRequire("8jBuy");


var $dLAsE = parcelRequire("dLAsE");


var $18ASy = parcelRequire("18ASy");


var $055M6 = parcelRequire("055M6");

const $05b0889a04ec2be1$var$HyperlinkFallbackComponent = ()=>null;
const $05b0889a04ec2be1$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $g6cf7.default)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DefaultComponent, props);
    };
const $05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $jMHhY.default)({
        href: props.href || ''
    });
    const services = (0, $226XV.getServices)(state?.details);
    const thirdPartyARI = (0, $226XV.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $226XV.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $dh538.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dLAsE.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if (state?.status === 'resolved' && e?.button === 0 && fire3PClickEvent && (0, $dh538.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state?.status
    ]);
    const onAuthorize = (0, $42omo.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild?.props?.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if (state?.status === 'unauthorized' && shouldRenderConnectBtn() && ((0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $79vw2.extractSmartLinkProvider)(state?.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $055M6.default), {
            ...props,
            onAuthorize: services?.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: services?.length > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18ASy.default), {
        ...props,
        onClick: onClick
    });
};
const $05b0889a04ec2be1$export$1fdb4f77fe528a52 = (0, $lAJUP.withErrorBoundary)($05b0889a04ec2be1$var$withValidator((0, $gmMgo.default)((0, $8jBuy.default)($05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $18ASy.default)), {
    FallbackComponent: $05b0889a04ec2be1$var$HyperlinkFallbackComponent
});
module.exports["HyperlinkWithSmartLinkResolver"] = $05b0889a04ec2be1$export$1fdb4f77fe528a52;

});

parcelRegister("jMHhY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $a43ao = parcelRequire("a43ao");


var $226XV = parcelRequire("226XV");


var $lz9QA = parcelRequire("lz9QA");


var $lUh1d = parcelRequire("lUh1d");

const $8ce3085c5c5a77bd$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const state = (0, $lz9QA.useSmartCardState)(href);
    const definitionId = (0, $226XV.getDefinitionId)(state.details);
    const extensionKey = (0, $226XV.getExtensionKey)(state.details);
    const resourceType = (0, $226XV.getResourceType)(state.details);
    const actions = (0, $a43ao.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $lUh1d.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $42omo.useEffect)(()=>{
        $l6tPN.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $l6tPN.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $l6tPN.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $8ce3085c5c5a77bd$export$2e2bcd8739ae039 = $8ce3085c5c5a77bd$var$useResolveHyperlink;
module.exports["default"] = $8ce3085c5c5a77bd$export$2e2bcd8739ae039;

});

parcelRegister("lUh1d", function(module, exports) {
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $42omo = parcelRequire("42omo");

const $30de6a1f90cac3ee$var$batchQueue = new Map();
const $30de6a1f90cac3ee$var$batchTimeouts = new Map();
const $30de6a1f90cac3ee$var$BATCH_DELAY = 250;
const $30de6a1f90cac3ee$var$executeBatch = (hostname)=>{
    const items = $30de6a1f90cac3ee$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $30de6a1f90cac3ee$var$batchQueue.delete(hostname);
    $30de6a1f90cac3ee$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $30de6a1f90cac3ee$var$addToBatch = (hostname, item)=>{
    if (!$30de6a1f90cac3ee$var$batchQueue.has(hostname)) $30de6a1f90cac3ee$var$batchQueue.set(hostname, []);
    $30de6a1f90cac3ee$var$batchQueue.get(hostname).push(item);
    if ($30de6a1f90cac3ee$var$batchTimeouts.has(hostname)) clearTimeout($30de6a1f90cac3ee$var$batchTimeouts.get(hostname));
    $30de6a1f90cac3ee$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $30de6a1f90cac3ee$var$executeBatch(hostname);
    }, $30de6a1f90cac3ee$var$BATCH_DELAY));
};
const $30de6a1f90cac3ee$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $42omo.useRef)(false);
    const scheduledRegister = (0, $42omo.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $30de6a1f90cac3ee$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};
module.exports["useScheduledRegister"] = $30de6a1f90cac3ee$export$db80d61271e4d5af;

});

parcelRegister("g6cf7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");

const $13849139a87405b6$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $13849139a87405b6$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $13849139a87405b6$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $13849139a87405b6$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    return hasSmartCardProvider && $13849139a87405b6$export$aa45d36a96427452(href);
};
var $13849139a87405b6$export$2e2bcd8739ae039 = $13849139a87405b6$var$useResolveHyperlinkValidator;
module.exports["default"] = $13849139a87405b6$export$2e2bcd8739ae039;

});

parcelRegister("8jBuy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

/**
 * HOC to wrap component with IntlProvider if not available
 */ const $255ccdc0ab7e7f63$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, content);
    };
var $255ccdc0ab7e7f63$export$2e2bcd8739ae039 = $255ccdc0ab7e7f63$var$withIntlProvider;
module.exports["default"] = $255ccdc0ab7e7f63$export$2e2bcd8739ae039;

});

parcelRegister("055M6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $afp1H = parcelRequire("afp1H");


var $7Vxvp = parcelRequire("7Vxvp");


var $18ASy = parcelRequire("18ASy");

const $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $18ASy.default), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: provider?.text
        }
    }))));
};
var $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039 = $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView;
module.exports["default"] = $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039;

});

parcelRegister("jUMCq", function(module, exports) {
$parcel$export(module.exports, "default", () => $edc36e514c97f3fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");

var $gmMgo = parcelRequire("gmMgo");

var $1e2E5 = parcelRequire("1e2E5");


var $eEA8O = parcelRequire("eEA8O");


var $2Nwuj = parcelRequire("2Nwuj");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $afp1H = parcelRequire("afp1H");

const $edc36e514c97f3fa$var$breakWordsCss = null;
const $edc36e514c97f3fa$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).check_this_link))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).go_back)), /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $42omo.createElement((0, $1e2E5.default), {
        locale: "en"
    }, content);
};
var $edc36e514c97f3fa$export$2e2bcd8739ae039 = (0, $gmMgo.default)($edc36e514c97f3fa$var$WarningModal, {
    enforceContext: false
});

});

parcelRegister("lKhNz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $l3dur = parcelRequire("l3dur");


var $lgqac = parcelRequire("lgqac");

const $83b01bdf128d776a$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $83b01bdf128d776a$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $42omo.useState)(null);
    const [url, setUrl] = (0, $42omo.useState)(null);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $l3dur.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $83b01bdf128d776a$var$toUrl(href, window.location.origin);
        const linkTextUrl = $83b01bdf128d776a$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};
module.exports["useLinkWarningModal"] = $83b01bdf128d776a$export$32b76c003683c2ec;

});

parcelRegister("l3dur", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");

const $8a7492fb362aaff8$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$8a7492fb362aaff8$var$linkify.add('sourcetree:', 'http:');
$8a7492fb362aaff8$var$linkify.add('jamfselfservice:', 'http:');
$8a7492fb362aaff8$var$linkify.add('notes:', 'http:');
const $8a7492fb362aaff8$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8a7492fb362aaff8$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8a7492fb362aaff8$var$tlds.push($8a7492fb362aaff8$var$tlds2Char);
$8a7492fb362aaff8$var$linkify.tlds($8a7492fb362aaff8$var$tlds, false);
const $8a7492fb362aaff8$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8a7492fb362aaff8$var$normaliseLinkHref = (url)=>{
    const match = $8a7492fb362aaff8$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8a7492fb362aaff8$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8a7492fb362aaff8$var$linkifyMatch(str);
    if (!match.length) match = $8a7492fb362aaff8$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8a7492fb362aaff8$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8a7492fb362aaff8$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8a7492fb362aaff8$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8a7492fb362aaff8$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8a7492fb362aaff8$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8a7492fb362aaff8$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8a7492fb362aaff8$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8a7492fb362aaff8$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8a7492fb362aaff8$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8a7492fb362aaff8$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $8a7492fb362aaff8$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $8a7492fb362aaff8$export$6535eb414fa2c8b6;

});

parcelRegister("3rvSa", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");

const $1c0162128aea5b38$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $1c0162128aea5b38$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1c0162128aea5b38$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
module.exports["MediaClientContext"] = $1c0162128aea5b38$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $1c0162128aea5b38$export$5bff351c86f56d97;

});

parcelRegister("Girkv", function(module, exports) {
const $89e375f5fe352748$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $89e375f5fe352748$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$89e375f5fe352748$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $89e375f5fe352748$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $89e375f5fe352748$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $89e375f5fe352748$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $89e375f5fe352748$var$getStringFromParams(params, 'collection'),
        alt: $89e375f5fe352748$var$getStringFromParams(params, 'alt'),
        height: $89e375f5fe352748$var$getNumberFromParams(params, 'height'),
        width: $89e375f5fe352748$var$getNumberFromParams(params, 'width'),
        size: $89e375f5fe352748$var$getNumberFromParams(params, 'size'),
        name: $89e375f5fe352748$var$getStringFromParams(params, 'name'),
        mimeType: $89e375f5fe352748$var$getStringFromParams(params, 'mimeType')
    };
};
const $89e375f5fe352748$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $89e375f5fe352748$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$89e375f5fe352748$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $89e375f5fe352748$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};
module.exports["isMediaBlobUrl"] = $89e375f5fe352748$export$e1e8ad57ada2d90;
module.exports["getAttrsFromUrl"] = $89e375f5fe352748$export$b91a9e94ff0cbb29;
module.exports["addFileAttrsToUrl"] = $89e375f5fe352748$export$e51a8146182600b8;

});

parcelRegister("7HtfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $59b33dafbf54dd0b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $2U6f2 = parcelRequire("2U6f2");


var $bIrEX = parcelRequire("bIrEX");


var $b5utg = parcelRequire("b5utg");


var $7aUsh = parcelRequire("7aUsh");

function $59b33dafbf54dd0b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var sign = (0, $bIrEX.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $2U6f2.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $bIrEX.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $7aUsh.default)((0, $egXhZ.default)(dirtyDateLeft)) && difference === 1 && (0, $bIrEX.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("2U6f2", function(module, exports) {
$parcel$export(module.exports, "default", () => $21d5a727b9d6b5f1$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $21d5a727b9d6b5f1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("bIrEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8879425dbfc491c0$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $8879425dbfc491c0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b5utg.default)(2, arguments);
    var dateLeft = (0, $egXhZ.default)(dirtyDateLeft);
    var dateRight = (0, $egXhZ.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("4XUIT", function(module, exports) {
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("8lfDt")).default);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jb7rL = parcelRequire("jb7rL");


var $8lfDt = parcelRequire("8lfDt");


var $kjDWr = parcelRequire("kjDWr");

const $632da732d9a46658$var$CreatableSelect = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const creatableProps = (0, $kjDWr.default)(props);
    const selectProps = (0, $8lfDt.default)(creatableProps);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jb7rL.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$632da732d9a46658$export$2e2bcd8739ae039 = $632da732d9a46658$var$CreatableSelect;
module.exports["default"] = $632da732d9a46658$export$2e2bcd8739ae039;

});

parcelRegister("8lfDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0dda67548c7e875$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $1Ywmy = parcelRequire("1Ywmy");


var $A6wna = parcelRequire("A6wna");

const $a0dda67548c7e875$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $a0dda67548c7e875$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$a0dda67548c7e875$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$a0dda67548c7e875$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $a0dda67548c7e875$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $a0dda67548c7e875$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $a0dda67548c7e875$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $a0dda67548c7e875$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $1Ywmy.getOptionValue), getOptionLabel: getOptionLabel = (0, $1Ywmy.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $42omo.useMemo)(()=>isValidNewOption(inputValue, (0, $A6wna.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $42omo.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $42omo.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $A6wna.valueTernary)(isMulti, [
                    ...(0, $A6wna.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("4XhNP", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $aXG5V = parcelRequire("aXG5V");
parcelRequire("2eY6H");



var $5SAOw = parcelRequire("5SAOw");

const $39ba7b57eb2a7102$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $39ba7b57eb2a7102$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $39ba7b57eb2a7102$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($39ba7b57eb2a7102$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $39ba7b57eb2a7102$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $39ba7b57eb2a7102$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID ? $39ba7b57eb2a7102$var$HISTORY_ACTIONS.REDID : $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID
        }
    });
function $39ba7b57eb2a7102$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $39ba7b57eb2a7102$var$HISTORY_ACTIONS.UNDID || event.payload.action === $39ba7b57eb2a7102$var$HISTORY_ACTIONS.REDID;
}
class $39ba7b57eb2a7102$export$cc33374693c7fb23 extends (0, $aXG5V.Step) {
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($39ba7b57eb2a7102$var$isHistoryAnalyticsEvent(analyticsEvent)) return $39ba7b57eb2a7102$var$toggleEventAction(analyticsEvent);
            else return $39ba7b57eb2a7102$var$createUndoEvent(analyticsEvent);
        });
        return new $39ba7b57eb2a7102$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $39ba7b57eb2a7102$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $aXG5V.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $aXG5V.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $39ba7b57eb2a7102$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $39ba7b57eb2a7102$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $39ba7b57eb2a7102$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $iLaQ6.default)(this, "analyticsEvents", []);
        (0, $iLaQ6.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
}
/** Register this step with Prosemirror */ (0, $aXG5V.Step).jsonID($39ba7b57eb2a7102$export$9126078e8b0f76e4, $39ba7b57eb2a7102$export$cc33374693c7fb23);
module.exports["AnalyticsStep"] = $39ba7b57eb2a7102$export$cc33374693c7fb23;

});

parcelRegister("2eY6H", function(module, exports) {
$parcel$export(module.exports, "Step", () => (parcelRequire("aXG5V")).Step);

var $dh538 = parcelRequire("dh538");


var $aXG5V = parcelRequire("aXG5V");

// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $1a1b839ca3f354ae$var$originalFromJSON = (0, $aXG5V.Step).fromJSON;
(0, $aXG5V.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $1a1b839ca3f354ae$var$originalFromJSON(schema, jsonStep);
    // See https://switcheroo.atlassian.com/ui/gates/4e7e1e8c-9126-4dba-a2a3-1c2b86f81c36/key/platform_editor_metadata_steps
    if (!(0, $dh538.fg)('platform_editor_metadata_step')) return stepImplementation;
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});

parcelRegister("h3X17", function(module, exports) {

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $8z9j5 = parcelRequire("8z9j5");

var $f0c66da303fc9af9$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({})/**
   * This occurs when the provided user token is considered invalid for the given document ARI.
   * It happens during initialisation of the provider.
   * It could mean the document has been deleted (hence not found).
   * @message Message returned to editor, i.e User does not have permissions to access this document or document is not found
   * @recoverable It is recoverable, as we will try to refresh the token.
   */ ;
var $f0c66da303fc9af9$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $f0c66da303fc9af9$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $8z9j5.default)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $f0c66da303fc9af9$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $f0c66da303fc9af9$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $f0c66da303fc9af9$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $f0c66da303fc9af9$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $f0c66da303fc9af9$export$74788e2dc4d9be50 = 'data-telepointer-sessionid'; // ED-22557: Safely convert to object styling
const $f0c66da303fc9af9$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9K4OG.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $aFUXX.participantColors).map((participantColor, index)=>$f0c66da303fc9af9$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $f0c66da303fc9af9$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $f0c66da303fc9af9$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $f0c66da303fc9af9$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $f0c66da303fc9af9$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $f0c66da303fc9af9$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $f0c66da303fc9af9$var$tintKey = 'collab:isDirtyTransaction';
const $f0c66da303fc9af9$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($f0c66da303fc9af9$var$tintKey));
}; /*
    * This function is used to mark which commands that are dispatching
    * unnecessary changes on Editor.
    */ 
const $f0c66da303fc9af9$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($f0c66da303fc9af9$var$tintKey, true);
};
module.exports["PROVIDER_ERROR_CODE"] = $f0c66da303fc9af9$export$54cb529986e2487b;
module.exports["DisconnectReason"] = $f0c66da303fc9af9$export$258d16488300d83f;
module.exports["TELEPOINTER_DIM_CLASS"] = $f0c66da303fc9af9$export$75f1e2b0ae2c8197;
module.exports["TELEPOINTER_PULSE_CLASS"] = $f0c66da303fc9af9$export$44ee82a2b1106d13;
module.exports["TELEPOINTER_PULSE_DURING_TR_CLASS"] = $f0c66da303fc9af9$export$15875d5e8ce4fd42;
module.exports["TELEPOINTER_PULSE_DURING_TR_DURATION_MS"] = $f0c66da303fc9af9$export$cea3f62f94f5fdf0;
module.exports["TELEPOINTER_DATA_SESSION_ID_ATTR"] = $f0c66da303fc9af9$export$74788e2dc4d9be50;
module.exports["isDirtyTransaction"] = $f0c66da303fc9af9$export$c500b1bc696a0abc;
module.exports["tintDirtyTransaction"] = $f0c66da303fc9af9$export$f25182515d14d793;

});

parcelRegister("evORK", function(module, exports) {
/**
 * @graphql experimental
 */ 
var $dlSEv = parcelRequire("dlSEv");


var $eSUdr = parcelRequire("eSUdr");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$isAIFCOnbardingEligibleSiteUserPersonalizationQuery = // eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
(0, $eSUdr.default)`query useIsAIFCOnbardingEligibleSiteUserPersonalizationQuery($cloudId:String!$userId:String!)@experimental{experimentalSiteUserPersonalization(cloudId:$cloudId userId:$userId){attributes{name value}}}`;
const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const queryArgs = {
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    };
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $6mKj3.expValEquals)('confluence_deprecate_experimental_personalization', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    (0, $gqypm.useExperimentalSiteUserPersonalization)(queryArgs) : // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    (0, $jMyy4.useQueryInterop)($eeeb74b654b378be$var$isAIFCOnbardingEligibleSiteUserPersonalizationQuery, queryArgs);
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $oWrxz = parcelRequire("oWrxz");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $oWrxz.getTagsWithPlatfromTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        aiExperienceName,
        aiFeatureName,
        product,
        proactiveGeneratedAI,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        userGeneratedAI,
        isAIFeature,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    return {
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("oWrxz", function(module, exports) {
const $b35ed956ecf5e00e$export$8dd34cb3211cf994 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatfromTag"] = $b35ed956ecf5e00e$export$8dd34cb3211cf994;

});

parcelRegister("8hhCV", function(module, exports) {
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("9hDHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2480da09d16f89$export$2e2bcd8739ae039);
function $6c2480da09d16f89$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("c3Z6w", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c8529e15839e3e9$export$2e2bcd8739ae039);

var $2h3f7 = parcelRequire("2h3f7");


var $bIrEX = parcelRequire("bIrEX");


var $7HtfM = parcelRequire("7HtfM");


var $eDMGY = parcelRequire("eDMGY");


var $g3Gzi = parcelRequire("g3Gzi");


var $egXhZ = parcelRequire("egXhZ");


var $hG32I = parcelRequire("hG32I");


var $9hDHZ = parcelRequire("9hDHZ");


var $qc9ak = parcelRequire("qc9ak");


var $b5utg = parcelRequire("b5utg");

var $8c8529e15839e3e9$var$MINUTES_IN_DAY = 1440;
var $8c8529e15839e3e9$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $8c8529e15839e3e9$var$MINUTES_IN_MONTH = 43200;
var $8c8529e15839e3e9$var$MINUTES_IN_TWO_MONTHS = 86400;
function $8c8529e15839e3e9$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $b5utg.default)(2, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $g3Gzi.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $bIrEX.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $9hDHZ.default)((0, $hG32I.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $egXhZ.default)(dirtyBaseDate);
        dateRight = (0, $egXhZ.default)(dirtyDate);
    } else {
        dateLeft = (0, $egXhZ.default)(dirtyDate);
        dateRight = (0, $egXhZ.default)(dirtyBaseDate);
    }
    var seconds = (0, $eDMGY.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $qc9ak.default)(dateRight) - (0, $qc9ak.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $8c8529e15839e3e9$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $7HtfM.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $8c8529e15839e3e9$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}

});

parcelRegister("eDMGY", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa8a7a6d6e092fc8$export$2e2bcd8739ae039);

var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $aa8a7a6d6e092fc8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / 1000;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hG32I", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde8b8224908a12d$export$2e2bcd8739ae039);

var $9hDHZ = parcelRequire("9hDHZ");

function $cde8b8224908a12d$export$2e2bcd8739ae039(object) {
    return (0, $9hDHZ.default)({}, object);
}

});

parcelRegister("3JtSu", function(module, exports) {

var $dDZcC = parcelRequire("dDZcC");


var $1A9t2 = parcelRequire("1A9t2");

const $2ac2e591b1565c3c$export$46a7f65963d82cf5 = (doc)=>{
    const pageElementCounts = {
        elements: {},
        textFormats: {},
        macros: {},
        unexpectedElements: {}
    };
    (0, $1A9t2.reduce)(doc, (acc, node)=>{
        if (node.type === 'text') {
            if (node.marks) node.marks.forEach((mark)=>{
                const markType = mark.type;
                acc.textFormats[markType] = (acc.textFormats[markType] ?? 0) + 1;
            });
            acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        } else if (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension' || node.type === 'multiBodiedExtension' || node.type === 'extensionFrame') {
            if ('attrs' in node && node.attrs && 'extensionKey' in node.attrs && node.attrs.extensionKey) {
                let extensionKey = node.attrs.extensionKey;
                // If there is a nested table extension
                if ((0, $dDZcC.isNestedTableExtension)(node)) {
                    if ('parameters' in node.attrs && node.attrs.parameters && 'adf' in node.attrs.parameters) {
                        // Check to see if the ADF contains a nested table
                        const adfString = node.attrs.parameters.adf;
                        const adf = JSON.parse(adfString);
                        if (adfString.includes('{"type":"table"')) {
                            if ($2ac2e591b1565c3c$var$getHasNestedTable(adf)) acc.unexpectedElements['tablesNestedMoreThanOnce'] = (acc.unexpectedElements['tablesNestedMoreThanOnce'] ?? 0) + 1;
                        }
                    }
                }
                // If macros extensionKey has <UUID>/<UUID>/static/ prepended to it, remove the prefix
                if (extensionKey.includes('/static/')) {
                    const extensionKeyParts = extensionKey.split('/');
                    extensionKey = extensionKeyParts[extensionKeyParts.length - 1];
                }
                acc.macros[extensionKey] = (acc.macros[extensionKey] ?? 0) + 1;
            }
        } else acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        return acc;
    }, pageElementCounts);
    return pageElementCounts;
};
/**
 * Return true is the JSON document contains a table nested within a table
 */ const $2ac2e591b1565c3c$var$getHasNestedTable = (node)=>{
    return (0, $1A9t2.reduce)(node, (hasNestedTable, node)=>{
        if (hasNestedTable) return hasNestedTable;
        if (node.type === 'table') {
            // The first node that we pass into the reduce function is a table node, and we need to ignore it
            let foundFirstTable = false;
            return (0, $1A9t2.reduce)(node, (hasNestedTable, node)=>{
                if (hasNestedTable) return hasNestedTable;
                if (node.type === 'table' && foundFirstTable) return true;
                else if (node.type === 'table') foundFirstTable = true;
                return hasNestedTable;
            }, false);
        }
        return hasNestedTable;
    }, false);
};
module.exports["getPageElementCounts"] = $2ac2e591b1565c3c$export$46a7f65963d82cf5;

});

parcelRegister("lcPXp", function(module, exports) {
function $f70305999585f159$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $f70305999585f159$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $f70305999585f159$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $f70305999585f159$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $f70305999585f159$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $f70305999585f159$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $f70305999585f159$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $f70305999585f159$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $f70305999585f159$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $f70305999585f159$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $f70305999585f159$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $f70305999585f159$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $f70305999585f159$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $f70305999585f159$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $f70305999585f159$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $f70305999585f159$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $f70305999585f159$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $f70305999585f159$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $f70305999585f159$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $f70305999585f159$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $f70305999585f159$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $f70305999585f159$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $f70305999585f159$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $f70305999585f159$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $f70305999585f159$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $f70305999585f159$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $f70305999585f159$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $f70305999585f159$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $f70305999585f159$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $f70305999585f159$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $f70305999585f159$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $f70305999585f159$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $f70305999585f159$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $f70305999585f159$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $f70305999585f159$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $f70305999585f159$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $f70305999585f159$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $f70305999585f159$var$fromHex_1 = $f70305999585f159$var$fromHex, $f70305999585f159$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $f70305999585f159$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $f70305999585f159$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $f70305999585f159$var$fromRgb_1 = $f70305999585f159$var$fromRgb, $f70305999585f159$var$fromCssRgb_1 = $f70305999585f159$var$fromCssRgb, $f70305999585f159$var$fromHsl_1 = $f70305999585f159$var$fromHsl, $f70305999585f159$var$fromCssHsl_1 = $f70305999585f159$var$fromCssHsl, $f70305999585f159$var$fromHsv_1 = $f70305999585f159$var$fromHsv, $f70305999585f159$var$fromCmyk_1 = $f70305999585f159$var$fromCmyk, $f70305999585f159$var$fromYiq_1 = $f70305999585f159$var$fromYiq, $f70305999585f159$var$fromXYZ_1 = $f70305999585f159$var$fromXYZ, $f70305999585f159$var$fromxyY_1 = $f70305999585f159$var$fromxyY, $f70305999585f159$var$fromLms_1 = $f70305999585f159$var$fromLms, $f70305999585f159$var$fromCieLab_1 = $f70305999585f159$var$fromCieLab, $f70305999585f159$var$fromCieLuv_1 = $f70305999585f159$var$fromCieLuv, $f70305999585f159$var$fromCieLch_1 = $f70305999585f159$var$fromCieLch, $f70305999585f159$var$fromHsluv = $f70305999585f159$var$fromCieLch$1, $f70305999585f159$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $f70305999585f159$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $f70305999585f159$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $f70305999585f159$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $f70305999585f159$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $f70305999585f159$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $f70305999585f159$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $f70305999585f159$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $f70305999585f159$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $f70305999585f159$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $f70305999585f159$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $f70305999585f159$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $f70305999585f159$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $f70305999585f159$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $f70305999585f159$var$fromHsluv
    }
}, $f70305999585f159$var$adapt_1 = $f70305999585f159$var$adapt, $f70305999585f159$var$adjacent_1 = $f70305999585f159$var$adjacent, $f70305999585f159$var$brightness_1 = $f70305999585f159$var$brightness, $f70305999585f159$var$complementary_1 = $f70305999585f159$var$complementary, $f70305999585f159$var$contrast_1 = $f70305999585f159$var$contrast, $f70305999585f159$var$contrastRatio_1 = $f70305999585f159$var$contrastRatio, $f70305999585f159$var$convert_1 = $f70305999585f159$var$convert, $f70305999585f159$var$difference_1 = $f70305999585f159$var$difference, $f70305999585f159$var$fade_1 = $f70305999585f159$var$fade, $f70305999585f159$var$greyscale_1 = $f70305999585f159$var$greyscale, $f70305999585f159$var$hue_1 = $f70305999585f159$var$hue, $f70305999585f159$var$invert_1 = $f70305999585f159$var$invert, $f70305999585f159$var$invertLightness_1 = $f70305999585f159$var$invertLightness, $f70305999585f159$var$mid_1 = $f70305999585f159$var$mid, $f70305999585f159$var$multiply_1 = $f70305999585f159$var$multiply, $f70305999585f159$var$saturation_1 = $f70305999585f159$var$saturation, $f70305999585f159$var$sepia_1 = $f70305999585f159$var$sepia, $f70305999585f159$var$shade_1 = $f70305999585f159$var$shade, $f70305999585f159$var$temperature_1 = $f70305999585f159$var$temperature, $f70305999585f159$var$tetrad_1 = $f70305999585f159$var$tetrad, $f70305999585f159$var$triad_1 = $f70305999585f159$var$triad, $f70305999585f159$var$index$2 = {
    adapt: $f70305999585f159$var$adapt_1,
    adjacent: $f70305999585f159$var$adjacent_1,
    brightness: $f70305999585f159$var$brightness_1,
    complementary: $f70305999585f159$var$complementary_1,
    contrast: $f70305999585f159$var$contrast_1,
    contrastRatio: $f70305999585f159$var$contrastRatio_1,
    convert: $f70305999585f159$var$convert_1,
    difference: $f70305999585f159$var$difference_1,
    fade: $f70305999585f159$var$fade_1,
    greyscale: $f70305999585f159$var$greyscale_1,
    hue: $f70305999585f159$var$hue_1,
    invert: $f70305999585f159$var$invert_1,
    invertLightness: $f70305999585f159$var$invertLightness_1,
    mid: $f70305999585f159$var$mid_1,
    multiply: $f70305999585f159$var$multiply_1,
    saturation: $f70305999585f159$var$saturation_1,
    sepia: $f70305999585f159$var$sepia_1,
    shade: $f70305999585f159$var$shade_1,
    temperature: $f70305999585f159$var$temperature_1,
    tetrad: $f70305999585f159$var$tetrad_1,
    triad: $f70305999585f159$var$triad_1
}, $f70305999585f159$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $f70305999585f159$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $f70305999585f159$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($f70305999585f159$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $f70305999585f159$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($f70305999585f159$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $f70305999585f159$var$api_1 = $f70305999585f159$var$api, $f70305999585f159$var$helpers = {
    getIlluminant: function(r) {
        return $f70305999585f159$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $f70305999585f159$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $f70305999585f159$var$index)if ($f70305999585f159$var$index.hasOwnProperty(e) && $f70305999585f159$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $f70305999585f159$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $f70305999585f159$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $f70305999585f159$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $f70305999585f159$var$constants, s));
            default:
                return null;
        }
    }
}, $f70305999585f159$var$helpers_1 = $f70305999585f159$var$helpers, $f70305999585f159$var$dependencies = {
    conversions: $f70305999585f159$var$index,
    operations: $f70305999585f159$var$index$2,
    helpers: $f70305999585f159$var$helpers_1
}, $f70305999585f159$var$entry = $f70305999585f159$var$api_1($f70305999585f159$var$dependencies, $f70305999585f159$var$constants);
var $f70305999585f159$export$2e2bcd8739ae039 = $f70305999585f159$var$entry;
module.exports["default"] = $f70305999585f159$export$2e2bcd8739ae039;

});

parcelRegister("kfZYI", function(module, exports) {

var $aK8Ra = parcelRequire("aK8Ra");


var $dFFSV = parcelRequire("dFFSV");


var $T9xHm = parcelRequire("T9xHm");


var $eJTH7 = parcelRequire("eJTH7");

function $73605056572cb2af$export$3f82b86ecb947bf0(subdomain, envType) {
    const currentCloudEnvironment = (0, $T9xHm.cloudEnvironment)();
    if (currentCloudEnvironment === undefined) return undefined;
    if (currentCloudEnvironment.type === 'isolated-cloud') {
        const domain = (0, $T9xHm.isolatedCloudDomain)();
        if (domain === undefined) return undefined;
        return $73605056572cb2af$var$getDomainForIsolatedCloud(subdomain, (0, $aK8Ra.COMMERCIAL), domain);
    }
    return $73605056572cb2af$var$getDomainForNonIsolatedCloud(subdomain, currentCloudEnvironment.perimeter, envType);
}
/**
 * Gets the full Isolated Cloud domain
 * Returns undefined only if ic_domain cannot be determined from the atl-ctx cookies
 * Defaults to returning the vanity name pattern
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The Isolated Cloud perimeter to get the domain for
 * @param isolatedCloudDomain - The IC domain (ex. "company.atlassian-isolated.net")
 * @returns The full domain associated with the subdomain in a specific IC
 */ function $73605056572cb2af$var$getDomainForIsolatedCloud(subdomain, perimeter, isolatedCloudDomain) {
    const domainMappings = (0, $eJTH7.isolatedCloudFunctions)[perimeter];
    if ((0, $eJTH7.ReservedNameMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudReservedNameDomain(subdomain, isolatedCloudDomain);
    if ((0, $eJTH7.AtlDomainMapping)[perimeter].includes(subdomain)) return domainMappings.isolatedCloudAtlDomain(subdomain, isolatedCloudDomain);
    return domainMappings.isolatedCloudVanityDomain(subdomain, isolatedCloudDomain);
}
/**
 * Gets the full domain in an non-Isolated Cloud perimeter
 *
 * @param subdomain - The Atlassian experience subdomain
 * @param perimeter - The non-isolated cloud perimeter to get the domain for
 * @param The environment to get the domain for ('dev', 'staging', or 'prod'). When in Isolated Cloud, the same value will be returned for all env types.
 * @returns The full domain associated with the subdomain for the given perimeter and environment
 */ function $73605056572cb2af$var$getDomainForNonIsolatedCloud(subdomain, perimeter, envType) {
    // First, check if the subdomain is associated with a global domain
    if ((0, $dFFSV.globalDomains)[subdomain]) return (0, $dFFSV.globalDomains)[subdomain];
    // Second, check if the subdomain is associated with a full domain override (ex. a domain that uses a different pattern in other perimeters/environments)
    const override = (0, $dFFSV.fullDomainOverride)[subdomain]?.[perimeter]?.[envType];
    if (override) return override;
    // Use default domain ending for the given perimeter
    const domainMappings = (0, $eJTH7.nonIsolatedCloudFunctions)[perimeter];
    return domainMappings.defaultDomainEnding(subdomain, envType);
}
function $73605056572cb2af$export$c162de1e7fecc908(subdomain, envType) {
    const domain = $73605056572cb2af$export$3f82b86ecb947bf0(subdomain, envType);
    if (!domain) {
        console.warn(`Domain could not be determined for requested subdomain: ${subdomain}`);
        return undefined;
    }
    return `${globalThis.location.protocol}//${domain}`;
}
module.exports["getUrlForDomainInContext"] = $73605056572cb2af$export$c162de1e7fecc908;

});

parcelRegister("dFFSV", function(module, exports) {

var $aK8Ra = parcelRequire("aK8Ra");

const $91e3fc913980c88d$export$cfd430a73d68f4bc = {
    confluence: 'confluence.atlassian.com',
    design: 'design.atlassian.com',
    extranet: 'extranet.atlassian.com',
    go: 'go.atlassian.com',
    my: 'my.atlassian.com',
    surveys: 'surveys.atlassian.com',
    'wac-cdn': 'wac-cdn.atlassian.com',
    integrations: 'integrations.atlassian.com',
    permalink: 'permalink.atlassian.com',
    support: 'support.atlassian.com'
};
const $91e3fc913980c88d$export$4723232b625f823e = {
    id: {
        [(0, $aK8Ra.COMMERCIAL)]: {
            [(0, $aK8Ra.PRODUCTION)]: 'id.atlassian.com',
            [(0, $aK8Ra.STAGING)]: 'id.stg.internal.atlassian.com',
            [(0, $aK8Ra.DEV)]: 'id.dev.internal.atlassian.com'
        },
        [(0, $aK8Ra.FEDRAMP_MODERATE)]: {
            [(0, $aK8Ra.PRODUCTION)]: 'id.atlassian-us-gov-mod.com',
            [(0, $aK8Ra.STAGING)]: 'id.stg.atlassian-us-gov-mod.com'
        }
    }
};
module.exports["globalDomains"] = $91e3fc913980c88d$export$cfd430a73d68f4bc;
module.exports["fullDomainOverride"] = $91e3fc913980c88d$export$4723232b625f823e;

});

parcelRegister("eJTH7", function(module, exports) {

var $aK8Ra = parcelRequire("aK8Ra");

const $0bd88ba85420b9b2$export$5860df3acd1ee020 = {
    [(0, $aK8Ra.COMMERCIAL)]: [
        'home',
        'start',
        'id',
        'api',
        'admin',
        'auth',
        'bitbucket'
    ]
};
const $0bd88ba85420b9b2$export$c6366754aee43afa = {
    [(0, $aK8Ra.COMMERCIAL)]: [
        'packages'
    ]
};
const $0bd88ba85420b9b2$export$ad1f7afdb45ad83 = {
    [(0, $aK8Ra.COMMERCIAL)]: {
        isolatedCloudReservedNameDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.${isolatedCloudDomain}`,
        isolatedCloudAtlDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.atl.${isolatedCloudDomain}`,
        isolatedCloudVanityDomain: (subdomain, isolatedCloudDomain)=>`${subdomain}.services.${isolatedCloudDomain}`
    }
};
const $0bd88ba85420b9b2$export$c3b4bc58a05128d6 = {
    [(0, $aK8Ra.COMMERCIAL)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $aK8Ra.PRODUCTION:
                    return `${subdomain}.atlassian.com`;
                case 0, $aK8Ra.STAGING:
                    return `${subdomain}.stg.atlassian.com`;
                case 0, $aK8Ra.DEV:
                    return `${subdomain}.dev.atlassian.com`;
                default:
                    console.warn(`Cannot get non-isolated commercial domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    },
    [(0, $aK8Ra.FEDRAMP_MODERATE)]: {
        defaultDomainEnding: (subdomain, envType)=>{
            switch(envType){
                case 0, $aK8Ra.PRODUCTION:
                    return `${subdomain}.atlassian-us-gov-mod.com`;
                case 0, $aK8Ra.STAGING:
                    return `${subdomain}.stg.atlassian-us-gov-mod.com`;
                default:
                    console.warn(`Cannot get fedramp-moderate domain for provided environment, ${envType} is unsupported`);
                    return '';
            }
        }
    }
};
module.exports["ReservedNameMapping"] = $0bd88ba85420b9b2$export$5860df3acd1ee020;
module.exports["AtlDomainMapping"] = $0bd88ba85420b9b2$export$c6366754aee43afa;
module.exports["isolatedCloudFunctions"] = $0bd88ba85420b9b2$export$ad1f7afdb45ad83;
module.exports["nonIsolatedCloudFunctions"] = $0bd88ba85420b9b2$export$c3b4bc58a05128d6;

});

parcelRegister("aCXDM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
function $7bcbb766a0cbdbe5$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $7bcbb766a0cbdbe5$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $7bcbb766a0cbdbe5$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $7bcbb766a0cbdbe5$export$2e2bcd8739ae039 = $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37;
module.exports["clsx"] = $7bcbb766a0cbdbe5$export$4f5d2d50c9deca37;
module.exports["default"] = $7bcbb766a0cbdbe5$export$2e2bcd8739ae039;

});

parcelRegister("asQED", function(module, exports) {

var $2daQU = parcelRequire("2daQU");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $7XPIt = parcelRequire("7XPIt");


var $42cjr = parcelRequire("42cjr");


var $2d38b = parcelRequire("2d38b");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ht0Th = parcelRequire("ht0Th");


var $4aGJ9 = parcelRequire("4aGJ9");


var $hFGQl = parcelRequire("hFGQl");


var $1CpUP = parcelRequire("1CpUP");

const $27cf6bbb40785c7e$export$392ec14fa63f4ae3 = {
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: "var(--ds-space-100, 8px)"
};
const $27cf6bbb40785c7e$export$63286b959e8d28b9 = (props)=>{
    const { webItems: webItems, actions: actions, modifications: modifications, className: className, id: id, disableIcons: disableIcons, webItemClassName: webItemClassName, ContainerTagName: ContainerTagName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, noContainer: noContainer = false, useBadgeStyles: useBadgeStyles = false } = props;
    const renderWebItems = ()=>webItems.map((webItem)=>{
            const webItemProps = {
                key: webItem.completeKey,
                url: webItem.url,
                id: webItem.id,
                onClick: webItem.onClick || actions[webItem.moduleKey],
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(webItem.styleClass, webItemClassName, {
                    'with-dot': // For live pages, hideDot will be true and we don't want to show dot separator
                    !hideDot
                }),
                params: webItem.params,
                iconInfo: webItem.icon,
                label: webItem.label,
                tooltip: webItem.tooltip,
                spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                disableIcon: disableIcons,
                iconStyle: webItem.iconStyle,
                addLargerMargin: hideDot,
                useBylineStyles: hideDot
            }; // Wow! The JIRA metadata item needs this data prop to work correctly! That was an easy debug ha hoo
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps['data-jira-metadata-count'] = -1;
             // "Unpublished Changes" lozenge
            if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) // Only show "Scheduled publish" lozenge
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42cjr.ScheduledStatus), {
                    key: pageId,
                    contentId: pageId
                });
                else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d38b.DraftStatus), {
                    key: pageId,
                    contentId: pageId
                });
            } // TODO(brizvash): move the button to header, no need to check it all the time
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                key: "view-attachments-button"
            });
            if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                key: "fabric-share"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
                key: "share-and-restrict-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
                contentId: webItem.contentId,
                contentType: webItem.contentType ?? 'page',
                contentSubType: contentSubType || undefined,
                source: source
            })));
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) return null;
            if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                key: webItem.completeKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), webItemProps));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CpUP.WebItem), {
                key: webItem.completeKey,
                ...webItemProps,
                useBadgeStyles: useBadgeStyles
            });
        });
    if (noContainer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderWebItems());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ContainerTagName // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        id: id,
        "data-test-id": dataTestId,
        "data-testid": dataTestId || 'web-item-wrapper'
    }, renderWebItems());
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.displayName = 'WebItemList';
$27cf6bbb40785c7e$export$63286b959e8d28b9.defaultProps = {
    disableIcons: false,
    ContainerTagName: 'div',
    actions: {},
    modifications: {},
    noContainer: false,
    useBadgeStyles: false
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.propTypes = {
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    ContainerTagName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    webItemClassName: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    pageId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    hideDot: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    noContainer: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["SHARE_BTN_STYLE"] = $27cf6bbb40785c7e$export$392ec14fa63f4ae3;
module.exports["WebItemList"] = $27cf6bbb40785c7e$export$63286b959e8d28b9;

});

parcelRegister("7XPIt", function(module, exports) {
/* ViewAttachmentsButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $gmMgo = parcelRequire("gmMgo");


var $inPa6 = parcelRequire("inPa6");


var $4KS7f = parcelRequire("4KS7f");


var $9lz2c = parcelRequire("9lz2c");


var $2UWuP = parcelRequire("2UWuP");


var $jlIaF = parcelRequire("jlIaF");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");

const $5cc628dffabd5f14$var$ViewAttachmentsButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1gflidpf _yhjmidpf _1gqnidpf _11lvidpf _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _4rtxtlke _jq8g1ul9 _14hp1ul9 _43dsazsu _oxk4azsu",
            __cmplp.className
        ])
    });
});
const $5cc628dffabd5f14$var$i18n = (0, $cgtv4.defineMessages)({
    attachments: {
        id: "attachments.view-attachments-button",
        defaultMessage: "View attachments"
    }
});
const $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'fromView'
        }
    }
};
const $5cc628dffabd5f14$export$6f695b80f23f4114 = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'actionsMenu'
        }
    }
};
const $5cc628dffabd5f14$export$774c527e91be8e54 = ({ intl: intl })=>{
    const label = intl.formatMessage($5cc628dffabd5f14$var$i18n.attachments);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'ViewAttachmentsButton',
            attributes: {
                isPageSSRd: window.__SSR_RENDERED__
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5cc628dffabd5f14$var$ViewAttachmentsButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewpageattachments.action?pageId=${contentId}&metadataLink=true`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
        spacing: "spacious",
        label: label
    }))))));
};
$5cc628dffabd5f14$export$774c527e91be8e54.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
};
const $5cc628dffabd5f14$export$5c9f1ebb6c75cefb = (0, $gmMgo.default)($5cc628dffabd5f14$export$774c527e91be8e54);
module.exports["ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU"] = $5cc628dffabd5f14$export$6f695b80f23f4114;
module.exports["ViewAttachmentsButton"] = $5cc628dffabd5f14$export$5c9f1ebb6c75cefb;

});

parcelRegister("2UWuP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $Asv1P = parcelRequire("Asv1P");

const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $Asv1P.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        ref: innerRef,
        onMouseDown: handleClick
    }, children));
    return /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}
module.exports["WebItemAnalyticsWrapper"] = $1c62d6fee936c450$export$907c57431ebf932;

});

parcelRegister("42cjr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7f6808c58612208d$export$d10c0abe99daab65 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a_lQj",
    name: "ScheduledStatus",
    loader: async ()=>(await (parcelRequire("91kTz"))).ScheduledStatus
});
module.exports["ScheduledStatus"] = $7f6808c58612208d$export$d10c0abe99daab65;

});

parcelRegister("91kTz", function(module, exports) {

let $69146a65f9834c6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $69146a65f9834c6c$var$load("Wowvf"),
    $69146a65f9834c6c$var$load("iWKl1")
]).then(()=>parcelRequire('dqNU1'));

});

parcelRegister("2d38b", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $30c96bfad3bb5778$export$ad9db10db9173ca8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6vTJj",
    name: "DraftStatus",
    loader: async ()=>(await (parcelRequire("fis0L"))).DraftStatus
});
module.exports["DraftStatus"] = $30c96bfad3bb5778$export$ad9db10db9173ca8;

});

parcelRegister("fis0L", function(module, exports) {

let $b22e43e512df60cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b22e43e512df60cc$var$load("Wowvf"),
    $b22e43e512df60cc$var$load("jYr96")
]).then(()=>parcelRequire('1cgZV'));

});

parcelRegister("ht0Th", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $2UWuP = parcelRequire("2UWuP");


var $hFGQl = parcelRequire("hFGQl");

const $cb75d5f0a986326c$var$JIRA_ANALYTICS = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        source: 'viewPageScreen',
        actionSubject: 'JiraTicketsButton'
    }
};
function $cb75d5f0a986326c$export$549130614231f8f4({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const container = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>{
            let linkVisible = false;
            const link = container?.current?.children?.[0, $hFGQl.CONTENT_METADATA_JIRA_ID];
            if (link && !link.classList.contains('hidden')) linkVisible = true;
            if (linkVisible) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'JiraTicketsButton',
                    action: 'shown',
                    source: 'viewPageScreen',
                    attributes: {
                        isPageSSRd: window.__SSR_RENDERED__
                    }
                }
            }).fire();
        }, 5000); // should be enough for render after the plugin has mounted
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $cb75d5f0a986326c$var$JIRA_ANALYTICS,
        innerRef: container,
        wrapChildren: true
    }, children);
}
$cb75d5f0a986326c$export$549130614231f8f4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node
};
module.exports["JiraButtonAnalyticsWrapper"] = $cb75d5f0a986326c$export$549130614231f8f4;

});

parcelRegister("hFGQl", function(module, exports) {
const $d3e8bd0515c02c91$export$8b02acc4219d8357 = 'content-metadata-jira';
const $d3e8bd0515c02c91$export$a93781d2f10a1a54 = 'content-metadata-attachments';
const $d3e8bd0515c02c91$export$126027a563ee39b2 = 'content-metadata-page-restrictions';
const $d3e8bd0515c02c91$export$e5b04880f6b7bed = 'draft-status-lozenge';
const $d3e8bd0515c02c91$export$b6c67256b8045624 = 'status-lozenge-scheduled';
const $d3e8bd0515c02c91$export$1b048ac0db68f7ab = 'rte-button-restrictions';
const $d3e8bd0515c02c91$export$607df6eced5a588c = 'inviteToEdit';
const $d3e8bd0515c02c91$export$c8362b8678d6b894 = 'com.addonengine.analytics__analytics-content-byline-item';
const $d3e8bd0515c02c91$export$de7935ab18e02484 = 'com.addonengine.analytics__analytics-content-menu-item';
const $d3e8bd0515c02c91$export$a643e9449b465583 = 'com.addonengine.analytics.moderate__analytics-content-menu-item';
module.exports["CONTENT_METADATA_JIRA_ID"] = $d3e8bd0515c02c91$export$8b02acc4219d8357;
module.exports["CONTENT_METADATA_ATTACHMENTS_ID"] = $d3e8bd0515c02c91$export$a93781d2f10a1a54;
module.exports["CONTENT_METADATA_PAGE_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$126027a563ee39b2;
module.exports["DRAFT_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$e5b04880f6b7bed;
module.exports["SCHEDULED_STATUS_LOZENGE_ID"] = $d3e8bd0515c02c91$export$b6c67256b8045624;
module.exports["EDIT_PAGE_METADATA_RESTRICTIONS_ID"] = $d3e8bd0515c02c91$export$1b048ac0db68f7ab;
module.exports["INVITE_TO_EDIT_ID"] = $d3e8bd0515c02c91$export$607df6eced5a588c;
module.exports["ANALYTICS_ADDON_BYLINE_ID"] = $d3e8bd0515c02c91$export$c8362b8678d6b894;
module.exports["ANALYTICS_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$de7935ab18e02484;
module.exports["ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID"] = $d3e8bd0515c02c91$export$a643e9449b465583;

});

parcelRegister("4aGJ9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7d2Nc = parcelRequire("7d2Nc");


var $9wGTI = parcelRequire("9wGTI");


var $ln0hx = parcelRequire("ln0hx");


var $irVI7 = parcelRequire("irVI7");


var $gw4Bt = parcelRequire("gw4Bt");


var $2Ppk3 = parcelRequire("2Ppk3");

const $67cd68d5c5612721$export$5894b1d1838f517c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD),
        isCustomStart: true,
        key: props.contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.SHARE_AND_RESTRICT_BUTTON_LOAD_EXPERIENCE)
    }), !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonLoader), props) : (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonSSRLoader), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Ppk3.ShareAndRestrictButtonLoader), props));
module.exports["ShareAndRestrictButton"] = $67cd68d5c5612721$export$5894b1d1838f517c;

});

parcelRegister("2Ppk3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $2pIlF = parcelRequire("2pIlF");


const $e72e8fb00bfcbe3f$export$58f1301a9e949269 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Oh2D2",
    name: "ShareAndRestrictButtonSSRLoader",
    loader: async ()=>(await (parcelRequire("kPgn8"))).ShareRestrictAndCopyCoordinator
});

const $e72e8fb00bfcbe3f$export$3f53fee84268f3f4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ImqyR",
    name: "ShareAndRestrictButtonLoader",
    loader: async ()=>(await (parcelRequire("kPgn8"))).ShareRestrictAndCopyCoordinator,
    loading: (0, $2pIlF.ShareRestrictAndCopyButtonPlaceholder)
});
module.exports["ShareAndRestrictButtonSSRLoader"] = $e72e8fb00bfcbe3f$export$58f1301a9e949269;
module.exports["ShareAndRestrictButtonLoader"] = $e72e8fb00bfcbe3f$export$3f53fee84268f3f4;

});

parcelRegister("2pIlF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");

var $9gE7g = parcelRequire("9gE7g");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $luv00 = parcelRequire("luv00");


var $lT8a1 = parcelRequire("lT8a1");

const $4c5c52253c9aa054$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $4c5c52253c9aa054$var$SkeletonGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "icon-skeleton",
        xcss: $4c5c52253c9aa054$var$iconSkeletonStyle
    });
const $4c5c52253c9aa054$export$4d89be89896b480 = ()=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", ssrPlaceholderIdProp, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9gE7g.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        testId: "copy-link-button-placeholder",
        icon: $4c5c52253c9aa054$var$SkeletonGlyph,
        label: "",
        isDisabled: true
    })));
};
module.exports["ShareRestrictAndCopyButtonPlaceholder"] = $4c5c52253c9aa054$export$4d89be89896b480;

});

parcelRegister("lT8a1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $Qy97i = parcelRequire("Qy97i");

const $1b4f772a0e4dae00$var$iconSkeletonStyle = (0, $ecnYn.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    marginLeft: 'space.050',
    marginRight: 'space.025',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $1b4f772a0e4dae00$var$SkeletonGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "icon-skeleton",
        xcss: $1b4f772a0e4dae00$var$iconSkeletonStyle
    });
const $1b4f772a0e4dae00$export$b125768944fa8b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1b4f772a0e4dae00$var$SkeletonGlyph, null),
        onClick: ()=>{},
        isDisabled: true,
        testId: "share-and-restrict-button-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $Qy97i.i18n).share));
module.exports["ShareAndRestrictButtonPlaceholder"] = $1b4f772a0e4dae00$export$b125768944fa8b3;

});

parcelRegister("Qy97i", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $a3fRD = parcelRequire("a3fRD");


var $3gadb = parcelRequire("3gadb");


var $9Q2dU = parcelRequire("9Q2dU");


var $h1ewt = parcelRequire("h1ewt");


var $2Snr1 = parcelRequire("2Snr1");

const $e65d026078d2a5b9$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    share: {
        id: "share-and-restrict-dialog.controlled-share-button.share",
        defaultMessage: "Share"
    }
});
const $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT = {
    open: (0, (/*@__PURE__*/$parcel$interopDefault($h1ewt))),
    restricted: (0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))),
    public: (0, $2Snr1.WorldGreenDotGlyph),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD)))
};
const $e65d026078d2a5b9$var$makeIconProps = (icon, isDisabled)=>{
    if (isDisabled) return {
        color: "var(--ds-icon-disabled, #080F214A)"
    };
    switch(icon){
        case 'error':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        case 'restricted':
            return {
                color: "var(--ds-icon-danger, #C9372C)"
            };
        default:
            return {
                color: "var(--ds-icon-subtle, #505258)"
            };
    }
};
const $e65d026078d2a5b9$export$f939f151d984bfc = ({ icon: icon, onClick: onClick, tooltipMessage: tooltipMessage, isDisabled: isDisabled, children: children, focusRef: focusRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const Icon = $e65d026078d2a5b9$var$ICON_PROP_TO_ICON_COMPONENT[icon];
    const iconProps = {
        label: '',
        ...$e65d026078d2a5b9$var$makeIconProps(icon, isDisabled)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage(tooltipMessage),
        position: "bottom",
        canAppear: ()=>!children,
        hideTooltipOnMouseDown: true,
        ignoreTooltipPointerEvents: true,
        delay: 100
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "subtle",
        iconBefore: (parentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...parentProps,
                ...iconProps
            }),
        onClick: onClick,
        "aria-label": `${formatMessage($e65d026078d2a5b9$export$a7357cdd1f0b0168.share)}, ${formatMessage(tooltipMessage)}`,
        isDisabled: isDisabled,
        ref: focusRef,
        testId: "controlled-share-button"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $e65d026078d2a5b9$export$a7357cdd1f0b0168.share)));
};
module.exports["i18n"] = $e65d026078d2a5b9$export$a7357cdd1f0b0168;
module.exports["ControlledShareButton"] = $e65d026078d2a5b9$export$f939f151d984bfc;

});

parcelRegister("kPgn8", function(module, exports) {

let $f2954538a1a2561a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2954538a1a2561a$var$load("5coOi"),
    $f2954538a1a2561a$var$load("e9JE4"),
    $f2954538a1a2561a$var$load("e4GNb"),
    $f2954538a1a2561a$var$load("2SjHp"),
    $f2954538a1a2561a$var$load("h4Nf7"),
    $f2954538a1a2561a$var$load("6XCf4"),
    $f2954538a1a2561a$var$load("1qlDN"),
    $f2954538a1a2561a$var$load("1yVM6"),
    $f2954538a1a2561a$var$load("cyGuT"),
    $f2954538a1a2561a$var$load("jXx9i"),
    $f2954538a1a2561a$var$load("bunf9"),
    $f2954538a1a2561a$var$load("kUbUu"),
    $f2954538a1a2561a$var$load("7Q5vz"),
    $f2954538a1a2561a$var$load("6FuHS"),
    $f2954538a1a2561a$var$load("eyaRC"),
    $f2954538a1a2561a$var$load("6wr18"),
    $f2954538a1a2561a$var$load("kjZZD"),
    $f2954538a1a2561a$var$load("Wowvf"),
    $f2954538a1a2561a$var$load("7EorR"),
    $f2954538a1a2561a$var$load("hhss7"),
    $f2954538a1a2561a$var$load("ffEVr"),
    $f2954538a1a2561a$var$load("c4Kdp"),
    $f2954538a1a2561a$var$load("4opMD")
]).then(()=>parcelRequire('8bw1z'));

});

parcelRegister("1CpUP", function(module, exports) {
/* WebItem.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $2daQU = parcelRequire("2daQU");


var $5qzNs = parcelRequire("5qzNs");


var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $bCECL = parcelRequire("bCECL");

function $12dd715bfa1d104a$var$_defineProperty(e, r, t) {
    return (r = $12dd715bfa1d104a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12dd715bfa1d104a$var$_toPropertyKey(t) {
    var i = $12dd715bfa1d104a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12dd715bfa1d104a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
const $12dd715bfa1d104a$var$imageStyles = null; // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $12dd715bfa1d104a$var$baseStyles = null;
const $12dd715bfa1d104a$var$largeMargin = null;
const $12dd715bfa1d104a$var$bylineStyles = null;
const $12dd715bfa1d104a$var$badgeStyles = null;
const $12dd715bfa1d104a$var$WebItemTooltip = ({ tooltip: tooltip, children: children })=>{
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip
    }, (tooltipProps)=>children(tooltipProps));
    return children({});
};
$12dd715bfa1d104a$var$WebItemTooltip.propTypes = {
    /**
  * Tooltip of the web item
  */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
const $12dd715bfa1d104a$var$WebItemIcon = ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, ...otherProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
        tooltip: tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", {
            "data-testId": "web-item-link" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: (0, $gMc0m.default)([
                "_2hwxu2gc _vwz4bs82",
                addLargerMargin && "_2hwx14h2 _vwz41vhj",
                useBylineStyles && "_syazd34b",
                useBadgeStyles && "_2rko12b0 _zulp1b66 _1yt41b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _vwz47vkz _2hwxze3t _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _1bnxagmp _1di6fcek _c2waglyw",
                classes
            ]),
            href: url,
            id: id,
            onClick: onClick,
            style: style,
            ...tooltipProps,
            ...otherProps
        }, icon, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: label
            }
        }) : label));
};
$12dd715bfa1d104a$var$WebItemIcon.propTypes = {
    /**
  * classes to use for the component
  */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * id passed from WebItem
  */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Route where the web item will point
  */ url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Label of the web item
  */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Tooltip of the web item
  */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Handler for clicks
  */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
  * WebItem styles
  */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
  * Icon obj
  */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
  * Will be true for live pages since apps have different styling
  */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
  * Will be true for live pages since apps have different styling
  */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
class $12dd715bfa1d104a$export$1c46d4b85d455dd4 extends (0, $42omo.PureComponent) {
    getIcon() {
        const { disableIcon: disableIcon, params: params, iconStyle: iconStyle, spinner: spinner, iconInfo: iconInfo, label: label, iconSize: iconSize } = this.props;
        let auiIconClass = params && params.iconClass;
        if (disableIcon) return null;
        if (spinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "spinner",
            size: "small"
        });
        if (iconInfo && iconInfo.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: iconStyle,
            src: iconInfo.path,
            width: iconInfo.width,
            height: iconInfo.height,
            alt: label,
            title: label,
            className: (0, $gMc0m.default)([
                "_c71l1osq _4t3i1wug _1e0c1o8l _s7n4nkob _2hwx14y2"
            ])
        });
        if (auiIconClass) {
            if (auiIconClass.indexOf('aui-iconfont-') === -1) auiIconClass = `aui-iconfont-${auiIconClass}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                iconSize: iconSize,
                className: auiIconClass,
                style: iconStyle
            });
        }
        return null;
    }
    render() {
        const { className: className, id: id, url: url, type: type, label: label, tooltip: tooltip, onClick: onClick, style: style, ...otherProps } = this.props;
        const buttonType = type === 'primary' ? 'aui-button-primary' : '';
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, buttonType);
        const icon = this.getIcon(); //react complains about these extra props but we still need to pass otherProps (e.g. data-jira-metadata-count)
        const webItemIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))({
            classes: classes,
            id: id,
            url: url,
            label: label,
            tooltip: tooltip,
            onClick: onClick,
            style: style,
            icon: icon,
            ...otherProps
        }, [
            'disableIcon',
            'iconStyle',
            'spinner',
            'iconInfo',
            'iconSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12dd715bfa1d104a$var$WebItemIcon, webItemIconProps);
    }
}
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "propTypes", {
    /**
  * Classnames. Note that WebItem no longer assumes that it should render as a button
  * And as such you may need to explicitly pass the `aui-button` class here.
  */ className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * id
  */ id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Route where the web item will point
  */ url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Type of the button
  */ type: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Label of the web item
  */ label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Tooltip of the web item
  */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Handler for clicks
  */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    /**
  * Contain parameters setted in the descriptor
  */ params: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
  * Doesn't render icons when true
  */ disableIcon: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
  * icon information used for absolute images
  */ iconInfo: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
        path: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
    }),
    /**
  * Show spinner instead of an icon if equals true
  */ spinner: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
  * WebItem styles
  */ style: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    /**
  * Icon styles
  */ iconStyle: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    /**
  * Will be true for live pages since apps have different styling
  */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
  * Will be true for live pages since apps have different styling
  */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
});
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "defaultProps", {
    spinner: false,
    iconStyle: {},
    style: {},
    iconSize: 'small'
});
module.exports["WebItem"] = $12dd715bfa1d104a$export$1c46d4b85d455dd4;

});

parcelRegister("6fwOO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");


var $gj7hi = parcelRequire("gj7hi");


var $5Mmzd = parcelRequire("5Mmzd");


var $8lKIo = parcelRequire("8lKIo");


var $6yyWj = parcelRequire("6yyWj");


var $inPa6 = parcelRequire("inPa6");


var $daw2l = parcelRequire("daw2l");


var $eCryJ = parcelRequire("eCryJ");


var $3IBnw = parcelRequire("3IBnw");

const $12b6fa95758c8d8a$var$SpotlightTourContext = /*#__PURE__*/ (0, $42omo.createContext)({
    currentStep: null,
    isEnrolled: false
}); // Move cssMap to top-level scope
const $12b6fa95758c8d8a$var$SpotlightBodyStyles = {
    root: "_195gmgjw"
};
const $12b6fa95758c8d8a$var$imageStyles = null; // Generic step content component
const $12b6fa95758c8d8a$var$SpotlightStep = ({ currentStep: currentStep, totalSteps: totalSteps, headlineMessage: headlineMessage, bodyMessage: bodyMessage, image: image, paddingInline: paddingInline = 'space.200', showBackButton: showBackButton = false, primaryActionLabel: primaryActionLabel, onBack: onBack, footerOrder: footerOrder = 'count-first' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage(headlineMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $12b6fa95758c8d8a$var$SpotlightBodyStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: paddingInline,
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(bodyMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: image,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1wug"
        ])
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, footerOrder === 'actions-first' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, showBackButton && onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: onBack
    }, formatMessage((0, $6yyWj.messages).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage(primaryActionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $6yyWj.messages).stepCount, {
        current: currentStep + 1,
        total: totalSteps
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $6yyWj.messages).stepCount, {
        current: currentStep + 1,
        total: totalSteps
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, showBackButton && onBack && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: onBack
    }, formatMessage((0, $6yyWj.messages).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage(primaryActionLabel))))));
};
const $12b6fa95758c8d8a$export$8343e683bc14cced = ({ children: children, shouldShowTour: shouldShowTour, isEnrolled: isEnrolled = false, onTourComplete: onTourComplete, onTourDismiss: onTourDismiss })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [currentStep, setCurrentStep] = (0, $42omo.useState)(shouldShowTour && isEnrolled ? 0 : null);
    const totalSteps = 2; // Step 1 (page title) and Step 2 (share button)
    (0, $42omo.useEffect)(()=>{
        if (shouldShowTour && isEnrolled) // Wait for one frame to ensure layout has settled and targets are in DOM
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                setCurrentStep(0);
            });
        });
        else setCurrentStep(null);
    }, [
        shouldShowTour,
        isEnrolled
    ]);
    const next = ()=>{
        setCurrentStep((prev)=>{
            if (prev === null) return 0; // Track next action with current step before moving forward
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'next',
                step: prev
            });
            const nextStep = prev + 1;
            if (nextStep >= totalSteps) {
                endTour(true);
                return null;
            }
            return nextStep;
        });
    };
    const back = ()=>{
        setCurrentStep((prev)=>prev === null ? 0 : Math.max(prev - 1, 0));
    };
    const endTour = (isComplete)=>{
        const stepToTrack = currentStep;
        setCurrentStep(null); // Track dismissal or completion
        if (isComplete) {
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'completed',
                step: stepToTrack
            });
            if (onTourComplete) onTourComplete();
        } else {
            (0, $daw2l.trackSpotlightEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                action: 'dismissed',
                step: stepToTrack
            });
            if (onTourDismiss) onTourDismiss();
        }
    };
    const done = ()=>endTour(true);
    const dismiss = ()=>endTour(false); // Handle errors and send operational event
    const handleError = (0, $42omo.useCallback)((error, errorInfo)=>{
        (0, $daw2l.trackErrorEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            error: error,
            errorInfo: errorInfo,
            componentName: 'export-jira-context-nudge-spotlight-tour'
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
        renderOnError: ()=>children,
        onError: handleError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightTourContext.Provider, {
        value: (0, $42omo.useMemo)(()=>({
                currentStep: currentStep,
                isEnrolled: isEnrolled
            }), [
            currentStep,
            isEnrolled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, children, currentStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: true,
        placement: "left-end",
        dismiss: dismiss,
        done: next
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightStep, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        headlineMessage: (0, $6yyWj.messages).stepOneHeadline,
        bodyMessage: (0, $6yyWj.messages).stepOneBody,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($5Mmzd))),
        showBackButton: false,
        primaryActionLabel: (0, $6yyWj.messages).next,
        onBack: undefined,
        footerOrder: "count-first"
    })), currentStep === 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: true,
        placement: "bottom-start",
        dismiss: dismiss,
        done: done
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($12b6fa95758c8d8a$var$SpotlightStep, {
        currentStep: currentStep,
        totalSteps: totalSteps,
        headlineMessage: (0, $6yyWj.messages).stepTwoHeadline,
        bodyMessage: (0, $6yyWj.messages).stepTwoBody,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($8lKIo))),
        showBackButton: true,
        primaryActionLabel: (0, $6yyWj.messages).done,
        onBack: back,
        footerOrder: "count-first"
    })))));
};
const $12b6fa95758c8d8a$export$1c3dc5815d8870ee = ({ children: children, stepIndex: stepIndex })=>{
    const { currentStep: currentStep, isEnrolled: isEnrolled } = (0, $42omo.useContext)($12b6fa95758c8d8a$var$SpotlightTourContext); // Only render as PopoverTarget when this step is active and user is enrolled
    // PopoverProvider can only handle one PopoverTarget at a time
    const shouldRenderTarget = currentStep === stepIndex && isEnrolled;
    if (shouldRenderTarget) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children);
     // Otherwise just render children normally
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
};
module.exports["ExperimentExportJiraContextToPageNudgeSpotlightTour"] = $12b6fa95758c8d8a$export$8343e683bc14cced;
module.exports["ExperimentExportJiraContextToPageNudgeSpotlightStepWrapper"] = $12b6fa95758c8d8a$export$1c3dc5815d8870ee;

});

parcelRegister("5Mmzd", function(module, exports) {
module.exports = new URL("step-one.dcc386c3.svg", import.meta.url).toString();

});

parcelRegister("8lKIo", function(module, exports) {
module.exports = new URL("step-two.cd055733.svg", import.meta.url).toString();

});

parcelRegister("6yyWj", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $96b51e9a0b93ad79$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    // Step 1 messages
    stepOneHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-one.headline",
        defaultMessage: "Your plans start here"
    },
    stepOneBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-one.body",
        defaultMessage: "We've embedded your Jira timeline into this doc so you can work while staying in sync across platforms."
    },
    // Step 2 messages
    stepTwoHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-two.headline",
        defaultMessage: "Share to keep everyone in sync"
    },
    stepTwoBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-two.body",
        defaultMessage: "Share this page with your team so everyone can see the latest updates in real time."
    },
    // Step 3 messages
    stepThreeHeadline: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-three.headline",
        defaultMessage: "Keep building this doc"
    },
    stepThreeBody: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-three.body",
        defaultMessage: "Type / to insert elements like headers, tables, columns and more."
    },
    // Common action buttons
    next: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.actions.dismiss",
        defaultMessage: "Dismiss"
    },
    stepCount: {
        id: "experiment-export-jira-context-nudge.spotlight-tour.step-count",
        defaultMessage: "{current} of {total}"
    }
});
module.exports["messages"] = $96b51e9a0b93ad79$export$defe85febe8b728c;

});

parcelRegister("daw2l", function(module, exports) {
const $904f0f764f52098e$export$648b2bd0c915d9fe = ({ createAnalyticsEvent: createAnalyticsEvent, action: action, step: step })=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: 'confluence',
            actionSubject: 'spotlight',
            action: 'actioned',
            attributes: {
                action: action,
                step: step !== null ? step : undefined
            }
        }
    }).fire();
};
const $904f0f764f52098e$export$d4b1091dbd9649e3 = ({ createAnalyticsEvent: createAnalyticsEvent, error: error, errorInfo: errorInfo, componentName: componentName })=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'reported',
            actionSubject: `${componentName}-error`,
            source: 'confluence',
            attributes: {
                name: error.name,
                msg: error.message,
                stack: error.stack,
                componentStack: errorInfo.componentStack
            }
        }
    }).fire();
};
module.exports["trackSpotlightEvent"] = $904f0f764f52098e$export$648b2bd0c915d9fe;
module.exports["trackErrorEvent"] = $904f0f764f52098e$export$d4b1091dbd9649e3;

});

parcelRegister("4zbo1", function(module, exports) {
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");

parcelRequire("7R5is");
var $bGq6O = parcelRequire("bGq6O");
var $3FKxL = parcelRequire("3FKxL");


var $bEdUx = parcelRequire("bEdUx");


var $aWwYt = parcelRequire("aWwYt");


var $6KaG6 = parcelRequire("6KaG6");


var $5Myco = parcelRequire("5Myco");


var $9wGTI = parcelRequire("9wGTI");


var $fT4aa = parcelRequire("fT4aa");


var $3YWj2 = parcelRequire("3YWj2");


var $9Gxdl = parcelRequire("9Gxdl");

const $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES = {};
const $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL = {};
const $699adfe23402337d$var$contentWrapperStyles = null;
const $699adfe23402337d$export$9d2b4227a95687cc = ({ contentId: contentId, fetchTheme: fetchTheme = false, children: children, isScreenContentView: isScreenContentView = false, isContainerContentView: isContainerContentView = false, spaceKey: spaceKey, errorAttribution: errorAttribution = (0, $3IBnw.Attribution).BACKBONE, contentScreenStyles: contentScreenStyles = $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES, stickyHeader: stickyHeader = null, versionOverride: versionOverride = null })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const behavior = (0, $aWwYt.useBehavior)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ isViewPageBannerVisible: isViewPageBannerVisible }] = (0, $bGq6O.useViewPageDistinctionBannerStore)();
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)(); // Close the object sidebar when navigating to a new page
    (0, $42omo.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const queryResult = (0, $j1Ss3.useQuery)(chooseContentUnifiedQuery, {
        context: {
            single: true
        },
        skip: !fetchTheme || !contentId,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            useNewContentTopper: true
        }
    });
    if (queryResult.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: errorAttribution
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryResult.error
    }));
    else {
        const theme = Boolean(queryResult?.data?.space?.theme);
        const lookAndFeel = queryResult?.data?.space?.lookAndFeel || $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL;
        const childrenToRender = typeof children === 'function' ? children({
            isThemed: theme,
            isLoading: queryResult.loading
        }) : children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: errorAttribution
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3YWj2.ContentScreenComponent), {
            spaceKey: spaceKey,
            isThemed: theme,
            isLoading: queryResult.loading,
            lookAndFeel: lookAndFeel,
            isContentView: isScreenContentView,
            contentScreenStyles: contentScreenStyles,
            isLivePage: isLivePage
        }, !theme && stickyHeader ? stickyHeader : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Gxdl.ContentContainerComponent), {
            isThemed: theme,
            lookAndFeel: lookAndFeel,
            isContentView: isContainerContentView,
            isLoading: queryResult.loading,
            isLivePage: isLivePage,
            isObjectSidebarEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            additionalPaddingTop: isViewPageBannerVisible ? (0, $3FKxL.BANNER_HEIGHT) : 0
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_16jlcs5v _1o9zkb7n _i0dlf1ug _1e0c1ule _1bsb1osq"
            ])
        }, childrenToRender), isObjectSidebarShown && pageMode === (0, $cD1qu.PageMode).VIEW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, behavior === 'push' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Myco.ObjectSidebarPushPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6KaG6.ObjectSidebarPanel), null))) : childrenToRender), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bEdUx.HighlightActionsProviderForNav4), null)));
    }
};
module.exports["ContentContainer"] = $699adfe23402337d$export$9d2b4227a95687cc;

});

parcelRegister("7R5is", function(module, exports) {
$parcel$export(module.exports, "useViewPageDistinctionBannerStore", () => (parcelRequire("bGq6O")).useViewPageDistinctionBannerStore);
$parcel$export(module.exports, "VIEW_PAGE_DISTINCTION_BANNER_HEIGHT", () => (parcelRequire("3FKxL")).BANNER_HEIGHT);

var $jmjWc = parcelRequire("jmjWc");


var $bGq6O = parcelRequire("bGq6O");


var $3FKxL = parcelRequire("3FKxL");


const $b607cb0728e6d003$export$d1792f644c5fb9c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kmBft",
    name: "ViewPageDistinctionBanner",
    loader: async ()=>(await (parcelRequire("aoeqD"))).ViewPageDistinctionBanner
});

});

parcelRegister("aoeqD", function(module, exports) {

let $7907567cf177404b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7907567cf177404b$var$load("5tz7G"),
    $7907567cf177404b$var$load("eEyVs"),
    $7907567cf177404b$var$load("hhss7"),
    $7907567cf177404b$var$load("i8Yee")
]).then(()=>parcelRequire('de33F'));

});

parcelRegister("bGq6O", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $c43e4fc54e365866$var$initialState = {
    isViewPageBannerVisible: false
};
const $c43e4fc54e365866$export$e324594224ef24da = {
    setViewPageBannerVisibility: (visibility)=>({ setState: setState })=>{
            setState({
                isViewPageBannerVisible: visibility
            });
        }
};
const $c43e4fc54e365866$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $c43e4fc54e365866$var$initialState,
    actions: $c43e4fc54e365866$export$e324594224ef24da,
    name: 'viewPageDistinctionBannerStore'
});
const $c43e4fc54e365866$export$d1266bf09e522b8e = (0, $9zUhf.createHook)($c43e4fc54e365866$export$390f32400eaf98c9);
const $c43e4fc54e365866$export$ec037367829e76f = (0, $9zUhf.createActionsHook)($c43e4fc54e365866$export$390f32400eaf98c9);
module.exports["useViewPageDistinctionBannerStore"] = $c43e4fc54e365866$export$d1266bf09e522b8e;
module.exports["useViewPageDistinctionBannerActions"] = $c43e4fc54e365866$export$ec037367829e76f;

});

parcelRegister("3FKxL", function(module, exports) {
const $b94c6baa776144a8$export$ed7cc0d417ee89e = 33;
module.exports["BANNER_HEIGHT"] = $b94c6baa776144a8$export$ed7cc0d417ee89e;

});

parcelRegister("5Myco", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $aWwYt = parcelRequire("aWwYt");


var $gV0XG = parcelRequire("gV0XG");

// the min-width should match the value of MIN_PANEL_WIDTH from '@confluence/object-sidebar-api/entry-points/useObjectSidebar'
const $5a9e6187ae9c8f81$var$panelPushStyles = (0, $ecnYn.xcss)({
    display: 'block',
    minWidth: '400px'
});
const $5a9e6187ae9c8f81$export$6bf626a2ed01dddd = ()=>{
    const { setPanelWidth: setPanelWidth } = (0, $aWwYt.useObjectSidebarActions)();
    const [containerRef, width] = (0, $gV0XG.useWidthResizeObserver)();
    (0, $42omo.useEffect)(()=>{
        setPanelWidth(width);
    }, [
        width,
        setPanelWidth
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: containerRef,
        xcss: $5a9e6187ae9c8f81$var$panelPushStyles,
        testId: "object-sidebar-push-placeholder"
    });
};
module.exports["ObjectSidebarPushPlaceholder"] = $5a9e6187ae9c8f81$export$6bf626a2ed01dddd;

});

parcelRegister("gV0XG", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $e8f0e07425900c28$export$38848a0b2363b578 = ()=>{
    const [width, setWidth] = (0, $42omo.useState)(0);
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const observeTarget = ref.current;
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                setWidth(entry.contentRect.width);
            });
        });
        if (observeTarget) {
            resizeObserver.observe(observeTarget);
            return ()=>{
                resizeObserver.unobserve(observeTarget);
            };
        } else setWidth(0);
    }, []);
    return [
        ref,
        width
    ];
};
module.exports["useWidthResizeObserver"] = $e8f0e07425900c28$export$38848a0b2363b578;

});

parcelRegister("3YWj2", function(module, exports) {
/* ContentScreenComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");


var $3Klda = parcelRequire("3Klda");

const $7517944cc70514f3$export$af5427d1c079635b = {
    position: 'relative',
    background: "var(--ds-surface, #FFFFFF)",
    paddingTop: '0',
    paddingRight: "var(--ds-space-500, 40px)",
    paddingBottom: "var(--ds-space-250, 20px)",
    paddingLeft: "var(--ds-space-500, 40px)",
    minHeight: 'calc(100vh - 56px)',
    boxSizing: 'border-box',
    // added in for cover image
    '--full-cover-image-margin': '-40px',
    '--full-cover-image-width': 'calc(100% + 80px)'
};
const $7517944cc70514f3$export$ae92da2802c530ea = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES = {
    paddingTop: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    minHeight: 'unset',
    // added in for cover image
    '--full-cover-image-margin': '0px',
    '--full-cover-image-width': '100%'
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7517944cc70514f3$var$OverflowHiddenDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7517944cc70514f3$var$PositionRelativeDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL = {
    content: {
        screen: $7517944cc70514f3$export$af5427d1c079635b
    }
};
const $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES = {};
function $7517944cc70514f3$var$convertGutters(customScreenStyles) {
    if (customScreenStyles.gutterLeft === 'none') customScreenStyles.paddingLeft = '0';
    if (customScreenStyles.gutterRight === 'none') customScreenStyles.paddingRight = '0';
    if (customScreenStyles.gutterTop === '0px') customScreenStyles.paddingTop = '0';
    if (customScreenStyles.gutterBottom === '0px') customScreenStyles.paddingBottom = '0';
    return customScreenStyles;
}
function $7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel) {
    if (!lookAndFeel || !lookAndFeel.content) return {};
    const screenLookAndFeel = $7517944cc70514f3$var$convertGutters({
        ...lookAndFeel.content.screen
    });
    delete screenLookAndFeel.layer;
    return screenLookAndFeel;
}
function $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight) {
    // Update the minHeight style only if a banner is being shown and the minHeight is "100vh" (aka full height)
    const updatedStyles = {
        ...styles
    };
    if (updatedStyles.minHeight === '100vh' && bannerHeight > 0) updatedStyles.minHeight = `calc(${updatedStyles.minHeight} - ${bannerHeight}px)`;
    return updatedStyles;
}
const $7517944cc70514f3$export$b578f5d8b8749ec2 = ({ spaceKey: spaceKey, children: children, lookAndFeel: lookAndFeel = $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL, contentScreenStyles: // This prop contains react-css values to customize the default content screen styles according to the consumer's need.
contentScreenStyles = $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES, isThemed: isThemed = false, isContentView: isContentView = false, isLoading: isLoading = false, isLivePage: isLivePage = false })=>{
    const previousStyleState = (0, $42omo.useRef)(null);
    const shouldApplyTheme = isThemed || isContentView;
    let styles; // 99.9% of time we should have lookAndFeel preloaded on SSR
    if (isLoading) {
        const previous = previousStyleState.current; // In transition since style in the same space should be the same
        // We can optimistically use the same style as the previous one
        if (spaceKey && spaceKey === previous?.spaceKey) styles = previous?.getStyles(isLivePage) || $7517944cc70514f3$export$ae92da2802c530ea;
        else styles = $7517944cc70514f3$export$ae92da2802c530ea;
    } else {
        const getStyles = shouldApplyTheme ? (live)=>({
                ...$7517944cc70514f3$export$af5427d1c079635b,
                ...live ? $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES : {},
                ...contentScreenStyles,
                ...$7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel)
            }) : ()=>({});
        previousStyleState.current = {
            getStyles: getStyles,
            spaceKey: spaceKey
        };
        styles = getStyles(isLivePage);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight();
        const updatedStyles = $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight); // styles came from a GraphQL result which will contain __typename
        delete updatedStyles.__typename;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-screen-component" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: "content-screen-component" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            style: updatedStyles
        }, shouldApplyTheme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
            lookAndFeel: lookAndFeel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7517944cc70514f3$var$PositionRelativeDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7517944cc70514f3$var$OverflowHiddenDiv, null), children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children));
    });
};
module.exports["ContentScreenComponent"] = $7517944cc70514f3$export$b578f5d8b8749ec2;

});

parcelRegister("9Gxdl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $9wGTI = parcelRequire("9wGTI");

const $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES = {
    background: "var(--ds-surface, #FFFFFF)",
    backgroundColor: "var(--ds-surface, #FFFFFF)"
};
const $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $70d1ccf7a353c4c2$var$_convertVerticalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
        case 'medium':
        case 'large':
        case 'default':
            return null;
        default:
            return gutterValue;
    }
};
const $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
            return 5;
        case 'medium':
            return 10;
        case 'large':
            return 15;
        case 'default':
            return null;
        case 'none':
        default:
            return 0;
    }
};
class $70d1ccf7a353c4c2$export$b5a05341299897cc extends (0, $42omo.Component) {
    static _getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop, isObjectSidebarEnabled) {
        if (!lookAndFeel.content) return $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES;
        const { screen: screen, container: container } = lookAndFeel.content;
        const containerStyles = {
            ...$70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES,
            ...container
        };
        const { padding: padding } = containerStyles;
        let paddingTop = additionalPaddingTop || 0; // if page header is fixed, content will need to be pushed down so that the title of the page isn't covered (unless rendered via embedded-confluence)
        // themed spaces do not have fixed headers and do not need the styling
        if (!isThemed && !isLivePage && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && !(0, $lJlG6.isMobileApp_DO_NOT_USE)()) {
            if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) // if confluence_frontend_content_wrapper is on, add 46px padding since the object header height is 56px and with-sticky-header div above it has 10px height already
            paddingTop += 46;
            else // add 60px padding since regular page header height is 60px.
            paddingTop += 60;
        }
        containerStyles.padding = `${paddingTop}px 0px 0px 0px`;
        if (isThemed && padding === '0') // if the theme doesn't have a padding, we should add a padding because otherwise comments overflow the container
        // see also: https://product-fabric.atlassian.net/wiki/spaces/~speachey/pages/3093430887/DEVHELP-6933
        containerStyles.padding = '20px';
        const { gutterTop: gutterTop, gutterBottom: gutterBottom } = screen;
        if (gutterTop) containerStyles.marginTop = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterTop);
        if (gutterBottom) containerStyles.marginBottom = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterBottom);
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        const gutterLeft = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterLeft);
        if (gutterRight !== null) containerStyles.marginRight = `${gutterRight}%`;
        if (gutterLeft !== null) containerStyles.marginLeft = `${gutterLeft}%`;
        containerStyles.width = `${100 - gutterRight - gutterLeft}%`;
        containerStyles.boxSizing = 'border-box';
        if (isObjectSidebarEnabled) {
            containerStyles.display = 'flex';
            containerStyles.flexDirection = 'row';
        } // container is from graphql result which will contain __typename
        delete containerStyles.__typename;
        return containerStyles;
    }
    static _getInlineCommentStyles(lookAndFeel) {
        if (!lookAndFeel.content) return null;
        const { screen: screen = {} } = lookAndFeel.content;
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        if (gutterRight === 0) /**
      * When we have no gutterRight, we need to override the default ic-sidebar marging-right of -20px and make it 0
      *  so that it does not pull too far right.
      */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style", null, '.ic-sidebar.ic-is-spa-view-page { margin-right: 0 !important; }');
        return null;
    }
    getLoadingStyles() {
        const { isLoading: isLoading } = this.props;
        return isLoading ? $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES : {};
    }
    render() {
        const { lookAndFeel: lookAndFeel, isThemed: isThemed, isContentView: isContentView, isLivePage: isLivePage, isObjectSidebarEnabled: isObjectSidebarEnabled, additionalPaddingTop: additionalPaddingTop } = this.props;
        const shouldApplyTheme = isThemed || isContentView;
        const containerStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop, isObjectSidebarEnabled) : this.getLoadingStyles();
        const inLineCommentStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getInlineCommentStyles(lookAndFeel) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "content-container-component" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: this.props.className,
            style: containerStyles
        }, inLineCommentStyles, this.props.children);
    }
}
$70d1ccf7a353c4c2$export$b5a05341299897cc.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).any,
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    isThemed: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    /**
  * In view page we apply default style regardless whether theme was enabled or not
  */ isContentView: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isLivePage: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isObjectSidebarEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    additionalPaddingTop: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).number
};
$70d1ccf7a353c4c2$export$b5a05341299897cc.defaultProps = {
    isContentView: false,
    lookAndFeel: {
        content: {
            screen: $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES
        }
    },
    isLivePage: false,
    isObjectSidebarEnabled: false
};
module.exports["ContentContainerComponent"] = $70d1ccf7a353c4c2$export$b5a05341299897cc;

});

parcelRegister("hlP5l", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $ca1c06444d7dc3f1$export$1acb68730768e8f3 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.BYLINE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$9f06d0bab23f5435 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["BYLINE_METRIC"] = $ca1c06444d7dc3f1$export$1acb68730768e8f3;
module.exports["CONTENT_TITLE_METRIC"] = $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e;
module.exports["CONNECT_APP_WEB_FRAGMENT_METRIC"] = $ca1c06444d7dc3f1$export$9f06d0bab23f5435;

});

parcelRegister("bYWO7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");

const $a54b0fce6ef1bccc$var$pressableLinkStyle = (0, $ecnYn.xcss)({
    background: 'transparent',
    ':hover': {
        cursor: 'pointer'
    },
    ':active': {
        color: 'color.text'
    }
});
const $a54b0fce6ef1bccc$var$underlineStyle = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    textDecorationColor: "var(--ds-text-subtlest, #6B6E76)"
});
const $a54b0fce6ef1bccc$export$12e82d6c56cc7acc = ({ href: href, targetBlank: targetBlank, onClick: onClick, children: children, fontSize: fontSize, showUnderline: showUnderline, isBlue: isBlue })=>{
    const openLink = (0, $42omo.useCallback)(()=>{
        window.open(href, targetBlank ? '_blank' : undefined);
    }, [
        href,
        targetBlank
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        padding: "space.0",
        onClick: onClick || openLink,
        xcss: [
            $a54b0fce6ef1bccc$var$pressableLinkStyle,
            showUnderline && $a54b0fce6ef1bccc$var$underlineStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: fontSize || 'medium',
        color: isBlue ? 'color.text.accent.blue' : 'color.text.subtlest'
    }, children));
};
module.exports["PressableLink"] = $a54b0fce6ef1bccc$export$12e82d6c56cc7acc;

});

parcelRegister("2WE3u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $gLeLL = parcelRequire("gLeLL");


var $cHKtk = parcelRequire("cHKtk");

const $de29dd5d68831993$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "change-edition.share-and-restrict-dialog.restrictions.title",
        defaultMessage: "Control who can view and edit content"
    },
    learnMoreLink: {
        id: "change-edition.share-and-restrict-dialog.restrictions.learn-more-link",
        defaultMessage: "Learn more"
    },
    body: {
        id: "change-edition.share-and-restrict-dialog.restrictions.body",
        defaultMessage: "You\u2019re on the Free plan. On paid plans, you can restrict content to specific people."
    },
    openUpAccess: {
        id: "change-edition.share-and-restrict-inline-message.open-up-access",
        defaultMessage: "Open up access"
    }
});
const $de29dd5d68831993$var$SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
const $de29dd5d68831993$export$e04850920db60a63 = ({ children: children, handleOnClick: handleOnClick, customPadding: customPadding })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)('shareAndRestrictDialogUpsell');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
        withGradient: false,
        title: formatMessage($de29dd5d68831993$export$a7357cdd1f0b0168.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            direction: "column",
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, formatMessage($de29dd5d68831993$export$a7357cdd1f0b0168.body)), children),
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton,
        showRequestUpgradeButtonAATest: showRequestUpgradeButtonAATest,
        learnMoreLink: {
            href: $de29dd5d68831993$var$SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION,
            ariaLabel: $de29dd5d68831993$export$a7357cdd1f0b0168.learnMoreLink,
            appearance: handleOnClick ? 'primary' : undefined
        },
        source: "shareAndRestrictDialogUpsell",
        secondaryLink: handleOnClick ? {
            messageDescriptor: $de29dd5d68831993$export$a7357cdd1f0b0168.openUpAccess,
            appearance: 'link',
            onClick: handleOnClick,
            actionSubjectId: 'openUpAccess'
        } : undefined,
        customPadding: customPadding
    });
};
module.exports["ChangeEditionSectionMessageShareAndRestrict"] = $de29dd5d68831993$export$e04850920db60a63;

});

parcelRegister("7DBey", function(module, exports) {
const $91acf6157f8b5c3c$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $91acf6157f8b5c3c$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $91acf6157f8b5c3c$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $91acf6157f8b5c3c$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $91acf6157f8b5c3c$export$6e9f7b680f09bab1;
module.exports["toError"] = $91acf6157f8b5c3c$export$cc3b967c039ed3e7;

});

parcelRegister("lf3m6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");

const $1fe9d405ea0b7d31$export$c8803e7fcf129fb7 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)(); // objectId
    const [spaceId] = (0, $ep3mz.usePageSpaceKey)(); // containerId
    const mentionRequestModel = (0, $42omo.useMemo)(()=>{
        return {
            contentId: contentId,
            spaceId: spaceId,
            mentionsSessionId: crypto.randomUUID(),
            contextType: 'Mentions'
        };
    }, [
        contentId,
        spaceId
    ]);
    if ((0, $6mKj3.expValEquals)('cc_suggested_users_next', 'cohort', 'variation')) return mentionRequestModel;
    return {
        contentId: undefined,
        spaceId: undefined,
        contextType: undefined,
        mentionsSessionId: undefined
    };
};
module.exports["useUserSuggestionsMentionsExperiment"] = $1fe9d405ea0b7d31$export$c8803e7fcf129fb7;

});

parcelRegister("86H8K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $4adOe = parcelRequire("4adOe");

const $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/troubleshoot-access-problems-to-content/';
const $09f2383e12028cd7$export$40b60b643290317e = (chunks)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'blockedAccessLearnMore'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        target: "_blank",
        href: $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION,
        onClick: handleClick
    }, chunks);
};
module.exports["LearnMoreChunk"] = $09f2383e12028cd7$export$40b60b643290317e;

});

parcelRegister("lTbRO", function(module, exports) {
function $e4e2a5af58e91b52$export$ca7afed3e2b74cb9({ specificAccessDelta: { stagedAdditions: stagedAdditions, removals: removals, reassignments: reassignments, removeAll: removeAll }, generalAccessDelta: generalAccessDelta }, { contentRestrictions: contentRestrictions, currentUser: currentUser, principalsPendingAccess: principalsPendingAccess }, { isCtaClick: isCtaClick, stagedGeneralAccessLevel: stagedGeneralAccessLevel }) {
    const map = new Map();
    // Ensure the current user is added to the principal map for these access levels.
    // This ensures the specific access list includes the current user when general access changes are staged.
    if (!(generalAccessDelta === 'none') && (stagedGeneralAccessLevel === 'open-can-view' || stagedGeneralAccessLevel === 'restricted')) map.set(currentUser.id, {
        role: 'can-edit',
        principal: currentUser,
        isNewOrUpdatedPrincipal: false
    });
    // Start with all the pre-existing principals
    for (const { principal: principal, role: role } of contentRestrictions.principals)map.set(principal.id, {
        role: role,
        principal: principal,
        isNewOrUpdatedPrincipal: false
    });
    // Include principals pending access
    for (const { principal: principal, role: role } of principalsPendingAccess)map.set(principal.id, {
        role: role,
        principal: principal,
        isNewOrUpdatedPrincipal: false
    });
    // Update the roles for any in the reassignments list
    for (const [id, role] of reassignments){
        const existingEntry = map.get(id);
        if (existingEntry) map.set(id, {
            ...existingEntry,
            role: role,
            isNewOrUpdatedPrincipal: true
        });
    }
    // Delete all the ones removed in this session
    for (const id of removals)map.delete(id);
    // Remove all the principals in this session
    if (removeAll) {
        for (const { principal: principal } of contentRestrictions.principals)if (principal.id !== currentUser.id) map.delete(principal.id);
        for (const { principal: principal } of principalsPendingAccess)if (principal.id !== currentUser.id) map.delete(principal.id);
    }
    // Add the ones we've added in this session when CTA is clicked
    if (isCtaClick) for (const { principal: principal, role: role } of stagedAdditions)map.set(principal.id, {
        role: role,
        principal: principal,
        isNewOrUpdatedPrincipal: true
    });
    return map;
}
module.exports["makePrincipalsMap"] = $e4e2a5af58e91b52$export$ca7afed3e2b74cb9;

});

parcelRegister("fec5t", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

function $e664db01cca310b7$export$ece2186cd7ef9af9(setMasterState, principalToAdd, inputAddMode) {
    setMasterState((masterState)=>{
        const { specificAccessDelta: { stagedAdditions: stagedAdditions, reassignments: reassignments }, addMode: defaultAddMode } = masterState;
        const { id: principalId } = principalToAdd;
        const addMode = inputAddMode || defaultAddMode;
        const role = addMode === 'as-editor' ? 'can-edit' : 'can-view';
        // Important: the state-hosted removals, stagedAdditions and reassignments objects
        // should be immutable. We have to build new ones to replace the originals.
        // If the principal is currently in the reassignments set, pull them out
        const newReassignments = new Map(reassignments);
        newReassignments.delete(principalId);
        // If the principal is currently in the stagedAdditions set, pull them out.
        const newAdditions = [
            {
                principal: principalToAdd,
                role: role
            },
            ...stagedAdditions.filter(({ principal: { id: id } })=>principalToAdd.id !== id)
        ];
        return {
            ...masterState,
            addMode: addMode,
            specificAccessDelta: {
                ...masterState.specificAccessDelta,
                stagedAdditions: newAdditions,
                reassignments: newReassignments
            }
        };
    });
}
function $e664db01cca310b7$export$ab86aca1a178a62e(setMasterState, role, id) {
    setMasterState((masterState)=>{
        const { specificAccessDelta: specificAccessDelta } = masterState;
        // Otherwise, change the reassignments map
        {
            const { reassignments: reassignments } = specificAccessDelta;
            const newReassignments = new Map(reassignments);
            newReassignments.set(id, role);
            return {
                ...masterState,
                specificAccessDelta: {
                    ...specificAccessDelta,
                    reassignments: newReassignments
                }
            };
        }
    });
}
function $e664db01cca310b7$export$4132550af942b008(setMasterState, id) {
    setMasterState((masterState)=>{
        const { specificAccessDelta: specificAccessDelta } = masterState;
        // Otherwise, add the principal to the removals set, and if they're on the
        // reassignments map, remove them from that too
        {
            const { removals: removals, reassignments: reassignments } = specificAccessDelta;
            const newRemovals = new Set(removals);
            newRemovals.add(id);
            const newReassignments = new Map(reassignments);
            newReassignments.delete(id);
            return {
                ...masterState,
                specificAccessDelta: {
                    ...specificAccessDelta,
                    removals: newRemovals,
                    reassignments: newReassignments
                }
            };
        }
    });
}
function $e664db01cca310b7$export$6cc5eab7328edbf8(setMasterState, principalsStagerPrincipals) {
    setMasterState((masterState)=>{
        const { specificAccessDelta: { stagedAdditions: stagedAdditions } } = masterState;
        // Extract IDs
        const principalsStagePrincipalIds = new Set(principalsStagerPrincipals.map((item)=>item.id));
        // Filter stagedAdditions to include only items present in principalsStagePrincipals
        const newStagedAdditions = stagedAdditions.filter((item)=>principalsStagePrincipalIds.has(item.principal.id));
        return {
            ...masterState,
            specificAccessDelta: {
                ...masterState.specificAccessDelta,
                stagedAdditions: newStagedAdditions
            }
        };
    });
}
const $e664db01cca310b7$export$ba7091c91c65ca76 = (platformPrincipal)=>{
    const { id: id, name: name, type: type } = platformPrincipal;
    switch(type){
        case 'user':
            return {
                type: 'user',
                id: id,
                name: name,
                avatarUrl: platformPrincipal.avatarUrl || '',
                email: platformPrincipal.email || '',
                knownErrors: platformPrincipal.knownErrors,
                sitePermissionType: platformPrincipal.isExternal ? 'EXTERNAL' : 'INTERNAL'
            };
        case 'group':
            return {
                type: 'group',
                id: id,
                name: name,
                usageType: null
            };
        case 'email':
            return {
                type: 'email',
                id: id,
                name: name
            };
        case 'team':
            return {
                type: 'team',
                id: id,
                name: name,
                usageType: null,
                memberCount: platformPrincipal.memberCount,
                isVerified: platformPrincipal.verified || false,
                avatarSrc: platformPrincipal.avatarUrl || ''
            };
        case 'external_user':
            return {
                type: 'external_user',
                id: id,
                name: name,
                email: platformPrincipal.email || '',
                avatarUrl: platformPrincipal.avatarUrl || ''
            };
        default:
            // This function is for converting principals that can appear in the
            // Specific Access table, and right now only users and groups can.
            const logger = (0, $7W8i8.getLogger)('share-and-restrict-dialog:convertPrincipal');
            logger.error`Tried to convert an unsupported platform type: ${type}`;
            return {
                type: 'user',
                id: id,
                name: name,
                avatarUrl: '',
                email: '',
                knownErrors: undefined,
                sitePermissionType: ''
            };
    }
};
module.exports["stagePrincipalAddition"] = $e664db01cca310b7$export$ece2186cd7ef9af9;
module.exports["stagePrincipalReassignment"] = $e664db01cca310b7$export$ab86aca1a178a62e;
module.exports["stagePrincipalRemoval"] = $e664db01cca310b7$export$4132550af942b008;
module.exports["filterStagedAdditionsByPrincipals"] = $e664db01cca310b7$export$6cc5eab7328edbf8;
module.exports["convertUserPickerPrincipal"] = $e664db01cca310b7$export$ba7091c91c65ca76;

});

parcelRegister("6SeRB", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $7CwhK = parcelRequire("7CwhK");

const $5a5cd8e5c5de5d5b$export$c2ba6cba2802ac6a = (0, $eSUdr.default)`query useAccessRequestsQuery($after:String$cloudId:ID!$contentId:ID!$first:Int=10$status:ConfluenceContentAccessRequestStatus=PENDING){confluence_contentAccessRequestByStatus(after:$after cloudId:$cloudId contentId:$contentId first:$first status:$status){nodes{id user{id displayName emails{isPrimary value}photos{isPrimary value}}accessRequestedAaid requestAccessType status}pageInfo{endCursor hasNextPage startCursor}}}`;
const $5a5cd8e5c5de5d5b$export$81d7bc2b035b49fd = (fetchPolicy, source, skipOverride = false, status = 'PENDING')=>{
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const skip = !contentId || edition === 'FREE' || skipOverride;
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $xQxzY.useQuery)($5a5cd8e5c5de5d5b$export$c2ba6cba2802ac6a, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            status: (0, $7CwhK.ConfluenceContentAccessRequestStatus)[status]
        },
        skip: skip,
        fetchPolicy: fetchPolicy,
        notifyOnNetworkStatusChange: true
    });
    const requests = data?.confluence_contentAccessRequestByStatus?.nodes ?? [];
    const pageInfo = data?.confluence_contentAccessRequestByStatus?.pageInfo;
    const endCursor = pageInfo?.endCursor ?? null;
    const hasNextPage = pageInfo?.hasNextPage ?? false;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'accessRequestsQuery',
                source: source,
                attributes: {
                    contentId: contentId,
                    errorMessage: error.message
                }
            }
        }).fire();
    }, [
        error,
        source,
        contentId,
        createAnalyticsEvent
    ]);
    return {
        requests: requests,
        endCursor: endCursor,
        hasNextPage: hasNextPage,
        loading: loading,
        error: error,
        fetchMore: fetchMore,
        contentId: contentId,
        hasFullyLoaded: !!data && !loading
    };
};
module.exports["useAccessRequests"] = $5a5cd8e5c5de5d5b$export$81d7bc2b035b49fd;

});

parcelRegister("13PIz", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $inPa6 = parcelRequire("inPa6");


var $4adOe = parcelRequire("4adOe");

const $8591fc2e7a08d9e9$var$useGroupsCountQuery = (0, $eSUdr.default)`query useGroupsCountQuery($groupIdList:[String]){groupCounts(groupIds:$groupIdList){groupCounts{key value}}}`;
function $8591fc2e7a08d9e9$var$toMap(pairs = []) {
    return new Map(pairs.map(({ key: key, value: value })=>[
            key,
            value
        ]));
}
const $8591fc2e7a08d9e9$export$92e64015d2452a7b = ({ data: data, groupList: //groupLists can be provided to skip the shareAndRestrictDialog query if they are already loaded
//this is useful for the GroupNotifyWarningDialog component
groupList, publishModalRestrictions: publishModalRestrictions, error: error })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [groupAndTeamCountsMap, setGroupAndTeamCountsMap] = (0, $42omo.useState)(new Map());
    const modalType = publishModalRestrictions ? 'publishModal' : 'shareAndRestrictModal';
    const publishedModalGroupAndTeamId = (0, $42omo.useMemo)(()=>{
        if (!publishModalRestrictions) return [];
        const ids = new Set();
        for (const item of publishModalRestrictions){
            const groups = item?.restrictions?.group?.results ?? [];
            for (const group of groups)if (group?.id) ids.add(group.id);
        }
        return Array.from(ids);
    }, [
        publishModalRestrictions
    ]);
    const groupsAndTeamsId = (0, $42omo.useMemo)(()=>{
        if (groupList && !data?.content?.nodes?.[0]?.restrictions) return groupList.map((group)=>group.id);
        if (!data?.content?.nodes?.[0]?.restrictions) return [];
        const readNodes = data.content.nodes[0].restrictions.read?.restrictions?.group?.nodes ?? [];
        const updateNodes = data.content.nodes[0].restrictions.update?.restrictions?.group?.nodes ?? [];
        const allNodes = [
            ...readNodes,
            ...updateNodes
        ];
        const uniqueIds = new Set(allNodes.map((node)=>node?.id).filter(Boolean));
        return Array.from(uniqueIds);
    }, [
        data,
        groupList
    ]);
    const shouldSkipQuery = (0, $42omo.useMemo)(()=>{
        const idsToQuery = modalType === 'publishModal' ? publishedModalGroupAndTeamId : groupsAndTeamsId;
        return !!error || idsToQuery.length === 0 && (!groupList || groupList.length === 0);
    }, [
        error,
        modalType,
        publishedModalGroupAndTeamId,
        groupsAndTeamsId,
        groupList
    ]);
    const { loading: isGroupsCountLoading, data: groupsCountData, error: groupsCountError } = (0, $j1Ss3.useQuery)($8591fc2e7a08d9e9$var$useGroupsCountQuery, {
        variables: {
            groupIdList: modalType === 'publishModal' ? publishedModalGroupAndTeamId : groupsAndTeamsId
        },
        skip: shouldSkipQuery
    });
    const processGroupCountsData = (0, $42omo.useMemo)(()=>{
        if (!groupsCountData?.groupCounts?.groupCounts) return new Map();
        const validCounts = groupsCountData.groupCounts.groupCounts.filter((item)=>item !== null).filter((item)=>typeof item.key === 'string' && typeof item.value === 'number');
        return $8591fc2e7a08d9e9$var$toMap(validCounts);
    }, [
        groupsCountData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isGroupsCountLoading && groupsCountError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: (0, $4adOe.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'useGroupsCountQuery',
                attributes: {
                    message: groupsCountError?.message,
                    name: groupsCountError?.name,
                    modalType: modalType,
                    groupCount: modalType === 'publishModal' ? publishedModalGroupAndTeamId.length : groupsAndTeamsId.length
                }
            }
        }).fire();
        if (!isGroupsCountLoading && processGroupCountsData.size > 0) setGroupAndTeamCountsMap(processGroupCountsData);
    }, [
        isGroupsCountLoading,
        groupsCountData,
        groupsCountError,
        createAnalyticsEvent,
        processGroupCountsData,
        modalType,
        publishedModalGroupAndTeamId.length,
        groupsAndTeamsId.length
    ]);
    return {
        isGroupsCountLoading: isGroupsCountLoading,
        groupAndTeamCountsMap: groupAndTeamCountsMap
    };
};
module.exports["useGroupsAndTeamCountQuery"] = $8591fc2e7a08d9e9$export$92e64015d2452a7b;

});

parcelRegister("7CwhK", function(module, exports) {
/**
 * @generated SignedSource<<5f76d1fe70120efd62a5d9df9694b167>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $a53db03f17943d59$export$9433ffa3560c2762 = /*#__PURE__*/ function(ConfluenceContentAccessRequestStatus) {
    ConfluenceContentAccessRequestStatus["APPROVE"] = "APPROVE";
    ConfluenceContentAccessRequestStatus["DENY"] = "DENY";
    ConfluenceContentAccessRequestStatus["PENDING"] = "PENDING";
    ConfluenceContentAccessRequestStatus["PENDING_SITE_APPROVAL"] = "PENDING_SITE_APPROVAL";
    return ConfluenceContentAccessRequestStatus;
}({});
var $a53db03f17943d59$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
module.exports["ConfluenceContentAccessRequestStatus"] = $a53db03f17943d59$export$9433ffa3560c2762;

});


//# sourceMappingURL=GeneralAccessLevelSelector.1b526d54.js.map
